// jve-5-1: SPA-only message keys that have no Jmix counterpart (loading/empty/error chrome and a
// few shared verbs). The domain keys are generated from the Jmix bundles (messages.generated.ts);
// these are authored here. Same flat-key namespace; merged by the i18nProvider.
export const appMessages = {
  en: {
    "common.loadError": "Could not be loaded.",
    "common.retry": "Retry",
    "common.previous": "Previous",
    "common.next": "Next",
    "common.more": "More",
    "common.loading": "Loading…",
    "validatie.emailadres": "Enter a valid e-mail address.",
    "common.opnieuw": "Retry",
    "common.remove": "Remove",
    "common.noMatches": "Nothing matches that search.",
    // Deep-link module guard (App.tsx): shown instead of a page whose owning module is disabled.
    "app.moduleDisabled": "This module is disabled for this organisation.",
    // Overrides the generated Jmix key: the api now accepts a bare host address and stores it as
    // its /32 range, so the placeholder shows both spellings (the generator has no source bundle
    // left to regenerate from — Jmix was removed).
    "serviceAccountDetailView.allowlist.add.placeholder": "e.g. 198.51.100.0/29 or 198.51.100.7",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "entityAdmin.loadFailed": "Could not load this screen.",
    "entityAdmin.search": "Search...",
    "entityAdmin.create": "New",
    "entityAdmin.edit": "Edit",
    "entityAdmin.delete": "Delete",
    "entityAdmin.empty": "Nothing recorded yet.",
    "entityAdmin.prev": "Previous",
    "entityAdmin.next": "Next",
    "entityAdmin.pageOf": "Page %s of %s",
    "entityAdmin.createTitle": "New %s",
    "entityAdmin.editTitle": "Edit %s",
    "entityAdmin.saveConflict": "This record was changed by someone else. Reload and try again.",
    "entityAdmin.saveError": "Saving failed.",
    "entityAdmin.deleteTitle": "Delete",
    "entityAdmin.deleteBody": "Are you sure you want to delete this record?",
    "entityAdmin.rowCount": "%s records",
    "entityAdmin.catalogTitle": "Data management",
    "entityAdmin.choiceBlank": "(not set)",
    // wizard-dialog-mode: the intake/release wizard dialog's "switch to the full-page view" action
    "wizard.openAsPage": "Open as full page",
    "common.close": "Close",
    "common.back": "Back",
    "common.open": "Open",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.view": "View",
    "common.delete": "Delete",
    "common.confirm": "Confirm",
    // communicatie (read-foundation UI) — the SPA read screens for templates/log/media. READ-ONLY.
    "communicatieRead.title": "Communication",
    "communicatieRead.tab.templates": "Templates",
    "communicatieRead.tab.log": "Log",
    "communicatieRead.tab.media": "Media",
    "communicatieRead.refresh": "Refresh",
    "communicatieRead.template.new": "New template",
    "communicatieRead.template.delete.title": "Delete template",
    "communicatieRead.template.delete.confirm": "Are you sure you want to delete this template?",
    "communicatieRead.template.new.failed": "The template could not be created.",
    "communicatieRead.loadFailed": "Could not load communication data.",
    "communicatieRead.filter.all": "All",
    "communicatieRead.type.EMAIL": "E-mail",
    "communicatieRead.type.PRINT": "Print",
    "communicatieRead.status.ACTIEF": "Active",
    "communicatieRead.status.CONCEPT": "Draft",
    "communicatieRead.status.INACTIEF": "Inactive",
    "communicatieRead.status.FOUT": "Error",
    "communicatieRead.origin.STANDAARD": "Standard",
    "communicatieRead.origin.AANGEPAST": "Customized",
    "communicatieRead.category.ASIEL": "Shelter",
    "communicatieRead.category.PENSION": "Boarding",
    "communicatieRead.category.FACTUREN": "Invoices",
    "communicatieRead.category.PLANNING": "Planning",
    "communicatieRead.category.DIER": "Animal",
    "communicatieRead.category.RELATIE": "Relation",
    "communicatieRead.category.ALGEMEEN": "General",
    "communicatieRead.pagination.range": "%d–%d of %d",
    "communicatieRead.pagination.previous": "Previous",
    "communicatieRead.pagination.next": "Next",
    "communicatieRead.pagination.page": "Page %d of %d",
    "communicatieRead.template.title": "Communication templates",
    "communicatieRead.template.empty": "No templates found.",
    "communicatieRead.template.search.placeholder": "Search templates…",
    "communicatieRead.template.filter.search": "Search",
    "communicatieRead.template.edit": "Edit",
    "communicatieRead.template.filter.type": "Type",
    "communicatieRead.template.filter.category": "Category",
    "communicatieRead.template.filter.status": "Status",
    "communicatieRead.template.column.name": "Name",
    "communicatieRead.template.column.type": "Type",
    "communicatieRead.template.column.category": "Category",
    "communicatieRead.template.column.status": "Status",
    "communicatieRead.template.column.origin": "Origin",
    "communicatieRead.template.column.modified": "Last modified",
    "communicatieRead.template.column.modifiedBy": "Modified by",
    "communicatieRead.template.section.body": "Body",
    "communicatieRead.template.section.settings": "Settings",
    "communicatieRead.template.section.versions": "Version history",
    "communicatieRead.template.body.empty": "(no content)",
    "communicatieRead.template.field.key": "Key",
    "communicatieRead.template.field.language": "Language",
    "communicatieRead.template.field.subject": "Subject",
    "communicatieRead.template.field.description": "Description",
    "communicatieRead.template.field.paperFormat": "Paper format",
    "communicatieRead.template.field.orientation": "Orientation",
    "communicatieRead.template.field.margins": "Margins",
    "communicatieRead.template.field.showLogoHeader": "Logo header",
    "communicatieRead.template.field.showPageNumberFooter": "Page-number footer",
    "communicatieRead.template.field.showSignatureBlock": "Signature block",
    "communicatieRead.template.field.sender": "Sender",
    "communicatieRead.template.field.replyTo": "Reply-to",
    "communicatieRead.template.field.cc": "Cc",
    "communicatieRead.template.field.bcc": "Bcc",
    "communicatieRead.template.field.attachmentNote": "Attachment note",
    "communicatieRead.template.field.sendOnlyOpeningHours": "Send only during opening hours",
    "communicatieRead.template.field.logInDossier": "Log in dossier",
    "communicatieRead.template.field.requiredBlock": "Required block",
    "communicatieRead.template.field.published": "Published",
    "communicatieRead.template.field.created": "Created",
    "communicatieRead.template.field.createdBy": "Created by",
    "communicatieRead.template.field.modified": "Modified",
    "communicatieRead.template.field.modifiedBy": "Modified by",
    "communicatieRead.template.version.number": "Version",
    "communicatieRead.template.version.subject": "Subject",
    "communicatieRead.template.version.summary": "Change summary",
    "communicatieRead.template.version.changedBy": "Changed by",
    "communicatieRead.template.version.changedAt": "Changed at",
    "communicatieRead.template.version.empty": "No versions recorded.",
    "communicatieRead.log.title": "Communication log",
    "communicatieRead.log.empty": "No log entries found.",
    "communicatieRead.log.filter.type": "Type",
    "communicatieRead.log.filter.status": "Status",
    "communicatieRead.log.filter.recipient": "Recipient",
    "communicatieRead.log.column.occurredAt": "Date/time",
    "communicatieRead.log.column.type": "Type",
    "communicatieRead.log.column.template": "Template",
    "communicatieRead.log.column.status": "Status",
    "communicatieRead.log.column.subject": "Subject",
    "communicatieRead.log.column.recipient": "Recipient",
    "communicatieRead.log.column.related": "Linked to",
    "communicatieRead.log.column.sentBy": "Sent by",
    "communicatieRead.log.related.dier": "Animal",
    "communicatieRead.log.related.relatie": "Contact",
    "communicatieRead.log.related.verblijf": "Stay",
    "communicatieRead.log.related.factuur": "Invoice",
    "communicatieRead.logType.EMAIL": "E-mail",
    "communicatieRead.logType.PRINT": "Print",
    "communicatieRead.logType.AUTO_HERINNERING": "Auto reminder",
    "communicatieRead.logType.TESTMAIL": "Test mail",
    "communicatieRead.logStatus.VERZONDEN": "Sent",
    "communicatieRead.logStatus.AFGEDRUKT": "Printed",
    "communicatieRead.logStatus.CONCEPT": "Draft",
    "communicatieRead.logStatus.MISLUKT": "Failed",
    "communicatieRead.media.title": "Media library",
    "communicatieRead.media.empty": "No media found.",
    "communicatieRead.media.previewHint": "Previews are not available yet — only metadata is shown. Thumbnails arrive in a later release.",
    "communicatieRead.media.search.placeholder": "Search media…",
    "communicatieRead.media.filter.type": "Type",
    "communicatieRead.media.filter.usage": "Usage",
    "communicatieRead.media.column.name": "Name",
    "communicatieRead.media.column.type": "Type",
    "communicatieRead.media.column.usage": "Usage allowed in",
    "communicatieRead.media.column.fileName": "File name",
    "communicatieRead.media.column.size": "Size",
    "communicatieRead.media.column.defaultWidth": "Default width",
    "communicatieRead.media.column.created": "Created",
    "communicatieRead.mediaType.LOGO": "Logo",
    "communicatieRead.mediaType.AFBEELDING": "Image",
    "communicatieRead.mediaType.HANDTEKENING": "Signature",
    "communicatieRead.mediaType.PICTOGRAM": "Pictogram",
    "communicatieRead.mediaType.QRCODE": "QR code",
    "communicatieRead.mediaUsage.EMAIL": "E-mail",
    "communicatieRead.mediaUsage.PRINT": "Print",
    "communicatieRead.mediaUsage.BEIDE": "Both",
    "communicatieRead.media.column.preview": "Preview",
    "communicatieRead.media.column.actions": "Actions",
    "communicatieRead.media.upload": "Upload",
    "communicatieRead.media.edit": "Edit",
    "communicatieRead.media.edited": "The media item has been updated.",
    "communicatieRead.media.edit.titel": "Edit media item",
    "communicatieRead.media.edit.bestand": "File: %s (cannot be changed — upload a new item to replace it)",
    "communicatieRead.media.edit.naamVerplicht": "Enter a name.",
    "communicatieRead.media.edit.breedteOngeldig": "Enter a width in pixels, or leave it empty.",
    "communicatieRead.media.edit.breedteLeeg": "Empty = original size",
    "communicatieRead.media.edit.fout": "The media item could not be updated.",
    "communicatieRead.media.delete": "Delete",
    "communicatieRead.media.uploaded": "File uploaded.",
    "communicatieRead.media.deleted": "File deleted.",
    "communicatieRead.media.deleteError": "Could not delete the file.",
    "communicatieRead.media.upload.title": "Upload media",
    "communicatieRead.media.upload.file": "File",
    "communicatieRead.media.upload.name": "Name",
    "communicatieRead.media.upload.submit": "Upload",
    "communicatieRead.media.upload.fileRequired": "Choose a file first.",
    "communicatieRead.media.upload.error": "Upload failed.",
    // communicatie (Slice 6) — the WYSIWYG template editor (edit mode, variable palette, save/publish).
    "communicatieEditor.action.edit": "Edit",
    "communicatieEditor.action.save": "Save concept",
    "communicatieEditor.action.publish": "Publish",
    "communicatieEditor.action.restore": "Restore default",
    "communicatieEditor.toolbar.label": "Formatting",
    "communicatieEditor.toolbar.bold": "Bold",
    "communicatieEditor.toolbar.italic": "Italic",
    "communicatieEditor.toolbar.underline": "Underline",
    "communicatieEditor.toolbar.strike": "Strikethrough",
    "communicatieEditor.toolbar.h1": "Heading 1",
    "communicatieEditor.toolbar.h2": "Heading 2",
    "communicatieEditor.toolbar.paragraph": "Paragraph",
    "communicatieEditor.toolbar.bulletList": "Bullet list",
    "communicatieEditor.toolbar.orderedList": "Numbered list",
    "communicatieEditor.toolbar.blockquote": "Quote",
    "communicatieEditor.toolbar.alignLeft": "Align left",
    "communicatieEditor.toolbar.alignCenter": "Align center",
    "communicatieEditor.toolbar.alignRight": "Align right",
    "communicatieEditor.toolbar.alignJustify": "Justify",
    "communicatieEditor.tegel.link": "Link",
    "communicatieEditor.tegel.image": "Image",
    "communicatieEditor.tegel.table": "Table",
    "communicatieEditor.tegel.signature": "Signature",
    "communicatieEditor.tegel.qr": "QR code",
    "communicatieEditor.tegel.hr": "Rule",
    "communicatieEditor.tegel.pageBreak": "Page break",
    "communicatieEditor.toolbar.hr": "Horizontal rule",
    "communicatieEditor.toolbar.pageBreak": "Page break",
    "communicatieEditor.tegel.kopVoet": "Header/footer",
    "communicatieEditor.toolbar.kopVoet": "Header and footer: on every page, or a separate header for page 1",
    "communicatieEditor.kopVoet.kop": "Header — every page",
    "communicatieEditor.kopVoet.kopEerste": "Header — page 1 only",
    "communicatieEditor.kopVoet.voet": "Footer — every page",
    "communicatieEditor.kopVoet.add": "Add",
    "communicatieEditor.kopVoet.edit": "Edit",
    "communicatieEditor.kopVoet.remove": "Remove",
    "communicatieEditor.kopVoet.hint": "Printed in the page margin and repeated on every page. The margin grows with the content.",
    "communicatieEditor.toolbar.signature": "Signature block",
    "communicatieEditor.toolbar.qr": "QR code",
    "communicatieEditor.toolbar.undo": "Undo",
    "communicatieEditor.toolbar.redo": "Redo",
    "communicatieEditor.toolbar.color": "Text colour",
    "communicatieEditor.toolbar.fill": "Background colour (cell or block)",
    "communicatieEditor.toolbar.noFill": "No background colour",
    "communicatieEditor.toolbar.indent": "Increase indent",
    "communicatieEditor.toolbar.outdent": "Decrease indent",
    "communicatieEditor.toolbar.colorClear": "Remove colour",
    "communicatieEditor.toolbar.fontFamily": "Font",
    "communicatieEditor.toolbar.fontFamilyDefault": "Default font",
    "communicatieEditor.toolbar.fontSize": "Size",
    "communicatieEditor.toolbar.fontSizeDefault": "Default size",
    "communicatieEditor.toolbar.link": "Insert / edit link",
    "communicatieEditor.toolbar.image": "Image from computer",
    "communicatieEditor.toolbar.table": "Table",
    "communicatieEditor.link.dialogTitle": "Hyperlink",
    "communicatieEditor.link.urlLabel": "Link URL",
    "communicatieEditor.link.urlPlaceholder": "https://…",
    "communicatieEditor.link.apply": "Apply",
    "communicatieEditor.link.remove": "Remove link",
    "communicatieEditor.link.cancel": "Cancel",
    "communicatieEditor.table.insert": "Insert table (3×3)",
    "communicatieEditor.table.addRowBefore": "Row above",
    "communicatieEditor.table.addRowAfter": "Row below",
    "communicatieEditor.table.deleteRow": "Delete row",
    "communicatieEditor.table.addColumnBefore": "Column left",
    "communicatieEditor.table.addColumnAfter": "Column right",
    "communicatieEditor.table.deleteColumn": "Delete column",
    "communicatieEditor.table.mergeCells": "Merge cells",
    "communicatieEditor.table.splitCell": "Split cell",
    "communicatieEditor.table.toggleHeaderRow": "Toggle header row",
    "communicatieEditor.table.deleteTable": "Delete table",
    "communicatieEditor.table.editHeading": "Edit selected table",
    "communicatieEditor.palette.title": "Available fields",
    "communicatieEditor.hulp.titel": "Let me help you",
    "communicatieEditor.hulp.bezig": "Thinking…",
    "communicatieEditor.hulp.toepassen": "Apply",
    "communicatieEditor.hulp.toegepast": "Applied to the document.",
    "communicatieEditor.hulp.voorstelKlaar": "Proposal ready.",
    "communicatieEditor.hulp.geenVoorstel": "No proposal came back. Try describing it differently.",
    "communicatieEditor.hulp.tokensKwijt": "The proposal loses one or more {fields}, so it cannot be applied. Try a smaller step.",
    "communicatieEditor.hulp.mislukt": "That did not work. Try again, or use the AI assistant.",
    "communicatieEditor.hulp.voorbeeld": "e.g. I want an invoice line here",
    "communicatieEditor.hulp.invoegen": "Add",
    "communicatieEditor.hulp.veldIngevoegd": "%s inserted at the cursor.",
    "communicatieEditor.hulp.ingevoegd": "%s inserted at the cursor.",
    "communicatieEditor.hulp.onbekend": "I don't recognise that yet. The blocks below I can insert.",
    "communicatieEditor.palette.search": "Filter fields…",
    "communicatieEditor.palette.empty": "No fields match.",
    "communicatieEditor.preview.title": "Preview",
    "communicatieEditor.raw.noticeShort": "Print document with fixed layout",
    "communicatieEditor.raw.notice":
      "This is a fixed-layout print document. You edit the document itself — its exact layout is preserved. Dashed blocks are repeated per record.",
    "communicatieEditor.raw.sourceLabel": "Document content",
    "communicatieEditor.raw.readOnlyHint": "You do not have permission to edit this document.",
    "communicatieEditor.error.title": "Cannot publish:",
    "communicatieEditor.error.conflict": "This template was changed elsewhere. Reload to get the latest version before saving.",
    "communicatieEditor.error.generic": "Something went wrong.",
    "communicatieEditor.notice.saved": "Concept saved.",
    "communicatieEditor.notice.published": "Template published.",
    "communicatieEditor.notice.restored": "Restored to the default content.",
    "communicatieImport.actie": "Import document",
    "communicatieImport.titel": "Import a document as a template",
    "communicatieImport.formaten": "PDF and scans keep their exact layout. A Word file (.docx) contributes its text and tables — fonts, colours and images are not carried over; save it as PDF if the exact layout matters. The old .doc format cannot be read.",
    "communicatieImport.intro": "Upload the letter or form you fill in by hand today. It is rebuilt as a template, with the values that differ per case replaced by fields, and any block that recurs per animal or per cost line marked as a repeating block.",
    "communicatieImport.kies": "Choose file",
    "communicatieImport.bezig": "Rebuilding the document…",
    "communicatieImport.bezigUitleg": "A full page can take a few minutes. You don't have to wait: close this window and carry on — a notice in the bottom right tells you when it is ready.",
    "communicatieImport.stoppen": "Stop",
    "communicatieImport.verderWerken": "Carry on working",
    "communicatieImport.anderSjabloon": "This document was rebuilt for \"%s\". You can still use it here.",
    "communicatieImport.melding.bezig": "Rebuilding document…",
    "communicatieImport.melding.klaar": "Document rebuilt",
    "communicatieImport.melding.fout": "Rebuilding failed",
    "communicatieImport.melding.voor": "%s · for %s",
    "communicatieImport.melding.bekijken": "View",
    "takenAi.melding.bezig": "Drafting a task with AI…",
    "takenAi.melding.klaar": "The task proposal is ready",
    "takenAi.melding.fout": "The AI proposal failed",
    "aiVoorstel.melding.sessie": "Your session expired — log in again",
    "aiVoorstel.melding.bekijken": "View",
    "aiVoorstel.melding.stoppen": "Stop",
    "wizardAi.melding.bezig": "Building a wizard with AI…",
    "wizardAi.melding.klaar": "The wizard is ready",
    "wizardAi.melding.fout": "Building the wizard failed",
    "communicatieImport.voorbeeld": "Rebuilt document",
    "communicatieImport.velden": "Recognised fields (%s)",
    "communicatieImport.geenVelden": "No fields were recognised — the document was taken over as fixed text.",
    "communicatieImport.herhaalblokken": "Repeating blocks (%s)",
    "communicatieImport.herhaalblok.uitleg": "Placed once; printed once per %s",
    "communicatieImport.onbekend": "Ignored, not a known field: %s",
    "communicatieImport.nazien": "Check the fields against the original before you save: what is a field cannot always be told from the layout alone.",
    "communicatieImport.overnemen": "Use this",
    "communicatieImport.fout.generiek": "The document could not be read.",
    "communicatieImport.fout.sessie": "Your session has expired. Refresh the page (F5), sign in again and try once more.",
    "communicatieImport.diagnose": "What the server saw",
    "communicatieImport.fout.status": "The server refused the request (status %s). Try again; if it keeps happening, report it.",
    "communicatieEditor.header.title": "Edit template",
    "communicatieEditor.header.lastSaved": "Last saved: %s",
    "communicatieEditor.action.more": "More actions",
    "communicatieEditor.rail.template": "Template",
    "communicatieEditor.pane.editor": "Editor",
    "communicatieEditor.pane.preview": "Preview",
    "communicatieEditor.pane.settings": "Settings",
    "communicatieEditor.pane.history": "History",
    "communicatieEditor.pane.historyHint": "Version history of this template.",
    "communicatieEditor.pane.settingsReadOnly": "Print and e-mail settings are managed here.",
    "communicatieEditor.settings.title": "Template settings",
    "communicatieEditor.settings.language": "Language",
    "communicatieEditor.info.title": "Information",
    "communicatieEditor.info.code": "Code",
    "communicatieEditor.info.description": "Description",
    "communicatieEditor.insert.title": "Insert",
    "communicatieEditor.insert.hint": "Click a field to insert it",
    "communicatieEditor.preview.hint": "Filled in with sample data, exactly as it will be printed or sent — nothing is sent.",
    "communicatieEditor.preview.refresh": "Refresh",
    "communicatieEditor.preview.loading": "Building preview…",
    "communicatieEditor.preview.failed": "The preview could not be built.",
    "communicatieEditor.preview.page": "Page %s of %s",
    "communicatieEditor.preview.subject": "Subject",
    "communicatieEditor.validation.none": "No problems found",
    "communicatieEditor.validation.problems": "%s problem(s) found",
    "communicatieEditor.testMail.action": "Send test mail",
    "communicatieEditor.testMail.title": "Send test mail",
    "communicatieEditor.testMail.intro": "Enter an e-mail address to receive a test mail.",
    "communicatieEditor.testMail.recipient": "To",
    "communicatieEditor.testMail.placeholder": "name@example.com",
    "communicatieEditor.testMail.note": "The test mail uses sample data (Fam. van Diessen, Beertje).",
    "communicatieEditor.testMail.send": "Send test mail",
    "communicatieEditor.testMail.sent": "Test mail sent to %s.",
    "communicatieEditor.testMail.notConfigured": "Mail is not configured — no test mail was sent. Configure the mail server in the settings first.",
    "communicatieEditor.testMail.error.required": "Enter a recipient address.",
    "communicatieEditor.testMail.error.generic": "Could not send the test mail.",
    "communicatieEditor.mediaInsert.action": "Insert image (media library)",
    "communicatieEditor.mediaInsert.title": "Insert image from media library",
    "communicatieEditor.mediaInsert.empty": "No images in the media library.",
    "communicatieEditor.mediaInsert.error": "Could not load the image.",
    "communicatieEditor.letterhead.title": "Letterhead",
    "communicatieEditor.letterhead.hint": "Customise the header and footer of the printed document. Leave everything blank to use the default derived from the location details.",
    "communicatieEditor.letterhead.brand": "Brand",
    "communicatieEditor.letterhead.name": "Organisation name",
    "communicatieEditor.letterhead.lines": "Address lines (one per line)",
    "communicatieEditor.letterhead.footer": "Footer",
    "communicatieAi.title": "AI assistant",
    "communicatieAi.toggle.show": "AI assistant",
    "communicatieAi.toggle.hide": "Close AI assistant",
    "communicatieAi.strip.friendlier": "Rewrite friendlier",
    "communicatieAi.strip.shorter": "Make it shorter",
    "communicatieAi.strip.check": "Check fields",
    "communicatieAi.strip.privacy": "Add privacy block",
    "communicatieAi.strip.email": "Make e-mail version",
    "communicatieAi.apply": "Apply",
    "communicatieAi.notPlaceholderSafe": "This proposal drops or changes fields and cannot be applied safely.",
    "communicatieAi.busy": "Working on it…",
    "communicatieAi.error.generic": "The AI assistant is unavailable right now.",
    "communicatieAi.rewrite.label": "Rewrite",
    "communicatieAi.rewrite.friendlier": "Friendlier",
    "communicatieAi.rewrite.formal": "More formal",
    "communicatieAi.rewrite.shorter": "Shorter",
    "communicatieAi.rewrite.longer": "Longer",
    "communicatieAi.rewrite.grammar": "Fix spelling",
    "communicatieAi.rewrite.b1": "Plain (B1) language",
    "communicatieAi.rewrite.custom": "Custom instruction…",
    "communicatieAi.rewrite.customPlaceholder": "e.g. make this suitable for a phone reminder",
    "communicatieAi.rewrite.customRun": "Rewrite",
    "communicatieAi.review.label": "Review",
    "communicatieAi.action.check": "Check template",
    "communicatieAi.action.suggestFields": "Suggest fields",
    "communicatieAi.action.close": "Close",
    "communicatieAi.proposal.title": "Proposal",
    "communicatieAi.proposal.apply": "Apply",
    "communicatieAi.proposal.noProvider": "No AI provider is configured — this is a sample proposal without real AI.",
    "communicatieAi.proposal.notApplicable": "This proposal changed or dropped variable fields and cannot be applied safely. Cancel and try again.",
    "communicatieAi.check.title": "Quality check — score %d/100",
    "communicatieAi.check.allGood": "No issues found.",
    "communicatieAi.suggestFields.title": "Suggested fields",
    "communicatieAi.suggestFields.insert": "Insert",
    // Search-migration E3 (FR14–FR16) — the global-search header dropdown + the basic `zoekresultaten`
    // route. nl = the verbatim Jmix literal (GlobalSearch.java / SearchResultsView.java).
    "search.placeholder": "Search for an animal, contact, chip number, phone, invoice or ask a question…",
    "search.aria.label": "Search",
    "search.smartPill.label": "Smart search",
    "search.smartPill.title": "Ask a question in plain language — e.g. \"cats with an expired vaccination\"",
    "search.tab.all": "All",
    "search.tab.animals": "Animals",
    "search.tab.relations": "Contacts",
    "search.tab.invoices": "Invoices",
    "search.group.animals": "Animals",
    "search.group.relations": "Contacts",
    "search.group.invoices": "Invoices",
    "search.group.shelters": "Stays",
    "search.badge.animal": "Animal",
    "search.badge.relation": "Contact",
    "search.badge.invoice": "Invoice",
    "search.badge.stay": "Stay",
    "search.count.none": "No results",
    "search.count.one": "%d result",
    "search.count.many": "%d results",
    "search.minChars": "Type at least %d characters to search.",
    "search.empty": "No results found.",
    "search.footer.title": "View all results",
    "search.footer.sub": "View all %d results on the full search page",
    "search.recent.title": "Recent searches",
    "search.recent.all": "All recent searches",
    "search.ai.title": "Smart search: \"%s\"",
    "search.ai.hint": "Press Enter or click Apply to interpret this question in plain language.",
    "search.ai.apply": "Apply",
    "search.results.title": "Search results",
    "search.results.prompt": "Enter a search term to view results.",
    "search.results.empty": "No results found for '%s'.",
    "search.results.aiPending":
      "Smart search (AI interpretation) arrives in a later phase; showing the standard results for now.",
    "search.results.loadFailed": "Search failed.",
    // Search-migration E4 (FR17–FR23) — the full `/zoekresultaten` results page. nl = the verbatim Jmix
    // literal (SearchResultsView.java / AISearchPanel.java); en is the translated counterpart.
    "zoekresultaten.subtitle.error": "Search could not be completed right now.",
    "zoekresultaten.subtitle.one": "%d result for '%s'",
    "zoekresultaten.subtitle.many": "%d results for '%s'",
    "zoekresultaten.empty.noQuery": "Enter a search term to find animals, contacts and invoices.",
    "zoekresultaten.empty.error":
      "Search could not be completed right now. Try again or clear your search term.",
    "zoekresultaten.empty.facetsEmpty": "No results within the selected filters.",
    "zoekresultaten.action.clearQuery": "Clear search term",
    "zoekresultaten.action.clearFilters": "Clear filters",
    "zoekresultaten.filter.type": "Type:",
    "zoekresultaten.filter.period": "Period:",
    "zoekresultaten.sort.prefix": "Sort by",
    "zoekresultaten.period.all": "All",
    "zoekresultaten.period.week": "Last week",
    "zoekresultaten.period.month": "Last month",
    "zoekresultaten.period.year": "Last year",
    "zoekresultaten.filters.title": "Filters",
    "zoekresultaten.filters.clearAll": "Clear all",
    "zoekresultaten.tabs.label": "Filter results by type",
    "zoekresultaten.section.typeResult": "Result type",
    "zoekresultaten.section.species": "Species",
    "zoekresultaten.section.relationRole": "Contact role",
    "zoekresultaten.section.sort": "Sort",
    "zoekresultaten.sort.relevance": "Relevance",
    "zoekresultaten.sort.newest": "Newest first",
    "zoekresultaten.sort.oldest": "Oldest first",
    "zoekresultaten.sort.name_az": "Name A-Z",
    "zoekresultaten.animalStatus.in_care": "In care",
    "zoekresultaten.animalStatus.foster": "In foster care",
    "zoekresultaten.animalStatus.placed": "Placed",
    "zoekresultaten.animalStatus.checked_out": "Checked out",
    "zoekresultaten.animalStatus.deceased": "Deceased",
    "zoekresultaten.animalStatus.beschikbaar": "Available",
    "zoekresultaten.species.dog": "Dog",
    "zoekresultaten.species.cat": "Cat",
    "zoekresultaten.species.rabbit": "Rabbit",
    "zoekresultaten.species.rodent": "Rodent",
    "zoekresultaten.species.bird": "Bird",
    "zoekresultaten.species.other": "Other",
    "zoekresultaten.relationType.person": "Person",
    "zoekresultaten.relationType.organization": "Organisation",
    "zoekresultaten.relationRole.eigenaar": "Owner",
    "zoekresultaten.relationRole.vinder": "Finder",
    "zoekresultaten.relationRole.brenger": "Bringer",
    "zoekresultaten.relationRole.pleeggezin": "Foster family",
    "zoekresultaten.relationRole.donateur": "Donor",
    "zoekresultaten.relationRole.dierenambulance": "Animal ambulance",
    "zoekresultaten.relationRole.dierenartspraktijk": "Veterinary practice",
    "zoekresultaten.relationRole.leverancier": "Supplier",
    "zoekresultaten.invoiceStatus.open": "Outstanding",
    "zoekresultaten.invoiceStatus.paid": "Paid",
    "zoekresultaten.invoiceStatus.expired": "Expired",
    "zoekresultaten.invoiceStatus.credited": "Credited",
    "zoekresultaten.invoiceStatus.cancelled": "Cancelled",
    "zoekresultaten.chip.query": "Search term: %s",
    "zoekresultaten.chip.tab": "Tab: %s",
    "zoekresultaten.chip.hidden": "Not shown: %s",
    "zoekresultaten.chip.animalStatus": "Residency status: %s",
    "zoekresultaten.chip.species": "Species: %s",
    "zoekresultaten.chip.relationType": "Contact type: %s",
    "zoekresultaten.chip.relationRole": "Role: %s",
    "zoekresultaten.chip.invoiceStatus": "Invoice status: %s",
    "zoekresultaten.chip.minDays": "Length of stay: > %d days",
    "zoekresultaten.chip.remove": "Remove filter: %s",
    "zoekresultaten.showMore.dieren": "View all animals",
    "zoekresultaten.showMore.relaties": "View all contacts",
    "zoekresultaten.showMore.facturen": "View all invoices",
    "zoekresultaten.section.dieren.emptyNone": "No animals found for '%s'.",
    "zoekresultaten.section.dieren.emptyFiltered": "No animals within the selected filters.",
    "zoekresultaten.section.relaties.emptyNone": "No contacts found for '%s'.",
    "zoekresultaten.section.relaties.emptyFiltered": "No contacts within the selected filters.",
    "zoekresultaten.section.facturen.emptyNone": "No invoices found for '%s'.",
    "zoekresultaten.section.facturen.emptyFiltered": "No invoices within the selected filters.",
    "zoekresultaten.section.verblijven.emptyNone": "No stays found for '%s'.",
    "zoekresultaten.section.verblijven.emptyFiltered": "No stays within the selected filters.",
    "zoekresultaten.card.chip": "Chip: %s",
    "zoekresultaten.recent.clearAll": "Clear all",
    "zoekresultaten.quickActions.title": "Quick actions",
    "zoekresultaten.quickActions.newAnimal": "Register new animal",
    "zoekresultaten.quickActions.newRelation": "Add new contact",
    "zoekresultaten.quickActions.newInvoice": "Create invoice",
    "zoekresultaten.quickActions.newStay": "Create stay",
    "zoekresultaten.tip.title": "Tip",
    "zoekresultaten.tip.text": 'Use quotation marks for an exact search, for example "Kitten Beertje".',
    "zoekresultaten.ai.title": "Smart search: %s",
    "zoekresultaten.ai.interpretedAs": "Interpreted as:",
    "zoekresultaten.ai.usedData": "Data used:",
    "zoekresultaten.ai.unsupported": "Not yet supported: %s",
    "zoekresultaten.samenvatting.totaal": "Total",
    "zoekresultaten.samenvatting.aantal": "Number",
    "zoekresultaten.samenvatting.toonOnderliggend": "Show the underlying records",
    "zoekresultaten.samenvatting.onder": "Records under",
    "zoekresultaten.samenvatting.terug": "Back to the summary",
    "zoekresultaten.samenvatting.exportCsv": "Export to CSV",
    "zoekresultaten.samenvatting.gemiddelde": "Average",
    "zoekresultaten.samenvatting.zonderWaarde": "records had no value and were left out",
    "menu.dataInsight": "Data & Insight",
    "dataInsight.title": "Data & Insight",
    "dataInsight.onderdeel": "Onderdeel",
    "dataInsight.uitsplitsen": "Break down by",
    "dataInsight.gebied": "Municipality or town",
    "dataInsight.gemeenten": "Municipalities",
    "dataInsight.woonplaatsen": "Towns",
    "dataInsight.ouderDan": "older than",
    "dataInsight.jongerDan": "younger than",
    "dataInsight.ouderDanEenheid": "Unit for older than",
    "dataInsight.jongerDanEenheid": "Unit for younger than",
    "dataInsight.leeftijdWeken": "weeks",
    "dataInsight.leeftijdMaanden": "months",
    "dataInsight.leeftijdJaren": "years",
    "dataInsight.vanDatum": "From date",
    "dataInsight.totDatum": "To date",
    "dataInsight.periodeSnel": "Quick period choices",
    "dataInsight.periodeDezeMaand": "This month",
    "dataInsight.periodeDitKwartaal": "This quarter",
    "dataInsight.periodeDitJaar": "This year",
    "dataInsight.periodeLaatste12": "Last 12 months",
    "dataInsight.periodeVorigJaar": "Last year",
    "dataInsight.periodeVijfJaar": "Last 5 years",
    "dataInsight.groepHuidige": "Current location",
    "dataInsight.groepVestigingen": "Locations",
    "dataInsight.welkeVestigingen": "Which",
    "dataInsight.huidigeVestiging": "Current location",
    "dataInsight.gekozen": "selected",
    "dataInsight.groepDiersoort": "Species",
    "dataInsight.groepGemeente": "Municipality (where found)",
    "dataInsight.trendlijn": "National trend line",
    "dataInsight.trendlijnNietBeschikbaar": "National figures are not in this database, so this comparison cannot be drawn here.",
    "dataInsight.periodeAs": "Period",
    "dataInsight.aantalDieren": "Number of animals",
    "dataInsight.diersoort": "Species",
    "dataInsight.alleSoorten": "All species",
    "dataInsight.alleGemeenten": "All municipalities",
    "dataInsight.leeftijd": "Age",
    "dataInsight.geenOnderdelen": "The list of analyses could not be loaded. Reload the page; if it persists, the server may be unreachable.",
    "dataInsight.leeftijdOnbekend": "Animals without a date of birth have no age and fall outside this bound.",
    "dataInsight.periode": "Period",
    "dataInsight.vanJaar": "From year",
    "dataInsight.totJaar": "To year",
    "dataInsight.tot": "to",
    "dataInsight.eenheid": "Period unit",
    "dataInsight.perJaar": "Per year",
    "dataInsight.perMaand": "Per month",
    "dataInsight.perKwartaal": "Per quarter",
    "dataInsight.perWeek": "Per week",
    "dataInsight.perDag": "Per day",
    "dataInsight.kgPerKwartaal": "Average per quarter",
    "dataInsight.kgPerWeek": "Average per week",
    "dataInsight.kgPerDag": "Average per day",
    "dataInsight.tovVorigJaar": "vs. the same period last year",
    "dataInsight.geenVergelijking": "no comparable period",
    "dataInsight.tabAi": "Ask AI",
    "dataInsight.tabStandaard": "Standard analyses",
    "dataInsight.tabKaart": "Origin map",
    "herkomst.titel": "Where do the animals come from?",
    "herkomst.uitleg": "Per intake the municipality entered as the found location: for a stray where it was found, for a surrender where the owner lives.",
    "herkomst.periode": "Period",
    "herkomst.laatste12": "Last 12 months",
    "herkomst.ditJaar": "This year",
    "herkomst.vorigJaar": "Last year",
    "herkomst.laatste5": "Last 5 years",
    "herkomst.van": "From",
    "herkomst.tot": "to",
    "herkomst.totDatum": "To",
    "herkomst.diersoort": "Species",
    "herkomst.alleSoorten": "All species",
    "herkomst.opnamesoort": "Intake type",
    "herkomst.alleOpnamesoorten": "All intake types",
    "herkomst.vestigingen": "Branches",
    "herkomst.huidigeVestiging": "Current branch",
    "herkomst.niveau": "Detail",
    "herkomst.perGemeente": "Per municipality",
    "herkomst.perPostcode": "Per postcode area",
    "herkomst.weergave": "View",
    "herkomst.warmte": "Heat",
    "herkomst.bollen": "Circles",
    "herkomst.opnames": "intakes",
    "herkomst.totaal": "Intakes in this period",
    "herkomst.opDeKaart": "On the map",
    "herkomst.meesteHerkomst": "Most animals from",
    "herkomst.postcode": "Postcode",
    "herkomst.zonderGemeente": "intakes without a municipality are not on the map.",
    "herkomst.zonderPostcode": "intakes without a postcode are not on the map.",
    "herkomst.nietGevonden": "intakes come from a place that cannot be found on the map (for example a municipality that no longer exists).",
    "herkomst.nogOpzoeken": "places are still being looked up; the map fills in by itself.",
    "herkomst.leeg": "No intakes with a found location for this selection.",
    "herkomst.weinig": "few",
    "herkomst.veel": "many",
    "herkomst.postcodeUitleg": "Per postcode: for a stray the postcode of the found location (not always entered), for a surrender, return or exchange that of the relation who brought the animal.",
    "herkomst.herstel": "Reset filters",
    "herkomst.gekozen": "selected",
    "herkomst.alleVestigingen": "All branches",
    "herkomst.richting": "Intake or departure",
    "herkomst.opname": "Intake",
    "herkomst.vertrek": "Departure",
    "herkomst.soortOpname": "Intake type",
    "herkomst.soortVertrek": "Departure type",
    "herkomst.alleSoortenKort": "all types",
    "herkomst.geenSoorten": "No types found.",
    "herkomst.titelVertrek": "Where do the animals go?",
    "herkomst.uitlegVertrek": "Per departure the place or postcode of the relation the animal went to: the new owner, the owner on a return, or the shelter on an exchange.",
    "herkomst.totaalVertrek": "Departures in this period",
    "herkomst.meesteBestemming": "Most animals to",
    "herkomst.vertrekken": "departures",
    "herkomst.zonderAdres": "departures without an address are not on the map, for example euthanasia or death.",
    "herkomst.zonderPostcodeVertrek": "departures without a postcode are not on the map.",
    "herkomst.nietGevondenVertrek": "departures go to a place that cannot be found on the map.",
    "herkomst.leegVertrek": "No departures with an address for this selection.",
    "herkomst.excel": "Export to Excel",
    "dataInsight.verdelingKop": "Distribution",
    "dataInsight.eenheidDieren": "animals",
    "insights.veelgebruikt": "Frequently used",
    "insights.geenSnelkoppelingen": "No shortcuts available.",
    "dataInsight.recenteKop": "Most recent intakes",
    "dataInsight.recenteSub": "The {n} most recently registered intakes",
    "dataInsight.kolomRegistratie": "Registration number",
    "dataInsight.kolomRas": "Breed",
    "dataInsight.kolomGeslacht": "Sex",
    "dataInsight.kolomHerkomst": "Origin",
    "dataInsight.kolomDatum": "Intake date",
    "dataInsight.jaar": "year",
    "dataInsight.jaren": "years",
    "dataInsight.cumulatief": "Cumulative",
    "dataInsight.filter": "Filter",
    "dataInsight.bezig": "Working…",
    "dataInsight.geenPeriode": "This figure is a snapshot of right now; a period does not apply.",
    "dataInsight.eigenVraag": "Or ask your own question",
    "dataInsight.uitleg": "Find insights, ask questions and make better decisions.",
    "dataInsight.heroTitel": "Ask anything about your organisation",
    "dataInsight.heroSub": "Ask in plain language. We turn it into a query you can check and adjust.",
    "dataInsight.filterKop": "This is the figure being shown",
    "dataInsight.filterSub": "Check the definition and adjust the filters where needed.",
    "dataInsight.filtersHerstellen": "Reset filters",
    "dataInsight.kgTotaal": "Total",
    "dataInsight.kgPerJaar": "Average per year",
    "dataInsight.kgPerMaand": "Average per month",
    "dataInsight.kgOverPeriodes": "across {n} periods",
    "dataInsight.kgTrend": "Versus the previous period",
    "samenvatting.weergave": "View",
    "samenvatting.gestapeld": "Stacked",
    "samenvatting.staaf": "Bars",
    "samenvatting.lijn": "Line",
    "samenvatting.tabel": "Table",
    "samenvatting.onderliggend": "Underlying figures",
    "dataInsight.tipKop": "Tip of the day",
    "dataInsight.tipTekst": "Not sure how to phrase it? Start with a question about one thing, then narrow it down with the filters.",
    "dataInsight.tipVraag": "What is the average length of stay per species?",
    "dataInsight.placeholder": "For example: how many animals came in per month?",
    "dataInsight.vraagLabel": "Your question",
    "dataInsight.stelVraag": "Ask AI",
    "dataInsight.voorbeelden": "Example questions:",
    "dataInsight.resultaten": "results",
    "dataInsight.wedervraag": "Could you put that differently? I am not sure what to count.",
    "dataInsight.nietBegrepen": "Not taken into account",
    "dataInsight.nietIngeschakeld": "Data & Insight is not switched on in this environment. Contact Docasoft to enable it.",
    "dataInsight.nietBeschikbaar": "This screen is not available for your account, or the server cannot be reached.",
    "zoekresultaten.samenvatting.exportExcel": "Export to Excel",
    "zoekresultaten.samenvatting.exportBezig": "Preparing…",
    "zoekresultaten.samenvatting.exportFout": "The export could not be created",
    "insights.kop": "Saved analyses",
    "insights.nogGeen": "Nothing saved yet.",
    "insights.bewaren": "Save this analysis",
    "insights.naam": "Name",
    "insights.naamPlaceholder": "e.g. Monthly stray intake",
    "insights.zichtbaarheid": "Visibility",
    "insights.zicht.prive": "Private",
    "insights.zicht.vestiging": "Share with location",
    "insights.zicht.organisatie": "Share with organisation",
    "insights.verwijderen": "Delete",
    "insights.foutOnbekend": "That did not work.",
    "zoekresultaten.ai.notExecuted": "This question is not executed.",
    "zoekresultaten.ai.unavailable": "Smart search is temporarily unavailable.",
    "zoekresultaten.aiMode.structured_filter": "Interpreted as",
    "zoekresultaten.aiMode.partial": "Interpreted as (partial)",
    "zoekresultaten.aiMode.clarification": "Need help",
    "zoekresultaten.aiMode.how_to": "How-to",
    "zoekresultaten.howTo.ganaar": "Go to this screen",
    "zoekresultaten.howTo.laatZien": "Show me",
    "zoekresultaten.howTo.watBedoelJe": "What do you mean?",
    "zoekresultaten.howTo.andereKeuze": "No, I meant something else",
    "rondleiding.stapVan": "Step %d of %d",
    "rondleiding.volgende": "Next",
    "rondleiding.vorige": "Back",
    "rondleiding.klaar": "Done",
    "rondleiding.sluiten": "Close",
    "rondleiding.nietGevonden": "Not on your screen yet — open the group or section yourself. The moment it appears I will point at it; you can keep clicking.",
    "zoekresultaten.aiMode.out_of_scope": "Out of scope",
    "zoekresultaten.aiMode.rejected": "Rejected",
    "zoekresultaten.pagination.prev": "Previous",
    "zoekresultaten.pagination.next": "Next",
    "zoekresultaten.pagination.perPage": "%d per page",
    // Sidebar menu — mirrors the Jmix `menu.xml` groups/items (see messages_nl for the Dutch source
    // of truth). Group titles + item labels + the legacy hand-off tooltip.
    "menu.application.title": "Application",
    "menu.producten.title": "Products",
    "picker.title": "Add product or tariff",
    "picker.intro": "Pick a product or tariff from one of the available sources.",
    "picker.bronnen": "Sources",
    "picker.bron.alle": "All sources",
    "picker.bron.producten": "Products & services",
    "picker.bron.pension": "Boarding",
    "picker.bron.eerderPension": "Used before at the boarding kennel",
    "picker.bron.creche": "Day care",
    "picker.bron.asiel": "Shelter",
    "picker.bron.ambulance": "Ambulance",
    "picker.bron.crematie": "Cremation",
    "picker.bron.vervoer": "Cremation transport",
    "picker.hint.title": "One place, every source",
    "picker.hint.body": "Search and add lines from your product and tariff sources.",
    "picker.zoek": "Search product, code or category...",
    "picker.categorie": "Category",
    "picker.categorie.alle": "All categories",
    "picker.sorteren": "Sort by",
    "picker.info.bron": "Source",
    "picker.info.standaardprijs": "Standard price (incl. VAT)",
    "picker.info.btw": "VAT percentage",
    "picker.aantalMinder": "One less",
    "picker.aantalMeer": "One more",
    "picker.tekens": "%s / 255 characters",
    "picker.totaalOpbouw": "%s × %s (incl. VAT)",
    "picker.sorteren.meest": "Most used",
    "picker.sorteren.naamAf": "Name Z → A",
    "picker.sorteren.naam": "Name A → Z",
    "picker.sorteren.prijsOp": "Price (low → high)",
    "picker.sorteren.prijsAf": "Price (high → low)",
    "picker.kolom.omschrijving": "Description",
    "picker.kolom.categorie": "Category",
    "picker.kolom.prijs": "Price incl. VAT",
    "picker.kolom.btw": "VAT",
    "picker.kolom.bron": "Source",
    "picker.resultaten": "%s–%s of %s results",
    "picker.geenResultaten": "No results",
    "picker.perPagina": "%s per page",
    "picker.tip": "Tip: use the filters and search to find the right line quickly.",
    "picker.leeg": "No products or tariffs found.",
    "picker.geenRegels": "No product or tariff matches this search.",
    "picker.laadFout": "The product and tariff list could not be loaded.",
    "picker.leegBron": "This source does not feed any lines yet.",
    "picker.gekozen": "Selected line",
    "picker.gekozen.leeg": "Select a product or tariff to compose the line here.",
    "picker.aantal": "Quantity",
    "picker.prijs": "Price incl. VAT",
    "picker.regelTotaal": "Line total",
    "picker.btwRegel": "VAT %s%",
    "picker.toevoegen": "Add",
    "menu.financieel.title": "Finance",
    "financieel.title": "Invoice overviews",
    "financieel.tab.overzichten": "Overzichten",
    "financieel.tab.facturen": "Facturen",
    "financieel.tab.betalingen": "Betalingen",
    "financieel.tab.omzet": "Turnover",
    "financieel.tab.kasboek": "Kas uitgaven",
    "financieel.tab.dagafsluiting": "Dagafsluiting",
    "financieel.tab.soon": "This section is still being built.",
    "financieel.overzicht.title": "Invoice overview",
    "financieel.overzicht.subtitle": "All invoices and their payment status",
    "financieel.kpi.omzet": "Omzet",
    "financieel.kpi.openstaand": "Openstaand",
    "financieel.kpi.betaald": "Betaald",
    "financieel.kpi.vervallen": "Vervallen",
    "financieel.kpi.totaal": "Totaal",
    "financieel.kpi.scope": "Amounts sum the invoices on this page; the count is the whole search.",
    "financieel.filter.zoek": "Search invoice number, relation or animal...",
    "financieel.filter.periode": "Periode",
    "financieel.filter.status": "Status",
    "financieel.filter.vestiging": "Branch",
    "financieel.filter.onderdeel": "Module",
    "financieel.filter.actief": "Active",
    "financieel.filter.inactief": "Inactive",
    "financieel.sorteren": "Sort by",
    "financieel.sorteren.nieuwste": "Newest first",
    "financieel.sorteren.oudste": "Oldest first",
    "financieel.sorteren.bedrag": "Highest amount",
    "financieel.sorteren.openstaand": "Most outstanding",
    "financieel.filter.bedragVanaf": "Bedrag vanaf",
    "financieel.filter.wissen": "Filters wissen",
    "financieel.filter.alle": "Alle",
    "financieel.filter.alleenOpenstaand": "Toon alleen openstaande facturen",
    "financieel.periode.maand": "Deze maand",
    "financieel.periode.kwartaal": "Dit kwartaal",
    "financieel.periode.jaar": "Dit jaar",
    "financieel.periode.alles": "Alles",
    "financieel.periode.eigen": "Eigen periode",
    "financieel.periode.van": "Van",
    "financieel.periode.tot": "Tot",
    "financieel.resultaten": "%s results found",
    "financieel.leeg": "No invoices within these filters.",
    "financieel.weergave": "Weergave",
    "financieel.weergave.tabel": "Tabel",
    "financieel.weergave.klein": "Kleine tegels",
    "financieel.weergave.groot": "Grote tegels",
    "financieel.kolom.nummer": "Factuurnummer",
    "financieel.kolom.datum": "Datum",
    "financieel.kolom.relatie": "Relatie",
    "financieel.kolom.dier": "Dier",
    "financieel.kolom.onderdeel": "Onderdeel",
    "financieel.kolom.vestiging": "Vestiging",
    "financieel.kolom.vervaldatum": "Vervaldatum",
    "financieel.kolom.status": "Status",
    "financieel.kolom.totaal": "Totaal",
    "financieel.kolom.betaald": "Betaald",
    "financieel.kolom.openstaand": "Openstaand",
    "financieel.actie.openen": "Open",
    "financieel.actie.pdf": "Download PDF",
    "financieel.concept": "Draft",
    "financieel.kolom.eersteHerinnering": "1st reminder",
    "financieel.kolom.tweedeHerinnering": "2nd reminder",
    "financieel.kolom.incassoDatum": "Collection date",
    "financieel.kolom.klantId": "Customer ID",
    "financieel.kolom.klantBedrijf": "Company",
    "financieel.kolom.klantAdres": "Address",
    "financieel.kolom.klantPostcode": "Postcode",
    "financieel.kolom.klantWoonplaats": "City",
    "financieel.kolom.klantLand": "Country",
    "financieel.kolom.klantTelefoon": "Phone",
    "financieel.kolom.klantMobiel": "Mobile",
    "financieel.kolom.klantEmail": "E-mail",
    "financieel.kolom.debiteurnummer": "Debtor no.",
    "financieel.kolom.externeReferentie": "Booking no.",
    "financieel.kolom.exclBtw": "Excl. VAT",
    "financieel.kolom.btw": "VAT",
    "betalingen.overzicht.title": "Payment overview",
    "betalingen.overzicht.subtitle": "All payments and their payment status",
    "betalingen.kpi.ontvangen": "Received",
    "betalingen.kpi.openstaand": "Outstanding",
    "betalingen.kpi.terugbetaald": "Refunded",
    "betalingen.kpi.geannuleerd": "Cancelled",
    "betalingen.filter.zoek": "Search by payment reference, invoice or customer...",
    "betalingen.filter.betaalmethode": "Payment method",
    "betalingen.filter.alleenOpenstaand": "Show outstanding payments only",
    "betalingen.leeg": "No payments match these filters.",
    "betalingen.kolom.referentie": "Payment reference",
    "betalingen.kolom.factuur": "Invoice",
    "betalingen.kolom.betaalmethode": "Payment method",
    "betalingen.kolom.soort": "Kind",
    "betalingen.kolom.bedrag": "Amount",
    "betalingen.kolom.factuurTotaal": "Invoice total",
    "betalingen.kolom.factuurBetaald": "Paid",
    "betalingen.kolom.factuurOpenstaand": "Outstanding",
    "betalingen.kolom.dier": "Animal",
    "betalingen.kolom.onderdeel": "Module",
    "betalingen.kolom.vestiging": "Branch",
    "betalingen.kolom.vervaldatum": "Due date",
    "betalingen.status.ONTVANGEN": "Received",
    "betalingen.status.OPENSTAAND": "Outstanding",
    "betalingen.status.TERUGBETAALD": "Refunded",
    "betalingen.status.GEANNULEERD": "Cancelled",
    "betalingen.actie.factuur": "Open invoice",
    "omzet.title": "Turnover overview",
    "omzet.subtitle": "Turnover by ledger account, period and branch",
    "omzet.kpi.totaal": "Total turnover",
    "omzet.kpi.exclBtw": "Turnover excl. VAT",
    "omzet.kpi.btw": "VAT",
    "omzet.kpi.boekingen": "Bookings",
    "omzet.kpi.gemiddeld": "Avg. booking",
    "omzet.filter.zoek": "Search by ledger account, description or module...",
    "omzet.filter.grootboek": "Ledger account",
    "omzet.filter.groeperen": "Group by",
    "omzet.filter.weergave": "Display",
    "omzet.filter.alleenMetBoekingen": "Only show turnover with bookings",
    "omzet.groep.grootboek": "Ledger account",
    "omzet.groep.vestiging": "Branch",
    "omzet.groep.onderdeel": "Module",
    "omzet.groep.maand": "Month",
    "omzet.weergave.beide": "Excl. + incl. VAT",
    "omzet.weergave.excl": "Excl. VAT only",
    "omzet.weergave.incl": "Incl. VAT only",
    "omzet.kolom.grootboek": "Ledger account",
    "omzet.kolom.vestiging": "Branch",
    "omzet.kolom.onderdeel": "Module",
    "omzet.kolom.maand": "Month",
    "omzet.kolom.omschrijving": "Description",
    "omzet.kolom.exclBtw": "Turnover excl. VAT",
    "omzet.kolom.btw": "VAT",
    "omzet.kolom.inclBtw": "Turnover incl. VAT",
    "omzet.kolom.aantal": "Bookings",
    "omzet.kolom.verschil": "Change",
    "omzet.sorteren.hoogste": "Highest turnover",
    "omzet.sorteren.laagste": "Lowest turnover",
    "omzet.sorteren.boekingen": "Most bookings",
    "omzet.sorteren.sleutel": "Ledger account",
    "omzet.perMaand": "Turnover per month",
    "omzet.analyse": "View full analysis",
    "omzet.terug": "Back to overview",
    "omzet.analyse.titel": "Monthly turnover trend",
    "omzet.analyse.titelRekening": "Turnover trend %s %s",
    "omzet.actie.trend": "View trend",
    "omzet.actie.boekingen": "View bookings",
    "omzet.boekingen.titel": "Bookings %s",
    "omzet.boekingen.regel": "Line",
    "omzet.boekingen.leeg": "No bookings found.",
    "omzet.zonderRekening": "No ledger account",
    "omzet.trendBeperkt": "Last %s months",
    "omzet.leeg": "No turnover in this period.",
    "kasboek.title": "Cash expenses",
    "kasboek.subtitle": "Book cash income and expenses",
    "kasboek.nieuw": "New booking",
    "kasboek.kpi.saldo": "Cash balance",
    "kasboek.kpi.laatsteMutatie": "Last change %s",
    "kasboek.kpi.geenMutatie": "No changes yet",
    "kasboek.kpi.inkomstenVandaag": "Income today",
    "kasboek.kpi.uitgavenVandaag": "Expenses today",
    "kasboek.kpi.boekingen": "%s bookings",
    "kasboek.kpi.boekingenLabel": "Bookings",
    "kasboek.kpi.waarvanVerwerkt": "%s processed",
    "kasboek.open": "Open",
    "kasboek.recente": "Recent bookings",
    "kasboek.filter.van": "Period from",
    "kasboek.filter.tot": "to",
    "kasboek.filter.kas": "Drawer",
    "kasboek.filter.alleKassen": "All drawers",
    "kasboek.filter.type": "Type",
    "kasboek.filter.zoek": "Search description or reference...",
    "kasboek.soort.INKOMST": "Income",
    "kasboek.soort.UITGAVE": "Expense",
    "kasboek.kolom.datum": "Date",
    "kasboek.kolom.type": "Type",
    "kasboek.kolom.omschrijving": "Description",
    "kasboek.kolom.kas": "Drawer",
    "kasboek.kolom.bedrag": "Amount",
    "kasboek.kolom.saldo": "Balance",
    "kasboek.leeg": "No bookings in this period.",
    "kasboek.resultaten": "%s-%s of %s results",
    "kasboek.perPagina": "Per page",
    "kasboek.perPaginaN": "%s per page",
    "kasboek.actie.wijzigen": "Edit booking",
    "kasboek.dialoog.nieuw": "New cash booking",
    "kasboek.dialoog.wijzig": "Edit cash booking",
    "kasboek.dialoog.opslaan": "Save booking",
    "kasboek.veld.datum": "Date",
    "kasboek.veld.tegenrekening": "Customer / contra account",
    "kasboek.veld.referentie": "Reference",
    "kasboek.veld.notitie": "Note",
    "kasboek.veld.geenRekening": "No ledger account",
    "kasboek.veld.rekeningZoek": "Search number or description...",
    "kasboek.veld.rekeningGeen": "No account found.",
    "kasboek.veld.direct": "Process immediately",
    "kasboek.veld.directHint": "Record the booking now and include it in the day closing.",
    "kasboek.fout.omschrijving": "Enter a description.",
    "kasboek.fout.bedrag": "Enter an amount greater than 0.",
    "kasboek.fout.vestiging": "No branch selected.",
    "kasboek.fout.opslaan": "The booking could not be saved.",
    "dagafsluiting.title": "Day closing",
    "dagafsluiting.subtitle": "Close the drawer step by step and check everything point by point.",
    "dagafsluiting.kpi.beginkas": "Opening balance",
    "dagafsluiting.kpi.inkomsten": "Cash income",
    "dagafsluiting.kpi.uitgaven": "Cash expenses",
    "dagafsluiting.kpi.verwacht": "Expected balance",
    "dagafsluiting.stap.gegevens": "Check the data",
    "dagafsluiting.stap.tellen": "Count the cash",
    "dagafsluiting.stap.verschil": "Check the difference",
    "dagafsluiting.stap.afronden": "Four-eyes check & finish",
    "dagafsluiting.stapStand.open": "nog te doen",
    "dagafsluiting.stapStand.ok": "klaar",
    "dagafsluiting.stapStand.letop": "verschil zonder uitleg",
    "dagafsluiting.stapStand.wacht": "wacht op akkoord",
    "dagafsluiting.dagstand.afgesloten": "Afgesloten door %s op %s.",
    "dagafsluiting.dagstand.akkoord": "Akkoord van %s op %s.",
    "dagafsluiting.dagstand.wachtAkkoord": "Nog geen vier-ogen akkoord.",
    "dagafsluiting.stap1.titel": "Step 1 · Check the data",
    "dagafsluiting.stap1.uitleg": "Check the day's data and signals. If it all adds up, continue to counting the cash.",
    "dagafsluiting.stap2.titel": "Step 2 · Count the cash",
    "dagafsluiting.stap2.uitleg": "Count the money in the drawer and check whether the total matches the expected balance.",
    "dagafsluiting.stap3.titel": "Step 3 · Check the difference",
    "dagafsluiting.stap4.titel": "Step 4 · Four-eyes check & finish",
    "dagafsluiting.nogTeBouwen": "This step is built next.",
    "dagafsluiting.basis": "Basics",
    "dagafsluiting.basis.datum": "Date",
    "dagafsluiting.basis.kas": "Drawer",
    "dagafsluiting.basis.open": "Open bookings",
    "dagafsluiting.basis.laatste": "Last booking",
    "dagafsluiting.basis.geenBoeking": "No booking yet today",
    "dagafsluiting.basis.door": "Closed by",
    "dagafsluiting.cijfers": "Today in numbers",
    "dagafsluiting.cijfer.geplaatst": "animals placed",
    "dagafsluiting.cijfer.tovGisteren": "vs yesterday",
    "dagafsluiting.cijfer.adopties": "adoptions completed",
    "dagafsluiting.cijfer.herenigd": "animals reunited with their owner",
    "dagafsluiting.ai.mooieDag": "A good day!",
    "dagafsluiting.ai.rustigeDag": "A quiet day",
    "dagafsluiting.cijfer.donaties": "donations received",
    "dagafsluiting.cijfer.ingeschreven": "animals admitted",
    "dagafsluiting.ai.geen": "No summary yet — enable an AI provider to have the day summed up in one sentence.",
    "dagafsluiting.ai.opnieuw": "Summarise again",
    "dagafsluiting.controle": "Checkpoints",
    "dagafsluiting.check.datum": "Date is correct",
    "dagafsluiting.check.vestiging": "Correct branch selected",
    "dagafsluiting.check.open": "No open bookings",
    "dagafsluiting.check.klaar": "Ready to count the cash",
    "dagafsluiting.check.geteld": "Drawer fully counted",
    "dagafsluiting.check.losGeld": "Loose change included",
    "dagafsluiting.concept": "Save as draft",
    "dagafsluiting.conceptOp": "Draft saved: %s",
    "dagafsluiting.conceptFout": "The draft could not be saved. Please try again.",
    "dagafsluiting.verder.tellen": "Continue to counting",
    "dagafsluiting.verder.verschil": "Continue to the difference",
    "dagafsluiting.vorige": "Previous step",
    "dagafsluiting.biljetten": "Notes and coins",
    "dagafsluiting.aantalVan": "Count of %s",
    "dagafsluiting.totaalGeteld": "Total counted",
    "dagafsluiting.overnemen": "Copy from previous day",
    "dagafsluiting.overnemenVan": "Count of %s",
    "dagafsluiting.overnemenGeenVorige": "There is no closed day to copy from yet",
    "dagafsluiting.kopBiljetten": "Notes",
    "dagafsluiting.kopMunten": "Coins",
    "dagafsluiting.subtotaal": "Subtotal",
    "dagafsluiting.getaldSaldo": "Counted balance",
    "dagafsluiting.pasAan": "Adjust if needed.",
    "dagafsluiting.tip": "Tip: always count with two hands and work from large to small.",
    "dagafsluiting.stap3.uitleg": "Compare the counted drawer with today's recorded cash-book entries.",
    "dagafsluiting.stap3.tip": "An amount that does not match? Check the count or the bookings and adjust if needed.",
    "dagafsluiting.contantGeteld": "Cash (counted)",
    "dagafsluiting.pinGeteld": "Card terminal (counted)",
    "dagafsluiting.totaalContant": "Total cash",
    "dagafsluiting.aantal": "Count",
    "dagafsluiting.munten": "Coins",
    "dagafsluiting.pin": "Card",
    "dagafsluiting.pinTransacties": "Transactions",
    "dagafsluiting.pinBedrag": "Total amount",
    "dagafsluiting.pinHint": "Copy the total from the card terminal.",
    "dagafsluiting.bijlageToevoegen": "Attach the terminal slip",
    "dagafsluiting.bijlageVerwijderen": "Remove",
    "dagafsluiting.bijlageFout": "The terminal slip could not be saved. Please try again.",
    "dagafsluiting.boekingenVandaag": "Today's cash-book entries",
    "dagafsluiting.ontvangsten": "RECEIPTS",
    "dagafsluiting.contant": "Cash",
    "dagafsluiting.totaalOntvangsten": "Total receipts",
    "dagafsluiting.uitgavenKop": "EXPENSES",
    "dagafsluiting.uitgaven": "Expenses",
    "dagafsluiting.beginSaldoKop": "OPENING BALANCE",
    "dagafsluiting.beginSaldo": "Opening balance",
    "dagafsluiting.verwachtEindsaldo": "Expected closing balance",
    "dagafsluiting.klopt": "It all adds up!",
    "dagafsluiting.kloptSoort": "%s: matches",
    "dagafsluiting.erIsVerschil": "There is a difference",
    "dagafsluiting.verschilContantMeer": "The drawer holds %s more than expected.",
    "dagafsluiting.verschilContantMinder": "The drawer holds %s less than expected.",
    "dagafsluiting.verschilPinMeer": "The terminal counted %s more than booked.",
    "dagafsluiting.verschilPinMinder": "The terminal counted %s less than booked.",
    "dagafsluiting.zoekUit": "View the cash-book entries",
    "dagafsluiting.verbergBoekingen": "Hide the cash-book entries",
    "dagafsluiting.boekingenVanDag": "Cash-book entries of this day",
    "dagafsluiting.bekijkFacturen": "View the invoices",
    "dagafsluiting.verbergFacturen": "Hide the invoices",
    "dagafsluiting.facturenVanDag": "Invoices of this day",
    "dagafsluiting.geenFacturenDag": "No invoices were created on this day.",
    "dagafsluiting.factuurOpenen": "Open the invoice in a new tab",
    "dagafsluiting.factuurTip": "Click an invoice number to open it — to add a payment, for instance. It opens in a new tab so your count stays put.",
    "dagafsluiting.eigenaar": "Owner",
    "dagafsluiting.totaalFacturen": "Total",
    "dagafsluiting.geenBoekingenDag": "No cash-book entries were made on this day.",
    "dagafsluiting.uitzoekTip": "A booking that is wrong? Correct it in the cash book and come back; the amounts recalculate.",
    "dagafsluiting.kloptUitleg": "The counted amount equals the expected balance.",
    "dagafsluiting.meerInLade": "%s more counted than expected.",
    "dagafsluiting.minderInLade": "%s less counted than expected.",
    "dagafsluiting.verschil.contant": "Difference on cash",
    "dagafsluiting.verschil.pin": "Difference on card",
    "dagafsluiting.verder.vierogen": "Continue to the four-eyes check",
    "dagafsluiting.stap4.uitleg": "A second employee checks the day-closing and approves it before it is finalised.",
    "dagafsluiting.samenvatting": "Day-closing summary",
    "dagafsluiting.opsteller": "Closed by (author)",
    "dagafsluiting.voltooid": "Completed",
    "dagafsluiting.akkoordKop": "Check & approval by a colleague (four-eyes)",
    "dagafsluiting.naamCollega": "Colleague",
    "dagafsluiting.selecteerCollega": "Select a colleague",
    "dagafsluiting.wachtwoord": "Password",
    "dagafsluiting.wachtwoordHint": "Enter password",
    "dagafsluiting.wachtwoordTonen": "Show or hide the password",
    "dagafsluiting.akkoordGeven": "Give approval",
    "dagafsluiting.akkoordGegeven": "Approval given",
    "dagafsluiting.akkoordFout": "The approval could not be established. Check the colleague and the password.",
    "dagafsluiting.vierOgen": "Four-eyes principle",
    "dagafsluiting.vierOgenUitleg": "A second employee checks the day-closing and approves it. Without approval the day cannot be finalised.",
    "dagafsluiting.dagAfsluiten": "Close the day",
    "dagafsluiting.knopHint": "This button becomes active once a colleague approves, or when you leave the check for later.",
    "dagafsluiting.laterControleren": "Have a colleague check later",
    "dagafsluiting.laterGekozen": "Check follows later",
    "dagafsluiting.laterGekozenUitleg": "The day is closed as 'awaiting the four-eyes check'. A colleague approves it later.",
    "dagafsluiting.tochNu": "Check it now after all",
    "dagafsluiting.dagAfsluitenLater": "Close, check follows",
    "dagafsluiting.knopHintLater": "The day is recorded and awaits a colleague's approval.",
    "dagafsluiting.opmerkingKop": "Remark",
    "dagafsluiting.opmerkingHint": "For example: where the difference comes from, or what else happened.",
    "dagafsluiting.afsluitFout": "The day closing could not be recorded. Please try again.",
    "dagafsluiting.vastgelegd": "Day closed",
    "dagafsluiting.vastgelegdWacht": "Day closed — awaiting the check",
    "dagafsluiting.vastgelegdUitleg": "%s, closed by %s on %s.",
    "dagafsluiting.akkoordDoorNaam": "Approved by %s.",
    "dagafsluiting.verschilKop": "Difference",
    "dagafsluiting.terugNaarAfsluiting": "Back to the closing",
    "dagafsluiting.volgendeDag": "Close another day",
    "dagafsluiting.alAfgesloten": "This day is already closed",
    "dagafsluiting.alAfgeslotenUitleg": "Closing it again corrects that closing; it does not add a second one.",
    "dagafsluiting.vierOgenLater": "No colleague around? The day can be closed as 'awaiting the check' and approved later.",
    "dagafsluiting.geenCollega": "There is no second employee with an account available to approve.",
    "dagafsluiting.kiesDag": "Pick a day",
    "dagafsluiting.vorigeMaand": "Previous month",
    "dagafsluiting.volgendeMaand": "Next month",
    "dagafsluiting.dagAfgesloten": "This day is closed and approved",
    "dagafsluiting.dagAfgeslotenZonderAkkoord": "This day is closed, not yet approved",
    "dagafsluiting.legendaAf": "Already closed",
    "dagafsluiting.nogNietGeteld": "Nothing counted in step 2 yet.",
    "financieel.velden": "Columns",
    "financieel.filter.zoeken": "Search",
    "financieel.filter.gekozen": "%s selected",
    "financieel.filter.allesAan": "Select all",
    "financieel.filter.allesUit": "Clear all",
    "financieel.filter.vestigingZoek": "Search branch...",
    "financieel.filter.vestigingGeen": "No branch matches.",
    "financieel.pagina": "Page %s of %s",
    "menu.betalingen": "Payments",
    "menu.financieelOverzichten": "Overviews",
    "menu.kasboek": "Cash expenses",
    "menu.dagafsluiting": "Day closing",
    "menu.financieelExport": "Export",
    "menu.crematorium.title": "Crematorium",
    "menu.communicatie.title": "Communication",
    "menu.security.title": "Security",
    "menu.dashboard": "Dashboard",
    // Dashboard (/home) — Fawkes Command Center
    "dashboard.appName": "Fawkes Command Center",
    "dashboard.greeting": "Welcome back",
    "dashboard.greeting.morning": "Good morning",
    "dashboard.greeting.afternoon": "Good afternoon",
    "dashboard.greeting.evening": "Good evening",
    "dashboard.greeting.night": "Good night",
    "dashboard.banner.noVestiging": "Choose a branch in the sidebar to see branch-specific information.",
    "dashboard.action.newAnimal": "New animal",
    "dashboard.action.inboeken": "Check in",
    "dashboard.action.uitboeken": "Check out",
    "dashboard.kpi.ANIMALS_PRESENT": "Animals in care",
    "dashboard.kpi.INTAKES_TODAY": "Intakes today",
    "dashboard.kpi.RELEASES_TODAY": "Placements today",
    "dashboard.kpi.OPEN_INVOICES": "Outstanding invoices",
    "dashboard.kpi.current": "Now",
    "dashboard.kpi.vsYesterday": "vs. yesterday",
    "dashboard.metric.systemStatus": "System status",
    "dashboard.metric.operational": "All operational",
    "dashboard.section.operation": "Live operations",
    "dashboard.live": "Updated in real time",
    "dashboard.chart.title": "Intake vs. outflow",
    "dashboard.chart.period7": "Last 7 days",
    "dashboard.chart.empty": "No data to display yet.",
    "dashboard.chart.trend.intake": "Intake",
    "dashboard.chart.trend.outflow": "Outflow",
    "dashboard.chart.occupancy": "Occupancy per branch",
    "dashboard.capacity.title": "Capacity overview",
    "dashboard.capacity.occupancyLabel": "Occupancy",
    "dashboard.capacity.present": "animals present",
    "dashboard.capacity.link": "To capacity & occupancy",
    "dashboard.occupancy.totalLabel": "Total",
    "dashboard.occupancy.present": "present",
    "dashboard.locations.link": "View all locations",
    "dashboard.gewicht.title": "Weight signals",
    "dashboard.gewicht.buiten": "Animals outside target weight",
    "dashboard.gewicht.onder": "Underweight",
    "dashboard.gewicht.boven": "Overweight",
    "dashboard.gewicht.verlopen": "Weighing overdue",
    "dashboard.gewicht.allClear": "All animals are within their target weight and recently weighed.",
    "dashboard.gewicht.link": "To the weight overview",
    "dashboard.taken.open": "Open tasks",
    "dashboard.taken.mijnTeam": "Open tasks of my team",
    "dashboard.taken.geen": "No open tasks.",
    "dashboard.taken.achterstallig": "overdue",
    "dashboard.taken.vandaag": "today",
    "dashboard.vacc.title": "Vaccinations expired",
    "dashboard.vacc.attention": "Attention",
    "dashboard.vacc.allClear": "All present animals are up to date.",
    "dashboard.vacc.today": "today",
    "dashboard.vacc.within7": "within 7 days",
    "dashboard.vacc.priority": "Highest priority:",
    "dashboard.vacc.link": "To vaccinations overview",
    "dashboard.section.actions": "Actions & alerts",
    "dashboard.tab.all": "All",
    "dashboard.tab.tasks": "Tasks",
    "dashboard.tab.financial": "Financial",
    "dashboard.tab.alerts": "Alerts",
    "dashboard.actions.priorityTasks": "Priority tasks",
    "dashboard.actions.noTasks": "No priority tasks",
    "dashboard.actions.financialHeading": "Financial alerts",
    "dashboard.actions.noFinancial": "No financial alerts",
    "dashboard.actions.overdueSub": "Older than 30 days",
    "dashboard.actions.link": "To action log",
    "dashboard.alert.highOccSub": "Above target occupancy",
    "dashboard.section.today": "Today",
    "dashboard.today.emptyTitle": "No scheduled activities",
    "dashboard.today.emptySub": "Agenda integration coming",
    "dashboard.today.link": "View full planning",
    "dashboard.section.sla": "SLA signals & attention",
    "dashboard.sla.allClear": "No open signals — all clear.",
    "dashboard.sla.attentionSuffix": "attention points",
    "dashboard.sla.link": "To tasks & SLA dashboard",
    "dashboard.sla.view": "View",
    "dashboard.sla.overdueSuffix": "overdue invoices",
    "dashboard.sla.overdueSub": "Total outstanding:",
    "dashboard.sla.longStaySuffix": "animals over 60 days",
    "dashboard.sla.longStaySub": "Review recommended",
    "dashboard.workspaces": "Workspaces",
    "dashboard.ws.animals": "Animals",
    "dashboard.ws.animals.desc": "Manage animals, files and medical data",
    "dashboard.ws.relations": "Relations",
    "dashboard.ws.relations.desc": "Adopters, customers and contacts",
    "dashboard.ws.planning": "Planning",
    "dashboard.ws.planning.desc": "Agenda, services and activities",
    "dashboard.ws.exchanges": "Exchanges",
    "dashboard.ws.exchanges.desc": "Transports and transfers",
    "dashboard.ws.invoices": "Invoices",
    "dashboard.ws.invoices.desc": "Invoicing and financial overview",
    "dashboard.ws.settings": "Settings",
    "dashboard.ws.settings.desc": "System, users and preferences",
    "menu.animal": "Animal",
    "animals.empty.title": "No animal open yet",
    "animals.empty.info": "Open an animal from the search at the top, or register a new one.",
    "animals.empty.action": "Register an animal",
    "relaties.empty.title": "No relation open yet",
    "relaties.empty.info": "Open a relation from the search at the top, or add a new one.",
    "relaties.empty.action": "New relation",
    "menu.relaties": "Contacts",
    // sidebar-menu-parity: the consolidated Opvangoverzichten bundle + its five Jmix tab labels.
    "menu.opvangOverzichten": "Shelter overviews",
    "opvangModules.opvang": "Shelter",
    "opvangModules.pleeggezinnen": "Foster families",
    "opvangModules.nazorg": "Aftercare",
    "opvangModules.uitwisselingen": "Exchanges",
    "opvangModules.advertenties": "Advertisements",
    "opvangOverzichten.tab.aanwezig": "Present",
    "opvangOverzichten.tab.entingen": "Vaccinations",
    "opvangOverzichten.tab.ontwormen": "Deworming & flea control",
    "opvangOverzichten.tab.medicijn": "Medication",
    "opvangOverzichten.tab.vertrokken": "Departed",
    "menu.facturen": "Invoices",
    "menu.dierAttendance": "Animals present",
    "menu.dierPlacement": "Animals placed",
    "menu.kennelplanning": "Planning",
    "menu.shelterExchanges": "Exchanges",
    "menu.entingenOverzicht": "Vaccinations overview",
    "menu.ontwormenOverzicht": "Deworming & flea control",
    "menu.medicijnOverzicht": "Medication overview",
    "menu.nazorg": "Aftercare",
    // nazorg-beheer (aftercare admin) — Jmix NazorgBeheerView migration.
    "nazorg.title": "Aftercare",
    "nazorg.inzending.laden": "Loading aftercare answers…",
    "nazorg.inzending.fout": "This aftercare submission could not be loaded.",
    "nazorg.inzending.terug": "Back to overview",
    "nazorg.inzending.naarDier": "Open animal file",
    "nazorg.inzending.onbekendDier": "Unknown animal",
    "nazorg.inzending.adoptant": "Adopter",
    "nazorg.inzending.moment": "Moment",
    "nazorg.inzending.ingediend": "Submitted",
    "nazorg.inzending.chip": "Chip",
    "nazorg.inzending.antwoorden": "Answers per question",
    "nazorg.inzending.geenAntwoorden": "No answers with this submission.",
    "nazorg.inzending.signaal": "Signal",
    "nazorg.inzending.uitkomst": "Result",
    "nazorg.inzending.telGroen": "green",
    "nazorg.inzending.telOranje": "amber",
    "nazorg.inzending.telRood": "red",
    "nazorg.inzending.signalen": "Signals",
    "nazorg.inzending.vragenlijst": "Questionnaire",
    "nazorg.inzending.prioriteit.groen": "No attention needed",
    "nazorg.inzending.prioriteit.oranje": "Some attention",
    "nazorg.inzending.prioriteit.rood": "Needs attention",
    "nazorg.subtitle": "Track adoptions after placement and flag where things go wrong.",
    "nazorg.empty.moduleDisabled": "The aftercare module is disabled for this organisation.",
    "nazorg.tab.overzicht": "Overview",
    "nazorg.tab.vragenlijsten": "Questionnaires",
    "nazorg.tab.taken": "Tasks",
    "nazorg.tab.huisstijl": "Layout and theme",
    "nazorg.huisstijl.title": "Layout and theme",
    "nazorg.huisstijl.subtitle": "How the aftercare questionnaire looks to the adopter: your colours, your logo, your words.",
    "nazorg.huisstijl.opslaan": "Save",
    "nazorg.huisstijl.opgeslagen": "Saved. The platform uses this style from now on.",
    "nazorg.huisstijl.opslaanFout": "Saving failed. Please try again.",
    "nazorg.huisstijl.aiKop": "Fetch your house style",
    "nazorg.huisstijl.aiUitleg": "Give your website address. We take the colours and logo from it; you can adjust everything afterwards.",
    "nazorg.huisstijl.aiKnop": "Fetch",
    "nazorg.huisstijl.bezig": "Working…",
    "nazorg.huisstijl.uitWebsiteKlaar": "Colours taken from your website.",
    "nazorg.huisstijl.uitWebsiteKlaarMetLogo": "Colours and logo taken from your website.",
    "nazorg.huisstijl.uitWebsiteFout": "Could not fetch. Check the address.",
    "nazorg.huisstijl.gevonden": "Colours found",
    "nazorg.huisstijl.gebruikAlsHoofdkleur": "Use as main colour",
    "nazorg.huisstijl.logoKop": "Logo",
    "nazorg.huisstijl.logoKies": "Choose a logo",
    "nazorg.huisstijl.logoUitleg": "A png, jpg, webp or svg of at most 2 MB. We take colours from it right away.",
    "nazorg.huisstijl.logoWeg": "Remove logo",
    "nazorg.huisstijl.logoKlaar": "Logo updated.",
    "nazorg.huisstijl.logoFout": "The logo could not be saved.",
    "nazorg.huisstijl.kleurenKop": "Colours",
    "nazorg.huisstijl.kleur.primair": "Main colour",
    "nazorg.huisstijl.kleur.accent": "Accent colour",
    "nazorg.huisstijl.kleur.achtergrond": "Background",
    "nazorg.huisstijl.kleur.oppervlak": "Surfaces",
    "nazorg.huisstijl.kleur.tekst": "Text",
    "nazorg.huisstijl.letterKop": "Typeface",
    "nazorg.huisstijl.letter.SYSTEEM": "Default",
    "nazorg.huisstijl.letter.SCHREEF": "Serif",
    "nazorg.huisstijl.letter.ROND": "Round",
    "nazorg.huisstijl.letter.SMAL": "Narrow",
    "nazorg.huisstijl.tekstenKop": "Texts",
    "nazorg.huisstijl.kopTitel": "Title at the top",
    "nazorg.huisstijl.kopTitelHint": "For example: How is your new housemate doing?",
    "nazorg.huisstijl.welkomTekst": "Welcome text",
    "nazorg.huisstijl.welkomTekstHint": "A few lines the adopter reads first.",
    "nazorg.huisstijl.slotTekst": "Closing text",
    "nazorg.huisstijl.slotTekstHint": "For example: Thank you, we read your answers and get in touch when needed.",
    "nazorg.huisstijl.voorbeeldKop": "Preview",
    "nazorg.huisstijl.voorbeeldAria": "Preview of the questionnaire on a phone",
    "nazorg.huisstijl.voorbeeldKicker": "Aftercare",
    "nazorg.huisstijl.voorbeeldTitel": "How is Balou doing?",
    "nazorg.huisstijl.voorbeeldWelkom": "Thanks for taking a moment. A few short questions about how things are going.",
    "nazorg.huisstijl.voorbeeldVraag1": "How settled does he feel?",
    "nazorg.huisstijl.voorbeeldVraag2": "Is he eating well?",
    "nazorg.huisstijl.voorbeeldNee": "No",
    "nazorg.huisstijl.voorbeeldBeetje": "A little",
    "nazorg.huisstijl.voorbeeldPrima": "Fine",
    "nazorg.huisstijl.voorbeeldKnop": "Send",
    "nazorg.huisstijl.voorbeeldVoet": "This is what the adopter sees. On DierMatch your logo appears — the colours there stay DierMatch's own.",
    "nazorg.prio.rood": "Red",
    "nazorg.prio.oranje": "Orange",
    "nazorg.prio.groen": "Green",
    "nazorg.stat.lopend": "Ongoing aftercare",
    "nazorg.stat.rodeVlaggen": "Red flags",
    "nazorg.stat.teVolgen": "To follow up",
    "nazorg.stat.huisbezoeken": "Home visits",
    "nazorg.stat.reactiegraad": "Response rate",
    "nazorg.soort.alle": "All species",
    "nazorg.filter.zoek": "Search animal or adopter…",
    "nazorg.filter.prioriteit": "Outcome",
    "nazorg.filter.moment": "Contact moment",
    "nazorg.filter.status": "Handling",
    "nazorg.filter.alle": "All",
    "nazorg.filter.onbehandeld": "Still to pick up",
    "nazorg.filter.opgepakt": "Closed",
    "nazorg.filter.wissen": "Clear filters",
    "nazorg.moment.DAG_1_2": "1–2 days",
    "nazorg.moment.WEEK_1_2": "1–2 weeks",
    "nazorg.moment.MAAND_1": "1 month",
    "nazorg.moment.MAANDEN_6": "6 months",
    "nazorg.resultaten.aantal": "%d results",
    "nazorg.resultaten.aantalEen": "1 result",
    "nazorg.resultaten.leegFilter": "No aftercare results for this filter.",
    "nazorg.aandacht.vragenlijst": "Questionnaire:",
    "nazorg.verzending.title": "Aftercare invitations",
    "nazorg.verzending.subtitle": "What is still going out and what has already been sent.",
    "nazorg.verzending.filter.alles": "All",
    "nazorg.verzending.filter.gepland": "Still to send",
    "nazorg.verzending.filter.verstuurd": "Sent",
    "nazorg.verzending.zoek": "Search animal, adopter or town",
    "nazorg.verzending.periode": "Period",
    "nazorg.verzending.van": "From",
    "nazorg.verzending.tot": "Up to and including",
    "nazorg.verzending.col.dier": "Animal",
    "nazorg.verzending.col.vragenlijst": "Questionnaire",
    "nazorg.verzending.col.moment": "Contact moment",
    "nazorg.verzending.col.keer": "Time",
    "nazorg.verzending.col.adoptant": "Adopter",
    "nazorg.verzending.col.datum": "Date",
    "nazorg.verzending.col.status": "Status",
    "nazorg.verzending.keer": "no. %d",
    "nazorg.verzending.status.GEPLAND": "Queued",
    "nazorg.verzending.status.VERSTUURD": "Sent",
    "nazorg.verzending.status.GEOPEND": "Opened",
    "nazorg.verzending.status.INGEVULD": "Completed",
    "nazorg.verzending.status.VERLOPEN": "Expired",
    "nazorg.verzending.empty": "Nothing is queued and nothing has been sent yet.",
    "nazorg.verzending.openDossier": "Open the aftercare file",
    "nazorg.verzending.toelichting": "A planned invitation goes out automatically on the date shown.",
    "nazorg.aandacht.title": "Aftercare results",
    "nazorg.aandacht.adoptant": "Adopter:",
    "nazorg.aandacht.moment": "Moment:",
    "nazorg.aandacht.ingediend": "Submitted:",
    "nazorg.aandacht.resultaat": "Result:",
    "nazorg.aandacht.signaal": "%d signal",
    "nazorg.aandacht.signalen": "%d signals",
    "nazorg.aandacht.empty": "No adoptions need attention right now.",
    "nazorg.vragenlijsten.title": "Questionnaires",
    "nazorg.vragenlijsten.subtitle": "Aftercare questionnaires per contact moment and species.",
    "nazorg.vragenlijsten.filterAll": "All species",
    "nazorg.vragenlijsten.empty": "No questionnaires for this filter yet — create one with “New aftercare questionnaire”.",
    "nazorg.vragenlijsten.nieuweLijst": "New aftercare questionnaire",
    "nazorg.vragenlijsten.openTitel": "Open in the questionnaire builder",
    "nazorg.vragenlijsten.kanaalPlatform": "Platform",
    "nazorg.vragenlijsten.col.naam": "Questionnaire",
    "nazorg.vragenlijsten.col.diersoort": "Species",
    "nazorg.vragenlijsten.col.contactmoment": "Contact moment",
    "nazorg.vragenlijsten.col.kanaal": "Channel",
    "nazorg.vragenlijsten.col.status": "Status",
    "nazorg.status.gepubliceerd": "Published",
    "nazorg.status.concept": "Draft",
    "nazorg.status.gearchiveerd": "Archived",
    // Wizard-builder nazorg tab (nazorg-authoring epic): the in-SPA aftercare questionnaire editors.
    // Vocabulary option labels (contact moments, operators, colours, dimensions) come from the api
    // payload; these keys cover only the chrome around them.
    "wizards.nazorg.tab": "Aftercare",
    "wizards.nazorg.rowBadge": "Aftercare questionnaire",
    "wizards.nazorg.nieuw": "New aftercare questionnaire",
    "wizards.nazorg.geenVelden": "Add questions on the “Formulier bouwen” tab first — rules point at a question.",
    "wizards.nazorg.verwijderen": "Delete",
    "wizards.nazorg.config.title": "Sending & follow-up",
    "wizards.nazorg.config.lead": "When the questionnaire goes out after adoption and when it closes.",
    "wizards.nazorg.config.contactmoment": "Contact moment",
    "wizards.nazorg.config.doelgroep": "Audience",
    "wizards.nazorg.config.kanaal": "Channel",
    "wizards.nazorg.config.autoVersturen": "Send automatically at the contact moment",
    "wizards.nazorg.config.herinnerNaDagen": "Remind after (days)",
    "wizards.nazorg.config.sluitNaDagen": "Close after (days)",
    "wizards.nazorg.config.opslaan": "Save aftercare settings",
    "wizards.nazorg.vlagRegels.title": "Red-flag rules",
    "wizards.nazorg.vlagRegels.lead": "An answer that matches a rule colours the submission (red/orange/green) in the signals inbox.",
    "wizards.nazorg.vlagRegels.leeg": "No rules yet.",
    "wizards.nazorg.vlagRegels.toevoegen": "Add rule",
    "wizards.nazorg.scoreMapping.title": "Wellbeing score",
    "wizards.nazorg.scoreMapping.lead": "Weigh questions on a wellbeing dimension; the answers feed the animal's wellbeing score.",
    "wizards.nazorg.scoreMapping.leeg": "No mappings yet.",
    "wizards.nazorg.scoreMapping.toevoegen": "Add mapping",
    "wizards.nazorg.col.veld": "Question",
    "wizards.nazorg.col.operator": "Operator",
    "wizards.nazorg.col.waarde": "Value",
    "wizards.nazorg.col.kleur": "Colour",
    "wizards.nazorg.col.dimensie": "Dimension",
    "wizards.nazorg.col.weging": "Weight",
    "menu.productenCatalogus": "Products & Services",
    "menu.pensionTarief": "Boarding rates",
    "menu.pensionArrangementen": "Boarding packages",
    "pensionArrangement.titel": "Boarding packages",
    "pensionArrangement.subtitel": "Packages and extras the front desk can add to a booking.",
    "pensionArrangement.nieuw": "New package",
    "pensionArrangement.zoek": "Search packages…",
    "pensionArrangement.alles": "All",
    "pensionArrangement.niveau.DIER": "Per animal",
    "pensionArrangement.niveau.RESERVERING": "Whole booking",
    "pensionArrangement.niveau.DIER.uitleg": "chosen for each animal.",
    "pensionArrangement.niveau.RESERVERING.uitleg": "once for the whole booking, such as live updates.",
    "pensionArrangement.eenheid.PER_KEER": "Per time",
    "pensionArrangement.eenheid.PER_DAG": "Per day",
    "pensionArrangement.eenheid.PER_WEEK": "Per week",
    "pensionArrangement.eenheid.PER_VERBLIJF": "Per stay",
    "pensionArrangement.eenheid.kort.PER_KEER": "per time",
    "pensionArrangement.eenheid.kort.PER_DAG": "per day",
    "pensionArrangement.eenheid.kort.PER_WEEK": "per week",
    "pensionArrangement.eenheid.kort.PER_VERBLIJF": "per stay",
    "pensionArrangement.prijs.vast": "%s %s",
    "pensionArrangement.prijs.vanaf": "from %s %s",
    "pensionArrangement.geenPrijs": "No price yet",
    "pensionArrangement.alleSoorten": "All species",
    "pensionArrangement.filter.elkeSoort": "Species: any",
    "pensionArrangement.filter.inactief": "Show inactive",
    "pensionArrangement.max": "max. %s",
    "pensionArrangement.inactief": "Inactive",
    "pensionArrangement.bewerk": "Edit",
    "pensionArrangement.bewerkVan": "Edit %s",
    "pensionArrangement.prijs.knop": "Price",
    "pensionArrangement.prijsVan": "Price of %s",
    "pensionArrangement.verwijderVan": "Delete %s",
    "pensionArrangement.laadFout": "The packages could not be loaded.",
    "pensionArrangement.leeg": "No packages yet. Create the first one with New package.",
    "pensionArrangement.geenTreffers": "No packages match.",
    "pensionArrangement.venster.nieuw": "New package",
    "pensionArrangement.venster.bewerk": "Edit %s",
    "pensionArrangement.veld.naam": "Name",
    "pensionArrangement.veld.omschrijving": "Description",
    "pensionArrangement.veld.diersoort": "Species",
    "pensionArrangement.veld.eenheid": "Price applies",
    "pensionArrangement.veld.niveau": "Chosen per",
    "pensionArrangement.veld.maxAantal": "Maximum quantity",
    "pensionArrangement.veld.positie": "Order",
    "pensionArrangement.veld.vanaf": "The price is a starting price",
    "pensionArrangement.veld.actief": "Active: the front desk can choose it",
    "pensionArrangement.veld.foto": "Photo",
    "pensionArrangement.veld.effectdatum": "From",
    "pensionArrangement.veld.bedrag": "Amount incl. VAT",
    "pensionArrangement.veld.reden": "Reason",
    "pensionArrangement.foto.kies": "Choose photo",
    "pensionArrangement.foto.anders": "Other photo",
    "pensionArrangement.foto.weg": "Remove photo",
    "pensionArrangement.foto.voorbeeld": "Package photo",
    "pensionArrangement.foto.uitleg": "JPG, PNG or WEBP. Large photos are made smaller.",
    "pensionArrangement.fout.recht": "You are not allowed to change rates.",
    "pensionArrangement.fout.ongeldig": "Check the details.",
    "pensionArrangement.fout.algemeen": "Saving failed. Please try again.",
    "pensionArrangement.fout.foto": "Choose a JPG, PNG or WEBP.",
    "pensionArrangement.fout.naam": "The name is required.",
    "pensionArrangement.fout.bedrag": "Enter a date and an amount.",
    "pensionArrangement.fout.verleden": "A back-dated price needs rate administrator rights.",
    "pensionArrangement.prijs.titel": "Price of %s",
    "pensionArrangement.prijs.huidig": "Now:",
    "pensionArrangement.prijs.legend": "Price",
    "pensionArrangement.prijs.nieuwUitleg": "Fill in the price that applies from the starting date.",
    "pensionArrangement.prijs.wijzigUitleg": "Fill in a new amount to change the price from the given date; the earlier prices stay in the table below.",
    "pensionArrangement.prijs.geenHistorie": "No price yet.",
    "pensionArrangement.prijs.velduitleg": "Leave the amount empty to keep the current price. A new amount starts on the date given and is kept in the price history.",
    "pensionArrangement.prijs.bedragPlaats": "e.g. 23,50",
    "pensionArrangement.prijs.sinds": "since %s",
    "pensionArrangement.prijs.opslaan": "Save price",
    "pensionArrangement.prijs.opgeslagen": "The price has been saved.",
    "pensionArrangement.verwijder.titel": "Delete %s",
    "pensionArrangement.verwijder.bevestig": "Delete",
    "pensionArrangement.verwijder.uitleg": "The package and its prices disappear. What is already on a booking stays there.",
    "menu.crecheTarief": "Daycare rates",
    "menu.asielTarief": "Shelter rates",
    "menu.dierenambulanceTarief": "Animal ambulance rates",
    "menu.crematoriumTarief": "Crematorium rates",
    "menu.crematoriumVervoer": "Crematorium transport",
    "menu.crematoriumDashboard": "Dashboard",
    "menu.crematoriumAanmeldingen": "Registrations",
    "menu.crematoriumCrematies": "Dossiers",
    "menu.crematoriumPlanning": "Planning",
    "menu.crematoriumRuns": "Cremation runs",
    "menu.crematoriumAsRetour": "Ashes & urn return",
    "menu.crematoriumFacturen": "Invoices",
    "menu.crematoriumInstellingen": "Settings / rates",
    "menu.communicatie": "Communication",
    // sidebar-menu-parity: Vestigingen (Security) legacy hand-off.
    "menu.vestigingen": "Branches",
    "menu.users": "Users",
    // vestigingen-beheer: the branch-admin screen (Security menu). Edit-only master/detail.
    "vestigingenBeheer.new": "New",
    "vestigingenBeheer.new.disabled": "A branch cannot be created here: every branch is tied one-to-one to its own customer record, which has to exist first.",
    "vestigingenBeheer.eyebrow": "Branch",
    "vestigingenBeheer.field.status": "Status",
    "vestigingenBeheer.field.ubn": "UBN",
    "vestigingenBeheer.field.defaultModule": "Opens in module",
    "vestigingenBeheer.groep.add": "Add group",
    "vestigingenBeheer.groep.change": "Change group",
    "vestigingenBeheer.groep.linked": "Linked group",
    "vestigingenBeheer.groep.remove": "Unlink group",
    "vestigingenBeheer.groep.empty": "Not linked to a group",
    "vestigingenBeheer.title": "Branches",
    "vestigingenBeheer.searchLabel": "Search",
    "vestigingenBeheer.searchPlaceholder": "Name, town or code…",
    "vestigingenBeheer.filterLabel": "Status",
    "vestigingenBeheer.filter.all": "All",
    "vestigingenBeheer.filter.active": "Active",
    "vestigingenBeheer.filter.inactive": "Inactive",
    "vestigingenBeheer.col.naam": "Branch",
    "vestigingenBeheer.col.status": "Status",
    "vestigingenBeheer.status.active": "Active",
    "vestigingenBeheer.status.inactive": "Inactive",
    "vestigingenBeheer.loadFailed": "Could not load branches.",
    "vestigingenBeheer.saveFailed": "Save failed.",
    "vestigingenBeheer.empty": "No branches found.",
    "vestigingenBeheer.detail.empty": "Select a branch to view its details.",
    "vestigingenBeheer.group.basis": "Basic information",
    "vestigingenBeheer.group.contact": "Contact details",
    "vestigingenBeheer.group.bedrijf": "Business details",
    "vestigingenBeheer.group.adres": "Address",
    "vestigingenBeheer.group.postadres": "Postal address",
    "vestigingenBeheer.postadres.empty": "No separate postal address set",
    "vestigingenBeheer.group.groep": "Group",
    "vestigingenBeheer.group.logo": "Logo",
    "vestigingenBeheer.logo.choose": "Choose a logo",
    "vestigingenBeheer.logo.replace": "Replace logo",
    "vestigingenBeheer.logo.remove": "Remove",
    "vestigingenBeheer.logo.busy": "Uploading…",
    "vestigingenBeheer.logo.hint": "A png, jpg, webp or svg of at most 2 MB. Shown on this branch's own page on DierMatch.",
    "vestigingenBeheer.logo.failed": "The logo could not be saved.",
    "vestigingenBeheer.group.whatsapp": "WhatsApp",
    "vestigingenBeheer.whatsapp.gekoppeld": "Linked number",
    "vestigingenBeheer.whatsapp.gekoppeldOp": "Linked on",
    "vestigingenBeheer.whatsapp.door": "by",
    "vestigingenBeheer.whatsapp.nietGekoppeld": "This branch has no WhatsApp number of its own yet.",
    "vestigingenBeheer.whatsapp.uitleg": "Log in with the branch's Facebook account and choose or create a WhatsApp number. Messages from the relation tile are then sent from this number.",
    "vestigingenBeheer.whatsapp.koppelen": "Link WhatsApp",
    "vestigingenBeheer.whatsapp.opnieuw": "Link another number",
    "vestigingenBeheer.whatsapp.bezig": "Linking…",
    "vestigingenBeheer.whatsapp.ontkoppelen": "Unlink",
    "vestigingenBeheer.whatsapp.ontkoppelenVraag": "Unlink this WhatsApp number from the branch? The number stays yours at Meta.",
    "vestigingenBeheer.whatsapp.nietIngericht": "Linking WhatsApp has not been set up yet for this organisation.",
    "vestigingenBeheer.whatsapp.afgebroken": "Linking was cancelled; nothing has changed.",
    "vestigingenBeheer.whatsapp.metaFout": "Meta reported an error while linking.",
    "vestigingenBeheer.whatsapp.geenNummer": "Meta did not return a number. Please try again.",
    "vestigingenBeheer.whatsapp.sdkFout": "The Facebook login could not be loaded. Is a blocker active in the browser?",
    "vestigingenBeheer.whatsapp.mislukt": "Linking failed.",
    "vestigingenBeheer.whatsapp.laadFout": "The WhatsApp status could not be loaded.",
    "vestigingenBeheer.field.code": "Code",
    "vestigingenBeheer.field.naamKort": "Short name",
    "vestigingenBeheer.field.naam": "Name",
    "vestigingenBeheer.field.telefoonnummer": "Phone 1",
    "vestigingenBeheer.field.mobielnummer": "Phone 2",
    "vestigingenBeheer.field.noodnummer": "Emergency number (foster homes)",
    "vestigingenBeheer.field.noodnummer.placeholder": "Shown in the foster app, 24/7",
    "vestigingenBeheer.field.emailAdres": "E-mail address",
    "vestigingenBeheer.field.website": "Website",
    "vestigingenBeheer.field.kvkNummer": "CoC no.",
    "vestigingenBeheer.field.btwNummer": "VAT no.",
    "vestigingenBeheer.field.bankRekeningNummer": "Bank/giro",
    "vestigingenBeheer.field.straat": "Street",
    "vestigingenBeheer.field.huisnummer": "House no.",
    "vestigingenBeheer.field.postcode": "Postcode",
    "vestigingenBeheer.field.woonplaats": "Town",
    "vestigingenBeheer.field.land": "Country",
    "vestigingenBeheer.field.postbusNummer": "PO box",
    "vestigingenBeheer.field.postbusPostcode": "Postcode",
    "vestigingenBeheer.field.postbusWoonplaats": "Town",
    "vestigingenBeheer.field.groep": "Group",
    "vestigingenBeheer.field.groep.placeholder": "Group name",
    "vestigingenBeheer.postadres.copy": "Copy from visit address",
    "menu.serviceAccounts": "Service accounts",
    "menu.moduleManagement": "Module management",
    "menu.legacyHint": "Opens in the classic Backoffice",
    "menu.devTools.title": "Development",
    "menu.gallery.components": "Component gallery",
    "menu.gallery.tiles": "Tile gallery",
    "moduleManagementView.title": "Module management",
    "moduleManagementView.intro":
      "Switch functional modules on or off organisation-wide. A sub-module is unavailable while its parent module is off.",
    "moduleManagementView.loadFailed": "Could not load the modules.",
    "module.dashboard": "Dashboard",
    "module.communicatie": "Communication",
    "module.backofficeTest": "Test tools",
    "module.group.kern": "Core",
    "module.group.opvang": "Shelter operation",
    "module.group.communicatie": "Communication",
    "module.group.modules": "Modules",
    "module.group.datatools": "Data tools",
    "module.asiel": "Shelter",
    "module.asiel.desc":
      "Core shelter operation: intake, attendance, placements, shelter/ambulance rates and stays. Foster, kennel planning, exchanges and donor fall under this.",
    "module.pleeggezin": "Foster home",
    "module.pleeggezin.desc": "Foster tab on the relation screen (foster programme).",
    "module.kennelplanning": "Kennel planning",
    "module.kennelplanning.desc": "Planning and occupancy of kennels/enclosures.",
    "module.shelterExchanges": "Exchanges",
    "module.shelterExchanges.desc": "Exchange of animals between shelters.",
    "module.donateur": "Donor",
    "module.donateur.desc": "Donor tab on the relation screen (donations, recurring gifts, fiscal).",
    "module.pension": "Boarding",
    "module.pension.desc": "Animal boarding with its own rate screen.",
    "module.creche": "Day care",
    "module.creche.desc": "Day care with its own rate screen.",
    "module.crematorium": "Crematorium",
    "module.crematorium.desc":
      "Pet cremation and funeral process: intake, pickup, case file, planning, ash return and invoicing.",
    "module.advertentie": "Advertisement & AI",
    "module.advertentie.desc":
      "Compose adoption advertisements with AI assistance, review and approve, publish to ikzoekbaas.nl and generate social-media material.",
    "module.taken": "Tasks",
    "module.taken.desc":
      "Automatic and manual tasks around an animal: a Tasks tile and tab on the animal profile plus the admin screens for automatic task rules and task packages.",
    "module.wizards": "Registrations & Wizards",
    "module.wizards.desc":
      "Configurable registration wizards (steps and fields) with a dynamic tile on the animal; managed via Settings -> Registrations & Wizards.",
    "module.nazorg": "Aftercare",
    "module.nazorg.desc":
      "Adoption aftercare: questionnaires per contact moment, filled in by the adopter via the platform, with red-flag signalling, a welfare score and an aftercare dossier on the animal.",
    "module.leverancier": "Supplier",
    "module.leverancier.desc": "Supplier management (own screen in the Modules menu group).",
    "serviceAccountSelfServiceView.title": "My account",
    "serviceAccountCreateView.title": "New service account",
    "serviceAccountListView.empty": "No service accounts.",
    "serviceAccountListView.loadFailed": "Could not load service accounts.",
    "serviceAccountDetailView.loadFailed": "Could not load the service account.",
    "serviceAccountDetailView.edit": "Edit",
    "serviceAccountDetailView.credentials.none": "No credentials.",
    "serviceAccountDetailView.allowlist.none": "No IP ranges.",
    "productListView.title": "Products & Services",
    "productListView.empty": "No products.",
    "productListView.loadFailed": "Could not load products.",
    "productListView.search.placeholder": "Search…",
    "productListView.refresh": "Refresh",
    "productListView.kpi.totaleOmzet": "Total revenue",
    "productListView.kpi.totaleOmzet.sub": "Last 12 months",
    "productListView.kpi.dezeMaand": "Sold this month",
    "productListView.kpi.korting": "Discount given",
    "productListView.column.naam": "Name",
    "productListView.column.artikelCode": "Article code",
    "productListView.column.onderdeel": "Section",
    "productListView.column.type": "Type",
    "productListView.column.prijs": "Price",
    "productListView.column.scope": "Scope",
    "productListView.column.omzet": "Revenue",
    "productListView.column.stock": "Current stock",
    "productListView.onderdeel.fallback": "General",
    "productListView.stock.restricted": "Restricted",
    "productListView.stock.value": "Stock: %d",
    "productListView.column.open": "",
    "productListView.open": "Open",
    "productListView.scope.label": "Scope",
    "productListView.filter.onderdeel": "Section",
    "productListView.filter.type": "Type",
    "productListView.filter.all": "All",
    "catalogus.weergave": "View",
    "catalogus.weergave.kaart": "Cards",
    "catalogus.weergave.compact": "Compact cards",
    "catalogus.weergave.lijst": "List",
    "productListView.sort.label": "Sort by",
    "productListView.actions.label": "Row actions",
    "productListView.actions.edit": "Edit",
    "productListView.actions.delete": "Delete",
    "productListView.delete.title": "Delete product",
    "productListView.delete.body": "Delete %s? This cannot be undone.",
    "productListView.delete.confirm": "Delete",
    "productListView.delete.failed": "The product could not be deleted.",
    "productListView.actions.priceChange": "Change price…",
    "productListView.actions.history": "Show history…",
    "productListView.pagination.range": "%d–%d of %d",
    "pager.range": "%d–%d of %d results",
    "pager.pageSize": "Rows per page:",
    "pager.page": "Page %d",
    "productListView.pagination.page": "Page %d of %d",
    "productListView.pagination.previous": "Previous",
    "productListView.pagination.next": "Next",
    // tarief-bewerkscherm (Story 1.6) — wire the product price-change + history dialogs to the seam.
    "productPrijsWijziging.title": "Change price: %s",
    "productPrijsWijziging.current": "Current price",
    "productPrijsWijziging.bedrag": "New price",
    "productPrijsWijziging.effectdatum": "Effective date",
    "productPrijsWijziging.reden": "Reason (optional)",
    "productPrijsWijziging.strategy.label": "Running reservations",
    "productPrijsWijziging.strategy.BEHOUDEN_OUDE_PRIJS": "Do not change — keep the old price on those reservations",
    "productPrijsWijziging.strategy.ALLEMAAL_AANPASSEN": "Re-price all",
    "productPrijsWijziging.strategy.HANDMATIGE_SELECTIE": "Show selection and choose manually",
    "productPrijsWijziging.mailen": "E-mail customers of adjusted reservations",
    "productPrijsWijziging.banner": "There are %d running reservations from the effective date that use the old price.",
    "productPrijsWijziging.bedragRequired": "Enter a new price.",
    "productPrijsWijziging.submit": "Apply",
    "productPrijsWijziging.cancel": "Cancel",
    "productPrijsWijziging.success": "Price changed. New version created.",
    "productPrijsWijziging.successAffected": "Price changed. %d reservations re-calculated.",
    "productPrijsWijziging.error": "Price change failed.",
    "productPrijsWijziging.pastForbidden": "Only an administrator may apply a back-dated price change (retroactive).",
    "productTariefHistorie.title": "Tariff history: %s",
    "productTariefHistorie.empty": "No tariff versions known for this product.",
    "productTariefHistorie.loadFailed": "Could not load the tariff history.",
    "productTariefHistorie.column.vanaf": "From",
    "productTariefHistorie.column.tot": "Until",
    "productTariefHistorie.column.bedrag": "Amount",
    "productTariefHistorie.column.reden": "Reason",
    "productTariefHistorie.column.status": "Status",
    "productTariefHistorie.status.GEPLAND": "Planned",
    "productTariefHistorie.status.ACTIEF": "Active",
    "productTariefHistorie.status.VERVALLEN": "Expired",
    "productTariefHistorie.count": "%d version(s) found",
    "productTariefHistorie.close": "Close",
    // products-migration Story 1.3 — read-only product detail (six tiles, Jmix parity).
    "productDetailView.loadFailed": "Could not load product.",
    "productDetailView.identity.subtitle": "Product",
    "productDetailView.tile.basis": "Basic information",
    "productDetailView.tile.classificatie": "Classification & codes",
    "productDetailView.tile.voorraad": "Stock",
    "productDetailView.tile.prijzen": "Prices",
    "productDetailView.tile.boekhouding": "Accounting",
    "productDetailView.tile.metadata": "Metadata & properties",
    "productDetailView.basis.naam": "Product name",
    "productDetailView.basis.onderdeel": "Section",
    "productDetailView.onderdeel.fallback": "General",
    "productDetailView.basis.type": "Type",
    "productDetailView.basis.scope": "Scope",
    "productDetailView.basis.omschrijving": "Short description",
    "productDetailView.classificatie.artikelCode": "Article code / SKU",
    "productDetailView.classificatie.leverancier": "Supplier",
    "productDetailView.classificatie.ean": "EAN",
    "productDetailView.classificatie.eanPlaceholder": "EAN code",
    "productDetailView.classificatie.leverancierProductNrPlaceholder": "Leverancier productnr.",
    "productDetailView.classificatie.eenheidPlaceholder": "Selecteer eenheid",
    "productDetailView.metadata.jsonPlaceholder": "Bijv. { \"medisch\": true, \"koeling\": \"ja\", \"online\": false }",
    "productDetailView.classificatie.leverancierProductNr": "Supplier product no.",
    "productDetailView.classificatie.verkoopeenheid": "Sales unit",
    "productDetailView.classificatie.inkoopeenheid": "Purchase unit",
    "productDetailView.voorraad.beheer": "Stock management for this product",
    "productDetailView.voorraad.beheer.on": "On",
    "productDetailView.voorraad.beheer.off": "Off",
    "productDetailView.voorraad.minimum": "Minimum stock",
    "productDetailView.voorraad.maximum": "Maximum stock",
    "productDetailView.voorraad.huidig": "Current stock",
    "productDetailView.voorraad.besteleenheid": "Order quantity",
    "productDetailView.prijzen.vanaf": "From",
    "productDetailView.prijzen.verkoop": "Sale",
    "productDetailView.prijzen.inkoop": "Purchase",
    "productDetailView.prijzen.btw": "VAT",
    "productDetailView.prijzen.empty": "No price rules.",
    "productDetailView.prijzen.add": "Add price rule",
    "productDetailView.prijzen.remove": "Remove price rule",
    "productDetailView.prijzen.remove.confirm": "Remove this price rule?",
    "productDetailView.prijzen.dialog.title": "Add price rule",
    "productDetailView.prijzen.dialog.vanaf": "From",
    "productDetailView.prijzen.dialog.btw": "VAT",
    "productDetailView.prijzen.dialog.verkoop": "Sale price",
    "productDetailView.prijzen.dialog.inkoop": "Purchase price",
    "productDetailView.prijzen.dialog.inkoop.optional": "(Optional)",
    "productDetailView.prijzen.dialog.submit": "Add",
    "productDetailView.prijzen.dialog.required": "A sale price and VAT are required.",
    "productDetailView.prijzen.dialog.error": "Could not add the price rule.",
    "productDetailView.prijzen.remove.error": "Could not remove the price rule.",
    // products-migration Story 4.3 — Voorraadmutatie timeline + booking surface.
    "productDetailView.voorraad.mutaties": "↗ Movements",
    "productDetailView.mutaties.dialog.title": "Stock movements — %s",
    "productDetailView.mutaties.huidig": "Current stock:",
    "productDetailView.mutaties.book": "Book movement",
    "productDetailView.mutaties.close": "Close",
    "productDetailView.mutaties.empty": "No stock movements.",
    "productDetailView.factuurregel.view": "View invoice line",
    "productDetailView.factuurregel.title": "Invoice line",
    "productDetailView.factuurregel.close": "Close",
    "productDetailView.factuurregel.nummer": "Invoice number",
    "productDetailView.factuurregel.datum": "Invoice date",
    "productDetailView.factuurregel.soort": "Type",
    "productDetailView.factuurregel.product": "Product",
    "productDetailView.factuurregel.regelAantal": "Quantity on line",
    "productDetailView.factuurregel.stuksPrijs": "Unit price incl. VAT",
    "productDetailView.factuurregel.effect": "Effect on stock",
    "productDetailView.mutaties.col.datum": "Date",
    "productDetailView.mutaties.col.bron": "Source",
    "productDetailView.mutaties.col.soort": "Kind",
    "productDetailView.mutaties.col.omschrijving": "Description",
    "productDetailView.mutaties.col.aantal": "Quantity",
    "productDetailView.mutaties.col.voorraadNa": "Stock after",
    "productDetailView.mutaties.bron.HANDMATIG": "Manual",
    "productDetailView.mutaties.bron.VERKOOP": "Sale",
    "productDetailView.mutaties.book.title": "Book stock movement",
    "productDetailView.mutaties.book.datum": "Date",
    "productDetailView.mutaties.book.richting": "Direction",
    "productDetailView.mutaties.book.opboeking": "Add (to stock)",
    "productDetailView.mutaties.book.afboeking": "Remove (from stock)",
    "productDetailView.mutaties.book.aantal": "Quantity",
    "productDetailView.mutaties.book.soort": "Kind",
    "productDetailView.mutaties.book.reden": "Reason / notes",
    "productDetailView.mutaties.book.submit": "Book",
    "productDetailView.mutaties.book.required": "A quantity greater than 0 is required.",
    "productDetailView.mutaties.book.error": "Could not book the movement.",
    "productDetailView.mutaties.soort.INKOOP": "Purchase / receipt",
    "productDetailView.mutaties.soort.RETOUR": "Return from customer",
    "productDetailView.mutaties.soort.CORRECTIE": "Count correction",
    "productDetailView.mutaties.soort.AFSCHRIJVING": "Write-off / breakage",
    "productDetailView.mutaties.soort.OVERIG": "Other",
    "productDetailView.boekhouding.advanced": "Advanced",
    "productDetailView.boekhouding.grootboekrekening": "Ledger account",
    "productDetailView.boekhouding.projectcode": "Project code",
    "productDetailView.boekhouding.grootboekrekeningKorting": "Discount ledger account",
    "productDetailView.boekhouding.kostenplaats": "Cost center",
    "productDetailView.metadata.json": "JSON properties",
    "productDetailView.metadata.helper": "JSON for extra metadata (medical, stock, online, …).",
    "productDetailView.metadata.invalid": "Not valid JSON — fix it before saving.",
    "productDetailView.productType.VERKOOP": "Sale",
    "productDetailView.productType.DIENST": "Service",
    "productDetailView.productType.ENTING": "Vaccination",
    "productDetailView.productType.MEDICIJN": "Medicine",
    "productDetailView.productType.APOTHEEK": "Pharmacy",
    "productDetailView.productType.ONTWORMEN": "Deworming & flea control",
    "productDetailView.productType.ONTVLOOIEN": "Flea control",
    "productDetailView.scopeType.ORGANISATIE": "Entire organisation",
    "productListView.scope.ORGANISATIE": "Organisation",
    "productDetailView.scopeType.VESTIGING": "Only this branch",
    "productDetailView.scopeType.BEIDE": "Both",
    // products-migration Story 2.4 — editable plain tiles + create flow.
    "productEditView.title": "Edit product",
    "productEditView.edit": "Edit",
    "productEditView.cancel": "Cancel",
    "productEditView.save": "Save",
    "productEditView.saved": "Saved.",
    "productEditView.saveError": "Could not save. Please try again.",
    "productEditView.saveConflict": "Changed by someone else — please reload and try again.",
    "productEditView.naamRequired": "A product name is required.",
    "productEditView.select.none": "—",
    "productEditView.new": "New",
    "productEditView.create.title": "New product",
    "productEditView.create.naam": "Product name",
    "productEditView.create.onderdeel": "Section",
    "productEditView.create.type": "Type",
    "productEditView.create.scope": "Scope",
    "productEditView.create.submit": "Create",
    "productEditView.create.error": "Could not create the product.",
    // products-migration Story 5.1 — Tegels (tile visibility) dialog.
    "productDetailView.tegels": "Tiles",
    "productDetailView.tegels.title": "Show / hide tiles",
    "productDetailView.tegels.error": "Could not save the tile settings.",
    // products-migration Story 5.2 — guarded delete.
    "productDetailView.delete": "Delete",
    "productDetailView.delete.confirm": "Permanently delete this product?",
    "productDetailView.delete.done": "Product deleted.",
    "productDetailView.delete.error": "Could not delete the product. Please try again.",
    "productDetailView.tab.product": "Product",
    "productDetailView.tab.entingen": "Vaccinations",
    "productDetailView.tab.behandeling": "Deworming & flea control",
    "productDetailView.tab.medicijn": "Medicine",
    // products-migration (analytics tabs) — overview tab strip + Statistieken + Trends.
    "productOverview.tabs.label": "Products & Services tabs",
    "productOverview.tab.catalogus": "Catalogue",
    "productOverview.tab.statistieken": "Statistics",
    "productOverview.tab.trends": "Trends",
    // verblijf-wizard-tarief Epic 2 — Asiel tarief overview (Hond & Kat rule tab).
    "asielTarief.tabs.label": "Shelter rates tabs",
    "asielTarief.tab.hondkat": "Dog & Cat",
    "asielTarief.tab.overige": "Other species",
    "asielTarief.tab.retour": "Return to owner",
    "asielTarief.placeholder.overige": "Other species rates — coming soon.",
    "asielTarief.placeholder.retour": "Return-to-owner rates — coming soon.",
    "asielTarief.search": "Search rules",
    "asielTarief.empty": "No active rules yet.",
    "asielTarief.load.error": "The rules could not be loaded.",
    "asielTarief.action.add": "Add rule",
    "asielTarief.action.ai": "Let AI help",
    "asielTarief.action.test": "Test rate",
    "asielTarief.action.parallelRun": "Parallel run",
    "asielTarief.action.parallelRun.todo": "Reconciliation (Epic 6) — coming soon",
    "asielTarief.recon.title": "Parallel run — legacy versus tariff engine",
    "asielTarief.recon.summary": "%s comparisons — %s equal, %s differing",
    "asielTarief.recon.summary.aligned": "✓ Legacy and engine are fully aligned; legacy can be hidden.",
    "asielTarief.recon.summary.diff": "— resolve the differences before hiding legacy.",
    "asielTarief.recon.col.vestiging": "Branch",
    "asielTarief.recon.col.diersoort": "Species",
    "asielTarief.recon.col.proces": "Process",
    "asielTarief.recon.col.legacy": "Legacy",
    "asielTarief.recon.col.motorStatus": "Engine status",
    "asielTarief.recon.col.motor": "Engine",
    "asielTarief.recon.col.status": "Status",
    "asielTarief.recon.col.opmerking": "Note",
    "asielTarief.recon.gelijk": "equal",
    "asielTarief.recon.afwijkend": "differing",
    "asielTarief.recon.empty": "No legacy price categories to compare.",
    "asielTarief.recon.error": "The reconciliation report could not be loaded.",
    "asielTarief.action.refresh": "Refresh",
    "asielTarief.action.deactivate": "Deactivate",
    "asielTarief.deactivate.confirm": "Deactivate rule \"%s\"?",
    "asielTarief.col.naam": "Name",
    "asielTarief.col.condities": "Conditions",
    "asielTarief.col.resultaat": "Result",
    "asielTarief.col.prioriteit": "Priority",
    "asielTarief.col.acties": "Actions",
    "asielTarief.result.none": "—",
    "asielTarief.result.useLabel": "(use free label)",
    "asielTarief.condition.any": "Any (matches everything)",
    "asielTarief.notice.conflict": "Saving failed: the rule was changed in the meantime.",
    "asielTarief.notice.forbidden": "You are not authorised to edit rates.",
    "asielTarief.notice.error": "Something went wrong. Please try again.",
    "asielTarief.dialog.new.title": "New rate rule",
    "asielTarief.dialog.edit.title": "Edit rate rule",
    "asielTarief.dialog.warnings.title": "Possible conflicts (the rule was saved):",
    "asielTarief.dialog.warnings.continue": "Understood, continue",
    "asielTarief.section.voorwaarden": "Conditions",
    "asielTarief.section.resultaat": "Result",
    "asielTarief.section.berekening": "Calculation",
    "asielTarief.field.naam": "Name",
    "asielTarief.field.naam.required": "Name is required.",
    "asielTarief.field.conditieOperator": "Combine conditions with",
    "asielTarief.operator.and": "AND (all must match)",
    "asielTarief.operator.or": "OR (any may match)",
    "asielTarief.cond.attribuut": "Attribute",
    "asielTarief.cond.operator": "Operator",
    "asielTarief.cond.waarde": "Value",
    "asielTarief.cond.add": "Add condition",
    "asielTarief.cond.remove": "Remove condition",
    "asielTarief.field.resultaatProduct": "Result product",
    "asielTarief.field.resultaatLabel": "Free result label",
    "asielTarief.field.priceMode": "Price mode",
    "asielTarief.field.calculationMethod": "Calculation method",
    "asielTarief.field.eigenBedrag": "Own amount (€)",
    "asielTarief.field.dagBedrag": "Day amount (€)",
    "asielTarief.field.bedragPerKm": "Amount per km (€)",
    "asielTarief.field.minDagen": "Minimum days",
    "asielTarief.field.dagTelling": "Day counting",
    "asielTarief.field.factureerPer": "Bill per",
    "asielTarief.field.afronding": "Rounding",
    "asielTarief.field.btwCode": "VAT code",
    "asielTarief.field.prioriteit": "Priority",
    "asielTarief.field.alleMatches": "Apply all matching rules",
    "asielTarief.option.none": "(none)",
    "asielTarief.attr.DIERSOORT": "Species",
    "asielTarief.attr.DIERSOORT_GROEP": "Species group",
    "asielTarief.attr.GESLACHT": "Sex",
    "asielTarief.attr.VERTREK_TYPE": "Process",
    "asielTarief.attr.LEEFTIJD": "Age (months)",
    "asielTarief.attr.GEWICHT": "Weight (kg)",
    "asielTarief.attr.GECASTREERD": "Neutered",
    "asielTarief.attr.CHIP": "Chipped",
    "asielTarief.op.EQUALS": "equals",
    "asielTarief.op.IN": "in",
    "asielTarief.op.LT": "less than",
    "asielTarief.op.GT": "greater than",
    "asielTarief.op.BETWEEN": "between",
    "asielTarief.calc.FIXED_AMOUNT": "Fixed amount",
    "asielTarief.calc.PER_DAY": "Per day",
    "asielTarief.calc.BASE_PLUS_DISTANCE": "Base + distance",
    "asielTarief.calc.SURCHARGE": "Surcharge",
    "asielTarief.calc.NONE": "None",
    "asielTarief.priceMode.FIXED": "Fixed",
    "asielTarief.priceMode.FROM_AMOUNT": "From amount",
    "asielTarief.priceMode.FREE": "Free",
    "asielTarief.priceMode.MANUAL_QUOTE": "Manual quote",
    "asielTarief.priceMode.IN_CONSULTATION": "In consultation",
    "asielTarief.dayCount.INCLUSIVE_BOTH": "Both days inclusive",
    "asielTarief.dayCount.INCLUSIVE_FIRST": "First day inclusive",
    "asielTarief.dayCount.PER_NIGHT": "Per night",
    "asielTarief.billPer.DAY": "Day",
    "asielTarief.billPer.NIGHT": "Night",
    "asielTarief.rounding.GEEN": "None",
    "asielTarief.rounding.CENTEN_HALF_UP": "Cents (half up)",
    "asielTarief.status.MATCHED": "Matched",
    "asielTarief.status.NO_MATCH": "No match",
    "asielTarief.status.CONFLICT": "Conflict",
    "asielTarief.status.MANUAL_QUOTE": "Manual quote",
    "asielTarief.test.title": "Test rate (dry run)",
    "asielTarief.test.run": "Run test",
    "asielTarief.test.diersoort": "Species",
    "asielTarief.test.proces": "Process",
    "asielTarief.test.leeftijd": "Age (months)",
    "asielTarief.test.gewicht": "Weight (kg)",
    "asielTarief.test.geslacht": "Sex",
    "asielTarief.test.datum": "Reference date",
    "asielTarief.test.kilometers": "Distance (km)",
    "asielTarief.test.dagen": "Number of days",
    "asielTarief.test.gecastreerd": "Neutered",
    "asielTarief.test.gechipt": "Chipped",
    "asielTarief.test.kandidaten": "Candidate rules",
    "asielTarief.test.noKandidaten": "No candidate rules.",
    "asielTarief.test.col.regel": "Rule",
    "asielTarief.test.col.bereik": "Range",
    "asielTarief.test.col.specificiteit": "Specificity",
    "asielTarief.test.col.vestiging": "Branch-specific",
    "asielTarief.test.col.gekozen": "Chosen",
    "asielTarief.test.col.reden": "Reason",
    "asielTarief.ai.title": "Describe a rule with AI",
    "asielTarief.ai.prompt": "Describe the rule in plain language",
    "asielTarief.ai.generate": "Generate",
    "asielTarief.ai.adopt": "Adopt",
    // ── Overige diersoorten (DiersoortTariefknoop tree) ──
    "asielTarief.overige.empty": "No species nodes yet.",
    "asielTarief.overige.load.error": "The species tree could not be loaded.",
    "asielTarief.overige.add": "Add node",
    "asielTarief.overige.col.naam": "Name",
    "asielTarief.overige.col.plaatsing": "Placement",
    "asielTarief.overige.col.afstand": "Surrender",
    "asielTarief.overige.col.adoptie": "Adoption",
    "asielTarief.overige.col.acties": "Actions",
    "asielTarief.overige.inherited": "(inherited)",
    "asielTarief.overige.none": "—",
    "asielTarief.overige.delete.confirm": "Delete node \"%s\"?",
    "asielTarief.overige.dialog.new.title": "New species node",
    "asielTarief.overige.dialog.edit.title": "Edit species node",
    "asielTarief.overige.field.naam": "Name",
    "asielTarief.overige.field.naam.required": "Name is required.",
    "asielTarief.overige.field.parent": "Parent node",
    "asielTarief.overige.field.parent.none": "(top level)",
    "asielTarief.overige.field.diersoortId": "Species id (optional)",
    "asielTarief.overige.field.bedragPlaatsing": "Placement amount (€)",
    "asielTarief.overige.field.bedragAfstand": "Surrender amount (€)",
    "asielTarief.overige.field.bedragAdoptie": "Adoption amount (€)",
    "asielTarief.overige.field.ervenVanParent": "Inherit empty amounts from parent",
    "asielTarief.overige.field.positie": "Position",
    "asielTarief.overige.legacyGrid.note":
      "The legacy price-category grid (AsielPrijsCategorie) is reconciliation scope (Epic 6) and is not shown here.",
    // ── Retour Eigenaar (return-to-owner daily rates) ──
    "asielTarief.retour.empty": "No return-to-owner rates yet.",
    "asielTarief.retour.load.error": "The return-to-owner rates could not be loaded.",
    "asielTarief.retour.add": "Add rate",
    "asielTarief.retour.col.diersoort": "Species",
    "asielTarief.retour.col.dagprijs": "Daily rate",
    "asielTarief.retour.col.geldigVanaf": "Valid from",
    "asielTarief.retour.col.acties": "Actions",
    "asielTarief.retour.badge.nieuw": "New",
    "asielTarief.retour.none": "—",
    "asielTarief.retour.deactivate": "Deactivate",
    "asielTarief.retour.deactivate.confirm": "Deactivate the rate for \"%s\"?",
    "asielTarief.retour.dialog.title": "Add return-to-owner rates",
    "asielTarief.retour.field.diersoorten": "Species",
    "asielTarief.retour.field.diersoorten.required": "Select at least one species.",
    "asielTarief.retour.field.dagprijs": "Daily rate (€)",
    "asielTarief.retour.field.dagprijs.required": "A daily rate is required.",
    "asielTarief.retour.field.effectdatum": "Valid from",
    "asielTarief.retour.create": "Create",
    "asielTarief.retour.report.created": "%s rate(s) created.",
    "asielTarief.retour.report.skipped": "Skipped (already active): %s",
    "asielTarief.retour.notice.forbiddenPast":
      "A past valid-from date requires tariff-admin rights.",
    "asielTarief.retour.notice.forbidden": "You are not authorised to edit rates.",
    "asielTarief.retour.notice.error": "Something went wrong. Please try again.",
    "pensionTarief.dagprijs.accommodatie": "Accommodation",
    "pensionTarief.dagprijs.standaard": "Standard day rate",
    "pensionTarief.dagprijs.standaardWisselt": "changes within this period",
    "pensionTarief.dagprijs.geenStandaard": "not set yet",
    "pensionTarief.dagprijs.geenTypes": "This branch has no accommodation types yet.",
    "pensionTarief.dagprijs.vorige": "Previous 3 months",
    "pensionTarief.dagprijs.vandaag": "Today",
    "pensionTarief.dagprijs.volgende": "Next 3 months",
    "pensionTarief.dagprijs.legenda": "Legend",
    "pensionTarief.dagprijs.afwijkend": "Different rate",
    "pensionTarief.dagprijs.weekdagen": "Mo,Tu,We,Th,Fr,Sa,Su",
    "pensionTarief.dagprijs.venstertitel": "Day rate",
    "pensionTarief.dagprijs.luxe": "Luxury",
    "pensionTarief.dagprijs.diersoort": "Species",
    "pensionTarief.dagprijs.maxDieren": "Max. animals",
    "pensionTarief.dagprijs.dagAanpassen": "Adjust day rate",
    "pensionTarief.dagprijs.dagprijs": "Day rate",
    "pensionTarief.dagprijs.opslaan": "Save",
    "pensionTarief.dagprijs.gebruikStandaard": "Use standard",
    "pensionTarief.dagprijs.periode": "Set a period rate",
    "pensionTarief.dagprijs.van": "From",
    "pensionTarief.dagprijs.tot": "Up to and including",
    "pensionTarief.dagprijs.toepassen": "Apply",
    "pensionTarief.dagprijs.periodeHint": "Leave the amount empty to put these days back on the standard rate.",
    "pensionTarief.dagprijs.opslaanFout": "The day rate could not be saved.",
    "pensionTarief.seizoen.laag": "Low season",
    "pensionTarief.seizoen.hoog": "High season",
    "pensionTarief.seizoen.perDag": "per day",
    "pensionTarief.section.huidigVanaf": "Current active rate (from %s)",
    "pensionTarief.geenSeizoensprijs": "no season rate",
    "pensionTarief.verwijder.knop": "Delete",
    "pensionTarief.verwijder.bevestig": "Delete rate type \"%s\"?",
    "pensionTarief.verwijder.fout": "This rate type could not be deleted.",
    "pensionTarief.col.rassen": "Breeds",
    "pensionTarief.col.rassen.aantal": "%s breeds",
    "pensionTarief.rassen.sectie": "Linked breeds",
    "pensionTarief.rassen.uitleg": "Manage which breeds belong to this rate type.",
    "pensionTarief.rassen.beheren": "Manage breeds",
    "pensionTarief.rassen.titel": "Breeds for %s",
    "pensionTarief.rassen.zoek": "Search breed",
    "pensionTarief.rassen.gekozen": "%s selected",
    "pensionTarief.rassen.geen": "There are no breeds for this species yet.",
    "pensionTarief.rassen.elders": "currently belongs to %s",
    "pensionTarief.rassen.fout": "The breeds could not be saved.",
    "pensionTarief.prijsmodel.slotDicht": "Locked",
    "pensionTarief.prijsmodel.slotOpen": "Unlocked",
    "pensionTarief.prijsmodel.slotVraag": "The price model decides which rates a reservation charges. Existing reservations stay as they are; everything after this changes. Unlock the choice?",
    "pensionTarief.hist.grootboek": "Ledger account",
    "pensionTarief.hist.kostenplaats": "Cost centre",
    "pensionTarief.hist.projectcode": "Project code",
    "pensionTarief.financieel.geen": "— none —",
    "pensionTarief.accommodatie.nieuw.knop": "Add accommodation type",
    "pensionTarief.accommodatie.nieuw.titel": "New accommodation type",
    "pensionTarief.accommodatie.nieuw.naam": "Name",
    "pensionTarief.accommodatie.nieuw.diersoort": "Species",
    "pensionTarief.accommodatie.nieuw.kiesSoort": "— choose a species —",
    "pensionTarief.accommodatie.nieuw.omschrijving": "Description",
    "pensionTarief.accommodatie.nieuw.luxe": "Luxury unit",
    "pensionTarief.accommodatie.nieuw.quarantaine": "Quarantine unit",
    "pensionTarief.accommodatie.nieuw.hint": "The type appears in the stay planning straight away. The units themselves, and the icon and colour, are set there.",
    "pensionTarief.accommodatie.nieuw.verplicht": "Enter a name and choose a species.",
    "pensionTarief.accommodatie.nieuw.bestaat": "An accommodation type with this name already exists.",
    "pensionTarief.accommodatie.nieuw.fout": "The accommodation type could not be created.",
    "pensionTarief.dagprijs.ai.titel": "Let AI help you",
    "pensionTarief.dagprijs.ai.beschrijf": "Describe which days should cost something else",
    "pensionTarief.dagprijs.ai.voorbeeld": "For example: make 24-12 through 02-01 15% more expensive",
    "pensionTarief.dagprijs.ai.vraag": "Make a proposal",
    "pensionTarief.dagprijs.ai.toepassen": "Apply",
    "pensionTarief.dagprijs.ai.onvolledig": "Add to the sentence and make a new proposal.",
    "pensionTarief.dagprijs.ai.fout": "The proposal could not be made.",
    "pensionTarief.actief.uit": "Take out of use",
    "pensionTarief.actief.aan": "Put back in use",
    "pensionTarief.actief.bevestig": "Take \"%s\" out of use? The rate disappears from the pick lists; the price history stays.",
    "pensionTarief.actief.fout": "This rate could not be changed.",
    "pensionTarief.col.status": "Status",
    "pensionTarief.status.actief": "In use",
    "pensionTarief.status.inactief": "Out of use",
    "pensionTarief.volgorde.kolom": "Order",
    "pensionTarief.volgorde.sleep": "Drag to change the order",
    "pensionTarief.volgorde.omhoog": "Move %s up",
    "pensionTarief.volgorde.omlaag": "Move %s down",
    "pensionTarief.volgorde.fout": "The order could not be saved.",
    "dierTegel.entingen.verlopen": "%s expired",
    "dierTegel.entingen.geldigTot": "valid until %s",
    "dierTegel.entingen.eersteAfloop": "first expires on %s",
    "dierTegel.behandeling.volgende": "next: %s",
    "dierTegel.medicatie.aantal": "%s medicines",
    "dierTegel.medicatie.meer": "and %s other medicine",
    "dierTegel.nogNiets": "nothing recorded yet",
    "dierTegel.gewicht.kg": "%s kg",
    "dierTegel.gewicht.nieuw": "New weighing",
    "dierTegel.gewicht.label": "Weight (kg)",
    "dierTegel.gewicht.datum": "Date",
    "dierTegel.gewicht.opmerking": "Note",
    "dierTegel.gewicht.vandaag": "The weighing is recorded for today.",
    "dierTegel.gewicht.wordt": "After saving the tile will show %s kg.",
    "dierTegel.gewicht.ongeldig": "Enter a weight greater than zero.",
    "dierTegel.gewicht.fout": "The weighing could not be saved.",
    "dierTegel.voeding.wijzigen": "Edit feeding schedule",
    "dierTegel.voeding.merk": "Brand",
    "dierTegel.voeding.soort": "Feed type",
    "dierTegel.voeding.hoeveelheid": "Amount",
    "dierTegel.voeding.tijden": "Feeding times",
    "dierTegel.voeding.notitie": "Note",
    "dierTegel.voeding.geenSchema": "no feeding schedule recorded",
    "dierTegel.voeding.hint": "The schedule is the instruction for everyone who feeds this animal. Recording a single feeding is done on the feeding list.",
    "dierTegel.voeding.fout": "The feeding schedule could not be saved.",
    "dierTegel.voeding.conflict": "Someone else changed this schedule. Close and reopen to see the current version.",
    "dierTegel.chip.paspoort": "passport %s",
    "dierTegel.chip.wijzigen": "Edit chip and passport",
    "dierTegel.chip.nummer": "Chip number",
    "dierTegel.chip.paspoortnummer": "Passport number",
    "dierTegel.chip.vijftien": "A chip number is exactly 15 digits, or leave it empty.",
    "dierTegel.chip.nogCijfers": "%s digits to go.",
    "dierTegel.chip.ongeldig": "A chip number is exactly 15 digits, or empty.",
    "dierTegel.chip.dubbel": "This chip number already belongs to %s. One chip, one animal.",
    "dierTegel.chip.anderDier": "another animal",
    "dierTegel.chip.controleMislukt": "The duplicate check could not run, so nothing was saved. Try again.",
    "dierTegel.chip.conflict": "Someone else changed this animal. Close and reopen to see the current version.",
    "dierTegel.chip.fout": "The chip and passport number could not be saved.",
    "dierTegel.gedrag.uitLogboek": "from the behaviour log",
    "dierTegel.verzorging.borstelen": "brushing %s",
    "dierTegel.verzorging.wassen": "washing %s",
    "dierTegel.dagprijs.perDag": "%s per day",
    "dierTegel.dagprijs.hoogseizoen": "%s in high season",
    "dierTegel.allergie.titel": "Allergies",
    "dierTegel.allergie.nogGeen": "No allergies recorded yet.",
    "dierTegel.allergie.toevoegen": "Add allergy",
    "dierTegel.allergie.stof": "Allergic to",
    "dierTegel.allergie.reactie": "Reaction",
    "dierTegel.allergie.ernst": "Severity",
    "dierTegel.allergie.vastgesteldOp": "Known since",
    "dierTegel.allergie.stofVerplicht": "Fill in what the animal is allergic to.",
    "dierTegel.allergie.zekerWeten": "Really delete?",
    "dierTegel.allergie.hint": "Only the substance is required. The reaction tells carers what to watch for if it happens anyway.",
    "dierTegel.allergie.fout": "That could not be saved.",
    "dierTegel.ring.openen": "Open the full animal overview",
    "dierTegel.ring.nietGewogen": "not weighed",
    "dierTegel.ring.status.inOrde": "in order",
    "dierTegel.ring.status.aandacht": "needs attention",
    "dierTegel.ring.status.verlopen": "expired",
    "dierTegel.ring.status.onbekend": "unknown",
    "dierTegel.ring.samenvatting.inOrde": "Health: everything in order",
    "dierTegel.ring.samenvatting.aandacht": "Health: something needs attention",
    "dierTegel.ring.samenvatting.verlopen": "Health: something has expired",
    "dierTegel.ring.samenvatting.onbekend": "Health: nothing recorded",
    "dierTegel.ontwerp.gezondheidsring": "Health ring",
    "dierTegel.ontwerp.zorgmeter": "Daily care meter",
    "dierTegel.ontwerp.inEenOogopslag": "At a glance",
    "dierTegel.ontwerp.voedingEnGewicht": "Feeding and weight",
    "dierTegel.ontwerp.medischeVeiligheid": "Medical safety",
    "dierTegel.ontwerp.gedragEnSociaal": "Behaviour and social",
    "dierTegel.ontwerp.verzorgingsprofiel": "Grooming profile",
    "dierTegel.ontwerp.tariefPerDier": "Rate per animal",
    "dierTegel.ontwerp.identiteitEnGezondheid": "Identity and health",
    "dierTegel.ontwerp.aandachtsmeter": "Attention meter",
    "dierTegel.ontwerp.dierkompas": "Animal compass",
    "dierTegel.bouwer.maken": "Create tile",
    "dierTegel.bouwer.instellen": "Configure %s",
    "dierTegel.bouwer.beschikbaar": "Choose components",
    "dierTegel.bouwer.beschikbaarUitleg": "Pick from the available components and add them to your tile.",
    "dierTegel.bouwer.zoek": "Search a component...",
    "dierTegel.bouwer.groep": "Category",
    "dierTegel.bouwer.nietsGevonden": "No component matches that.",
    "dierTegel.bouwer.opbouw": "Set the layout",
    "dierTegel.bouwer.opbouwUitleg": "Set the name and the order of the components.",
    "dierTegel.bouwer.sleep": "Drag to change the order",
    "dierTegel.bouwer.vanMax": "%s of %s",
    "dierTegel.bouwer.verplaats": "Move %s; use the arrow keys",
    "dierTegel.bouwer.weghalen": "Remove %s",
    "dierTegel.bouwer.snelleActieSoort": "Quick action: %s",
    "dierTegel.bouwer.sleepHierheen": "Drag here or add on the left",
    "dierTegel.bouwer.voorbeeldUitleg": "This is how the tile looks on your dashboard.",
    "dierTegel.bouwer.naastElkaar": "Tiles side by side",
    "dierTegel.bouwer.eenTegel": "1 tile",
    "dierTegel.bouwer.aantalTegels": "%s tiles",
    "dierTegel.bouwer.stijl": "Visual style",
    "dierTegel.bouwer.schaaltMee": "The content scales automatically.",
    "dierTegel.bouwer.automatischUitleg": "The tile adapts to the space available.",
    "dierTegel.bouwer.snelleActiesUitleg": "Show actions such as quick edit or record.",
    "dierTegel.bouwer.toevoegen": "Add tile",
    "dierTegel.bouwer.fotoInMidden": "Show photo",
    "dierTegel.bouwer.fotoInMiddenUitleg": "Put the animal’s photo in the middle of the tile.",
    "dierTegel.stijl.rond": "Round",
    "dierTegel.stijl.raster": "Grid",
    "dierTegel.stijl.lijst": "List",
    "dierTegel.bouwer.titel": "Create a composed tile",
    "dierTegel.bouwer.uitleg": "Choose which information you want to see together on one tile.",
    "dierTegel.bouwer.naam": "Tile name",
    "dierTegel.bouwer.stijlUitleg": "Choose how the information is shown on the tile.",
    "dierTegel.bouwer.schalen": "Scale automatically",
    "dierTegel.bouwer.schalenUitleg": "The tile adapts to the number of tiles on the dashboard.",
    "dierTegel.bouwer.maat.compact": "Compact",
    "dierTegel.bouwer.maat.compactUitleg": "Small tile, fewer details",
    "dierTegel.bouwer.maat.normaal": "Normal",
    "dierTegel.bouwer.maat.normaalUitleg": "Standard size, balanced information",
    "dierTegel.bouwer.maat.uitgebreid": "Extended",
    "dierTegel.bouwer.maat.uitgebreidUitleg": "Extra room for more details",
    "dierTegel.bouwer.instellingen": "Settings",
    "dierTegel.bouwer.instellingenUitleg": "Decide which extra information to show.",
    "dierTegel.bouwer.toonHerkomst": "Show date and time",
    "dierTegel.bouwer.toonHerkomstUitleg": "Show for each component when it was last recorded.",
    "dierTegel.bouwer.naamUitleg": "Give this composed tile a name.",
    "dierTegel.bouwer.vorm": "Shape",
    "dierTegel.bouwer.onderdelen": "Components (%s of %s)",
    "dierTegel.bouwer.grens": "A tile holds at most %s components; that keeps it readable.",
    "dierTegel.bouwer.reden.vol": "tile is full",
    "dierTegel.bouwer.reden.nietVanToepassing": "not in use here",
    "dierTegel.bouwer.volgorde": "Order",
    "dierTegel.bouwer.omhoog": "Move %s up",
    "dierTegel.bouwer.omlaag": "Move %s down",
    "dierTegel.bouwer.automatisch": "Scale automatically",
    "dierTegel.bouwer.vasteMaat": "Fixed size",
    "dierTegel.bouwer.dichtheid.compact": "Compact",
    "dierTegel.bouwer.dichtheid.normaal": "Normal",
    "dierTegel.bouwer.dichtheid.uitgebreid": "Extended",
    "dierTegel.bouwer.snelleActies": "Show quick actions",
    "dierTegel.bouwer.actiesHint": "Without write permission the button disappears anyway; this switch cannot bring one back.",
    "dierTegel.bouwer.voorbeeld": "Preview",
    "dierTegel.bouwer.voorbeeldHint": "Example values. The tile applies to every animal, so it shows no real data.",
    "dierTegel.bouwer.waarde": "example",
    "dierTegel.bouwer.nogNiets": "Choose a component to see the tile.",
    "dierTegel.bouwer.verwijderen": "Delete tile",
    "dierTegel.vorm.ring": "Ring",
    "dierTegel.vorm.halvemeter": "Half meter",
    "dierTegel.vorm.satellieten": "Satellites",
    "dierTegel.vorm.gesplitst": "Split",
    "dierTegel.vorm.statuslijst": "Status list",
    "dierTegel.vorm.radiaal": "Radial",
    "dierTegel.vorm.prijskaart": "Price card",
    "dierTegel.vorm.tweekolommen": "Two columns",
    "dierTegel.vorm.boogmeter": "Arc meter",
    "dierTegel.vorm.waardenboog": "Value arc",
    "dierTegel.ontwerp.inEenBoog": "In an arc",
    "dierTegel.vorm.kwadranten": "Quadrants",
    "dierTegel.meter.aandacht": "%s need attention",
    "dierTegel.meter.inOrde": "All in order",
    "dierTegel.meter.nietsBekend": "Nothing recorded yet",
    "dierTegel.meter.onbekend": "%s unknown",
    "dierTegel.uitleg.gewicht": "Latest measurement and trend",
    "dierTegel.uitleg.voeding": "Schedule, feed and amount",
    "dierTegel.uitleg.medicatie": "Active medicine and administration",
    "dierTegel.uitleg.vaccinaties": "Status and validity",
    "dierTegel.uitleg.ontworming": "Last and next treatment",
    "dierTegel.uitleg.ontvlooiing": "Last and next treatment",
    "dierTegel.uitleg.allergieen": "Active warnings",
    "dierTegel.uitleg.gedrag": "Traits and handling",
    "dierTegel.uitleg.verzorging": "Needs and execution",
    "dierTegel.uitleg.chipPaspoort": "Chip number and passport",
    "dierTegel.uitleg.dierenarts": "Practice and contact",
    "dierTegel.uitleg.dagprijs": "Chosen rate and day price",
    "dierTegel.groep.alles": "All",
    "dierTegel.groep.dagelijks": "Daily care",
    "dierTegel.groep.medisch": "Medical",
    "dierTegel.groep.identiteit": "Identity",
    "dierTegel.component.gewicht": "Weight",
    "dierTegel.component.voeding": "Feeding",
    "dierTegel.component.medicatie": "Medication",
    "dierTegel.component.vaccinaties": "Vaccinations",
    "dierTegel.component.ontworming": "Deworming",
    "dierTegel.component.ontvlooiing": "Flea treatment",
    "dierTegel.component.allergieen": "Allergies",
    "dierTegel.component.gedrag": "Behaviour",
    "dierTegel.component.verzorging": "Grooming",
    "dierTegel.component.chipPaspoort": "Chip and passport",
    "dierTegel.component.dierenarts": "Vet",
    "dierTegel.component.diersoort": "Species",
    "dierTegel.component.ras": "Breed",
    "dierTegel.component.geslacht": "Sex",
    "dierTegel.component.leeftijd": "Age",
    "dierTegel.component.kenmerken": "Characteristics",
    "dierTegel.component.bijzonderheden": "Particulars",
    "dierTegel.uitleg.diersoort": "Dog, cat, rabbit",
    "dierTegel.uitleg.ras": "Breed of the animal",
    "dierTegel.uitleg.geslacht": "Sex and neutered or not",
    "dierTegel.uitleg.leeftijd": "Age and date of birth",
    "dierTegel.uitleg.kenmerken": "Colour, markings and other traits",
    "dierTegel.uitleg.bijzonderheden": "Free text on the animal",
    "dierTegel.leeftijd.geboren": "born %s",
    "dierTegel.bouwer.breedte.heel": "Full row",
    "dierTegel.bouwer.breedte.half": "Half row",
    "dierTegel.bouwer.breedte.kwart": "Quarter",
    "dierTegel.bouwer.breedteHint": "This is how wide the tile appears on the animal screen.",
    "dierTegel.component.dagprijs": "Day rate per animal",
    "dierTegel.status.inOrde": "In order",
    "dierTegel.status.aandacht": "Attention",
    "dierTegel.status.verlopen": "Expired",
    "dierTegel.actie.registratie": "New registration",
    "dierTegel.actie.wijziging": "Edit",
    "pensionTarief.subtitel": "Manage the rates per animal and breed for boarding and day care here.",
    "pensionTarief.tab.prijsberekening": "Price calculation",
    "pensionTarief.prijsmodel.titel": "Price model",
    "pensionTarief.prijsmodel.dier.naam": "Rate per animal",
    "pensionTarief.prijsmodel.dier.uitleg": "The animal sets the day rate. Suitable for small dog, large dog, cat, etc.",
    "pensionTarief.prijsmodel.accommodatie.naam": "Rate per accommodation",
    "pensionTarief.prijsmodel.accommodatie.uitleg": "The accommodation has a day rate per calendar day. You can set a different price per day or period.",
    "pensionTarief.prijsmodel.opslaanFout": "The price model could not be saved.",
    "pensionTarief.prijsmodel.alleenLezen": "Only a boarding manager can change the price model.",
    "pensionTarief.soort.label": "Rate kind",
    "pensionTarief.soort.pension": "Boarding",
    "pensionTarief.soort.dagopvang": "Day care",
    "pensionTarief.tabs.label": "Boarding rates tabs",
    "pensionTarief.tab.tarieven": "Rates",
    "pensionTarief.tab.hoogseizoen": "High season",
    "pensionTarief.tab.kortingen": "Discounts",
    "pensionTarief.tab.aanbetaling": "Deposit",
    "pensionTarief.tab.verzekering": "Booking products",
    "pensionTarief.tab.accommodaties": "Accommodations",
    "pensionTarief.accommodatie.uitleg.ACCOMMODATIE": "This location charges day prices per accommodation: the price below is the day price of the stay.",
    "pensionTarief.accommodatie.uitleg.PENSIONPRIJZEN": "This location charges the boarding prices: the price below is a surcharge per day on top of the animal's rate. Empty means no surcharge.",
    "pensionTarief.accommodatie.beheer": "Accommodation types are created in the kennel planning; day price or surcharge is chosen under Settings › Boarding › Price calculation.",
    "pensionTarief.accommodatie.col.diersoort": "Species",
    "pensionTarief.accommodatie.col.naam": "Accommodation",
    "pensionTarief.accommodatie.col.laag.ACCOMMODATIE": "Day rate",
    "pensionTarief.accommodatie.col.laag.PENSIONPRIJZEN": "Surcharge low season",
    "pensionTarief.accommodatie.col.hoog.ACCOMMODATIE": "Day price high season",
    "pensionTarief.accommodatie.col.hoog.PENSIONPRIJZEN": "Surcharge high season",
    "pensionTarief.accommodatie.col.geldigVanaf": "Valid from",
    "pensionTarief.accommodatie.col.acties": "Actions",
    "pensionTarief.accommodatie.luxe": "Luxury",
    "pensionTarief.accommodatie.quarantaine": "Quarantine",
    "pensionTarief.accommodatie.geenPrijs": "No price",
    "pensionTarief.accommodatie.leeg": "No accommodation types yet. Create them in the kennel planning.",
    "pensionTarief.accommodatie.laden": "The accommodations could not be loaded.",
    "pensionTarief.accommodatie.wijzig": "Change price",
    "pensionTarief.accommodatie.wijzigVan": "Change price of %s",
    "pensionTarief.accommodatie.dialoog.titel": "Price of %s",
    "pensionTarief.accommodatie.section.huidig": "Current price",
    "pensionTarief.accommodatie.section.wijziging": "Price change",
    "pensionTarief.accommodatie.section.historie": "Rate history",
    "pensionTarief.accommodatie.hint": "Add a price with a start date. Several lines are scheduled one after another.",
    "pensionTarief.accommodatie.editRow": "Edit the price line of %s",
    "pensionTarief.accommodatie.regel.nieuw": "New price line",
    "pensionTarief.accommodatie.regel.wijzig": "Edit price line",
    "pensionTarief.accommodatie.regel.uitleg": "The line is added to the list; nothing is saved until you choose Save price.",
    "pensionTarief.accommodatie.regel.voegToe": "Add",
    "pensionTarief.accommodatie.regel.bijwerken": "Update",
    "pensionTarief.accommodatie.regel.onvolledig": "Fill in a start date and an amount.",
    "pensionTarief.accommodatie.add": "Add price line",
    "pensionTarief.accommodatie.remove": "Remove price line",
    "pensionTarief.accommodatie.submit": "Save price",
    "pensionTarief.accommodatie.field.effectdatum": "Start date",
    "pensionTarief.accommodatie.field.reden": "Reason",
    "pensionTarief.accommodatie.opgeslagen": "Price saved",
    "pensionTarief.accommodatie.fout.error": "Saving failed. Check amount, date and VAT.",
    "pensionTarief.accommodatie.fout.forbidden": "You are not allowed to change rates.",
    "pensionTarief.accommodatie.fout.forbiddenPast": "A start date in the past needs rate administrator rights.",
    "pensionTarief.aanbetaling.title": "Deposit on a booking",
    "pensionTarief.aanbetaling.intro": "The percentage applies to the stay only, without washing and other extras. The days count from the confirmation of the booking. 0% means: no deposit.",
    "pensionTarief.aanbetaling.scope": "For branch %s.",
    "pensionTarief.aanbetaling.field.percentage": "Percentage of the stay",
    "pensionTarief.aanbetaling.field.herinnering": "Reminder after (days)",
    "pensionTarief.aanbetaling.field.annuleren": "Expires after (days)",
    "pensionTarief.aanbetaling.save": "Save",
    "pensionTarief.aanbetaling.saved": "Saved.",
    "pensionTarief.aanbetaling.load.error": "The deposit settings could not be loaded.",
    "pensionTarief.none": "—",
    "pensionTarief.action.add": "Add rate",
    "pensionTarief.action.delete": "Delete",
    "pensionTarief.action.refresh": "Refresh",
    "pensionTarief.search": "Search rates",
    "pensionTarief.peildatum": "Valid on",
    "pensionTarief.sort.label": "Sort by",
    "pensionTarief.sort.dir": "Direction",
    "pensionTarief.sort.asc": "Ascending",
    "pensionTarief.sort.desc": "Descending",
    "pensionTarief.empty": "No rates yet.",
    "pensionTarief.load.error": "The rates could not be loaded.",
    "pensionTarief.badge.nieuw": "New",
    "pensionTarief.col.verblijftype": "Stay type",
    "pensionTarief.col.diersoort": "Species",
    "pensionTarief.col.dagprijs": "Low season",
    "pensionTarief.col.dagprijsHoog": "High season",
    "pensionTarief.col.geldigVanaf": "Valid from",
    "pensionTarief.col.laatstGewijzigd": "Last changed",
    "pensionTarief.col.acties": "Actions",
    "pensionTarief.dagprijsHoog.missing": "no season price",
    "pensionTarief.delete.confirm": "Delete rate \"%s\"?",
    "pensionTarief.paging.prev": "Previous",
    "pensionTarief.paging.next": "Next",
    "pensionTarief.paging.info": "Page %s of %s",
    "pensionTarief.banner.hoogseizoen": "High season is active on the reference date — the high-season day price applies.",
    "pensionTarief.hoog.label": "High season",
    "pensionTarief.hoog.alle": "All",
    "tariefAi.action": "Let AI help",
    "tariefAi.title": "Let AI help with a rate",
    "tariefAi.intro": "Describe in your own words what you want: a new rate, a price change, or removing a rate.",
    "tariefAi.veld": "Your description",
    "tariefAi.submit": "Make a proposal",
    "tariefAi.apply.NIEUW": "Open as a new rate",
    "tariefAi.apply.WIJZIG": "Open this rate",
    "tariefAi.apply.VERWIJDER": "Delete this rate",
    "tariefAi.notFound": "That rate is no longer in the list.",
    "tariefAi.notHere": "This screen has no form for that.",
    "tariefAi.error": "Could not read that. Try describing it differently.",
    "tariefAi.voorbeeld.pension": "e.g. raise Dog to 18 euro from 1 March",
    "tariefAi.voorbeeld.creche": "e.g. day care cat 9 euro, 14 with overnight stay",
    "tariefAi.voorbeeld.ambulance": "e.g. raise Animal Ambulance Enschede to 42 euro, 0.55 per km",
    "pensionTarief.ai.action": "Let AI help",
    "pensionTarief.ai.title": "Let AI help with a rate",
    "pensionTarief.ai.intro": "Describe in your own words what you want: a new rate, a price change, or removing a rate.",
    "pensionTarief.ai.veld": "Your description",
    "pensionTarief.ai.placeholder": "e.g. raise Dog to 18 euro from 1 March",
    "pensionTarief.ai.submit": "Make a proposal",
    "pensionTarief.ai.apply.NIEUW": "Open as a new rate",
    "pensionTarief.ai.apply.WIJZIG": "Open this rate",
    "pensionTarief.ai.apply.VERWIJDER": "Delete this rate",
    "pensionTarief.ai.notFound": "That rate is no longer in the list.",
    "pensionTarief.ai.error": "Could not read that. Try describing it differently.",
    "pensionTarief.field.diersoort": "Species",
    "pensionTarief.field.diersoort.placeholder": "Choose a species…",
    "pensionTarief.field.diersoort.required": "Choose a species.",
    "pensionTarief.hoog.eigen": "Own high-season price",
    "pensionTarief.hoog.gelijk": "Same as low season",
    "pensionTarief.hoog.geen": "No high-season surcharge",
    "pensionTarief.kpi.actief": "Active rates",
    "pensionTarief.kpi.aankomend": "Upcoming changes (≤30 days)",
    "pensionTarief.kpi.ontbrekend": "Missing season prices",
    "pensionTarief.notice.conflict": "This rate was changed in the meantime. Reload and try again.",
    "pensionTarief.notice.forbidden": "You are not authorised to edit rates.",
    "pensionTarief.notice.forbiddenPast": "A past effective date requires the rate-admin role (ROLE_TARIEF_ADMIN).",
    "pensionTarief.notice.error": "Something went wrong. Please try again.",
    "pensionTarief.field.naam": "Name",
    "pensionTarief.field.naam.required": "A name is required.",
    "pensionTarief.field.diersoortId": "Species id (empty = general)",
    "pensionTarief.field.omschrijving": "Description",
    "pensionTarief.field.dagprijs": "Day price (low)",
    "pensionTarief.field.dagprijs.required": "A day price is required.",
    "pensionTarief.field.dagprijsHoog": "Day price (high)",
    "pensionTarief.field.effectdatum": "Effective date",
    "pensionTarief.field.reden": "Reason",
    "pensionTarief.field.vestiging": "Branch",
    "pensionTarief.vestiging.org": "Whole organisation",
    "pensionTarief.nieuw.title": "New boarding rate",
    "pensionTarief.bewerk.title": "Edit rate — %s",
    "pensionTarief.section.basis": "Basic information",
    "pensionTarief.section.huidig": "Current rate",
    "pensionTarief.section.gepland": "Scheduled rates",
    "pensionTarief.section.historie": "History",
    "pensionTarief.gepland.empty": "Nothing scheduled.",
    "pensionTarief.basis.save": "Save basic information",
    "pensionTarief.basis.saved": "Basic information saved.",
    "pensionTarief.current": "Current",
    "pensionTarief.prijswijziging.hint": "Add one or more future price changes. A single change is applied directly; several are scheduled.",
    "pensionTarief.prijswijziging.add": "Add price change",
    "pensionTarief.prijswijziging.remove": "Remove price change",
    "pensionTarief.prijswijziging.submit": "Save price change",
    "pensionTarief.hist.vanaf": "From",
    "pensionTarief.hist.tot": "Until",
    "pensionTarief.hist.bedrag": "Price (low)",
    "pensionTarief.hist.bedragHoog": "Price (high)",
    "pensionTarief.hist.reden": "Reason",
    "pensionTarief.hist.status": "Status",
    "pensionTarief.hist.status.GEPLAND": "Planned",
    "pensionTarief.hist.status.ACTIEF": "Active",
    "pensionTarief.hist.status.VERVALLEN": "Expired",
    "pensionTarief.hist.empty": "No versions yet.",
    "pensionTarief.hoogseizoen.new.title": "New high-season period",
    "pensionTarief.hoogseizoen.add": "Add period",
    "pensionTarief.hoogseizoen.field.naam": "Name",
    "pensionTarief.hoogseizoen.field.vanaf": "Valid from",
    "pensionTarief.hoogseizoen.field.tm": "Valid until (incl.)",
    "pensionTarief.hoogseizoen.col.naam": "Name",
    "pensionTarief.hoogseizoen.col.vanaf": "From",
    "pensionTarief.hoogseizoen.col.tm": "Until (incl.)",
    "pensionTarief.hoogseizoen.col.scope": "Scope",
    "pensionTarief.hoogseizoen.scope.org": "Whole organisation",
    "pensionTarief.hoogseizoen.empty": "No high-season periods yet.",
    "pensionTarief.hoogseizoen.load.error": "The periods could not be loaded.",
    "pensionTarief.hoogseizoen.delete.confirm": "Delete period \"%s\"?",
    "pensionTarief.korting.add": "Add discount",
    "pensionTarief.korting.ai": "Describe with AI",
    "pensionTarief.korting.empty": "No discount rules yet.",
    "pensionTarief.korting.load.error": "The discount rules could not be loaded.",
    "pensionTarief.korting.delete.confirm": "Deactivate discount \"%s\"?",
    "pensionTarief.korting.col.naam": "Name",
    "pensionTarief.korting.col.type": "Type",
    "pensionTarief.korting.col.waarde": "Value",
    "pensionTarief.korting.col.toepassing": "Applies to",
    "pensionTarief.korting.col.actief": "Active",
    "pensionTarief.korting.actief.yes": "Active",
    "pensionTarief.korting.actief.no": "Inactive",
    "pensionTarief.korting.type.PERCENTAGE": "Percentage",
    "pensionTarief.korting.type.VAST_BEDRAG": "Fixed amount",
    "pensionTarief.korting.toepassing.ALLEEN_EXTRA_DIEREN": "Only extra animals",
    "pensionTarief.korting.toepassing.ALLE_DIEREN": "All animals",
    "pensionTarief.korting.toepassing.LANGSTE_VERBLIJF": "Longest stay",
    "pensionTarief.korting.dialog.new.title": "New discount rule",
    "pensionTarief.korting.dialog.edit.title": "Edit discount rule",
    "pensionTarief.korting.field.naam": "Name",
    "pensionTarief.korting.field.naam.required": "A name is required.",
    "pensionTarief.korting.field.conditie": "Condition (IF / AND)",
    "pensionTarief.korting.field.type": "Discount type (THEN)",
    "pensionTarief.korting.field.waarde": "Value",
    "pensionTarief.korting.field.waarde.required": "A value is required.",
    "pensionTarief.korting.field.toepassing": "Applies to (ON)",
    "pensionTarief.korting.field.geldigVanaf": "Valid from",
    "pensionTarief.korting.field.geldigTm": "Valid until (incl.)",
    "pensionTarief.korting.field.actief": "Active",
    "pensionTarief.korting.ai.title": "Describe a discount with AI",
    "pensionTarief.korting.ai.prompt": "Describe the discount in plain language",
    "pensionTarief.korting.ai.generate": "Generate",
    "pensionTarief.korting.ai.adopt": "Adopt",
    "crecheTarief.tabs.label": "Daycare rates tabs",
    "crecheTarief.tab.losseDagen": "Single days",
    "crecheTarief.tab.rittenkaarten": "Punch cards",
    "crecheTarief.tab.abonnementen": "Subscriptions",
    "crecheTarief.none": "—",
    "crecheTarief.yes": "Yes",
    "crecheTarief.no": "No",
    "crecheTarief.action.add": "Add rate",
    "crecheTarief.action.delete": "Delete",
    "crecheTarief.action.refresh": "Refresh",
    "crecheTarief.search": "Search rates",
    "crecheTarief.peildatum": "Valid on",
    "crecheTarief.sort.label": "Sort by",
    "crecheTarief.sort.dir": "Direction",
    "crecheTarief.sort.asc": "Ascending",
    "crecheTarief.sort.desc": "Descending",
    "crecheTarief.empty": "No rates yet.",
    "crecheTarief.load.error": "The rates could not be loaded.",
    "crecheTarief.badge.nieuw": "New",
    "crecheTarief.col.categorie": "Category",
    "crecheTarief.col.diersoort": "Species",
    "crecheTarief.col.dagprijs": "Day price",
    "crecheTarief.col.dagprijsOvernachting": "Day price incl. overnight",
    "crecheTarief.col.geldigVanaf": "Valid from",
    "crecheTarief.col.acties": "Actions",
    "crecheTarief.dagprijsOvernachting.missing": "no overnight price",
    "crecheTarief.delete.confirm": "Delete rate \"%s\"?",
    "crecheTarief.paging.prev": "Previous",
    "crecheTarief.paging.next": "Next",
    "crecheTarief.paging.info": "Page %s of %s",
    "crecheTarief.notice.conflict": "This rate was changed in the meantime. Reload and try again.",
    "crecheTarief.notice.forbidden": "You are not authorised to edit rates.",
    "crecheTarief.notice.forbiddenPast": "A past effective date requires the rate-admin role (ROLE_TARIEF_ADMIN).",
    "crecheTarief.notice.error": "Something went wrong. Please try again.",
    "crecheTarief.field.categorie": "Category name",
    "crecheTarief.field.categorie.required": "A category name is required.",
    "crecheTarief.field.diersoortId": "Species id (empty = general)",
    "crecheTarief.field.omschrijving": "Description",
    "crecheTarief.field.dagprijs": "Day price",
    "crecheTarief.field.dagprijs.required": "A day price is required.",
    "crecheTarief.field.dagprijsOvernachting": "Day price incl. overnight",
    "crecheTarief.field.effectdatum": "Effective date",
    "crecheTarief.field.geldigVanaf": "Valid from",
    "crecheTarief.field.reden": "Reason",
    "crecheTarief.field.vestiging": "Branch",
    "crecheTarief.vestiging.org": "Whole organisation",
    "crecheTarief.nieuw.title": "New daycare rate",
    "crecheTarief.bewerk.title": "Edit rate — %s",
    "crecheTarief.section.basis": "Basic information",
    "crecheTarief.section.huidig": "Current rate",
    "crecheTarief.section.prijswijziging": "Schedule a price change",
    "crecheTarief.section.overzicht": "Rate history",
    "crecheTarief.basis.save": "Save basic information",
    "crecheTarief.basis.saved": "Basic information saved.",
    "crecheTarief.prijswijziging.hint": "Add one or more future price changes. A single change is applied directly; several are scheduled.",
    "crecheTarief.prijswijziging.add": "Add price change",
    "crecheTarief.prijswijziging.remove": "Remove price change",
    "crecheTarief.prijswijziging.submit": "Save price change",
    "crecheTarief.hist.vanaf": "From",
    "crecheTarief.hist.tot": "Until",
    "crecheTarief.hist.bedrag": "Day price",
    "crecheTarief.hist.bedragHoog": "Incl. overnight",
    "crecheTarief.hist.reden": "Reason",
    "crecheTarief.hist.status": "Status",
    "crecheTarief.hist.status.GEPLAND": "Planned",
    "crecheTarief.hist.status.ACTIEF": "Active",
    "crecheTarief.hist.status.VERVALLEN": "Expired",
    "crecheTarief.hist.empty": "No versions yet.",
    "crecheTarief.rittenkaart.add": "Add punch card",
    "crecheTarief.rittenkaart.empty": "No punch cards yet.",
    "crecheTarief.rittenkaart.load.error": "The punch cards could not be loaded.",
    "crecheTarief.rittenkaart.delete.confirm": "Deactivate punch card \"%s\"?",
    "crecheTarief.rittenkaart.col.naam": "Name",
    "crecheTarief.rittenkaart.col.aantalRitten": "Rides",
    "crecheTarief.rittenkaart.col.prijs": "Price",
    "crecheTarief.rittenkaart.col.geldigheidMaanden": "Validity (months)",
    "crecheTarief.rittenkaart.col.overdraagbaar": "Transferable",
    "crecheTarief.rittenkaart.col.verlengen": "Auto-extend",
    "crecheTarief.rittenkaart.dialog.new.title": "New punch card",
    "crecheTarief.rittenkaart.dialog.edit.title": "Edit punch card",
    "crecheTarief.rittenkaart.field.naam": "Name",
    "crecheTarief.rittenkaart.field.naam.required": "A name is required.",
    "crecheTarief.rittenkaart.field.aantalRitten": "Number of rides",
    "crecheTarief.rittenkaart.field.aantalRitten.required": "The number of rides is required.",
    "crecheTarief.rittenkaart.field.prijs": "Price",
    "crecheTarief.rittenkaart.field.prijs.required": "A price is required.",
    "crecheTarief.rittenkaart.field.geldigheidMaanden": "Validity (months, empty = unlimited)",
    "crecheTarief.rittenkaart.field.overdraagbaar": "Transferable",
    "crecheTarief.rittenkaart.field.verlengen": "Auto-extend on last ride",
    "crecheTarief.abonnement.add": "Add subscription",
    "crecheTarief.abonnement.empty": "No subscriptions yet.",
    "crecheTarief.abonnement.load.error": "The subscriptions could not be loaded.",
    "crecheTarief.abonnement.delete.confirm": "Deactivate subscription \"%s\"?",
    "crecheTarief.abonnement.col.naam": "Name",
    "crecheTarief.abonnement.col.dagenPerWeek": "Days/week",
    "crecheTarief.abonnement.col.prijsPerMaand": "Price/month",
    "crecheTarief.abonnement.col.strategy": "Extra days",
    "crecheTarief.abonnement.col.looptijd": "Term",
    "crecheTarief.abonnement.col.status": "Status",
    "crecheTarief.abonnement.action.publiceren": "Publish",
    "crecheTarief.abonnement.action.depubliceren": "Unpublish",
    "crecheTarief.abonnement.status.ACTIEF": "Active",
    "crecheTarief.abonnement.status.CONCEPT": "Draft",
    "crecheTarief.abonnement.strategy.RITTENKAART": "From punch card",
    "crecheTarief.abonnement.strategy.LOSSE_DAGPRIJS": "At single-day price",
    "crecheTarief.abonnement.looptijd.DOORLOPEND": "Open-ended",
    "crecheTarief.abonnement.looptijd.BEPAALDE_TIJD": "Fixed term",
    "crecheTarief.abonnement.dialog.new.title": "New subscription",
    "crecheTarief.abonnement.dialog.edit.title": "Edit subscription",
    "crecheTarief.abonnement.field.naam": "Name",
    "crecheTarief.abonnement.field.naam.required": "A name is required.",
    "crecheTarief.abonnement.field.dagenPerWeek": "Days per week",
    "crecheTarief.abonnement.field.dagenPerWeek.required": "Days per week is required.",
    "crecheTarief.abonnement.field.prijsPerMaand": "Price per month",
    "crecheTarief.abonnement.field.prijsPerMaand.required": "A monthly price is required.",
    "crecheTarief.abonnement.field.strategy": "Extra days strategy",
    "crecheTarief.abonnement.field.looptijd": "Term type",
    "crecheTarief.abonnement.field.looptijdMaanden": "Term (months)",
    "crecheTarief.pakketsaldo.title": "Package balance lookup",
    "crecheTarief.pakketsaldo.hint": "Look up a customer's daycare package balance by customer id (read-only).",
    "crecheTarief.pakketsaldo.field.klantId": "Customer id",
    "crecheTarief.pakketsaldo.lookup": "Look up",
    "crecheTarief.pakketsaldo.empty": "No package balances for this customer.",
    "crecheTarief.pakketsaldo.load.error": "The package balance could not be loaded.",
    "crecheTarief.pakketsaldo.col.dier": "Animal",
    "crecheTarief.pakketsaldo.col.rittenkaart": "Punch card",
    "crecheTarief.pakketsaldo.col.rittenOver": "Rides left",
    "crecheTarief.pakketsaldo.col.verloop": "Expires",
    "crecheTarief.pakketsaldo.col.abonnement": "Subscription",
    "productStatistiek.filter.van": "Period from",
    "productStatistiek.filter.tot": "Period to",
    "productStatistiek.filter.vestiging": "Branch",
    "productStatistiek.filter.organisatie": "Whole organisation",
    "productStatistiek.export": "Export CSV",
    "productStatistiek.empty": "No sales in this period.",
    "productStatistiek.loadFailed": "Could not load the statistics.",
    "productStatistiek.col.product": "Product",
    "productStatistiek.col.aantal": "Quantity",
    "productStatistiek.col.omzetExcl": "Revenue excl. VAT",
    "productStatistiek.col.omzetIncl": "Revenue incl. VAT",
    "productStatistiek.col.korting": "Discount",
    "productStatistiek.col.netto": "Net",
    "productStatistiek.kpi.topProduct": "Top product",
    "productStatistiek.kpi.gemKorting": "Avg. discount %",
    "productStatistiek.kpi.aantalVerkopen": "Number of sales",
    "productTrends.filter.weergave": "View",
    "productTrends.weergave.aantal": "Quantity",
    "productTrends.weergave.omzet": "Revenue",
    "productTrends.filter.product": "Product",
    "productTrends.product.none": "No products with sales.",
    "productTrends.filter.periode": "Period",
    "productTrends.periode.maanden": "%d months",
    "productTrends.filter.vestiging": "Branch",
    "productTrends.filter.organisatie": "Whole organisation",
    "productTrends.empty": "No data for this product in this period.",
    "productTrends.loadFailed": "Could not load the trends.",
    "productTrends.chart.label": "Sales per month",
    "productTrends.insight.title": "Insight",
    "productTrends.insight.groei": "Growth",
    "productTrends.insight.piek": "Peak month",
    "entingenTab.loadFailed": "Could not load the vaccination settings.",
    "entingenTab.saved": "Saved.",
    "entingenTab.saveError": "Could not save. Please try again.",
    "entingenTab.saveConflict": "Changed by someone else — please reload and try again.",
    "entingenTab.section.toepassing": "Application",
    "entingenTab.section.geldigheidsduur": "Validity & repetition",
    "entingenTab.section.verplichting": "Obligation",
    "entingenTab.section.vervolg": "Follow-up vaccination",
    "entingenTab.section.overige": "Other settings",
    "entingenTab.section.notities": "Notes",
    "entingenTab.section.geldigheidsregeling": "Validity scheme",
    "entingenTab.diersoort": "Species",
    "entingenTab.diersoort.all": "All species",
    "entingenTab.vanafLeeftijd": "From age",
    "entingenTab.totLeeftijd": "To age",
    "entingenTab.totLeeftijd.helper": "(empty = unlimited)",
    "entingenTab.toepassenStatus": "Apply for status",
    "entingenTab.toepassenAanwezig": "Present in shelter",
    "entingenTab.toepassenPleeggezin": "Foster home",
    "entingenTab.geldigheidsduur": "Validity period",
    "entingenTab.geldigheidsduur.info": "The vaccination is %s valid from the administration date.",
    "entingenTab.waarschuwingVooraf": "Warning in advance",
    "entingenTab.waarschuwingVooraf.helper":
      "The animal appears %s before the vaccination expires in the overview.",
    "entingenTab.verplicht": "Is this vaccination mandatory?",
    "entingenTab.vrijstelling": "Exemption allowed?",
    "entingenTab.vervolg.geen": "No follow-up",
    "entingenTab.vervolg.zelfde": "Same vaccination",
    "entingenTab.vervolg.andere": "Other vaccination",
    "entingenTab.vervolg.info": "A follow-up can be the same vaccination, but also another one.",
    "entingenTab.vervolg.product": "Follow-up vaccination",
    "entingenTab.vervolg.moment": "Follow-up after (days)",
    "entingenTab.vervolg.stap1": "Step 1:",
    "entingenTab.vervolg.stap1.value": "1st vaccination",
    "entingenTab.vervolg.stap2": "Step 2:",
    "entingenTab.vervolg.stap2.zelfde": "Repeat",
    "entingenTab.vervolg.stap2.andere": "Follow-up vaccination",
    "entingenTab.vervolg.stap2.dagen": "after %s days",
    "entingenTab.combineerbaar": "May be combined with other vaccinations?",
    "entingenTab.interneOpmerking": "Internal note",
    "entingenTab.actief": "Active",
    "entingenTab.notities.placeholder": "Optional notes…",
    "entingenTab.geldigVanaf": "Valid from",
    "entingenTab.geldigVanaf.TOEDIENINGSDATUM": "Administration date",
    "entingenTab.geldigVanaf.REGISTRATIEDATUM": "Registration date",
    "entingenTab.geldigTot": "Valid until",
    "entingenTab.geldigTot.GELDIGHEIDSDUUR": "Calculate end date from validity period",
    "entingenTab.geldigTot.VASTE_EINDDATUM": "Fixed end date",
    "entingenTab.geldigheidsregeling.info":
      "When this vaccination is registered the expiry date is calculated automatically based on the administration date and the settings above.",
    "entingenTab.toggle.ja": "Yes",
    "entingenTab.toggle.jaVerplicht": "Yes, required",
    "entingenTab.toggle.nee": "No",
    "entingenTab.eenheid.dagen": "days",
    "entingenTab.eenheid.weken": "weeks",
    "entingenTab.eenheid.maanden": "months",
    "entingenTab.eenheid.jaren": "years",
    "entingenTab.eenheidEnkelvoud.dagen": "day",
    "entingenTab.eenheidEnkelvoud.weken": "week",
    "entingenTab.eenheidEnkelvoud.maanden": "month",
    "entingenTab.eenheidEnkelvoud.jaren": "year",
    "entingenTab.vrijstellingReden": "Exemption reason (optional)",
    "entingenTab.vrijstellingReden.placeholder": "Select exemption reason",
    "entingenTab.geldigheidsduur.1maand": "1 month",
    "entingenTab.geldigheidsduur.3maanden": "3 months",
    "entingenTab.geldigheidsduur.6maanden": "6 months",
    "entingenTab.geldigheidsduur.1jaar": "1 year",
    "entingenTab.geldigheidsduur.2jaar": "2 years",
    "entingenTab.geldigheidsduur.3jaar": "3 years",
    "medicijnTab.loadFailed": "Failed to load the medication settings.",
    "medicijnTab.section.toepassing": "Application",
    "medicijnTab.section.dosering": "Dosage",
    "medicijnTab.diersoort": "Species",
    "medicijnTab.diersoort.all": "All species",
    "medicijnTab.toedieningsvorm": "Administration form",
    "medicijnTab.toedieningsvorm.select": "Select form",
    "medicijnTab.vanafGewicht": "From weight",
    "medicijnTab.totGewicht": "To weight",
    "medicijnTab.gewicht.helper": "(empty = unlimited)",
    "medicijnTab.toepassenStatus": "Apply for status",
    "medicijnTab.toepassenAanwezig": "Present in shelter",
    "medicijnTab.toepassenPleeggezin": "Foster home",
    "medicijnTab.dosering": "Dosage",
    "medicijnTab.doseringEenheid": "Dosage unit",
    "medicijnTab.dosering.placeholder": "e.g. 10",
    "medicijnTab.frequentie": "Administration frequency",
    "medicijnTab.freqUnit.dag": "per day",
    "medicijnTab.freqUnit.week": "per week",
    "medicijnTab.freqUnit.maand": "per month",
    "medicijnTab.freqUnit.uur": "every … hours",
    "medicijnTab.freq.per.dag": "%s× per day",
    "medicijnTab.freq.per.week": "%s× per week",
    "medicijnTab.freq.per.maand": "%s× per month",
    "medicijnTab.freq.omDe": "Every %s hours",
    "medicijnTab.kuur": "Course duration (optional)",
    "medicijnTab.kuur.placeholder": "e.g. 7",
    "medicijnTab.reden": "Reason for medication (optional)",
    "medicijnTab.reden.select": "Select reason",
    "medicijnTab.instructie": "Administration instruction (optional)",
    "medicijnTab.instructie.placeholder": "e.g. Administer with food. Ensure enough water.",
    "medicijnTab.saved": "Saved",
    "medicijnTab.saveConflict": "These medication settings were changed by someone else in the meantime. Reload and try again.",
    "medicijnTab.saveError": "Saving failed. Please try again.",
    "behandelingTab.loadFailed": "Failed to load the treatment settings.",
    "behandelingTab.section.toepassing": "Application",
    "behandelingTab.section.overige": "Other settings",
    "behandelingTab.section.vervolg": "Follow-up treatment",
    "behandelingTab.diersoort": "Species",
    "behandelingTab.diersoort.all": "All species",
    "behandelingTab.vanafLeeftijd": "From age",
    "behandelingTab.totLeeftijd": "To age",
    "behandelingTab.totLeeftijd.helper": "(empty = unlimited)",
    "behandelingTab.toepassenStatus": "Apply for status",
    "behandelingTab.toepassenAanwezig": "Present in shelter",
    "behandelingTab.toepassenPleeggezin": "Foster home",
    "behandelingTab.interneOpmerking": "Internal note",
    "behandelingTab.actief": "Active",
    "behandelingTab.herhalen": "Repeat every",
    "behandelingTab.herhalen.info": "The next treatment takes place %s after the administration date.",
    "behandelingTab.vervolg.softInfo": "Treatment usually only needs a simple repeat.",
    "behandelingTab.waarschuwingVooraf": "Warning in advance",
    "behandelingTab.waarschuwingVooraf.helper": "The animal appears %s before the next treatment in the overview.",
    "behandelingTab.vervolg.geen": "No automatic follow-up treatment",
    "behandelingTab.vervolg.zelfde": "Same product again",
    "behandelingTab.vervolg.andere": "Different treatment afterwards",
    "behandelingTab.vervolg.geen.info": "No automatic repeat. The animal will not reappear in the overview afterwards.",
    "behandelingTab.vervolg.product": "Follow-up treatment product",
    "behandelingTab.vervolg.product.select": "Select product",
    "behandelingTab.vervolg.stap1": "Step 1: Treat",
    "behandelingTab.vervolg.stap1.value": "today",
    "behandelingTab.vervolg.stap2": "Step 2: Repeat",
    "behandelingTab.vervolg.stap2.value": "after %s",
    "behandelingTab.toggle.ja": "Yes",
    "behandelingTab.toggle.nee": "No",
    "behandelingTab.saved": "Saved",
    "behandelingTab.saveConflict": "These treatment settings were changed by someone else in the meantime. Reload and try again.",
    "behandelingTab.saveError": "Saving failed. Please try again.",
    "behandelingTab.eenheid.dagen": "days",
    "behandelingTab.eenheidEnkelvoud.dagen": "day",
    "behandelingTab.eenheidEnkelvoud.weken": "week",
    "behandelingTab.eenheidEnkelvoud.maanden": "month",
    "behandelingTab.eenheidEnkelvoud.jaren": "year",
    "behandelingTab.eenheid.weken": "weeks",
    "behandelingTab.eenheid.maanden": "months",
    "behandelingTab.eenheid.jaren": "years",
    "productNav": "Products",
    "animalTagNav": "Animal tags",
    "animalTagListView.empty": "No animal tags.",
    "animalTagListView.loadFailed": "Could not load animal tags.",
    "animalTagListView.column.color": "Colour",
    "animalTagListView.create": "New tag",
    "animalTagListView.edit": "Edit",
    "animalTagListView.delete": "Delete",
    "animalTagDetailView.create.title": "New animal tag",
    "animalTagDetailView.label": "Label",
    "animalTagDetailView.color": "Colour",
    "animalTagDetailView.saveFailed": "Could not save the animal tag.",
    "tagsHubNav": "Tags",
    "tagsHub.title": "Tags",
    "tagsHub.category.label": "Category",
    "tagsHub.category.customer": "Customer",
    "tagsHub.category.animal": "Animal",
    "tagsHub.category.note": "Note",
    "tagsHub.category.file": "File (animal)",
    "tagsHub.category.relatieFile": "File (customer)",
    "tagsHub.category.pensionReservering": "Boarding reservation",
    "tagsHub.delete.inUse": "%d item(s) use \"%s\". Choose what happens before deleting:",
    "tagsHub.delete.transferTo": "Transfer usages to",
    "tagsHub.delete.choosePlaceholder": "Choose a tag…",
    "tagsHub.delete.transferAndDelete": "Transfer & delete",
    "tagsHub.delete.removeAndDelete": "Remove from all & delete",
    "wassenSoortListView.title": "Wassen soorts",
    "wassenSoortListView.column.naam": "Naam",
    "wassenSoortListView.empty": "No wash types.",
    "wassenSoortListView.loadFailed": "Could not load wash types.",
    "wassenSoortListView.new": "New",
    "wassenSoortListView.edit": "Edit",
    "wassenSoortListView.delete": "Remove",
    "wassenSoortListView.delete.confirm": "Remove this wash type?",
    "wassenSoortListView.delete.error": "Could not remove the wash type.",
    "wassenSoortDetailView.title": "Wassen soort",
    "wassenSoortDetailView.new.title": "New wash type",
    "wassenSoortDetailView.naam": "Naam",
    "wassenSoortDetailView.naam.required": "Name is required.",
    "wassenSoortDetailView.save.conflict": "This wash type was changed in the meantime. Reload and try again.",
    "wassenSoortDetailView.save.error": "Could not save the wash type.",
    "wassenSoortDetailView.loadFailed": "Could not load the wash type.",
    // Category-neutral card/modal strings (the Jmix hub used one neutral set for all 5 categories).
    "tagsHub.empty": "No tags yet.",
    "tagsHub.loadFailed": "Could not load tags.",
    "tagsHub.create.title": "Add tag",
    "tagsHub.edit.title": "Edit tag",
    // Login page (recreation of the Jmix LoginView.* / loginForm.* bundle).
    "login.headerTitle": "Docasoft",
    "login.username": "Username",
    "login.password": "Password",
    "login.rememberMe": "Remember me",
    "login.submit": "Log in",
    "login.locale": "Language",
    "login.showPassword": "Show password",
    "login.hidePassword": "Hide password",
    "login.provisioningLogin": "Log in with HelloID",
    "login.badCredentials":
      "Check that you entered the correct username and password and try again",
    // Set-password page (recreation of the Jmix SetPasswordView — anonymous /set-password).
    "setPassword.title": "Set password",
    "setPassword.intro": "Choose a new password for your account.",
    "setPassword.newPassword": "New password",
    "setPassword.confirmPassword": "Confirm password",
    "setPassword.submit": "Set password",
    "setPassword.success": "Your password has been set. You can now log in.",
    "setPassword.toLogin": "Go to login",
    "setPassword.error.confirmMismatch": "The passwords do not match.",
    "setPassword.error.weakPassword": "Choose a stronger password (at least 8 characters).",
    "setPassword.error.uniform": "The link has expired or is invalid.",
    // Admin users screen (migration of the Jmix `users` view).
    "userListView.title": "Users",
    "userListView.createButton": "New user",
    "userListView.showRemoved": "Show removed",
    "userListView.empty": "No users.",
    "userListView.loadFailed": "Could not load users.",
    "userListView.column.username": "Username",
    "userListView.column.name": "Name",
    "userListView.column.email": "Email",
    "userListView.column.status": "Status",
    "userListView.status.active": "Active",
    "userListView.status.disabled": "Disabled",
    "userListView.status.removed": "Removed",
    "userListView.migrateLegacyButton": "Migrate legacy users",
    "userListView.search.placeholder": "Search by username, name or e-mail…",
    "userListView.pagination.range": "%d–%d of %d",
    "userListView.pagination.page": "Page %d of %d",
    "userListView.pagination.previous": "Previous",
    "userListView.pagination.next": "Next",
    "legacyMigrationDialog.title": "Migrate legacy users",
    "legacyMigrationDialog.intro":
      "Accounts from the legacy docasoft database. Migrated accounts keep their password and roles and can sign in here immediately.",
    "legacyMigrationDialog.empty": "No legacy accounts.",
    "legacyMigrationDialog.loadFailed": "Could not load legacy accounts.",
    "legacyMigrationDialog.selectAll": "Select all",
    "legacyMigrationDialog.selectAllOnPage": "Select all on this page",
    "legacyMigrationDialog.filter.status": "Show",
    "legacyMigrationDialog.filter.status.pending": "Not migrated",
    "legacyMigrationDialog.filter.status.migrated": "Already migrated",
    "legacyMigrationDialog.filter.status.all": "Both",
    "legacyMigrationDialog.filter.username": "Username",
    "legacyMigrationDialog.filter.linkedUser": "Migrated to",
    "legacyMigrationDialog.selectRow": "Select %s",
    "legacyMigrationDialog.column.linkedUser": "Migrated to",
    "legacyMigrationDialog.status.migrated": "Migrated",
    "legacyMigrationDialog.status.matchedByName": "Existing user with this name",
    "legacyMigrationDialog.status.notMigrated": "Not migrated",
    "legacyMigrationDialog.status.noPassword": "No password",
    "legacyMigrationDialog.migrateButton": "Migrate selection (%d)",
    "legacyMigrationDialog.result.success": "%d account(s) migrated.",
    "legacyMigrationDialog.result.partial": "%d account(s) migrated, %d skipped or failed.",
    "legacyMigrationDialog.failed": "Migration failed.",
    "userDetailView.loadFailed": "Could not load this user.",
    "userDetailView.field.username": "Username",
    "userDetailView.field.name": "Name",
    "userDetailView.field.firstName": "First name",
    "userDetailView.field.lastName": "Last name",
    "userDetailView.field.email": "Email",
    "userDetailView.field.employeeId": "Employee ID",
    "userDetailView.field.active": "Active",
    "userDetailView.field.status": "Status",
    "userDetailView.field.password": "Password",
    "userDetailView.password.set": "Set",
    "userDetailView.password.unset": "Not set — issue a reset link",
    "userDetailView.password.mustChange": "Must be changed at next login",
    "userDetailView.setPassword.button": "Set password",
    "userDetailView.setPassword.title": "Set password",
    "userDetailView.setPassword.field.password": "New password",
    "userDetailView.setPassword.field.confirm": "Confirm password",
    "userDetailView.setPassword.field.mustChange": "User must change it at next login",
    "userDetailView.setPassword.help":
      "Use this for a user with no e-mail address on file; hand the password over in person. Otherwise a reset link is safer.",
    "userDetailView.setPassword.submit": "Set password",
    "userDetailView.setPassword.error.mismatch": "The passwords do not match.",
    "userDetailView.setPassword.error.weak": "Choose a stronger password (at least 8 characters).",
    "userDetailView.setPassword.error.generic": "Could not set the password.",
    "forcePasswordChange.title": "Change your password",
    "forcePasswordChange.intro":
      "Your password was set by an administrator. Choose your own password to continue.",
    "forcePasswordChange.currentPassword": "Current password",
    "forcePasswordChange.newPassword": "New password",
    "forcePasswordChange.confirmPassword": "Confirm password",
    "forcePasswordChange.submit": "Change password",
    "forcePasswordChange.logout": "Log out",
    "forcePasswordChange.error.confirmMismatch": "The passwords do not match.",
    "forcePasswordChange.error.weakPassword": "Choose a stronger password (at least 8 characters).",
    "forcePasswordChange.error.badCurrentPassword": "That is not your current password.",
    "forcePasswordChange.error.unreachable": "Could not reach the server. Try again.",
    "forcePasswordChange.error.generic": "Could not change the password.",
    "userDetailView.action.delete": "Remove",
    "userDetailView.action.deleteTitle": "Remove user",
    "userDetailView.action.deleteBody":
      "Remove the account \u201c%s\u201d? They lose access immediately. The account can be restored afterwards.",
    "userDetailView.action.restore": "Restore",
    "userDetailView.action.failed": "The action failed. Try again.",
    "userDetailView.resetLink.button": "Generate password-reset link",
    "userDetailView.resetLink.revealed": "Share this single-use link with the user (shown once):",
    "userDetailView.resetLink.copy": "Copy",
    "userDetailView.resetLink.copied": "Copied",
    "userDetailView.resetLink.failed": "Could not generate a reset link.",
    "userDetailView.teams.title": "Teams",
    "userDetailView.teams.none": "Not in a team yet. A team decides which tasks this user gets and sees.",
    "userDetailView.teams.add": "Add team",
    "userDetailView.teams.addTitle": "Add a team",
    "userDetailView.teams.addNoneLeft": "This user is already in every team.",
    "userDetailView.teams.removeTitle": "Remove from team",
    "userDetailView.teams.removeBody": "Remove this user from %s?",
    "userDetailView.teams.removeAria": "Remove from %s",
    "userDetailView.teams.searchPlaceholder": "Search teams",
    "userDetailView.teams.loadFailed": "The teams could not be loaded.",
    "userDetailView.teams.saveFailed": "The teams could not be saved.",
    "teamsBeheer.knop": "Manage teams",
    "mijnTeams.titel": "My teams",
    "mijnTeams.uitleg": "Teams you are currently working for",
    "mijnTeams.actief": "%s active",
    "mijnTeams.vast": "Permanent",
    "mijnTeams.vandaag": "Today",
    "mijnTeams.vandaagKort": "today",
    "mijnTeams.totMiddernacht": "Temporarily active until 23:59",
    "mijnTeams.tijdelijk": "Temporarily add a team",
    "mijnTeams.voegToe": "Add team for today",
    "mijnTeams.loslaten": "Leave %s for today",
    "mijnTeams.geen": "You are not in a team yet. Add one for today below, or ask an administrator for a permanent team.",
    "mijnTeams.nietsTeKiezen": "There are no other teams to choose.",
    "mijnTeams.mislukt": "That did not work.",
    "mijnTeams.beheren": "Manage teams",
    "mijnTeams.kiezen": "Choose a team",
    "dashboard.aanpassen.knop": "Customise dashboard",
    "dashboard.aanpassen.titel": "Customise dashboard",
    "dashboard.aanpassen.uitleg": "Choose which tiles you see and in what order. This applies to you only.",
    "dashboard.aanpassen.standaard": "Reset to default",
    "dashboard.aanpassen.mislukt": "Saving did not work.",
    "dashboard.aanpassen.omhoog": "Move %s up",
    "dashboard.aanpassen.omlaag": "Move %s down",
    "berichten.titel": "Messages & teams",
    "berichten.ongelezenBadge": "%s unread messages",
    "berichten.ongelezenBadgeEen": "%s unread message",
    "berichten.ongelezenEen": "Unread",
    "berichten.versturenNaar": "Send to",
    "berichten.alleTeamsChip": "All teams",
    "berichten.alleTeams": "all teams",
    "berichten.tekstLabel": "Message",
    "berichten.placeholder": "Type your message… The first line becomes the title.",
    "berichten.hint": "Without a team or person the message goes to everyone.",
    "berichten.persoonZoeken": "Search a person",
    "berichten.persoonPlaceholder": "+ Add a person (search by name)…",
    "berichten.persoonGeen": "Nobody found.",
    "berichten.gekozenPersonen": "Chosen people",
    "berichten.persoonWeg": "Remove %s",
    "berichten.verstuurd": "Message sent.",
    "berichten.versturen": "Send",
    "berichten.typEerst": "Type a message first.",
    "berichten.mislukt": "Sending did not work.",
    "berichten.recent": "Recent messages",
    "berichten.geen": "No messages yet.",
    "berichten.allesBekijken": "View all",
    "berichten.alleBerichten": "All messages",
    "berichten.bericht": "Message",
    "berichten.vanMij": "You",
    "berichten.aan": "To %s",
    "berichten.reacties": "%s replies",
    "berichten.zojuist": "just now",
    "berichten.minGeleden": "%s min ago",
    "berichten.uurGeleden": "%s h ago",
    "berichten.gisteren": "yesterday",
    "berichten.nietGevonden": "This message could not be opened.",
    "berichten.reageerLabel": "Reply",
    "berichten.reageerPlaceholder": "Type a reply…",
    "berichten.reageren": "Reply",
    "teamsBeheer.titel": "Teams",
    "teamsBeheer.uitleg": "The teams tasks are assigned to. A team that is switched off can no longer be chosen; existing tasks keep it.",
    "teamsBeheer.nieuw": "New team",
    "teamsBeheer.nieuwPlaats": "Name of a new team, e.g. Management",
    "teamsBeheer.toevoegen": "Add",
    "teamsBeheer.naamVan": "Name of %s",
    "teamsBeheer.actief": "Active",
    "teamsBeheer.uitgezet": "Switched off",
    "teamsBeheer.mislukt": "Saving failed.",
    "teamsBeheer.naam": "Team name",
    "teamsBeheer.leden": "%s members",
    "teamsBeheer.eenLid": "1 member",
    "teamsBeheer.kiesTeam": "Choose a team on the left.",
    "teamsBeheer.uitgezetUitleg": "This team can no longer be chosen for new tasks. Existing tasks and members stay.",
    "teamsBeheer.ledenTitel": "Members",
    "teamsBeheer.lidZoeken": "Add a member: search by name or e-mail",
    "teamsBeheer.geenGebruikers": "No users found (or already in this team).",
    "teamsBeheer.geenLeden": "Nobody in this team yet. Search above to add someone.",
    "teamsBeheer.accountUit": "Account inactive",
    "teamsBeheer.lidWeg": "Remove %s from this team",
    "userDetailView.roles.title": "Roles",
    "userDetailView.roles.none": "This user has no roles.",
    "userDetailView.roles.add": "Add role",
    "userDetailView.roles.addTitle": "Add role",
    "userDetailView.roles.addNoneLeft": "This user already has every role.",
    "userDetailView.roles.searchPlaceholder": "Search roles…",
    "userDetailView.roles.removeTitle": "Remove role",
    "userDetailView.roles.removeBody": "Remove the role \u201c%s\u201d from this user?",
    "userDetailView.roles.removeAria": "Remove role %s",
    "userDetailView.roles.loadFailed": "Could not load this user's roles.",
    "userDetailView.roles.saveFailed": "Could not save the roles. Nothing was changed.",
    "userDetailView.vestigingen.title": "Branches",
    "userDetailView.vestigingen.help":
      "The branches this user can reach. Adding or removing one takes effect immediately.",
    "userDetailView.vestigingen.none": "This user has access to no branches.",
    "userDetailView.vestigingen.add": "Add branch",
    "userDetailView.vestigingen.addTitle": "Add branch",
    "userDetailView.vestigingen.addNoneLeft": "This user already has every assignable branch.",
    "userDetailView.vestigingen.searchPlaceholder": "Search branches…",
    "userDetailView.vestigingen.removeTitle": "Remove branch",
    "userDetailView.vestigingen.removeBody": "Remove access to \u201c%s\u201d for this user?",
    "userDetailView.vestigingen.removeAria": "Remove branch %s",
    "userDetailView.vestigingen.loadFailed": "Could not load this user's branches.",
    "userDetailView.vestigingen.writeFailed": "Could not change the branch access. Nothing was changed.",
    "userDetailView.vestigingen.refused":
      "This branch cannot be changed on its own — see the explanation next to it. Nothing was changed.",
    "userDetailView.vestigingen.notLinked":
      "This account is not linked to a docaserver user account, so branch access cannot be assigned to it.",
    "userDetailView.vestigingen.koppelen": "Link account",
    "userDetailView.vestigingen.koppelenUitleg":
      "Linking creates the docaserver account this user needs for branch access (or links the existing one with the same user name).",
    "userDetailView.vestigingen.koppelenMislukt": "Linking the account failed. Nothing was changed.",
    "userDetailView.vestigingen.fullAccess":
      "This user has a full-access role and reaches every branch, regardless of the list below.",
    "userDetailView.vestigingen.blocked.noGroup": "No group grants this branch.",
    "userDetailView.vestigingen.blocked.ambiguous": "Several groups grant this branch (%s), so it cannot be changed here.",
    "userDetailView.vestigingen.blocked.shared": "Its group also grants %s, so removing it here would revoke those too.",
    // Voorkeuren (personal preferences — migration of the Jmix UserPreferencesView).
    "voorkeuren.title": "My preferences",
    "voorkeuren.tab.apparaten": "My devices",
    "voorkeuren.apparaten.uitleg": "The phones and tablets you use the animal-care app on. Create a pairing code, then scan it in the app — or enter the address and the code by hand.",
    "voorkeuren.apparaten.codeMaken": "Create pairing code",
    "voorkeuren.apparaten.codeMislukt": "Creating a pairing code failed. Please try again.",
    "voorkeuren.apparaten.intrekkenMislukt": "Revoking that device failed. Please try again.",
    "voorkeuren.apparaten.adres": "Address",
    "voorkeuren.apparaten.code": "Code",
    "voorkeuren.apparaten.opvang": "Shelter",
    "voorkeuren.apparaten.kopieer": "Copy",
    "voorkeuren.apparaten.qrAlt": "QR code with the address and the pairing code",
    "voorkeuren.apparaten.gekopieerd": "Copied.",
    "voorkeuren.apparaten.geldigNog": "Valid for another %s. The code works once.",
    "voorkeuren.apparaten.handmatig": "Cannot scan? In the app, choose \"Enter by hand\" and type the address and the code above.",
    "voorkeuren.apparaten.adresOnbruikbaar": "This address points at the machine itself, so no phone can reach it. Set fawkes.api.devices.base-url to the address the app must call, then create a new code.",
    "voorkeuren.apparaten.gekoppeld": "Paired devices",
    "voorkeuren.apparaten.geen": "No devices paired yet.",
    "logboek.periode": "Period",
    "logboek.periode.week": "Last 7 days",
    "logboek.periode.maand": "Last 30 days",
    "logboek.periode.kwartaal": "Last 90 days",
    "logboek.periode.alles": "Everything",
    "logboek.categorie": "Category",
    "logboek.categorie.alle": "All",
    "logboek.zoeken": "Search",
    "logboek.zoekenPlaceholder": "Search…",
    "logboek.uitleg": "Daily care actions and observations",
    "logboek.leeg": "Nothing logged in this period.",
    "logboek.ophalenMislukt": "The logbook could not be loaded.",
    "logboek.opslaanMislukt": "The entry could not be saved.",
    "logboek.vandaag": "Today",
    "logboek.gisteren": "Yesterday",
    "logboek.door": "by %s",
    "logboek.doorOnbekend": "author unknown",
    "logboek.uitTaak": "from a task",
    "logboek.uitFormulier": "from a form",
    "logboek.allesBekijken": "View all",
    "logboek.allesTitel": "Logbook — everything",
    "logboek.nieuw": "New entry",
    "logboek.wat": "What happened?",
    "logboek.watPlaceholder": "Walked, ate poorly, barks at other dogs…",
    "logboek.snelleActies": "Quick actions",
    "logboek.snelUitleg": "One tap for what comes back every day. Anything else you type yourself.",
    "logboek.snel.uitgelaten": "Walked",
    "logboek.snel.water": "Water refreshed",
    "logboek.snel.hok": "Enclosure cleaned",
    "logboek.snel.goedGegeten": "Ate well",
    "logboek.snel.slechtGegeten": "Ate poorly",
    "animalDetailView.tile.logboek": "Logbook",
    "voorkeuren.apparaten.zojuistGekoppeld": "%s is now paired. The code has been used and no longer works.",
    "voorkeuren.apparaten.wachtOpToestel": "Waiting for a device to use this code…",
    "voorkeuren.apparaten.intrekken": "Revoke",
    "voorkeuren.apparaten.nooitGebruikt": "Never used",
    "voorkeuren.apparaten.kolom.naam": "Device",
    "voorkeuren.apparaten.kolom.platform": "Platform",
    "voorkeuren.apparaten.kolom.gekoppeld": "Paired",
    "voorkeuren.apparaten.kolom.laatstGebruikt": "Last used",
    "voorkeuren.tab.profiel": "Profile",
    "voorkeuren.tab.taal": "Language",
    "voorkeuren.tab.vestiging": "Branch",
    "voorkeuren.tab.notificaties": "Notifications",
    "voorkeuren.tab.filters": "Default filters",
    "voorkeuren.apparaten.koppel": "Pair a device",
    "voorkeuren.apparaten.scan": "Scan this code with the app",
    "voorkeuren.apparaten.geldig": "Still valid:",
    "voorkeuren.apparaten.verberg": "Hide code",
    "voorkeuren.apparaten.qrFout": "The pairing code could not be drawn.",
    "voorkeuren.apparaten.codeFout": "No pairing code could be created. Please try again.",
    "voorkeuren.apparaten.leeg": "You have not paired a device yet.",
    "voorkeuren.apparaten.gekoppeldOp": "Paired on",
    "voorkeuren.apparaten.laatstGebruikt": "Last used",
    "voorkeuren.apparaten.intrekkenTitel": "Revoke device",
    "voorkeuren.apparaten.intrekkenUitleg": "{naam} will no longer get into the app. If you lost the device, revoke it and pair the new one. Your other devices keep working.",
    "voorkeuren.apparaten.intrekkenFout": "The device could not be revoked.",
    "voorkeuren.profiel.lokaal": "Local users: editable.",
    "voorkeuren.profiel.foto": "Profile photo",
    "voorkeuren.profiel.fotoKiezen": "Choose a photo",
    "voorkeuren.profiel.fotoVerwijderen": "Remove photo",
    "voorkeuren.profiel.fotoHint": "JPG or PNG, max 2 MB.",
    "voorkeuren.profiel.fotoFout": "The photo could not be saved. Choose a JPG or PNG of at most 2 MB.",
    "voorkeuren.vestiging.uitleg": "This branch is selected automatically when you sign in.",
    "voorkeuren.vestiging.label": "Default branch",
    "voorkeuren.thema.uitleg": "Click a theme for a live preview. Press Save to confirm.",
    "voorkeuren.taal.uitleg": "Interface language.",
    "voorkeuren.notificaties.uitleg": "Switch on and off per type.",
    "voorkeuren.notificaties.leeg": "Notification types are not available yet — coming later.",
    "voorkeuren.filters.uitleg": "Default time filter per tile on the animal screen.",
    "voorkeuren.opslaanFout": "Your preferences could not be saved. Please try again.",
    "voorkeuren.theme.docasoft-green.uitleg": "Default look — neutral, bright.",
    "voorkeuren.theme.warm.uitleg": "Cream + brown with a golden accent, editorial feel.",
    "voorkeuren.theme.dark.uitleg": "Dark mode with green-tinted surfaces.",
    "voorkeuren.theme.high-contrast.uitleg": "Accessibility — high contrast, hard edges.",
    "voorkeuren.tab.thema": "Theme",
    "voorkeuren.profiel.username": "Username",
    "voorkeuren.profiel.firstName": "First name",
    "voorkeuren.profiel.lastName": "Last name",
    "voorkeuren.profiel.email": "Email",
    "voorkeuren.profiel.saved": "Saved.",
    "voorkeuren.profiel.loadFailed": "Could not load your profile.",
    "voorkeuren.profiel.managedExternally": "Your profile is managed via HelloID and can't be edited here.",
    "voorkeuren.password.hint": "We send a verification link to your email; the change takes effect after you click it.",
    "voorkeuren.password.button": "Change password",
    "voorkeuren.password.sent": "Verification link sent to your email.",
    "voorkeuren.password.noEmail": "You have no email on file. Add one and save first.",
    "voorkeuren.password.oidcDisabled": "Password is managed via HelloID.",
    "voorkeuren.password.failed": "Could not start a password change. Try again.",
    "voorkeuren.taal.label": "Interface language",
    "voorkeuren.thema.label": "Theme",
    "voorkeuren.thema.saved": "Theme applied.",
    "voorkeuren.theme.docasoft-green": "Docasoft (green)",
    "voorkeuren.theme.warm": "Warm / Earth tones",
    "voorkeuren.theme.dark": "Dark",
    "voorkeuren.theme.high-contrast": "High contrast",
    "voorkeuren.theme.eigen": "Own theme (AI)",
    "voorkeuren.theme.eigen.uitleg": "Generated from a website URL — AI picks the dominant colours.",
    "voorkeuren.thema.eigenUitleg": "Paste a website URL and click 'Generate AI theme'. The site's colours are fetched and turned into a theme; colours from embedded videos are left out.",
    "voorkeuren.thema.website": "Website URL",
    "voorkeuren.thema.genereer": "Generate AI theme",
    "voorkeuren.thema.bezig": "Working…",
    "voorkeuren.thema.gevonden": "Found on the site:",
    "voorkeuren.thema.eigenFout": "No theme could be made from this page. Try another URL.",
    "userCreateView.title": "New user",
    "userCreateView.field.username": "Username",
    "userCreateView.field.password": "Password (optional)",
    "userCreateView.field.passwordHelp": "Leave empty to let the user set it via a reset link.",
    "userCreateView.submit": "Create user",
    "userCreateView.error.usernameRequired": "Enter a username.",
    "userCreateView.error.duplicate": "That username is already in use.",
    "userCreateView.error.generic": "Could not create the user. Try again.",
    // Vestiging (branch) selector + switch dialog (port of the Jmix vestigingSelector.* bundle).
    "vestigingSelector.label": "Location",
    // Short pill label in the sidebar card header (the live Jmix "Wisselen" button).
    "vestigingSelector.switchLabel": "Switch",
    "vestigingSelector.empty": "No active locations available",
    "vestigingSelector.dialogTitle": "Switch location",
    "vestigingSelector.dialogIntro": "Choose the location to work in.",
    "vestigingSelector.current": "Current",
    "vestigingSelector.loadFailed": "Could not load locations.",
    "vestigingSelector.searchPlaceholder": "Search by name or town…",
    "vestigingSelector.noResults": "No locations match your search.",
    // Asiel/Pension work-mode segments in the location card (only shown when both modules are on).
    "vestigingSelector.modus.label": "Working mode",
    "vestigingSelector.modus.asiel": "Shelter",
    "vestigingSelector.modus.pension": "Boarding",
    "vestigingSelector.modus.crematorium": "Crematorium",
    "menu.crematoriumKlanten": "Customers",
    "menu.crematieTarieven": "Cremation rates",
    "menu.ophaalkosten": "Collection costs",
    "crematoriumTarief.sub": "Prices per weight class and funeral type",
    "crematoriumTarief.kpi.versie": "Active version since",
    "crematoriumTarief.kpi.klassen": "Weight classes",
    "crematoriumTarief.kpi.regels": "Rate lines",
    "crematoriumTarief.kpi.toeslagen": "Active surcharges",
    "crematoriumTarief.tab.tarieven": "Rates",
    "crematoriumTarief.klasse.col.diersoort": "Species",
    "crematoriumTarief.klasse.uitleg": "Boundaries follow on from each other without overlap.",
    "crematoriumTarief.diersoort.alle": "All species",
    "crematoriumTarief.filter.geldigOp": "Valid on",
    "crematoriumTarief.filter.alleenActief": "Active only",
    "crematoriumTarief.filter.wissen": "Clear",
    "crematoriumTarief.tarief.versieUitleg": "A change creates a new version. Issued invoices keep their own version and do not change with it.",
    "crematoriumTarief.toeslag.title": "Surcharges",
    "crematoriumTarief.toeslag.add": "Add surcharge",
    "crematoriumTarief.toeslag.add.title": "New surcharge",
    "crematoriumTarief.toeslag.edit.title": "Edit surcharge",
    "crematoriumTarief.toeslag.empty": "No surcharges yet.",
    "crematoriumTarief.toeslag.uitleg": "Energy and administration surcharges on top of the rate, per funeral type.",
    "crematoriumTarief.toeslag.col.naam": "Name",
    "crematoriumTarief.toeslag.col.bedrag": "Amount",
    "crematoriumTarief.toeslag.col.geldigVanaf": "Valid from",
    "crematoriumTarief.toeslag.col.geldigTot": "Valid until",
    "crematoriumTarief.toeslag.col.automatisch": "Automatic invoice line",
    "crematoriumTarief.toeslag.alleVormen": "All types",
    "crematoriumTarief.toeslag.alleKlassen": "All weight classes",
    "crematoriumTarief.klasse.controleer": "Check with the other classes",
    "crematoriumTarief.klasse.advies.voorstel": "Proposed adjustments:",
    "crematoriumTarief.klasse.advies.toepassen": "Apply these adjustments",
    "crematoriumTarief.klasse.advies.eigenNaam": "The name matching these limits is \"%s\".",
    "crematoriumTarief.klasse.advies.naamOvernemen": "Use that name",
    "crematoriumTarief.toeslag.verplicht": "Name and amount are required.",
    "crematoriumTarief.toeslag.geldigTotUitleg": "Leave \"valid until\" empty while the surcharge continues. A new version closes the previous one automatically.",
    "crematoriumTarief.toeslag.status.ACTIEF": "Active",
    "crematoriumTarief.toeslag.status.GEPLAND": "Planned",
    "crematoriumTarief.toeslag.status.VERLOPEN": "Expired",
    "crematoriumTarief.toeslag.status.INACTIEF": "Inactive",
    "relatieDetailView.tab.documenten": "Documents",
    "crematoriumKlantDocumenten.col.document": "Document",
    "crematoriumKlantDocumenten.col.categorie": "Category",
    "crematoriumKlantDocumenten.col.kanaal": "Channel",
    "crematoriumKlantDocumenten.col.datum": "Date",
    "crematoriumKlantDocumenten.col.uitvaart": "Funeral",
    "crematoriumKlantDocumenten.col.status": "Status",
    "crematoriumKlantDocumenten.dossier": "Open dossier",
    "crematoriumKlantDocumenten.empty": "No documents yet.",
    "crematoriumVervoer.sub": "Standard collection rule and agreements per practice",
    "crematoriumVervoer.nieuweVersie": "New version",
    "crematoriumVervoer.standaardregel": "Standard collection rule",
    "crematoriumVervoer.actiefSinds": "Active since",
    "crematoriumVervoer.veld.naam": "Name",
    "crematoriumVervoer.veld.starttarief": "Base fee",
    "crematoriumVervoer.veld.starttariefTot": "Base fee up to",
    "crematoriumVervoer.veld.starttariefVanaf": "Base fee above",
    "crematoriumVervoer.veld.grensKm": "Limit (km)",
    "crematoriumVervoer.veld.prijsPerKm": "Price per extra km",
    "crematoriumVervoer.veld.vrijeKm": "Free km",
    "crematoriumVervoer.veld.spoedtoeslag": "Urgent surcharge",
    "crematoriumVervoer.veld.btw": "VAT",
    "crematoriumVervoer.veld.retour": "Charge return trip",
    "crematoriumVervoer.veld.ingangsdatum": "Effective date",
    "crematoriumVervoer.proef.title": "Trial calculation",
    "crematoriumVervoer.proef.exclBtw": "Excluding VAT",
    "crematoriumVervoer.proef.enkeleReis": "One way (km)",
    "crematoriumVervoer.proef.moment": "Collection moment",
    "crematoriumVervoer.proef.regulier": "Regular",
    "crematoriumVervoer.proef.spoed": "Urgent",
    "crematoriumVervoer.proef.retour": "return",
    "crematoriumVervoer.proef.start": "base fee",
    "crematoriumVervoer.proef.geenRegel": "No active rule to calculate with.",
    "crematoriumVervoer.proef.uitleg": "The rule used and the outcome are stored as a snapshot when the invoice is issued.",
    "crematoriumVervoer.afspraken.title": "Deviating practice agreements",
    "crematoriumVervoer.afspraken.uitleg": "Agreed on the relation (Veterinary practice tab); listed here so you can see who deviates from the standard rule.",
    "crematoriumVervoer.afspraken.empty": "No practice deviates from the standard rule.",
    "crematoriumVervoer.afspraak.col.praktijk": "Practice",
    "crematoriumVervoer.afspraak.col.regel": "Rule",
    "crematoriumVervoer.afspraak.col.prijs": "Transport price",
    "crematoriumVervoer.afspraak.col.geldigVanaf": "Valid from",
    "crematoriumVervoer.afspraak.col.status": "Status",
    "crematoriumVervoer.afspraak.vast": "Fixed price within the area",
    "crematoriumVervoer.status.actief": "Active",
    "crematoriumVervoer.status.gepland": "Planned",
    "crematoriumVervoer.status.vorig": "Previous",
    "crematoriumVervoer.versies.title": "Earlier versions",
    "crematoriumVervoer.fout.verplicht": "Base fee and price per km are required.",
    "crematoriumVervoer.fout.opslaan": "Could not save the rule.",
    "menu.crematoriumVergoedingen": "Referral fees",
    "crematoriumVergoedingen.title": "Referral fees",
    "crematoriumVergoedingen.sub": "Agreements with referring practices and third parties",
    "crematoriumVergoedingen.tab.afspraken": "Agreements",
    "crematoriumVergoedingen.tab.uitbetaling": "Payout list",
    "crematoriumVergoedingen.zoek": "Search",
    "crematoriumVergoedingen.peildatum": "Reference date",
    "crematoriumVergoedingen.alleenActief": "Active only",
    "crematoriumVergoedingen.uitleg": "Agreements are edited on the relation itself; this list shows who gets what.",
    "crematoriumVergoedingen.empty": "No agreements on this date.",
    "crematoriumVergoedingen.col.relatie": "Practice",
    "crematoriumVergoedingen.col.rol": "Role",
    "crematoriumVergoedingen.col.type": "Fee type",
    "crematoriumVergoedingen.col.waarde": "Value",
    "crematoriumVergoedingen.col.vervoer": "Transport price",
    "crematoriumVergoedingen.col.uitbetaling": "Payout",
    "crematoriumVergoedingen.col.geldigVanaf": "Valid from",
    "crematoriumVergoedingen.col.status": "Status",
    "crematoriumVergoedingen.col.uitvaarten": "Funerals",
    "crematoriumVergoedingen.col.totaal": "Total",
    "crematoriumVergoedingen.rol.alle": "All roles",
    "crematoriumVergoedingen.rol.praktijk": "Veterinary practice",
    "crematoriumVergoedingen.rol.derdePartij": "Third party",
    "crematoriumVergoedingen.type.bedrag": "Amount per funeral",
    "crematoriumVergoedingen.type.percentage": "Percentage",
    "crematoriumVergoedingen.uitbetaling.maand": "Monthly",
    "crematoriumVergoedingen.uitbetaling.kwartaal": "Quarterly",
    "crematoriumVergoedingen.status.actief": "Active",
    "crematoriumVergoedingen.status.gepland": "Planned",
    "crematoriumVergoedingen.van": "From",
    "crematoriumVergoedingen.tot": "To",
    "crematoriumVergoedingen.dezeMaand": "This month",
    "crematoriumVergoedingen.uitbetaling.uitleg": "Per practice: the funerals that came in through it in the period, times the fee that applied on each registration date.",
    "crematoriumVergoedingen.uitbetaling.empty": "No funerals via a practice in this period.",
    "crematoriumVergoedingen.uitbetaling.totaal": "Total to pay out",
    // Werkmodus Pension: the APPLICATIE section is rewritten (its own dashboard, Dier+Relaties merged
    // into one "Relatie" entry, Opvangoverzichten under its boarding name, Planning unchanged).
    "menu.pensionRelatie": "Relation",
    "menu.pensionOverzichten": "Boarding overviews",
    "pensionOverzichten.title": "Animals in boarding",
    "pensionOverzichten.subtitle": "Who is here on this day, who arrives and who leaves",
    "pensionOverzichten.onderdelen": "Sections",
    "pensionOverzichten.onderdeel.PENSION": "Boarding",
    "pensionOverzichten.onderdeel.DAGOPVANG": "Day care",
    "pensionOverzichten.onderdeel.RESERVERINGEN": "Reservations",
    "pensionOverzichten.onderdeel.BEZETTING": "Occupancy",
    "pensionOverzichten.kop.PENSION": "Animals in boarding",
    "pensionOverzichten.kop.DAGOPVANG": "Animals in day care",
    "pensionOverzichten.kop.RESERVERINGEN": "Upcoming reservations",
    "pensionOverzichten.kop.BEZETTING": "Occupancy",
    "pensionOverzichten.ondertitel.PENSION": "Animals present today, arriving or leaving",
    "pensionOverzichten.ondertitel.DAGOPVANG": "The animals in day care on this day",
    "pensionOverzichten.ondertitel.RESERVERINGEN": "Who is coming in the next two weeks, boarding and day care",
    "pensionOverzichten.tabs": "Overviews",
    "pensionOverzichten.tab.aanwezig": "Present",
    "pensionOverzichten.tab.aankomsten": "Arrivals",
    "pensionOverzichten.tab.vertrekken": "Departures",
    "pensionOverzichten.tab.reserveringen": "Reservations",
    "pensionOverzichten.soort": "Species",
    "pensionOverzichten.soort.HOND": "Dog",
    "pensionOverzichten.soort.KAT": "Cat",
    "pensionOverzichten.soort.OVERIG": "Other",
    "pensionOverzichten.teller.aankomst": "Arrival",
    "pensionOverzichten.teller.vertrek": "Departure",
    "pensionOverzichten.teller.totaal": "Total",
    "pensionOverzichten.filters": "Filters",
    "pensionOverzichten.zoek": "Search by name, chip number, owner…",
    "pensionOverzichten.datum": "Date",
    "pensionOverzichten.alle": "All",
    "pensionOverzichten.wis": "Clear filters",
    "pensionOverzichten.toonDagopvang": "Show day care",
    "pensionOverzichten.toonDagopvang.uitleg": "Also show animals staying in day care",
    "pensionOverzichten.groeperen": "Group by:",
    "pensionOverzichten.groeperen.GEEN": "None",
    "pensionOverzichten.groeperen.RESERVERING": "Reservation",
    "pensionOverzichten.weergave": "View",
    "pensionOverzichten.weergave.GROOT": "Large tiles",
    "pensionOverzichten.weergave.KLEIN": "Small tiles",
    "pensionOverzichten.weergave.LIJST": "List",
    "pensionOverzichten.velden": "Fields",
    "pensionOverzichten.velden.titel": "Fields on the tile",
    "pensionOverzichten.velden.uitleg.GEEN": "For animals on their own: the customer belongs on the tile.",
    "pensionOverzichten.velden.uitleg.RESERVERING": "Per reservation: the customer and the boarding note are already in the header.",
    "pensionOverzichten.velden.standaard": "Back to default",
    "pensionOverzichten.sorteren": "Sort by:",
    "pensionOverzichten.sortering.AANKOMST_NIEUW": "Arrival date (newest)",
    "pensionOverzichten.sortering.AANKOMST_OUD": "Arrival date (oldest)",
    "pensionOverzichten.sortering.VERTREK": "Departure date",
    "pensionOverzichten.sortering.NAAM": "Animal name",
    "pensionOverzichten.sortering.EIGENAAR": "Owner",
    "pensionOverzichten.sortering.KENNEL": "Kennel",
    "pensionOverzichten.veld.verblijfnr": "Stay no.",
    "pensionOverzichten.veld.status": "Status",
    "pensionOverzichten.veld.ras": "Breed and sex",
    "pensionOverzichten.veld.eigenaar": "Owner",
    "pensionOverzichten.veld.telefoon": "Phone",
    "pensionOverzichten.veld.email": "Email",
    "pensionOverzichten.veld.woonplaats": "City",
    "pensionOverzichten.veld.reservering": "Reservation",
    "pensionOverzichten.veld.kennel": "Kennel",
    "pensionOverzichten.veld.verblijf": "Stay",
    "pensionOverzichten.veld.nachten": "Nights",
    "pensionOverzichten.veld.voeding": "Food",
    "pensionOverzichten.veld.medicatie": "Medication",
    "pensionOverzichten.veld.bijzonderheden": "Notes",
    "pensionOverzichten.veld.opmerking": "Boarding note",
    "pensionOverzichten.kolom.foto": "Photo",
    "pensionOverzichten.kolom.dier": "Animal",
    "pensionOverzichten.kolom.van": "From",
    "pensionOverzichten.kolom.tot": "Until",
    "pensionOverzichten.kolom.verzorging": "Care",
    "pensionOverzichten.kolom.acties": "Actions",
    "pensionOverzichten.status.GEPLAND": "Planned",
    "pensionOverzichten.status.KOMT": "Arrives",
    "pensionOverzichten.status.KOMT.vandaag": "Arrives today",
    "pensionOverzichten.status.AANWEZIG": "Present",
    "pensionOverzichten.status.VERTREKT": "Leaves",
    "pensionOverzichten.status.VERTREKT.vandaag": "Leaves today",
    "pensionOverzichten.status.VERTROKKEN": "Left",
    "pensionOverzichten.chip.voeding": "Food",
    "pensionOverzichten.chip.eigenVoeding": "Own food",
    "pensionOverzichten.chip.medicatie": "Medication",
    "pensionOverzichten.chip.bijzonderheden": "Notes",
    "pensionOverzichten.chip.dagopvang": "Day care",
    "pensionOverzichten.chip.aankomstVandaag": "Arrives today",
    "pensionOverzichten.geslacht.HOND.M": "Male",
    "pensionOverzichten.geslacht.HOND.V": "Female",
    "pensionOverzichten.geslacht.KAT.M": "Tom",
    "pensionOverzichten.geslacht.KAT.V": "Queen",
    "pensionOverzichten.geslacht.OVERIG.M": "Male",
    "pensionOverzichten.geslacht.OVERIG.V": "Female",
    "pensionOverzichten.nachten": "%d nights",
    "pensionOverzichten.nietIngedeeld": "Not placed yet",
    "pensionOverzichten.aantalDieren": "%d animals",
    "pensionOverzichten.aantalDieren.een": "%d animal",
    "pensionOverzichten.aantal.HOND.een": "%d dog",
    "pensionOverzichten.aantal.HOND.meer": "%d dogs",
    "pensionOverzichten.aantal.KAT.een": "%d cat",
    "pensionOverzichten.aantal.KAT.meer": "%d cats",
    "pensionOverzichten.aantal.OVERIG.een": "%d other",
    "pensionOverzichten.aantal.OVERIG.meer": "%d other",
    "pensionOverzichten.gevonden.reserveringen.een": "%d reservation found",
    "pensionOverzichten.gevonden.reserveringen.meer": "%d reservations found",
    "pensionOverzichten.gevonden.dieren.een": "%d animal found",
    "pensionOverzichten.gevonden.dieren.meer": "%d animals found",
    "pensionOverzichten.groep.reservering": "Reservation",
    "pensionOverzichten.groep.dagopvang": "Day care",
    "pensionOverzichten.groep.inklappen": "Collapse reservation of %s",
    "pensionOverzichten.groep.uitklappen": "Expand reservation of %s",
    "pensionOverzichten.acties": "Actions for %s",
    "pensionOverzichten.openDier": "Open animal",
    "pensionOverzichten.openKlant": "Open customer",
    "pensionOverzichten.loadFailed": "The overview could not be loaded.",
    "pensionOverzichten.leeg.aanwezig": "No animals are boarding on this day.",
    "pensionOverzichten.leeg.aankomsten": "No animal arrives on this day.",
    "pensionOverzichten.leeg.vertrekken": "No animal leaves on this day.",
    "pensionOverzichten.leeg.reserveringen": "Nobody new is coming in the next two weeks.",
    "pensionOverzichten.leeg.DAGOPVANG": "Nobody is in day care on this day.",
    "pensionOverzichten.leeg.RESERVERINGEN": "Nobody new is coming in the next two weeks.",
    "pensionOverzichten.leeg.filters": "No animals match these filters.",
    "pensionOverzichten.bezetting.planning": "Open kennel planning",
    "pensionOverzichten.bez.aankomsten": "Arrivals",
    "pensionOverzichten.bez.aankomstenVandaag": "Arrivals today",
    "pensionOverzichten.bez.vertrekken": "Departures",
    "pensionOverzichten.bez.vertrekkenVandaag": "Departures today",
    "pensionOverzichten.bez.bezet": "Occupied",
    "pensionOverzichten.bez.capaciteit": "Capacity",
    "pensionOverzichten.bez.dagenVol": "Days (nearly) full",
    "pensionOverzichten.bez.dezeDag": "On this day",
    "pensionOverzichten.bez.dieren": "animals",
    "pensionOverzichten.bez.drukste": "Busiest days in period",
    "pensionOverzichten.bez.drukste.uitleg": "Days with the highest occupancy.",
    "pensionOverzichten.bez.geenRuimtes": "This branch has no kennel groups yet. Set them up in the kennel planning.",
    "pensionOverzichten.bez.geenRuimte": "no area of its own",
    "pensionOverzichten.bez.geenVakantie": "No upcoming holiday period (high season) has been set.",
    "pensionOverzichten.bez.gem": "Avg. occupancy",
    "pensionOverzichten.bez.hoogste": "Peak occupancy",
    "pensionOverzichten.bez.graad": "Occupancy",
    "pensionOverzichten.bez.inPeriode": "in this period",
    "pensionOverzichten.bez.kaarten": "Cards",
    "pensionOverzichten.bez.kennels": "Kennels",
    "pensionOverzichten.bez.meestBezet": "Most occupied areas",
    "pensionOverzichten.bez.meestBezet.uitleg": "Areas with the highest occupancy rate.",
    "pensionOverzichten.bez.mini.aankomsten": "arrivals",
    "pensionOverzichten.bez.mini.vertrekken": "departures",
    "pensionOverzichten.bez.mini.bijnaVol": "areas nearly full",
    "pensionOverzichten.bez.mini.dagopvang": "day care",
    "pensionOverzichten.bez.nDagen": "%d days",
    "pensionOverzichten.bez.nVrij": "%d free",
    "pensionOverzichten.bez.nietIngedeeld": "Not placed yet",
    "pensionOverzichten.bez.nietIngedeeld.uitleg": "Animals that are here but have no kennel yet.",
    "pensionOverzichten.bez.nieuw": "Add a new area",
    "pensionOverzichten.bez.nieuw.uitleg": "Manage kennels and areas in the kennel planning.",
    "pensionOverzichten.bez.ondertitel": "Current occupancy of the boarding and the available capacity per area or animal group.",
    "pensionOverzichten.bez.ondertitel.periode": "Occupancy and available capacity over a chosen period.",
    "pensionOverzichten.bez.ongeldig": "The period runs from the start date to at most %d days later.",
    "pensionOverzichten.bez.perDag": "Occupancy per day",
    "pensionOverzichten.bez.perDag.kort": "Occupancy per day",
    "pensionOverzichten.bez.perDag.uitleg": "Total occupancy and available capacity per day in the chosen period.",
    "pensionOverzichten.bez.perRuimte": "Occupancy per area / group",
    "pensionOverzichten.bez.perRuimte.periode": "Occupancy per area / group in period",
    "pensionOverzichten.bez.perRuimte.periode.uitleg": "Detailed overview per stay or group, with average and peak occupancy in the chosen period.",
    "pensionOverzichten.bez.plek": "Space available",
    "pensionOverzichten.bez.presets": "Quick period",
    "pensionOverzichten.bez.punt.vol": "%s: %s full (%d / %d)",
    "pensionOverzichten.bez.punt.bijnaVol": "%s: %s nearly full (%d / %d)",
    "pensionOverzichten.bez.punt.drukste": "%d free places left on the busiest day (%s)",
    "pensionOverzichten.bez.punt.rustig": "No areas getting full or nearly full.",
    "pensionOverzichten.bez.punten": "Points of attention",
    "pensionOverzichten.bez.punten.uitleg": "Important signals in this period.",
    "pensionOverzichten.bez.rij.bezetting": "Occupancy",
    "pensionOverzichten.bez.rij.bezet": "Occupied / total",
    "pensionOverzichten.bez.rij.vrij": "Free places",
    "pensionOverzichten.bez.ruimte": "Stay / group",
    "pensionOverzichten.bez.spark": "Occupancy per day of %s",
    "pensionOverzichten.bez.stand": "Day or period",
    "pensionOverzichten.bez.stand.DAG": "Day",
    "pensionOverzichten.bez.stand.PERIODE": "Period",
    "pensionOverzichten.bez.van": "From",
    "pensionOverzichten.bez.tot": "Until",
    "pensionOverzichten.bez.totaal": "Total occupancy",
    "pensionOverzichten.bez.vakantie": "Holiday period",
    "pensionOverzichten.bez.vanPlekken": "of %d places",
    "pensionOverzichten.bez.vanTotaal": "of %d total",
    "pensionOverzichten.bez.vandaag": "Today",
    "pensionOverzichten.bez.vandaag.uitleg": "Expected movements and points of attention.",
    "pensionOverzichten.bez.volOp": "Full on %s",
    "pensionOverzichten.bez.vrij": "Free places",
    "pensionOverzichten.bez.vrijDrukste": "Free places on busiest day",
    "pensionOverzichten.bez.vrijKort": "Free",
    "pensionOverzichten.bez.zone": "Stay / zone",
    "pensionOverzichten.bez.aantalKennels.een": "%d kennel",
    "pensionOverzichten.bez.aantalKennels.meer": "%d kennels",
    "pensionOverzichten.bez.legenda.groen": "0 – 60%",
    "pensionOverzichten.bez.legenda.groen.uitleg": "Plenty available",
    "pensionOverzichten.bez.legenda.geel": "61 – 80%",
    "pensionOverzichten.bez.legenda.geel.uitleg": "Well occupied",
    "pensionOverzichten.bez.legenda.oranje": "81 – 95%",
    "pensionOverzichten.bez.legenda.oranje.uitleg": "Nearly full",
    "pensionOverzichten.bez.legenda.rood": "96 – 100%",
    "pensionOverzichten.bez.legenda.rood.uitleg": "Full",
    "pensionOverzichten.bez.soort.HOND": "Dogs",
    "pensionOverzichten.bez.soort.KAT": "Cats",
    "pensionOverzichten.bez.soort.OVERIG": "%s",
    "pensionOverzichten.bez.sortering.HOOG": "Occupancy (high → low)",
    "pensionOverzichten.bez.sortering.LAAG": "Occupancy (low → high)",
    "pensionOverzichten.bez.sortering.VRIJ": "Most places free",
    "pensionOverzichten.bez.sortering.NAAM": "Name",
    "pensionOverzichten.bez.staat.VOL": "Full",
    "pensionOverzichten.bez.staat.BIJNA_VOL": "Nearly full",
    "pensionOverzichten.bez.staat.RUIMTE": "Space",
    "pensionDashboard.title": "Boarding",
    "pensionDashboard.subtitle": "Your starting point in the boarding administration.",
    "pensionDashboard.note":
      "The boarding figures are not available yet: the shelter dashboard counts intakes, vaccinations and shelter occupancy, which are about other animals. Until boarding has its own figures, this page takes you straight to the four boarding screens.",
    "pensionDashboard.open": "Open ›",
    "pensionDashboard.tile.planning.desc": "Kennels, arrivals and departures on the timeline.",
    "pensionDashboard.tile.relatie.desc": "Customers and the animals that belong to them.",
    "pensionDashboard.tile.overzichten.desc": "The overviews of the animals staying here.",
    "pensionDashboard.tile.tarief.desc": "Rates, high season and discounts.",
    "pensionDashboard.loadFailed": "Could not load the boarding figures.",
    "pensionDashboard.kpi.aanwezig": "Animals boarding",
    "pensionDashboard.kpi.aankomsten": "Arriving today",
    "pensionDashboard.kpi.vertrekken": "Leaving today",
    "pensionDashboard.kpi.vrij": "Places free",
    "pensionDashboard.kpi.vanCapaciteit": "of %d places",
    "pensionDashboard.kpi.geenCapaciteit": "capacity not set",
    "pensionDashboard.bezetting.title": "Occupancy, next two weeks",
    "pensionDashboard.bezetting.leeg": "No bookings in the coming two weeks.",
    "pensionDashboard.bezetting.capaciteitLijn": "The dashed line is the capacity: %d places.",
    "pensionDashboard.bezetting.geenCapaciteit":
      "No capacity set for this branch, so there is no line to read against — set it under Settings → Boarding.",
    "pensionDashboard.bezetting.omschrijving":
      "Animals boarding per day for the next %d days; the busiest day has %d.",
    // Werkmodus Pension — the planning board (days as rows, kennels as columns) and the bookings below it.
    "pensionPlanning.title": "Kennel planning",
    "pensionPlanning.subtitle": "Stays, rooms and placements at a glance",
    "pensionPlanning.zoek": "Search by animal, owner or booking…",
    "pensionPlanning.loadFailed": "Could not load the kennel planning.",
    "pensionPlanning.opnieuw": "Retry",
    "pensionPlanning.kpi.aria": "Key figures",
    "pensionPlanning.kpi.aankomsten": "Arrivals today",
    "pensionPlanning.kpi.aankomstenOp": "Arrivals on %s",
    "pensionPlanning.kpi.vertrekken": "Departures today",
    "pensionPlanning.kpi.vertrekkenOp": "Departures on %s",
    "pensionPlanning.kpi.nogTePlaatsen": "Still to place",
    "pensionPlanning.filters.titel": "Filters",
    "pensionPlanning.filters.inklappen": "Collapse filters",
    "pensionPlanning.filters.uitklappen": "Expand filters",
    "pensionPlanning.nogTePlaatsen.velden": "Fields on the card",
    "pensionPlanning.nogTePlaatsen.sleepHier": "Drop here to take the animal out of its stay",
    "pensionPlanning.nogTePlaatsen.veldenStandaard": "Back to default",
    "pensionPlanning.kaartveld.soort": "Species and breed",
    "pensionPlanning.kaartveld.geslacht": "Sex",
    "pensionPlanning.kaartveld.eigenaar": "Owner",
    "pensionPlanning.kaartveld.telefoon": "Phone",
    "pensionPlanning.kaartveld.woonplaats": "City",
    "pensionPlanning.kaartveld.periode": "Period",
    "pensionPlanning.kaartveld.nachten": "Nights",
    "pensionPlanning.kaartveld.tarief": "Rate",
    "pensionPlanning.kaartveld.reservering": "Reservation",
    "pensionPlanning.kaartveld.opmerking": "Note",
    "pensionPlanning.kaartveld.chips": "Markers (first visit, medication)",
    "pensionPlanning.filters.wissen": "Clear",
    "pensionPlanning.filters.periode": "Period",
    "pensionPlanning.filters.van": "From",
    "pensionPlanning.filters.tm": "to",
    "pensionPlanning.filters.tot": "Until",
    "pensionPlanning.filters.diersoort": "Species",
    "pensionPlanning.filters.accommodatie": "Accommodation",
    "pensionPlanning.filters.status": "Status",
    "pensionPlanning.filters.extra": "More filters",
    "pensionPlanning.diersoort.alles": "All",
    "pensionPlanning.status.GERESERVEERD": "Booked",
    "pensionPlanning.status.INGECHECKT": "Checked in",
    "pensionPlanning.status.UITGECHECKT": "Checked out",
    "pensionPlanning.status.GEBLOKKEERD": "Blocked",
    "pensionPlanning.extra.eersteBezoek": "First visit only",
    "pensionPlanning.extra.luxe": "Luxury suite booked only",
    "pensionPlanning.extra.nogTePlaatsen": "Still to place only",
    "pensionPlanning.vandaag": "Today",
    "pensionPlanning.periode.wijzigen": "Change period",
    "pensionPlanning.vorige": "Previous period",
    "pensionPlanning.volgende": "Next period",
    "pensionPlanning.weergave.aria": "View",
    "pensionPlanning.weergave.1": "Day",
    "pensionPlanning.weergave.7": "Week",
    "pensionPlanning.weergave.14": "2 weeks",
    "pensionPlanning.weergave.31": "Month",
    "pensionPlanning.bord.aria": "Kennel planning per kennel and day",
    "pensionPlanning.bord.kop": "Stay / Room",
    "pensionPlanning.bord.leeg": "This location has no kennels.",
    "pensionPlanning.bord.geenGroep": "No group",
    "pensionPlanning.blokkade.ONDERHOUD": "Maintenance",
    "pensionPlanning.blokkade.GEBLOKKEERD": "Blocked",
    "pensionPlanning.chip.eersteBezoek": "First visit",
    "pensionPlanning.chip.luxe": "Luxury suite",
    "pensionPlanning.nachten": "%d nights",
    "pensionPlanning.nogTePlaatsen.titel": "Still to place",
    "pensionPlanning.nogTePlaatsen.leeg": "Every animal in this period has a place.",
    "pensionPlanning.nogTePlaatsen.urgent": "Arrives today or is already here",
    "pensionPlanning.legenda.ingecheckt": "Checked in / present",
    "pensionPlanning.legenda.gereserveerd": "Booked",
    "pensionPlanning.legenda.uitgecheckt": "Checked out",
    "pensionPlanning.legenda.geblokkeerd": "Blocked / maintenance",
    "pensionPlanning.legenda.quarantaine": "Quarantine",
    "pensionPlanning.legenda.gezin": "Same owner / family",
    "pensionPlanning.legenda.eersteBezoek": "First visit",
    "pensionPlanning.bijgewerkt": "Last updated: %s",
    "pensionPlanning.verversen": "Refresh",
    "pensionPlanning.paneel.sluiten": "Close",
    "pensionPlanning.paneel.inGebruik": "In use",
    "pensionPlanning.paneel.vrij": "Available",
    "pensionPlanning.paneel.gereserveerd": "Booked",
    "pensionPlanning.paneel.uitgecheckt": "Checked out",
    "pensionPlanning.paneel.nietGeplaatst": "Not placed yet",
    "pensionPlanning.paneel.geblokkeerd": "Blocked",
    "pensionPlanning.paneel.dieren": "%d animals",
    "pensionPlanning.paneel.bewoners": "Residents",
    "pensionPlanning.paneel.eigenaar": "Owner",
    "pensionPlanning.paneel.periode": "Booked period",
    "pensionPlanning.paneel.ingecheckt": "Checked in on %s",
    "pensionPlanning.paneel.dagenAanwezig": "(%d days)",
    "pensionPlanning.paneel.geboekt": "Booked accommodation",
    "pensionPlanning.paneel.geboektUitleg": "The rate on the booking.",
    "pensionPlanning.paneel.geplaatstIn": "Actually placed in",
    "pensionPlanning.paneel.kiesHok": "Choose a kennel",
    "pensionPlanning.tip.voorstel": "%s suits best",
    "pensionPlanning.tip.plaats": "Place here",
    "pensionPlanning.tip.geen": "No suitable stay is free in this period.",
    "pensionPlanning.paneel.profiel": "Group profile / notes",
    "pensionPlanning.paneel.geenNotities": "No notes.",
    "pensionPlanning.paneel.arrangementen": "Packages / care",
    "pensionPlanning.paneel.geenArrangementen": "No packages.",
    "pensionPlanning.paneel.details": "Open details",
    "pensionPlanning.paneel.verplaatsen": "Move",
    "pensionPlanning.paneel.groepsmatch": "Group match",
    "pensionPlanning.paneel.uitHok": "Remove from kennel",
    "pensionPlanning.paneel.mislukt": "That did not work. Please try again.",
    "pensionPlanning.paneel.nuInHok": "In this kennel during this period",
    "pensionPlanning.paneel.leegHok": "Nobody is here during this period.",
    "pensionPlanning.paneel.instellingen": "Settings",
    "pensionPlanning.paneel.capaciteit": "Capacity",
    "pensionPlanning.paneel.capaciteitStandaard": "default",
    "pensionPlanning.paneel.opslaan": "Save",
    "pensionPlanning.paneel.blokkades": "Blocks",
    "pensionPlanning.paneel.geenBlokkades": "No blocks in this period.",
    "pensionPlanning.paneel.opheffen": "Lift",
    "pensionPlanning.paneel.blokkeren": "Block kennel",
    "pensionPlanning.paneel.soort": "Type",
    "pensionPlanning.paneel.omschrijving": "Description",
    "pensionPlanning.match.titel": "Group match for %s",
    "pensionPlanning.match.hokTitel": "Who fits in %s",
    "pensionPlanning.match.geen": "No suitable kennel is free in this period.",
    "pensionPlanning.match.geenDieren": "Nobody fits here.",
    "pensionPlanning.match.plaatsen": "Place",
    "pensionPlanning.match.plaatsenIn": "Place in %s",
    "pensionPlanning.match.plaatsDier": "Place %s",
    "pensionPlanning.match.reden.luxe": "Luxury booked",
    "pensionPlanning.match.reden.gezin": "With own family",
    "pensionPlanning.match.reden.leeg": "Has the kennel to itself",
    "pensionPlanning.match.reden.accommodatie": "Different accommodation than booked",
    "pensionPlanning.match.reden.ruimte": "%d of %d places free",
    "pensionPlanning.verplaatsen.titel": "Move %s",
    "pensionPlanning.verplaatsen.vol": "Does not fit",
    "pensionPlanning.filters.zonderType": "No accommodation type",
    "pensionPlanning.filters.beheren": "Manage accommodations",
    "pensionPlanning.beheer.titel": "Accommodation types and price calculation",
    "pensionPlanning.kpi.bezetting": "%s occupancy",
    "pensionPlanning.legenda.medicatie": "Medication",
    "pensionPlanning.chip.medicatie": "Medication",
    "pensionPlanning.paneel.accommodatie": "Accommodation type",
    "pensionPlanning.paneel.accommodatieAfgeleid": "derived from the group name",
    "pensionPlanning.paneel.prijsDag": "%s per day",
    "pensionPlanning.paneel.prijsToeslag": "+ %s per day surcharge",
    "pensionAccommodatie.types.titel": "Accommodation types",
    "pensionAccommodatie.algemeen.titel": "General",
    "pensionAccommodatie.omschrijving.uitleg": "What the stay is; shown in the New reservation wizard.",
    "pensionAccommodatie.ruimtes.titel": "Stays of this type",
    "pensionAccommodatie.ruimtes.uitleg": "%d stays in total for %s, spread over the areas below.",
    "pensionAccommodatie.ruimtes.aantal": "Number of stays",
    "pensionAccommodatie.ruimtes.aantalVan": "Number of stays in %s",
    "pensionAccommodatie.ruimtes.verblijven": "stays",
    "pensionAccommodatie.ruimtes.bijwerken": "Update",
    "pensionAccommodatie.ruimtes.nieuweNaam": "New area",
    "pensionAccommodatie.ruimtes.toevoegen": "Add area",
    "pensionAccommodatie.ruimtes.nieuwUitleg": "An area \"%s\" is created with this number of stays, numbered from 1.",
    "pensionAccommodatie.ruimtes.bewaard": "The stays have been updated.",
    "pensionAccommodatie.ruimtes.inGebruik": "A stay that would be removed has been used before; it stays. Choose a higher number.",
    "pensionAccommodatie.model.titel": "Capacity model",
    "pensionAccommodatie.model.PER_DIER": "One stay per animal",
    "pensionAccommodatie.model.PER_DIER.uitleg": "Each animal gets its own stay. Capacity is counted per animal.",
    "pensionAccommodatie.model.PER_DIER.telt": "In this type capacity is counted per animal.",
    "pensionAccommodatie.model.PER_RESERVERING": "One stay per reservation",
    "pensionAccommodatie.model.PER_RESERVERING.uitleg": "%s from the same reservation share one stay. Capacity is counted per reservation.",
    "pensionAccommodatie.model.PER_RESERVERING.telt": "In this type capacity is counted per reservation, not per animal.",
    "pensionAccommodatie.model.GROEP": "Group stay",
    "pensionAccommodatie.model.GROEP.uitleg": "Several %s, also from different reservations, share one stay. Capacity is counted per group.",
    "pensionAccommodatie.model.GROEP.telt": "In this type capacity is counted per group; animals from different reservations may share it.",
    "pensionAccommodatie.regels.titel": "Rules within this model",
    "pensionAccommodatie.regels.max": "Max. %s in one stay",
    "pensionAccommodatie.regels.min": "Minimum number of %s",
    "pensionAccommodatie.regels.buffer": "Buffer after departure",
    "pensionAccommodatie.regels.buffer.geen": "No buffer",
    "pensionAccommodatie.regels.buffer.minuten": "%d minutes",
    "pensionAccommodatie.regels.delen": "Share stays between different reservations",
    "pensionAccommodatie.regels.zelfdeEigenaar": "Only %s of the same owner",
    "pensionAccommodatie.regels.voorkeur": "Preferred stay in automatic planning",
    "pensionAccommodatie.regels.actief": "Active",
    "pensionAccommodatie.regels.schoonmaak": "Automatic cleaning block after departure",
    "pensionAccommodatie.plaatsing.titel": "Placement rules",
    "pensionAccommodatie.plaatsing.uitleg": "What counts when several animals share one stay.",
    "pensionAccommodatie.plaatsing.geslacht": "Take sex into account",
    "pensionAccommodatie.plaatsing.castratie": "Take neutering into account",
    "pensionAccommodatie.plaatsing.formaat": "Take size into account",
    "pensionAccommodatie.plaatsing.leeftijd": "Take age into account",
    "pensionAccommodatie.plaatsing.sociaal": "Only socially suitable animals",
    "pensionAccommodatie.plaatsing.goedkeuring": "Manual approval required",
    "pensionAccommodatie.voorbeeld.titel": "Capacity example",
    "pensionAccommodatie.voorbeeld.situatie": "Situation",
    "pensionAccommodatie.voorbeeld.bezet": "Stays occupied",
    "pensionAccommodatie.voorbeeld.een": "1 %s from reservation A",
    "pensionAccommodatie.voorbeeld.drie": "3 %s from reservation A",
    "pensionAccommodatie.voorbeeld.twee": "2 %s from reservation A + 1 from reservation B",
    "pensionAccommodatie.voorbeeld.ruimtes": "%d occupied",
    "pensionAccommodatie.samenvatting.titel": "Capacity summary",
    "pensionAccommodatie.samenvatting.teltOp": "Capacity counts",
    "pensionAccommodatie.samenvatting.PER_DIER": "Per animal",
    "pensionAccommodatie.samenvatting.PER_RESERVERING": "Per reservation",
    "pensionAccommodatie.samenvatting.GROEP": "Per group",
    "pensionAccommodatie.samenvatting.max": "Max. %s per stay",
    "pensionAccommodatie.samenvatting.geenGrens": "No limit",
    "pensionAccommodatie.samenvatting.samen": "Sharing",
    "pensionAccommodatie.samenvatting.nooit": "Never shared",
    "pensionAccommodatie.samenvatting.zelfdeReservering": "Same reservation only",
    "pensionAccommodatie.samenvatting.ookAndere": "Other reservations too",
    "pensionAccommodatie.notities.titel": "Internal notes",
    "pensionAccommodatie.notities.uitleg": "For staff only; not shown in the wizard or on the confirmation.",
    "pensionAccommodatie.types.uitleg": "Per species the stays there are: which types, in which areas and how many. Change the number here or add a type.",
    "pensionAccommodatie.overzicht.overig": "No species",
    "pensionAccommodatie.overzicht.eenVerblijf": "1 stay",
    "pensionAccommodatie.overzicht.verblijven": "%d stays",
    "pensionAccommodatie.overzicht.typeToevoegen": "Add type",
    "pensionAccommodatie.overzicht.typeToevoegenVoor": "Add type for %s",
    "pensionAccommodatie.overzicht.leegSoort": "No stays for %s yet. Add a type to create them.",
    "pensionAccommodatie.overzicht.geenVerblijven": "No stays of this type yet.",
    "pensionAccommodatie.overzicht.verblijvenToevoegen": "Add stays",
    "pensionAccommodatie.overzicht.los.titel": "Not linked to a type yet",
    "pensionAccommodatie.overzicht.los.uitleg": "These areas are in the planning but belong to no accommodation type yet. Link them so they count.",
    "pensionAccommodatie.overzicht.los.koppelVan": "Link %s to a type",
    "pensionAccommodatie.overzicht.los.kies": "Link to type…",
    "pensionAccommodatie.overzicht.ruimteToevoegen": "Add area",
    "pensionAccommodatie.overzicht.ruimteToevoegenVoor": "Add area for %s",
    "pensionAccommodatie.overzicht.ruimteBijType": "Add area to %s",
    "pensionAccommodatie.overzicht.eerstEenType": "Add a type first; an area always belongs to a type.",
    "pensionAccommodatie.overzicht.type": "Type",
    "pensionAccommodatie.overzicht.automatisch": "automatic",
    "pensionAccommodatie.overzicht.automatischUitleg": "Not set: the planning picks this type from the area's name. Updating makes it fixed.",
    "pensionAccommodatie.types.leeg": "No accommodation types yet.",
    "pensionAccommodatie.nieuw": "New type",
    "pensionAccommodatie.bewerken": "Edit %s",
    "pensionAccommodatie.verwijderen.knop": "Delete %s",
    "pensionAccommodatie.verwijderen.vraag": "Delete accommodation type '%s'? Groups with this type fall back to the type matching their name.",
    "pensionAccommodatie.luxe": "Luxury",
    "pensionAccommodatie.quarantaine": "Quarantine",
    "pensionAccommodatie.geenDagprijs": "No day price yet",
    "pensionAccommodatie.perDag": "%s per day",
    "pensionAccommodatie.toeslagPerDag": "+ %s per day surcharge",
    "pensionAccommodatie.opgeslagen": "Saved",
    "pensionAccommodatie.prijzenBijTarieven": "Prices are set under Products › Boarding rates, tab Accommodations. Whether that is a day price or a surcharge is chosen under Settings › Boarding › Price calculation.",
    "pensionPrijsberekening.titel": "Price calculation",
    "pensionBenaming.titel": "Name",
    "pensionBenaming.laden": "The name setting could not be loaded.",
    "pensionBenaming.alleenLezen": "Only a boarding administrator can change the name.",
    "pensionBenaming.fout": "Saving failed. Please try again.",
    "pensionBenaming.opgeslagen": "Saved.",
    "pensionPrijsberekening.uitleg": "How this location calculates the price of a stay.",
    "pensionPrijsberekening.PENSIONPRIJZEN": "Boarding prices",
    "pensionPrijsberekening.PENSIONPRIJZEN.uitleg": "The animal's rate as it is in the system now. The price of an accommodation type is a surcharge per day on top of it, for example for a luxury suite.",
    "pensionPrijsberekening.ACCOMMODATIE": "Day prices per accommodation",
    "pensionPrijsberekening.ACCOMMODATIE.uitleg": "Every accommodation type has its own day price in low and high season, such as a comfort room and a luxury suite.",
    "pensionPrijsberekening.gratisTot": "Check-out free until",
    "pensionPrijsberekening.halveDagTot": "Half day until",
    "pensionPrijsberekening.halveDagOngeldig": "The half day must end after the free check-out time.",
    "pensionPrijsberekening.incheckdag": "The check-in day counts in full",
    "pensionPrijsberekening.prijzen": "The prices themselves are set under Products › Boarding rates; discounts, such as on the second animal, on the Discounts tab there.",
    "pensionPrijsberekening.later": "New bookings use this; existing bookings do not change.",
    "pensionPrijsberekening.alleenLezen": "Only a boarding administrator can change the price calculation.",
    "pensionPrijsberekening.laden": "The price calculation could not be loaded.",
    "pensionPrijsberekening.fout": "Saving failed. Please try again.",
    "pensionPrijsberekening.opgeslagen": "Saved",
    "pensionAccommodatie.fout.bestaat": "There is already a type with this name for this species.",
    "pensionAccommodatie.fout.geenRecht": "You are not allowed to manage accommodations.",
    "pensionAccommodatie.fout.ongeldig": "Check the details: name, colour and logo.",
    "pensionAccommodatie.fout.mislukt": "Saving failed. Please try again.",
    "pensionAccommodatie.fout.laden": "The accommodation types could not be loaded.",
    "pensionAccommodatie.fout.logo": "Choose a PNG, JPEG, WebP, GIF or SVG file of at most 150 kB.",
    "pensionAccommodatie.veld.naam": "Name",
    "pensionAccommodatie.veld.diersoort": "Species",
    "pensionAccommodatie.veld.kleur": "Colour",
    "pensionAccommodatie.veld.icoon": "Icon",
    "pensionAccommodatie.icoon.home": "Kennel",
    "pensionAccommodatie.icoon.crown": "Luxury",
    "pensionAccommodatie.icoon.gem": "Suite",
    "pensionAccommodatie.icoon.star": "Star",
    "pensionAccommodatie.icoon.sparkles": "Pampering",
    "pensionAccommodatie.icoon.bed": "Bed",
    "pensionAccommodatie.icoon.bed-double": "Double bed",
    "pensionAccommodatie.icoon.bed-single": "Single bed",
    "pensionAccommodatie.icoon.building": "Building",
    "pensionAccommodatie.icoon.warehouse": "Shed",
    "pensionAccommodatie.icoon.tent": "Tent",
    "pensionAccommodatie.icoon.house": "House",
    "pensionAccommodatie.icoon.house-plus": "House plus",
    "pensionAccommodatie.icoon.trees": "Outdoors",
    "pensionAccommodatie.icoon.sun": "Sunny",
    "pensionAccommodatie.icoon.door-open": "Open pen",
    "pensionAccommodatie.icoon.door-closed": "Closed pen",
    "pensionAccommodatie.icoon.lock": "Locked",
    "pensionAccommodatie.icoon.siren": "Isolation",
    "pensionAccommodatie.icoon.alert-triangle": "Quarantine",
    "pensionAccommodatie.icoon.cat": "Cat",
    "pensionAccommodatie.icoon.cat-2": "Cat room",
    "pensionAccommodatie.icoon.dog": "Dog",
    "pensionAccommodatie.icoon.dog-2": "Dog room",
    "pensionAccommodatie.icoon.bird": "Bird",
    "pensionAccommodatie.icoon.rabbit": "Rabbit",
    "pensionAccommodatie.icoon.gamepad": "Play pen",
    "pensionAccommodatie.icoon.wrench": "Maintenance",
    "pensionAccommodatie.icoon.paw-print": "General",
    "pensionAccommodatie.veld.logo": "Own logo",
    "pensionAccommodatie.veld.luxe": "Luxury (group match prefers luxury bookings here)",
    "pensionAccommodatie.veld.quarantaine": "Quarantine (group match never places here by itself)",
    "pensionAccommodatie.logo.kies": "Upload own logo",
    "pensionAccommodatie.logo.weg": "Remove logo",
    "pensionAccommodatie.logo.uitleg": "PNG, JPEG, WebP, GIF or SVG, at most 150 kB. A logo takes precedence over the icon.",
    "pensionAccommodatie.alleenLezen": "Only a boarding administrator can change accommodation types.",
    // Werkmodus Pension — the customer screen: the customer's own animals, their bookings and what
    // today's drop-off needs (medication, feeding, warnings).
    "pensionKlant.galerij": "Boarding — customer screen",
    "pensionKlant.chip.actief": "Active customer",
    "pensionKlant.chip.bijzonderheden": "Notes on file",
    "pensionKlant.chip.inactief": "Inactive customer",
    "pensionKlant.dieren.zoek": "Search animals…",
    "dierCreate.titel": "New animal",
    "dierCreate.naam": "Name",
    "dierCreate.diersoort": "Species",
    "dierCreate.ras": "Breed",
    "dierCreate.geslacht": "Sex",
    "dierCreate.gecastreerd": "Neutered",
    "dierCreate.geboortedatum": "Date of birth",
    "dierCreate.chip": "Chip number",
    "dierCreate.kies": "Choose…",
    "dierCreate.onbekend": "Unknown",
    "dierCreate.mannelijk": "Male",
    "dierCreate.vrouwelijk": "Female",
    "dierCreate.melding.verplicht": "Name and species are required.",
    "dierCreate.melding.chip": "A chip number is exactly 15 digits.",
    "dierCreate.melding.verboden": "You are not allowed to create animals.",
    "dierCreate.melding.fout": "Could not save the animal.",
    "pensionKlant.dieren.nieuwDier": "New animal",
    "pensionKlant.dieren.geenTreffer": "No animal matches this search.",
    "pensionKlant.dieren.bezoek": "Visit %d",
    "pensionKlant.dieren.eersteBezoek": "First visit",
    "pensionKlant.dieren.jaar": "%d years",
    "pensionKlant.dieren.maanden": "%d months",
    "pensionKlant.dier.bewerken": "Edit animal",
    "pensionKlant.actie.bewerken": "Edit",
    "pensionKlant.contact.noodcontact": "Emergency contact",
    "pensionKlant.contact.geenNoodcontact": "Not recorded",
    "pensionKlant.contact.email": "E-mail",
    "pensionKlant.kpi.dieren": "Animals",
    "pensionKlant.kpi.openstaand": "Outstanding",
    "pensionKlant.melding.waarschuwing.een": "One animal has notes worth reading before drop-off.",
    "pensionKlant.melding.waarschuwing.meer": "%d animals have notes worth reading before drop-off.",
    "pensionKlant.dieren.geen": "This customer has no animals registered.",
    "pensionKlant.laadFout": "The animals and bookings of this customer could not be loaded.",
    "pensionKlant.kop.aria": "Customer",
    "pensionKlant.tabs.aria": "Customer sections",
    "pensionKlant.tab.relatie": "Customer",
    "pensionKlant.tab.dieren": "Animals",
    "pensionKlant.tab.pension": "Boarding",
    "pensionKlant.tab.dagopvang": "Day care",
    "pensionKlant.tab.reserveringen": "Bookings",
    "pensionKlant.tab.facturen": "Invoices",
    "pensionKlant.tab.notities": "Notes",
    "pensionKlant.tab.geschiedenis": "History",
    "pensionKlant.facturen.totalenAria": "Invoice totals",
    "pensionKlant.facturen.zoek": "Search invoice number",
    "pensionKlant.facturen.wisFilters": "Clear filters",
    "pensionKlant.facturen.geenGevonden": "No invoices match.",
    "pensionKlant.facturen.onderdeel": "Department",
    "pensionKlant.facturen.zoekStatus": "Search status...",
    "pensionKlant.facturen.geenStatus": "No status matches.",
    "pensionKlant.facturen.zoekOnderdeel": "Search department...",
    "pensionKlant.facturen.geenOnderdeel": "No department matches.",
    "pensionKlant.facturen.vestiging": "Branch",
    "pensionKlant.facturen.betaald": "Paid",
    "pensionKlant.facturen.openstaand": "Outstanding",
    "pensionKlant.facturen.openAria": "Open invoice %s",
    "pensionKlant.relatie.asielverblijven": "Shelter stays",
    "pensionKlant.blad.laadFout": "Could not load this.",
    "pensionKlant.blad.opnieuw": "Try again",
    "pensionKlant.blad.minder": "Show less",
    "pensionKlant.blad.meer": "Show more",
    "pensionKlant.blad.alle": "Show all %s",
    "pensionKlant.blad.verberg": "Hide",
    "pensionKlant.blad.toon": "Show",
    "pensionKlant.pension.geen": "This customer has no boarding stays yet.",
    "pensionKlant.res.titel": "Booking %s",
    "pensionKlant.res.bewerk.dierIngecheckt": "You cannot remove an animal from a checked-in booking.",
    "pensionKlant.res.bewerk.laatsteDier": "At least one animal has to stay on the booking.",
    "pensionKlant.res.terugdraaien.bevestig": "Undo cancellation",
    "pensionKlant.res.terugdraaien.uitleg": "The booking is confirmed again afterwards.",
    "pensionKlant.res.terugdraaien.titel": "Undo cancellation of %s",
    "pensionKlant.res.annuleren.mislukt": "That did not work. The booking may have changed or been checked in meanwhile; it has been refreshed.",
    "pensionKlant.res.annuleren.terug": "Back",
    "pensionKlant.res.annuleren.bevestig": "Cancel booking",
    "pensionKlant.res.annuleren.reden": "Reason (added as a note on the booking)",
    "pensionKlant.res.annuleren.uitleg": "The booking gets the status Cancelled. An invoice stays as it is.",
    "pensionKlant.res.annuleren.titel": "Cancel booking %s",
    "pensionKlant.res.menu.kanNietIngecheckt": "A checked-in booking cannot be cancelled.",
    "pensionKlant.res.menu.terugdraaien": "Undo cancellation",
    "pensionKlant.res.menu.annuleren": "Cancel booking",
    "pensionKlant.res.bewerk.voorVan": "Who %s is for",
    "pensionKlant.res.bewerk.geenDierenOver": "All animals of this customer are already on the booking.",
    "pensionKlant.res.bewerk.dierKiezenUitleg": "Choose one of this customer's animals. It is added to the booking when you save.",
    "pensionKlant.res.bewerk.dierKiezen": "Add an animal",
    "pensionKlant.res.bewerk.dierZoeken": "Search for an animal...",
    "pensionKlant.res.bewerk.geenDierGevonden": "No animal found.",
    "pensionKlant.res.bewerk.nieuw": "New",
    "pensionKlant.res.bewerk.klitvrijVan": "Coat mat-free: %s",
    "pensionKlant.res.bewerk.kortingVan": "Discount of %s",
    "pensionKlant.res.bewerk.btwVan": "VAT of %s",
    "pensionKlant.res.bewerk.aantalVan": "Quantity of %s",
    "pensionKlant.res.bewerk.prijsVan": "Price of %s",
    "pensionKlant.res.bewerk.naamVan": "Description of %s",
    "pensionKlant.res.bewerk.totDatum": "To (booked)",
    "pensionKlant.res.bewerk.vanDatum": "From (booked)",
    "pensionKlant.res.bewerk.terugzetten": "Restore",
    "pensionKlant.res.bewerk.kanNiet": "A cancelled booking cannot be edited.",
    "pensionKlant.res.bewerk.ongeldig": "Check the period and the amounts: the end cannot be before the start, amounts cannot be negative, and every product needs a description.",
    "pensionKlant.res.bewerk.mislukt": "Saving did not work. Please try again.",
    "pensionKlant.res.bewerk.conflict": "Someone else changed this booking in the meantime. The new details are shown now; please make your change again.",
    "pensionKlant.res.bewerk.annuleren": "Cancel",
    "pensionKlant.res.opslaan": "Save",
    "pensionKlant.res.doc.factuur": "Invoice",
    "pensionKlant.res.tagToevoegen": "Tag",
    "pensionKlant.res.tags.titel": "Tags on this booking",
    "pensionKlant.res.tags.geen": "No tags yet; create them under Settings › Tags.",
    "pensionKlant.res.tags.laadfout": "The tags could not be loaded.",
    "pensionKlant.res.tags.mislukt": "The tag could not be saved.",
    "pensionKlant.res.minderVerblijven": "Show fewer stays",
    "pensionKlant.res.alleVerblijven": "View all stays",
    "pensionKlant.res.nacht": "1 night",
    "pensionKlant.res.fin.ontvangen": "Received",
    "pensionKlant.res.fin.aanbetalingVereist": "Deposit required (%s)",
    "pensionKlant.res.fin.btwPercentage": "VAT (%s)",
    "pensionKlant.res.fin.kortingOverig": "Discount (other)",
    "pensionKlant.res.fin.klantkorting": "Customer discount",
    "pensionKlant.res.fin.subtotaal": "Subtotal",
    "pensionKlant.res.verblijfHoog": "%s, high season",
    "pensionKlant.res.verblijfCategorie": "Boarding %s",
    "pensionKlant.res.verblijfRegel": "Boarding stay",
    "pensionKlant.res.reserveringRegel": "Booking",
    "pensionKlant.res.verwijderRegel": "Delete line",
    "pensionKlant.res.bewerkRegel": "Edit line",
    "pensionKlant.res.kol.omschrijving": "Description",
    "pensionKlant.res.kol.dierReservering": "Animal / Booking",
    "pensionKlant.res.kol.acties": "Actions",
    "pensionKlant.res.kol.kennelKamer": "Kennel / Room",
    "pensionKlant.res.kol.geslacht": "Sex",
    "pensionKlant.res.kol.dierRas": "Animal / Breed",
    "pensionKlant.res.dierenAantal": "Animals (%s)",
    "pensionKlant.res.sig.geenActie": "No action needed",
    "pensionKlant.res.sig.geenBijzonderheden": "Nothing to note",
    "pensionKlant.res.sig.vereist": "%s required",
    "pensionKlant.res.sig.geldigTot": "Valid until %s",
    "pensionKlant.res.nietUitgecheckt": "Not checked out yet",
    "pensionKlant.res.uitgechecktOp": "Checked out on %s",
    "pensionKlant.res.ingechecktOp": "Checked in on %s",
    "pensionKlant.res.uitgechecktDoorOp": "Checked out by %s on %s",
    "pensionKlant.res.ingechecktDoorOp": "Checked in by %s on %s",
    "pensionKlant.res.baliOpmerking": "Desk note for the carer",
    "pensionKlant.res.duur": "Length of stay",
    "pensionKlant.res.tot": "To",
    "pensionKlant.res.van": "From",
    "pensionKlant.res.bevestigdOp": "Confirmed on %s",
    "pensionKlant.res.aangemaaktOp": "Created on %s",
    "pensionKlant.res.status.NIEUW": "New",
    "pensionKlant.res.status.BEVESTIGD": "Confirmed",
    "pensionKlant.res.status.AFGEROND": "Completed",
    "pensionKlant.res.status.GEANNULEERD": "Cancelled",
    "pensionKlant.res.status.ONBEKEND": "Unknown",
    "pensionKlant.res.eersteBezoek": "First visit",
    "pensionKlant.res.bezoek": "Visit %s",
    "pensionKlant.res.online": "Booked online",
    "pensionKlant.res.bewerken": "Edit",
    "pensionKlant.res.meer": "More actions",
    "pensionKlant.res.volgt": "Coming in a next step",
    "pensionKlant.res.verblijf": "Stay & check-in/out",
    "pensionKlant.res.gereserveerd": "Booked period",
    "pensionKlant.res.werkelijk": "Actual stay",
    "pensionKlant.res.dagdeel.VM": "AM",
    "pensionKlant.res.dagdeel.NM": "PM",
    "pensionKlant.res.dag": "1 day",
    "pensionKlant.res.dagen": "%s days",
    "pensionKlant.res.nietIngecheckt": "Not checked in yet",
    "pensionKlant.res.inchecken": "Check in",
    "pensionKlant.res.uitchecken": "Check out",
    "pensionKlant.res.checkin.titel.inchecken": "Check in %s",
    "pensionKlant.res.checkin.titel.uitchecken": "Check out %s",
    "pensionKlant.res.checkin.info.inchecken": "Who brings the animal, and what should the carers know?",
    "pensionKlant.res.checkin.info.uitchecken": "Who collects the animal, and what was handed over?",
    "pensionKlant.res.checkin.annuleren": "Cancel",
    "pensionKlant.res.checkin.mislukt": "That did not work. The booking may have changed in the meantime; it has been refreshed.",
    "pensionKlant.res.akkoord": "Customer accepted the terms",
    "pensionKlant.res.geschiedenis": "History",
    "pensionKlant.res.gesch.aangemaakt": "Booking created",
    "pensionKlant.res.gesch.bevestigd": "Confirmed",
    "pensionKlant.res.gesch.ingecheckt": "Checked in",
    "pensionKlant.res.gesch.uitgecheckt": "Checked out",
    "pensionKlant.res.gesch.geannuleerd": "Cancelled",
    "pensionKlant.res.gesch.door": "by %s",
    "pensionKlant.res.gesch.naar": "to %s",
    "pensionKlant.res.gesch.soort.EMAIL": "Email",
    "pensionKlant.res.gesch.soort.BRIEF": "Letter",
    "pensionKlant.res.gesch.soort.AFDRUK": "Print",
    "pensionKlant.res.gesch.soort.SMS": "Text message",
    "pensionKlant.res.gesch.soort.overig": "Sent",
    "pensionKlant.res.gesch.uitleg": "These are the moments stored on the booking itself. Changes in between are not recorded.",
    "pensionKlant.res.reserveringsproducten": "Booking products",
    "pensionKlant.res.beheren": "Manage",
    "pensionKlant.res.geenReserveringsproducten": "No products on this booking.",
    "pensionKlant.res.respro.afgesloten": "Taken out",
    "pensionKlant.res.respro.toegevoegd": "Added",
    "pensionKlant.res.dier.hierPlaatsen": "Place in %s",
    "pensionKlant.res.dier.hierheenVerplaatsen": "Move to %s",
    "pensionKlant.res.dier.hierKort": "place here",
    "pensionKlant.res.dier.hierheenKort": "move here",
    "pensionKlant.res.verblijfKort": "Stay",
    "pensionKlant.res.aankomst": "Arrival",
    "pensionKlant.res.vertrek": "Departure",
    "pensionKlant.res.dagdeelUit.VM": "morning",
    "pensionKlant.res.dagdeelUit.NM": "afternoon",
    "pensionKlant.res.verblijvenOpenen": "View all stays",
    "pensionKlant.res.kern.klant": "Customer",
    "pensionKlant.res.kern.verblijf": "Stay",
    "pensionKlant.res.kern.dieren": "Animals",
    "pensionKlant.res.kern.eenDier": "1 animal",
    "pensionKlant.res.kern.aantalDieren": "%s animals",
    "pensionKlant.res.kern.totaal": "Total amount",
    "pensionKlant.res.kern.aandachtEen": "1 point of attention",
    "pensionKlant.res.kern.aandacht": "%s points of attention",
    "pensionKlant.res.kern.geenAandacht": "Nothing needs attention",
    "pensionKlant.res.signalen": "Signals",
    "pensionKlant.res.sig.enting.inOrde": "Vaccinations OK",
    "pensionKlant.res.sig.enting.verlopen": "Vaccinations expired",
    "pensionKlant.res.sig.enting.binnenkort": "Vaccinations expire soon",
    "pensionKlant.res.sig.enting.onbekend": "Vaccinations unknown",
    "pensionKlant.res.sig.open": "%s outstanding",
    "pensionKlant.res.sig.vanTotaal": "of %s",
    "pensionKlant.res.sig.betaald": "Paid",
    "pensionKlant.res.sig.geenBedrag": "No amount yet",
    "pensionKlant.res.sig.aanbetaling.OPEN": "Deposit due",
    "pensionKlant.res.sig.aanbetaling.VERLOPEN": "Deposit overdue",
    "pensionKlant.res.sig.aanbetaling.VOLDAAN": "Deposit received",
    "pensionKlant.res.sig.uiterlijk": "by %s",
    "pensionKlant.res.sig.receptie": "For reception",
    "pensionKlant.res.sig.actie": "Action needed",
    "pensionKlant.res.sig.geenKennel": "%s: no kennel yet",
    "pensionKlant.res.sig.voorwaarden": "Terms not accepted",
    "pensionKlant.res.sig.luxe": "Luxury suite booked",
    "pensionKlant.res.dieren": "Animals",
    "pensionKlant.res.dierToevoegen": "Add animal to this booking",
    "pensionKlant.res.geenDieren": "No animals on this booking.",
    "pensionKlant.res.kol.foto": "Photo",
    "pensionKlant.res.kol.naam": "Name",
    "pensionKlant.res.kol.startgewicht": "Start weight",
    "pensionKlant.res.kol.huidigGewicht": "Current weight",
    "pensionKlant.res.kol.verblijf": "Stay",
    "pensionKlant.res.kol.entingen": "Vaccinations",
    "pensionKlant.res.kol.klitvrij": "Coat mat-free",
    "pensionKlant.res.kol.tags": "Tags",
    "pensionKlant.res.kol.aantal": "Qty",
    "pensionKlant.res.dier.instellingen": "Animal settings",
    "pensionKlant.res.dier.instellingenVan": "Settings for %s on this booking",
    "pensionKlant.res.kol.arrangementen": "Packages",
    "pensionKlant.res.kol.productDienst": "Product / service",
    "pensionKlant.res.wijzigen": "Edit",
    "pensionKlant.res.kol.arrangement": "Package",
    "pensionKlant.res.dier.boeking": "Booking",
    "pensionKlant.res.bekijkDier": "View animal",
    "pensionKlant.res.bekijkDierVan": "View %s",
    "pensionKlant.res.klitvrijJa": "Mat-free",
    "pensionKlant.res.klitvrijNee": "Not checked for mats",
    "pensionKlant.res.kol.prijs": "Price",
    "pensionKlant.res.kol.korting": "Discount",
    "pensionKlant.res.kol.btw": "VAT",
    "pensionKlant.res.kol.totaal": "Total",
    "pensionKlant.res.bekijk": "View",
    "pensionKlant.res.bekijkAria": "View %s",
    "pensionKlant.res.geenKennel": "Not assigned",
    "pensionKlant.res.dier.titel": "%s in this booking",
    "pensionKlant.res.dier.bekijkAria": "Show what is booked for this animal",
    "pensionKlant.res.dier.naarDier": "To the animal",
    "pensionKlant.res.dier.verblijf": "Stay",
    "pensionKlant.res.dier.periode": "Period",
    "pensionKlant.res.dier.dagen": "Days",
    "pensionKlant.res.dier.tarief": "Rate",
    "pensionKlant.res.dier.dagprijs": "Day rate",
    "pensionKlant.res.dier.hoogseizoen": "High season",
    "pensionKlant.res.dier.maal": "%d × %s",
    "pensionKlant.res.dier.toeslag": "Surcharge",
    "pensionKlant.res.dier.korting": "Discount",
    "pensionKlant.res.dier.verblijfkosten": "Stay total",
    "pensionKlant.res.dier.kennel": "Kennel",
    "pensionKlant.res.dier.kennelUitleg": "Assign a kennel in the kennel planning.",
    "pensionKlant.res.dier.advies.kop": "Kennel advice",
    "pensionKlant.res.dier.advies.plaats": "Place here",
    "pensionKlant.res.dier.advies.verplaats": "Show other kennels",
    "pensionKlant.res.dier.advies.ligtHier": "Is here now",
    "pensionKlant.res.dier.advies.geen": "No kennel fits this period.",
    "pensionKlant.res.dier.advies.fout": "Could not place the animal. Try again.",
    "pensionKlant.res.dier.advies.strookAria": "Occupancy during this booking",
    "pensionKlant.res.dier.advies.vrij": "free",
    "pensionKlant.res.dier.advies.reden.HUIDIG_HOK": "Already here",
    "pensionKlant.res.dier.advies.reden.VRIJ": "Free for the whole stay",
    "pensionKlant.res.dier.advies.reden.ZELFDE_ALS_VORIGE_KEER": "Same kennel as last time",
    "pensionKlant.res.dier.advies.reden.SAMEN_MET": "Together with %s",
    "pensionKlant.res.dier.advies.reden.GEBOEKTE_ACCOMMODATIE": "Booked as %s",
    "pensionKlant.res.dier.advies.reden.JUISTE_DIERSOORT": "For %s",
    "pensionKlant.res.dier.advies.reden.GEEN_DIERSOORT": "No species set",
    "pensionKlant.res.dier.advies.reden.DEELS_BEZET": "Partly occupied",
    "pensionKlant.res.dier.advies.reden.MOET_ALLEEN": "Must be alone",
    "pensionKlant.res.dier.geboekt": "Packages & extra products",
    "pensionKlant.res.dier.geenProducten": "Nothing else booked for this animal.",
    "pensionKlant.res.dier.verzorging": "Care",
    "pensionKlant.res.dier.voorstel": "AI placement suggestion",
    "pensionKlant.res.dier.aiAdvies": "AI advice",
    "pensionKlant.res.dier.tarieven": "Rates",
    "pensionKlant.res.dier.reservering": "Booking details",
    "pensionKlant.res.dier.status": "Status",
    "pensionKlant.res.dier.nummer": "Booking number",
    "pensionKlant.res.dier.gemaaktOp": "Created on",
    "pensionKlant.res.dier.door": "By",
    "pensionKlant.res.dier.online": "Booked online",
    "pensionKlant.res.dier.klant": "Customer",
    "pensionKlant.res.dier.opmerkingKlant": "Customer note",
    "pensionKlant.res.dier.opmerkingen": "Notes",
    "pensionKlant.res.dier.pensionverblijf": "Boarding stay",
    "pensionKlant.res.dier.dagenMaal": "%d × %s",
    "pensionKlant.res.dier.totaal": "Total",
    "pensionKlant.res.dier.tarievenAanpassen": "Adjust",
    "pensionKlant.res.dier.kortingVeld": "Discount",
    "pensionKlant.res.dier.stukprijs": "Unit price",
    "pensionKlant.res.dier.aantal": "Quantity",
    "pensionKlant.res.dier.geboektPil": "Booked",
    "pensionKlant.res.dier.verzorgingElders": "Care details are on the animal card.",
    "pensionKlant.res.dier.vandaag": "Today",
    "pensionKlant.res.dier.eerder": "Earlier",
    "pensionKlant.res.dier.later": "Later",
    "pensionKlant.res.dier.dag": "Day",
    "pensionKlant.res.dier.week": "Week",
    "pensionKlant.res.dier.openPlanning": "Open in kennel planning",
    "pensionKlant.res.dier.plankjeAria": "Kennels during this booking",
    "pensionKlant.res.dier.zonderGroep": "Without a group",
    "pensionKlant.res.dier.geenHokken": "This branch has no kennels yet.",
    "pensionKlant.res.dier.meerHokken": "Show all kennels (%d more)",
    "pensionKlant.res.dier.minderHokken": "Just this kennel and its neighbours",
    "pensionKlant.res.dier.hierheen": "%s here",
    "pensionKlant.res.dier.blokkade.ONDERHOUD": "Maintenance",
    "pensionKlant.res.dier.blokkade.QUARANTAINE": "Quarantine",
    "pensionKlant.res.dier.blokkade.OVERIG": "Blocked",
    "pensionKlant.res.dier.advies.voorstelKop": "%s fits best. ",
    "pensionKlant.res.klitvrij": "Yes",
    "pensionKlant.res.nietGecontroleerd": "No",
    "pensionKlant.res.meerTags": "+%s",
    "pensionKlant.res.alleenInKennel": "Kennel only",
    "pensionKlant.res.sociaalGeval": "Social case",
    "pensionKlant.res.staat.verlopen": "Expired",
    "pensionKlant.res.staat.binnenkort": "Expires soon",
    "pensionKlant.res.staat.inOrde": "OK",
    "pensionKlant.res.staat.onbekend": "Unknown",
    "pensionKlant.res.producten": "Products and services",
    "pensionKlant.res.productToevoegen": "Add product",
    "pensionKlant.res.geenProducten": "No products or services.",
    "pensionKlant.res.financieel": "Financial summary",
    "pensionKlant.res.fin.exclBtw": "Total (excl. VAT)",
    "pensionKlant.res.fin.btw": "VAT",
    "pensionKlant.res.fin.totaal": "Total",
    "pensionKlant.res.fin.betaald": "Paid",
    "pensionKlant.res.fin.openstaand": "Outstanding",
    "pensionKlant.res.verblijven": "Earlier stays",
    "pensionKlant.res.verblijvenAria": "Choose a stay",
    "pensionKlant.res.bijzonderheden": "Notes & communication",
    "pensionKlant.res.aanvraag.titel": "From the booking wizard",
    "pensionKlant.res.aanvraag.concept": "Saved as draft",
    "pensionKlant.res.geenNotities": "No notes on this booking.",
    "pensionKlant.res.documenten": "Documents & actions",
    "pensionKlant.res.factuur": "Invoice %s",
    "pensionKlant.res.geenFactuur": "No invoice yet.",
    "pensionKlant.res.doc.bevestiging": "Confirmation",
    "pensionKlant.res.doc.overeenkomst": "Agreement",
    "pensionKlant.res.doc.voedingssticker": "Feeding label",
    "pensionKlant.res.doc.klantkaart": "Customer card",
    "pensionKlant.res.doc.whatsapp": "Send message (WhatsApp)",
    "pensionKlant.res.doc.email": "Send email",
    "pensionKlant.dagopvang.geen": "This customer does not use day care yet. Plan a day to get started.",
    "pensionKlant.dagopvang.contracten": "Contracts",
    "nieuweReservering.knop": "New booking",
    "nieuweReservering.knopBoeking": "New booking",
    "nieuweReservering.stap.verblijf": "Stay & care",
    "nieuweReservering.stap.arrangementen": "Packages & extras",
    "nieuweReservering.stap.keuzes": "Booking choices",
    "nieuweReservering.verblijf.periode": "Selected period",
    "nieuweReservering.verblijf.periodeAanpassen": "Change period",
    "nieuweReservering.verblijf.titel": "Stay & care",
    "nieuweReservering.verblijf.uitleg": "Choose the type of stay for each animal and fill in the care details.",
    "nieuweReservering.verblijf.verwijder": "Remove animal",
    "nieuweReservering.verblijf.verwijderAria": "Remove %s from the booking",
    "nieuweReservering.verblijf.inklappen": "Collapse %s",
    "nieuweReservering.verblijf.uitklappen": "Expand %s",
    "nieuweReservering.verblijf.type": "Type of stay",
    "nieuweReservering.verblijf.kiesType": "Choose a stay",
    "nieuweReservering.verblijf.tarief": "Rate",
    "nieuweReservering.verblijf.kiesTarief": "Rate of the animal",
    "nieuweReservering.verblijf.geenTarieven": "There are no boarding rates for this species yet. Set them in Products › Boarding rates.",
    "nieuweReservering.verblijf.tariefNodig": "%s has no daily price of its own yet: choose a rate.",
    "nieuweReservering.verblijf.kiesTariefNodig": "Choose a rate…",
    "nieuweReservering.verblijf.geenTypes": "There are no stay types for %s yet.",
    "nieuweReservering.verblijf.meerprijs": "Surcharge %s per day",
    "nieuweReservering.verblijf.prijsTitel": "Price of this stay",
    "nieuweReservering.verblijf.prijsUitTarief": "Pension rate of the animal",
    "nieuweReservering.verblijf.prijsUitAccommodatie": "Day price of the accommodation",
    "nieuweReservering.verblijf.prijsDagen": "%s days x %s",
    "nieuweReservering.verblijf.prijsDagenHoog": "%s high-season days x %s",
    "nieuweReservering.verblijf.prijsMeerprijs": "surcharge %s %s",
    "nieuweReservering.verblijf.prijsKalender": "%s for days with their own price",
    "nieuweReservering.verblijf.dagprijs": "%s per day",
    "nieuweReservering.verblijf.voeding": "Feeding",
    "nieuweReservering.verblijf.typeVoeding": "Type of food",
    "nieuweReservering.verblijf.voedingSTANDAARD": "Standard food",
    "nieuweReservering.verblijf.voedingEIGEN": "Brings own food",
    "nieuweReservering.verblijf.voedingPension": "Boarding food",
    "nieuweReservering.verblijf.voedingInstructies": "Feeding instructions",
    "nieuweReservering.verblijf.voedingPlaats": "E.g. brand, amount, frequency, particulars",
    "nieuweReservering.verblijf.medicatie": "Medication",
    "nieuweReservering.verblijf.medicatieNodig": "Medication needed?",
    "nieuweReservering.verblijf.medicatieInstructies": "Medication instructions",
    "nieuweReservering.verblijf.medicatiePlaats": "E.g. name of the medication, dose, times",
    "nieuweReservering.verblijf.verzorging": "Care",
    "nieuweReservering.verblijf.borstelen": "Brushing",
    "nieuweReservering.verblijf.wassen": "Wash before departure",
    "nieuweReservering.verblijf.samen": "Together with own family",
    "nieuweReservering.verblijf.nee": "No",
    "nieuweReservering.verblijf.ja": "Yes",
    "nieuweReservering.verblijf.jaGraag": "Yes, please",
    "nieuweReservering.verblijf.bijzonderheden": "Particulars",
    "nieuweReservering.verblijf.bijzonderhedenPlaats": "E.g. behaviour, extra attention, allergies, etc.",
    "nieuweReservering.verblijf.terug": "Back to period",
    "nieuweReservering.verblijf.volgende": "Next: Packages & extras",
    "nieuweReservering.som.titel": "Summary",
    "nieuweReservering.som.periode": "Period",
    "nieuweReservering.som.dieren": "Animals",
    "nieuweReservering.som.verblijven": "Stays",
    "nieuweReservering.som.geenVerblijf": "No stay chosen",
    "nieuweReservering.som.extras": "Packages & extras",
    "nieuweReservering.som.verzekering": "Booking options",
    "nieuweReservering.som.opbouw": "Price breakdown",
    "nieuweReservering.som.verblijf": "Stay",
    "nieuweReservering.som.totaal": "Total estimate",
    "nieuweReservering.som.totaalUitleg": "Incl. VAT, discounts are applied on approval",
    "nieuweReservering.som.naGoedkeuring": "After approval",
    "nieuweReservering.som.aanbetaling": "Deposit (%s%)",
    "nieuweReservering.keuzes.titel": "Booking options",
    "nieuweReservering.keuzes.uitleg": "Choose the remaining options for this booking.",
    "nieuweReservering.keuzes.verzekering": "Cancellation insurance",
    "nieuweReservering.keuzes.verzekeringUitleg": "Would the customer like cancellation insurance for this booking?",
    "nieuweReservering.keuzes.productUitleg": "Would you like %s for this reservation?",
    "nieuweReservering.keuzes.productJa": "Yes, add it",
    "nieuweReservering.keuzes.productNee": "No, thank you",
    "nieuweReservering.keuzes.verzekeringJa": "Yes, add cancellation insurance",
    "nieuweReservering.keuzes.verzekeringNee": "No, no cancellation insurance",
    "nieuweReservering.keuzes.wensen": "Other wishes",
    "nieuweReservering.keuzes.wensenUitleg": "Wishes of the customer for this booking.",
    "nieuweReservering.keuzes.wensenPlaats": "E.g. arrival later in the day, brings own basket",
    "nieuweReservering.keuzes.notitie": "Internal notes",
    "nieuweReservering.keuzes.notitieUitleg": "Only visible to staff.",
    "nieuweReservering.keuzes.notitiePlaats": "Notes for colleagues",
    "nieuweReservering.keuzes.info": "The booking is created as a request. The customer receives a confirmation once the boarding has approved it.",
    "nieuweReservering.keuzes.terug": "Back to packages",
    "nieuweReservering.keuzes.volgende": "Next: Check & create",
    "nieuweReservering.controle.titel": "Check & create",
    "nieuweReservering.controle.uitleg": "Check the details and create the booking request.",
    "nieuweReservering.controle.wijzig": "Change",
    "nieuweReservering.controle.wijzigAria": "Change %s",
    "nieuweReservering.controle.dieren": "Animals & stays",
    "nieuweReservering.controle.verblijf": "Stay",
    "nieuweReservering.controle.geen": "None",
    "nieuweReservering.controle.geenExtras": "No packages or extras chosen.",
    "nieuweReservering.controle.type": "Type",
    "nieuweReservering.controle.aanvraag": "Booking request",
    "nieuweReservering.controle.status": "Status after creating",
    "nieuweReservering.controle.ontvangen": "Request received",
    "nieuweReservering.controle.info": "After creating, the booking appears as a new request with the customer and in the boarding dashboard.",
    "nieuweReservering.controle.ongeldig": "The booking could not be created: some details are not valid. Check the steps.",
    "nieuweReservering.controle.fout": "The booking could not be created. Try again.",
    "nieuweReservering.controle.terug": "Back to booking options",
    "nieuweReservering.controle.concept": "Save as draft",
    "nieuweReservering.controle.aanmaken": "Create booking request",
    "nieuweReservering.klaar.aanvraag": "Booking request created",
    "nieuweReservering.klaar.concept": "Draft saved",
    "nieuweReservering.klaar.nummer": "Booking number %s",
    "nieuweReservering.klaar.aanvraagUitleg": "The request has status Request received and can now be approved.",
    "nieuweReservering.klaar.conceptUitleg": "The draft is with the customer's bookings and can be completed later.",
    "nieuweReservering.klaar.sluiten": "Close",
    "nieuweReservering.volgendeNaar": "Next: %s",
    "nieuweReservering.voorbeeld": "Preview: you can look at everything, but nothing is created or saved.",
    "nieuweReservering.eigen.kies": "Choose…",
    "nieuweReservering.eigen.verplicht": "Still to fill in: %s",
    "nieuweReservering.controle.vragen": "Questions at %s",
    "pensionWizard.titel": "New booking wizard",
    "pensionWizard.status.standaard": "The standard layout is active",
    "pensionWizard.status.versie": "Version %s published on %s",
    "pensionWizard.status.concept": "Draft with changes",
    "pensionWizard.status.nietOpgeslagen": "Not saved",
    "pensionWizard.knop.voorbeeld": "Preview",
    "pensionWizard.knop.standaard": "Back to standard",
    "pensionWizard.knop.verwerpen": "Discard draft",
    "pensionWizard.knop.opslaan": "Save",
    "pensionWizard.knop.publiceren": "Publish",
    "pensionWizard.knop.sluiten": "Close",
    "pensionWizard.sluiten.vraag": "You have changes that have not been saved.",
    "pensionWizard.sluiten.terug": "Keep editing",
    "pensionWizard.sluiten.weggooien": "Discard changes",
    "pensionWizard.stappen": "Steps",
    "pensionWizard.stap.eigen": "Own step",
    "pensionWizard.stap.vast": "Standard step",
    "pensionWizard.stap.vastePlek": "Fixed position",
    "pensionWizard.stap.uit": "Turned off",
    "pensionWizard.stap.nieuw": "Add own step",
    "pensionWizard.stap.omhoog": "%s up",
    "pensionWizard.stap.omlaag": "%s down",
    "pensionWizard.stap.tonen": "Show %s",
    "pensionWizard.stap.verbergen": "Hide %s",
    "pensionWizard.stap.verwijder": "Remove %s",
    "pensionWizard.stap.nr": "Step %s of %s",
    "pensionWizard.stap.naam": "Name of the step",
    "pensionWizard.stap.uitlegVeld": "Explanation of the step",
    "pensionWizard.stap.nodig": "Required step",
    "pensionWizard.stap.kern": "This step is needed to create a booking and is always on.",
    "pensionWizard.stap.aan": "Show this step in the wizard",
    "pensionWizard.stap.standaardNaam": "Standard name: %s. Clear the field to use it again.",
    "pensionWizard.stapUitleg.ZOEKEN": "The desk searches for the customer by e-mail and/or address. Skipped when the wizard is started from a customer.",
    "pensionWizard.stapUitleg.KIEZEN": "The customers found, checking the chosen customer, or creating a new one.",
    "pensionWizard.stapUitleg.DIEREN": "The customer's animals to choose from, with the option to add a new animal.",
    "pensionWizard.stapUitleg.PERIODE": "Arrival and departure with times, the length of stay and the availability.",
    "pensionWizard.stapUitleg.VERBLIJF": "Per animal: the type of stay and the care. Questions per animal appear in each animal's card.",
    "pensionWizard.stapUitleg.ARRANGEMENTEN": "The packages and extras per animal and for the whole booking.",
    "pensionWizard.stapUitleg.KEUZES": "Cancellation insurance, other wishes and internal notes, with the summary.",
    "pensionWizard.stapUitleg.CONTROLE": "Everything in a row, the answers to the questions, and creating the booking request.",
    "pensionWizard.stapUitleg.EIGEN": "A step of your own with questions and text blocks. The answers are saved with the booking.",
    "pensionWizard.element.omhoog": "%s up",
    "pensionWizard.element.omlaag": "%s down",
    "pensionWizard.element.tonen": "Show %s",
    "pensionWizard.element.verbergen": "Hide %s",
    "pensionWizard.element.verwijder": "Remove %s",
    "pensionWizard.element.kies": "Edit %s",
    "pensionWizard.element.vast": "Standard part",
    "pensionWizard.element.verplicht": "Required",
    "pensionWizard.element.perDier": "Per animal",
    "pensionWizard.element.uit": "Hidden",
    "pensionWizard.element.leeg": "Drag a question or text block here, or click on the right what you want to add.",
    "pensionWizard.toevoegen": "Add to this step",
    "pensionWizard.toevoegenUitleg": "Click, or drag into the step.",
    "pensionWizard.toevoegenKlant": "When searching for and choosing the customer you can only add text.",
    "pensionWizard.soort.TEKST": "Text block",
    "pensionWizard.soort.TEXT": "Short text",
    "pensionWizard.soort.TEXTAREA": "Long text",
    "pensionWizard.soort.NUMBER": "Number",
    "pensionWizard.soort.BOOLEAN": "Yes / no",
    "pensionWizard.soort.DATE": "Date",
    "pensionWizard.soort.SELECT": "One choice",
    "pensionWizard.soort.MULTISELECT": "Multiple choices",
    "pensionWizard.eigenschappen": "Properties",
    "pensionWizard.eigenschappen.leeg": "Choose a part in the step to change it.",
    "pensionWizard.blok.EMAIL": "Search field for the customer's e-mail address.",
    "pensionWizard.blok.ADRES": "Search field for postcode, house number or address.",
    "pensionWizard.blok.NIEUW_DIER": "Button to add a new animal straight away.",
    "pensionWizard.blok.BESCHIKBAARHEID": "Checks whether there is room in the chosen period.",
    "pensionWizard.blok.TYPE_VERBLIJF": "The type of stay per animal, with photo and price.",
    "pensionWizard.blok.TARIEF": "The boarding rate the day price comes from, per animal.",
    "pensionWizard.blok.VOEDING": "Type of food and feeding instructions per animal.",
    "pensionWizard.blok.MEDICATIE": "Whether the animal gets medication, with instructions.",
    "pensionWizard.blok.VERZORGING": "Brushing, washing and together with the own family.",
    "pensionWizard.blok.BIJZONDERHEDEN": "Particulars for this stay.",
    "pensionWizard.blok.ARRANGEMENTEN": "The packages from Products › Boarding packages, per animal and for the booking.",
    "pensionWizard.blok.VERZEKERING": "The cancellation insurance, when the branch offers it.",
    "pensionWizard.blok.WENSEN": "Other wishes of the customer.",
    "pensionWizard.blok.NOTITIE": "Internal notes for staff.",
    "pensionWizard.blok.INFO": "An information block.",
    "pensionWizard.blok.SAMENVATTING": "The summary with the price; always part of the check.",
    "pensionWizard.blok.CONCEPT": "The button to save the booking as a draft.",
    "pensionWizard.veld.naam": "Name",
    "pensionWizard.veld.titel": "Title",
    "pensionWizard.veld.naamStandaard": "Leave empty for the standard name.",
    "pensionWizard.veld.uitleg": "Explanation",
    "pensionWizard.veld.plaatshouder": "Example text in the field",
    "pensionWizard.veld.tekst": "Text",
    "pensionWizard.veld.vraag": "Question",
    "pensionWizard.veld.soort": "Type of answer",
    "pensionWizard.veld.keuzes": "Choices (one per line)",
    "pensionWizard.veld.verplicht": "Required to fill in",
    "pensionWizard.veld.perDier": "Ask per animal",
    "pensionWizard.veld.perDierNiet": "Only possible in a step after the animals.",
    "pensionWizard.veld.tonen": "Show in the wizard",
    "pensionWizard.veld.nodig": "This part is needed and stays visible.",
    "pensionWizard.veld.verwijder": "Remove",
    "pensionWizard.nieuw.vraag": "New question",
    "pensionWizard.nieuw.tekst": "New text block",
    "pensionWizard.nieuw.stap": "New step",
    "pensionWizard.nieuw.optie": "Option %s",
    "pensionWizard.regel.klantEerst": "Find customer and choose customer stay the first two steps.",
    "pensionWizard.regel.controleLaatst": "Check & create stays the last step.",
    "pensionWizard.regel.dierenVoorPeriode": "The animals come before the period.",
    "pensionWizard.regel.naPeriode": "Stay, packages and booking choices come after the period.",
    "pensionWizard.regel.perDierNaDieren": "A question per animal belongs in a step after the animals.",
    "pensionWizard.regel.eigenStapNaam": "Give every own step a name.",
    "pensionWizard.regel.eigenStapLeeg": "An own step has at least one question or text block.",
    "pensionWizard.regel.zoekenLeeg": "Find customer needs at least searching by e-mail or by address.",
    "pensionWizard.regel.vraagTekst": "Every question has a text.",
    "pensionWizard.regel.vraagOpties": "A choice question has at least one choice.",
    "pensionWizard.regel.tekstLeeg": "A text block has a title or text.",
    "pensionWizard.melding.opgeslagen": "Draft saved. Publish it to change the wizard.",
    "pensionWizard.melding.gepubliceerd": "Published: the wizard now uses version %s.",
    "pensionWizard.melding.verworpen": "Draft discarded.",
    "pensionWizard.melding.standaard": "The standard layout is ready as a draft.",
    "pensionWizard.fout.laden": "The layout could not be loaded.",
    "pensionWizard.fout.opslaan": "Saving failed. %s",
    "pensionWizard.fout.alleenBeheer": "Only a boarding administrator can arrange the wizard.",
    "nieuweReservering.arrangementen.titel": "Packages & extras",
    "nieuweReservering.arrangementen.uitleg": "Choose the packages and extras for each animal. They are optional.",
    "nieuweReservering.arrangementen.voorWie": "For whom",
    "nieuweReservering.arrangementen.reservering": "Booking",
    "nieuweReservering.arrangementen.reserveringUitleg": "Extras for the whole booking",
    "nieuweReservering.arrangementen.laadFout": "The packages could not be loaded.",
    "nieuweReservering.arrangementen.geen": "There are no packages here. Set them up under Products › Boarding packages.",
    "nieuweReservering.arrangementen.gekozen": "Selected extras",
    "nieuweReservering.arrangementen.gekozenUitleg": "Overview of all chosen packages and extras.",
    "nieuweReservering.arrangementen.minder": "One %s fewer",
    "nieuweReservering.arrangementen.meer": "One more %s",
    "nieuweReservering.arrangementen.weg": "Remove %s",
    "nieuweReservering.arrangementen.nogNiets": "Nothing chosen yet.",
    "nieuweReservering.arrangementen.totaal": "Total extras",
    "nieuweReservering.arrangementen.overslaanTitel": "No extras wanted?",
    "nieuweReservering.arrangementen.overslaanUitleg": "You can skip this step if no packages or extras are needed.",
    "nieuweReservering.arrangementen.overslaan": "Skip this step",
    "nieuweReservering.arrangementen.terug": "Back to stay",
    "pensionAccommodatie.veld.omschrijving": "Description",
    "pensionAccommodatie.veld.foto": "Photo",
    "pensionAccommodatie.foto.kies": "Choose photo",
    "pensionAccommodatie.foto.weg": "Remove photo",
    "pensionAccommodatie.foto.uitleg": "A photo of the stay, shown in the New booking wizard.",
    "pensionAccommodatie.fout.foto": "Choose a PNG, JPEG or WebP.",
    "nieuweReservering.titel": "Create a new booking",
    "nieuweReservering.subtitel": "Register a new boarding booking",
    "nieuweReservering.groot": "Enlarge",
    "nieuweReservering.klein": "Shrink",
    "nieuweReservering.sluiten": "Close",
    "nieuweReservering.stappen": "Steps",
    "nieuweReservering.stap.zoeken": "Find customer",
    "nieuweReservering.stap.kiezen": "Choose customer",
    "nieuweReservering.stap.controleren": "Check customer",
    "nieuweReservering.stap.dieren": "Select animals",
    "nieuweReservering.stap.nieuwDier": "Add new animal",
    "nieuweReservering.stap.periode": "Select period",
    "nieuweReservering.stap.perDier": "Settings per animal",
    "nieuweReservering.stap.verzorging": "Packages & extras",
    "nieuweReservering.stap.controle": "Review & create",
    "nieuweReservering.volgt": "This step is still being built.",
    "nieuweReservering.terug": "Back",
    "nieuweReservering.volgende": "Next",
    "nieuweReservering.annuleren": "Cancel",
    "nieuweReservering.zoeken.titel": "Find customer",
    "nieuweReservering.zoeken.uitleg": "Who is the booking for?",
    "nieuweReservering.zoeken.email": "Search by email address",
    "nieuweReservering.zoeken.emailPlaats": "Email address",
    "nieuweReservering.zoeken.enOf": "and/or",
    "nieuweReservering.zoeken.adres": "Search by address",
    "nieuweReservering.zoeken.adresPlaats": "Type street, city or postcode…",
    "nieuweReservering.adres.suggesties": "Address suggestions",
    "nieuweReservering.adres.nietBeschikbaar": "Address search (Postcode.eu) is not set up on this server; type the address yourself.",
    "nieuweReservering.nieuw.adresZoeken": "Search address",
    "nieuweReservering.nieuw.adresZoekenPlaats": "Type street, house number and town",
    "nieuweReservering.zoeken.knop": "Search",
    "nieuweReservering.zoeken.fout": "Searching failed. Please try again.",
    "nieuweReservering.kiezen.titel": "Customers found",
    "nieuweReservering.kiezen.uitleg": "Choose the right customer for this booking or create a new one.",
    "nieuweReservering.kiezen.voor": "Search results for:",
    "nieuweReservering.kiezen.inactief": "Inactive",
    "nieuweReservering.kiezen.dierEen": "1 animal",
    "nieuweReservering.kiezen.dieren": "%s animals",
    "nieuweReservering.kiezen.boekingEen": "1 boarding booking",
    "nieuweReservering.kiezen.boekingen": "%s boarding bookings",
    "nieuweReservering.kiezen.selecteerAria": "Select %s",
    "nieuweReservering.kiezen.selecteren": "Select",
    "nieuweReservering.kiezen.geselecteerd": "Selected",
    "nieuweReservering.kiezen.meer": "More customers match than are shown here; search more precisely.",
    "nieuweReservering.kiezen.nietGevonden": "Not the right customer?",
    "nieuweReservering.kiezen.nietGevondenUitleg": "Create a new customer and carry on with the booking straight away.",
    "nieuweReservering.kiezen.nieuw": "Create new customer",
    "nieuweReservering.controleren.titel": "Check customer",
    "nieuweReservering.controleren.uitleg": "Are these the right details for this booking?",
    "nieuweReservering.controleren.naam": "Name",
    "nieuweReservering.controleren.adres": "Address",
    "nieuweReservering.controleren.dieren": "Animals",
    "nieuweReservering.controleren.boekingen": "Boarding bookings",
    "nieuweReservering.controleren.klopt": "Something wrong? Change it on the customer screen after the booking.",
    "nieuweReservering.controleren.aanpassen": "Change details",
    "nieuweReservering.controleren.opslaan": "Save details",
    "nieuweReservering.controleren.opgeslagen": "The details have been saved.",
    "nieuweReservering.controleren.telefoon2": "Second phone number",
    "nieuweReservering.controleren.laadFout": "The customer's details could not be loaded.",
    "nieuweReservering.controleren.fout": "Saving failed. Try again.",
    "nieuweReservering.controleren.geenRecht": "You are not allowed to change customer details.",
    "nieuweReservering.controleren.conflict": "Someone else has just changed this customer. The details have been reloaded.",
    "nieuweReservering.nieuw.titel": "Create new customer",
    "nieuweReservering.nieuw.uitleg": "Fill in the details. After saving, this customer is selected straight away.",
    "nieuweReservering.nieuw.persoon": "Personal details",
    "nieuweReservering.nieuw.contactpersoon": "Contact person",
    "nieuweReservering.nieuw.bedrijfsnaam": "Company name",
    "nieuweReservering.nieuw.voorletters": "Initials",
    "nieuweReservering.nieuw.tussenvoegsel": "Prefix",
    "nieuweReservering.nieuw.achternaam": "Surname",
    "nieuweReservering.nieuw.geslacht": "Gender",
    "nieuweReservering.nieuw.geslachtLeeg": "—",
    "nieuweReservering.nieuw.geslachtMAN": "Male",
    "nieuweReservering.nieuw.geslachtVROUW": "Female",
    "nieuweReservering.nieuw.geboortedatum": "Date of birth",
    "nieuweReservering.nieuw.contact": "Contact details",
    "nieuweReservering.nieuw.email": "Email address",
    "nieuweReservering.nieuw.telefoon": "Phone number",
    "nieuweReservering.nieuw.emailOngeldig": "This is not a valid email address.",
    "nieuweReservering.nieuw.adres": "Address details",
    "nieuweReservering.nieuw.straat": "Street",
    "nieuweReservering.nieuw.huisnummer": "House number",
    "nieuweReservering.nieuw.toevoeging": "Addition",
    "nieuweReservering.nieuw.postcode": "Postcode",
    "nieuweReservering.nieuw.plaats": "City",
    "nieuweReservering.nieuw.opzoeken": "Look up address",
    "nieuweReservering.nieuw.adresNietGevonden": "No address found for this postcode and house number.",
    "nieuweReservering.nieuw.organisatie": "Save as business relation / organisation",
    "nieuweReservering.nieuw.verplicht": "Fill in the required fields.",
    "nieuweReservering.nieuw.geenRecht": "You are not allowed to create customers.",
    "nieuweReservering.nieuw.ongeldig": "Check the details.",
    "nieuweReservering.nieuw.fout": "Creating the customer failed. Please try again.",
    "nieuweReservering.nieuw.opslaan": "Create customer and continue",
    "nieuweReservering.dieren.klant": "Selected customer",
    "nieuweReservering.dieren.klantWijzigen": "Change customer",
    "nieuweReservering.dieren.titel": "Select animals",
    "nieuweReservering.dieren.uitleg": "Choose one or more animals for this booking.",
    "nieuweReservering.dieren.zoek": "Search animals…",
    "nieuweReservering.dieren.soort": "Species",
    "nieuweReservering.dieren.alles": "All",
    "nieuweReservering.dieren.nieuw": "Add new animal",
    "nieuweReservering.dieren.laadFout": "The animals could not be loaded.",
    "nieuweReservering.dieren.geen": "This customer has no animals yet.",
    "nieuweReservering.dieren.inPension": "In boarding now",
    "nieuweReservering.dieren.gepland": "Booked: %s",
    "nieuweReservering.dieren.laatste": "Last stay: %s",
    "nieuweReservering.dieren.geenReservering": "No booking",
    "nieuweReservering.dieren.entingVerlopen": "Vaccination expired",
    "nieuweReservering.dieren.medicatie": "Medication",
    "nieuweReservering.dieren.geselecteerd": "Selected",
    "nieuweReservering.dier.titel": "Add new animal",
    "nieuweReservering.dier.voor": "Add animal to",
    "nieuweReservering.dier.andereKlant": "Choose another customer",
    "nieuweReservering.dier.uitleg": "Fill in the animal's details. After saving you can select it for the booking straight away.",
    "nieuweReservering.dier.gegevens": "Animal details",
    "nieuweReservering.dier.naam": "Name",
    "nieuweReservering.dier.naamPlaats": "Name of the animal",
    "nieuweReservering.dier.chip": "Chip number",
    "nieuweReservering.dier.chipPlaats": "Enter the 15-digit chip number",
    "nieuweReservering.dier.chipOngeldig": "A chip number has 15 digits.",
    "nieuweReservering.dier.geslacht": "Sex",
    "nieuweReservering.dier.onbekend": "Unknown",
    "nieuweReservering.dier.mannelijk": "Male",
    "nieuweReservering.dier.vrouwelijk": "Female",
    "nieuweReservering.dier.gecastreerd": "Neut./Spayed",
    "nieuweReservering.dier.geboortedatum": "Date of birth",
    "nieuweReservering.dier.diersoort": "Species",
    "nieuweReservering.dier.kiesSoort": "Choose a species",
    "nieuweReservering.dier.ras": "Breed",
    "nieuweReservering.dier.kiesRas": "Choose a breed",
    "nieuweReservering.dier.kruising": "Cross-breed",
    "nieuweReservering.dier.vacht": "Coat",
    "nieuweReservering.dier.kiesVacht": "Select coat",
    "nieuweReservering.dier.kleur": "Colour",
    "nieuweReservering.dier.kiesKleur": "Select colour",
    "nieuweReservering.dier.bijzonderheden": "Particulars",
    "nieuweReservering.dier.bijzonderhedenPlaats": "For example character, medical particulars, feeding, etc.",
    "nieuweReservering.dier.verplicht": "Name and species are required.",
    "nieuweReservering.dier.foto": "Photo of the animal",
    "nieuweReservering.dier.fotoUitleg": "Upload a photo of the animal (also by camera).",
    "nieuweReservering.dier.fotoUitlegAi": "Upload a photo of the animal (also by camera) for AI prefill.",
    "nieuweReservering.dier.fotoKiezen": "Choose a photo",
    "nieuweReservering.dier.fotoVoorbeeld": "Chosen photo",
    "nieuweReservering.dier.fotoKlik": "Click to upload a photo",
    "nieuweReservering.dier.fotoAnders": "Choose another photo",
    "nieuweReservering.dier.fotoSleep": "or drag a file here",
    "nieuweReservering.dier.fotoFormaten": "Supported formats: JPG, PNG, WEBP · Max. 10 MB",
    "nieuweReservering.dier.fotoOngeldig": "Choose a JPG, PNG or WEBP of at most 10 MB.",
    "nieuweReservering.dier.fotoNietOpgeslagen": "The animal was added, but the photo could not be saved.",
    "nieuweReservering.dier.of": "or",
    "nieuweReservering.dier.paspoort": "Scan passport photo",
    "nieuweReservering.dier.paspoortUitleg": "We try to fill in the details automatically.",
    "nieuweReservering.dier.aiTitel": "AI prefill",
    "nieuweReservering.dier.aiUitleg": "Upload a photo or passport photo and we fill in as many details as possible.",
    "nieuweReservering.dier.aiBezig": "Reading the photo…",
    "nieuweReservering.dier.aiIngevuld": "%s fields filled in. Check them before saving.",
    "nieuweReservering.dier.aiNiets": "Nothing usable was found.",
    "nieuweReservering.dier.aiFout": "The photo could not be read.",
    "nieuweReservering.dier.geenRecht": "You are not allowed to add animals.",
    "nieuweReservering.dier.ongeldig": "Check the details.",
    "nieuweReservering.dier.fout": "Adding the animal failed. Please try again.",
    "nieuweReservering.dier.terug": "Back to animals",
    "nieuweReservering.dier.toevoegen": "Add animal",
    "nieuweReservering.periode.klantBekijken": "View customer details",
    "nieuweReservering.periode.dieren": "Selected animals",
    "nieuweReservering.periode.dierenAanpassen": "Change animals",
    "nieuweReservering.periode.titel": "Select period",
    "nieuweReservering.periode.uitleg": "Choose when the animals are brought and collected.",
    "nieuweReservering.periode.aankomst": "Arrival",
    "nieuweReservering.periode.aankomstVraag": "When are the animals brought?",
    "nieuweReservering.periode.aankomstdatum": "Arrival date",
    "nieuweReservering.periode.aankomsttijd": "Arrival time",
    "nieuweReservering.periode.vertrek": "Departure",
    "nieuweReservering.periode.vertrekVraag": "When are the animals collected?",
    "nieuweReservering.periode.vertrekdatum": "Departure date",
    "nieuweReservering.periode.vertrektijd": "Departure time",
    "nieuweReservering.periode.en": "and",
    "nieuweReservering.periode.brengenOp": "Animals can be brought in %s on this day",
    "nieuweReservering.periode.halenOp": "Animals can be collected %s on this day",
    "nieuweReservering.periode.brengenDicht": "The boarding does not take in animals on this day. Choose another date.",
    "nieuweReservering.periode.halenDicht": "The boarding does not hand out animals on this day. Choose another date.",
    "nieuweReservering.periode.duur": "Length of stay",
    "nieuweReservering.periode.nacht": "1 night",
    "nieuweReservering.periode.nachten": "%s nights",
    "nieuweReservering.periode.kies": "Choose arrival and departure",
    "nieuweReservering.periode.ongeldig": "Departure must be after arrival",
    "nieuweReservering.periode.kiesTijd": "Choose an arrival and departure time",
    "nieuweReservering.periode.verblijf": "Type of stay",
    "nieuweReservering.periode.verblijfUitleg": "Choose the preferred stay for each animal.",
    "nieuweReservering.periode.verblijfKeuze": "Stay for %s",
    "nieuweReservering.periode.verblijfGeen": "There are no accommodation types for %s yet.",
    "nieuweReservering.periode.meerprijs": "Surcharge %s per day",
    "nieuweReservering.periode.dagprijs": "%s per day",
    "nieuweReservering.periode.locatie": "Location",
    "nieuweReservering.periode.locatieUitleg": "Availability, rates and opening hours differ per location.",
    "nieuweReservering.periode.locatieKiezen": "Book at",
    "nieuweReservering.periode.beschikbaarheid": "Check availability",
    "nieuweReservering.periode.tm": "%s to %s",
    "nieuweReservering.periode.kiesEerst": "Choose a period first.",
    "nieuweReservering.periode.bezig": "Checking…",
    "nieuweReservering.periode.ok": "There is capacity for this period.",
    "nieuweReservering.periode.okUitleg": "You can continue to the next step.",
    "nieuweReservering.periode.geenCapaciteit": "No capacity has been set; only full days were checked.",
    "nieuweReservering.periode.vol": "Not enough room on every day",
    "nieuweReservering.periode.knelpuntVol": "%s: full for %s",
    "nieuweReservering.periode.knelpuntCapaciteit": "%s: %s, %s places left",
    "nieuweReservering.periode.fout": "Availability could not be checked.",
    "nieuweReservering.periode.opnieuw": "Check again",
    "pensionKlant.opvang.titel": "Day care profile",
    "pensionKlant.opvang.vasteKlant": "Regular customer",
    "pensionKlant.opvang.eenDier": "1 animal",
    "pensionKlant.opvang.dieren.aantal": "%s animals",
    "pensionKlant.opvang.doorlopend": "Ongoing",
    "pensionKlant.opvang.bewerken": "Edit",
    "pensionKlant.opvang.dagPlannen": "Plan a day",
    "pensionKlant.opvang.meer": "More actions",
    "pensionKlant.opvang.rittenkaartVerkopen": "Sell a ride card",
    "pensionKlant.opvang.afrekenwijzeWijzigen": "Change billing method",
    "pensionKlant.opvang.kalender": "Day care calendar",
    "pensionKlant.opvang.eerder": "Earlier months",
    "pensionKlant.opvang.later": "Later months",
    "pensionKlant.opvang.vandaag": "Today",
    "pensionKlant.opvang.filter": "Animals in the calendar",
    "pensionKlant.opvang.alleDieren": "All animals",
    "pensionKlant.opvang.soort.vast": "Planned (regular day)",
    "pensionKlant.opvang.soort.extra": "Extra day",
    "pensionKlant.opvang.soort.afwezig": "Absent",
    "pensionKlant.opvang.soort.proefdag": "Trial day",
    "pensionKlant.opvang.soort.feestdag": "Public holiday",
    "pensionKlant.opvang.soort.verwacht": "Regular day, not planned yet",
    "pensionKlant.opvang.legenda.dieren": "Animals on this day",
    "pensionKlant.opvang.gepland": "Planned day care days",
    "pensionKlant.opvang.maandKeuze": "Month",
    "pensionKlant.opvang.alleMaanden": "All months shown",
    "pensionKlant.opvang.alleBekijken": "View all day care days",
    "pensionKlant.opvang.minderBekijken": "One month only",
    "pensionKlant.opvang.geenDagen": "No day care days in this period.",
    "pensionKlant.opvang.kolom.datum": "Date",
    "pensionKlant.opvang.kolom.dieren": "Animals",
    "pensionKlant.opvang.kolom.type": "Type",
    "pensionKlant.opvang.kolom.status": "Status",
    "pensionKlant.opvang.kolom.afrekening": "Billing",
    "pensionKlant.opvang.kolom.opmerking": "Note",
    "pensionKlant.opvang.kolom.acties": "Actions",
    "pensionKlant.opvang.type.VASTE_DAG": "Regular day",
    "pensionKlant.opvang.type.EXTRA_DAG": "Extra day",
    "pensionKlant.opvang.type.PROEFDAG": "Trial day",
    "pensionKlant.opvang.afrekening.INBEGREPEN": "Included",
    "pensionKlant.opvang.afrekening.eenRit": "1 ride",
    "pensionKlant.opvang.afrekening.ritten": "%s rides",
    "pensionKlant.opvang.afrekening.DAGPRIJS": "Day price",
    "pensionKlant.opvang.afrekening.PROEFDAG": "Trial day",
    "pensionKlant.opvang.gefactureerd": "Invoiced",
    "pensionKlant.opvang.actie.bewerk": "Edit %s",
    "pensionKlant.opvang.actie.afmelden": "Mark %s absent",
    "pensionKlant.opvang.actie.terugzetten": "Restore %s",
    "pensionKlant.opvang.actie.verwijder": "Delete %s",
    "pensionKlant.opvang.dieren.titel": "Day care animals",
    "pensionKlant.opvang.dieren.geen": "No animals on the contract yet.",
    "pensionKlant.opvang.geenVasteDagen": "No regular days",
    "pensionKlant.opvang.alleenInKennel": "Kennel only",
    "pensionKlant.opvang.medicatie": "Medication",
    "pensionKlant.opvang.laatsteBezoek": "Last visit: %s",
    "pensionKlant.opvang.afrekenwijze": "Billing method",
    "pensionKlant.opvang.wijze.RITTENKAART": "Ride card",
    "pensionKlant.opvang.wijze.PERIODE": "Periodic invoicing",
    "pensionKlant.opvang.wijze.MAANDCONTRACT": "Monthly contract",
    "pensionKlant.opvang.wijze.RITTENKAART.uitleg": "The customer buys a card with rides; every animal that comes uses one ride.",
    "pensionKlant.opvang.wijze.PERIODE.uitleg": "Every day at the day price, invoiced per period (usually a month).",
    "pensionKlant.opvang.wijze.MAANDCONTRACT.uitleg": "Regular days per week; extra days via the ride card or at the single day price.",
    "pensionKlant.opvang.rit.stand": "%s rides bought | %s left",
    "pensionKlant.opvang.rit.perDier": "1 ride per animal present",
    "pensionKlant.opvang.rit.verloopt": "Valid until %s",
    "pensionKlant.opvang.periode.stand": "%s per day | invoiced monthly",
    "pensionKlant.opvang.periode.geenPrijs": "No day price yet; set it under Products › Day care rates.",
    "pensionKlant.opvang.maand.vast": "Regular days: %s",
    "pensionKlant.opvang.maand.geenVast": "No regular days yet",
    "pensionKlant.opvang.maand.inbegrepen": "%s included per month",
    "pensionKlant.opvang.maand.extra.RITTENKAART": "Extra days via the ride card",
    "pensionKlant.opvang.maand.extra.LOSSE_DAGPRIJS": "Extra days at the single day price",
    "pensionKlant.opvang.maand.abonnement": "%s, %s per month",
    "pensionKlant.opvang.afgeleid": "Not set yet: derived from the contract in the old system.",
    "pensionKlant.opvang.en": "and",
    "pensionKlant.opvang.samenvatting": "Summary of this month",
    "pensionKlant.opvang.som.inbegrepen": "Included",
    "pensionKlant.opvang.som.gebruikt": "Used",
    "pensionKlant.opvang.som.extra": "Extra days",
    "pensionKlant.opvang.som.beschikbaar": "Still available",
    "pensionKlant.opvang.som.openstaand": "Outstanding this month",
    "pensionKlant.opvang.volgende": "Next day care day",
    "pensionKlant.opvang.geenVolgende": "No day care day planned.",
    "pensionKlant.opvang.brengen": "Drop-off",
    "pensionKlant.opvang.halen": "Pick-up",
    "pensionKlant.opvang.annuleren": "Cancel",
    "pensionKlant.opvang.opslaan": "Save",
    "pensionKlant.opvang.dag.planTitel": "Plan a day care day",
    "pensionKlant.opvang.dag.bewerkTitel": "Day care day %s",
    "pensionKlant.opvang.dag.plannen": "Plan day",
    "pensionKlant.opvang.dag.datum": "Date",
    "pensionKlant.opvang.dag.dieren": "Animals",
    "pensionKlant.opvang.dag.extra": "Extra day",
    "pensionKlant.opvang.dag.extraAfgeleid": "Not every animal has this as a regular day.",
    "pensionKlant.opvang.dag.vastAfgeleid": "A regular day for these animals.",
    "pensionKlant.opvang.dag.proefdag": "Trial day",
    "pensionKlant.opvang.dag.opmerking": "Note",
    "pensionKlant.opvang.dag.toevoegenTitel": "Add day care",
    "pensionKlant.opvang.dag.bewerkTitel2": "Edit day care",
    "pensionKlant.opvang.dag.toevoegen": "Add",
    "pensionKlant.opvang.dag.andereDag": "another day",
    "pensionKlant.opvang.dag.geselecteerd": "%d selected",
    "pensionKlant.opvang.dag.tijd": "Time",
    "pensionKlant.opvang.dag.soort": "Type of day",
    "pensionKlant.opvang.dag.regulier": "Regular",
    "pensionKlant.opvang.dag.opmerkingHint": "Add extra information…",
    "pensionKlant.opvang.afmelden.titel": "Mark %s absent",
    "pensionKlant.opvang.afmelden.uitleg": "The day stays, marked absent; it does not count for billing.",
    "pensionKlant.opvang.afmelden.reden": "Reason",
    "pensionKlant.opvang.afmelden.bevestig": "Mark absent",
    "pensionKlant.opvang.verwijderen.titel": "Delete %s",
    "pensionKlant.opvang.verwijderen.uitleg": "The day disappears completely. If the animal simply did not come, mark it absent instead.",
    "pensionKlant.opvang.verwijderen.bevestig": "Delete",
    "pensionKlant.opvang.vast.titel": "Regular days per animal",
    "pensionKlant.opvang.vast.uitleg": "The days each animal comes as standard. Pick the period below to have those days booked straight away.",
    "pensionKlant.opvang.vast.periode": "Period to schedule",
    "pensionKlant.opvang.vast.van": "From",
    "pensionKlant.opvang.vast.tot": "Up to and including",
    "pensionKlant.opvang.vast.periodeUitleg": "The regular days in this period are booked; days that no longer fit disappear. Extra days, trial days, days with a note and invoiced days are left alone, as are days already past.",
    "pensionKlant.opvang.vast.periodeLeeg": "Without a period only the weekly pattern changes; nothing is booked.",
    "pensionKlant.opvang.vast.periodeHalf": "Give both a start and an end, or leave both empty.",
    "pensionKlant.opvang.vast.periodeOmgekeerd": "The end lies before the start.",
    "pensionKlant.opvang.afrekening.hoe": "How is day care billed?",
    "pensionKlant.opvang.afrekening.abonnement": "Subscription",
    "pensionKlant.opvang.afrekening.kies": "Choose…",
    "pensionKlant.opvang.afrekening.geenAbonnementen": "There are no active subscriptions yet; create them under Products › Day care rates.",
    "pensionKlant.opvang.afrekening.perWeek": "%s days a week",
    "pensionKlant.opvang.afrekening.dagprijs": "Single day price",
    "pensionKlant.opvang.afrekening.standaardPrijs": "Location default",
    "pensionKlant.opvang.afrekening.brengen": "Standard drop-off",
    "pensionKlant.opvang.afrekening.halen": "Standard pick-up",
    "pensionKlant.opvang.rittenkaart.welke": "Which ride card?",
    "pensionKlant.opvang.rittenkaart.geen": "There are no ride cards yet; create them under Products › Day care rates.",
    "pensionKlant.opvang.rittenkaart.ritten": "%s rides",
    "pensionKlant.opvang.rittenkaart.geldig": "valid %s months",
    "pensionKlant.opvang.rittenkaart.verkoop": "Sell",
    "pensionKlant.opvang.fout.conflict": "That is not possible: there is already day care on that day, the day has been invoiced, or the animal has already come.",
    "pensionKlant.opvang.fout.geenContract": "No day care contract runs on that date.",
    "pensionKlant.opvang.fout.ongeldig": "Check the details.",
    "pensionKlant.opvang.fout.algemeen": "Saving failed. Please try again.",
    "pensionKlant.opvang.fout.tijden": "Pick-up must be after drop-off.",
    "pensionKlant.dagopvang.geenLopend": "No running contract.",
    "pensionKlant.dagopvang.toonEerdere": "Show %s earlier contracts",
    "pensionKlant.dagopvang.toonEerdereEen": "Show 1 earlier contract",
    "pensionKlant.dagopvang.verbergEerdere": "Hide earlier contracts",
    "pensionKlant.dagopvang.komend": "Upcoming days",
    "pensionKlant.dagopvang.geenKomend": "No day care booked.",
    "pensionKlant.dagopvang.eerste": "The first %s of %s days.",
    "pensionKlant.dagopvang.geweest": "Earlier days",
    "pensionKlant.dagopvang.geenGeweest": "No earlier days.",
    "pensionKlant.dagopvang.laatste": "The last %s of %s days.",
    "pensionKlant.dagopvang.vanafOnbeperkt": "From %s, open-ended",
    "pensionKlant.dagopvang.dagenPerWeek": "%s days a week",
    "pensionKlant.dagopvang.contract": "Contract %s",
    "pensionKlant.dagopvang.rittenkaart": "Punch card",
    "pensionKlant.dagopvang.opgezegd": "Cancelled as of %s",
    "pensionKlant.dagopvang.extraDag": "Extra day",
    "pensionKlant.contractstatus.LOPEND": "Running",
    "pensionKlant.contractstatus.TOEKOMSTIG": "Starts later",
    "pensionKlant.contractstatus.OPGEZEGD": "Terminated",
    "pensionKlant.contractstatus.AFGELOPEN": "Ended",
    "pensionKlant.contractstatus.GEANNULEERD": "Cancelled",
    "pensionKlant.dagstatus.AANWEZIG": "Present",
    "pensionKlant.dagstatus.VANDAAG": "Today",
    "pensionKlant.dagstatus.GEPLAND": "Booked",
    "pensionKlant.dagstatus.OPGEHAALD": "Picked up",
    "pensionKlant.dagstatus.GEWEEST": "Done",
    "pensionKlant.dagstatus.GEANNULEERD": "Cancelled",
    "pensionKlant.reserveringen.filterAria": "Show bookings for",
    "pensionKlant.reserveringen.filter.alles": "All",
    "pensionKlant.reserveringen.filter.pension": "Boarding",
    "pensionKlant.reserveringen.filter.dagopvang": "Day care",
    "pensionKlant.reserveringen.komend": "Upcoming and now",
    "pensionKlant.reserveringen.geenKomend": "Nothing upcoming.",
    "pensionKlant.factuur.geen": "Not invoiced",
    "pensionKlant.factuur.status.CONCEPT": "Draft invoice",
    "pensionKlant.factuur.status.OPEN": "Invoiced",
    "pensionKlant.factuur.status.BETAALD": "Paid",
    "pensionKlant.factuur.status.VERVALLEN": "Overdue",
    "pensionKlant.factuur.nummer.CONCEPT": "Draft invoice %s",
    "pensionKlant.factuur.nummer.OPEN": "Invoice %s",
    "pensionKlant.factuur.nummer.BETAALD": "Invoice %s paid",
    "pensionKlant.factuur.nummer.VERVALLEN": "Invoice %s overdue",
    "pensionKlant.factuur.openstaand": "%s outstanding",
    "pensionKlant.reserveringen.geweest": "Earlier",
    "pensionKlant.reserveringen.geenGeweest": "Nothing earlier.",
    "pensionKlant.reserveringen.nachten": "%s nights",
    "pensionKlant.reserveringen.dagopvangBegrensd": "Only the most recent 30 day-care days are listed here.",
    "pensionKlant.notities.zoek": "Search notes",
    "pensionKlant.notities.soortAria": "Which notes",
    "pensionKlant.notities.soort.alles": "All",
    "pensionKlant.notities.soort.notities": "Notes",
    "pensionKlant.notities.soort.logboek": "Log",
    "pensionKlant.notities.geen": "No notes yet.",
    "pensionKlant.notities.geenGevonden": "No notes match.",
    "pensionKlant.notities.automatisch": "Automatic",
    "pensionKlant.notities.nieuw": "New note",
    "pensionKlant.notities.tekst": "Note",
    "pensionKlant.notities.opmerking": "Remark (optional)",
    "pensionKlant.notities.opslaan": "Add note",
    "pensionKlant.notities.opgeslagen": "Note added.",
    "pensionKlant.notities.opslaanMislukt": "The note could not be saved.",
    "pensionKlant.kpi.pensionBoekingen": "Boarding bookings",
    "pensionKlant.kpi.dagopvangBoekingen": "Day care bookings",
    "pensionKlant.dieren.titelAantal": "Animals (%s)",
    "pensionKlant.dieren.lijstAria": "Animals of this customer",
    "pensionKlant.status.gereserveerd": "Booked",
    "pensionKlant.dier.subtabsAria": "About this animal",
    "pensionKlant.sub.overzicht": "Overview",
    "pensionKlant.sub.verzorging": "Care",
    "pensionKlant.sub.medisch": "Medical",
    "pensionKlant.sub.notities": "Notes & log",
    "pensionKlant.signaal.entingVerlopen": "Vaccination expired",
    "pensionKlant.signaal.entingBinnenkort": "Vaccination expires soon",
    "pensionKlant.signaal.medicatieActief": "On medication",
    "pensionKlant.tegel.basis": "Basic details",
    "pensionKlant.tegel.verzorging": "Care",
    "pensionKlant.tegel.medisch": "Medical",
    "pensionKlant.tegel.gewicht": "Weight",
    "pensionKlant.tegel.bijzonderheden": "Particulars",
    "pensionKlant.tegel.fotos": "Media & Documents",
    "pensionKlant.tegel.activiteiten": "Recent activity",
    "pensionKlant.tegel.verblijf": "Current / next stay",
    "pensionKlant.tegel.instellen": "Set up tile",
    "pensionKlant.tegel.instellenAria": "Set up the %s tile",
    "pensionKlant.tegel.open": "Open larger",
    "pensionKlant.tegel.openAria": "Open %s",
    "pensionKlant.regel.ras": "Breed",
    "pensionKlant.regel.kleur": "Colour",
    "pensionKlant.regel.geboortedatum": "Date of birth",
    "pensionKlant.regel.geslacht": "Sex",
    "pensionKlant.regel.chipnummer": "Chip number",
    "pensionKlant.regel.paspoortnummer": "Passport number",
    "pensionKlant.regel.soort": "Species",
    "pensionKlant.regel.vacht": "Coat",
    "pensionKlant.regel.registratienummer": "Registration number",
    "pensionKlant.regel.dierenarts": "Vet",
    "pensionKlant.regel.voeding": "Food",
    "pensionKlant.regel.hoeveelheid": "Amount",
    "pensionKlant.regel.schema": "Schedule",
    "pensionKlant.regel.voerBijzonderheden": "Particulars",
    "pensionKlant.regel.gedrag": "Behaviour",
    "pensionKlant.regel.vaccinaties": "Vaccinations",
    "pensionKlant.regel.medicatie": "Medication",
    "pensionKlant.regel.ontworming": "Deworming",
    "pensionKlant.regel.ontvlooien": "Flea treatment",
    "pensionKlant.regel.actGewicht": "Weighings",
    "pensionKlant.regel.actMedicatie": "Medication started",
    "pensionKlant.regel.actNotitie": "Notes",
    "pensionKlant.regel.actLogboek": "Log entries",
    "pensionKlant.regel.status": "Status",
    "pensionKlant.regel.foto": "Photo",
    "pensionKlant.regel.leeftijd": "Age",
    "pensionKlant.regel.bijzonderheden": "Notable",
    "pensionKlant.regel.reservering": "Next booking",
    "pensionKlant.regel.periode": "Period",
    "pensionKlant.regel.kennel": "Kennel",
    "pensionKlant.regel.bezoeknummer": "Visit number",
    "pensionKlant.regel.nachten": "Nights",
    "pensionKlant.regel.tarief": "Rate",
    "pensionKlant.regel.totaal": "Total",
    "pensionKlant.regel.gecastreerd": "neutered",
    "pensionKlant.regel.nietGecastreerd": "not neutered",
    "pensionKlant.optie.maanden": "Period of the chart",
    "pensionKlant.optie.maanden.3": "3 months",
    "pensionKlant.optie.maanden.6": "6 months",
    "pensionKlant.optie.maanden.12": "12 months",
    "pensionKlant.optie.aantalFotos": "Photos and documents shown",
    "pensionKlant.optie.aantalActiviteiten": "Number of activities",
    "pensionKlant.staat.inOrde": "Up to date",
    "pensionKlant.staat.verlopen": "Expired",
    "pensionKlant.staat.verlooptOp": "Expires %s",
    "pensionKlant.kopieer.aria": "Copy %s",
    "pensionKlant.kopieer.titel": "Copy",
    "pensionKlant.kopieer.klaar": "Copied",
    "pensionKlant.en": "and",
    "pensionKlant.waarde.perDag": "%s %sx a day",
    "pensionKlant.waarde.daags": "%s %sx daily",
    "pensionKlant.waarde.geenSchema": "No schedule",
    "pensionKlant.waarde.geen": "None",
    "pensionKlant.waarde.actief": "Active",
    "pensionKlant.waarde.kg": "%s kg",
    "pensionKlant.waarde.laatsteMeting": "Last weighed: %s",
    "pensionKlant.waarde.grafiekAria": "Weight over the last %s months",
    "pensionKlant.waarde.nietGewogen": "Not weighed yet.",
    "pensionKlant.waarde.trend": "%s since %s",
    "pensionKlant.waarde.trendGelijk": "Unchanged since %s",
    "pensionKlant.waarde.grafiekLeeg": "No weighings in this period.",
    "pensionKlant.waarde.grafiekBuitenPeriode": "older than %d months",
    "pensionKlant.waarde.geenBijzonderheden": "No particulars",
    "pensionKlant.bijzonderheden.wijzigen": "Edit particulars",
    "pensionKlant.bijzonderheden.labels": "Labels",
    "pensionKlant.bijzonderheden.labelsHint": "One per line, or separated by commas. Each one becomes a label on the tile.",
    "pensionKlant.bijzonderheden.notitie": "Note",
    "pensionKlant.bijzonderheden.fout": "The particulars could not be saved.",
    "pensionKlant.bijzonderheden.teLang": "The labels are too long together (250 characters at most). Shorten or remove a few.",
    "pensionKlant.bijzonderheden.conflict": "Someone else changed this animal. Close and reopen to see the current version.",
    "pensionKlant.waarde.fotoToevoegen": "Add",
    "pensionKlant.waarde.nietIngedeeld": "Not yet assigned",
    "pensionKlant.waarde.nacht": "%s night",
    "pensionKlant.waarde.nachten": "%s nights",
    "pensionKlant.waarde.perDagBedrag": "%s / day",
    "pensionKlant.activiteit.gewicht": "Weight recorded",
    "pensionKlant.activiteit.medicatie": "Medication started",
    "pensionKlant.activiteit.notitie": "Note added",
    "pensionKlant.activiteit.logboek": "Log entry",
    "pensionKlant.activiteit.geen": "Nothing recorded recently.",
    "pensionKlant.activiteit.alle": "View all activity",
    "pensionKlant.verblijf.open": "All stays",
    "pensionKlant.resstatus.GEANNULEERD": "Cancelled",
    "pensionKlant.resstatus.AFGEROND": "Completed",
    "pensionKlant.resstatus.IN_PENSION": "Boarding",
    "pensionKlant.resstatus.GEPLAND": "Booked",
    "pensionKlant.instellen.tegelsKnop": "Set up tiles",
    "pensionKlant.instellen.tegelsTitel": "Set up tiles",
    "pensionKlant.instellen.tegelsUitleg": "Choose which tiles you see and in which order. This applies to every animal.",
    "pensionKlant.instellen.lijstTitel": "Choose card fields",
    "pensionKlant.instellen.lijstUitleg": "Choose what you see on an animal card in the list, and in which order. This applies to every customer.",
    "pensionKlant.instellen.opKaartje": "On the card",
    "pensionKlant.instellen.nietsBeschikbaar": "Everything is on the card",
    "pensionKlant.dieren.velden": "Choose card fields",
    "pensionKlant.instellen.tegelTitel": "Set up tile: %s",
    "pensionKlant.instellen.hoe": "How it shows",
    "pensionKlant.instellen.geenTegels": "All tiles are hidden. Use “Set up tiles” to show them again.",
    "pensionKlant.instellen.verplaatst": "%s is now in position %s of %s.",
    "pensionKlant.instellen.verplaatsAria": "Move %s (arrow keys)",
    "pensionKlant.instellen.sleep": "Drag to move",
    "pensionKlant.instellen.standaard": "Restore default",
    "pensionKlant.instellen.mislukt": "Saving failed. Please try again.",
    "pensionKlant.regel.waarde": "Latest weight",
    "pensionKlant.regel.datum": "Date weighed",
    "pensionKlant.regel.grafiek": "Chart",
    "pensionKlant.regel.kenmerken": "Characteristics",
    "pensionKlant.regel.notitie": "Particulars note",
    "pensionKlant.instellen.sleepUitleg": "Drag parts onto the tile and into your order. Drag them back to Available to remove them.",
    "pensionKlant.instellen.opDeTegel": "On the tile",
    "pensionKlant.instellen.beschikbaar": "Available",
    "pensionKlant.instellen.sleepHierheen": "Drag parts here",
    "pensionKlant.instellen.allesErop": "Everything is on the tile",
    "pensionKlant.instellen.voegToeAria": "Add %s to the tile",
    "pensionKlant.instellen.haalWegAria": "Remove %s from the tile",
    "pensionKlant.instellen.weggehaald": "%s has been removed.",
    "pensionKlant.instellen.voorbeeld": "Preview",
    "pensionKlant.instellen.zichtbaar": "In the overview",
    "pensionKlant.instellen.verborgen": "Hidden",
    "pensionKlant.instellen.nietsVerborgen": "No hidden tiles",
    "pensionKlant.instellen.toonAria": "Show %s",
    "pensionKlant.instellen.verbergAria": "Hide %s",
    "pensionKlant.instellen.opKaartjeAria": "Put %s on the card",
    "pensionKlant.instellen.vanKaartjeAria": "Take %s off the card",
    "pensionKlant.dieren.kiesEen": "Pick an animal to see its details.",
    "pensionKlant.status.inPension": "Boarding",
    "pensionKlant.status.geenReservering": "No booking",
    // Elk kaartje eindigt in een doorgang naar het dierdossier, waar het onderwerp thuishoort.
    "pensionKlant.dier.gecastreerdJa": "Neutered",
    "pensionKlant.dier.gecastreerdNee": "Not neutered",
    "pensionKlant.actie.naarFacturen": "To the outstanding invoices",
    // Werkmodus Pension — the "Wegen" (weighing) overview.
    "pensionModules.overzichten": "Overviews",
    "pensionLijst.soort": "Species",
    "pensionLijst.zoek": "Search animal, customer or kennel…",
    "pensionLijst.resultaten": "%s animal(s)",
    "menu.pensionWegen": "Weighing",
    "menu.pensionVoerlijst": "Feeding list",
    "pensionVoerlijst.galerij": "Boarding — feeding list",
    "pensionVoerlijst.title": "Feeding list",
    "pensionVoerlijst.subtitle": "What goes in the bowl when, and who fed it.",
    "pensionVoerlijst.loadFailed": "Could not load the feeding list.",
    "pensionVoerlijst.datum": "Date",
    "pensionVoerlijst.vandaag": "Today",
    "pensionVoerlijst.initialen": "Initials",
    "pensionVoerlijst.gedrag": "Eating behaviour",
    "pensionVoerlijst.stickers": "Print labels",
    "pensionVoerlijst.dagdeel": "Part of day",
    "pensionVoerlijst.dagdeel.ALLE": "All day",
    "pensionVoerlijst.dagdeel.OCHTEND": "Morning",
    "pensionVoerlijst.dagdeel.MIDDAG": "Afternoon",
    "pensionVoerlijst.dagdeel.AVOND": "Evening",
    "pensionVoerlijst.teller.teVoeren": "To feed",
    "pensionVoerlijst.teller.gevoerd": "Fed",
    "pensionVoerlijst.teller.achterstallig": "Overdue",
    "pensionVoerlijst.teller.zonderPlan": "No feeding plan",
    "pensionVoerlijst.leeg": "No feeding moments on this date.",
    "pensionVoerlijst.kolom.tijd": "Time",
    "pensionVoerlijst.kolom.dier": "Animal",
    "pensionVoerlijst.kolom.kennel": "Kennel",
    "pensionVoerlijst.kolom.voer": "Food",
    "pensionVoerlijst.kolom.hoeveelheid": "Amount",
    "pensionVoerlijst.kolom.staat": "Status",
    "pensionVoerlijst.kolom.afvinken": "Check off",
    "pensionVoerlijst.staat.GEPLAND": "Planned",
    "pensionVoerlijst.staat.ACHTERSTALLIG": "Overdue",
    "pensionVoerlijst.staat.GEVOERD": "Fed",
    "pensionVoerlijst.staat.GEEN_PLAN": "No feeding plan",
    "pensionVoerlijst.gevoerd": "Fed",
    "pensionVoerlijst.klaar": "Done",
    "pensionVoerlijst.geenPlan": "Add a plan first",
    "pensionVoerlijst.mislukt": "Could not save.",
    "pensionVoerlijst.gram.titel": "Fed %s",
    "pensionVoerlijst.gram.uitleg":
        "The plan says \"%s\" — no number to record. How many grams went in the bowl?",
    "pensionVoerlijst.gram.veld": "Grams",
    "pensionVoerlijst.sticker.titel": "Feeding labels",
    "pensionVoerlijst.sticker.tijden": "Times",
    "pensionVoerlijst.sticker.dieet": "Diet",
    "pensionVoerlijst.sticker.notitie": "Note",
    "menu.pensionMedicatie": "Medication",
    "pensionMedicatie.galerij": "Boarding — medication",
    "pensionMedicatie.title": "Medication",
    "pensionMedicatie.subtitle": "Which dose is due when, and who gave it.",
    "pensionMedicatie.loadFailed": "Could not load the medication list.",
    "pensionMedicatie.datum": "Date",
    "pensionMedicatie.vandaag": "Today",
    "pensionMedicatie.initialen": "Initials",
    "pensionMedicatie.soort": "Species",
    "pensionMedicatie.soort.ALLE": "All",
    "pensionMedicatie.soort.HOND": "Dogs",
    "pensionMedicatie.soort.KAT": "Cats",
    "pensionMedicatie.soort.OVERIG": "Other",
    "pensionMedicatie.teller.teGeven": "To give",
    "pensionMedicatie.teller.gegeven": "Given",
    "pensionMedicatie.teller.achterstallig": "Overdue",
    "pensionMedicatie.teller.dieren": "Animals",
    "pensionMedicatie.leeg": "No medication for the guests on this date.",
    "pensionMedicatie.kolom.tijd": "Time",
    "pensionMedicatie.kolom.dier": "Animal",
    "pensionMedicatie.kolom.kennel": "Kennel",
    "pensionMedicatie.kolom.medicijn": "Medication",
    "pensionMedicatie.kolom.dosering": "Dose",
    "pensionMedicatie.kolom.staat": "Status",
    "pensionMedicatie.kolom.afvinken": "Check off",
    "pensionMedicatie.staat.GEPLAND": "Planned",
    "pensionMedicatie.staat.ACHTERSTALLIG": "Overdue",
    "pensionMedicatie.staat.GEGEVEN": "Given",
    "pensionMedicatie.gegeven": "Given",
    "pensionMedicatie.klaar": "Done",
    "pensionMedicatie.mislukt": "Could not save.",
    "menu.pensionBorstelen": "Brushing",
    "pensionBorstelen.galerij": "Boarding — brushing",
    "pensionBorstelen.title": "Brushing",
    "pensionBorstelen.subtitle": "Who is due for a brush today, at the frequency the customer asked for.",
    "pensionBorstelen.loadFailed": "Could not load the brushing list.",
    "pensionBorstelen.datum": "Date",
    "pensionBorstelen.vandaag": "Today",
    "pensionBorstelen.initialen": "Initials",
    "pensionBorstelen.soort": "Species",
    "pensionBorstelen.soort.ALLE": "All",
    "pensionBorstelen.soort.HOND": "Dogs",
    "pensionBorstelen.soort.KAT": "Cats",
    "pensionBorstelen.soort.OVERIG": "Other",
    "pensionBorstelen.teller.teDoen": "To brush",
    "pensionBorstelen.teller.gedaan": "Done",
    "pensionBorstelen.teller.bijzonderheid": "Something found",
    "pensionBorstelen.teller.zonderFrequentie": "No frequency set",
    "pensionBorstelen.leeg": "No boarding animals on this date.",
    "pensionBorstelen.kolom.dier": "Animal",
    "pensionBorstelen.kolom.klant": "Customer",
    "pensionBorstelen.kolom.kennel": "Kennel",
    "pensionBorstelen.kolom.frequentie": "Frequency",
    "pensionBorstelen.kolom.laatst": "Last brushed",
    "pensionBorstelen.kolom.reden": "Today",
    "pensionBorstelen.kolom.afvinken": "Check off",
    "pensionBorstelen.frequentieVoor": "Brushing frequency for %s",
    "pensionBorstelen.geenFrequentie": "Not set",
    "pensionBorstelen.reden.GEEN_FREQUENTIE": "No frequency",
    "pensionBorstelen.reden.VOLGENS_SCHEMA": "Due today",
    "pensionBorstelen.reden.ONBEKEND_SCHEMA": "Frequency unreadable",
    "pensionBorstelen.reden.NIET_VANDAAG": "Not today",
    "pensionBorstelen.reden.GEDAAN": "Done today",
    "pensionBorstelen.gedaan": "Brushed",
    "pensionBorstelen.bijzonderheid": "Something found",
    "pensionBorstelen.bijzonderheid.titel": "Brushing %s",
    "pensionBorstelen.bijzonderheid.wat": "What did you see?",
    "pensionBorstelen.mislukt": "Could not save.",
    "menu.pensionBodycheck": "Body check",
    "pensionBodycheck.galerij": "Boarding — body check",
    "pensionBodycheck.title": "Body check",
    "pensionBodycheck.subtitle": "Who is due for a check, and what was found last time.",
    "pensionBodycheck.loadFailed": "Could not load the body-check list.",
    "pensionBodycheck.datum": "Date",
    "pensionBodycheck.vandaag": "Today",
    "pensionBodycheck.initialen": "Initials",
    "pensionBodycheck.soort": "Species",
    "pensionBodycheck.soort.ALLE": "All",
    "pensionBodycheck.soort.HOND": "Dogs",
    "pensionBodycheck.soort.KAT": "Cats",
    "pensionBodycheck.soort.OVERIG": "Other",
    "pensionBodycheck.teller.teDoen": "To check",
    "pensionBodycheck.teller.gedaan": "Done",
    "pensionBodycheck.teller.bijzonderheid": "Something found",
    "pensionBodycheck.teller.nooitGedaan": "Not yet checked",
    "pensionBodycheck.leeg": "No boarding animals on this date.",
    "pensionBodycheck.kolom.dier": "Animal",
    "pensionBodycheck.kolom.klant": "Customer",
    "pensionBodycheck.kolom.kennel": "Kennel",
    "pensionBodycheck.kolom.laatst": "Last checked",
    "pensionBodycheck.kolom.bevinding": "Finding",
    "pensionBodycheck.kolom.reden": "Reason",
    "pensionBodycheck.kolom.afvinken": "Check off",
    "pensionBodycheck.reden.NOOIT_GEDAAN": "Not yet checked",
    "pensionBodycheck.reden.INTERVAL": "Due",
    "pensionBodycheck.reden.DAG_VOOR_VERTREK": "Day before departure",
    "pensionBodycheck.reden.GEDAAN": "Checked",
    "pensionBodycheck.bevinding.OK": "All fine",
    "pensionBodycheck.bevinding.BIJZONDERHEID": "Something found",
    "pensionBodycheck.ok": "All fine",
    "pensionBodycheck.bijzonderheid": "Something found",
    "pensionBodycheck.bijzonderheid.titel": "Body check %s",
    "pensionBodycheck.bijzonderheid.wat": "What did you see?",
    "pensionBodycheck.mislukt": "Could not save.",
    "pensionBodycheck.instellingen.knop": "Body-check settings",
    "pensionBodycheck.instellingen.titel": "Body-check settings",
    "pensionBodycheck.instellingen.uitleg":
        "How often a boarding animal is checked over, per location.",
    "pensionBodycheck.instellingen.interval": "Check every … days",
    "pensionBodycheck.instellingen.dagVoorVertrek": "Also check the day before departure",
    "pensionBodycheck.instellingen.mislukt": "Could not save the settings.",
    "pensionWegen.galerij": "Boarding — weighing",
    "pensionWegen.title": "Weighing",
    "pensionWegen.subtitle": "Who is due on the scales, and where the weight calls for action.",
    "pensionWegen.loadFailed": "Could not load the weighing list.",
    "pensionWegen.datum": "Date",
    "pensionWegen.vandaag": "Today",
    "pensionWegen.soort": "Species",
    "pensionWegen.soort.ALLE": "All",
    "pensionWegen.soort.HOND": "Dogs",
    "pensionWegen.soort.KAT": "Cats",
    "pensionWegen.soort.OVERIG": "Other",
    "pensionWegen.teller.teWegen": "To weigh",
    "pensionWegen.teller.gewogen": "Done",
    "pensionWegen.teller.actieNodig": "Action needed",
    "pensionWegen.teller.zonderStart": "No start weight",
    "pensionWegen.leeg": "No boarding animals on this date.",
    "pensionWegen.kolom.dier": "Animal",
    "pensionWegen.kolom.klant": "Customer",
    "pensionWegen.kolom.kennel": "Kennel",
    "pensionWegen.kolom.laatst": "Last weighed",
    "pensionWegen.kolom.gewicht": "Weight",
    "pensionWegen.kolom.verschil": "Difference",
    "pensionWegen.kolom.reden": "Reason",
    "pensionWegen.kolom.registreren": "Record",
    "pensionWegen.reden.GEEN_STARTGEWICHT": "No start weight",
    "pensionWegen.reden.INTERVAL": "Due",
    "pensionWegen.reden.DAG_VOOR_VERTREK": "Day before departure",
    "pensionWegen.reden.GEWOGEN": "Weighed",
    "pensionWegen.kg": "kg",
    "pensionWegen.kgVoor": "Weight in kg for %s",
    "pensionWegen.opslaan": "Save",
    "pensionWegen.instellingen.knop": "Weighing settings",
    "pensionWegen.instellingen.titel": "Weighing settings",
    "pensionWegen.instellingen.uitleg":
      "Every boarding house weighs differently, so these apply to this branch only.",
    "pensionWegen.instellingen.interval": "Weigh every … days",
    "pensionWegen.instellingen.dagVoorVertrek": "Also weigh the day before departure",
    "pensionWegen.instellingen.drempelLicht": "Action needed above … % (under the weight limit)",
    "pensionWegen.instellingen.drempelZwaar": "Action needed above … % (from the weight limit)",
    "pensionWegen.instellingen.grens": "Weight limit (kg)",
    "pensionWegen.instellingen.mislukt": "Could not save the settings.",
    // Settings dashboard (port of the Jmix SettingsDashboardView — route `instellingen`).
    "instellingen.title": "Settings",
    "instellingen.contextLabel": "Settings for:",
    "instellingen.context.organization": "Organization",
    "instellingen.activeContext": "Active context: %s",
    "instellingen.section.algemeen": "General",
    "instellingen.section.dieren": "Animals",
    "instellingen.tile.advertentie.title": "Advertisement",
    "instellingen.tile.advertentie.desc": "Which platform the adverts are published on — one setting for every shelter",
    "instellingen.advertentie.uitleg": "Applies to every shelter in this organisation. The live preview on the animal shows how the advert will look on the chosen platform.",
    "instellingen.advertentie.kanaal.DIERMATCH": "DierMatch.nl",
    "instellingen.advertentie.kanaal.DIERMATCH.uitleg": "For shelters publishing on DierMatch.nl.",
    "instellingen.advertentie.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "instellingen.advertentie.kanaal.IKZOEKBAAS.uitleg": "The Dierenbescherming platform.",
    "instellingen.advertentie.kanaal.BEIDE": "Both",
    "instellingen.advertentie.kanaal.BEIDE.uitleg": "The preview lets you switch between the two.",
    "instellingen.advertentie.fout": "The settings could not be saved. Please try again.",
    "instellingen.advertentie.afvoeren": "Take animals off the site automatically",
    "instellingen.advertentie.afvoerenUitleg":
      "Putting an animal on the site always stays a person's job. This is only about the end: once an animal has left the shelter it disappears by itself.",
    "instellingen.advertentie.geplaatstDagen": "Days visible as \"Placed\"",
    "instellingen.advertentie.geplaatstDagenUitleg":
      "An adopted animal stays on the site as \"Placed\" for this many days, then goes off. Animals that leave for another reason go off right away.",
    "instellingen.advertentie.geplaatstDagenNul":
      "An adopted animal goes off the site straight away.",
    "instellingen.advertentie.nieuwDagen": "Days shown as \"New in the shelter\"",
    "instellingen.advertentie.nieuwDagenUitleg":
      "After this many days in the shelter the ribbon reads \"Looking for a home\" instead of \"New in the shelter\".",
    "instellingen.advertentie.nieuwDagenNul":
      "No animal is shown as new; the ribbon reads \"Looking for a home\" from day one.",
    "instellingen.advertentie.contactTekst": "Text under \"Get in touch\"",
    "instellingen.advertentie.contactHint": "e.g. Call us or drop by during opening hours; an appointment is not needed.",
    "advertentieDetailView.preview.kanaal": "Platform",
    "advertentieDetailView.site.aan": "on",
    "advertentieDetailView.site.uit": "off",
    "advertentieDetailView.kanaal.label": "On which site",
    "advertentieDetailView.kanaal.uitleg": "Choose where this animal appears; the organisation setting only applies to a new advertisement.",
    "advertentieDetailView.kanaal.DIERMATCH": "DierMatch.nl",
    "advertentieDetailView.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieDetailView.kanaal.BEIDE": "Both",
    "advertentieDetailView.preview.kanaal.DIERMATCH": "DierMatch.nl",
    "advertentieDetailView.preview.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieIkzoekbaas.dieren": "Animals",
    "advertentieIkzoekbaas.andereDieren": "Other animals at this location",
    "advertentieIkzoekbaas.deelProfiel": "Share %s's profile",
    "advertentieIkzoekbaas.deelTekst": "I am looking for an owner! Tell your partner, housemate, friends and family.",
    "advertentieIkzoekbaas.kenmerken": "Characteristics",
    "advertentieIkzoekbaas.stap1": "Step 1: Find out if I suit you",
    "advertentieIkzoekbaas.stap2": "Step 2: Know our fees",
    "advertentieIkzoekbaas.naarWebsite": "To the fees",
    "advertentieIkzoekbaas.onbekend": "Unknown",
    "advertentieIkzoekbaas.kenmerkenInvullen": "Fill in these questions",
    "advertentieIkzoekbaas.fotos": "Manage photos",
    "advertentieIkzoekbaas.doneer": "DONATE",
    "advertentieIkzoekbaas.ig.likes": "Liked by dierenbescherming and others",
    "advertentieIkzoekbaas.ig.meer": "… more",
    "advertentieIkzoekbaas.ig.tijd": "Just now",
    "advertentieDetailView.publicatie.leeg": "Not published yet.",
    "advertentieIkzoekbaas.neemContact": "Get in touch",
    "advertentieIkzoekbaas.stap3": "Step 3: Get in touch",
    "advertentieIkzoekbaas.stap3.tekst": "Think %s suits you? Get in touch with the shelter.",
    "advertentieIkzoekbaas.geenTekst": "No text about this animal has been written yet.",
    "instellingen.section.financieel": "Finance",
    "instellingen.cta.open": "Open ›",
    "instellingen.comingSoon.body":
      "This setting is being migrated to the new platform and is not available here yet. Use the classic view for now.",
    "instellingen.comingSoon.items": "Includes:",
    // Gemeente tile detail (settings-gemeente — the first migrated tile).
    "instellingen.gemeente.title": "Municipalities & towns",
    "instellingen.gemeente.searchLabel": "Search",
    "instellingen.gemeente.searchPlaceholder": "Name, province or town…",
    "instellingen.gemeente.filterLabel": "Status",
    "instellingen.gemeente.filter.all": "All",
    "instellingen.gemeente.filter.active": "Active",
    "instellingen.gemeente.filter.inactive": "Inactive",
    "instellingen.gemeente.new": "New municipality",
    "instellingen.gemeente.col.naam": "Name",
    "instellingen.gemeente.col.provincie": "Province",
    "instellingen.gemeente.col.status": "Status",
    "instellingen.gemeente.col.woonplaatsen": "Towns",
    "instellingen.gemeente.status.active": "Active",
    "instellingen.gemeente.status.inactive": "Inactive",
    "instellingen.gemeente.empty": "No municipalities found.",
    "instellingen.gemeente.loadFailed": "Could not load municipalities.",
    "instellingen.gemeente.detail.empty": "Select a municipality to view its details.",
    "instellingen.gemeente.detail.edit": "Edit",
    "instellingen.gemeente.detail.delete": "Delete",
    "instellingen.gemeente.detail.active": "Active",
    "instellingen.gemeente.delete.confirm": "Are you sure you want to delete municipality \"%s\"?",
    "instellingen.gemeente.create.title": "New municipality",
    "instellingen.gemeente.edit.title": "Edit municipality",
    "instellingen.gemeente.form.naam": "Name",
    "instellingen.gemeente.form.provincie": "Province",
    "instellingen.gemeente.woonplaatsen.title": "Towns",
    "instellingen.gemeente.woonplaatsen.add": "Add town",
    "instellingen.gemeente.woonplaatsen.edit": "Edit",
    "instellingen.gemeente.woonplaatsen.delete": "Delete",
    "instellingen.gemeente.woonplaatsen.empty": "No towns yet.",
    "instellingen.gemeente.woonplaatsen.label": "Town",
    "instellingen.gemeente.woonplaatsen.col.naam": "Town",
    "instellingen.gemeente.woonplaatsen.col.actions": "Actions",
    "instellingen.gemeente.error.nameRequired": "Name is required.",
    "instellingen.gemeente.error.duplicateNaam": "This municipality already exists.",
    "instellingen.gemeente.error.townRequired": "Town is required.",
    "instellingen.gemeente.error.duplicateWoonplaats": "This town already exists.",
    "instellingen.tile.animals.title": "Animals",
    "instellingen.tile.animals.desc": "Manage animal reference data",
    "instellingen.tile.breedWeights.title": "Weight ranges",
    "instellingen.tile.breedWeights.desc": "Manage expected weight ranges per breed",
    "instellingen.item.breedWeights.bands": "Bands per age block",
    "instellingen.item.breedWeights.ai": "AI suggestions",
    "instellingen.item.breedWeights.review": "Review & activate",
    "instellingen.gewichtsbandbreedte.title": "Weight ranges",
    "instellingen.gewichtsbandbreedte.subtitle": "Scope: %s",
    "instellingen.gewichtsbandbreedte.noAccess": "You do not have permission to manage weight ranges.",
    "instellingen.gewichtsbandbreedte.speciesLabel": "Species",
    "instellingen.gewichtsbandbreedte.breedLabel": "Breed",
    "instellingen.gewichtsbandbreedte.choosBreed": "Choose a breed…",
    "instellingen.gewichtsbandbreedte.pickBreedHint": "Pick a species and breed to manage its weight ranges.",
    "instellingen.gewichtsbandbreedte.add": "Add rule",
    "instellingen.gewichtsbandbreedte.edit": "Edit",
    "instellingen.gewichtsbandbreedte.remove": "Deactivate",
    "instellingen.gewichtsbandbreedte.review": "Activate + approve",
    "instellingen.gewichtsbandbreedte.aiSuggest": "Generate AI suggestion",
    "instellingen.gewichtsbandbreedte.create": "Add range",
    "instellingen.gewichtsbandbreedte.editTitle": "Edit range",
    "instellingen.gewichtsbandbreedte.saved": "Rule saved.",
    "instellingen.gewichtsbandbreedte.deactivated": "Rule deactivated.",
    "instellingen.gewichtsbandbreedte.activated": "Rule approved and activated.",
    "instellingen.gewichtsbandbreedte.aiBusy": "Generating AI suggestion…",
    "instellingen.gewichtsbandbreedte.aiAdded": "%s AI draft rule(s) added (not yet reviewed).",
    "instellingen.gewichtsbandbreedte.aiNone": "AI provided no reliable suggestion for this breed.",
    "instellingen.gewichtsbandbreedte.empty": "No rules for this breed yet.",
    "instellingen.gewichtsbandbreedte.conceptHint": "AI draft rules are inactive and unreviewed; they are not used for the chart until approved.",
    "instellingen.gewichtsbandbreedte.months": "mo",
    "instellingen.gewichtsbandbreedte.col.age": "Age",
    "instellingen.gewichtsbandbreedte.col.sex": "Sex",
    "instellingen.gewichtsbandbreedte.col.neutered": "Neutered",
    "instellingen.gewichtsbandbreedte.col.min": "Min (kg)",
    "instellingen.gewichtsbandbreedte.col.ideal": "Ideal (kg)",
    "instellingen.gewichtsbandbreedte.col.max": "Max (kg)",
    "instellingen.gewichtsbandbreedte.col.source": "Source",
    "instellingen.gewichtsbandbreedte.col.confidence": "Confidence",
    "instellingen.gewichtsbandbreedte.col.status": "Status",
    "instellingen.gewichtsbandbreedte.col.scope": "Scope",
    "instellingen.gewichtsbandbreedte.status.ACTIEF": "Active",
    "instellingen.gewichtsbandbreedte.status.CONCEPT": "Draft — not reviewed",
    "instellingen.gewichtsbandbreedte.status.INACTIEF": "Inactive",
    "instellingen.gewichtsbandbreedte.scope.platform": "Platform",
    "instellingen.gewichtsbandbreedte.scope.vestiging": "Branch",
    "instellingen.gewichtsbandbreedte.field.ageFrom": "Age from (months)",
    "instellingen.gewichtsbandbreedte.field.ageTo": "Age up to (months)",
    "instellingen.gewichtsbandbreedte.field.sex": "Sex (empty = both)",
    "instellingen.gewichtsbandbreedte.field.neutered": "Neutered (empty = both)",
    "instellingen.gewichtsbandbreedte.field.both": "Both",
    "instellingen.gewichtsbandbreedte.field.min": "Minimum weight (kg)",
    "instellingen.gewichtsbandbreedte.field.ideal": "Ideal weight (kg, optional)",
    "instellingen.gewichtsbandbreedte.field.max": "Maximum weight (kg)",
    "instellingen.gewichtsbandbreedte.field.confidence": "Confidence",
    "instellingen.gewichtsbandbreedte.field.sourceName": "Source name",
    "instellingen.gewichtsbandbreedte.field.sourceUrl": "Source URL",
    "instellingen.gewichtsbandbreedte.field.changeReason": "Change reason (optional)",
    "instellingen.gewichtsbandbreedte.field.actief": "Active",
    "instellingen.gewichtsbandbreedte.field.reviewed": "Reviewed",
    "instellingen.gewichtsbandbreedte.err.age": "Enter a valid age block (from ≤ to, both ≥ 0).",
    "instellingen.gewichtsbandbreedte.err.minmaxRequired": "Minimum and maximum weight are required.",
    "instellingen.gewichtsbandbreedte.err.positive": "Weights must be greater than 0.",
    "instellingen.gewichtsbandbreedte.err.minLtMax": "Minimum must be less than maximum.",
    "instellingen.gewichtsbandbreedte.err.idealBetween": "Ideal weight must be between minimum and maximum.",
    "instellingen.tile.gemeente.title": "Municipality",
    "instellingen.tile.gemeente.desc": "Manage the list of municipalities",
    "instellingen.tile.finance.title": "Finance",
    "instellingen.tile.finance.desc": "Configure bookkeeping and ledger",
    "instellingen.tile.communication.title": "Communication & contracts",
    "instellingen.tile.communication.desc": "Manage contracts and e-mail templates",
    "instellingen.tile.integrations.title": "Integrations",
    "instellingen.tile.integrations.desc": "Manage external integrations",
    "instellingen.tile.pension.title": "Boarding",
    "instellingen.tile.pension.desc": "Manage boarding rules and capacity",
    "instellingen.tile.pleeggezinnen.title": "Foster homes",
    "instellingen.tile.pleeggezinnen.desc": "Manage foster homes and care facilities",
    "instellingen.tile.taken.title": "Tasks",
    "instellingen.tile.taken.desc": "Automatic task rules, deadline rules and task packages",
    "instellingen.tile.wizards.title": "Registrations & Wizards",
    "instellingen.tile.wizards.desc": "Configurable registration wizards with a dynamic tile",
    "instellingen.item.vacht": "Coat",
    "instellingen.item.kleur": "Colour",
    "instellingen.item.kenneleigenschap": "Kennel property",
    "instellingen.item.ras": "Breed",
    "instellingen.item.gemeente": "Municipality",
    "instellingen.item.koppelingBoekhouding": "Bookkeeping connection",
    "instellingen.item.grootboeknummers": "Ledger accounts",
    "instellingen.item.afdrukken": "Printing",
    "instellingen.item.contracten": "Contracts",
    "instellingen.item.emailBerichten": "E-mail messages",
    "instellingen.item.aiKoppeling": "AI connection",
    "instellingen.item.berekeningPension": "Boarding calculation",
    "instellingen.item.hoogseizoenDagen": "High-season days",
    "instellingen.item.capaciteit": "Capacity",
    "instellingen.item.accommodaties": "Accommodation types",
    "instellingen.item.pensionVol": "Boarding full",
    "instellingen.pension.pensionVol.desc": "Days on which the boarding is full for a species; no bookings can be made for those animals",
    "instellingen.item.opvangcategorieen": "Care categories",
    "instellingen.item.vestigingSpecifiek": "Location-specific",
    "instellingen.item.boekhouden": "Bookkeeping",
    "instellingen.item.grootboek": "Ledger",
    "instellingen.item.mailLayout": "Mail layout",
    "instellingen.item.idealMollie": "iDEAL/Mollie",
    "instellingen.item.pinapparaat": "PIN device",
    "instellingen.item.petbase": "PetBase",
    "instellingen.item.automatischeTaken": "Automatic tasks",
    "instellingen.item.wizardsBeheren": "Manage wizards",
    "instellingen.ai.title": "AI connection",
    "instellingen.tile.platform.title": "Platform connection",
    "instellingen.tile.platform.desc": "Pair this backoffice with the Fawkes platform (foster families, absences, aftercare, DierMatch).",
    "instellingen.item.platformKoppeling": "Pairing & connection test",
    "platformKoppeling.title": "Platform connection",
    "platformKoppeling.description": "The connection with the Fawkes platform. Pair with a code from the platform, then test both directions here.",
    "platformKoppeling.loadFailed": "The platform connection could not be loaded.",
    "platformKoppeling.status.connected": "Connected",
    "platformKoppeling.status.legacy": "From the application settings",
    "platformKoppeling.status.none": "Not connected",
    "platformKoppeling.origin.PAIRING": "paired with a code",
    "platformKoppeling.origin.MANUAL": "entered manually",
    "platformKoppeling.field.platform": "Platform",
    "platformKoppeling.field.organization": "Organization ID",
    "platformKoppeling.field.clientId": "Client ID",
    "platformKoppeling.field.secret": "Secret",
    "platformKoppeling.field.features": "Features",
    "platformKoppeling.field.updated": "Last changed",
    "platformKoppeling.feature.FOSTER_WEBHOOKS": "Foster families",
    "platformKoppeling.feature.ABSENCES": "Absences",
    "platformKoppeling.feature.NAZORG": "Aftercare",
    "platformKoppeling.feature.PUBLICATIONS": "DierMatch",
    "platformKoppeling.feature.WHATSAPP": "WhatsApp",
    "platformKoppeling.test": "Test connection",
    "platformKoppeling.unpair": "Unpair",
    "platformKoppeling.unpair.confirm": "Remove the stored connection? The application settings apply again.",
    "platformKoppeling.unpaired": "The stored connection was removed.",
    "platformKoppeling.pair.title": "Pair with the platform",
    "platformKoppeling.pair.intro": "A platform administrator creates a pairing code for this organization. Paste it here; it is valid for a short time and works once. The current connection keeps working until the new pairing is confirmed.",
    "platformKoppeling.pair.code": "Pairing code",
    "platformKoppeling.pair.backofficeUrl": "Address of this backoffice",
    "platformKoppeling.pair.backofficeUrl.help": "The platform calls this backoffice at this address.",
    "platformKoppeling.pair.redeem": "Redeem code",
    "platformKoppeling.pending.title": "Confirm the pairing",
    "platformKoppeling.pending.intro": "The platform accepted the code. Allow the platform's addresses and confirm; the platform then checks that it can reach this backoffice.",
    "platformKoppeling.pending.confirmBefore": "Confirm before %s.",
    "platformKoppeling.pending.egress": "Platform addresses to allow",
    "platformKoppeling.pending.noEgress": "The platform did not list its addresses. Enter the address it calls from, or confirm and allow the refused address afterwards.",
    "platformKoppeling.pending.extraIp": "Other address (optional)",
    "platformKoppeling.pending.confirm": "Confirm",
    "platformKoppeling.pending.cancel": "Cancel pairing",
    "platformKoppeling.confirmed": "The pairing is active.",
    "platformKoppeling.confirmFailed": "The platform could not reach this backoffice: %s",
    "platformKoppeling.rejections.title": "Recently refused token requests",
    "platformKoppeling.rejections.none": "No refused requests.",
    "platformKoppeling.rejections.allowAndRetry": "Allow %s and confirm again",
    "platformKoppeling.test.title": "Test result",
    "platformKoppeling.test.column.check": "Check",
    "platformKoppeling.test.column.status": "Result",
    "platformKoppeling.test.column.detail": "Details",
    "platformKoppeling.test.check.OUTBOUND": "Backoffice → platform",
    "platformKoppeling.test.check.ORGANIZATION": "Organization",
    "platformKoppeling.test.check.INBOUND": "Platform → backoffice",
    "platformKoppeling.test.status.OK": "OK",
    "platformKoppeling.test.status.FAILED": "Failed",
    "platformKoppeling.test.status.SKIPPED": "Skipped",
    "platformKoppeling.test.callerIp": "The platform sees this backoffice as %s.",
    "platformKoppeling.error.generic": "The request failed.",
    "tokenRejection.column.time": "Time",
    "tokenRejection.column.reason": "Reason",
    "tokenRejection.column.ip": "Caller IP",
    "tokenRejection.reason.ip_mismatch": "Address not allowed",
    "tokenRejection.reason.bad_secret": "Wrong secret",
    "tokenRejection.reason.removed_credential": "Credential removed",
    "tokenRejection.reason.expired_credential": "Credential expired",
    "tokenRejection.reason.disabled_account": "Account disabled",
    "tokenRejection.reason.no_authorities": "No roles",
    "tokenRejection.allowIp": "Allow IP",
    "tokenRejection.proxyAddress": "Proxy address — cannot be allowed",
    "tokenRejection.proxyAddress.help": "One or more refusals come from an internal address (such as 0:0:0:0:0:0:0:1 or 127.0.0.1). That is this backoffice's own reverse proxy, not the real caller: allowing it would let every caller through. Set fawkes.api.service-account-token.trusted-proxies (for example 127.0.0.1/32,::1/128) and restart the backoffice; the real caller's address then appears here.",
    "serviceAccountDetailView.credentials.column.lastUsedIp": "Last IP",
    "serviceAccountDetailView.rejections.title": "Refused token requests (last 7 days)",
    "serviceAccountDetailView.rejections.none": "No refused requests.",
    "instellingen.ai.description":
      "Choose which AI provider answers by default, and an optional fallback when it is unavailable.",
    "instellingen.ai.defaultProvider": "Default provider",
    "instellingen.ai.fallbackEnabled": "Enable fallback",
    "instellingen.ai.fallbackProvider": "Fallback provider",
    "instellingen.ai.saved": "Settings saved.",
    "instellingen.ai.loadFailed": "The AI settings could not be loaded.",
    "instellingen.ai.providersTitle": "API keys per provider",
    "instellingen.ai.providersDescription":
      "Set the API key and model per AI provider. Leave the key blank to keep the stored one.",
    "instellingen.ai.field.apiKey": "API key",
    "instellingen.ai.field.apiKey.keep": "Leave blank to keep the stored key",
    "instellingen.ai.field.model": "Model",
    "instellingen.ai.modellen.kies": "Choose a model…",
    "instellingen.ai.modellen.onbekend": "%s — not offered by this provider",
    "instellingen.ai.modellen.onbekendUitleg": "This provider does not offer \"%s\". Pick one from the list, or calls will keep failing.",
    "instellingen.ai.modellen.mislukt": "Could not fetch the models; type the name yourself.",
    "instellingen.ai.modellen.eerstSleutel": "Enter an API key and save; then the models can be fetched.",
    "instellingen.ai.field.enabled": "Enabled",
    "instellingen.ai.providerSaved": "Key saved.",
    "instellingen.communicatie.subtitle":
      "Manage contracts, prints and e-mail templates. Templates can be adjusted per location when allowed.",
    "instellingen.communicatie.search": "Search",
    "instellingen.communicatie.empty": "No items.",
    "instellingen.communicatie.breadcrumb.organisatie": "Organization",
    "instellingen.communicatie.breadcrumb.vestiging": "Location",
    "instellingen.communicatie.column.naam": "Name",
    "instellingen.communicatie.column.pad": "Path",
    "instellingen.communicatie.column.volgorde": "Order",
    "instellingen.communicatie.column.acties": "Actions",
    "instellingen.communicatie.column.onderwerp": "Subject",
    "instellingen.communicatie.column.ontvanger": "Recipient",
    "instellingen.communicatie.column.type": "Type",
    "instellingen.communicatie.column.nummer": "Number",
    "instellingen.communicatie.column.vestiging": "Location",
    "instellingen.communicatie.column.dagenPerWeek": "Days/week",
    "instellingen.communicatie.column.periode": "Period",
    "instellingen.communicatie.column.status": "Status",
    "instellingen.communicatie.type.email": "E-mail",
    "instellingen.communicatie.type.afdruk": "Print",
    "instellingen.communicatie.status.actief": "Active",
    "instellingen.communicatie.status.geannuleerd": "Cancelled",
    "instellingen.communicatie.periode.onbeperkt": "Unlimited",
    "instellingen.communicatie.add.afdruk": "New print",
    "instellingen.communicatie.edit.afdruk": "Edit print",
    "instellingen.communicatie.edit.email": "Edit e-mail message",
    "instellingen.communicatie.mailLayout.readOnly":
      "This location may not adjust the organization mail layout.",
    "instellingen.communicatie.field.naam": "Name",
    "instellingen.communicatie.field.pad": "Path (JasperReports template)",
    "instellingen.communicatie.field.rapportinstelling": "Report setting",
    "instellingen.communicatie.field.kies": "Choose…",
    "instellingen.communicatie.field.volgorde": "Order",
    "instellingen.communicatie.field.onderwerp": "Subject",
    "instellingen.communicatie.field.ontvanger": "Default recipient",
    "instellingen.communicatie.field.bericht": "Message",
    // Koppelingen (integrations) tile — branch context. Secrets are write-only/masked.
    "instellingen.integraties.loadError": "The integration settings could not be loaded.",
    "instellingen.integraties.status.configured": "Configured",
    "instellingen.integraties.status.configuredTail": "Configured (•••• %s)",
    "instellingen.integraties.status.notConfigured": "Not configured",
    "instellingen.integraties.secret.empty": "Not configured",
    "instellingen.integraties.field.apiKey": "API key",
    "instellingen.integraties.field.profileId": "Profile ID",
    "instellingen.integraties.field.methods": "Payment methods",
    "instellingen.integraties.field.webhook": "Webhook URL",
    "instellingen.integraties.field.active": "Active",
    "instellingen.integraties.field.provider": "Payment provider",
    "instellingen.integraties.field.merchantId": "Merchant ID",
    "instellingen.integraties.field.merchantAccount": "Merchant account",
    "instellingen.integraties.field.clientId": "Client ID",
    "instellingen.integraties.field.username": "Username",
    "instellingen.integraties.field.password": "Password",
    "instellingen.integraties.field.locale": "Locale (e-mail language)",
    // Financieel tile → Koppeling boekhouding (accounting connection).
    "instellingen.boekhouding.title": "Bookkeeping connection",
    "instellingen.boekhouding.subtitle": "Connect to an external accounting package",
    "instellingen.boekhouding.providerLabel": "Accounting package",
    "instellingen.boekhouding.status.connected": "Connected to %s",
    "instellingen.boekhouding.status.disconnected": "Not yet connected to %s",
    "instellingen.boekhouding.account": "Account: %s",
    "instellingen.boekhouding.account.none": "Account: not yet linked",
    "instellingen.boekhouding.lastSync": "Last synced: %s",
    "instellingen.boekhouding.lastSync.never": "never",
    "instellingen.boekhouding.badge.connected": "Connected",
    "instellingen.boekhouding.badge.disconnected": "Not connected",
    "instellingen.boekhouding.action.connect": "Connect",
    "instellingen.boekhouding.action.resync": "Resynchronize",
    "instellingen.boekhouding.action.settings": "Settings",
    "instellingen.boekhouding.action.disconnect": "Disconnect",
    "instellingen.boekhouding.form.connectTitle": "Connect to %s",
    "instellingen.boekhouding.form.settingsTitle": "%s settings",
    "instellingen.boekhouding.form.clientId": "Client ID",
    "instellingen.boekhouding.form.clientSecret": "Client secret",
    "instellingen.boekhouding.form.clientSecret.keep": "Leave blank to keep the stored secret",
    "instellingen.boekhouding.form.redirectUri": "Redirect URI",
    "instellingen.boekhouding.extra.division": "Division",
    "instellingen.boekhouding.extra.officeCode": "Office code",
    "instellingen.boekhouding.extra.administrationId": "Administration ID",
    "instellingen.boekhouding.extra.environmentId": "Environment ID",
    "instellingen.boekhouding.secret.configured": "A client secret is configured",
    "instellingen.boekhouding.error.generic": "Something went wrong. Please try again.",
    "instellingen.boekhouding.error.connectRequired": "Client ID, redirect URI and client secret are required to connect.",
    "instellingen.boekhouding.save": "Save",
    // Financieel tile → Grootboeknummers (ledger accounts).
    "instellingen.grootboek.title": "Ledger accounts",
    "instellingen.grootboek.search.placeholder": "Search by number or name…",
    "instellingen.grootboek.empty": "No ledger accounts.",
    "instellingen.grootboek.loadFailed": "Could not load ledger accounts.",
    "instellingen.grootboek.create": "New ledger account",
    "instellingen.grootboek.edit": "Edit",
    "instellingen.grootboek.delete": "Delete",
    "instellingen.grootboek.column.nummer": "Number",
    "instellingen.grootboek.column.omschrijving": "Name",
    "instellingen.grootboek.column.type": "Type",
    "instellingen.grootboek.column.status": "Status",
    "instellingen.grootboek.column.actions": "Actions",
    "instellingen.grootboek.status.active": "Active",
    "instellingen.grootboek.status.inactive": "Inactive",
    "instellingen.grootboek.field.nummer": "Ledger number",
    "instellingen.grootboek.field.omschrijving": "Name",
    "instellingen.grootboek.field.type": "Type",
    "instellingen.grootboek.field.actief": "Active",
    "instellingen.grootboek.type.activa": "Assets",
    "instellingen.grootboek.type.passiva": "Liabilities",
    "instellingen.grootboek.type.kosten": "Costs",
    "instellingen.grootboek.type.opbrengst": "Revenue",
    "instellingen.grootboek.create.title": "New ledger account",
    "instellingen.grootboek.edit.title": "Edit ledger account",
    "instellingen.grootboek.delete.title": "Delete ledger account",
    "instellingen.grootboek.delete.inUse":
      "%d reference(s) still use \"%s\". Choose a replacement ledger account; the references are moved to it before deleting:",
    "instellingen.grootboek.delete.replacementLabel": "Move references to",
    "instellingen.grootboek.delete.choosePlaceholder": "Choose a ledger account…",
    "instellingen.grootboek.delete.transferAndDelete": "Reassign & delete",
    "instellingen.grootboek.saveFailed": "Could not save the ledger account. The number may already exist.",
    "instellingen.grootboek.deleteFailed": "Could not delete the ledger account.",

    // settings-rest: migrated Pension / Pleeggezinnen / Dieren-stamgegevens tile keys.
    "common.yes": "Yes",
    "common.no": "No",
    "instellingen.pension.new": "New",
    "instellingen.pension.edit": "Edit",
    "instellingen.pension.delete": "Delete",
    "instellingen.pension.field.naam": "Name",
    "instellingen.pension.field.kleur": "Kennel planning colour",
    "instellingen.pension.field.toon": "Show in kennel planning",
    "instellingen.pension.field.datum": "Date",
    "instellingen.pension.field.diersoort": "Animal type",
    "instellingen.pension.diersoort.placeholder": "Choose an animal type…",
    "instellingen.pension.berekening.title": "Boarding calculation",
    "instellingen.pension.berekening.desc": "Manage boarding characteristics and kennel-planning colours",
    "instellingen.pension.berekening.col.naam": "Name",
    "instellingen.pension.berekening.col.kleur": "Colour",
    "instellingen.pension.berekening.col.toon": "In kennel planning",
    "instellingen.pension.berekening.empty": "No boarding characteristics yet.",
    "instellingen.pension.berekening.loadFailed": "Could not load the boarding characteristics.",
    "instellingen.pension.hoogseizoen.title": "High-season days",
    "instellingen.pension.hoogseizoen.desc": "Manage full-boarding dates per animal type for this branch",
    "instellingen.pension.hoogseizoen.col.datum": "Date",
    "instellingen.pension.hoogseizoen.col.diersoort": "Animal type",
    "instellingen.pension.hoogseizoen.empty": "No days on which boarding is full yet.",
    "instellingen.pension.hoogseizoen.loadFailed": "Could not load the days on which boarding is full.",
    "instellingen.pension.capaciteit.title": "Capacity",
    "instellingen.pension.capaciteit.desc": "Set the boarding capacity for this branch",
    "instellingen.pension.accommodaties.desc": "Accommodation types per species, with icon or logo",
    "instellingen.item.prijsberekening": "Price calculation",
    "instellingen.pension.prijsberekening.desc": "Charge boarding prices or day prices per accommodation, and the check-in and check-out rules",
    "instellingen.item.benaming": "Name: boarding or hotel",
    "instellingen.pension.benaming.desc": "Call your boarding kennel a hotel throughout the back office and the customer portal",
    "instellingen.item.annuleringsverzekering": "Cancellation insurance",
    "instellingen.pension.annuleringsverzekering.desc": "What the cancellation insurance costs per booking, offered in the New booking wizard",
    "instellingen.item.brengHaaltijden": "Drop-off and collection times",
    "instellingen.pension.brengHaaltijden.desc": "Per day of the week when animals can be brought in and collected; the New booking wizard offers only those times",
    "pensionBrengHaaltijden.titel": "Drop-off and collection times",
    "pensionBrengHaaltijden.uitleg": "Per day of the week the blocks in which animals are taken in and handed out. The New booking wizard offers only these times; without any blocks a day counts as closed. Set nothing at all and the desk picks freely.",
    "pensionBrengHaaltijden.stap": "Choose a time every",
    "pensionBrengHaaltijden.minuten": "%s minutes",
    "pensionBrengHaaltijden.dag": "Day",
    "pensionBrengHaaltijden.brengen": "Bringing in",
    "pensionBrengHaaltijden.halen": "Collecting",
    "pensionBrengHaaltijden.blokToevoegen": "Add block",
    "pensionBrengHaaltijden.blok.brengen": "Add a drop-off block on %s",
    "pensionBrengHaaltijden.blok.halen": "Add a collection block on %s",
    "pensionBrengHaaltijden.van.brengen": "Drop-off %s block %s from",
    "pensionBrengHaaltijden.tot.brengen": "Drop-off %s block %s until",
    "pensionBrengHaaltijden.weg.brengen": "Remove bringing in %s block %s",
    "pensionBrengHaaltijden.van.halen": "Collection %s block %s from",
    "pensionBrengHaaltijden.tot.halen": "Collection %s block %s until",
    "pensionBrengHaaltijden.weg.halen": "Remove collection %s block %s",
    "pensionBrengHaaltijden.dicht": "Closed",
    "pensionBrengHaaltijden.kopieer": "Copy %s to the other days",
    "pensionBrengHaaltijden.kopieerKolom": "Copy",
    "pensionBrengHaaltijden.ongeldig": "Every block ends after it starts.",
    "pensionBrengHaaltijden.alleenLezen": "Only a boarding administrator can change these times.",
    "pensionBrengHaaltijden.laden": "The times could not be loaded.",
    "pensionBrengHaaltijden.fout": "Saving failed. Try again.",
    "pensionBrengHaaltijden.opgeslagen": "Saved.",
    "instellingen.item.wizardIndeling": "New booking wizard",
    "instellingen.pension.wizardIndeling.desc": "Arrange the steps, parts and own questions of the New booking wizard",
    "pensionReserveringsproducten.titel": "Booking products",
    "pensionReserveringsproducten.uitleg": "The extra services this location sells per booking: a cancellation insurance, a care fund, a deposit.",
    "pensionReserveringsproducten.nogGeen": "No products yet.",
    "pensionReserveringsproducten.nieuw": "New product",
    "pensionReserveringsproducten.wijzigen": "Edit product",
    "pensionReserveringsproducten.naam": "Name",
    "pensionReserveringsproducten.aanbieden": "Offer on new bookings",
    "pensionReserveringsproducten.inactief": "not offered",
    "pensionReserveringsproducten.minimumVan": "minimum %s",
    "pensionReserveringsproducten.per.PER_RESERVERING": "per booking",
    "pensionReserveringsproducten.per.PER_DIER": "per animal",
    "pensionReserveringsproducten.per.PER_NACHT": "per night",
    "pensionReserveringsproducten.per.PER_DIER_PER_NACHT": "per animal per night",
    "pensionReserveringsproducten.per.PERCENTAGE": "of the stay plus extras",
    "pensionAnnuleringsverzekering.titel": "Cancellation insurance",
    "pensionAnnuleringsverzekering.uitleg": "What the cancellation insurance costs and how that amount becomes a premium. The New booking wizard offers it to the customer and shows the premium for that booking.",
    "pensionAnnuleringsverzekering.bedrag.PER_RESERVERING": "Amount per booking (incl. VAT)",
    "pensionAnnuleringsverzekering.bedrag.PER_DIER": "Amount per animal (incl. VAT)",
    "pensionAnnuleringsverzekering.bedrag.PER_NACHT": "Amount per night (incl. VAT)",
    "pensionAnnuleringsverzekering.bedrag.PER_DIER_PER_NACHT": "Amount per animal per night (incl. VAT)",
    "pensionAnnuleringsverzekering.berekening": "How it is calculated",
    "pensionAnnuleringsverzekering.berekening.PER_RESERVERING": "One amount per booking",
    "pensionAnnuleringsverzekering.berekening.PER_DIER": "Per animal",
    "pensionAnnuleringsverzekering.berekening.PER_NACHT": "Per night",
    "pensionAnnuleringsverzekering.berekening.PER_DIER_PER_NACHT": "Per animal per night",
    "pensionAnnuleringsverzekering.berekening.PERCENTAGE": "A percentage of the booking",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_RESERVERING": "The same amount whatever the booking looks like.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_DIER": "The amount times the number of animals on the booking.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_NACHT": "The amount times the number of nights; a day care visit counts as one.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_DIER_PER_NACHT": "The amount times the animals times the nights.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PERCENTAGE": "A percentage of the stay plus the extras — not of the product itself.",
    "pensionAnnuleringsverzekering.percentage": "Percentage of the booking",
    "pensionAnnuleringsverzekering.minimum": "Minimum amount (optional)",
    "pensionAnnuleringsverzekering.voorbeeld": "Example: two animals, four nights, € 240.00 of stay and extras → %s.",
    "pensionAnnuleringsverzekering.btw": "VAT percentage",
    "pensionAnnuleringsverzekering.geenBedrag": "Without an amount, this product is not offered.",
    "pensionAnnuleringsverzekering.ongeldig": "Enter an amount between 0 and 100,000, a percentage between 0 and 100, and a VAT percentage between 0 and 100. A minimum amount needs an amount to go with it.",
    "pensionAnnuleringsverzekering.alleenLezen": "Only a boarding administrator can change these products.",
    "pensionAnnuleringsverzekering.laden": "The reservation products could not be loaded.",
    "pensionAnnuleringsverzekering.fout": "Saving failed. Try again.",
    "pensionAnnuleringsverzekering.opgeslagen": "Saved.",
    "instellingen.pension.capaciteit.loadFailed": "Could not load the capacity.",
    "instellingen.pension.capaciteit.uitleg": "How many animals the boarding can take at the same time, per species. The wizard flags the days a booking would go over it. Leave a species empty and it has no limit.",
    "instellingen.pension.capaciteit.uitKennelplanning": "Take the capacity from the kennel planning",
    "instellingen.pension.capaciteit.uitKennelplanningUitleg": "The kennels of that species count, each for its own capacity — so a new kennel counts straight away.",
    "instellingen.pension.capaciteit.soort": "Species",
    "instellingen.pension.capaciteit.plaatsen": "Places",
    "instellingen.pension.capaciteit.plaatsenVan": "Places for %s",
    "instellingen.pension.capaciteit.kennelplanning": "Kennel planning",
    "instellingen.pension.capaciteit.hokken": "%d kennels, %d places",
    "instellingen.pension.capaciteit.geenHokken": "no kennels",
    "instellingen.pension.capaciteit.effectief": "Used for checks",
    "instellingen.pension.capaciteit.plaatsenAantal": "%d places",
    "instellingen.pension.capaciteit.geenGrens": "no limit",
    "instellingen.pension.capaciteit.geenSoorten": "No species yet. Add one to set its capacity.",
    "instellingen.pension.capaciteit.soortToevoegen": "Add species",
    "instellingen.pension.capaciteit.kies": "Choose…",
    "instellingen.pension.capaciteit.verwijderen": "Remove %s",
    "instellingen.pension.capaciteit.alleenLezen": "You can view the capacity, but not change it.",
    "instellingen.pension.capaciteit.fout": "Could not save the capacity.",
    "instellingen.pension.capaciteit.saved": "Capacity saved.",
    "instellingen.opvangcat.title": "Care categories",
    "instellingen.opvangcat.intro": "Manage the care categories foster homes in this branch can offer, per animal species.",
    "instellingen.opvangcat.add": "New category",
    "instellingen.opvangcat.empty": "No care categories yet.",
    "instellingen.opvangcat.loadFailed": "Could not load the care categories.",
    "instellingen.opvangcat.col.diersoort": "Species",
    "instellingen.opvangcat.col.naam": "Name",
    "instellingen.opvangcat.col.omschrijving": "Description",
    "instellingen.opvangcat.col.status": "Status",
    "instellingen.opvangcat.col.sortering": "Order",
    "instellingen.opvangcat.col.acties": "Actions",
    "instellingen.opvangcat.status.actief": "Active",
    "instellingen.opvangcat.status.inactief": "Inactive",
    "instellingen.opvangcat.edit": "Edit",
    "instellingen.opvangcat.create.title": "New care category",
    "instellingen.opvangcat.edit.title": "Edit care category",
    "instellingen.opvangcat.field.diersoort": "Species",
    "instellingen.opvangcat.field.diersoortPlaceholder": "Choose a species…",
    "instellingen.opvangcat.field.naam": "Name",
    "instellingen.opvangcat.field.omschrijving": "Description",
    "instellingen.opvangcat.field.sortering": "Order",
    "instellingen.opvangcat.field.actief": "Active",
    "instellingen.opvangcat.delete": "Delete",
    "instellingen.opvangcat.deleteInUse": "This category is in use by a foster home and can only be deactivated.",
    "instellingen.opvangcat.saveFailed": "Could not save the category.",
    "instellingen.opvangcat.pleeggezinActief": "Foster care active",
    "instellingen.opvangcat.pleeggezinFout": "Could not switch foster care for {soort}.",
    "instellingen.opvangcat.geenDiersoorten": "No animal species have been configured yet.",
    "instellingen.opvangcat.geenCategorieen": "No categories for this species yet.",
    "instellingen.dieren.title": "Animals",
    "instellingen.dieren.subtitle": "Manage reference data for animals",
    "instellingen.dieren.speciesLabel": "Species:",
    "instellingen.dieren.create": "New item",
    "instellingen.dieren.edit": "Edit",
    "instellingen.dieren.naam": "Name",
    "instellingen.dieren.kleurLabel": "Colour",
    "instellingen.dieren.editRow": "Edit",
    "instellingen.dieren.deleteRow": "Delete",
    "instellingen.dieren.empty": "No items for this species.",
    "instellingen.dieren.noResults": "No results for this search.",
    "instellingen.dieren.loadFailed": "Could not load the list.",
    "instellingen.dieren.vacht.title": "Coats",
    "instellingen.dieren.vacht.subtitle": "Manage coat types",
    "instellingen.dieren.vacht.add": "Add coat",
    "instellingen.dieren.vacht.search": "Search coat…",
    "instellingen.dieren.kleur.title": "Colours",
    "instellingen.dieren.kleur.subtitle": "Manage colours",
    "instellingen.dieren.kleur.add": "Add colour",
    "instellingen.dieren.kleur.search": "Search colour…",
    "instellingen.dieren.kenneleigenschap.title": "Kennel properties",
    "instellingen.dieren.kenneleigenschap.subtitle": "Manage kennel properties",
    "instellingen.dieren.kenneleigenschap.add": "Add kennel property",
    "instellingen.dieren.kenneleigenschap.search": "Search kennel property…",
    "instellingen.dieren.ras.title": "Breeds",
    "instellingen.dieren.ras.subtitle": "Manage breeds",
    "instellingen.dieren.ras.add": "Add breed",
    "instellingen.dieren.ras.search": "Search breed…",
    "instellingen.dieren.delete.title": "Delete",
    "instellingen.dieren.delete.inUse": "This item is linked to %s animal(s) (\"%s\"). Choose what happens before deleting:",
    "instellingen.dieren.delete.transferTo": "Transfer links to",
    "instellingen.dieren.delete.choosePlaceholder": "Choose a replacement…",
    "instellingen.dieren.delete.removeLinks": "Remove links & delete",
    "instellingen.dieren.delete.transfer": "Transfer & delete",
    // animal-detail migration: list + detail view i18n (merged from feature/animal-detail-spa)
    "animalListView.title": "Animals",
    // Dier aanwezig (present-animals overview) — SPA migration of the Jmix DierAttendanceOverview.
    "dierAanwezig.title": "Animals present",
    "dierAanwezig.subtitle": "Overview of the animals in the shelter",
    "dierAanwezig.results.found": "results found",
    "dierAanwezig.filter.all": "All",
    "dierAanwezig.filter.speciesSelected": "%d selected",
    "dierAanwezig.sortLabel": "Sort by",
    "dierAanwezig.search.placeholder": "Search animal by name, chip number, breed, colour…",
    "dierAanwezig.filter.age": "Age",
    "dierAanwezig.filter.age.young": "Young (< 1 yr)",
    "dierAanwezig.filter.age.adult": "Adult (1–8 yrs)",
    "dierAanwezig.filter.age.senior": "Senior (> 8 yrs)",
    "dierAanwezig.filter.age.under3m": "Under 3 months",
    "dierAanwezig.filter.age.under6m": "Under 6 months",
    "dierAanwezig.filter.age.range": "Between…",
    "dierAanwezig.filter.age.rangeLabel": "Age between",
    "dierAanwezig.filter.age.from": "from",
    "dierAanwezig.filter.age.to": "to",
    "dierAanwezig.filter.age.unit": "Unit",
    "dierAanwezig.filter.age.months": "months",
    "dierAanwezig.filter.age.weeks": "weeks",
    "dierAanwezig.filter.age.weeksShort": "wks",
    "dierAanwezig.filter.age.years": "years",
    "dierAanwezig.filter.age.rangeHint": "The upper bound is exclusive: 3 to 6 months = at least 3, under 6 months.",
    "dierAanwezig.filter.age.apply": "Apply",
    "dierAanwezig.filter.age.cancel": "Cancel",
    "dierAanwezig.filter.age.edit": "change",
    "dierAanwezig.filter.age.monthsShort": "mo",
    "dierAanwezig.filter.age.yearsShort": "yrs",
    "dierAanwezig.filter.age.fromShort": "from",
    "dierAanwezig.filter.age.toShort": "under",
    "dierAanwezig.field.gewichtsignaal": "Weight signal",
    "dierAanwezig.filter.gewicht": "Weight",
    "dierAanwezig.gewicht.onder": "Below target weight",
    "dierAanwezig.gewicht.boven": "Above target weight",
    "dierAanwezig.gewicht.binnen": "Within target weight",
    "dierAanwezig.gewicht.buiten": "Outside target weight",
    "dierAanwezig.gewicht.verlopen": "Weighing overdue",
    "dierAanwezig.gewicht.geen": "No target weight",
    "dierAanwezig.filter.dumped": "Dumped",
    "dierAanwezig.filter.minDays": "Min. days in shelter",
    "pleeg.titel": "Foster homes",
    "pleeg.geen": "None",
    "pleeg.beide": "Both",
    "pleeg.alleen": "Foster homes only",
    "pleeg.aantal": "%s in foster care",
    "pleeg.aantalEen": "1 in foster care",
    "dierAanwezig.filter.showFoster": "Show %d animals in foster care",
    "dierAanwezig.filter.showFosterOne": "Show %d animal in foster care",
    "dierAanwezig.filter.fosterActive": "Active",
    "dierAanwezig.filter.fosterInactive": "Inactive",
    "dierAanwezig.results.foundOne": "result found",
    "dierAanwezig.filter.more": "More filters",
    "filter.inklap": "Filters",
    "dierAanwezig.filter.opnameVan": "Intake from",
    "dierAanwezig.filter.opnameTot": "Intake until",
    "dierAanwezig.filter.vertrekVan": "Departure from",
    "dierAanwezig.filter.vertrekTot": "Departure until",
    "dierAanwezig.filter.vertrekSoort": "Status",
    "dierAanwezig.filter.gemeente": "Municipality",
    "dierAanwezig.filter.clear": "Clear filters",
    "dierAanwezig.sort.newest": "Newest first",
    "dierAanwezig.sort.name": "Name (A–Z)",
    "dierAanwezig.sort.oldest": "Longest in the shelter",
    "dierAanwezig.sort.departedNewest": "Most recently departed",
    "dierAanwezig.sort.departedOldest": "Departed longest ago",
    "dierAanwezig.sort.nameDesc": "Name (Z–A)",
    "dierAanwezig.sort.youngest": "Youngest animal first",
    "dierAanwezig.sort.oldestAge": "Oldest animal first",
    "dierAanwezig.sort.species": "Species",
    "dierAanwezig.sort.verblijfnr": "Stay number",
    "dierAanwezig.viewMode": "View",
    "dierAanwezig.cardMode": "Cards",
    "dierAanwezig.compactMode": "Compact",
    "dierAanwezig.listMode": "List",
    "dierAanwezig.fieldChooser.open": "Fields",
    "dierAanwezig.fieldChooser.title": "Card fields",
    "dierAanwezig.loadFailed": "Could not load animals.",
    "dierAanwezig.empty": "No animals present.",
    "dierAanwezig.yes": "Yes",
    "dierAanwezig.no": "No",
    "dierAanwezig.kruising": "crossbreed",
    "dierAanwezig.onbekendRas": "Unknown breed",
    "dierAanwezig.stat.total": "Total",
    "dierAanwezig.card.noPhoto": "Photo not yet available",
    "dierAanwezig.card.foster": "Foster home",
    "dierAanwezig.card.inShelterSince": "In shelter since",
    "dierAanwezig.card.day": "day",
    "dierAanwezig.card.days": "days",
    "dierAanwezig.card.chipLabel": "Chip number",
    "dierAanwezig.card.details": "Details",
    "dierAanwezig.field.ras": "Breed",
    "dierAanwezig.field.kleur": "Colour",
    "dierAanwezig.field.vacht": "Coat",
    "dierAanwezig.field.leeftijd": "Age",
    "dierAanwezig.field.geboortedatum": "Date of birth",
    "dierAanwezig.field.geslacht": "Sex",
    "dierAanwezig.field.gecastreerd": "Neutered",
    "dierAanwezig.field.status": "Status",
    "dierAanwezig.field.herkomst": "Origin",
    "dierAanwezig.field.diersoort": "Species",
    "dierAanwezig.field.opnamedatum": "Intake date",
    "dierAanwezig.field.gewicht": "Last weight",
    "dierAanwezig.field.entingen": "Vaccinations ok",
    "dierAanwezig.field.ontwormen": "Deworming ok",
    "dierAanwezig.field.ontvlooien": "Flea treatment ok",
    "dierAanwezig.field.pleegdagen": "Days in foster care",
    "dierAanwezig.veld.pleegdagen": "%s days",
    "dierAanwezig.veld.pleegdagEen": "1 day",
    "dierAanwezig.field.bijzonderheden": "Notes",
    "dierAanwezig.field.castratiedatum": "Neuter date",
    "dierAanwezig.field.paspoortnummer": "Passport number",
    "dierAanwezig.field.chipnummer": "Chip number",
    "dierAanwezig.field.foto": "Photo",
    // products-migration (vaccinations): the two ANIMAL-scoped status overviews — vaccination
    // (entingen) + deworming/flea (ontwormen). Faithful labels from the Jmix iframe sources.
    "entingenOverzicht.title": "Vaccinations",
    "entingenOverzicht.subtitle": "Overview of vaccination status and outstanding vaccination actions",
    "entingenOverzicht.kpi.aria": "Vaccination status",
    "entingenOverzicht.kpi.verlopen": "Vaccination expired",
    "entingenOverzicht.kpi.binnenkort": "Expiring soon",
    "entingenOverzicht.kpi.binnenkortSub": "(within 30 days)",
    "entingenOverzicht.kpi.ontbreekt": "Vaccination missing",
    "entingenOverzicht.kpi.ok": "Vaccinations OK",
    "entingenOverzicht.kpi.totaal": "Total animals",
    "entingenOverzicht.status.VERLOPEN": "Vaccination expired",
    "entingenOverzicht.status.BINNENKORT": "Expiring soon",
    "entingenOverzicht.status.ONTBREEKT": "Vaccination missing",
    "entingenOverzicht.status.OK": "Vaccinations OK",
    "entingenOverzicht.search.placeholder": "Search by name, chip number, stay…",
    "entingenOverzicht.filter.all": "All",
    "entingenOverzicht.filter.diersoort": "Species",
    "entingenOverzicht.filter.type": "Vaccination type",
    "entingenOverzicht.filter.clear": "Clear filters",
    "entingenOverzicht.filter.vervaldatumVan": "Expiry date from",
    "entingenOverzicht.filter.vervaldatumTot": "Expiry date to",
    "entingenOverzicht.stat.total": "Total",
    "entingenOverzicht.results.found": "results found",
    "entingenOverzicht.results.foundOne": "result found",
    "entingenOverzicht.pager.range": "%a - %b of %n animals",
    "entingenOverzicht.pager.empty": "0 animals",
    "entingenOverzicht.sortLabel": "Sort by",
    "entingenOverzicht.sort.urgent": "Most urgent first",
    "entingenOverzicht.sort.name": "Name (A-Z)",
    "entingenOverzicht.sort.due": "Due date (ascending)",
    "entingenOverzicht.sort.species": "Species",
    "entingenOverzicht.sort.nameDesc": "Name (Z-A)",
    "entingenOverzicht.sort.youngest": "Youngest animal first",
    "entingenOverzicht.sort.oldestAge": "Oldest animal first",
    "entingenOverzicht.sort.intakeNewest": "Most recent intake first",
    "entingenOverzicht.sort.intakeOldest": "Longest in the shelter",
    "entingenOverzicht.sort.kennel": "Kennel",
    "entingenOverzicht.foster.show": "Show %d animals in foster care",
    "entingenOverzicht.foster.showOne": "Show %d animal in foster care",
    "entingenOverzicht.foster.active": "Active",
    "entingenOverzicht.foster.inactive": "Inactive",
    "entingenOverzicht.card.foster": "Foster",
    "entingenOverzicht.filter.status": "Vaccination status",
    "entingenOverzicht.filter.statusNone": "None",
    "entingenOverzicht.filter.statusN": "%d selected",
    "entingenOverzicht.empty": "No animals found for these filters.",
    "entingenOverzicht.loadFailed": "Could not load the overview.",
    "entingenOverzicht.field.diersoort": "Species",
    "entingenOverzicht.field.leeftijd": "Age",
    "entingenOverzicht.field.kennel": "Kennel",
    "entingenOverzicht.field.entingstype": "Vaccination type",
    "entingenOverzicht.field.laatsteEnting": "Last vaccination",
    "entingenOverzicht.field.vervaldatum": "Expiry date",
    "entingenOverzicht.field.kleur": "Colour",
    "entingenOverzicht.field.vacht": "Coat",
    "entingenOverzicht.field.geboortedatum": "Date of birth",
    "entingenOverzicht.field.geslacht": "Sex",
    "entingenOverzicht.field.gecastreerd": "Neutered",
    "entingenOverzicht.field.castratiedatum": "Neuter date",
    "entingenOverzicht.field.herkomst": "Origin",
    "entingenOverzicht.field.opnamedatum": "Intake date",
    "entingenOverzicht.field.paspoortnummer": "Passport number",
    "entingenOverzicht.field.bijzonderheden": "Notes",
    "entingenOverzicht.field.chipnummer": "Chip number",
    "entingenOverzicht.veldkiezer.open": "Fields",
    "entingenOverzicht.veldkiezer.title": "Choose fields",
    "entingenOverzicht.veldkiezer.cancel": "Cancel",
    "entingenOverzicht.veldkiezer.save": "Save",
    "entingenOverzicht.weergave.grid": "Cards",
    "entingenOverzicht.weergave.compact": "Compact",
    "entingenOverzicht.weergave.lijst": "List",
    "entingenOverzicht.table.status": "Status",
    "entingenOverzicht.table.dier": "Animal",
    "entingenOverzicht.card.chipLabel": "Chip number",
    "entingenOverzicht.card.details": "Details",
    "entingenOverzicht.card.bewerken": "Add vaccination",
    "entingenOverzicht.card.instellingen": "Settings (products)",
    "entingenOverzicht.card.today": "today",
    "entingenOverzicht.card.inDays": "in %d days",
    "entingenOverzicht.card.daysAgo": "%d days ago",
    "entingenOverzicht.card.daysSigned": "%d days",
    "ontwormenOverzicht.title": "Deworming & flea control",
    "ontwormenOverzicht.subtitle": "Overview of deworming/flea status and outstanding treatments",
    "ontwormenOverzicht.kpi.aria": "Treatment status",
    "ontwormenOverzicht.kpi.verlopen": "Treatment expired",
    "ontwormenOverzicht.kpi.binnenkort": "Expiring soon",
    "ontwormenOverzicht.kpi.binnenkortSub": "(within 30 days)",
    "ontwormenOverzicht.kpi.ontbreekt": "Treatment missing",
    "ontwormenOverzicht.kpi.ok": "Treatments OK",
    "ontwormenOverzicht.kpi.totaal": "Total animals",
    "ontwormenOverzicht.status.VERLOPEN": "Treatment expired",
    "ontwormenOverzicht.status.BINNENKORT": "Expiring soon",
    "ontwormenOverzicht.status.ONTBREEKT": "Treatment missing",
    "ontwormenOverzicht.status.OK": "Treatments OK",
    "ontwormenOverzicht.search.placeholder": "Search by name, chip number, stay…",
    "ontwormenOverzicht.filter.all": "All",
    "ontwormenOverzicht.filter.diersoort": "Species",
    "ontwormenOverzicht.filter.type": "Treatment type",
    "ontwormenOverzicht.filter.clear": "Clear filters",
    "ontwormenOverzicht.filter.vervaldatumVan": "Expiry date from",
    "ontwormenOverzicht.filter.vervaldatumTot": "Expiry date to",
    "ontwormenOverzicht.stat.total": "Total",
    "ontwormenOverzicht.results.found": "results found",
    "ontwormenOverzicht.results.foundOne": "result found",
    "ontwormenOverzicht.pager.range": "%a - %b of %n animals",
    "ontwormenOverzicht.pager.empty": "0 animals",
    "ontwormenOverzicht.sortLabel": "Sort by",
    "ontwormenOverzicht.sort.urgent": "Most urgent first",
    "ontwormenOverzicht.sort.name": "Name (A-Z)",
    "ontwormenOverzicht.sort.due": "Next treatment (ascending)",
    "ontwormenOverzicht.sort.species": "Species",
    "ontwormenOverzicht.sort.nameDesc": "Name (Z-A)",
    "ontwormenOverzicht.sort.youngest": "Youngest animal first",
    "ontwormenOverzicht.sort.oldestAge": "Oldest animal first",
    "ontwormenOverzicht.sort.intakeNewest": "Most recent intake first",
    "ontwormenOverzicht.sort.intakeOldest": "Longest in the shelter",
    "ontwormenOverzicht.sort.kennel": "Kennel",
    "ontwormenOverzicht.foster.show": "Show %d animals in foster care",
    "ontwormenOverzicht.foster.showOne": "Show %d animal in foster care",
    "ontwormenOverzicht.foster.active": "Active",
    "ontwormenOverzicht.foster.inactive": "Inactive",
    "ontwormenOverzicht.card.foster": "Foster",
    "ontwormenOverzicht.filter.status": "Treatment status",
    "ontwormenOverzicht.filter.statusNone": "None",
    "ontwormenOverzicht.filter.statusN": "%d selected",
    "ontwormenOverzicht.empty": "No animals found for these filters.",
    "ontwormenOverzicht.loadFailed": "Could not load the overview.",
    "ontwormenOverzicht.field.diersoort": "Species",
    "ontwormenOverzicht.field.leeftijd": "Age",
    "ontwormenOverzicht.field.kennel": "Kennel",
    "ontwormenOverzicht.field.entingstype": "Treatment type",
    "ontwormenOverzicht.field.laatsteEnting": "Last treatment",
    "ontwormenOverzicht.field.vervaldatum": "Next due",
    "ontwormenOverzicht.field.kleur": "Colour",
    "ontwormenOverzicht.field.vacht": "Coat",
    "ontwormenOverzicht.field.geboortedatum": "Date of birth",
    "ontwormenOverzicht.field.geslacht": "Sex",
    "ontwormenOverzicht.field.gecastreerd": "Neutered",
    "ontwormenOverzicht.field.castratiedatum": "Neuter date",
    "ontwormenOverzicht.field.herkomst": "Origin",
    "ontwormenOverzicht.field.opnamedatum": "Intake date",
    "ontwormenOverzicht.field.paspoortnummer": "Passport number",
    "ontwormenOverzicht.field.bijzonderheden": "Notes",
    "ontwormenOverzicht.field.chipnummer": "Chip number",
    "ontwormenOverzicht.veldkiezer.open": "Fields",
    "ontwormenOverzicht.veldkiezer.title": "Choose fields",
    "ontwormenOverzicht.veldkiezer.cancel": "Cancel",
    "ontwormenOverzicht.veldkiezer.save": "Save",
    "ontwormenOverzicht.weergave.grid": "Cards",
    "ontwormenOverzicht.weergave.compact": "Compact",
    "ontwormenOverzicht.weergave.lijst": "List",
    "ontwormenOverzicht.table.status": "Status",
    "ontwormenOverzicht.table.dier": "Animal",
    "ontwormenOverzicht.card.chipLabel": "Chip number",
    "ontwormenOverzicht.card.details": "Details",
    "ontwormenOverzicht.card.bewerken": "Add treatment",
    "ontwormenOverzicht.card.instellingen": "Settings (products)",
    "ontwormenOverzicht.card.today": "today",
    "ontwormenOverzicht.card.inDays": "in %d days",
    "ontwormenOverzicht.card.daysAgo": "%d days ago",
    "ontwormenOverzicht.card.daysSigned": "%d days",
    "medicijnOverzicht.title": "Medication",
    "medicijnOverzicht.subtitle": "Overview of current medication, administrations and stop moments",
    "medicijnOverzicht.kpi.aria": "Medication status",
    "medicijnOverzicht.kpi.vandaag": "Administer today",
    "medicijnOverzicht.kpi.binnenkort": "Stopping soon",
    "medicijnOverzicht.kpi.binnenkortSub": "(within 7 days)",
    "medicijnOverzicht.kpi.actief": "Medication active",
    "medicijnOverzicht.kpi.historisch": "Historical",
    "medicijnOverzicht.kpi.totaal": "Total animals",
    "medicijnOverzicht.stat.total": "Total",
    "medicijnOverzicht.card.foster": "Foster",
    "medicijnOverzicht.foster.show": "Show %d animals in foster care",
    "medicijnOverzicht.foster.showOne": "Show %d animal in foster care",
    "medicijnOverzicht.foster.active": "Active",
    "medicijnOverzicht.foster.inactive": "Inactive",
    "medicijnOverzicht.status.TOEDIENING_VANDAAG": "Administer today",
    "medicijnOverzicht.status.BINNENKORT_STOPPEN": "Stopping soon",
    "medicijnOverzicht.status.ACTIEF": "Medication active",
    "medicijnOverzicht.status.HISTORISCH": "Historical",
    "medicijnOverzicht.search.placeholder": "Search by name, chip number, medication…",
    "medicijnOverzicht.filter.all": "All",
    "medicijnOverzicht.filter.diersoort": "Species",
    "medicijnOverzicht.filter.categorie": "Category",
    "medicijnOverzicht.filter.status": "Medication status",
    "medicijnOverzicht.filter.statusNone": "None",
    "medicijnOverzicht.filter.statusN": "%d selected",
    "medicijnOverzicht.filter.vanaf": "Administration from",
    "medicijnOverzicht.filter.tot": "Administration to",
    "medicijnOverzicht.sort.label": "Sort by",
    "medicijnOverzicht.sort.urgent": "Most urgent first",
    "medicijnOverzicht.sort.naam": "Name (A–Z)",
    "medicijnOverzicht.sort.volgende": "Next administration",
    "medicijnOverzicht.sort.diersoort": "Species",
    "medicijnOverzicht.sort.naamDesc": "Name (Z–A)",
    "medicijnOverzicht.sort.jongste": "Youngest animal first",
    "medicijnOverzicht.sort.oudste": "Oldest animal first",
    "medicijnOverzicht.sort.opnameNieuwste": "Most recent intake first",
    "medicijnOverzicht.sort.opnameOudste": "Longest in the shelter",
    "medicijnOverzicht.sort.kennel": "Kennel",
    "medicijnOverzicht.filter.clear": "Clear filters",
    "medicijnOverzicht.results.found": "results found",
    "medicijnOverzicht.results.foundOne": "result found",
    "medicijnOverzicht.pager.range": "%a - %b of %n animals",
    "medicijnOverzicht.pager.empty": "0 animals",
    "medicijnOverzicht.empty": "No animals with medication found for these filters.",
    "medicijnOverzicht.loadFailed": "Could not load the overview.",
    "medicijnOverzicht.field.medicijn": "Medication",
    "medicijnOverzicht.field.dosering": "Dosage",
    "medicijnOverzicht.field.frequentie": "Frequency",
    "medicijnOverzicht.field.laatsteToediening": "Last administration",
    "medicijnOverzicht.field.kennel": "Kennel",
    "medicijnOverzicht.field.volgendeToediening": "Next administration",
    "medicijnOverzicht.field.categorie": "Category",
    "medicijnOverzicht.field.toedieningsvorm": "Administration form",
    "medicijnOverzicht.field.startDatum": "Start date",
    "medicijnOverzicht.field.stopDatum": "Stop date",
    "medicijnOverzicht.field.voorgeschrevenDoor": "Prescribed by",
    "medicijnOverzicht.field.diersoort": "Species",
    "medicijnOverzicht.field.kleur": "Colour",
    "medicijnOverzicht.field.vacht": "Coat",
    "medicijnOverzicht.field.leeftijd": "Age",
    "medicijnOverzicht.field.geboortedatum": "Date of birth",
    "medicijnOverzicht.field.geslacht": "Sex",
    "medicijnOverzicht.field.gecastreerd": "Neutered",
    "medicijnOverzicht.field.castratiedatum": "Neuter date",
    "medicijnOverzicht.field.herkomst": "Origin",
    "medicijnOverzicht.field.opnamedatum": "Intake date",
    "medicijnOverzicht.field.paspoortnummer": "Passport number",
    "medicijnOverzicht.field.bijzonderheden": "Notes",
    "medicijnOverzicht.field.chipnummer": "Chip number",
    "medicijnOverzicht.veldkiezer.open": "Fields",
    "medicijnOverzicht.veldkiezer.title": "Choose fields",
    "medicijnOverzicht.veldkiezer.cancel": "Cancel",
    "medicijnOverzicht.veldkiezer.save": "Save",
    "medicijnOverzicht.weergave.grid": "Cards",
    "medicijnOverzicht.weergave.compact": "Compact",
    "medicijnOverzicht.weergave.lijst": "List",
    "medicijnOverzicht.table.status": "Status",
    "medicijnOverzicht.table.dier": "Animal",
    "medicijnOverzicht.card.chipLabel": "Chip number",
    "medicijnOverzicht.card.details": "Details",
    "medicijnOverzicht.card.bewerken": "Register administration",
    "medicijnOverzicht.card.instellingen": "Settings (products)",
    "dierAanwezig.column.verblijfNummer": "Stay no.",
    "dierAanwezig.column.animalName": "Animal name",
    // dieren-geplaatst (Dieren geplaatst / placed-animals overview — Jmix DierPlacementOverview migration).
    "dierGeplaatst.title": "Departed animals",
    "dierGeplaatst.subtitle": "Overview of departed animals",
    "animalListView.search.placeholder": "Search by name, chip or breed…",
    "animalListView.refresh": "Refresh",
    "animalListView.empty": "No animals.",
    "animalListView.loadFailed": "Could not load animals.",
    "relatieListView.title": "Contacts",
    "relatieListView.search.placeholder": "Search by name, number, e-mail or city…",
    "relatieListView.refresh": "Refresh",
    "relatieListView.create.button": "New relation",
    "relatieListView.create.title": "New relation",
    "relatieDubbel.kopEen": "A relation like this already exists.",
    "relatieDubbel.kop": "%s relations like this already exist.",
    "relatieDubbel.openen": "Open",
    "relatieDubbel.reden.EMAIL": "same e-mail address",
    "relatieDubbel.reden.TELEFOON": "same phone number",
    "relatieDubbel.reden.KVK": "same CoC number",
    "relatieDubbel.reden.BEDRIJFSNAAM": "same company name",
    "relatieDubbel.reden.NAAM_ADRES": "same surname at this address",
    "relatieDubbel.tochAanmaken": "Create anyway",
    "relatieSamenvoegen.knop": "Merge",
    "relatieSamenvoegen.title": "Merge relations",
    "relatieSamenvoegen.uitleg": "Everything from this relation moves to the one you pick: animals, invoices, stays, notes and documents. This relation then no longer appears in the list; links to it lead to the one that remains.",
    "relatieSamenvoegen.zoek": "Search by name, number, e-mail or city",
    "relatieSamenvoegen.geenResultaat": "No relations found.",
    "relatieSamenvoegen.kiezen": "Pick",
    "relatieSamenvoegen.gekozen": "Everything moves to %s.",
    "relatieSamenvoegen.bevestig": "Merge",
    "relatieSamenvoegen.annuleer": "Cancel",
    "relatieSamenvoegen.bezig": "Merging…",
    "relatieSamenvoegen.klaar": "Merged: %s records moved.",
    "relatieSamenvoegen.fout": "Merging failed. Nothing has been changed.",
    "relatieSamenvoegen.alSamengevoegd": "This relation has been merged into another one.",
    "relatieSamenvoegen.naarDoel": "Open that relation",
    "relatieListView.create.contactpersoon": "Contact person",
    "relatieListView.empty": "No contacts.",
    "relatieListView.loadFailed": "Could not load contacts.",
    "relatieListView.column.nummer": "No.",
    "relatieListView.column.naam": "Name",
    "relatieListView.column.plaats": "City",
    "relatieListView.column.email": "E-mail",
    "relatieListView.column.rollen": "Roles",
    "relatieListView.type.persoon": "Person",
    "relatieListView.type.organisatie": "Organisation",
    "relatieListView.pagination.range": "%d–%d of %d",
    "relatieListView.pagination.page": "Page %d of %d",
    "relatieListView.pagination.previous": "Previous",
    "relatieListView.pagination.next": "Next",
    "relatieDetailView.title": "Contact",
    "relatieDetailView.loadFailed": "Could not load the contact.",
    "relatieDetailView.tileLoadFailed": "Could not load this section.",
    "relatieDetailView.blokkade.title": "On the blacklist",
    "relatieDetailView.blokkade.geenAdoptie": "No adoption allowed",
    "relatieDetailView.blokkade.sinds": "since",
    "relatieDetailView.blokkade.tot": "until",
    "relatieDetailView.blokkade.details": "View details",
    "relatieDetailView.blokkade.opheffen": "Lift block",
    "relatieDetailView.blokkade.plaatsen": "Add to blacklist",
    "relatieDetailView.blokkade.ingetrokkenLabel": "Withdrawn",
    "relatieDetailView.blokkade.dialog.nieuwTitle": "Add to blacklist",
    "relatieDetailView.blokkade.dialog.detailsTitle": "Block details",
    "relatieDetailView.blokkade.dialog.opheffenTitle": "Lift block",
    "relatieDetailView.blokkade.plaatsenPrimary": "Add to blacklist",
    "relatieDetailView.blokkade.form.reden": "Reason",
    "relatieDetailView.blokkade.form.toelichting": "Notes",
    "relatieDetailView.blokkade.form.geldigVan": "Blocked from",
    "relatieDetailView.blokkade.form.geldigTot": "Until (optional)",
    "relatieDetailView.blokkade.form.geldigTotHelp": "Leave empty = permanent",
    "relatieDetailView.blokkade.form.opheffenReden": "Reason for lifting",
    "relatieDetailView.blokkade.err.reden": "Reason is required.",
    "relatieDetailView.blokkade.err.van": "Date 'Blocked from' is required.",
    "relatieDetailView.blokkade.err.totVoorVan": "Date 'Until' may not precede 'Blocked from'.",
    "relatieDetailView.blokkade.err.andersToelichting": "Notes are required for reason 'Other'.",
    "relatieDetailView.blokkade.err.opheffenReden": "Reason is required (at least 5 characters).",
    "relatieDetailView.blokkade.saved": "Saved.",
    "relatieDetailView.blokkade.saveConflict": "Changed by someone else. Reload and try again.",
    "relatieDetailView.blokkade.saveForbidden": "You don't have permission to manage blocks.",
    "relatieDetailView.blokkade.saveError": "Could not save. Try again.",
    "relatieDetailView.status.inactief": "Inactive",
    "relatieDetailView.tab.algemeen": "General",
    "relatieDetailView.tab.geschiedenis": "History",
    "relatieDetailView.tile.persoonsgegevens": "Personal details",
    "relatieDetailView.tile.relatiegegevens": "Contact details",
    "relatieDetailView.section.persoon": "Personal details",
    "relatieDetailView.section.bedrijf": "Company details",
    "relatieDetailView.tile.bedrijfsgegevens": "Company details",
    "relatieDetailView.tile.facturen": "Invoices",
    "relatieDetailView.facturen.empty": "No invoices for this contact yet.",
    "relatieDetailView.rest": "View the rest (%s)",
    "relatieDetailView.nogMeer": "%s more · %s total",
    "relatieDetailView.restKort": "View the rest",
    "relatieDetailView.facturen.bekijkAlle": "View all invoices",
    "relatieDetailView.facturen.nieuwe": "New invoice",
    "relatieDetailView.facturen.nieuweGeenRecht": "You are not allowed to create invoices.",
    "relatieDetailView.facturen.nieuweMislukt": "The invoice could not be created.",
    "relatieDetailView.facturen.nieuweNietBeschikbaar": "Creating an invoice is not available yet",
    "relatieDetailView.verblijven.bekijkAlle": "View all stays",
    "relatieDetailView.velden.titel": "Relation detail fields",
    "relatieDetailView.velden.AANHEF": "Salutation",
    "relatieDetailView.velden.TUSSENVOEGSEL": "Name infix",
    "relatieDetailView.velden.ADRES": "Address details",
    "relatieDetailView.velden.CONTACT": "Contact details",
    "relatieDetailView.velden.ROL_CATEGORIE": "Role / category",
    "relatieDetailView.velden.knop": "Show or hide fields",
    "relatieDetailView.velden.FACTUREN_OPENSTAAND": "Total outstanding",
    "relatieDetailView.velden.FACTUREN_BETAALD": "Total paid",
    "relatieDetailView.velden.FACTUREN_VERVALLEN": "Total overdue",
    "relatieDetailView.velden.FACTUREN_TOTAAL": "Total invoices",
    "relatieDetailView.facturen.totalenTitel": "Invoice totals",
    "relatieDetailView.facturen.totalenKnop": "Invoices tile settings",
    "relatieDetailView.verblijven.instellingenKnop": "Stays tile settings",
    "relatieDetailView.media.instellingenKnop": "Media tile settings",
    "relatieDetailView.tegels.knop": "Show or hide tiles",
    "relatieDetailView.tegels.titel": "Show or hide tiles",
    "relatieDetailView.facturen.alleTitel": "All invoices",
    "relatieDetailView.verblijven.alleTitel": "All stays",
    "relatieDetailView.media.restBekijken": "View the rest",
    "relatieDetailView.media.bekijkAlle": "View all files",
    "relatieDetailView.media.alleTitel": "All files",
    "relatieDetailView.facturen.onderdelen": "Filter by module",
    "relatieDetailView.facturen.module.ALLE": "All modules",
    "relatieDetailView.facturen.module.ASIEL": "Shelter",
    "relatieDetailView.facturen.module.PENSION": "Boarding",
    "relatieDetailView.facturen.module.LOSSE_VERKOOP": "Counter sale",
    "relatieDetailView.facturen.module.CRECHE": "Day care",
    "relatieDetailView.facturen.module.OVERIG": "Other",
    "relatieDetailView.facturen.meer": "%d more · %d in total",
    "relatieDetailView.facturen.totaalOpenstaand": "Total outstanding",
    "relatieDetailView.facturen.totaalBetaald": "Total paid",
    "relatieDetailView.facturen.totaalVervallen": "Total overdue",
    "relatieDetailView.facturen.totaalFacturen": "Total invoices",
    "relatieDetailView.facturen.countOpenstaand": "%d outstanding",
    "relatieDetailView.facturen.countBetaald": "%d paid",
    "relatieDetailView.facturen.countVervallen": "%d overdue",
    "relatieDetailView.facturen.col.nummer": "No.",
    "relatieDetailView.facturen.col.datum": "Date",
    "relatieDetailView.facturen.col.verval": "Due",
    "relatieDetailView.facturen.col.status": "Status",
    "relatieDetailView.facturen.col.bedrag": "Amount",
    "relatieDetailView.facturen.status.CONCEPT": "Draft",
    "relatieDetailView.facturen.status.BETAALD": "Paid",
    "relatieDetailView.facturen.status.OPENSTAAND": "Outstanding",
    "relatieDetailView.facturen.status.VERVALLEN": "Overdue",
    "relatieDetailView.verblijven.filter.vestiging": "Branch",
    "relatieDetailView.verblijven.filter.alleVestigingen": "All branches",
    "relatieDetailView.verblijven.filter.periode": "Period",
    "relatieDetailView.verblijven.filter.alles": "All",
    "relatieDetailView.verblijven.filter.actief": "Current",
    "relatieDetailView.verblijven.filter.afgerond": "Finished",
    "relatieDetailView.verblijven.filter.geen": "No stays match this filter.",
    "relatieDetailView.tile.verblijven": "Stays",
    "relatieDetailView.verblijven.empty": "No stays known for this contact yet.",
    "relatieDetailView.verblijven.meer": "%d more · %d in total",
    "relatieDetailView.verblijven.actief": "Active stays",
    "relatieDetailView.verblijven.totaal": "Total stays",
    "relatieDetailView.verblijven.laatsteVertrek": "Last departure",
    "relatieDetailView.verblijven.heden": "present",
    "relatieDetailView.verblijven.dagen": "%d days present",
    "relatieDetailView.verblijven.dag": "%d day present",
    "relatieDetailView.verblijven.col.dier": "Animal",
    "relatieDetailView.verblijven.col.rol": "Role",
    "relatieDetailView.verblijven.col.vestiging": "Branch",
    "relatieDetailView.verblijven.col.opnameSoort": "Intake type",
    "relatieDetailView.verblijven.col.periode": "Period",
    "relatieDetailView.verblijven.col.duur": "Duration",
    "relatieDetailView.verblijven.col.status": "Status",
    "relatieDetailView.verblijven.status.ACTIEF": "Active",
    "relatieDetailView.verblijven.status.AFGEROND": "Finished",
    "relatieDetailView.tab.pleeggezin": "Foster",
    "relatieDetailView.pleeggezin.instellingenTitel": "Foster family settings",
    "relatieDetailView.pleeggezin.profielTitle": "Foster settings & care profile",
    "relatieDetailView.pleeggezin.huidigeTitle": "Current animals",
    "relatieDetailView.pleeggezin.dierPlaatsen": "Place animal",
    "relatieDetailView.pleeggezin.plaatsTitel": "Place an animal with this foster family",
    "relatieDetailView.pleeggezin.plaatsen": "Place",
    "relatieDetailView.pleeggezin.plaatsUitleg": "Only animals currently in the shelter that have no foster family yet and whose species suits this foster family are shown. Which species suit is set under \"Welcomed categories\" on the Foster family tab.",
    "relatieDetailView.pleeggezin.dagenInOpvang": "%s days in care",
    "relatieDetailView.pleeggezin.zoekDier": "Search by animal name...",
    "relatieDetailView.pleeggezin.geenPlaatsbaar": "No animals available to place.",
    "relatieDetailView.pleeggezin.geenZoekresultaat": "No animals match this search.",
    "relatieDetailView.pleeggezin.plaatsFout": "Placing the animal failed.",
    "relatieDetailView.pleeggezin.historieTitle": "Animal history",
    "relatieDetailView.pleeggezin.afwTitle": "Absences",
    "relatieDetailView.pleeggezin.geenProfiel": "This relation has no foster profile yet.",
    "relatieDetailView.pleeggezin.profielAanmaken": "Create profile",
    "relatieDetailView.pleeggezin.loginActiefUitleg": "Yes, this foster family may sign in",
    "relatieDetailView.pleeggezin.loginEmailHint": "Taken from the relation details by default.",
    "relatieDetailView.pleeggezin.portaalUitleg": "While the login is active, this foster family has access to the foster portal.",
    "relatieDetailView.pleeggezin.loginActief": "Login active",
    "relatieDetailView.pleeggezin.loginEmail": "Login e-mail",
    "relatieDetailView.pleeggezin.interneOpmerking": "Internal note",
    "relatieDetailView.pleeggezin.emailVerplicht": "An e-mail address is required to activate the foster login.",
    "relatieDetailView.pleeggezin.opslaanMislukt": "Saving failed. Please try again.",
    "relatieDetailView.pleeggezin.opgeslagen": "Foster profile saved.",
    "relatieDetailView.pleeggezin.laatsteLogin": "Last login",
    "relatieDetailView.pleeggezin.stuurUitnodiging": "Send invitation",
    "relatieDetailView.pleeggezin.resetInloglink": "Reset password",
    "relatieDetailView.pleeggezin.uitnodigingVerstuurd": "Invitation sent.",
    "relatieDetailView.pleeggezin.capaciteit": "Capacity & preferences",
    "relatieDetailView.pleeggezin.geenCapaciteit": "No capacity configured.",
    "relatieDetailView.pleeggezin.cap.diersoort": "Species",
    "relatieDetailView.pleeggezin.cap.max": "Max. capacity",
    "relatieDetailView.pleeggezin.cap.uitleg": "Set the maximum intake capacity per species and select which categories are welcome.",
    "relatieDetailView.pleeggezin.cap.min": "One less",
    "relatieDetailView.pleeggezin.cap.plus": "One more",
    "relatieDetailView.pleeggezin.cap.huidig": "Currently present",
    "relatieDetailView.pleeggezin.cap.vrij": "Still available",
    "relatieDetailView.pleeggezin.cap.klaar": "Done",
    "relatieDetailView.pleeggezin.cap.geenVestiging": "No current shelter selected — capacity editing is unavailable.",
    "relatieDetailView.pleeggezin.cap.geenDiersoorten": "No species are enabled for foster families in this shelter yet.",
    "relatieDetailView.pleeggezin.welkom": "Welcomed categories",
    "relatieDetailView.pleeggezin.huidigeEmpty": "There are currently no animals at this foster family.",
    "relatieDetailView.pleeggezin.historieEmpty": "No earlier stays for this foster family yet.",
    "relatieDetailView.pleeggezin.cap.voet": "Currently present = the number of animals staying with this foster family right now, in the active shelter.",
    "relatieDetailView.pleeggezin.huidigeVoet": "Days present = the number of days the animal has been staying with this foster family.",
    "relatieDetailView.pleeggezin.historieVoet": "These are the animals that stayed with this foster family earlier.",
    "relatieDetailView.pleeggezin.laatsteUpdate": "Last update: %s",
    "relatieDetailView.pleeggezin.aanwezig": "Present",
    "relatieDetailView.pleeggezin.totaalVerblijven": "Total stays",
    "relatieDetailView.pleeggezin.laatsteVerblijf": "Last stay",
    "relatieDetailView.pleeggezin.retour": "Return",
    "relatieDetailView.pleeggezin.retourBevestig": "End the foster placement of %s? The animal returns to the shelter.",
    "relatieDetailView.pleeggezin.retourFout": "Could not end the placement. Please try again.",
    "relatieDetailView.pleeggezin.dagenVerbleven": "%s days stayed",
    "relatieDetailView.pleeggezin.col.categorie": "Category",
    "relatieDetailView.pleeggezin.afw.unavailable": "Absences temporarily unavailable — try again later.",
    "relatieDetailView.pleeggezin.afw.empty": "No absences scheduled.",
    "relatieDetailView.pleeggezin.afw.col.type": "Type",
    "relatieDetailView.pleeggezin.afw.col.bron": "Source",
    "relatieDetailView.pleeggezin.afw.bron.person": "By foster family",
    "relatieDetailView.pleeggezin.afw.bron.organization": "By shelter",
    "relatieDetailView.pleeggezin.afw.type.vacation": "Holiday",
    "relatieDetailView.pleeggezin.afw.type.sick": "Illness",
    "relatieDetailView.pleeggezin.afw.type.other": "Other",
    "relatieDetailView.pleeggezin.afw.col.acties": "Actions",
    "relatieDetailView.pleeggezin.afw.toevoegen": "Add absence",
    "relatieDetailView.pleeggezin.afw.van": "From",
    "relatieDetailView.pleeggezin.afw.tot": "Until",
    "relatieDetailView.pleeggezin.afw.verwijderen": "Delete",
    "relatieDetailView.pleeggezin.afw.momenteel": "Currently",
    "relatieDetailView.pleeggezin.afw.volgende": "Next absence",
    "relatieDetailView.pleeggezin.afw.afwezig": "Away",
    "relatieDetailView.pleeggezin.afw.beschikbaar": "Available",
    "relatieDetailView.tile.media": "Media & documents",
    "relatieDetailView.media.empty": "No files for this contact yet.",
    "relatieDetailView.media.filter.datum": "Date",
    "relatieDetailView.media.filter.soort": "Kind",
    "relatieDetailView.media.filter.tag": "Tag",
    "relatieDetailView.media.filter.alles": "All",
    "relatieDetailView.media.filter.alleTags": "All tags",
    "relatieDetailView.media.filter.zesMaanden": "Last 6 months",
    "relatieDetailView.media.filter.jaar": "Last year",
    "relatieDetailView.media.filterGeen": "No files match this filter.",
    "relatieDetailView.media.download": "Download",
    "relatieDetailView.media.toevoegen": "Add file",
    "relatieDetailView.media.uploaden": "Upload",
    "relatieDetailView.media.kiesBestanden": "Choose files",
    "relatieDetailView.media.omschrijving": "Description",
    "relatieDetailView.media.geupload": "File added.",
    "relatieDetailView.media.uploadFout": "Uploading failed.",
    "relatieDetailView.media.verwijderen": "Delete",
    "relatieDetailView.media.verwijderTitel": "Delete file",
    "relatieDetailView.media.verwijderBevestiging": "Delete this file?",
    "relatieDetailView.media.verwijderd": "File deleted.",
    "relatieDetailView.media.verwijderFout": "Deleting failed.",
    "relatieDetailView.tab.donateur": "Donor",
    "relatieDetailView.donateur.geen": "No donor data for this contact.",
    "relatieDetailView.donateur.geenDonaties": "No donations in this period.",
    "relatieDetailView.donateur.periodiekToevoegen": "Add recurring donation",
    "relatieDetailView.donateur.periodiekHint": "Recurring donations are followed up automatically through payment agreements or direct debit.",
    "relatieDetailView.donateur.geenPeriodiek": "No recurring donation has been set up yet.",
    "relatieDetailView.donateur.donateurschapTitle": "Donor membership",
    "relatieDetailView.donateur.overzichtTitle": "Donation overview",
    "relatieDetailView.donateur.periodiekTitle": "Recurring donation",
    "relatieDetailView.donateur.fiscaalTitle": "Fiscal data",
    "relatieDetailView.donateur.communicatieTitle": "Communication & thank-yous",
    "relatieDetailView.donateur.communicatieKolom": "Communication",
    "relatieDetailView.donateur.bedankmomenten": "Thank-you moments",
    "relatieDetailView.donateur.bedankmail": "Thank-you e-mail",
    "relatieDetailView.donateur.jaarbedankje": "Annual thank-you",
    "relatieDetailView.donateur.persoonlijkeKaart": "Personal card",
    "relatieDetailView.donateur.bedank.verzondenOp": "Sent on %s",
    "relatieDetailView.donateur.bedank.nogTeVersturen": "Still to send",
    "relatieDetailView.donateur.bedank.teVersturenVanaf": "To send from %s",
    "relatieDetailView.donateur.bedank.nietGepland": "Not planned",
    "relatieDetailView.donateur.statusLabel": "Status",
    "relatieDetailView.donateur.statusHint": "Status is determined automatically from donations; switch the toggle off to stop the donor membership manually.",
    "relatieDetailView.donateur.donateurSinds": "Donor since",
    "relatieDetailView.donateur.status.ACTIEF": "Active",
    "relatieDetailView.donateur.status.GEPAUZEERD": "Paused",
    "relatieDetailView.donateur.status.GESTOPT": "Stopped",
    "relatieDetailView.donateur.status.INACTIEF": "Inactive",
    "relatieDetailView.donateur.totaalGedoneerd": "Total donated",
    "relatieDetailView.donateur.ditJaar": "This year",
    "relatieDetailView.donateur.laatsteDonatie": "Last donation",
    "relatieDetailView.donateur.aantal": "Donations",
    "relatieDetailView.donateur.col.datum": "Date",
    "relatieDetailView.donateur.col.type": "Type",
    "relatieDetailView.donateur.col.status": "Status",
    "relatieDetailView.donateur.col.bedrag": "Amount",
    "relatieDetailView.donateur.type.EENMALIG": "One-off",
    "relatieDetailView.donateur.type.PERIODIEK": "Recurring",
    "relatieDetailView.donateur.dstatus.BETAALD": "Paid",
    "relatieDetailView.donateur.dstatus.OPENSTAAND": "Outstanding",
    "relatieDetailView.donateur.dstatus.GEPLAND": "Planned",
    "relatieDetailView.donateur.periode.alle": "All",
    "relatieDetailView.donateur.periode.label": "Period",
    "relatieDetailView.donateur.periode.maanden": "Last %d mo \u00b7 next %d mo",
    "relatieDetailView.donateur.aantalGepland": "%s planned",
    "relatieDetailView.donateur.bekijkAlleDonaties": "View all donations",
    "relatieDetailView.donateur.onbekend": "Unknown",
    "relatieDetailView.donateur.geenWaarde": "None",
    "relatieDetailView.donateur.inningEnStart": "Next collection %s · started %s",
    "relatieDetailView.donateur.geenNotitie": "No note recorded.",
    "relatieDetailView.donateur.bedankmailSturen": "Send thank-you e-mail",
    "relatieDetailView.donateur.berichtVersturen": "Send message",
    "relatieDetailView.donateur.kaartjePlannen": "Plan a card",
    "relatieDetailView.donateur.actieLater": "This action arrives in a later phase.",
    "relatieDetailView.donateur.betaalwijze": "Payment method",
    "relatieDetailView.donateur.volgendeInning": "Next collection",
    "relatieDetailView.donateur.gestartOp": "Started",
    "relatieDetailView.donateur.freq.MAANDELIJKS": "per month",
    "relatieDetailView.donateur.freq.PER_KWARTAAL": "per quarter",
    "relatieDetailView.donateur.freq.JAARLIJKS": "per year",
    "relatieDetailView.donateur.payment.AUTOMATISCHE_INCASSO": "Direct debit (SEPA)",
    "relatieDetailView.donateur.payment.BANKOVERSCHRIJVING": "Bank transfer",
    "relatieDetailView.donateur.payment.CONTANT": "Cash",
    "relatieDetailView.donateur.payment.PIN": "Card",
    "relatieDetailView.donateur.payment.IDEAL": "iDEAL",
    "relatieDetailView.donateur.totaalJaar": "Total %d",
    "relatieDetailView.donateur.verwachtRestKort": "+ %s expected",
    "relatieDetailView.donateur.jaaroverzichtGewenst": "Annual statement wanted",
    "relatieDetailView.donateur.bekijken": "View",
    "relatieDetailView.donateur.contactmoment": "Contact moment",
    "relatieDetailView.donateur.jaaroverzicht": "Annual statement",
    "relatieDetailView.donateur.fiscaalHint": "Tax documents and annual overviews are built automatically from recorded donations.",
    "relatieDetailView.donateur.verwachtRest": "Expected remaining",
    "relatieDetailView.donateur.laatsteOverzicht": "Latest overview",
    "relatieDetailView.donateur.referentie": "Reference",
    "relatieDetailView.donateur.laatsteContact": "Last contact",
    "relatieDetailView.donateur.laatsteBedankmail": "Last thank-you e-mail",
    "relatieDetailView.donateur.nieuwsbrief.label": "Newsletter",
    "relatieDetailView.donateur.nieuwsbrief.aan": "Subscribed",
    "relatieDetailView.donateur.nieuwsbrief.uit": "Unsubscribed",
    "relatieDetailView.donateur.nieuwsbrief.onbekend": "Unknown",
    "relatieDetailView.donateur.voorkeur": "Preference",
    "relatieDetailView.donateur.interneNotitie": "Internal note",
    "relatieDetailView.donateur.alleDonaties": "All donations",
    "relatieDetailView.donateur.nieuweDonatie": "New donation",
    "relatieDetailView.donateur.nieuwePeriodiek": "Recurring donation",
    "relatieDetailView.donateur.bewerken": "Edit",
    "relatieDetailView.donateur.hervatten": "Resume",
    "relatieDetailView.donateur.geenMandaat": "No mandate",
    "relatieDetailView.donateur.pauzeren": "Pause",
    "relatieDetailView.donateur.stoppen": "Stop",
    "relatieDetailView.donateur.dialog.donatieTitle": "New donation",
    "relatieDetailView.donateur.dialog.periodiekTitle": "Recurring donation",
    "relatieDetailView.donateur.dialog.periodiekEditTitle": "Edit recurring donation",
    "relatieDetailView.donateur.dialog.stopTitle": "Stop recurring donation",
    "relatieDetailView.donateur.dialog.stopConfirm": "Stop this recurring donation? It is kept for the history.",
    "relatieDetailView.donateur.form.datum": "Date",
    "relatieDetailView.donateur.form.bedrag": "Amount",
    "relatieDetailView.donateur.form.type": "Type",
    "relatieDetailView.donateur.form.frequentie": "Frequency",
    "relatieDetailView.donateur.form.betaalwijze": "Payment method",
    "relatieDetailView.donateur.form.status": "Status",
    "relatieDetailView.donateur.form.iban": "IBAN",
    "relatieDetailView.donateur.form.omschrijving": "Description",
    "relatieDetailView.donateur.form.bedankmail": "Send thank-you e-mail",
    "relatieDetailView.donateur.form.startdatum": "Start date",
    "relatieDetailView.donateur.form.mandaat": "Mandate present",
    "relatieDetailView.donateur.form.opmerking": "Note",
    "relatieDetailView.donateur.freqOpt.MAANDELIJKS": "Monthly",
    "relatieDetailView.donateur.freqOpt.PER_KWARTAAL": "Quarterly",
    "relatieDetailView.donateur.freqOpt.JAARLIJKS": "Yearly",
    "relatieDetailView.donateur.err.datumBedrag": "Date and amount are required.",
    "relatieDetailView.donateur.err.bedragStart": "Amount and start date are required.",
    "relatieDetailView.donateur.err.ibanRequired": "IBAN is required for direct debit.",
    "relatieDetailView.donateur.err.mandaatRequired": "A mandate is required for direct debit.",
    "relatieDetailView.donateur.saved": "Saved.",
    "relatieDetailView.donateur.saveConflict": "Changed by someone else. Reload and try again.",
    "relatieDetailView.donateur.saveForbidden": "You don't have permission to edit donor data.",
    "relatieDetailView.donateur.saveError": "Could not save. Try again.",
    "relatieDetailView.donateur.actiefToggle": "Donor membership active",
    "relatieDetailView.donateur.dialog.stopProfileTitle": "Stop donor membership",
    "relatieDetailView.donateur.dialog.stopProfileIntro": "Stopping the donor membership also ends these active recurring donations immediately:",
    "relatieDetailView.donateur.dialog.stopProfileConfirm": "Are you sure you want to stop the donor membership?",
    "relatieDetailView.tab.dierenarts": "Vet practice",
    "relatieDetailView.tab.derdePartij": "Third party",
    "relatieDetailView.crematie.huidige": "Current price agreement",
    "relatieDetailView.crematie.wijzigen": "Edit",
    "relatieDetailView.crematie.col.datum": "Date",
    "relatieDetailView.crematie.prijswijzigingen": "Price changes",
    "relatieDetailView.crematie.nieuweWijziging": "New price change",
    "relatieDetailView.crematie.nieuwTitel": "New price change",
    "relatieDetailView.crematie.wijzigTitel": "Edit price change",
    "relatieDetailView.crematie.geenWijzigingen": "No price agreement recorded yet.",
    "relatieDetailView.crematie.gewijzigdDoor": "Changed by",
    "relatieDetailView.crematie.status": "Status",
    "relatieDetailView.crematie.status.ACTIEF": "Active",
    "relatieDetailView.crematie.status.GEPLAND": "Scheduled",
    "relatieDetailView.crematie.status.VERVALLEN": "Superseded",
    "relatieDetailView.crematie.verwijderTitel": "Delete price change",
    "relatieDetailView.crematie.verwijderBevestiging": "Delete this price change?",
    "relatieDetailView.crematie.opslaanFout": "Saving the price change failed.",
    "relatieDetailView.crematie.verwijderFout": "Deleting the price change failed.",
    "relatieDetailView.crematie.interneOpmerking": "Internal note",
    "relatieDetailView.crematie.vergoeding": "Fee per registration",
    "relatieDetailView.crematie.vervoersprijs": "Transport price",
    "relatieDetailView.crematie.btw": "VAT %",
    "relatieDetailView.crematie.ingangsdatum": "Effective date",
    "relatieDetailView.dierenarts.geenTegels": "No tiles yet for this role — the crematorium module is off.",
    "relatieDetailView.dierenarts.geen": "No vet-practice price agreement for this contact yet.",
    "relatieDetailView.derdePartij.geen": "No third-party price agreement for this contact yet.",
    "relatieDetailView.section.contact": "Contact",
    "relatieDetailView.section.adres": "Address",
    "relatieDetailView.section.rol": "Roles & tags",
    "relatieDetailView.section.rolCategorie": "Role / category",
    "relatieDetailView.section.rolCategorieHint": "Select one or more roles that apply",
    "relatieDetailView.section.rolCategorieNote": "Your selection decides which extra sections appear below.",
    "relatieDetailView.section.tags": "Tags",
    "relatieDetailView.section.tagsHint": "Add labels to find this relation back more quickly.",
    "relatieDetailView.section.tagToevoegen": "Add tag",
    "relatieDetailView.section.tagToevoegenKort": "Add",
    "relatieDetailView.section.tagsDialoog": "Add tags",
    "relatieDetailView.section.tagsGeen": "No tags have been set up yet.",
    "relatieDetailView.field.aanhef": "Salutation",
    "relatieDetailView.field.voorletters": "Initials",
    "relatieDetailView.field.voornaam": "First name",
    "relatieDetailView.field.tussenvoegsel": "Infix",
    "relatieDetailView.field.achternaam": "Last name",
    "relatieDetailView.field.geboortedatum": "Date of birth",
    "relatieDetailView.field.bedrijfsnaam": "Company name (full)",
    "relatieDetailView.field.kvk": "Chamber of Commerce no.",
    "relatieDetailView.field.btw": "VAT no.",
    "relatieDetailView.field.email": "E-mail",
    "relatieDetailView.field.telefoon1": "Phone 1",
    "relatieDetailView.field.telefoon2": "Phone 2",
    "relatieDetailView.field.adres": "Street",
    "relatieDetailView.field.postcodeWoonplaats": "Postcode / city",
    "relatieDetailView.field.land": "Country",
    "relatieDetailView.field.type": "Type",
    "relatieDetailView.type.persoon": "Person",
    "relatieDetailView.type.organisatie": "Organisation",
    "relatieDetailView.field.straat": "Street",
    "relatieDetailView.field.huisnummer": "House no.",
    "relatieDetailView.field.toevoeging": "Addition",
    "relatieDetailView.adres.bestaandeRelaties": "%s other relations are already at this address.",
    "relatieDetailView.adres.bekijken": "View",
    "relatieDetailView.adres.dialoogTitel": "Existing relations at this address",
    "relatieDetailView.adres.openen": "Open",
    "relatieDetailView.field.postcode": "Postcode",
    "relatieDetailView.field.woonplaats": "City",
    "relatieDetailView.edit.button": "Edit",
    "relatieDetailView.edit.save": "Save",
    "relatieDetailView.edit.cancel": "Cancel",
    "relatieDetailView.edit.saved": "Saved.",
    "relatieDetailView.edit.conflict": "Changed by someone else in the meantime — reload and try again.",
    "relatieDetailView.edit.forbidden": "You don't have permission to edit relations.",
    "relatieDetailView.edit.error": "Could not save. Try again.",
    "relatieDetailView.edit.required": "Last name is required.",
    "relatieDetailView.edit.requiredBedrijf": "Company name is required.",
    "relatieDetailView.edit.rollen": "Roles",
    "relatieDetailView.edit.labels": "Tags",
    "relatieDetailView.edit.pleeggezinInUse": "Can't remove the foster role while this contact still has active foster placements.",
    "relatieDetailView.history.search": "Search history…",
    "relatieDetailView.history.toonMeer": "Show more",
    "relatieDetailView.history.systeem": "system",
    "relatieDetailView.history.empty": "No history for this contact yet.",
    "relatieDetailView.history.emptyFiltered": "No changes found for this search term.",
    "inboeken.title": "Intake",
    "inboeken.editTitle": "Edit intake",
    "inboeken.subtitle": "Register new animals in the shelter",
    "inboeken.editSubtitle": "Amend this intake and its reason",
    "inboeken.start": "Intake",
    "inboeken.editStart": "Edit intake",
    "inboeken.finish": "Complete intake",
    "inboeken.editFinish": "Save changes",
    // wizard cost-line catalog picker (Jmix FactuurRegelDialog picker mode; adoption + surrender)
    "wizard.productPicker.title": "Add product or tariff",
    "wizard.productPicker.subtitle": "Choose a product or tariff from one of the available sources.",
    "wizard.productPicker.search": "Search by product, code or category...",
    "wizard.productPicker.selectedTitle": "Selected line",
    "wizard.productPicker.selectEmpty": "Select a product or tariff to compose the line here.",
    "wizard.productPicker.aantal": "Quantity",
    "wizard.productPicker.prijs": "Price (incl. VAT)",
    "wizard.productPicker.prijsHelp": "The price is editable",
    "wizard.productPicker.omschrijving": "Description",
    "wizard.productPicker.totaal": "Line total",
    "wizard.productPicker.add": "Add",
    "wizard.productPicker.aantalInvalid": "Enter a quantity greater than zero.",
    "wizard.productPicker.prijsInvalid": "Enter a price.",
    "wizard.productPicker.omschrijvingInvalid": "Enter a description.",
    // wizard-jmix-parity: the StepWizard accordion chrome + the animal-count step
    "wizard.confirm": "Confirm",
    "wizard.editStep": "Edit step",
    "wizard.count.sub": "The choice determines how the next steps are filled in",
    "wizard.count.single": "One animal",
    "wizard.count.multiple": "Multiple animals",
    "wizard.count.amount": "Number of animals",
    "wizard.count.summary": "Selected count",
    "wizard.animals.add": "Add",
    "wizard.agreed": "Agreed",
    "inboeken.count.header": "How many animals do you want to intake?",
    "inboeken.count.singleDesc": "I want to intake one individual animal",
    "inboeken.count.multiDesc": "I want to intake multiple animals at once",
    "inboeken.summary.type": "Intake",
    "uitboeken.count.header": "How many animals do you want to release?",
    "uitboeken.count.singleDesc": "I want to release one individual animal",
    "uitboeken.count.multiDesc": "I want to release multiple animals at once",
    "uitboeken.summary.type": "Release",
    "wizard.step.count": "Count",
    "inboeken.step.type": "Type",
    "inboeken.step.animals": "Animals",
    "inboeken.step.ownerConfirm": "Owner check",
    "inboeken.step.details": "Details",
    "inboeken.step.chip": "Chip registration",
    "inboeken.step.summary": "Review",
    "inboeken.ownerConfirm.title": "Owner check",
    "inboeken.ownerConfirm.question": "Is this the surrendering owner?",
    "inboeken.ownerConfirm.yes": "Yes, this is the right owner",
    "inboeken.ownerConfirm.no": "No, this is not the right owner",
    "inboeken.ownerConfirm.required": "Choose Yes or No to continue.",
    "inboeken.ownerConfirm.none": "No known owner on file for this animal — pick the person bringing it in on the next step.",
    "inboeken.ownerConfirm.changeBringer": "Choose a different person",
    "inboeken.chip.header": "Chip registration",
    "inboeken.chip.info": "Register or check the chip details for PetBase.",
    "inboeken.chip.outage": "PetBase is unreachable. Chip registration is skipped; you can continue with the wizard.",
    "inboeken.chip.field.name": "Animal name",
    "inboeken.chip.field.gender": "Sex",
    "inboeken.chip.field.species": "Species",
    "inboeken.chip.field.breed": "Breed",
    "inboeken.chip.field.coat": "Coat",
    "inboeken.chip.field.color": "Colour",
    "inboeken.chip.field.birthDate": "Date of birth",
    "inboeken.chip.field.passport": "Passport number",
    "inboeken.chip.field.features": "Features",
    "inboeken.chip.field.castrated": "Castrated / sterilised",
    "inboeken.chip.field.crossBreed": "Cross-breed",
    "inboeken.chip.field.aanvoerType": "Registration type",
    "inboeken.chip.field.eventDate": "Event date",
    "inboeken.chip.field.chipNumber": "Chip number",
    "inboeken.chip.field.chipNumber.placeholder": "15 digits",
    "inboeken.chip.field.countryOfOrigin": "Country of origin",
    "inboeken.chip.field.motherChip": "Mother chip number",
    "inboeken.chip.field.motherChip.placeholder": "15 digits, required at birth",
    "inboeken.chip.field.chipInsertDate": "Chip insertion date",
    "inboeken.chip.field.chipper": "Chipper",
    "inboeken.chip.field.chipper.placeholder": "Choose a chipper…",
    "inboeken.chip.field.chipReadDate": "Chip read date",
    "inboeken.chip.aanvoerType.AANVOER_NIEUWE_EIGENAAR": "Intake - New owner",
    "inboeken.chip.aanvoerType.AANVOER_NIEUWE_CHIP": "Intake - New chip",
    "inboeken.chip.aanvoerType.AANVOER_GEBOORTE": "Intake - Birth",
    "inboeken.chip.aanvoerType.AANVOER_IMPORT": "Intake - Import",
    "inboeken.chip.validation.aanvoerType": "Choose a registration type.",
    "inboeken.chip.validation.eventDate": "Event date is required.",
    "inboeken.chip.validation.chipFormat": "Chip number must contain exactly 15 digits.",
    "inboeken.chip.validation.countryOfOrigin": "Country of origin is required.",
    "inboeken.chip.validation.chipper": "Select a chipper.",
    "inboeken.chip.validation.chipReadDate": "Chip read date is required.",
    "inboeken.chip.validation.motherChip": "Mother chip number is required at birth.",
    "inboeken.chip.validation.motherChipFormat": "Mother chip number must be exactly 15 digits.",
    "inboeken.chip.validation.chipInsertDate": "Chip insertion date is required for a new chip.",
    "inboeken.field.soort": "Type of intake",
    "inboeken.field.soort.placeholder": "Choose a type…",
    "inboeken.field.datum": "Intake date",
    "inboeken.field.brenger": "Surrendered by",
    "inboeken.field.vinder": "Found by",
    "inboeken.field.relatie": "Relation",
    "inboeken.field.straat": "Street",
    "inboeken.field.huisnummer": "House number",
    "inboeken.field.postcode": "Postcode",
    "inboeken.field.plaats": "Town",
    "inboeken.field.gemeente": "Municipality",
    "inboeken.field.gemeente.placeholder": "Choose a municipality…",
    "inboeken.field.opmerking": "Remark",
    "inboeken.field.redenAfstand": "Reason for surrender",
    "inboeken.field.retourReden": "Reason for return",
    "inboeken.field.moeder": "Mother",
    "inboeken.field.geboortedatum": "Date of birth",
    "inboeken.birth.dateInfo": "The intake date is set equal to the date of birth.",
    "inboeken.soort.unavailable": "This intake reason is temporarily unavailable.",
    "inboeken.soort.unavailableShort": "temporarily unavailable",
    "inboeken.field.woonplaats.placeholder": "Choose a town",
    "inboeken.foundLocation.title": "Found location",
    "inboeken.foundLocation.info": "Where was the animal found? As precisely as possible.",
    "inboeken.ambulance.question": "Was the animal brought in by an animal ambulance?",
    "inboeken.ambulance.info": "State whether the animal was brought in by an animal ambulance.",
    "inboeken.ambulance.yes": "Yes",
    "inboeken.ambulance.yes.desc": "The animal was handed over by an animal ambulance",
    "inboeken.ambulance.no": "No",
    "inboeken.ambulance.no.desc": "Brought in some other way",
    "inboeken.field.dierenambulance": "Animal ambulance",
    "inboeken.field.dierenambulance.placeholder": "Make a choice",
    "inboeken.field.dierenambulance.required": "Choose the animal ambulance that brought the animal.",
    "inboeken.terms.printFailed": "The declaration could not be printed. Try again.",
    "animalDetailView.stay.field.gevondenOpmerking": "Found-location remark",
    "animalDetailView.stay.v2.map.expand": "Enlarge map",
    "inboeken.field.ritnummer": "Ride number (optional)",
    "inboeken.field.redenAfstand.placeholder": "Make a choice",
    "inboeken.field.redenAfstand.required": "Select a reason for surrender before continuing.",
    "inboeken.field.eigenaar": "Owner",
    "inboeken.field.woonplaats": "Town",
    "inboeken.field.toevoeging": "Addition",
    "inboeken.field.opmerkingVindplaats": "Found-location remark (optional)",
    "inboeken.field.gedumpt": "Dumped",
    "inboeken.gedumpt.ja": "Yes",
    "inboeken.gedumpt.nee": "No",
    "inboeken.field.moederdier": "Mother animal",
    "inboeken.field.gemeente.birthPlaceholder": "Select municipality",
    "inboeken.field.gemeente.birthHelper": "Defaults to the current location's municipality.",
    "inboeken.field.gemeente.required": "Select a municipality before continuing.",
    "inboeken.field.gemeente.strayRequired": "Select the municipality where the animal was found.",
    "inboeken.mother.search": "Search by name or chip number",
    "inboeken.mother.notFound": "No mother animal found.",
    "inboeken.summary.vindplaats": "Found location",
    "inboeken.animals.openStay": "This animal already has an open stay.",
    "inboeken.animals.openStayShort": "already present",
    "inboeken.relation.email": "E-mail address",
    "inboeken.relation.postcode": "Postcode",
    "inboeken.relation.huisnummer": "House number",
    "inboeken.type.header": "How did the animal arrive?",
    "inboeken.type.stray.info": "Found without an owner",
    "inboeken.type.surrender.info": "Surrendered by the owner",
    "inboeken.type.return.info": "Returned after adoption",
    "inboeken.type.exchange.info": "From/to another shelter",
    "inboeken.type.birth.info": "Born in the shelter",
    "inboeken.type.wildcatCatsOnly": "Only available for cats",
    "inboeken.exchangeSource.title": "Shelter of origin",
    "inboeken.exchangeSource.info": "Choose the shelter the animal comes from.",
    "inboeken.exchangeSource.search": "Search by shelter name or city...",
    "inboeken.exchangeSource.empty": "There are no shelters available to exchange from.",
    "inboeken.exchangeSource.noMatches": "No shelters found for this search.",
    "inboeken.exchangeSource.card.email": "E-mail",
    "inboeken.exchangeSource.card.phone": "Phone",
    "inboeken.exchangeSource.card.address": "Address",
    "inboeken.summary.opname": "Intake",
    "inboeken.summary.adres": "Address",
    "inboeken.summary.afstand": "Surrender",
    "inboeken.summary.retour": "Return",
    "inboeken.summary.geboorte": "Birth",
    "inboeken.summary.title": "Registration summary",
    "inboeken.summary.title.return": "Summary",
    "inboeken.summary.info": "Check the details below before completing the registration.",
    "inboeken.summary.info.surrender": "Check the details before finishing.",
    "inboeken.summary.info.return": "Check all details before completing the registration.",
    "inboeken.summary.section.registratie": "Registration",
    "inboeken.summary.section.dier": "Animal",
    "inboeken.summary.section.binnenkomst": "Intake",
    "inboeken.summary.section.vinder": "Finder",
    "inboeken.summary.section.verklaring": "Surrender declaration",
    "inboeken.summary.section.chip": "Chip registration",
    "inboeken.summary.section.betaling": "Payment",
    "inboeken.summary.section.kostenRestitutie": "Costs & restitution",
    "inboeken.summary.section.relatie": "Relation",
    "inboeken.summary.label.naam": "Name",
    "inboeken.summary.label.chip": "Chip number",
    "inboeken.summary.label.geslacht": "Gender",
    "inboeken.summary.label.type": "Type",
    "inboeken.summary.label.diersoortRas": "Species / breed",
    "inboeken.summary.label.vachtKleur": "Coat / colour",
    "inboeken.summary.label.straat": "Street",
    "inboeken.summary.label.postcodePlaats": "Postal code / city",
    "inboeken.summary.label.ritnummer": "Ride number",
    "inboeken.summary.label.telefoon": "Phone",
    "inboeken.summary.label.email": "E-mail",
    "inboeken.summary.label.totaal": "Total",
    "inboeken.summary.label.paid": "Paid",
    "inboeken.summary.label.paymentMethod": "Payment method",
    "inboeken.summary.label.intakeType": "Intake type",
    "inboeken.summary.label.placedOn": "Placed on",
    "inboeken.summary.label.returnedOn": "Returned on",
    "inboeken.summary.label.duration": "Placement duration",
    "inboeken.summary.label.totalPaid": "Total adoption fees paid",
    "inboeken.summary.label.adoptionCosts": "Adoption fees",
    "inboeken.summary.label.chipCosts": "Chip registration",
    "inboeken.summary.label.refunded": "Refunded",
    "inboeken.summary.label.restitutionCompleted": "Restitution granted",
    "inboeken.summary.label.bedrag": "Amount",
    "inboeken.summary.label.rekening": "Account",
    "inboeken.summary.label.geboortedatum": "Date of birth",
    "inboeken.summary.label.rol": "Role",
    "inboeken.summary.rol.brenger": "Bringer",
    "inboeken.summary.rol.vinder": "Finder",
    "inboeken.summary.days": "days",
    "inboeken.summary.value.yes": "yes",
    "inboeken.summary.value.no": "no",
    "inboeken.summary.terms.accepted": "Declaration read and agreed",
    "inboeken.summary.terms.acceptedLater": "Not read; agreement given",
    "inboeken.summary.terms.notAccepted": "Declaration not accepted",
    "inboeken.summary.terms.signed": "Digitally signed",
    "inboeken.summary.terms.notSigned": "Not signed",
    "inboeken.summary.chip.update": "Chip registration will be updated",
    "inboeken.summary.chip.none": "Cannot register - no chip number known",
    "inboeken.summary.chip.infoReturn": "The chip registration will be updated with our shelter's details.",
    "inboeken.summary.notPaid": "Not paid",
    "inboeken.summary.signedOn": "Signed on %s by %s",
    "inboeken.summary.finder.none": "No finder specified.",
    "inboeken.summary.printStray": "Print finder's declaration",
    "inboeken.summary.printSurrender": "Print surrender declaration",
    "inboeken.summary.printReturn": "Print return declaration",
    "inboeken.summary.footerNote": "Clicking finish saves the registration permanently.",
    "inboeken.map.label": "Map",
    "inboeken.map.info": "Click the map to mark the location where the animal was found.",
    "inboeken.step.terms": "Declaration",
    "inboeken.terms.header": "Finder's declaration",
    "inboeken.terms.info": "Read the declaration carefully and sign to continue.",
    "inboeken.terms.finder": "Finder details",
    "inboeken.terms.declTitle": "Finder's declaration",
    "inboeken.terms.declIntro": "The undersigned hereby declares:",
    "inboeken.terms.declText": "1. that the animal described above does not belong to them and that they have no idea who its owner and/or keeper is;\n2. that they have / have not reported finding and taking in the unattended animal under art. 5:5 of the Dutch Civil Code;\n3. that they transfer all rights and duties of finder's possession to the shelter's management.",
    "inboeken.terms.agree": "I have read the finder's declaration and agree with its content *",
    "inboeken.terms.agreeRequired": "You must accept the finder's declaration to continue.",
    "inboeken.terms.signature": "Signature",
    "inboeken.terms.signaturePlaceholder": "Sign here",
    "inboeken.terms.signatureRetry": "Draw again",
    "inboeken.terms.date": "Date",
    "inboeken.terms.place": "Place",
    "inboeken.terms.print": "Print declaration",
    "inboeken.terms.signatureRequired": "You must add a signature to continue.",
    "inboeken.step.costs": "Costs",
    "inboeken.step.surrenderTerms": "Terms",
    "inboeken.costs.header": "Surrender costs",
    "inboeken.costs.info": "Enter the costs for this surrender.",
    "inboeken.costs.product": "Description",
    "inboeken.costs.amount.placeholder": "0.00",
    "inboeken.costs.add": "Add line",
    "inboeken.costs.empty": "No costs added yet.",
    "inboeken.costs.total": "Total costs",
    "korting.label": "Discount",
    "betaling.tegengesteld": "A negative amount is only possible on a negative invoice — a refund goes through a credit note.",
    "betaling.restantTitel": "Leave an amount outstanding?",
    "betaling.restantVraag": "%s remains outstanding after this payment. Is that correct?",
    "betaling.restantJa": "Yes, leave it outstanding",
    "betaling.restantNee": "No, go back",
    "korting.placeholder": "Korting",
    "korting.teHoog": "A discount cannot exceed the line it is on. Use a credit note to pay money back.",
    "inboeken.returnTerms.total": "Total refund",
    "inboeken.costs.propose": "Propose tariff",
    "inboeken.costs.propose.matched": "Tariff proposed: %s — %s",
    "inboeken.costs.propose.none": "No matching tariff found for this selection. Enter the amount manually.",
    "inboeken.costs.propose.conflict": "Multiple tariffs match equally (%s). Give one a higher priority or refine the conditions, or choose manually.",
    "inboeken.costs.propose.manual": "Tariff is on request / in consultation — enter the amount manually.",
    "inboeken.costs.propose.noAmount": "A rule matches but has no amount (set an own amount or a product with a price).",
    "inboeken.costs.propose.error": "Could not fetch a tariff proposal.",
    "inboeken.surrenderTerms.header": "Terms agreement",
    "inboeken.surrenderTerms.info": "Read and accept the surrender terms.",
    "inboeken.terms.tag.eigenaar": "Owner details",
    "inboeken.terms.tag.vinder": "Finder details",
    "inboeken.terms.fact.naam": "Name",
    "inboeken.terms.fact.adres": "Address",
    "inboeken.terms.fact.telefoon": "Phone",
    "inboeken.terms.fact.email": "E-mail",
    "inboeken.terms.fact.diernaam": "Animal name",
    "inboeken.terms.fact.chipnummer": "Chip number",
    "inboeken.terms.fact.soortRas": "Species / breed",
    "inboeken.surrenderTerms.declTitle": "Surrender declaration",
    "inboeken.surrenderTerms.declIntro": "The undersigned further declares:",
    "inboeken.surrenderTerms.declText": "1. to be the owner of the animal described, and to transfer ownership to the shelter, unconditionally relinquishing all rights to the animal and handing over any pedigree papers and the animal's passport;\n2. to be the sole owner, or that any co-owner/keeper is aware of and agrees with the surrender, indemnifying the shelter against third-party claims;\n3. to have answered the questions about the animal's health and behaviour truthfully and to have disclosed all relevant facts;\n4. to agree to pay the costs associated with the surrender, and to agree with the accompanying privacy statement.",
    "inboeken.surrenderTerms.agree": "I have read the surrender declaration and agree with its content and costs *",
    "inboeken.surrenderTerms.agreeRequired": "You must accept the surrender declaration to continue.",
    "inboeken.surrenderTerms.signLater": "Owner signs later",
    "inboeken.step.payment": "Payment",
    "inboeken.step.restitution": "Restitution",
    "inboeken.payment.header": "Payment",
    "inboeken.payment.info": "Choose a payment method and settle the surrender costs.",
    "inboeken.payment.due": "Amount due",
    "inboeken.payment.step1": "1. Payment method",
    "inboeken.payment.step2": "2. Payment details",
    "inboeken.payment.combi": "Combination",
    "inboeken.payment.invoice": "On invoice",
    "inboeken.payment.invoiceOpen": "Invoice (outstanding)",
    "inboeken.payment.invoiceRemark": "Invoice note (optional)",
    "inboeken.payment.invoiceRemark.placeholder": "For example: remainder as agreed",
    "inboeken.payment.invoiceNote": "An invoice is raised for the outstanding amount.",
    "inboeken.payment.overview": "Payment overview",
    "inboeken.payment.open": "Outstanding",
    "inboeken.payment.pin": "Card payment",
    "inboeken.payment.cash": "Cash",
    "inboeken.payment.later": "Pays later",
    "inboeken.payment.paid": "Total paid",
    "inboeken.payment.remaining": "Still to pay",
    "inboeken.restitution.header": "Return overview",
    "inboeken.restitution.info": "Does the customer get a refund?",
    "inboeken.restitution.yes": "Yes, (partial) refund",
    "inboeken.restitution.no": "No refund",
    "inboeken.restitution.amount": "Refund amount",
    "inboeken.returnPayment.header": "Refund",
    "inboeken.returnPayment.info": "Choose a payment method and process the refund.",
    "inboeken.returnPayment.toRefund": "Total to refund",
    "inboeken.returnPayment.method": "Method",
    "inboeken.returnPayment.method.placeholder": "Make a choice",
    "inboeken.returnPayment.transfer": "Bank transfer",
    "inboeken.returnPayment.pin": "Refund via card",
    "inboeken.returnPayment.cash": "Cash refund",
    "inboeken.returnPayment.iban": "IBAN",
    "inboeken.returnPayment.ibanRequired": "An IBAN is required for a bank refund.",
    "inboeken.returnPayment.ibanInvalid": "Enter a valid IBAN.",
    "inboeken.returnPayment.ibanPlaceholder": "NL00 BANK 0000 0000 00",
    "inboeken.returnPayment.amount": "Amount",
    "inboeken.returnPayment.amountDue": "Amount to refund",
    "inboeken.returnPayment.add": "Add",
    "inboeken.returnPayment.paymentsTitle": "Refunds",
    "inboeken.returnPayment.colAmount": "Amount (€)",
    "inboeken.returnPayment.colAction": "Action",
    "inboeken.returnPayment.totalRefund": "Total refund:",
    "inboeken.returnPayment.totalPaidOut": "Amount paid out:",
    "inboeken.returnPayment.remaining": "Restitution remaining:",
    "inboeken.returnPayment.remarkLabel": "Remark (optional):",
    "inboeken.returnPayment.remarkPlaceholder": "Any remarks",
    "inboeken.returnPayment.remark": "Remark (optional)",
    "inboeken.returnPayment.paidOut": "Total paid out",
    "inboeken.returnPayment.open": "Outstanding",
    "inboeken.returnPayment.stillToPay": "Still to pay out",
    "inboeken.ownerConfirm.summary": "Owner confirmed",
    "inboeken.ownerConfirm.ownerTitle": "Owner",
    "inboeken.ownerConfirm.contactTitle": "Contact details",
    "inboeken.returnOwnerConfirm.title": "Return after placement",
    "inboeken.returnOwnerConfirm.question": "Is this the correct owner?",
    "inboeken.returnOwnerConfirm.changeOwner": "Choose a different owner",
    "inboeken.field.retourReden.placeholder": "Choose a reason",
    "inboeken.restitution.overview": "Overview of the placement and paid adoption fees",
    "inboeken.restitution.placedOn": "Placed on:",
    "inboeken.restitution.returnOn": "Returned on:",
    "inboeken.restitution.daysAtOwner": "The animal stayed with the owner:",
    "inboeken.restitution.daysSuffix": "days",
    "inboeken.restitution.costsTitle": "Adoption fees",
    "inboeken.restitution.costsDescription": "Description",
    "inboeken.restitution.costsAmount": "Amount",
    "inboeken.restitution.totalPaid": "Total paid",
    "inboeken.restitution.max": "Maximum",
    "inboeken.restitution.ownerMismatch": "Note: the selected owner does not match the owner on the invoice.",
    "inboeken.restitution.remarkPlaceholder": "Notes on the return (optional)",
    "inboeken.animals.search": "Search an animal by name, chip or breed…",
    "inboeken.animals.none": "No animals selected yet.",
    "inboeken.animals.countRange": "Enter between 2 and 10 animals",
    "inboeken.animals.remove": "Remove",
    "inboeken.newAnimal.start": "New animal",
    "inboeken.newAnimal.naam": "Name",
    "inboeken.newAnimal.diersoort": "Species",
    "inboeken.newAnimal.diersoort.placeholder": "Choose a species…",
    "inboeken.newAnimal.geslacht": "Sex",
    "inboeken.newAnimal.geslacht.placeholder": "Unknown",
    "inboeken.newAnimal.add": "Add animal",
    "inboeken.newAnimal.chip": "Chip number",
    "inboeken.newAnimal.chip.placeholder": "Enter the 15-digit chip number",
    "inboeken.newAnimal.chipFormat": "Chip number must contain exactly 15 digits (or be empty).",
    "inboeken.newAnimal.chipDuplicate": "Chip number %s is already registered to \"%s\". This animal cannot be registered again.",
    "inboeken.newAnimal.chipDuplicate.use": "Use existing animal",
    "inboeken.newAnimal.naamRequired": "Enter an animal name before continuing.",
    "inboeken.newAnimal.diersoortRequired": "Select a species before continuing.",
    "inboeken.newAnimal.ras": "Breed",
    "inboeken.newAnimal.ras.placeholder": "Breed",
    "inboeken.newAnimal.vacht": "Coat",
    "inboeken.newAnimal.vacht.placeholder": "Select coat",
    "inboeken.newAnimal.kleur": "Colour",
    "inboeken.newAnimal.kleur.placeholder": "Colour",
    "inboeken.newAnimal.casSter": "Neutered/spayed",
    "inboeken.newAnimal.kruising": "Crossbreed",
    "inboeken.search.header": "Search animal",
    "inboeken.search.naam": "Animal name",
    "inboeken.search.button": "Search",
    "inboeken.search.minOne": "Enter at least one search field to search.",
    "inboeken.search.chipAutoSelected": "One chip match found. The animal was selected automatically.",
    "inboeken.results.header": "Search results",
    "inboeken.results.none": "No animals found.",
    "inboeken.results.select": "Select",
    "inboeken.results.view": "View",
    "inboeken.results.cardView": "Card view",
    "inboeken.results.listView": "List view",
    "inboeken.results.noPhoto": "No photo",
    "inboeken.results.alreadySelected": "This animal is already selected for this intake.",
    "inboeken.details.header": "Animal",
    "inboeken.details.newBanner": "No results found – enter the details for the new animal.",
    "inboeken.details.confirm": "Confirm animal",
    "inboeken.photo.upload": "Upload animal photo",
    "inboeken.photo.info": "Upload an animal photo (also via camera) for AI prefill",
    "inboeken.photo.aiPrefillApplied": "AI has prefilled available data from the file.",
    "inboeken.photo.passportScan": "Scan passport photo",
    "inboeken.photo.passportError": "Error while processing passport photo",
    "inboeken.photo.previewAlt": "Animal photo",
    "uitboeken.animals.presentHeader": "Animals present",
    "inboeken.relation.none": "None",
    "inboeken.relation.change": "Change",
    "inboeken.relation.close": "Close",
    "inboeken.relation.clear": "Clear",
    "inboeken.relation.search": "Search a relation by name…",
    // Relation sub-wizard (step variant — Jmix relation-find / -search-results fragments).
    "inboeken.relation.edit.info": "Check and complete the owner's details.",
    "inboeken.relation.edit.save": "Save details",
    "inboeken.relation.edit.saved": "Details saved.",
    "inboeken.relation.edit.error": "Saving the details failed.",
    "inboeken.relation.edit.other": "Choose another owner",
    "inboeken.field.opmerkingen": "Remarks",
    "inboeken.field.redenAfstand.remarkPlaceholder": "Optional note on the reason for surrender",
    "inboeken.relation.findTitle": "Find owner",
    "inboeken.relation.findFinderTitle": "Find finder",
    "inboeken.relation.findInfo.surrender": "Who is surrendering the animal?",
    "inboeken.relation.findInfo.return": "Who is returning the animal?",
    "inboeken.relation.findInfo.stray": "Who is the finder?",
    "inboeken.relation.emailSearch.title": "Search by e-mail address",
    "inboeken.relation.addressSearch.title": "Search by address",
    "inboeken.relation.addressSearch.placeholder": "Type street, city or postcode…",
    "inboeken.relation.addressSearch.unavailable": "Address search is unavailable: this server has no Postcode.eu credentials.",
    "inboeken.relation.separator": "and/or",
    "inboeken.relation.searchAction": "Search",
    "inboeken.relation.results.title": "Search results",
    "inboeken.relation.results.info":
      "Choose an existing relation from the search results, or continue to create a new relation.",
    "inboeken.relation.results.empty": "No relations found for the search criteria.",
    "inboeken.relation.search.hint": "Type a name, e-mail address or postcode to search.",
    "inboeken.relation.select": "Select",
    "inboeken.relation.blocked": "On the blacklist",
    "inboeken.relation.noFinder": "No finder",
    "inboeken.relation.create.start": "Create new relation",
    "inboeken.relation.create.title": "New relation",
    "inboeken.relation.create.bedrijfsnaam": "Company name",
    "inboeken.relation.create.aanhef": "Salutation",
    "inboeken.relation.create.voorletters": "Initials",
    "inboeken.relation.create.tussenvoegsel": "Prefix",
    "inboeken.relation.create.achternaam": "Last name",
    "inboeken.relation.create.postcode": "Postcode",
    "inboeken.relation.create.adresVerplicht": "Postcode and house number are required, so the address is stored with the relation.",
    "inboeken.relation.create.adresNodig": "Required",
    "inboeken.relation.create.huisnummer": "House number",
    "inboeken.relation.create.toevoeging": "Addition",
    "inboeken.relation.create.straat": "Street",
    "inboeken.relation.create.woonplaats": "Town",
    "inboeken.relation.create.land": "Country",
    "inboeken.relation.create.email": "E-mail address",
    "inboeken.relation.create.telefoon": "Phone number",
    "inboeken.relation.create.telefoon2": "Phone number 2",
    "inboeken.relation.create.opmerking": "Remark",
    "inboeken.relation.create.submit": "Create relation",
    "inboeken.relation.create.forbidden": "You are not authorized to create a new relation.",
    "inboeken.relation.create.error": "The relation could not be created.",
    "inboeken.notice.conflict": "This stay was changed in the meantime. Reload and try again.",
    "inboeken.notice.invalid": "The intake could not be completed — check the fields.",
    "inboeken.notice.error": "Something went wrong completing the intake.",
    // Uitboeken (release) wizard — the OUT counterpart of inboeken (reuses many inboeken.* keys).
    "uitboeken.title": "Release",
    "uitboeken.start": "Release",
    "uitboeken.finish": "Confirm and complete",
    "uitboeken.step.type": "Type",
    "uitboeken.step.animals": "Animals",
    "uitboeken.step.newOwner": "New owner",
    "uitboeken.step.owner": "Owner",
    "uitboeken.step.costs": "Costs",
    "uitboeken.step.terms": "Terms",
    "uitboeken.step.payment": "Payment",
    "uitboeken.step.details": "Details",
    "uitboeken.step.declaration": "Declaration",
    "uitboeken.step.chip": "Chip deregistration",
    "uitboeken.step.petbaseChip": "Chip registration",
    "uitboeken.step.summary": "Review",
    "uitboeken.blokkade.title": "Relation on the blacklist",
    "uitboeken.blokkade.subtitle": "Adoption to this relation is blocked",
    "uitboeken.blokkade.overrideReden": "Reason for overruling the block",
    "uitboeken.blokkade.overridePlaceholder": "Explain why this adoption is allowed despite the block (min. 10 characters)…",
    "uitboeken.blokkade.noOverrule": "You don't have permission to overrule this block — choose another relation or contact a manager.",
    "uitboeken.type.header": "How is the animal leaving?",
    "uitboeken.type.adoption.info": "The animal is placed with a new owner.",
    "uitboeken.type.return.info": "The animal is returned to its original owner.",
    "uitboeken.type.euthanasia.info": "The animal was euthanised.",
    "uitboeken.type.deceased.info": "The animal has died.",
    "uitboeken.type.nature.info": "The animal is released back into nature.",
    "uitboeken.type.exchange.info": "Transfer to another shelter.",
    "uitboeken.animals.info": "Select the resident animal(s) to release. Only animals currently in the shelter can be released.",
    "uitboeken.animals.notResident": "This animal has no open stay to close.",
    "uitboeken.animals.notResidentShort": "not in shelter",
    "uitboeken.field.releaseDate": "Departure date",
    "uitboeken.field.newOwner": "New owner",
    "uitboeken.field.owner": "Original owner",
    "uitboeken.field.soort": "Departure type",
    "uitboeken.costs.header": "Placement costs",
    "uitboeken.costs.info": "Add the placement cost lines. A concept invoice is created for the new owner on completion.",
    "uitboeken.payment.header": "Payment",
    "uitboeken.payment.info": "Choose a payment method and settle the adoption costs.",
    "uitboeken.payment.methodRequired": "Register at least one payment before continuing.",
    "uitboeken.payment.method.pin": "Card",
    "uitboeken.payment.method.cash": "Cash",
    "uitboeken.payment.method.later": "Pay later",
    "uitboeken.payment.add": "Add",
    "uitboeken.payment.paymentsTitle": "Payments",
    "uitboeken.payment.colMethod": "Method",
    "uitboeken.payment.colAmount": "Amount",
    "uitboeken.payment.totalDue": "Total due",
    "uitboeken.payment.totalPaid": "Total paid",
    "uitboeken.payment.remaining": "Remaining",
    "uitboeken.payment.remarkPlaceholder": "Optional remark for the payment",
    "uitboeken.nazorg.check": "Create an aftercare task",
    "uitboeken.nazorg.hint": "The system creates a task on the animal to automatically send the aftercare invitation after the configured number of days.",
    "uitboeken.done.factuur": "Concept invoice #%s created for the adoption.",
    "uitboeken.adoptionTerms.header": "Placement agreement",
    "uitboeken.adoptionTerms.info": "Review the placement agreement with the new owner and capture their signature.",
    "uitboeken.adoptionTerms.declTitle": "Placement agreement",
    "uitboeken.adoptionTerms.declIntro": "The new owner agrees to the following placement terms.",
    "uitboeken.adoptionTerms.declText": "The undersigned accepts the animal described above and agrees to care for it responsibly, and to pay the placement costs shown.",
    "uitboeken.adoptionTerms.agree": "The new owner agrees to the placement terms.",
    "uitboeken.adoptionTerms.signLater": "Owner signs later",
    "uitboeken.adoptionTerms.agreeRequired": "You must accept the placement agreement to continue.",
    "uitboeken.returnCosts.header": "Return costs",
    "uitboeken.returnCosts.info": "These costs appear on the return declaration the owner signs and can be paid at the desk. No invoice is created.",
    "uitboeken.returnCosts.opvang": "Housing costs",
    "uitboeken.returnCosts.ambulance": "Animal ambulance",
    "uitboeken.returnCosts.vet": "Veterinarian",
    "uitboeken.returnCosts.admin": "Administration costs",
    "uitboeken.returnCosts.day": "day",
    "uitboeken.returnCosts.days": "days",
    "uitboeken.returnPayment.header": "Payment",
    "uitboeken.returnPayment.info": "Choose a payment method and settle the return costs.",
    "uitboeken.return.stay.intakeDate": "Arrived on",
    "uitboeken.return.stay.releaseDate": "Return on",
    "uitboeken.return.stay.ambulance": "Animal ambulance",
    "uitboeken.return.ownerSuggestion.note": "Suggested from the animal's intake registration.",
    "uitboeken.return.ownerSuggestion.search": "Search another owner",
    "uitboeken.relation.findInfo.adoption": "Who is the new owner?",
    "uitboeken.relation.findInfo.return": "Who is the owner?",
    "uitboeken.adoption.knownOwner.title": "Owner check",
    "uitboeken.adoption.knownOwner.question": "Is the animal being placed with this owner?",
    "uitboeken.adoption.knownOwner.yes": "Yes, this owner",
    "uitboeken.adoption.knownOwner.no": "No, search another owner",
    "uitboeken.return.knownOwner.question": "Is the animal going back to this owner?",
    "uitboeken.return.knownOwner.yes": "Yes, this owner",
    "uitboeken.return.knownOwner.no": "No, search another owner",
    "uitboeken.returnDeclaration.header": "Return declaration",
    "uitboeken.returnDeclaration.info": "Review the return declaration with the owner and capture their signature.",
    "uitboeken.returnDeclaration.declTitle": "Return declaration",
    "uitboeken.returnDeclaration.declIntro": "The owner confirms they collect their animal.",
    "uitboeken.returnDeclaration.declText": "The undersigned confirms ownership of the animal described above and that it is collected from the shelter in good condition.",
    "uitboeken.returnDeclaration.agree": "The owner agrees to the return declaration.",
    "uitboeken.returnDeclaration.agreeRequired": "You must accept the return declaration to continue.",
    "uitboeken.euthanasia.date": "Euthanasia date",
    "uitboeken.euthanasia.performer": "Performed by",
    "uitboeken.euthanasia.performer.placeholder": "Choose…",
    "uitboeken.euthanasia.vetName": "Veterinarian name",
    "uitboeken.euthanasia.vetPractice": "Practice (optional)",
    "uitboeken.euthanasia.reason": "Reason for euthanasia",
    "uitboeken.euthanasia.reason.placeholder": "Choose…",
    "uitboeken.euthanasia.remarks": "Remarks",
    "uitboeken.chip.header": "Chip deregistration",
    "uitboeken.chip.info": "Deregister each animal from the chip registry.",
    "uitboeken.chip.none": "None of the selected animals has a chip number.",
    "uitboeken.chip.deregister": "Chip registration deregistered",
    "uitboeken.petbaseChip.header": "Chip registration",
    "uitboeken.petbaseChip.info": "Check or correct the chip details before the release; the update to PetBase (deregistration and, on an adoption/return, the new owner) is sent in the background.",
    "uitboeken.petbaseChip.registered": "Chip is registered",
    "uitboeken.petbaseChip.validation.chipFormat": "Chip number must contain exactly 15 digits.",
    "uitboeken.deceased.date": "Date of death",
    "uitboeken.deceased.cause": "Cause of death",
    "uitboeken.deceased.cause.placeholder": "Choose…",
    "uitboeken.deceased.causeOther": "Other cause",
    "uitboeken.deceased.externalVet": "Was an external veterinarian involved?",
    "uitboeken.deceased.vetName": "Veterinarian name",
    "uitboeken.deceased.vetReference": "Reference number (optional)",
    "uitboeken.deceased.remarks": "Remarks",
    "uitboeken.nature.date": "Release date",
    "uitboeken.nature.remark": "Release-location remark (optional)",
    "uitboeken.nature.vetCheck": "Veterinary fitness check performed",
    "uitboeken.nature.mapInfo": "The map starts around the selected location. Click the map to mark the release location with a pin.",
    "uitboeken.nature.place.label": "Release location",
    "uitboeken.nature.place.found": "At the found/caught location",
    "uitboeken.nature.place.other": "Another location",
    "uitboeken.nature.place.otherInfo": "Enter the address or click the map",
    "uitboeken.nature.place.foundUnknown": "No location recorded at intake",
    "uitboeken.nature.mapLocked": "The animal goes back to where it was found; pick \"Another location\" to change it.",
    "uitboeken.details.required": "Complete the required fields to continue.",
    "uitboeken.soort.unavailable": "This release reason is temporarily unavailable.",
    "uitboeken.count.helper": "Enter a number between 2 and 10",
    "uitboeken.typeChange.title": "Change release type?",
    "uitboeken.typeChange.body": "Changing the release type removes the follow-up steps you already filled in. Continue?",
    "uitboeken.typeChange.confirm": "Yes, change",
    "uitboeken.summary.vertrek": "Departure",
    "uitboeken.summary.printReturn": "Print return declaration",
    "uitboeken.summary.euthanasia": "Euthanasia",
    "uitboeken.summary.deceased": "Death",
    "uitboeken.summary.nature": "Release location",
    "uitboeken.summary.title": "Summary",
    "uitboeken.summary.title.adoption": "Adoption overview",
    "uitboeken.summary.title.return": "Return to owner — summary",
    "uitboeken.summary.title.nature": "Release into the wild — summary",
    "uitboeken.summary.title.exchange": "Exchange — summary",
    "uitboeken.summary.info": "Check all details carefully before the release is completed.",
    "uitboeken.summary.info.adoption": "Check all details and complete the placement.",
    "uitboeken.summary.info.euthanasia": "Check all details before finalising the euthanasia.",
    "uitboeken.summary.info.deceased": "Check all details carefully before finalising the release.",
    "uitboeken.summary.section.dier": "Animal",
    "uitboeken.summary.section.plaatsing": "Placement",
    "uitboeken.summary.section.newOwner": "New owner",
    "uitboeken.summary.section.betaling": "Payment",
    "uitboeken.summary.section.kosten": "Costs",
    "uitboeken.summary.section.overeenkomst": "Placement agreement",
    "uitboeken.summary.section.chip": "Chip registration",
    "uitboeken.summary.section.owner": "Original owner",
    "uitboeken.summary.section.retour": "Return details",
    "uitboeken.summary.section.remarks": "Remarks",
    "uitboeken.summary.section.release": "Release details",
    "uitboeken.summary.section.party": "Receiving organisation",
    "uitboeken.summary.section.exchange": "Exchange details",
    "uitboeken.summary.label.naam": "Name",
    "uitboeken.summary.label.chip": "Chip number",
    "uitboeken.summary.label.diersoortRas": "Species / breed",
    "uitboeken.summary.label.geslacht": "Gender",
    "uitboeken.summary.label.status": "Status",
    "uitboeken.summary.status.adoption": "Placed",
    "uitboeken.summary.status.return": "Returned to owner",
    "uitboeken.summary.status.euthanasia": "Euthanised",
    "uitboeken.summary.status.deceased": "Deceased",
    "uitboeken.summary.status.nature": "TNRC",
    "uitboeken.summary.status.exchange": "Exchanged",
    "uitboeken.summary.label.releaseType": "Placement type",
    "uitboeken.summary.label.releaseDate": "Placement date",
    "uitboeken.summary.label.adres": "Address",
    "uitboeken.summary.label.email": "E-mail",
    "uitboeken.summary.label.telefoon": "Phone",
    "uitboeken.summary.label.paid": "Paid",
    "uitboeken.summary.label.paymentMethod": "Paid via",
    "uitboeken.summary.label.total": "Total",
    "uitboeken.summary.notPaid": "Not paid",
    "uitboeken.summary.costs.empty": "No cost lines",
    "uitboeken.summary.terms.accepted": "Agreement read and agreed",
    "uitboeken.summary.terms.signed": "Digitally signed",
    "uitboeken.summary.terms.notSigned": "Not signed",
    "uitboeken.summary.label.signatureDate": "Signature date",
    "uitboeken.summary.label.signaturePlace": "Signature place",
    "uitboeken.summary.chip.note": "The chip registration will be updated with the new owner's details.",
    "uitboeken.summary.chip.none": "No chip number known",
    "uitboeken.summary.chip.updatedFor": "Chip registration updated for",
    "uitboeken.summary.chip.noChipReturn": "Animal has no chip number",
    "uitboeken.summary.label.owner": "Owner",
    "uitboeken.summary.label.contact": "Contact",
    "uitboeken.summary.label.returnDate": "Return date",
    "uitboeken.summary.label.notes": "Remarks",
    "uitboeken.summary.notes.none": "No remarks",
    "uitboeken.summary.label.euthDate": "Euthanasia date",
    "uitboeken.summary.label.performer": "Performed by",
    "uitboeken.summary.label.practice": "Practice",
    "uitboeken.summary.label.reason": "Reason",
    "uitboeken.summary.remarks.none": "No remark added",
    "uitboeken.summary.label.dateOfDeath": "Date of death",
    "uitboeken.summary.label.causeOfDeath": "Cause",
    "uitboeken.summary.label.externalVet": "External veterinarian",
    "uitboeken.summary.label.natureDate": "Release date",
    "uitboeken.summary.label.vetCheck": "Veterinary fitness check",
    "uitboeken.summary.vetCheck.done": "Performed",
    "uitboeken.summary.vetCheck.notDone": "Not performed",
    "uitboeken.summary.label.straat": "Street",
    "uitboeken.summary.label.postcodePlaats": "Postal code / city",
    "uitboeken.summary.label.receivingParty": "Receiving organisation",
    "uitboeken.summary.label.exchangeDate": "Exchange date",
    "uitboeken.summary.reason.none": "No reason given",
    "uitboeken.step.party": "Receiving shelter",
    "uitboeken.exchange.partyHeader": "Receiving shelter",
    "uitboeken.exchange.partyInfo": "Choose the shelter that will receive the animal(s).",
    "uitboeken.exchange.noShelters": "No eligible shelters available.",
    "uitboeken.exchange.reason": "Reason for the exchange",
    "uitboeken.exchange.reasonPlaceholder": "Describe the reason for the exchange",
    "uitboeken.exchange.detailsRequired": "Complete the required fields for the exchange details.",
    "uitboeken.exchange.receivingShelter": "Receiving shelter",
    "uitboeken.notice.conflict": "This stay was changed in the meantime. Reload and try again.",
    "uitboeken.notice.invalid": "The release could not be completed — check the fields.",
    "uitboeken.notice.error": "Something went wrong completing the release.",
    // Uitwisselingen (shelter exchange) inbox/outbox — Epic 3.
    "uitwisselingen.title": "Exchanges",
    "uitwisselingen.heading": "Shelter exchanges",
    "uitwisselingen.subtitle": "Incoming and outgoing exchanges with other shelters",
    "uitwisselingen.filter.status": "Status",
    "uitwisselingen.filter.status.all": "All statuses",
    "uitwisselingen.filter.asiel": "Shelter",
    "uitwisselingen.filter.asiel.all": "All shelters",
    "uitwisselingen.filter.diersoort": "Species",
    "uitwisselingen.filter.diersoort.all": "All species",
    "uitwisselingen.tab.inbox": "Incoming",
    "uitwisselingen.tab.outbox": "Outgoing",
    "uitwisselingen.empty": "No exchanges.",
    "uitwisselingen.col.status": "Status",
    "uitwisselingen.col.source": "Source shelter",
    "uitwisselingen.col.target": "Target shelter",
    "uitwisselingen.col.animals": "Animals",
    "uitwisselingen.col.sentAt": "Sent at",
    "uitwisselingen.col.createdAt": "Created at",
    "uitwisselingen.col.actions": "Actions",
    "uitwisselingen.action.open": "Open",
    "uitwisselingen.action.accept": "Accept",
    "uitwisselingen.action.reject": "Reject",
    "uitwisselingen.action.cancel": "Cancel",
    "uitwisselingen.action.complete": "Complete",
    "uitwisselingen.action.intake": "Book in",
    "uitwisselingen.status.DRAFT": "Draft",
    "uitwisselingen.status.SENT": "Sent",
    "uitwisselingen.status.SENT_INBOX": "Received",
    "uitwisselingen.status.ACCEPTED": "Accepted",
    "uitwisselingen.status.REJECTED": "Rejected",
    "uitwisselingen.status.CANCELLED": "Cancelled",
    "uitwisselingen.status.COMPLETED": "Completed",
    "uitwisselingen.animals.one": "animal",
    "uitwisselingen.animals.many": "animals",
    "uitwisselingen.animals.unknownSpecies": "Unknown",
    "uitwisselingen.external.label": "External",
    "uitwisselingen.external.tooltip": "External shelter — no in-app response; notification goes by e-mail",
    "uitwisselingen.cancel.title": "Cancel exchange",
    "uitwisselingen.cancel.warning": "This cannot be undone. The target shelter will no longer see this exchange.",
    "uitwisselingen.cancel.confirm": "Cancel exchange",
    "uitwisselingen.cancel.back": "Keep exchange",
    "uitwisselingen.notif.accepted": "Exchange accepted.",
    "uitwisselingen.notif.rejected": "Exchange rejected.",
    "uitwisselingen.notif.cancelled": "Exchange cancelled.",
    "uitwisselingen.notif.completed": "Exchange completed.",
    "uitwisselingen.detail.title": "Exchange",
    "uitwisselingen.detail.external": "External shelter",
    "uitwisselingen.detail.reason": "Reason",
    "uitwisselingen.detail.reason.empty": "(no reason given)",
    "uitwisselingen.detail.createdAt": "Created",
    "uitwisselingen.detail.rejectionReason": "Rejection reason",
    "uitwisselingen.detail.rejectionRemark": "Note",
    "uitwisselingen.detail.col.chipStatus": "Chip registration",
    "uitwisselingen.chipStatus.REGISTERED": "Registered",
    "uitwisselingen.chipStatus.NOT_REGISTERED": "Not registered",
    "uitwisselingen.chipStatus.SKIPPED_NO_CHIP": "No chip",
    "uitwisselingen.chipStatus.SKIPPED_OUTAGE": "Skipped (outage)",
    "uitwisselingen.detail.acceptedAt": "Accepted",
    "uitwisselingen.detail.rejectedAt": "Rejected",
    "uitwisselingen.detail.cancelledAt": "Cancelled",
    "uitwisselingen.detail.completedAt": "Completed",
    "uitwisselingen.detail.animals": "Animals",
    "uitwisselingen.detail.history": "History",
    "uitwisselingen.history.empty": "No history yet.",
    "uitwisselingen.history.EXCHANGE_CREATED": "Exchange created",
    "uitwisselingen.history.EXCHANGE_SENT": "Exchange sent",
    "uitwisselingen.history.EXCHANGE_ACCEPTED": "Exchange accepted",
    "uitwisselingen.history.EXCHANGE_REJECTED": "Exchange rejected",
    "uitwisselingen.history.EXCHANGE_CANCELLED": "Exchange cancelled",
    "uitwisselingen.history.EXCHANGE_COMPLETED": "Exchange completed",
    "uitwisselingen.reject.title": "Reject exchange",
    "uitwisselingen.reject.reason": "Reason",
    "uitwisselingen.reject.reasonPlaceholder": "Choose a reason…",
    "uitwisselingen.reject.codeHelper": "Choose a category. Shared with the source shelter.",
    "uitwisselingen.reject.remark": "Note (optional)",
    "uitwisselingen.reject.remarkHelper": "Max 500 characters. Shared with the source shelter.",
    "uitwisselingen.reason.WRONG_SHELTER": "Wrong shelter",
    "uitwisselingen.reason.ANIMAL_DECLINED": "Animals declined",
    "uitwisselingen.reason.CAPACITY_FULL": "No capacity",
    "uitwisselingen.reason.OPERATOR_RECONSIDERED": "Reconsidered after accepting",
    "uitwisselingen.reason.OTHER": "Other (see note)",
    "uitwisselingen.notice.conflict": "This exchange was changed in the meantime. Reload and try again.",
    "uitwisselingen.notice.invalid": "That action isn't allowed for this exchange.",
    "uitwisselingen.notice.error": "Something went wrong processing the exchange.",
    "animalListView.column.naam": "Name",
    "animalListView.column.diersoort": "Species",
    "animalListView.column.ras": "Breed",
    "animalListView.column.geslacht": "Sex",
    "animalListView.column.geboortedatum": "Date of birth",
    "animalListView.column.chip": "Chip number",
    "animalDetailView.title": "Animal",
    "animalDetailView.loadFailed": "Could not load the animal.",
    "animalDetailView.placeholder": "This section will follow in a later migration step.",
    "animalDetailView.layout.edit": "Edit layout",
    "animalDetailView.layout.done": "Done",
    "animalDetailView.layout.hide": "Hide tile",
    "animalDetailView.layout.drag": "Drag to reorder",
    "animalDetailView.layout.hiddenSection": "Hidden tiles",
    // tile field-visibility migration: the pencil (per-user field visibility) + lock (foster access
    // policy) dialogs — the Jmix openBasisFieldsDialog / openFosterVisibilityDialog affordances.
    "animalDetailView.fieldConfig.edit": "Configure fields",
    "animalDetailView.fieldConfig.basisTitle": "Basic information fields",
    "animalDetailView.fieldConfig.voedingTitle": "Feeding tile — sections",
    "animalDetailView.fieldConfig.gewichtenTitle": "Weights tile",
    "animalDetailView.fieldConfig.foto": "Photo",
    // Dialog-specific field labels where the Jmix dialog text differs from the tile's field label.
    "animalDetailView.fieldConfig.gecastreerd": "Neutered",
    "animalDetailView.fieldConfig.castratieDatum": "Neutering date",
    "animalDetailView.fieldConfig.chipPasnummer": "Chip number",
    "animalDetailView.fieldConfig.paspoortNummer": "Passport number",
    "animalDetailView.fieldConfig.voedingSchema": "Feeding schedule (incl. Edit schedule button)",
    "animalDetailView.fieldConfig.voedingLog": "Feeding log (incl. log actions and Full log)",
    "animalDetailView.fieldConfig.gewichtenChart": "Show chart",
    "animalDetailView.fieldConfig.saveError": "Could not save the field settings.",
    "animalDetailView.foster.lockTitle": "Foster family access",
    "animalDetailView.foster.title": "Foster family — %s",
    "animalDetailView.foster.rule": "Per row: Hidden · Read-only · Edit · Delete. A foster family never gets more than the backoffice. This setting applies to all animals at once.",
    "animalDetailView.foster.colBackoffice": "In the backoffice",
    "animalDetailView.foster.colFoster": "Foster family",
    "animalDetailView.foster.tileRow": "Tile",
    "animalDetailView.foster.level.hidden": "Hidden",
    "animalDetailView.foster.level.readonly": "Read-only",
    "animalDetailView.foster.level.editable": "Edit",
    "animalDetailView.foster.level.deletable": "Delete",
    "animalDetailView.foster.boVisible": "Visible in the backoffice",
    "animalDetailView.foster.boHidden": "Hidden in the backoffice",
    "animalDetailView.foster.boHiddenTooltip": "Hidden in the backoffice — cannot be enabled for the foster family",
    "animalDetailView.foster.tileOffTooltip": "This tile is turned off in the backoffice",
    "animalDetailView.foster.notAvailableTooltip": "This tile is not (yet) available to the foster portal",
    "animalDetailView.foster.conflict": "The settings were changed in the meantime — the dialog has been refreshed. Check your changes and save again.",
    "animalDetailView.foster.saveError": "Could not save the foster access settings.",
    "animalDetailView.status.overleden": "Deceased",
    "animalDetailView.tab.general": "General",
    "animalDetailView.tab.verblijf": "Stay",
    "animalDetailView.tab.geschiedenis": "History",
    "animalDetailView.tab.advertentie": "Advertisement",
    "animalDetailView.advertentie.geen": "This animal has no advertisement yet.",
    "animalDetailView.advertentie.laadFout": "The advertisement could not be loaded.",
    "animalDetailView.tile.basis": "Basic information",
    "animalDetailView.tile.bescherming": "Protection",
    "animalDetailView.tile.medicijnen": "Medication",
    "animalDetailView.medicijnen.status.ACTIEF": "Active",
    "animalDetailView.medicijnen.status.BINNENKORT": "Starting soon",
    "animalDetailView.medicijnen.status.HISTORISCH": "Historical",
    "animalDetailView.medicijnen.field.dosering": "Dosage",
    "animalDetailView.medicijnen.field.frequentie": "Frequency",
    "animalDetailView.medicijnen.field.toedieningsvorm": "Form",
    "animalDetailView.medicijnen.field.categorie": "Category",
    "animalDetailView.medicijnen.field.startDatum": "Start date",
    "animalDetailView.medicijnen.field.stopDatum": "Stop date",
    "animalDetailView.medicijnen.field.voorgeschrevenDoor": "Prescribed by",
    "animalDetailView.medicijnen.field.indicatie": "Indication",
    "animalDetailView.medicijnen.toedienlijst": "Administrations",
    "animalDetailView.medicijnen.toegediend": "Administered",
    "animalDetailView.medicijnen.toegediendDoor": "Administered by %s",
    "animalDetailView.medicijnen.gepland": "Planned",
    "animalDetailView.medicijnen.field.naam": "Medication",
    "animalDetailView.medicijnen.field.product": "Medication (from catalog)",
    "animalDetailView.medicijnen.field.productAnders": "— Other (free text) —",
    "animalDetailView.medicijnen.ai.button": "Fill with AI",
    "animalDetailView.medicijnen.ai.busy": "Working…",
    "animalDetailView.medicijnen.ai.done": "Fields filled from the AI suggestion.",
    "animalDetailView.medicijnen.ai.unavailable": "AI suggestions are not available (no provider configured).",
    "animalDetailView.medicijnen.ai.error": "Could not get an AI suggestion.",
    "animalDetailView.medicijnen.tab.actueel": "Current",
    "animalDetailView.medicijnen.tab.toedienlijst": "Schedule",
    "animalDetailView.medicijnen.tab.historie": "History",
    "animalDetailView.medicijnen.searchPlaceholder": "Search medication…",
    "animalDetailView.medicijnen.noMatch": "No medication matches the search.",
    "animalDetailView.medicijnen.tabEmpty": "Nothing here.",
    "animalDetailView.medicijnen.showAll": "Show all (%d)",
    "animalDetailView.medicijnen.showLess": "Show less",
    "animalDetailView.medicijnen.field.opmerkingen": "Notes",
    "animalDetailView.medicijnen.field.actief": "Active prescription",
    "animalDetailView.medicijnen.add": "New medication",
    "animalDetailView.medicijnen.edit": "Edit medication",
    "animalDetailView.medicijnen.delete": "Delete medication",
    "animalDetailView.medicijnen.addTitle": "New medication",
    "animalDetailView.medicijnen.editTitle": "Edit medication",
    "animalDetailView.medicijnen.deleteTitle": "Delete medication",
    "animalDetailView.medicijnen.deleteBody": "Delete the prescription \"%s\"? The administrations are removed too.",
    "animalDetailView.medicijnen.deleteConfirm": "Delete",
    "animalDetailView.medicijnen.saved": "Medication saved.",
    "animalDetailView.medicijnen.deleted": "Medication deleted.",
    "animalDetailView.medicijnen.saveConflict": "This medication was changed in the meantime. Reload and try again.",
    "animalDetailView.medicijnen.saveInvalid": "Please check the entered values.",
    "animalDetailView.medicijnen.saveError": "Could not save. Try again.",
    "animalDetailView.medicijnen.err.naamRequired": "Enter a medication name.",
    "animalDetailView.medicijnen.err.stopBeforeStart": "The stop date cannot be before the start date.",
    "animalDetailView.medicijnen.toediening.add": "Add",
    "animalDetailView.medicijnen.toediening.addTitle": "Register administration",
    "animalDetailView.medicijnen.toediening.register": "Register",
    "animalDetailView.medicijnen.toediening.delete": "Delete administration",
    "animalDetailView.medicijnen.toediening.empty": "No administrations yet.",
    "animalDetailView.medicijnen.toediening.datum": "Date",
    "animalDetailView.medicijnen.toediening.tijd": "Time",
    "animalDetailView.medicijnen.toediening.door": "Administered by",
    "animalDetailView.medicijnen.toediening.opmerking": "Note",
    "animalDetailView.medicijnen.toediening.toegediend": "Administered",
    "animalDetailView.medicijnen.toediening.err.momentRequired": "Enter a date and time.",
    "animalDetailView.medicijnen.genereer.button": "Generate",
    "animalDetailView.medicijnen.genereer.title": "Generate administrations",
    "animalDetailView.medicijnen.genereer.submit": "Generate",
    "animalDetailView.medicijnen.genereer.aantal": "Number",
    "animalDetailView.medicijnen.genereer.eenheid": "Frequency",
    "animalDetailView.medicijnen.genereer.eenheid.DAG": "× per day",
    "animalDetailView.medicijnen.genereer.eenheid.WEEK": "× per week",
    "animalDetailView.medicijnen.genereer.eenheid.MAAND": "× per month",
    "animalDetailView.medicijnen.genereer.eenheid.UUR": "every … hours",
    "animalDetailView.medicijnen.genereer.hint": "Builds the schedule from the start date (08:00) up to the stop date. Already-administered moments are kept.",
    "animalDetailView.medicijnen.genereer.err.aantal": "Enter a number of at least 1.",
    "animalDetailView.tile.gewichten": "Weights",
    "animalDetailView.tile.voeding": "Feeding",
    "animalDetailView.tile.notities": "Notes",
    "animalDetailView.tile.media": "Media & documents",
    "animalDetailView.tile.taken": "Tasks & planning",
    // taken-runtime (Epic T5): the animal-detail Taken tile + its "Alles bekijken" full view. Only UI
    // chrome — the data labels (status/priority/team/source) come from the server payload verbatim.
    "taken.kpi.open": "Open",
    "taken.kpi.vandaag": "Due today",
    "taken.kpi.achterstallig": "Overdue",
    "taken.kpi.afgerond": "Completed",
    "taken.kpi.totaal": "Total",
    "taken.tile.empty": "No open tasks",
    "taken.tile.meer": "+%d more open tasks",
    "taken.tile.alles": "View all →",
    "taken.tab.title": "Tasks & planning",
    "taken.tab.subtitle": "Open, planned and completed tasks for this animal.",
    "taken.nieuw": "New task",
    "taken.leeg": "No tasks found.",
    "taken.vandaag": "Today",
    "taken.fout": "Saving the task failed. Please try again.",
    "taken.fout.conflict": "This automatic task has since been created again. Update the newer task instead of this one.",
    "taken.automatisch": "Created automatically",
    "taken.automatisch.sjabloon": "template %s",
    "taken.automatisch.regel": "rule %s",
    "taken.filter.zoek": "Search tasks…",
    "taken.filter.bron": "Source",
    "taken.filter.alleBronnen": "All sources",
    "taken.filter.team": "Team",
    "taken.filter.alleTeams": "All teams",
    "taken.filter.mijnTeam": "My team",
    "taken.filter.toonAfgerond": "Show completed/cancelled",
    "taken.actie.inBehandeling": "Start",
    "taken.nieuw.titel": "New task",
    "taken.nieuw.taak": "Task",
    "taken.nieuw.kies": "Choose a task…",
    "taken.nieuw.dezeSoort": "For this species",
    "taken.nieuw.elkeSoort": "For every species",
    "taken.nieuw.andere": "Other task (type it yourself)",
    "taken.nieuw.handeling": "When carried out this task opens the %s screen and is done once that is saved.",
    "taken.actie.uitvoeren": "Carry out: %s",
    "taken.uitvoeren.geenTegel": "The tile for this task is not shown on this animal. Turn it on, or mark the task done yourself.",
    "taken.actie.afronden": "Complete",
    "taken.actie.wizardStarten": "Start wizard",
    "taken.actie.bewerken": "Edit",
    "taken.actie.annuleren": "Cancel task",
    "taken.actie.heropenen": "Reopen",
    "taken.form.titel": "Task title",
    "taken.form.omschrijving": "Description (optional)",
    "taken.nieuw.kiesOfTyp": "Choose a task or type your own…",
    "taken.actie.verwijderen": "Remove",
    "taken.bewerk.titel": "Edit task",
    "taken.verwijder.titel": "Remove task?",
    "taken.verwijder.uitleg": "“%s” is no longer needed and disappears from the open tasks. It stays visible under cancelled tasks.",
    "taken.nieuw.kiesEerst": "Choose a task from the list or type one yourself.",
    "taken.nieuw.toonLijst": "Show task list",
    "taken.nieuw.eigen": "Own task: “%s”",
    "taken.nieuw.leeg": "No tasks in the list yet; just type one.",
    "taken.nieuw.omschrijvingPlaats": "Add a description if you like…",
    "taken.form.prioriteit": "Priority",
    "taken.form.deadline": "Deadline",
    "taken.form.team": "Team",
    "taken.form.geenTeam": "No team",
    "taken.form.toevoegen": "Add",
    // WIZARDS tile (Registraties & Wizards): only UI chrome — wizard names, field labels, summary
    // values and status chips come from the server payload verbatim (authored in the wizard builder).
    "animalDetailView.tile.wizards": "Registrations & Wizards",
    "wizards.badge.enkel": "registration",
    "wizards.badge.meer": "registrations",
    "wizards.historie": "History",
    "wizards.historie.leeg": "No registrations yet.",
    "wizards.nieuw": "New registration",
    "wizards.leeg": "No published wizards available yet.",
    "wizards.laatstBijgewerkt": "Last updated",
    "wizards.nogGeenRegistratie": "No registration filled in yet",
    "wizards.meerDetails": "More details",
    "wizards.kiezer.titel": "Which registration do you want to start?",
    "wizards.runner.titel": "Run %s",
    "wizards.verplicht": "\"%s\" is required.",
    "wizards.geenVelden": "No fields in this step.",
    "wizards.vorige": "Previous",
    "wizards.volgende": "Next",
    "wizards.concept": "Save as draft",
    "wizards.afronden": "Complete",
    "wizards.fout": "Saving the registration failed. Please try again.",
    "wizards.ja": "Yes",
    "wizards.nee": "No",
    "wizards.chipnummer": "Chip number",
    "wizards.geboortedatum": "Date of birth",
    "wizards.geslacht": "Sex",
    "wizards.leeftijd": "Age",
    "wizards.inAsielSinds": "In shelter for %d days",
    "wizards.verblijfstatus": "Stay status",
    "wizards.actief": "ACTIVE",
    "wizards.sinds": "since",
    "wizards.dagen": "days",
    "wizards.samenvatting": "Wizard summary",
    "wizards.stap.ingevuld": "Filled in",
    "wizards.stap.bezig": "In progress…",
    "wizards.stap.wacht": "Waiting for previous step",
    "wizards.detail.titel": "Registration",
    "wizards.detail.leeg": "No values.",
    "animalDetailView.field.naam": "Name",
    "animalDetailView.field.geslacht": "Sex",
    "animalDetailView.field.gecastreerd": "Neutered/spayed",
    "animalDetailView.field.castratieDatum": "Neutering date",
    "animalDetailView.field.diersoort": "Species",
    "animalDetailView.field.ras": "Breed",
    "animalDetailView.field.kruising": "Crossbreed",
    "animalDetailView.field.rasKruising": "Crossbreed breed",
    "animalDetailView.field.vacht": "Coat",
    "animalDetailView.field.eartip": "Ear tip",
    "animalDetailView.field.eartipOor": "Which ear",
    "animalDetailView.field.eartipOorLeeg": "Not recorded",
    "animalDetailView.field.eartipLinks": "Left ear",
    "animalDetailView.field.eartipRechts": "Right ear",
    "animalDetailView.field.kleur": "Colour",
    "animalDetailView.field.chip": "Chip number",
    "animalDetailView.field.paspoort": "Passport number",
    "animalDetailView.field.stamboom": "Pedigree number",
    "animalDetailView.field.kenmerken": "Markings",
    "animalDetailView.field.geboortedatum": "Date of birth",
    "animalDetailView.field.overledendatum": "Date of death",
    "animalDetailView.field.casSter": "Neutered",
    "animalDetailView.field.vachtKleur": "Coat colour",
    "animalDetailView.basis.photo": "Upload photo",
    "animalDetailView.basis.photoChange": "Change photo",
    "animalDetailView.photo.dialogTitle": "Change photo",
    "animalDetailView.photo.helper": "Choose a photo via upload or take one directly with the camera.",
    "animalDetailView.photo.choose": "Choose file",
    "animalDetailView.photo.camera": "Take photo (camera)",
    "animalDetailView.photo.cameraFallback": "Camera not working on this device? Use 'Choose file'.",
    "animalDetailView.photo.cameraSnap": "Take photo",
    "animalDetailView.photo.cameraCancel": "Cancel",
    "animalDetailView.photo.cameraBack": "Back",
    "animalDetailView.photo.cameraUnsupported": "Camera not supported on this device/browser.",
    "animalDetailView.photo.cameraDenied": "Camera unavailable or permission denied.",
    "animalDetailView.photo.previewAlt": "New photo preview",
    "animalDetailView.photo.horizontal": "Horizontal",
    "animalDetailView.photo.vertical": "Vertical",
    "animalDetailView.photo.rotation": "Rotation",
    "animalDetailView.photo.left": "Move left",
    "animalDetailView.photo.right": "Move right",
    "animalDetailView.photo.up": "Move up",
    "animalDetailView.photo.down": "Move down",
    "animalDetailView.photo.center": "Centre",
    "animalDetailView.photo.rotateLeft": "Rotate left",
    "animalDetailView.photo.rotateRight": "Rotate right",
    "animalDetailView.photo.save": "Save photo",
    "animalDetailView.photo.cancel": "Cancel",
    "animalDetailView.photo.empty": "Choose a photo via upload or camera first",
    "animalDetailView.photo.unsupported": "Only JPG, PNG and WEBP are supported",
    "animalDetailView.photo.tooLarge": "Photo is too large (max 15 MB)",
    "animalDetailView.photo.saveError": "Saving the photo failed",
    "animalDetailView.photo.aiAnalyze": "AI analysis",
    "animalDetailView.photo.aiAnalyzing": "Analysing…",
    "animalDetailView.photo.aiTitle": "AI suggestions",
    "animalDetailView.photo.aiHelper": "Select which suggestions to apply to the basic information.",
    "animalDetailView.photo.aiApply": "Apply",
    "animalDetailView.photo.aiRetry": "Analyse again",
    "animalDetailView.photo.aiBack": "Cancel",
    "animalDetailView.photo.aiOverwrites": "overwrites existing value",
    "animalDetailView.photo.aiNone": "AI found no usable suggestions",
    "animalDetailView.photo.aiUnavailable": "No AI provider configured",
    "animalDetailView.photo.aiError": "AI analysis failed",
    "basis.subtitel": "Animal details",
    "basis.sectie.identiteit": "Identity",
    "basis.sectie.identiteitOnder": "Basic details of the animal",
    "basis.sectie.kenmerken": "Characteristics",
    "basis.sectie.kenmerkenOnder": "Breed and appearance",
    "basis.sectie.registratie": "Registration",
    "basis.sectie.registratieOnder": "Official details and dates",
    "basis.sectie.overige": "Other",
    "basis.sectie.overigeOnder": "Additional information",
    "animalDetailView.basis.tags": "Tags",
    "animalDetailView.basis.tagsAdd": "+ add",
    "animalDetailView.basis.tagsEmpty": "No tags yet",
    "animalDetailView.basis.tagsDialogTitle": "Edit tags",
    "animalDetailView.basis.stamboomPlaceholder": "e.g. NHSB 1234567",
    "animalDetailView.basis.chipDuplicateTitle": "Chip number already exists",
    "animalDetailView.basis.chipDuplicateMessage": "Chip number %s already belongs to animal \"%s\". Do you want to open that animal?",
    "animalDetailView.basis.chipDuplicateStay": "No, stay here",
    "animalDetailView.basis.chipDuplicateOpen": "Yes, open existing animal",
    "animalDetailView.basis.chipDuplicateNoName": "(no name)",
    "animalDetailView.basis.reset": "Reset",
    "animalDetailView.basis.saved": "Saved",
    "animalDetailView.basis.saveError": "Could not save.",
    "animalDetailView.basis.saveConflict": "This animal was changed by someone else. Reload and try again.",
    "animalDetailView.basis.diersoortRequired": "Species is required.",
    "animalDetailView.basis.aiApplied": "AI suggestions applied (%s)",
    "animalDetailView.basis.age.y": "y",
    "animalDetailView.basis.age.mo": "mo",
    "animalDetailView.basis.age.wk": "wk",
    "animalDetailView.basis.age.day": "day",
    "animalDetailView.basis.age.days": "days",
    "animalDetailView.tileLoadFailed": "Could not load this section.",
    "animalDetailView.tileEmpty": "Nothing recorded yet.",
    "animalDetailView.weights.target": "Target range",
    "animalDetailView.weights.latest": "Latest measurement",
    "animalDetailView.weights.min": "Minimum",
    "animalDetailView.weights.idealLabel": "Ideal",
    "animalDetailView.weights.max": "Maximum",
    "animalDetailView.weights.status.within": "On target",
    "animalDetailView.weights.status.below": "Below target",
    "animalDetailView.weights.status.above": "Above target",
    "animalDetailView.weights.status.noTarget": "No target weight set",
    "animalDetailView.weights.status.pending": "No measurement yet",
    "animalDetailView.weights.col.datum": "Date",
    "animalDetailView.weights.col.gewicht": "Weight",
    "animalDetailView.weights.col.opmerking": "Note",
    "animalDetailView.weights.chartTitle": "Weight (kg)",
    "animalDetailView.weights.noChart": "No measurements to chart yet",
    "animalDetailView.weights.none": "No measurements recorded yet",
    "animalDetailView.weights.add": "Add",
    "animalDetailView.weights.edit": "Edit",
    "animalDetailView.weights.delete": "Delete",
    "animalDetailView.weights.remove": "Remove",
    "animalDetailView.weights.addTitle": "Add weight",
    "animalDetailView.weights.editTitle": "Edit weight",
    "animalDetailView.weights.targetTitle": "Set target range",
    "animalDetailView.weights.targetEditTitle": "Edit target range",
    "animalDetailView.weights.changeReason": "Reason for change (optional)",
    "animalDetailView.weights.deleteTitle": "Delete measurement",
    "animalDetailView.weights.deleteConfirm": "Are you sure you want to delete this measurement?",
    "animalDetailView.weights.range.3m": "Last 3 months",
    "animalDetailView.weights.range.1m": "Last month",
    "animalDetailView.weights.range.all": "All",
    "animalDetailView.weights.viewAll": "Show all",
    "animalDetailView.weights.addSubtitle": "Record a new weight measurement for this animal.",
    "animalDetailView.weights.editSubtitle": "Change this weight measurement.",
    "animalDetailView.weights.targetSubtitle": "Set the weight band within which this animal is healthy.",
    "animalDetailView.weights.dateHint": "Select the date the weight was measured.",
    "animalDetailView.weights.weegschaal": "Scale / note",
    "animalDetailView.weights.weegschaalPlaats": "E.g. small scale, cattery",
    "animalDetailView.weights.weegschaalHint": "Which scale you used. Different scales differ; this explains a jump.",
    "animalDetailView.weights.weightHint": "Enter the measured weight in kilograms.",
    "animalDetailView.weights.weightPlaceholder": "e.g. 17.5",
    "animalDetailView.weights.current": "Current weight",
    "animalDetailView.weights.sincePrevious": "since previous measurement",
    "animalDetailView.weights.bandRange": "Target band",
    "animalDetailView.weights.band.within": "Within target band",
    "animalDetailView.weights.band.below": "Below target band",
    "animalDetailView.weights.band.above": "Above target band",
    "animalDetailView.weights.band.noTarget": "No target band known",
    "animalDetailView.weights.band.pending": "No measurement yet",
    "animalDetailView.weights.recent": "Latest measurements",
    "animalDetailView.weights.pickRow": "Pick a measurement in the list first",
    "animalDetailView.weights.periodLabel": "Period",
    "animalDetailView.weights.period.3m": "Last 3 months",
    "animalDetailView.weights.period.1m": "Last month",
    "animalDetailView.weights.period.all": "All measurements",
    "animalDetailView.weights.restTitle": "Other weight measurements",
    "animalDetailView.weights.tipStatus": "Status",
    "animalDetailView.weights.tipSource": "Source",
    "animalDetailView.weights.saved": "Saved",
    "animalDetailView.weights.saveError": "Save failed. Please try again.",
    "animalDetailView.weights.saveConflict": "This data changed in the meantime. Reload and try again.",
    "animalDetailView.weights.saveInvalid": "Check the entered values.",
    "animalDetailView.weights.err.dateRequired": "Date is required",
    "animalDetailView.weights.err.dateFuture": "Date cannot be in the future",
    "animalDetailView.weights.err.weightRequired": "Weight is required",
    "animalDetailView.weights.err.weight": "Weight must be greater than 0",
    "animalDetailView.weights.err.minMaxRequired": "Minimum and maximum are required",
    "animalDetailView.weights.err.minLtMax": "Minimum must be less than maximum",
    "animalDetailView.weights.err.idealBetween": "Ideal weight must be between minimum and maximum",
    "animalDetailView.weights.err.weightsPositive": "Weights must be greater than 0",
    "animalDetailView.weights.optional": "optional",
    "animalDetailView.weights.minPlaceholder": "e.g. 25.0",
    "animalDetailView.weights.idealPlaceholder": "e.g. 30.0",
    "animalDetailView.weights.maxPlaceholder": "e.g. 36.0",
    "animalDetailView.weights.reasonPlaceholder": "e.g. vet advice, diet, recovery",
    "animalDetailView.feeding.log": "Feeding log",
    "animalDetailView.feeding.field.feedType": "Feed type",
    "animalDetailView.feeding.field.brand": "Brand",
    "animalDetailView.feeding.field.amount": "Amount",
    "animalDetailView.feeding.field.times": "Feeding times",
    "animalDetailView.feeding.field.dietStatus": "Diet status",
    "animalDetailView.feeding.field.note": "Note",
    "animalDetailView.feeding.col.fedAt": "When",
    "animalDetailView.feeding.col.amount": "Amount",
    "animalDetailView.feeding.col.behavior": "Eating",
    "animalDetailView.feeding.col.note": "Note",
    "animalDetailView.feeding.behavior.GOED_GEGETEN": "Ate well",
    "animalDetailView.feeding.behavior.ALLES_GEGETEN": "Ate everything",
    "animalDetailView.feeding.behavior.BIJNA_OP": "Almost finished",
    "animalDetailView.feeding.behavior.SLECHT_GEGETEN": "Ate poorly",
    "animalDetailView.feeding.behavior.ONBEKEND": "Unknown",
    "animalDetailView.feeding.col.date": "Date",
    "animalDetailView.feeding.noLog": "No feeding recorded yet",
    "animalDetailView.feeding.add": "Add",
    "animalDetailView.feeding.edit": "Edit",
    "animalDetailView.feeding.delete": "Delete",
    "animalDetailView.feeding.editPlan": "Edit plan",
    "voedingsplan.nieuw": "New feeding plan",
    "voedingsschema.knop": "Feeding schedule",
    "voedingsschema.bewerken": "Edit",
    "voedingsschema.bewerkTitel": "Edit feeding schedule",
    "voedingsschema.bewerkUitleg": "Correct the current schedule. For a real change in feeding, create a new schedule instead: then the history stays intact.",
    "voedingsschema.wijzigingOpslaan": "Save changes",
    "voedingsschema.titel": "Feeding schedules",
    "voedingsschema.uitleg": "All feeding schedules for this animal.",
    "voedingsschema.nieuw": "New schedule",
    "voedingsschema.geen": "No feeding schedule yet. Create the first one with “New schedule”.",
    "voedingsschema.huidig": "Current schedule",
    "voedingsschema.aangemaaktOp": "Created on",
    "voedingsschema.door": "By",
    "voedingsschema.detail.titel": "Schedule details",
    "voedingsschema.detail.uitleg": "Everything recorded and given within this feeding schedule.",
    "voedingsschema.terug": "Back to overview",
    "voedingsschema.opBasisVan": "New schedule based on this one",
    "voedingsschema.huidigSchema": "Current schedule",
    "voedingsschema.huidigUitleg": "This schedule is currently active for this animal.",
    "voedingsschema.eerderSchema": "Earlier schedule",
    "voedingsschema.eerderUitleg": "This schedule has been replaced by a newer one.",
    "voedingsschema.periode": "Period",
    "voedingsschema.actiefSinds": "Active since",
    "voedingsschema.tot": "Until",
    "voedingsschema.nogActief": "Still active",
    "voedingsschema.informatie": "Feeding information",
    "voedingsschema.voertype": "Feed type",
    "voedingsschema.product": "Product / brand",
    "voedingsschema.frequentie": "Frequency",
    "voedingsschema.totaalPerDag": "Total per day",
    "voedingsschema.voertijden": "Feeding times",
    "voedingsschema.samenstelling": "Composition",
    "voedingsschema.calorisch": "Calorie value",
    "voedingsschema.perDag": "per day",
    "voedingsschema.kcalOnbekend": "Unknown: the products have no calorie value.",
    "voedingsschema.gegeven": "Feedings given within this schedule",
    "voedingsschema.registraties": "%s records",
    "voedingsschema.eenRegistratie": "1 record",
    "voedingsschema.opgegeten": "eaten",
    "voedingsschema.geweigerd": "Refused",
    "voedingsschema.kolom.datum": "Date",
    "voedingsschema.kolom.tijd": "Time",
    "voedingsschema.kolom.moment": "Meal",
    "voedingsschema.kolom.status": "Status",
    "voedingsschema.nieuwTitel": "New feeding schedule",
    "voedingsschema.nieuwUitleg": "Create a new feeding schedule for this animal. The previous one stays in the overview.",
    "voedingsschema.opslaan": "Save schedule",
    "voedingsschema.portieKort": "Portion",
    "voedingsschema.productMerk": "Product / brand",
    "voedingsschema.productPlaceholder": "Choose from the list or type a name",
    "voedingsschema.perDagKlein": "(per day)",
    "voedingsschema.kcalOnbekendKort": "kcal unknown",
    "voedingsschema.tijdToevoegen": "Add time",
    "voedingsschema.tijdWeg": "Remove time %s",
    "voedingsschema.nieuwProduct": "New product. Add it to the product list?",
    "voedingsschema.gram": "gram",
    "voedingsschema.ml": "ml",
    "voedingsschema.referentie": "Current schedule (for reference)",
    "voedingsschema.eerdere": "View all schedules (%s earlier)",
    "voedingsschema.eenEerder": "View all schedules (1 earlier)",
    "voedingsplan.bekijkVoerbeurten": "View feedings",
    "voedingsplan.vorigeSchemas": "Previous schedules",
    "voedingsplan.huidigSchema": "Current schedule",
    "voedingsplan.vorigSchema": "Previous schedule",
    "voedingsplan.nu": "now",
    "voedingsplan.voerbeurten": "feedings",
    "voedingsplan.gegeven": "Given",
    "voedingsplan.gegeten": "Eaten",
    "voedingsplan.opgegeten": "eaten of what was given",
    "voedingsplan.geenVoerbeurten": "No feedings were recorded under this schedule.",
    "instellingen.tile.voeding.title": "Feeding",
    "instellingen.tile.voeding.desc": "Products for feeding plans, with their calorie value.",
    "instellingen.item.voeding.producten": "Dry food, wet food and fluids",
    "instellingen.item.voeding.kcal": "kcal per 100 g",
    "instellingen.item.voeding.locatie": "Per location or for all locations",
    "voedingsproducten.kolom.product": "Product",
    "voedingsproducten.kolom.kcal": "Calorie value",
    "voedingsproducten.kolom.locatie": "Location",
    "voedingsproducten.kolom.status": "Status",
    "voedingsproducten.alleLocaties": "All locations",
    "voedingsproducten.uitlegVestiging": "The products of this location. Products for all locations are shown too; you change those under Organisation.",
    "voedingsproducten.uitlegOrganisatie": "Products for all locations. Each location can add its own products on top.",
    "voedingsproducten.voorAlle": "This product applies to all locations.",
    "voedingsproducten.voorVestiging": "This product applies to %s.",
    "voedingsproducten.titel": "Feeding products",
    "voedingsproducten.uitleg": "Dry food, wet food and fluids with their calorie value, to choose from in a feeding plan.",
    "voedingsproducten.zoek": "Search product",
    "voedingsproducten.leeg": "No products of this type yet.",
    "voedingsproducten.nieuw": "New product",
    "voedingsproducten.wijzig": "Edit product",
    "voedingsproducten.geenKcal": "kcal unknown",
    "voedingsproducten.kcalHint": "On the packaging: energy per 100 g (for fluids per 100 ml). Without it the plan shows no kcal for this product.",
    "voedingsplan.titel": "New feeding plan",
    "voedingsplan.ondertitel": "The current plan is kept as history.",
    "voedingsplan.opslaan": "Save new plan",
    "voedingsplan.huidig": "Current plan",
    "voedingsplan.hoeVaak": "How often per day",
    "voedingsplan.perMaaltijd": "Per meal",
    "voedingsplan.soort": "Type",
    "voedingsplan.soort.BROK": "Dry food",
    "voedingsplan.soort.NATVOER": "Wet food / meat",
    "voedingsplan.soort.VOCHT": "Fluid",
    "voedingsplan.product": "Product",
    "voedingsplan.kiesProduct": "Choose a product",
    "voedingsplan.eigenProduct": "+ New product…",
    "voedingsplan.eigenNaam": "Product name",
    "voedingsplan.hoeveelheid": "Amount",
    "voedingsplan.regelWeg": "Remove line",
    "voedingsplan.productToevoegen": "Add product to the list",
    "voedingsplan.productNaam": "Name of the product",
    "voedingsplan.kcalPer100": "kcal per 100 g/ml",
    "voedingsplan.productBewaren": "Save in list",
    "voedingsplan.portie": "Portion per meal",
    "voedingsplan.perDag": "Per day",
    "voedingsplan.kcalPerDag": "%s kcal per day",
    "voedingsplan.kcalPerDagMinstens": "at least %s kcal per day (not every product has a calorie value)",
    "voedingsplan.kcalOnbekend": "kcal unknown: add a calorie value to the product",
    "voedingsplan.voertijden": "Feeding times (optional)",
    "voedingsplan.voertijd": "Feeding time",
    "voedingsplan.onvolledig": "Enter a product and a portion for every component.",
    "voedingsplan.fout": "The plan could not be saved.",
    "voedingsplan.voergift": "Feeding",
    "voedingsplan.keerPerDag": "%s× per day",
    "voedingsplan.historie": "History",
    "voedingsplan.meer": "Show all",
    "voedingsplan.minder": "Show less",
    "animalDetailView.feeding.viewRest": "View rest",
    "animalDetailView.feeding.planAddSubtitle": "Add a new feeding plan for this animal.",
    "animalDetailView.feeding.planEditSubtitle": "Change this animal's feeding plan.",
    "animalDetailView.feeding.form.feedTypePlaceholder": "E.g. kibble, wet food, raw meat",
    "animalDetailView.feeding.form.brandPlaceholder": "E.g. Royal Canin, Hill's",
    "animalDetailView.feeding.form.amountPlaceholder": "E.g. 3 × 75 grams a day, 1 can, 50 ml",
    "animalDetailView.feeding.form.timesTitle": "Feeding times",
    "animalDetailView.feeding.form.timesHint": "Choose when the animal is fed.",
    "animalDetailView.feeding.form.planNotePlaceholder": "Any additional information…",
    "animalDetailView.feeding.logAddSubtitle": "Record a new feeding in the log.",
    "animalDetailView.feeding.logEditSubtitle": "Change this entry in the log.",
    "animalDetailView.feeding.form.fedAtHint": "Choose the date and time the animal was fed.",
    "animalDetailView.feeding.form.amountHint": "Enter the amount of food in grams.",
    "animalDetailView.feeding.form.amountPrefilled": "Filled in from the feeding plan — change it if it's not right.",
    "animalDetailView.feeding.form.eaten": "Eaten (grams)",
    "animalDetailView.feeding.form.eatenHint": "How much of the portion is gone. Leave empty if you don't know yet; fill it in at the next feeding.",
    "animalDetailView.feeding.eatenTooMuch": "More cannot have been eaten than was given.",
    "animalDetailView.feeding.eaten": "%s g eaten (%p%)",
    "animalDetailView.feeding.eatenOpen": "Eaten: still to fill in",
    "animalDetailView.feeding.col.eaten": "Eaten",
    "animalDetailView.feeding.form.behaviorHint": "How did the animal eat?",
    "animalDetailView.feeding.form.notePlaceholder": "Any particulars…",
    "animalDetailView.feeding.form.noteHint": "Add an extra remark if needed.",
    "animalDetailView.feeding.subtitle": "Everything about this animal's feeding",
    "animalDetailView.feeding.next": "Next feeding",
    "animalDetailView.feeding.onSchedule": "On schedule",
    "animalDetailView.feeding.behindSchedule": "Behind schedule",
    "animalDetailView.feeding.countOne": "1 entry",
    "animalDetailView.feeding.countMany": "%s entries",
    "animalDetailView.feeding.inHoursMinutes": "In %s hours and %s minutes",
    "animalDetailView.feeding.inHours": "In %s hours",
    "animalDetailView.feeding.inMinutes": "In %s minutes",
    "animalDetailView.feeding.today": "Today",
    "animalDetailView.feeding.yesterday": "Yesterday",
    "animalDetailView.feeding.tomorrow": "Tomorrow",
    "animalDetailView.feeding.meal.breakfast": "Breakfast",
    "animalDetailView.feeding.meal.lunch": "Lunch",
    "animalDetailView.feeding.meal.dinner": "Dinner",
    "animalDetailView.feeding.meal.generic": "Feeding",
    "animalDetailView.feeding.rowActions": "Actions for this entry",
    "animalDetailView.feeding.planAddTitle": "Add feeding plan",
    "animalDetailView.feeding.planEditTitle": "Edit feeding plan",
    "animalDetailView.feeding.logAddTitle": "Add feeding entry",
    "animalDetailView.feeding.logEditTitle": "Edit feeding entry",
    "animalDetailView.feeding.restTitle": "Other feeding entries",
    "animalDetailView.feeding.form.time1": "Feeding time 1",
    "animalDetailView.feeding.form.time2": "Feeding time 2",
    "animalDetailView.feeding.form.time3": "Feeding time 3 (optional)",
    "animalDetailView.feeding.form.fedAt": "Date and time",
    "animalDetailView.feeding.form.amountGrams": "Amount (grams)",
    "animalDetailView.feeding.form.behavior": "Behaviour",
    "animalDetailView.feeding.saved": "Saved",
    "animalDetailView.feeding.saveConflict": "This was changed by someone else. Reload and try again.",
    "animalDetailView.feeding.saveError": "Save failed",
    "animalDetailView.feeding.timeRequired": "Enter at least one feeding time",
    "animalDetailView.feeding.fedAtRequired": "Date and time are required",
    "animalDetailView.feeding.amountInvalid": "Amount must be greater than 0",
    "animalDetailView.feeding.behaviorRequired": "Behaviour is required",
    "animalDetailView.vaccination.col.naam": "Name",
    "animalDetailView.vaccination.col.merk": "Brand",
    "animalDetailView.vaccination.col.begin": "Date",
    "animalDetailView.vaccination.col.eind": "Valid until",
    "animalDetailView.vaccination.col.vet": "Veterinarian",
    "animalDetailView.vaccination.type.enting": "Vaccination",
    "animalDetailView.vaccination.type.ontwormen": "Deworming",
    "animalDetailView.vaccination.type.ontvlooien": "Flea treatment",
    "animalDetailView.vaccination.type.combo": "Deworming/flea",
    "animalDetailView.vaccination.status.actueel": "Current",
    "animalDetailView.vaccination.status.binnenkort": "Soon",
    "animalDetailView.vaccination.status.verlopen": "Expired",
    "animalDetailView.vaccination.status.onbekend": "Unknown",
    "animalDetailView.vaccination.givenBy": "Given by",
    "animalDetailView.vaccination.next": "Next",
    "animalDetailView.vaccination.by": "By",
    "animalDetailView.vaccination.filter.all": "All",
    "animalDetailView.vaccination.filter.typeLabel": "Type",
    "animalDetailView.vaccination.filter.statusLabel": "Status",
    "animalDetailView.vaccination.filter.searchPlaceholder": "Search…",
    "animalDetailView.vaccination.filter.clear": "+ Clear filters",
    "animalDetailView.vaccination.empty": "No treatments found",
    "animalDetailView.vaccination.viewRemaining": "Show the rest",
    "animalDetailView.vaccination.remainingTitle": "Other treatments",
    "bescherming.subtitel": "Vaccinations, deworming and flea treatment",
    "bescherming.volgendeOver": "next in",
    "bescherming.geenVolgende": "nothing scheduled",
    "bescherming.aandacht": "Show what needs attention",
    "bescherming.sorteren": "Sort",
    "bescherming.sorteer.nieuwste": "Newest first",
    "bescherming.sorteer.oudste": "Oldest first",
    "bescherming.uitgevoerd": "Done",
    "bescherming.acties": "Actions",
    "bescherming.add.ontwormen": "New deworming",
    "bescherming.add.ontvlooien": "New flea treatment",
    "bescherming.eenheid.dag": "%d days",
    "bescherming.eenheid.week": "%d weeks",
    "bescherming.eenheid.maand": "%d months",
    "animalDetailView.vaccination.add.enting": "New vaccination",
    "animalDetailView.vaccination.add.parasiet": "New deworming/flea treatment",
    "animalDetailView.vaccination.passport.import": "Import from passport",
    "animalDetailView.vaccination.passport.uploadHelper": "Upload passport photos (jpg/png/webp) and read them automatically.",
    "animalDetailView.vaccination.passport.choose": "Choose files",
    "animalDetailView.vaccination.passport.uploadFirst": "Upload passport photos first",
    "animalDetailView.vaccination.passport.scan": "Read with AI",
    "animalDetailView.vaccination.passport.scanning": "Analysing…",
    "animalDetailView.vaccination.passport.scanError": "AI analysis failed",
    "animalDetailView.vaccination.passport.unavailable": "No AI provider configured",
    "animalDetailView.vaccination.passport.none": "AI found no clear vaccinations",
    "animalDetailView.vaccination.passport.reviewSummary": "Found: %s line(s). Choose a product and check the dates.",
    "animalDetailView.vaccination.passport.lineFallback": "Vaccination",
    "animalDetailView.vaccination.passport.noProduct": "no product match",
    "animalDetailView.vaccination.passport.titer": "titre determination, not a vaccination",
    "animalDetailView.vaccination.passport.titerUitleg": "A titre test measures antibodies; it shows whether vaccinating is needed. It is not recorded here as a vaccination.",
    "animalDetailView.vaccination.passport.alAanwezig": "already in the file",
    "animalDetailView.vaccination.passport.alAanwezigUitleg": "This vaccination is already recorded for this animal on the same date. It is not added a second time.",
    "animalDetailView.vaccination.passport.mogelijkDubbel": "possibly already in the file",
    "animalDetailView.vaccination.passport.mogelijkDubbelUitleg": "A nearly identical vaccination is already recorded (same product, date within one day). Check it before you add it.",
    "animalDetailView.vaccination.passport.zonderProductUitleg": "No product in the catalogue matches. It is recorded with the name and brand from the passport; pick a product if you want one.",
    "animalDetailView.vaccination.passport.titersKop": "Titre determinations found",
    "animalDetailView.vaccination.passport.titersUitleg": "These are measurements, not vaccinations. They are recorded separately with the animal.",
    "animalDetailView.vaccination.passport.titerVoldoende": "sufficient",
    "animalDetailView.vaccination.passport.titerOnvoldoende": "insufficient",
    "animalDetailView.vaccination.passport.titerAlAanwezigUitleg": "This titre determination is already recorded for this animal on the same date. It is not added a second time.",
    "animalDetailView.vaccination.titers.kop": "Titre determinations",
    "animalDetailView.vaccination.titers.meting": "Titre determination",
    "animalDetailView.vaccination.passport.product": "Product",
    "animalDetailView.vaccination.passport.type": "Type",
    "animalDetailView.vaccination.passport.brand": "Product/brand",
    "animalDetailView.vaccination.passport.toedien": "Given",
    "animalDetailView.vaccination.passport.vanaf": "From",
    "animalDetailView.vaccination.passport.tot": "Until",
    "animalDetailView.vaccination.passport.execute": "Import",
    "animalDetailView.vaccination.passport.result": "AI import: %s added, %s skipped",
    "animalDetailView.vaccination.passport.resultDetailed": "AI import: %s added, %s already present, %s possible duplicate · %s file(s) kept",
    "animalDetailView.vaccination.dialog.newEnting": "New vaccination",
    "animalDetailView.tileVisibility.open": "Show or hide tiles",
    "animalDetailView.tileVisibility.title": "Show or hide tiles",
    "animalDetailView.tileSettings.open": "Tile settings",
    "animalDetailView.tileSettings.title": "%s settings",
    "animalDetailView.tileSettings.intro": "Choose which fields are visible in the backoffice and what the foster family may see or edit.",
    "animalDetailView.tileSettings.introBackoffice": "Choose which fields are visible in the backoffice.",
    "animalDetailView.tileSettings.ruleTitle": "Hidden in the backoffice = hidden for the foster family too.",
    "animalDetailView.tileSettings.ruleText": "When a field is switched off in the backoffice, the foster family automatically can't see it either.",
    "animalDetailView.tileSettings.colField": "Field",
    "animalDetailView.tileSettings.colBackoffice": "Visible in backoffice",
    "animalDetailView.tileSettings.colFoster": "What may the foster family do?",
    "animalDetailView.tileSettings.colBackofficeHint": "Your own view: whether you see this field on the animal page.",
    "animalDetailView.tileSettings.colFosterHint": "Applies to every foster family in the organisation. Never more than the backoffice shows.",
    "animalDetailView.tileSettings.wholeTile": "Whole tile",
    "animalDetailView.tileSettings.followsTile": "Follows the tile",
    "animalDetailView.tileSettings.defaults": "Default settings",
    "animalDetailView.tileSettings.defaultsHint": "Show every field in the backoffice again",
    "animalDetailView.tileVisibility.intro": "Choose which information you want to see on the animal page, and in which order.",
    "animalDetailView.tileVisibility.search": "Search a tile…",
    "animalDetailView.tileVisibility.category": "Category",
    "animalDetailView.tileVisibility.allCategories": "All categories",
    "animalDetailView.tileVisibility.available": "Available tiles (hidden)",
    "animalDetailView.tileVisibility.availableHint": "Drag or click to add",
    "animalDetailView.tileVisibility.selected": "Selected tiles (visible)",
    "animalDetailView.tileVisibility.selectedHint": "Drag or change the order with the arrows.",
    "animalDetailView.tileVisibility.defaultOrder": "Default order",
    "animalDetailView.tileVisibility.add": "Add",
    "animalDetailView.tileVisibility.up": "Move up",
    "animalDetailView.tileVisibility.down": "Move down",
    "animalDetailView.tileVisibility.hide": "Hide",
    "animalDetailView.tileVisibility.pinned": "This tile always stays at the top",
    "animalDetailView.tileVisibility.noMatch": "No hidden tile matches.",
    "animalDetailView.tileVisibility.allVisible": "All tiles are visible.",
    "animalDetailView.tileVisibility.cat.algemeen": "General",
    "animalDetailView.tileVisibility.cat.medisch": "Medical",
    "animalDetailView.tileVisibility.cat.verzorging": "Care",
    "animalDetailView.tileVisibility.cat.registratie": "Registration",
    "animalDetailView.tileVisibility.cat.documentatie": "Documentation",
    "animalDetailView.tileVisibility.desc.basis": "Name, breed, sex, born",
    "animalDetailView.tileVisibility.desc.bescherming": "Vaccinations, deworming and flea treatment",
    "animalDetailView.tileVisibility.desc.taken": "Tasks, reminders, planning",
    "animalDetailView.tileVisibility.desc.wizards": "Registrations and checks",
    "animalDetailView.tileVisibility.desc.medicijnen": "Current medication and administration",
    "animalDetailView.tileVisibility.desc.gewichten": "Chart and overview",
    "animalDetailView.tileVisibility.desc.voeding": "Feeding plan and feeding log",
    "animalDetailView.tileVisibility.desc.logboek": "Recent events",
    "animalDetailView.tileVisibility.desc.notities": "Latest notes and remarks",
    "animalDetailView.tileVisibility.desc.media": "Photos, files and documents",
    "animalDetailView.vaccination.dialog.header.chip": "Chip number",
    "animalDetailView.vaccination.dialog.header.last": "Last vaccination",
    "animalDetailView.vaccination.dialog.header.expires": "Expiry date",
    "animalDetailView.vaccination.dialog.header.days": "days",
    "animalDetailView.vaccination.dialog.header.kruising": "cross",
    "animalDetailView.vaccination.dialog.header.kruisingAlleen": "Cross",
    "animalDetailView.vaccination.dialog.header.onbekend": "Unknown",
    "animalDetailView.vaccination.dialog.uploadedFile": "%d file ready to save",
    "animalDetailView.vaccination.dialog.uploadedFiles": "%d files ready to save",
    "animalDetailView.vaccination.dialog.clearUploads": "Clear uploads",
    "animalDetailView.vaccination.dialog.dropzone": "Click to upload or drop files here (jpg/png/pdf)",
    "animalDetailView.vaccination.dialog.takePhoto": "Take a photo",
    "animalDetailView.vaccination.dialog.takeAnotherPhoto": "Take another photo",
    "animalDetailView.vaccination.dialog.nogEenFotoVraag": "Another page to photograph? Add it — they are read together.",
    "animalDetailView.vaccination.dialog.newParasiet": "New deworming/flea treatment",
    "animalDetailView.vaccination.dialog.edit": "Edit treatment",
    "animalDetailView.vaccination.dialog.type": "Type",
    "animalDetailView.vaccination.dialog.product": "Type",
    "animalDetailView.vaccination.dialog.productPlaceholder": "Choose product…",
    "animalDetailView.vaccination.dialog.brand": "Product/Brand",
    "animalDetailView.vaccination.dialog.givenDate": "Given on",
    "animalDetailView.vaccination.dialog.nextDate": "Next on",
    "animalDetailView.vaccination.dialog.delete": "Delete",
    "animalDetailView.vaccination.dialog.givenDateRequired": "The 'Given on' date is required",
    "animalDetailView.vaccination.dialog.productRequired": "Type is required",
    "animalDetailView.vaccination.dialog.conflict": "This treatment was changed in the meantime. Reload and try again.",
    "animalDetailView.vaccination.dialog.saveError": "Could not save the treatment",
    "animalDetailView.vaccination.dialog.deleteError": "Could not delete the treatment",
    "animalDetailView.note.col.date": "Date",
    "animalDetailView.note.col.title": "Title",
    "animalDetailView.note.col.note": "Note",
    "animalDetailView.note.col.author": "Author",
    "animalDetailView.note.col.tags": "Tags",
    "animalDetailView.note.pinned": "Pinned",
    "animalDetailView.note.followUp": "Follow-up",
    "animalDetailView.note.by": "By",
    "animalDetailView.note.add": "New note",
    "animalDetailView.note.viewRest": "View rest",
    "animalDetailView.note.empty": "No notes found",
    "animalDetailView.note.filter.dateRange": "Period",
    "animalDetailView.note.filter.range.3m": "Last 3 months",
    "animalDetailView.note.filter.range.1m": "Last month",
    "animalDetailView.note.filter.range.all": "All",
    "animalDetailView.note.filter.tag": "Tag",
    "animalDetailView.note.filter.tagPlaceholder": "All",
    "animalDetailView.note.filter.search": "Search…",
    "animalDetailView.note.filter.clear": "Clear filters",
    "animalDetailView.note.action.edit": "Edit",
    "animalDetailView.note.action.delete": "Delete",
    "animalDetailView.note.action.pin": "Pin",
    "animalDetailView.note.action.unpin": "Unpin",
    "animalDetailView.note.dialog.createTitle": "New note",
    "animalDetailView.note.dialog.editTitle": "Edit note",
    "animalDetailView.note.dialog.remainingTitle": "Other notes",
    "animalDetailView.note.field.title": "Title",
    "animalDetailView.note.field.date": "Date",
    "animalDetailView.note.field.note": "Note",
    "animalDetailView.note.field.tags": "Tags",
    "animalDetailView.note.field.followUp": "Follow-up date (optional)",
    "animalDetailView.note.field.author": "Author",
    "animalDetailView.note.field.pinned": "Pinned",
    "animalDetailView.note.delete.title": "Delete note",
    "animalDetailView.note.delete.message": "Are you sure you want to delete this note? This cannot be undone.",
    "animalDetailView.note.validation.title": "Title is required",
    "animalDetailView.note.validation.date": "Date is required",
    "animalDetailView.note.validation.note": "Note is required",
    "animalDetailView.note.validation.author": "Author is required",
    "animalDetailView.note.saved": "Note saved",
    "animalDetailView.note.deleted": "Note deleted",
    "animalDetailView.note.saveConflict": "This note was changed by someone else. Reload and try again.",
    "animalDetailView.note.saveError": "Saving failed",
    "animalDetailView.media.col.file": "File",
    "animalDetailView.media.col.category": "Category",
    "animalDetailView.media.col.size": "Size",
    "animalDetailView.media.col.uploaded": "Uploaded",
    "animalDetailView.media.col.tags": "Tags",
    "animalDetailView.media.filter.date": "Date:",
    "animalDetailView.media.filter.date.6m": "Last 6 months",
    "animalDetailView.media.filter.date.12m": "Last 12 months",
    "animalDetailView.media.filter.date.alles": "All",
    "animalDetailView.media.filter.kind": "Kind",
    "animalDetailView.media.filter.kind.alles": "All",
    "animalDetailView.media.filter.kind.foto": "Photos",
    "animalDetailView.media.filter.kind.video": "Videos",
    "animalDetailView.media.filter.kind.document": "Documents",
    "animalDetailView.media.filter.tag": "Tag:",
    "animalDetailView.media.filter.tag.all": "All tags",
    "animalDetailView.media.addFile": "Add file",
    "animalDetailView.media.tabs": "Media and documents",
    "animalDetailView.media.tab.media": "Media",
    "animalDetailView.media.tab.documents": "Documents",
    "animalDetailView.media.kindLabel": "File type",
    "animalDetailView.media.kindMedia": "Photo / video",
    "animalDetailView.media.kindDocument": "Document",
    "animalDetailView.media.dropInDialog": "Drag files here or click to choose",
    "animalDetailView.media.maxPerFile": "(max. 15 MB per file)",
    "animalDetailView.media.removeFile": "Remove",
    "animalDetailView.media.descriptionPlaceholder": "Give a short description of the files…",
    "animalDetailView.media.fosterVisible": "Visible to the foster family right away",
    "animalDetailView.media.fosterVisibleHint": "The linked foster family can see these files straight away.",
    "animalDetailView.media.actions": "Actions",
    "animalDetailView.media.dropTitle": "Drag photos, videos or files here",
    "animalDetailView.media.dropHint": "or click to choose (max. 15 MB)",
    "animalDetailView.media.showAll": "View all %s",
    "animalDetailView.media.month.current": "This month",
    "animalDetailView.media.month.previous": "Last month",
    "animalDetailView.media.month.unknown": "Unknown date",
    "animalDetailView.media.emptyMedia": "No photos or videos yet — add one",
    "animalDetailView.media.emptyDocuments": "No documents yet — add one",
    "animalDetailView.media.uploadTitle": "Add media",
    "animalDetailView.media.editTitle": "Edit file",
    "animalDetailView.media.deleteTitle": "Delete file",
    "animalDetailView.media.deleteConfirm": "Are you sure you want to delete this file?",
    "animalDetailView.media.chooseFiles": "Choose files…",
    "animalDetailView.media.noFiles": "No file selected yet",
    "animalDetailView.media.maxSizeHint": "Drag here or click to browse (max 15 MB)",
    "animalDetailView.media.filesSelectedSuffix": "files selected",
    "animalDetailView.media.fileRejected": "File rejected (too large or not allowed):",
    "animalDetailView.media.descriptionLabel": "Description (optional)",
    "animalDetailView.media.tagsLabel": "Tags",
    "animalDetailView.media.view": "Open directly",
    "animalDetailView.media.enlarge": "Enlarge",
    "animalDetailView.media.copyLink": "Copy link",
    "animalDetailView.media.copied": "Link copied",
    "animalDetailView.media.download": "Download",
    "animalDetailView.media.rotate": "Rotate",
    "animalDetailView.media.rotateError": "The image could not be rotated.",
    "animalDetailView.media.editTags": "Edit tags",
    "animalDetailView.media.delete": "Delete",
    "animalDetailView.media.saved": "Saved.",
    "animalDetailView.media.uploaded": "Uploaded.",
    "animalDetailView.media.deleted": "Deleted.",
    "animalDetailView.media.saveError": "Could not save. Please try again.",
    "animalDetailView.media.uploadError": "Upload failed. Please try again.",
    "animalDetailView.media.deleteError": "Could not delete. Please try again.",
    "animalDetailView.media.saveConflict": "This file changed in the meantime — reload and try again.",
    "animalDetailView.stay.col.gemeente": "Municipality",
    "animalDetailView.stay.title": "Stay",
    "animalDetailView.stay.active": "Active",
    "animalDetailView.stay.in": "In",
    "animalDetailView.stay.uit": "Out",
    "animalDetailView.stay.days": "days",
    "animalDetailView.stay.notReleased": "Not yet checked out",
    "animalDetailView.stay.current": "Current",
    "animalDetailView.stay.now": "today",
    "animalDetailView.stay.tile.overzicht": "Stays overview",
    "animalDetailView.stay.tile.in": "Intake",
    "animalDetailView.stay.tile.uit": "Departure",
    "animalDetailView.stay.tile.pleeggezin": "Foster home",
    "animalDetailView.stay.tile.chipRegistration": "Chip registration (PetBase)",
    "animalDetailView.stay.tile.nazorg": "Aftercare",

    "menu.pleeggezinOverzicht": "Foster overviews",
    "pgOverzicht.title": "Foster family overviews",
    "pgOverzicht.pleeggezin": "Foster family",
    "pgOverzicht.pleeggezinBij": "Foster family at",
    "pgOverzicht.tab.dieren": "Animals in foster care",
    "pgOverzicht.tab.pleeggezinnen": "Foster families",
    "pgOverzicht.tab.historie": "History",
    "pgOverzicht.totaal": "Total",
    "pgOverzicht.alle": "All",
    "pgOverzicht.wisFilters": "Clear filters",
    "pgOverzicht.zoek.placeholder": "Search animal by name, chip number, breed, colour, foster family…",
    "pgOverzicht.pgZoek.placeholder": "Search foster family by name or place…",
    "pgOverzicht.filter.beschikbaar": "Available (space free)",
    "pgOverzicht.filter.metDieren": "With animals in the home",
    "pgOverzicht.leeftijd.young": "< 1 year",
    "pgOverzicht.leeftijd.adult": "1 to 7 years",
    "pgOverzicht.leeftijd.senior": "8 years and older",
    "pgOverzicht.sorterenOp": "Sort by",
    "pgOverzicht.sorteer.pleeggezin": "Foster family (grouped)",
    "pgOverzicht.sorteer.nieuwste": "Newest first",
    "pgOverzicht.sorteer.naam": "Name (A-Z)",
    "pgOverzicht.sorteer.plaats": "Place",
    "pgOverzicht.sorteer.inhuis": "Most animals in the home",
    "pgOverzicht.sorteer.vrij": "Most space free",
    "pgOverzicht.velden": "Fields",
    "pgOverzicht.velden.kiezen": "Choose fields",
    "pgOverzicht.weergave.kaarten": "Cards",
    "pgOverzicht.weergave.compact": "Compact",
    "pgOverzicht.weergave.lijst": "List",
    "pgOverzicht.resultaat.een": "1 result",
    "pgOverzicht.resultaat.meer": "%d results",
    "pgOverzicht.pgResultaat.een": "1 foster family",
    "pgOverzicht.pgResultaat.meer": "%d foster families",
    "pgOverzicht.dieren.leeg": "No animals found with these filters.",
    "pgOverzicht.relaties.geen": "No relations configured as foster family for this branch.",
    "pgOverzicht.relaties.leegFilter": "No foster families found with these filters.",
    "pgOverzicht.openDier": "Open animal",
    "pgOverzicht.onbekendRas": "Unknown breed",
    "pgOverzicht.periode": "Period:",
    "pgOverzicht.sinds": "Since:",
    "pgOverzicht.nu": "now",
    "pgOverzicht.dag.een": "1 day in foster care",
    "pgOverzicht.dag.meer": "%d days in foster care",
    "pgOverzicht.asielDag.een": "1 day in the shelter",
    "pgOverzicht.asielDag.meer": "%d days in the shelter",
    "pgOverzicht.dagBij.een": "1 day at foster home",
    "pgOverzicht.dagBij.meer": "%d days at foster home",
    "pgOverzicht.details": "Details",
    "pgOverzicht.kolom.dier": "Animal",
    "pgOverzicht.kolom.nuInHuis": "In the home now",
    "pgOverzicht.nuInHuis": "in the home now",
    "pgOverzicht.nuInHuis.title": "Animals in the home now",
    "pgOverzicht.capaciteitTitel": "Capacity & availability",
    "pgOverzicht.plekkenVrij": "%v of %m places free",
    "pgOverzicht.plaats.een": "1 place",
    "pgOverzicht.plaats.meer": "%d places",
    "pgOverzicht.plek.een": "1 place free",
    "pgOverzicht.plek.meer": "%d places free",
    "pgOverzicht.bezet": "%d occupied",
    "pgOverzicht.cat.vrij": "%d free",
    "pgOverzicht.cat.welkom": "welcome",
    "pgOverzicht.stat.vrij": "%s free",
    "pgOverzicht.stat.totaalVrij": "Total free",
    "pgOverzicht.status.actief": "Active",
    "pgOverzicht.status.inactief": "Inactive",
    "pgOverzicht.historie.van": "From",
    "pgOverzicht.historie.tot": "Up to and including",
    "pgOverzicht.historie.zoek": "Search",
    "pgOverzicht.historie.zoeken": "Searching…",
    "pgOverzicht.historie.kies": "Choose a period and click Search.",
    "pgOverzicht.historie.afgekapt": "Only the first %d placements; narrow the period to see the rest.",
    "pgOverzicht.historie.leeg": "No placements in this period.",
    "pgOverzicht.pager.geen": "0 animals",
    "pgOverzicht.pager.bereik": "%f - %t of %n",
    "pgOverzicht.pager.pagina": "page %p / %n",
    "pgOverzicht.veld.foto": "Photo",
    "pgOverzicht.veld.ras": "Breed",
    "pgOverzicht.veld.woonplaats": "Foster family place",
    "pgOverzicht.veld.leeftijd": "Age",
    "pgOverzicht.veld.diersoort": "Species",
    "pgOverzicht.veld.kleur": "Colour",
    "pgOverzicht.veld.vacht": "Coat",
    "pgOverzicht.veld.geslacht": "Sex",
    "pgOverzicht.veld.gecastreerd": "Neutered",
    "pgOverzicht.veld.geboortedatum": "Date of birth",
    "pgOverzicht.veld.herkomst": "Origin",
    "pgOverzicht.veld.opnamedatum": "Intake date",
    "pgOverzicht.veld.gewicht": "Latest weight",
    "pgOverzicht.veld.entingen": "Vaccinations ok",
    "pgOverzicht.veld.bijzonderheden": "Particulars",
    "pgOverzicht.veld.castratiedatum": "Neutering date",
    "pgOverzicht.veld.paspoortnummer": "Passport number",
    "pgOverzicht.veld.chipnummer": "Chip number",
    "pgOverzicht.pgveld.klantnummer": "Relation number",
    "pgOverzicht.pgveld.email": "E-mail",
    "pgOverzicht.pgveld.telefoon": "Phone",
    "pgOverzicht.pgveld.plaats": "Place",
    "pgOverzicht.pgveld.vestiging": "Foster family at",
    "pgOverzicht.pgveld.diersoorten": "Species",
    "pgOverzicht.pgveld.capaciteit": "Capacity",
    "pgOverzicht.pgveld.status": "Status",

    "nazorg.tile.title": "Aftercare",
    "nazorg.tegel.actief": "Aftercare active",
    "nazorg.tegel.nietGestart": "No aftercare started yet",
    "nazorg.tegel.geenVragenlijst": "No questionnaire filled in yet",
    "nazorg.tegel.actieNodig": "Action needed",
    "nazorg.tegel.overwegendGoed": "Mostly good",
    "nazorg.tegel.allesGoed": "All good",
    "nazorg.tegel.badge.actieNodig": "Action needed",
    "nazorg.tegel.badge.aandacht": "Attention",
    "nazorg.tegel.badge.opKoers": "On track",
    "nazorg.tegel.laatsteContact": "Last contact",
    "nazorg.tegel.volgendeMoment": "Next moment",
    "nazorg.tegel.opmerking": "Remark",
    "nazorg.tegel.laatsteScore": "Latest score",
    "nazorg.tegel.nGroen": "%d green",
    "nazorg.tegel.nOranje": "%d amber",
    "nazorg.tegel.nRood": "%d red",
    "nazorg.tile.geenScore": "No score yet",
    "nazorg.tile.bijgewerkt": "updated %s",
    "nazorg.tile.verstuur": "Send aftercare invitation",
    "nazorg.tile.nogGeenAntwoorden": "No answers from the adopter yet. Once they arrive, open them with \"View dossier\".",
    "nazorg.tile.dossier": "View dossier →",
    "nazorg.tile.alleenLezen": "This stay is closed — the dossier stays readable, no new aftercare moments can be sent.",
    "nazorg.tile.linkLabel": "Share this link with the adopter",
    "nazorg.tile.linkKopieer": "Copy",
    "nazorg.tile.linkGekopieerd": "Copied",
    "nazorg.tile.linkLeeg": "There is no published aftercare questionnaire available yet.",
    "nazorg.dim.VOEDING": "Nutrition",
    "nazorg.dim.GEDRAG": "Behaviour",
    "nazorg.dim.GEZONDHEID": "Health",
    "nazorg.dim.HECHTING": "Attachment",
    "nazorg.dim.STRESS": "Stress",
    "animalDetailView.chipReg.flow.INTAKE": "Intake",
    "animalDetailView.chipReg.flow.RELEASE": "Release",
    "animalDetailView.chipReg.attempts": "Attempts",
    "animalDetailView.chipReg.lastError": "Last error",
    "animalDetailView.chipReg.requeue": "Resend registration",
    "animalDetailView.chipReg.requeued": "Re-queued for sending.",
    "animalDetailView.chipReg.requeueFailed": "Could not re-queue this registration.",
    "animalDetailView.chipReg.status.QUEUED": "Queued",
    "animalDetailView.chipReg.status.REGISTERED": "Registered",
    "animalDetailView.chipReg.status.NOT_REGISTERED": "Not registered",
    "animalDetailView.chipReg.status.AFVOER_DONE": "Departure done",
    "animalDetailView.chipReg.status.COMPLETED": "Completed",
    "animalDetailView.chipReg.status.FAILED_AFVOER": "Departure failed",
    "animalDetailView.chipReg.status.FAILED_AANVOER": "New-owner failed",
    "animalDetailView.chipReg.status.SKIPPED_NO_CHIP": "No chip",
    "animalDetailView.chipReg.status.SKIPPED_OUTAGE": "Skipped (PetBase offline)",
    "animalDetailView.chipReg.status.DEAD_LETTERED": "Failed (manual retry)",
    "animalDetailView.stay.field.brenger": "Brought by",
    "animalDetailView.stay.field.opname": "Intake date",
    "animalDetailView.stay.field.opnamesoort": "Intake reason",
    "animalDetailView.stay.field.gemeente": "Municipality",
    "animalDetailView.stay.field.opmerking": "Remarks",
    "animalDetailView.stay.field.haler": "Collected by",
    "animalDetailView.stay.field.vertrek": "Release date",
    "animalDetailView.stay.field.vertreksoort": "Release reason",
    "animalDetailView.stay.empty.overzicht": "No stay history yet",
    "animalDetailView.stay.empty.in": "No intake recorded yet",
    "animalDetailView.stay.empty.uit": "No departure recorded yet",
    "animalDetailView.stay.empty.pleeggezin": "No foster placement",
    "animalDetailView.stay.field.van": "From date",
    "animalDetailView.stay.field.tot": "To date",
    "animalDetailView.stay.action.edit": "Edit",
    // Stray intake tile (Jmix renderStrayBrengerOverviewV2). Jmix hard-codes these in Dutch; the SPA
    // is bilingual, so they get keys.
    "animalDetailView.stay.v2.eyebrow": "Intake",
    "animalDetailView.stay.v2.broughtAsPrefix": "%s was brought in as ",
    "animalDetailView.stay.v2.strayFallback": "stray",
    "animalDetailView.stay.v2.dossier": "File number %s",
    "animalDetailView.stay.v2.organisation": "Organisation",
    "animalDetailView.stay.v2.person": "Person",
    "animalDetailView.stay.v2.complete": "Complete",
    "animalDetailView.stay.v2.unknown": "Unknown",
    "animalDetailView.stay.v2.brenger.role": "Brought by",
    "animalDetailView.stay.v2.brenger.rit": "Trip %s",
    "animalDetailView.stay.v2.brenger.noRit": "No trip number recorded",
    "animalDetailView.stay.v2.vinder.role": "Finder",
    "animalDetailView.stay.v2.vinder.none": "No finder given",
    "animalDetailView.stay.v2.vinder.noneHint": "At intake it was recorded that no finder is known.",
    "animalDetailView.stay.v2.openRelation": "Open relation",
    "animalDetailView.stay.v2.vindplaats.eyebrow": "Found at",
    "animalDetailView.stay.v2.vindplaats.unknown": "Location unknown",
    "animalDetailView.stay.v2.vindplaats.gemeente": "Municipality %s",
    "animalDetailView.stay.v2.note.label": "Remark",
    "animalDetailView.stay.v2.note.empty": "No remark added",
    // Legacy IN variants (surrender / return / birth) — own header vocabulary, no dossier line.
    "animalDetailView.stay.v2.legacyTitle": "INTAKE",
    "animalDetailView.stay.v2.summary.opnamePrefix": "Intake ",
    "animalDetailView.stay.v2.summary.bornPrefix": "%s was ",
    "animalDetailView.stay.v2.summary.bornEm": "born",
    "animalDetailView.stay.v2.summary.bornSuffix": " at the shelter",
    "animalDetailView.stay.v2.releaseTitle": "DEPARTURE",
    "animalDetailView.stay.v2.summary.releasePrefix": "%s was after ",
    "animalDetailView.stay.v2.duration.day": "1 day",
    "animalDetailView.stay.v2.duration.days": "%d days",
    "animalDetailView.stay.v2.summary.releasePrefixNoDuration": "%s is ",
    "animalDetailView.stay.v2.release.adoption": "rehomed",
    "animalDetailView.stay.v2.release.returnOwner": "returned",
    "animalDetailView.stay.v2.release.deceased": "deceased",
    "animalDetailView.stay.v2.release.euthanasia": "euthanised",
    "animalDetailView.stay.v2.release.natureRelease": "released",
    "animalDetailView.stay.v2.release.tijdstip": "Time",
    "animalDetailView.stay.v2.release.doodsoorzaak": "Cause of death",
    "animalDetailView.stay.v2.release.indicatie": "Medical indication",
    "animalDetailView.stay.v2.release.besluitDoor": "Decision made by",
    "animalDetailView.stay.v2.release.onbekend": "Unknown",
    "animalDetailView.stay.v2.release.dierenarts": "Veterinarian",
    "animalDetailView.stay.v2.release.redenUitzetten": "Reason for release",
    "animalDetailView.stay.v2.release.opmerking": "Remark",
    "animalDetailView.stay.v2.release.hersteld": "Fully recovered",
    "animalDetailView.stay.v2.release.habitat": "Ready to return to its habitat",
    "animalDetailView.stay.v2.release.externeVetBetrokken": "External vet involved",
    "animalDetailView.stay.v2.release.geenExterneVet": "No external vet involved",
    "animalDetailView.stay.v2.uitzetlocatie.eyebrow": "Release location",
    "animalDetailView.stay.v2.uitzetlocatie.unknown": "Location unknown",
    "animalDetailView.stay.v2.adoptant.role": "Adopter",
    "animalDetailView.stay.v2.verklaring.plaatsing": "Placement agreement",
    "animalDetailView.stay.v2.verklaring.retourEigenaar": "Return declaration",
    "animalDetailView.stay.v2.eigenaar.role": "Owner",
    "animalDetailView.stay.v2.reden.afstand": "Reason for surrender",
    "animalDetailView.stay.v2.reden.retour": "Reason for return",
    "animalDetailView.stay.v2.reden.choose": "Make a choice",
    "animalDetailView.stay.v2.verklaring.afstand": "Surrender declaration",
    "animalDetailView.stay.v2.verklaring.vinder": "Finder declaration",
    "animalDetailView.stay.v2.verklaring.signedOn": "Signed on",
    "animalDetailView.stay.v2.verklaring.open": "Open",
    "animalDetailView.stay.v2.verklaring.notFound": "No stored %s found for this stay yet",
    "animalDetailView.stay.v2.verklaring.openFailed": "Could not open the document.",
    "animalDetailView.stay.v2.factuur.title": "Invoice",
    "animalDetailView.stay.v2.factuur.open": "Open invoice",
    "animalDetailView.stay.v2.factuur.empty": "No invoice created for this stay yet.",
    "animalDetailView.stay.v2.factuur.nummer": "Invoice number",
    "animalDetailView.stay.v2.factuur.datum": "Invoice date",
    "animalDetailView.stay.v2.factuur.col.omschrijving": "Description",
    "animalDetailView.stay.v2.factuur.col.aantal": "Quantity",
    "animalDetailView.stay.v2.factuur.col.prijs": "Price",
    "animalDetailView.stay.v2.factuur.col.totaal": "Total",
    "animalDetailView.stay.v2.factuur.totaal": "Total",
    "animalDetailView.stay.v2.factuur.betaald": "Paid",
    "animalDetailView.stay.v2.factuur.openstaand": "Outstanding",
    "animalDetailView.stay.v2.reden.saveFailed": "Saving %s failed",
    "animalDetailView.stay.v2.moeder.role": "Mother",
    "animalDetailView.stay.v2.moeder.type": "Animal",
    "animalDetailView.stay.v2.moeder.unknown": "Mother unknown",
    "animalDetailView.stay.v2.moeder.unknownHint": "No mother was recorded at intake.",
    "animalDetailView.stay.v2.moeder.chip": "Chip %s",
    "animalDetailView.stay.v2.moeder.born": "Born %s",
    "animalDetailView.stay.v2.moeder.toProfile": "To animal profile",
    "animalDetailView.stay.action.registerDeparture": "Register departure",
    "animalDetailView.stay.action.delete": "Delete",
    "animalDetailView.stay.action.retour": "Return to shelter",
    "animalDetailView.stay.editIntakeTitle": "Edit intake",
    "animalDetailView.stay.typeChange": "Change",
    "animalDetailView.stay.typeChange.title": "Change intake type?",
    "animalDetailView.stay.typeChange.body": "You will walk through the intake wizard again. The current intake is overwritten — no second stay is created. Unsaved changes on this screen are lost.",
    "animalDetailView.stay.typeChange.confirm": "Start wizard",
    "animalDetailView.stay.releaseTypeChange.title": "Change departure type?",
    "animalDetailView.stay.releaseTypeChange.body": "You will walk through the departure wizard again. The current departure is overwritten. Unsaved changes on this screen are lost.",
    "animalDetailView.stay.edit.chip.organisatie": "Organisation",
    "animalDetailView.stay.edit.chip.persoon": "Person",
    "animalDetailView.stay.edit.reden": "Reason",
    "animalDetailView.stay.editReleaseTitle": "Edit departure",
    "animalDetailView.stay.editFosterTitle": "Adjust dates",
    "animalDetailView.stay.confirmDeleteTitle": "Delete foster placement",
    "animalDetailView.stay.confirmDeleteBody": "Are you sure you want to delete this foster placement? This cannot be undone.",
    "animalDetailView.stay.confirmRetourTitle": "Return to shelter",
    "animalDetailView.stay.confirmRetourBody": "The current foster placement will be closed as of today. Continue?",
    "animalDetailView.stay.notice.saved": "Saved",
    "animalDetailView.stay.notice.error": "Could not save — please try again.",
    "animalDetailView.stay.notice.conflict": "This stay was changed elsewhere. Reload the page and try again.",
    "animalDetailView.stay.notice.invalidPeriod": "Invalid period — check the dates (it may overlap or fall outside the stay).",
    "animalDetailView.stay.notice.required": "Please fill in the required fields.",
    "animalDetailView.stay.klant.none": "—",
    "animalDetailView.stay.klant.change": "Change",
    "animalDetailView.stay.klant.close": "Close",
    "animalDetailView.stay.klant.clear": "Clear",
    "animalDetailView.stay.klant.search": "Search contact…",
    "animalDetailView.stay.klant.empty": "No contacts found",
    "animalDetailView.stay.action.place": "Place with foster",
    "animalDetailView.stay.placeTitle": "Place with foster",
    "animalDetailView.stay.notice.ineligible": "This foster cannot take in this animal (species/branch mismatch).",
    "animalDetailView.stay.place.label": "Foster",
    "animalDetailView.stay.place.choose": "Choose a foster",
    "animalDetailView.stay.place.search": "Search foster…",
    "animalDetailView.stay.place.empty": "No suitable fosters found",
    "animalDetailView.stay.place.subtitle": "Choose the foster this animal goes to. Fosters with available capacity and matching categories are listed first.",
    "animalDetailView.stay.place.filterAll": "All categories",
    "animalDetailView.stay.place.suitable": "Suitable fosters (%s)",
    "animalDetailView.stay.place.unsuitable": "Not suitable (%s)",
    "animalDetailView.stay.place.capacity": "Available places",
    "animalDetailView.stay.place.capacityUnset": "Not set",
    "animalDetailView.stay.place.capacityUnsetHint": "Capacity not set",
    "animalDetailView.stay.place.capacityHint": "%s of %s places taken",
    "animalDetailView.stay.place.suitableFor": "Suitable for",
    "animalDetailView.stay.place.noCategories": "No categories set",
    "animalDetailView.stay.place.fullMatch": "Fully suitable",
    "animalDetailView.stay.place.notIdeal": "Not ideal for this animal",
    "animalDetailView.stay.place.onlyCat": "Only: %s",
    "animalDetailView.stay.place.suitableShort": "Suitable",
    "animalDetailView.stay.place.notSuited": "Not suitable",
    "animalDetailView.note.delete.messageNamed": "Are you sure you want to delete \"%s\"? This cannot be undone.",
    "animalDetailView.stay.currentStay": "Current stay",
    "animalDetailView.stay.historical": "Historical",
    "animalDetailView.stay.side.binnen": "In",
    "animalDetailView.stay.side.uit": "Out",
    "animalDetailView.stay.overview.countOne": "1 stay",
    "animalDetailView.stay.overview.countMany": "%s stays",
    "animalDetailView.stay.overview.since": "since %s",
    "animalDetailView.stay.overview.viewAll": "Show all %s stays",
    "animalDetailView.stay.print.button": "Print",
    "animalDetailView.stay.print.title": "Print a document",
    "animalDetailView.stay.print.intro": "For the selected stay (%s).",
    "animalDetailView.stay.print.empty": "There are no print templates switched on.",
    "animalDetailView.stay.print.failed": "The document could not be created.",
    "animalDetailView.stay.overview.allTitle": "All stays",
    "animalDetailView.stay.field.typeBinnenkomst": "Intake type",
    "animalDetailView.stay.field.typeVertrek": "Departure type",
    "animalDetailView.stay.field.locatie": "Location",
    "animalDetailView.stay.field.naamBrenger": "Name of bringer",
    "animalDetailView.stay.field.naamHaler": "Name of collector",
    "animalDetailView.stay.field.redenHerkomst": "Reason / origin",
    "animalDetailView.stay.empty.uitForStay": "No departure recorded for this stay yet",
    "animalDetailView.stay.foster.historyTitle": "History within this stay",
    "animalDetailView.stay.foster.categorie": "Category",
    "animalDetailView.stay.foster.geenPleeggezin": "No foster home",
    "animalDetailView.stay.foster.actief": "Active",
    "animalDetailView.stay.foster.opDitMomentInAsiel": "Currently in the shelter",
    "animalDetailView.stay.foster.huidigInPleeggezin": "Currently in a foster home",
    "animalDetailView.stay.foster.kiesCategorie": "Choose category",
    "animalDetailView.stay.foster.geenCategorieen": "No categories available for this branch",
    "animalDetailView.stay.foster.asiel": "Shelter",
    "animalDetailView.stay.foster.sinds": "Since",
    "animalDetailView.stay.foster.aanwezig": "in care",
    "animalDetailView.stay.foster.capaciteit": "Capacity used",
    "animalDetailView.stay.dayOne": "day",
    "animalDetailView.history.search": "Search history…",
    "animalDetailView.history.today": "Today",
    "animalDetailView.history.yesterday": "Yesterday",
    "animalDetailView.history.unknownDate": "Unknown date",
    "animalDetailView.history.system": "system",
    "animalDetailView.history.by": "by",
    "animalDetailView.history.more": "Show more",
    "animalDetailView.history.less": "Show less",
    "animalDetailView.history.close": "Close",
    "animalDetailView.history.changed": "Change",
    "animalDetailView.history.empty": "No history yet for this animal.",
    "animalDetailView.history.emptyFiltered": "No changes found for this search term.",
    "animalDetailView.history.ent.DIER": "Animal",
    "animalDetailView.history.ent.ASIELVERBLIJF": "Shelter stay",
    "animalDetailView.history.ent.ASIELVERBLIJFNOTITIE": "Note",
    "animalDetailView.history.ent.ASIELVERBLIJFSTATUSPERIODE": "Status period",
    "animalDetailView.history.ent.ASIELVERBLIJFOPVANGCATEGORIE": "Care category",
    "animalDetailView.history.ent.MEETMOMENTHOND": "Measurement",
    "animalDetailView.history.ent.MEETMOMENTKAT": "Measurement",
    "animalDetailView.history.ent.TNRVANGACTIEDIER": "TNR capture",
    "animalDetailView.history.ent.DOSSIERREGEL": "Record line",
    "animalDetailView.history.ent.USERANIMALPREFERENCE": "Preference",
    "animalDetailView.history.ent.EXCHANGE": "Exchange",
    "animalDetailView.history.ent.KLANT": "Relation",
    "animalDetailView.history.ent.FACTUUR": "Invoice",
    "animalDetailView.history.ent.VESTIGING": "Branch",
    "animalDetailView.history.verb.CREATED": "created",
    "animalDetailView.history.verb.UPDATED": "updated",
    "animalDetailView.history.verb.DELETED": "deleted",
    "animalDetailView.history.verb.SENT": "sent",
    "animalDetailView.history.verb.ACCEPTED": "accepted",
    "animalDetailView.history.verb.CANCELLED": "cancelled",
    "animalDetailView.history.verb.COMPLETED": "completed",
    "animalDetailView.history.verb.REJECTED": "rejected",
    "animalDetailView.history.evt.KLANT_CREATED": "Relation created",
    "animalDetailView.history.evt.KLANT_UPDATED": "General details updated",
    "animalDetailView.history.evt.KLANT_DELETED": "Relation deleted",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_PLAATSING": "Placed in foster home",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_EINDE": "Returned from foster home",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_UPDATED": "Foster period adjusted",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_DELETED": "Foster stay removed",
    // Under-construction placeholder — shown when the SPA handles a not-yet-migrated / unknown route.
    "underConstruction.title": "Under construction",
    "underConstruction.heading": "This page isn't ready yet",
    "underConstruction.body":
      "We're still building this part of the new Docasoft. It's on the way — thanks for your patience.",
    "underConstruction.routeLabel": "Requested page",
    "underConstruction.home": "Back to the start",
    // tarief-types Epic 5: Dierenambulance tarief overview (single rates grid, migrate-as-is).
    "dierenambulanceTarief.none": "—",
    "dierenambulanceTarief.banner":
      "Animal-ambulance rates: change a rate's base price + per-km tariff, or view its history.",
    "dierenambulanceTarief.empty": "No rates yet.",
    "dierenambulanceTarief.load.error": "The rates could not be loaded.",

    // Crematorium tariff settings (Epic 21)
    "crematoriumTarief.klasse.title": "Weight classes",
    "crematoriumTarief.klasse.add": "Add weight class",
    "crematoriumTarief.klasse.add.title": "New weight class",
    "crematoriumTarief.klasse.edit.title": "Edit weight class",
    "crematoriumTarief.klasse.empty": "No weight classes yet.",
    "crematoriumTarief.klasse.col.naam": "Name",
    "crematoriumTarief.klasse.col.vanKg": "From (kg)",
    "crematoriumTarief.klasse.col.totKg": "To (kg)",
    "crematoriumTarief.klasse.col.volgorde": "Order",
    "crematoriumTarief.tarief.title": "Cremation costs per weight class & processing type",
    "crematoriumTarief.tarief.add": "Add tariff",
    "crematoriumTarief.tarief.add.title": "New tariff",
    "crematoriumTarief.tarief.edit.title": "Edit tariff",
    "crematoriumTarief.tarief.empty": "No tariffs yet.",
    "crematoriumTarief.tarief.col.klasse": "Weight class",
    "crematoriumTarief.tarief.col.vorm": "Processing form",
    "crematoriumTarief.tarief.col.prijs": "Price",
    "crematoriumTarief.tarief.col.btw": "VAT",
    "crematoriumTarief.tarief.col.ingangsdatum": "Effective from",
    "crematoriumTarief.tarief.col.einddatum": "End date",
    "crematoriumTarief.col.actief": "Active",
    "crematoriumTarief.col.acties": "Actions",
    "crematoriumTarief.actief.ja": "Active",
    "crematoriumTarief.actief.nee": "Inactive",
    "crematoriumTarief.action.refresh": "Refresh",
    "menu.crematoriumHandeling": "Funeral steps",
    "crematoriumHandeling.title": "Steps",
    "crematoriumHandeling.sub": "Which steps a funeral goes through, and when each one is due",
    "crematoriumHandeling.vorm.groep": "Funeral type",
    "crematoriumHandeling.vorm.add": "Add funeral type",
    "crematoriumHandeling.vorm.edit": "Edit type",
    "crematoriumHandeling.vorm.add.title": "New funeral type",
    "crematoriumHandeling.vorm.edit.title": "Edit funeral type",
    "crematoriumHandeling.vorm.naam": "Name",
    "crematoriumHandeling.vorm.code": "Code",
    "crematoriumHandeling.vorm.soort": "Kind",
    "crematoriumHandeling.vorm.soort.hint": "The kind determines the pricing and whether the ashes return; the name around it is yours to choose.",
    "crematoriumHandeling.vorm.empty": "No funeral types yet.",
    "crematoriumHandeling.vorm.delete.blocked": "Remove its steps first.",
    "crematoriumHandeling.field.code.required": "Enter a code.",
    "crematoriumHandeling.stappen.title": "Steps",
    "crematoriumHandeling.stappen.van": "Steps — %s",
    "crematoriumHandeling.handeling.add": "Add step",
    "crematoriumHandeling.handeling.add.title": "New step",
    "crematoriumHandeling.handeling.edit.title": "Edit step",
    "crematoriumHandeling.handeling.empty": "This funeral type has no steps yet.",
    "crematoriumHandeling.col.naam": "Step",
    "crematoriumHandeling.col.wanneer": "When",
    "crematoriumHandeling.col.verplicht": "Required",
    "crematoriumHandeling.col.document": "On completion",
    "crematoriumHandeling.verplicht.ja": "Required",
    "crematoriumHandeling.verplicht.nee": "Optional",
    "crematoriumHandeling.document.geen": "No document",
    "crematoriumHandeling.moment.AANMELDING": "registration",
    "crematoriumHandeling.moment.ONTVANGST": "receipt",
    "crematoriumHandeling.moment.UITVAART": "the funeral",
    "crematoriumHandeling.vanaf.label": "Counts from",
    "crematoriumHandeling.vanaf.hint": "A moment in the file, or another step — the latter lets you chain steps together.",
    "crematoriumHandeling.vanaf.naHandeling": "after “%s”",
    "crematoriumHandeling.vanaf.onbekend": "an earlier step",
    "crematoriumHandeling.dagen": "Days",
    "crematoriumHandeling.werkdagen": "Count working days only",
    "crematoriumHandeling.soort.werkdagen": "working days",
    "crematoriumHandeling.soort.kalenderdagen": "calendar days",
    "crematoriumHandeling.wanneer.direct": "straight away at %s",
    "crematoriumHandeling.wanneer.na": "%d %s after %s",
    "crematoriumHandeling.uitleg.asRetour": ", the ashes return to the owner.",
    "crematoriumHandeling.uitleg.geenAsRetour": ", no ashes return.",
    "crematoriumPlanning.tab.groep": "Planning view",
    "crematoriumPlanning.tab.werklijst": "Steps due",
    "crematoriumPlanning.tab.runs": "Cremation planning",
    "crematoriumWerklijst.search.label": "Search",
    "crematoriumWerklijst.filter.termijn": "Due",
    "crematoriumWerklijst.filter.handeling": "Step",
    "crematoriumWerklijst.filter.alleHandelingen": "All steps",
    "crematoriumWerklijst.col.verwachtOp": "Due",
    "crematoriumWerklijst.col.handeling": "Step",
    "crematoriumWerklijst.col.dossier": "Animal / file",
    "crematoriumWerklijst.col.eigenaar": "Owner",
    "crematoriumWerklijst.col.vorm": "Funeral type",
    "crematoriumWerklijst.col.verplicht": "Required",
    "crematoriumWerklijst.termijn.verlopen": "Overdue",
    "crematoriumWerklijst.termijn.vandaag": "Today",
    "crematoriumWerklijst.termijn.komend": "Upcoming",
    "crematoriumWerklijst.termijn.onbepaald": "Not yet dated",
    "crematoriumWerklijst.dier.onbekend": "No name",
    "crematoriumWerklijst.action.afronden": "Mark done",
    "crematoriumWerklijst.empty": "Nothing outstanding.",
    "crematoriumWerklijst.uitleg": "The due dates follow from the configured steps — that is where you set what has to happen how many days after which moment.",
    "crematieDetail.kop.dossier": "File",
    "crematieDetail.kop.dier": "Animal",
    "crematieDetail.kop.vorm": "Funeral type",
    "crematieDetail.kop.uitvaartdatum": "Funeral date",
    "crematieDetail.kop.herkomst": "Referred by",
    "crematieDetail.kop.totaal": "Total",
    "crematieDetail.kop.openstaand": "%s outstanding",
    "crematieDetail.kop.factuur": "Invoice",
    "crematieDetail.section.vervoer": "Transport",
    "relatieDetailView.tab.uitvaart": "Funeral",
    "relatieDetailView.tab.eigenaar": "Owner",
    "relatieDetailView.tab.historie": "History",
    "relatieDetailView.klantNummer": "Customer K-%s",
    "relatieDetailView.adresetiket": "Address label",
    "crematieUitvaartTab.geen": "No funerals for this customer yet.",
    "crematieDetail.tab.dossier": "Dossier",
    "crematieDetail.tab.documenten": "Documents",
    "crematieDetail.tab.afdrukken": "Print",
    "crematieDetail.documenten.maken": "Create document",
    "crematieDetail.documenten.uploaden": "Upload",
    "crematieDetail.documenten.bezig": "Uploading…",
    "crematieDetail.documenten.uploadFout": "Upload failed.",
    "crematieDetail.document.bestand": "File",
    "crematieDetail.document.downloaden": "Download",
    "crematieDetail.factuur.voorbeeld": "Preview",
    "crematieDetail.factuur.datum": "Invoice date",
    "crematieDetail.factuur.herinnering": "1st reminder",
    "crematieDetail.factuur.belmoment": "Call",
    "crematieDetail.factuur.incasso": "Collection agency",
    "crematieDetail.factuur.perEmail": "Send the invoice by e-mail",
    "crematieDetail.factuur.opslaanMislukt": "Saving the follow-up failed.",
    "crematieDetail.factuur.uitgeven": "Issue invoice",
    "crematieDetail.factuur.alUitgegeven": "This dossier already has an invoice",
    "crematieDetail.factuur.conflict": "This dossier already has an invoice, or is still a draft.",
    "crematieDetail.factuur.forbidden": "You are not allowed to issue invoices.",
    "crematieDetail.factuur.error": "Issuing the invoice failed.",
    "crematieDetail.afdruk.titel": "Available prints",
    "crematieDetail.afdruk.afdrukken": "Print",
    "crematieDetail.afdruk.voorbeeld": "Preview",
    "crematieDetail.afdruk.beschikbaar": "Available",
    "crematieDetail.afdruk.naUitgifte": "After issuing",
    "crematieDetail.afdruk.geblokkeerd": "The browser blocked the print window; allow pop-ups for this site.",
    "crematieDetail.afdruk.fout": "Printed, but the document could not be recorded on the dossier.",
    "crematieDetail.afdruk.FACTUUR": "Crematorium invoice",
    "crematieDetail.afdruk.CREMATIEFACTUUR": "Cremation invoice (pre-printed)",
    "crematieDetail.afdruk.CREMATIECERTIFICAAT": "Cremation certificate",
    "crematieDetail.afdruk.HERINNERINGSKAART": "Memorial card",
    "crematieDetail.afdruk.BEGELEIDENDE_BRIEF": "Cover letter",
    "crematieDetail.afdruk.AS_RETOURBRIEF": "Ashes return letter",
    "crematieDetail.afdruk.IDENTIFICATIELABEL": "Cremation identification label",
    "crematieDetail.afdruk.URNLABEL": "Urn label",
    "crematieDetail.afdruk.ADRESETIKET": "Address label",
    "crematieDetail.klantOpenen": "Open customer",
    "crematieDetail.groep.identiteit": "Identity",
    "crematieDetail.groep.rasGeslacht": "Breed and sex",
    "crematieDetail.groep.gewicht": "Weight and death",
    "crematieDetail.groep.wanneer": "When",
    "crematieDetail.groep.tarief": "Chosen rate",
    "crematieDetail.groep.asbestemming": "Ashes",
    "crematieDetail.groep.opmerking": "Remarks",
    "crematieDetail.groep.aanlevering": "Delivery",
    "crematieDetail.groep.ophaaladres": "Pick-up address",
    "crematieDetail.groep.rit": "Origin and trip",
    "crematieDetail.groep.regels": "Lines",
    "crematieDetail.groep.totaal": "Total",
    "crematieDetail.groep.status": "Change status",
    "crematieDetail.section.factuurregels": "Invoice lines",
    "crematieDetail.section.logboek": "Log",
    "crematieDetail.log.status": "Status",
    "crematieDetail.log.controle": "Check",
    "crematieDetail.log.handeling": "Step",
    "crematieDetail.log.betaling": "Payment",
    "crematieDetail.klasse.hint": "Follows from the weight and sets the cremation rate",
    "crematieStappen.door": "By",
    "crematieStappen.doorIkzelf": "Myself",
    "crematieStappen.datum": "Date",
    "crematieStappen.tijd": "Time",
    "crematieDetail.crematie.run": "Run",
    "crematieDetail.vervoer.ophaalDatum": "Collection date",
    "crematieDetail.vervoer.afstand": "Distance",
    "crematieDetail.vervoer.retourwijze": "Return method",
    "crematieDetail.vervoer.opgehaald": "Collected from the customer",
    "crematieDetail.dier.kruising": "Crossbreed",
    "crematieDetail.dier.kruisingMet": "Crossed with",
    "crematieDetail.dier.geboortedatum": "Date of birth",
    "crematieDetail.dier.leeftijd": "Age",
    "crematieDetail.dier.jaar": "%s years",
    "crematieDetail.dier.maanden": "%s months",
    "crematieDetail.dier.klasseAutomatisch": "%s (automatic)",
    "crematieDetail.groep.leeftijdGewicht": "Age and weight",
    "crematieDetail.crematie.ingevoerdDoor": "Entered by",
    "crematieDetail.crematie.uitvaartdatum": "Funeral date",
    "crematieDetail.crematie.tijd": "Time",
    "crematieDetail.crematie.tarief": "Cremation rate",
    "crematieDetail.crematie.geenTarief": "No rate on the invoice yet",
    "crematieDetail.crematie.tariefKiesHint": "Applies from the weight class; pick another as long as the invoice has not been issued.",
    "crematieDetail.crematie.tariefVast": "The invoice has been issued, so the rate is fixed; a change is a correction.",
    "crematieDetail.crematie.tariefVersie": "version %s",
    "crematieDetail.crematie.basisprijs": "Base price",
    "crematieDetail.crematie.bestemming": "Destination",
    "crematieDetail.crematie.grafnummer": "Grave number",
    "crematieDetail.asbestemming.URN_MEE": "Urn taken home",
    "crematieDetail.asbestemming.VERSTROOIEN_VELD": "Scattered on the field",
    "crematieDetail.asbestemming.VERSTROOIEN_ZEE": "Scattered at sea",
    "crematieDetail.asbestemming.BIJZETTEN_GRAF": "Interred in the grave",
    "crematieDetail.vervoer.gebracht": "Owner brings the animal",
    "crematieDetail.vervoer.afstandEnkel": "Distance (one way, km)",
    "crematieDetail.vervoer.ophaalmoment": "Collection",
    "crematieDetail.vervoer.regulier": "Regular",
    "crematieDetail.vervoer.spoed": "Urgent",
    "crematieDetail.vervoer.retourRekenen": "Charge the distance as a return trip",
    "crematieDetail.vervoer.adres": "Address",
    "crematieDetail.vervoer.adresEigenaar": "Owner address — %s",
    "crematieDetail.vervoer.adresPraktijk": "Practice address — %s",
    "crematieDetail.vervoer.adresAnders": "Other address…",
    "crematieDetail.vervoer.tijd": "Time",
    "crematieDetail.vervoer.praktijk": "Practice / clinic",
    "crematieDetail.vervoer.derdePartij": "Third party",
    "crematieDetail.vervoer.opgehaaldDoor": "Collected by",
    "crematieDetail.vervoer.ritUitleg": "%s km %s · call-out %s + %s km ·",
    "crematieDetail.vervoer.retour": "return",
    "crematieDetail.vervoer.enkel": "one way",
    "crematieDetail.vervoer.ritOpFactuur": "listed as a line on the invoice.",
    "crematieStappen.tegel.titel": "Steps",
    "crematieStappen.volgende": "Next step",
    "crematieStappen.allesAf": "Everything done",
    "crematieStappen.voortgang": "%d of %d done",
    "crematieStappen.afronden": "Mark “%s” done",
    "crematieStappen.heropenen": "Reopen",
    "crematieStappen.afgerondOp": "done %s",
    "crematieStappen.verwacht": "due %s",
    "crematieStappen.teLaatSinds": "overdue since %s",
    "crematieStappen.leeg": "This funeral type has no steps set up.",
    "crematieDetail.bord.ontgrendel": "Unlock the board to edit",
    "crematieDetail.bord.vergrendel": "Lock the board",
    "relatieDetailView.tile.crematies": "Cremations",
    "crematiesTile.col.dier": "Animal / file",
    "crematiesTile.col.vorm": "Funeral type",
    "crematiesTile.col.datum": "Date",
    "crematiesTile.col.status": "Status",
    "crematiesTile.col.bedrag": "Amount",
    "crematiesTile.nieuw": "New cremation",
    "crematiesTile.lopend": "Ongoing",
    "crematiesTile.inBehandeling": "In progress",
    "crematiesTile.totaal": "Total cremations",
    "crematiesTile.laatste": "Last cremation",
    "crematiesTile.filter.vestiging": "Branch",
    "crematiesTile.filter.alleVestigingen": "All branches",
    "crematiesTile.filter.periode": "Period",
    "crematiesTile.filter.alles": "all",
    "crematiesTile.filter.geen": "No cremations match this filter.",
    "crematiesTile.nogTePlannen": "not scheduled yet",
    "crematiesTile.geenFactuur": "not invoiced yet",
    "crematiesTile.empty": "No cremations for this customer.",
    "crematiesTile.error": "The cremations could not be loaded.",
    "crematiesTile.aantal": "%d in total",
    "menu.crematoriumUitvaartoverzichten": "Funeral overviews",
    "crematoriumOverzichten.title": "Funeral overviews",
    "crematoriumOverzichten.sub": "All files, oven runs and ashes returns together",
    "crematoriumOverzichten.tab.dossiers": "Files",
    "crematoriumOverzichten.tab.runs": "Oven runs",
    "crematoriumOverzichten.tab.asretour": "Ashes return",
    "crematoriumOverzichten.kpi.ontvangen": "Received",
    "crematoriumOverzichten.kpi.gepland": "Scheduled",
    "crematoriumOverzichten.kpi.asRetour": "Ashes awaiting return",
    "crematoriumOverzichten.kpi.openstaand": "Outstanding",
    "crematoriumTarief.load.error": "Loading failed.",
    "crematoriumTarief.field.naam.required": "Name is required.",
    "crematoriumTarief.field.prijs.required": "Price is required.",
    "crematoriumTarief.notice.conflict": "Changed in the meantime — reload and try again.",
    "crematoriumTarief.notice.forbidden": "You are not authorised for this action.",
    "crematoriumTarief.notice.error": "Saving failed.",
    "crematoriumTarief.vorm.INDIVIDUEEL": "Individual",
    "crematoriumTarief.vorm.UITGEBREID": "Extended",
    "crematoriumTarief.vorm.COLLECTIEF": "Collective",
    "crematoriumTarief.vorm.RESOMEREN_INDIVIDUEEL": "Resomation (individual)",
    "crematoriumTarief.vorm.RESOMEREN_COLLECTIEF": "Resomation (collective)",
    "crematoriumTarief.vorm.BEGRAFENIS_INDIVIDUEEL": "Burial (individual)",
    "crematoriumTarief.vorm.BEGRAFENIS_ANONIEM": "Burial (anonymous)",
    "crematoriumTarief.vorm.DESTRUCTIE": "Destruction",
    // Crematorium transport tariff settings (Epic 21)
    "crematoriumVervoer.title": "Collection costs",
    "crematoriumVervoer.add": "Add transport tariff",
    "crematoriumVervoer.add.title": "New transport tariff",
    "crematoriumVervoer.edit.title": "Edit transport tariff",
    "crematoriumVervoer.empty": "No transport tariffs yet.",
    "crematoriumVervoer.col.naam": "Name",
    "crematoriumVervoer.col.starttarief": "Base fee",
    "crematoriumVervoer.col.prijsPerKm": "Price per km",
    "crematoriumVervoer.col.vrijeKm": "Free km",
    "crematoriumVervoer.col.spoedtoeslag": "Urgent surcharge",
    "crematoriumVervoer.col.btw": "VAT",
    "crematoriumVervoer.col.actief": "Active",
    "crematoriumVervoer.col.acties": "Actions",
    "crematoriumVervoer.actief.ja": "Active",
    "crematoriumVervoer.actief.nee": "Inactive",
    "crematoriumVervoer.action.refresh": "Refresh",
    "crematoriumVervoer.load.error": "Loading failed.",
    "crematoriumVervoer.field.naam.required": "Name is required.",
    "crematoriumVervoer.notice.conflict": "Changed in the meantime — reload and try again.",
    "crematoriumVervoer.notice.forbidden": "You are not authorised for this action.",
    "crematoriumVervoer.notice.error": "Saving failed.",
    // Crematorium dashboard (Epic 21, MR-5)
    "crematoriumDashboard.load.error": "The dashboard could not be loaded.",
    "crematoriumDashboard.subtitle": "Crematorium · today's overview",
    "crematoriumDashboard.snelacties.title": "Quick actions",
    "crematoriumDashboard.action.nieuw": "New registration",
    "crematoriumDashboard.action.relatie": "Find relation",
    "crematoriumDashboard.action.ophaling": "Schedule pickup",
    "crematoriumDashboard.action.asRetour": "Register ash return",
    "crematoriumDashboard.kpi.nieuweAanmeldingen": "New registrations",
    "crematoriumDashboard.kpi.ophalenVandaag": "Pickups today",
    "crematoriumDashboard.kpi.ontvangen": "Received",
    "crematoriumDashboard.kpi.geplandeCrematies": "Planned cremations",
    "crematoriumDashboard.kpi.asKlaarVoorRetour": "Ashes ready for return",
    "crematoriumDashboard.kpi.openstaandBedrag": "Outstanding amount",
    "crematoriumDashboard.kpi.wachtOpBetaling": "Awaiting payment",
    "crematoriumDashboard.kpi.nogNietIngepland": "Not yet scheduled",
    "crematoriumDashboard.kpi.facturenVervallen": "Overdue invoices",
    "crematoriumDashboard.acties.title": "Actions required",
    "crematoriumDashboard.omzet.title": "Revenue",
    "crematoriumDashboard.omzet.dezeMaand": "This month",
    "crematoriumDashboard.omzet.openstaand": "Outstanding",
    "crematoriumDashboard.verdeling.title": "Distribution this month",
    "crematoriumDashboard.verdeling.empty": "No cremations this month yet.",
    "crematoriumDashboard.perDag.title": "Cremations per day (last 7)",
    "crematoriumDashboard.recent.title": "Recent dossiers",
    "crematoriumDashboard.recent.empty": "No dossiers yet.",
    "crematoriumDashboard.status.CONCEPT": "Draft",
    "crematoriumDashboard.status.AANGEMELD": "Registered",
    "crematoriumDashboard.status.OPHALING_GEPLAND": "Pickup planned",
    "crematoriumDashboard.status.OPGEHAALD": "Picked up",
    "crematoriumDashboard.status.ONTVANGEN": "Received",
    "crematoriumDashboard.status.WACHT_OP_BETALING": "Awaiting payment",
    "crematoriumDashboard.status.KLAAR_VOOR_CREMATIE": "Ready for cremation",
    "crematoriumDashboard.status.GEPLAND": "Scheduled",
    "crematoriumDashboard.status.GECREMEERD": "Cremated",
    "crematoriumDashboard.status.AS_URN_KLAAR_VOOR_RETOUR": "Ashes ready for return",
    "crematoriumDashboard.status.AFGEROND": "Completed",
    "crematoriumDashboard.status.GEANNULEERD": "Cancelled",
    // Crematorium Epic 21 (MR-4): read-only Planning / Runs / As-retour overviews.
    "crematoriumPlanning.col.planningDatum": "Scheduled for",
    "crematoriumPlanning.col.dossier": "Dossier",
    "crematoriumPlanning.col.dier": "Animal",
    "crematoriumPlanning.col.vorm": "Processing form",
    "crematoriumPlanning.col.status": "Status",
    "crematoriumPlanning.col.locatie": "Location",
    "crematoriumPlanning.col.run": "Run",
    "crematoriumPlanning.status.KLAAR_VOOR_CREMATIE": "Ready for cremation",
    "crematoriumPlanning.status.GEPLAND": "Scheduled",
    "crematoriumPlanning.search.label": "Search (dossier / animal)",
    "crematoriumPlanning.filter.status": "Status",
    "crematoriumPlanning.filter.vorm": "Processing form",
    "crematoriumPlanning.filter.all": "All",
    "crematoriumPlanning.action.refresh": "Refresh",
    "crematoriumPlanning.load.error": "Could not load the planning.",
    "crematoriumPlanning.empty": "No dossiers in the planning.",
    "crematoriumPlanning.col.acties": "Actions",
    "crematoriumPlanning.action.koppel": "Assign to run",
    "crematoriumPlanning.assign.title": "Assign to a cremation run",
    "crematoriumPlanning.assign.dossier": "Dossier: %s",
    "crematoriumPlanning.assign.run": "Cremation run",
    "crematoriumPlanning.assign.opslaan": "Assign",
    "crematoriumPlanning.assign.annuleren": "Cancel",
    "crematoriumPlanning.assign.forbidden": "You are not authorised to plan runs.",
    "crematoriumPlanning.assign.error": "The dossier could not be assigned.",
    "crematoriumRuns.col.runnummer": "Run number",
    "crematoriumRuns.col.datumTijd": "Date/time",
    "crematoriumRuns.col.vorm": "Processing form",
    "crematoriumRuns.col.locatie": "Location",
    "crematoriumRuns.col.oven": "Oven",
    "crematoriumRuns.col.status": "Status",
    "crematoriumRuns.col.totaalGewicht": "Total weight",
    "crematoriumRuns.status.CONCEPT": "Draft",
    "crematoriumRuns.status.GEPLAND": "Scheduled",
    "crematoriumRuns.status.IN_UITVOERING": "In progress",
    "crematoriumRuns.status.UITGEVOERD": "Completed",
    "crematoriumRuns.status.GECONTROLEERD": "Checked",
    "crematoriumRuns.status.AFGESLOTEN": "Closed",
    "crematoriumRuns.status.GEANNULEERD": "Cancelled",
    "crematoriumRuns.search.label": "Search (run number / location)",
    "crematoriumRuns.filter.status": "Status",
    "crematoriumRuns.filter.all": "All",
    "crematoriumRuns.action.refresh": "Refresh",
    "crematoriumRuns.load.error": "Could not load the runs.",
    "crematoriumRuns.empty": "No cremation runs.",
    "crematoriumRuns.col.acties": "Actions",
    "crematoriumRuns.action.nieuw": "New run",
    "crematoriumRuns.action.bewerken": "Edit",
    "crematoriumRuns.action.opslaan": "Save",
    "crematoriumRuns.action.annuleren": "Cancel",
    "crematoriumRuns.add.title": "New cremation run",
    "crematoriumRuns.edit.title": "Edit cremation run",
    "crematoriumRuns.veld.datumTijd": "Date & time",
    "crematoriumRuns.veld.vorm": "Processing form",
    "crematoriumRuns.veld.locatie": "Location",
    "crematoriumRuns.veld.oven": "Oven",
    "crematoriumRuns.veld.capaciteit": "Capacity (kg)",
    "crematoriumRuns.veld.status": "Status",
    "crematoriumRuns.veld.opmerkingen": "Remarks",
    "crematoriumRuns.conflict": "This run was changed in the meantime. Refresh and try again.",
    "crematoriumRuns.forbidden": "You are not authorised to edit runs.",
    "crematoriumRuns.error": "The run could not be saved.",
    "crematoriumAsRetour.col.dossier": "Dossier",
    "crematoriumAsRetour.col.dier": "Animal",
    "crematoriumAsRetour.col.eigenaar": "Owner",
    "crematoriumAsRetour.col.asUrnNummer": "Ashes/urn number",
    "crematoriumAsRetour.col.retourwijze": "Return method",
    "crematoriumAsRetour.col.klaarSinds": "Ready since",
    "crematoriumAsRetour.search.label": "Search (dossier / owner / animal)",
    "crematoriumAsRetour.action.refresh": "Refresh",
    "crematoriumAsRetour.load.error": "Could not load the ashes & urn return.",
    "crematoriumAsRetour.empty": "No dossiers ready for return.",
    // Crematorium registration worklist (Epic 21, MR-3)
    "aanmeldingen.col.dossier": "Dossier",
    "aanmeldingen.col.dier": "Animal",
    "aanmeldingen.col.eigenaar": "Owner",
    "aanmeldingen.col.herkomst": "Origin",
    "aanmeldingen.col.status": "Status",
    "aanmeldingen.col.verwerkingsvorm": "Processing form",
    "aanmeldingen.col.aangemeld": "Registered",
    "aanmeldingen.search.placeholder": "Search dossier no., owner or animal…",
    "aanmeldingen.filter.alle": "All",
    "aanmeldingen.load.error": "Loading failed.",
    "aanmeldingen.empty": "No registrations yet.",
    "aanmeldingen.nieuw": "New registration",
    "aanmeldingen.status.CONCEPT": "Draft",
    "aanmeldingen.status.AANGEMELD": "Registered",
    "aanmeldingen.status.OPHALING_GEPLAND": "Pickup planned",
    "aanmeldingen.status.OPGEHAALD": "Picked up",
    "aanmeldingen.herkomst.DOOR_EIGENAAR_GEBRACHT": "Brought by owner",
    "aanmeldingen.herkomst.OPHALEN_BIJ_EIGENAAR": "Pickup at owner",
    "aanmeldingen.herkomst.VIA_DIERENARTS": "Via vet",
    "aanmeldingen.herkomst.VIA_DERDE_PARTIJ": "Via third party",
    // Crematorium dossier list + read-only detail (Epic 21, MR-2)
    "crematies.col.dossier": "Dossier",
    "crematies.col.dier": "Animal",
    "crematies.col.eigenaar": "Owner",
    "crematies.col.status": "Status",
    "crematies.col.verwerkingsvorm": "Processing form",
    "crematies.col.betaling": "Payment",
    "crematies.col.aangemeld": "Registered",
    "crematies.col.totaal": "Total",
    "crematies.search.placeholder": "Search dossier no., owner or animal…",
    "crematies.filter.alle": "All",
    "crematies.load.error": "Loading failed.",
    "crematies.empty": "No dossiers yet.",
    "crematies.status.CONCEPT": "Draft",
    "crematies.status.AANGEMELD": "Registered",
    "crematies.status.OPHALING_GEPLAND": "Pickup planned",
    "crematies.status.OPGEHAALD": "Picked up",
    "crematies.status.ONTVANGEN": "Received",
    "crematies.status.WACHT_OP_BETALING": "Awaiting payment",
    "crematies.status.KLAAR_VOOR_CREMATIE": "Ready for cremation",
    "crematies.status.GEPLAND": "Scheduled",
    "crematies.status.GECREMEERD": "Cremated",
    "crematies.status.AS_URN_KLAAR_VOOR_RETOUR": "Ashes ready for return",
    "crematies.status.AFGEROND": "Completed",
    "crematies.status.GEANNULEERD": "Cancelled",
    "crematies.betaal.NOG_NIET_GEFACTUREERD": "Not yet invoiced",
    "crematies.betaal.GEFACTUREERD": "Invoiced",
    "crematies.betaal.BETAALLINK_VERSTUURD": "Payment link sent",
    "crematies.betaal.DEELS_BETAALD": "Partially paid",
    "crematies.betaal.BETAALD": "Paid",
    "crematies.betaal.VERVALLEN": "Overdue",
    "crematies.betaal.HERINNERING_VERSTUURD": "Reminder sent",
    "crematies.betaal.GECREDITEERD": "Credited",
    "crematies.herkomst.DOOR_EIGENAAR_GEBRACHT": "Brought by owner",
    "crematies.herkomst.OPHALEN_BIJ_EIGENAAR": "Pickup at owner",
    "crematies.herkomst.VIA_DIERENARTS": "Via vet",
    "crematies.herkomst.VIA_DERDE_PARTIJ": "Via third party",
    "crematies.factuur.col.nummer": "Invoice no.",
    "crematies.factuur.col.factuurdatum": "Invoice date",
    "crematies.factuur.col.vervaldatum": "Due date",
    "crematies.factuur.col.status": "Status",
    "crematies.factuur.col.totaal": "Total",
    "crematies.factuur.col.openstaand": "Outstanding",
    "crematieDetail.heading": "Cremation dossier",
    "crematieDetail.load.error": "The dossier could not be loaded.",
    "crematieAanmelding.heading": "New registration",
    "crematieAanmelding.dier.panel": "Animal details",
    "crematieAanmelding.dier.naamVerplicht": "A name is required.",
    "crematieAanmelding.dier.soortVerplicht": "Choose a species.",
    "crematieAanmelding.dier.gewichtVerplicht": "The weight sets the weight class and the rate.",
    "crematieAanmelding.dier.overlijdenVerplicht": "The date of death is required.",
    "crematieAanmelding.dier.gevolg": "What follows",
    "crematieAanmelding.dier.gevolgLeeg": "Enter a weight — the weight class and the rate follow from it.",
    "crematieAanmelding.dier.vormen": "Funeral types for this class, incl. VAT:",
    "crematieAanmelding.dier.vormGeenTarief": "no rate",
    "crematieAanmelding.dier.gevolgPrijs": "cremation rate incl. VAT",
    "crematieAanmelding.dier.gevolgGeenVorm": "The rate follows once a funeral type is chosen.",
    "crematieAanmelding.kosten.vraag": "What will this cost?",
    "crematieAanmelding.kosten.sub": "What is already fixed, and what you add to it.",
    "crematieAanmelding.kosten.tarief": "Cremation %s · %s",
    "crematieAanmelding.kosten.ophalen": "Collection — %s",
    "crematieAanmelding.kosten.ophalenInfo": "Only the call-out rate of the collection is fixed; the kilometres are added once the trip is driven.",
    "crematieAanmelding.kosten.uitTarief": "from the rates",
    "crematieAanmelding.kosten.bedrag": "Amount",
    "crematieAanmelding.kosten.totaal": "Total incl. VAT",
    "crematieAanmelding.kosten.geen": "Nothing is fixed yet: choose a weight and a funeral type.",
    "crematieAanmelding.kosten.toevoegen": "Add from the catalogue",
    "crematieAanmelding.kosten.spoed": "urgent",
    "crematieAanmelding.kosten.productToevoegen": "Add product",
    "crematieAanmelding.handelingen.datum": "Date",
    "crematieAanmelding.handelingen.tijd": "Time",
    "crematieAanmelding.kosten.geenTarief": "For weight class %s no %s rate is set up — the cremation itself is missing from this breakdown.",
    "crematieAanmelding.subtitle": "Register a funeral at the crematorium",
    "crematieAanmelding.dier.vraag": "Which animal is this about?",
    "crematieAanmelding.dier.sub": "The details of the animal being cremated",
    "crematieAanmelding.crematie.vraag": "Which funeral, and when?",
    "crematieAanmelding.crematie.sub": "The type sets both the rate and the steps that follow",
    "crematieAanmelding.bijverkoop.vraag": "Anything else going with them?",
    "crematieAanmelding.handelingen.vraag": "Which steps get scheduled?",
    "crematieAanmelding.handelingen.sub": "These end up on the dossier as work to be done",
    "crematieAanmelding.bevestigen.vraag": "Is this correct?",
    "crematieAanmelding.bevestigen.sub": "Check it over — then the funeral is created and opened",
    "crematieAanmelding.eyebrow": "Crematorium",
    "crematieAanmelding.annuleren": "Cancel",
    "crematieAanmelding.vorige": "Previous",
    "crematieAanmelding.volgende": "Next",
    "crematieAanmelding.opslaanConcept": "Save as draft",
    "crematieAanmelding.definitief": "Register definitively",
    "crematieAanmelding.ja": "Yes",
    "crematieAanmelding.nee": "No",
    "crematieAanmelding.forbidden": "You are not authorised to create registrations.",
    "crematieAanmelding.validatie": "Please complete the required fields before registering.",
    "crematieAanmelding.error": "The registration could not be saved.",
    "crematieAanmelding.stap.dier": "Animal",
    "crematieAanmelding.stap.crematie": "Cremation",
    "crematieAanmelding.stap.bijverkoop": "Costs",
    "crematieAanmelding.stap.handelingen": "Steps",
    "crematieAanmelding.eigenaar.zoek": "Find owner",
    "crematieAanmelding.eigenaar.zoekInfo": "Who brought the animal?",
    "crematieAanmelding.dier.kiezen": "Choose…",
    "crematieAanmelding.dier.reu": "Male",
    "crematieAanmelding.dier.teef": "Female",
    "crematieAanmelding.dier.onbekend": "Unknown",
    "crematieAanmelding.crematie.uitvaartvorm": "Funeral type",
    "crematieAanmelding.crematie.datum": "Funeral date",
    "crematieAanmelding.crematie.tijd": "Time",
    "crematieAanmelding.bijverkoop.uitleg": "Urns, jewellery and keepsakes from the catalogue; they end up as lines on the invoice.",
    "crematieAanmelding.bijverkoop.zoek": "Search products",
    "crematieAanmelding.bijverkoop.omschrijving": "Description",
    "crematieAanmelding.bijverkoop.aantal": "Qty",
    "crematieAanmelding.bijverkoop.prijs": "Price",
    "crematieAanmelding.bijverkoop.btw": "VAT",
    "crematieAanmelding.bijverkoop.totaal": "Additional sales total",
    "crematieAanmelding.handelingen.geenVorm": "Choose a funeral type first — its steps are scheduled from there.",
    "crematieAanmelding.handelingen.geenVormen": "No funeral types have been set up yet, so there are no steps to schedule.",
    "crematieAanmelding.handelingen.geen": "This funeral type has no steps set up yet.",
    "crematieAanmelding.handelingen.uitleg": "These steps are scheduled on the dossier for %s:",
    "crematieAanmelding.handelingen.verplicht": "Required",
    "crematieAanmelding.handelingen.moment.AANMELDING": "%s days after registration",
    "crematieAanmelding.handelingen.moment.ONTVANGST": "%s days after receipt",
    "crematieAanmelding.handelingen.moment.UITVAART": "%s days after the funeral",
    "crematieAanmelding.concept": "Save as draft",
    "crematieAanmelding.aanmaken": "Create and open",
    "crematieAanmelding.stap.eigenaar": "Owner",
    "crematieAanmelding.stap.verwerking": "Origin & processing",
    "crematieAanmelding.stap.bevestigen": "Confirm",
    "crematieAanmelding.dier.naam": "Name",
    "crematieAanmelding.dier.diersoort": "Species",
    "crematieAanmelding.dier.ras": "Breed",
    "crematieAanmelding.dier.geslacht": "Sex",
    "crematieAanmelding.dier.kleur": "Colour",
    "crematieAanmelding.dier.gewicht": "Weight (kg)",
    "crematieAanmelding.dier.chip": "Chip / tattoo",
    "crematieAanmelding.dier.overlijden": "Date of death",
    "crematieAanmelding.eigenaar.naam": "Name",
    "crematieAanmelding.eigenaar.adres": "Address",
    "crematieAanmelding.eigenaar.postcode": "Postcode",
    "crematieAanmelding.eigenaar.plaats": "City",
    "crematieAanmelding.eigenaar.telefoon": "Phone",
    "crematieAanmelding.eigenaar.email": "Email",
    "crematieAanmelding.eigenaar.geenEmail": "No email",
    "crematieAanmelding.eigenaar.betaler": "Payer (if different)",
    "crematieAanmelding.verwerking.herkomst": "Origin",
    "crematieAanmelding.verwerking.vorm": "Processing form",
    "crematieAanmelding.verwerking.spoed": "Urgent",
    "crematieAanmelding.prijs.titel": "Estimated price (incl. VAT)",
    "crematieAanmelding.prijs.klasse": "Weight class: %s",
    "crematieAanmelding.prijs.geenKlasse": "No weight class for this weight yet",
    "crematieAanmelding.prijs.geenTarief": "No tariff found",
    "crematieAanmelding.check.dierNaam": "Animal name",
    "crematieAanmelding.check.diersoort": "Species",
    "crematieAanmelding.check.gewicht": "Weight",
    "crematieAanmelding.check.overlijden": "Date of death",
    "crematieAanmelding.check.eigenaar": "Owner name",
    "crematieAanmelding.check.contact": "Phone or email",
    "crematieAanmelding.check.verwerkingsvorm": "Processing form",
    "crematieAanmelding.check.herkomst": "Origin",
    "crematieAanmelding.check.gewichtsklasse": "Weight class",
    "crematieDetail.status.title": "Status",
    "crematieDetail.status.volgendeStap": "Next step: %s",
    "crematieDetail.status.wijzigen": "Change status",
    "crematieDetail.status.opmerking": "Remark (optional)",
    "crematieDetail.status.bevestig": "Confirm",
    "crematieDetail.status.conflict": "There is an open identification deviation. Resolve it first before the dossier can continue.",
    "crematieDetail.status.forbidden": "You are not authorised to change the status.",
    "crematieDetail.status.error": "The status could not be changed.",
    "crematieDetail.status.geenActie": "This dossier has reached a final status; no further steps are possible.",
    "crematieDetail.eyebrow": "Cremation dossier #%s",
    "crematieDetail.section.dier": "Animal",
    "crematieDetail.section.eigenaar": "Owner",
    "crematieDetail.section.crematie": "Cremation",
    "crematieDetail.section.producten": "Products",
    "crematieDetail.section.facturen": "Invoices",
    "crematieDetail.section.betalingen": "Payments",
    "crematieDetail.section.historie": "Status history",
    "crematieDetail.section.controles": "Identification checks",
    "crematieDetail.section.documenten": "Documents",
    "crematieDetail.dier.naam": "Name",
    "crematieDetail.dier.diersoort": "Species",
    "crematieDetail.dier.ras": "Breed",
    "crematieDetail.dier.geslacht": "Sex",
    "crematieDetail.dier.kleur": "Colour",
    "crematieDetail.dier.gewicht": "Weight",
    "crematieDetail.dier.chip": "Chip / tattoo",
    "crematieDetail.dier.overlijden": "Date of death",
    "crematieDetail.eigenaar.naam": "Name",
    "crematieDetail.eigenaar.adres": "Address",
    "crematieDetail.eigenaar.postcode": "Postcode",
    "crematieDetail.eigenaar.plaats": "City",
    "crematieDetail.eigenaar.telefoon": "Phone",
    "crematieDetail.eigenaar.email": "Email",
    "crematieDetail.crematie.herkomst": "Origin",
    "crematieDetail.crematie.planning": "Planned",
    "crematieDetail.crematie.locatie": "Location",
    "crematieDetail.crematie.klasse": "Weight class",
    "crematieDetail.crematie.ophaalAdres": "Pickup address",
    "crematieDetail.crematie.chauffeur": "Driver",
    "crematieDetail.crematie.rit": "Trip no.",
    "crematieDetail.crematie.ontvangen": "Received by",
    "crematieDetail.crematie.identificatie": "Identification no.",
    "crematieDetail.crematie.asUrn": "Ashes / urn no.",
    "crematieDetail.crematie.bijzonderheden": "Remarks",
    "crematieDetail.regel.omschrijving": "Description",
    "crematieDetail.regel.aantal": "Qty",
    "crematieDetail.regel.prijs": "Price",
    "crematieDetail.regel.korting": "Discount",
    "crematieDetail.regel.btw": "VAT",
    "crematieDetail.regel.totaal": "Total",
    "crematieDetail.regel.empty": "No products.",
    "crematieDetail.regel.acties": "Actions",
    "crematieDetail.regel.toevoegen": "Add product",
    "crematieDetail.regel.gefactureerdSlot": "Invoiced — change it on the invoice",
    "crematieDetail.regel.bewerken": "Edit",
    "crematieDetail.regel.verwijderen": "Remove",
    "crematieDetail.regel.add.title": "Add product",
    "crematieDetail.regel.edit.title": "Edit product",
    "crematieDetail.regel.verwijderConfirm": "Remove this product line?",
    "crematieDetail.regel.opslaan": "Save",
    "crematieDetail.regel.annuleren": "Cancel",
    "crematieDetail.regel.veld.omschrijving": "Description",
    "crematieDetail.regel.veld.aantal": "Qty",
    "crematieDetail.regel.veld.prijs": "Price",
    "crematieDetail.regel.veld.kortingPct": "Discount %",
    "crematieDetail.regel.veld.btw": "VAT %",
    "crematieDetail.regel.conflict": "This product line was changed in the meantime. Refresh and try again.",
    "crematieDetail.regel.forbidden": "You are not authorised to edit products.",
    "crematieDetail.regel.error": "The product could not be saved.",
    "crematieDetail.totaal.subtotaal": "Subtotal",
    "crematieDetail.totaal.korting": "Discount",
    "crematieDetail.totaal.btw": "VAT",
    "crematieDetail.totaal.totaal": "Total",
    "crematieDetail.totaal.betaald": "Paid",
    "crematieDetail.totaal.openstaand": "Outstanding",
    "crematieDetail.betaling.datum": "Date",
    "crematieDetail.betaling.wijze": "Method",
    "crematieDetail.betaling.bedrag": "Amount",
    "crematieDetail.betaling.door": "Registered by",
    "crematieDetail.betaling.acties": "Actions",
    "crematieDetail.betaling.registreren": "Register payment",
    "crematieDetail.betaling.add.title": "Register payment",
    "crematieDetail.betaling.veld.bedrag": "Amount",
    "crematieDetail.betaling.veld.wijze": "Method",
    "crematieDetail.betaling.opslaan": "Save",
    "crematieDetail.betaling.annuleren": "Cancel",
    "crematieDetail.betaling.verwijderen": "Cancel payment",
    "crematieDetail.betaling.verwijderConfirm": "Cancel this payment?",
    "crematieDetail.betaling.forbidden": "You are not authorised to register payments.",
    "crematieDetail.betaling.error": "The payment could not be saved.",
    "crematieDetail.betalingen.empty": "No payments.",
    "crematieDetail.facturen.empty": "No invoices.",
    "crematieDetail.document.type": "Type",
    "crematieDetail.document.omschrijving": "Description",
    "crematieDetail.document.kanaal": "Channel",
    "crematieDetail.document.aangemaakt": "Created",
    "crematieDetail.document.door": "By",
    "crematieDetail.documenten.empty": "No documents.",
    "crematieDetail.controle.stap": "Step",
    "crematieDetail.controle.uitkomst": "Outcome",
    "crematieDetail.controle.door": "Checked by",
    "crematieDetail.controle.locatie": "Location",
    "crematieDetail.controle.tijdstip": "Time",
    "crematieDetail.controles.empty": "No checks.",
    "crematieDetail.uitkomst.AKKOORD": "OK",
    "crematieDetail.uitkomst.AFWIJKING": "Deviation",
    "crematieDetail.historie.empty": "No status history.",
    // Crematorium invoices list (Epic 21)
    "crematoriumFacturen.col.nummer": "Invoice no.",
    "crematoriumFacturen.col.factuurdatum": "Invoice date",
    "crematoriumFacturen.col.vervaldatum": "Due date",
    "crematoriumFacturen.col.betaler": "Payer",
    "crematoriumFacturen.col.status": "Status",
    "crematoriumFacturen.col.totaal": "Total",
    "crematoriumFacturen.col.openstaand": "Outstanding",
    "crematoriumFacturen.search.placeholder": "Search invoice no. or payer…",
    "crematoriumFacturen.filter.alle": "All statuses",
    "crematoriumFacturen.load.error": "Loading failed.",
    "crematoriumFacturen.empty": "No invoices yet.",
    "crematoriumFacturen.status.NOG_NIET_GEFACTUREERD": "Not yet invoiced",
    "crematoriumFacturen.status.GEFACTUREERD": "Invoiced",
    "crematoriumFacturen.status.BETAALLINK_VERSTUURD": "Payment link sent",
    "crematoriumFacturen.status.DEELS_BETAALD": "Partially paid",
    "crematoriumFacturen.status.BETAALD": "Paid",
    "crematoriumFacturen.status.VERVALLEN": "Overdue",
    "crematoriumFacturen.status.HERINNERING_VERSTUURD": "Reminder sent",
    "crematoriumFacturen.status.GECREDITEERD": "Credited",
    "dierenambulanceTarief.col.diensttype": "Service type",
    "dierenambulanceTarief.col.basisprijs": "Base price",
    "dierenambulanceTarief.col.perKm": "Per km",
    "dierenambulanceTarief.col.geldigVanaf": "Valid from",
    "dierenambulanceTarief.col.acties": "Actions",
    "dierenambulanceTarief.action.prijswijzigen": "Change price",
    "dierenambulanceTarief.action.historie": "Show history",
    "dierenambulanceTarief.action.toevoegen": "Add rate",
    "dierenambulanceTarief.search": "Search rates",
    "dierenambulanceTarief.peildatum": "Valid on",
    "dierenambulanceTarief.action.historieOverzicht": "History overview",
    "dierenambulanceTarief.action.refresh": "Refresh",
    "dierenambulanceTarief.stub.tooltip": "Coming in later work",
    "dierenambulanceTarief.notice.forbidden": "You are not authorised to edit rates.",
    "dierenambulanceTarief.notice.forbiddenPast":
      "A past effective date requires the rate-admin role (ROLE_TARIEF_ADMIN).",
    "dierenambulanceTarief.notice.error": "Something went wrong. Please try again.",
    "dierenambulanceTarief.prijswijzigen.title": "Change price — %s",
    "dierenambulanceTarief.prijswijzigen.submit": "Apply",
    "dierenambulanceTarief.field.basisprijs": "Base price",
    "dierenambulanceTarief.field.basisprijs.required": "A base price is required.",
    "dierenambulanceTarief.field.perKm": "Per-km tariff",
    "dierenambulanceTarief.field.effectdatum": "Effective date",
    "dierenambulanceTarief.field.reden": "Reason",
    "dierenambulanceTarief.historie.title": "History — %s",
    "dierenambulanceTarief.historie.empty": "No history yet.",
    "dierenambulanceTarief.historie.error": "The history could not be loaded.",
    "dierenambulanceTarief.hist.vanaf": "Valid from",
    "dierenambulanceTarief.hist.tot": "Until",
    "dierenambulanceTarief.hist.basisprijs": "Base price",
    "dierenambulanceTarief.hist.perKm": "Per km",
    "dierenambulanceTarief.hist.reden": "Reason",
    "dierenambulanceTarief.hist.status": "Status",
    "dierenambulanceTarief.hist.status.GEPLAND": "Planned",
    "dierenambulanceTarief.hist.status.ACTIEF": "Active",
    "dierenambulanceTarief.hist.status.VERVALLEN": "Expired",
    // kp-Epic 2 (kennelplanning-migration): the React floorplan read shell. The nl block carries the
    // verbatim Jmix `kennelplanningOverviewView.*` literals; en is the translated counterpart. A
    // SEPARATE nav item from the legacy `menu.kennelplanning` so both coexist during the transition.
    // advertentie-migration (Epic 22/23 Jmix-exit): the React Advertentie list + read-only detail. A new
    // menu group mirroring the Jmix `advertentie` menu; the Jmix list view stays reachable by its @Route.
    "menu.advertentie.title": "Advertisement",
    "menu.advertentieBeheer": "Advertisements",
    "kenmerkWerklijst.title": "Fill in the questions",
    "kenmerkWerklijst.subtitle": "%open% questions are still unanswered across %dieren% advertisements. The match wizard on DierMatch reads exactly these answers.",
    "kenmerkWerklijst.laden": "Counting what is still open…",
    "kenmerkWerklijst.toon": "Show the list",
    "kenmerkWerklijst.verberg": "Hide the list",
    "kenmerkWerklijst.uitleg": "An unanswered question is not a match: a visitor who has a cat at home never sees an animal whose file does not say whether it can live with cats.",
    "kenmerkWerklijst.uitlegAi": "For %n% of these the file holds enough text for the AI to propose answers — you check them before they are saved.",
    "kenmerkWerklijst.openVan": "%open% of %totaal% open",
    "kenmerkWerklijst.aiKanHelpen": "AI can help",
    "kenmerkWerklijst.geenDossier": "No file text",
    "kenmerkWerklijst.invullen": "Fill in",
    "kenmerkWerklijst.naamloos": "Without a name",
    "kenmerkWerklijst.allesGedaan": "Everything on this page has been answered.",
    "kenmerkWerklijst.meer": "Show more",
    "advertentieListView.title": "Advertisements",
    "advertentieListView.subtitle": "Every animal that has an advertisement, and where it stands.",
    "advertentieListView.stat.total": "Total",
    "advertentieListView.acties": "Actions",
    "advertentieListView.stand.NIEUW": "New",
    "advertentieListView.stand.GERESERVEERD": "Reserved",
    "advertentieListView.stand.GEPLAATST": "Placed",
    "advertentieListView.stand.BUITENBEENTJE": "Underdog",
    "advertentieListView.actie.stand.BUITENBEENTJE":
      "Show as an underdog — the row \"The underdogs\" on the home page",
    "advertentieListView.actie.stand.NIEUW": "Show as new in the shelter",
    "advertentieListView.actie.stand.GERESERVEERD": "Show as reserved",
    "advertentieListView.actie.stand.GEPLAATST": "Show as placed (leaves the site after the set number of days)",
    "advertentieListView.actie.standAutomatisch": "Back to automatic",
    "advertentieDetailView.snel.title": "Set directly",
    "advertentieListView.column.bekeken": "Viewed",
    "advertentieListView.bekeken.uitleg":
      "How often this animal was viewed on the site you are looking at. DierMatch and ikzoekbaas count separately — they are two lists with their own audience.",
    "advertentieListView.column.bewaard": "Saved",
    "advertentieListView.bewaard.uitleg":
      "How many visitors have this animal on their favourites list right now. Someone who removes the heart no longer counts.",
    "advertentieListView.column.vragen": "Characteristics",
    "advertentieListView.vragen.open": "%n% unanswered",
    "advertentieListView.vragen.klaar": "—",
    "advertentieListView.vragen.klaarUitleg": "All characteristics answered — open the animal",
    "advertentieListView.vragen.uitleg":
      "The match wizard on DierMatch reads these answers. Every unanswered question becomes “unknown” there, so this animal barely takes part in matching. Click to fill them in.",
    "advertentieListView.vragen.openAi": "%n% unanswered · AI can help",
    "advertentieListView.vragen.uitlegAi":
      "This animal’s file holds enough behaviour notes for the AI to propose the answers — you only have to check them. Click to start.",
    "advertentieListView.filter.ai": "AI can help",
    "advertentieListView.filter.ai.alle": "All",
    "advertentieListView.filter.ai.ja": "Only where AI can help",
    "advertentieListView.filter.ai.nee": "Only without file text",
    "advertentieListView.column.reacties": "Responses",
    "advertentieListView.reacties.aantal": "%n%",
    "advertentieListView.reacties.nieuw": "%n% · %nieuw% new",
    "advertentieListView.reacties.leeg": "No responses yet — they appear here, and this is where you add extra questions for this animal",
    "advertentieListView.reacties.uitleg":
      "People who filled in the form on DierMatch. Click to read what they wrote and to find their phone number.",
    "kennismaking.titel": "Who wants to meet %naam%",
    "kennismaking.ditDier": "this animal",
    "kennismaking.aantal": "%n% responses, %nieuw% not yet read",
    "kennismaking.aantal.een": "1 response, %nieuw% not yet read",
    "kennismaking.extra.titel": "Extra questions about this animal",
    "kennismaking.extra.uitleg":
      "They appear after the standard questions for the species, in their own block headed with the animal's name. Saving re-sends the listing to DierMatch straight away.",
    "kennismaking.extra.plaatshouder": "For example: do you have a fenced garden?",
    "kennismaking.extra.toevoegen": "Add question",
    "kennismaking.extra.verplicht": "Required",
    "kennismaking.extra.bewaard": "Saved and sent to DierMatch.",
    "kennismaking.geen":
      "Nobody has filled in the form for this animal yet. Responses arrive here within a few minutes of being submitted.",
    "kennismaking.kiesEen": "Pick a response to read it.",
    "kennismaking.nieuw": "New",
    "kennismaking.zonderNaam": "Name missing",
    "kennismaking.heeftNotitie": "Has a note",
    "kennismaking.overigeAntwoorden": "Other answers",
    "kennismaking.nietIngevuld": "Not answered",
    "kennismaking.notitie": "Note for your colleagues",
    "kennismaking.notitie.hint": "Called on Tuesday, will come by on Saturday…",
    "kennismaking.notitie.bewaar": "Save note",
    "kennismaking.sluiten": "Close",
    "advertentieDetailView.bekeken.label": "Viewed on the site",
    "advertentieDetailView.bekeken.uitleg":
      "Counted once per visitor, only when the page was actually on screen. Search engines and link previews are not counted.",
    "advertentieListView.stand.gereserveerd": "Reserved",
    "advertentieListView.actie.gereserveerd": "Mark as reserved",
    "advertentieListView.actie.beschikbaar": "Mark as available",
    "advertentieListView.actie.openen": "Open",
    "advertentieListView.filter.kanaal": "Channel",
    "advertentieListView.filter.vestiging": "Shelter",
    "advertentieListView.filter.alleVestigingen": "All shelters",
    "advertentieListView.filter.vestigingZoek": "Search shelter...",
    "advertentieListView.filter.vestigingGeen": "No shelter matches.",
    "advertentieListView.filter.vestigingGekozen": "%d shelters",
    "advertentieListView.filter.allesAan": "Select all",
    "advertentieListView.filter.allesUit": "Clear all",
    "advertentieListView.site": "Site",
    "advertentieListView.filter.clear": "Clear filters",
    "advertentieListView.beschikbaarheid.beschikbaar": "Available",
    "advertentieListView.beschikbaarheid.gereserveerd": "Reserved",
    "advertentieListView.beschikbaarheid.nogNiet": "Not yet available",
    "advertentieListView.verouderd.only": "Outdated only",
    "advertentieListView.verouderd.hide": "Up to date",
    "advertentieListView.results.found": "advertisements found",
    "advertentieListView.results.foundOne": "advertisement found",
    "advertentieListView.viewMode": "View",
    "advertentieListView.cardMode": "Cards",
    "advertentieListView.compactMode": "Compact",
    "advertentieListView.listMode": "List",
    "advertentieListView.sortLabel": "Sort by:",
    "advertentieListView.sort.gewijzigd": "Last modified",
    "advertentieListView.sort.reacties": "Responses first",
    "advertentieListView.sort.naam": "Name",
    "advertentieListView.card.noPhoto": "No photo",
    "advertentieListView.card.beschikbaarheid": "Available",
    "advertentieListView.card.gewijzigd": "Modified",
    "advertentieListView.search.placeholder": "Search by animal name",
    "advertentieListView.filter.status": "Status",
    "advertentieListView.filter.opSite": "On the site",
    "advertentieListView.column.opSite": "On the site",
    "advertentieListView.opSite.ja": "On the site",
    "advertentieListView.opSite.nee": "Not on the site",
    "advertentieListView.opSite.zetErop": "Put on this site",
    "advertentieListView.opSite.haalEraf": "Take off this site",
    "advertentieListView.opSite.bezig": "Working…",
    "advertentieListView.opSite.mislukt": "This animal could not be put on the site.",
    "advertentieListView.opSite.teDoen": "Still needs an advertisement",
    "advertentieListView.opSite.dierWeg": "Left the shelter on %s — should no longer be on the site",
    "advertentieListView.status.geen": "No advertisement yet",
    "advertentieListView.filter.all": "All",
    "advertentieListView.column.foto": "Photo",
    "advertentieListView.column.dier": "Animal",
    "advertentieListView.column.soort": "Species",
    "advertentieListView.column.status": "Status",
    "advertentieListView.column.beschikbaarheid": "Availability",
    "advertentieListView.column.verouderd": "Outdated",
    "advertentieListView.column.gewijzigd": "Last modified",
    "advertentieListView.refresh": "Refresh",
    "advertentieListView.empty": "No advertisements found.",
    "advertentieListView.loadFailed": "Could not load the advertisements.",
    "advertentieListView.verouderd.yes": "Outdated",
    "advertentieListView.verouderd.no": "—",
    "advertentieListView.pagination.range": "%d–%d of %d",
    "advertentieListView.pagination.page": "Page %d of %d",
    "advertentieListView.pagination.previous": "Previous",
    "advertentieListView.pagination.next": "Next",
    "advertentieStatus.CONCEPT": "Draft",
    "advertentieStatus.KLAAR_VOOR_CONTROLE": "Ready for review",
    "advertentieStatus.GEPUBLICEERD": "Published",
    "advertentieStatus.GEPLAATST": "Placed",
    "advertentieStatus.GEPAUZEERD": "Paused",
    "advertentieStatus.VERLOPEN": "Expired",
    "advertentieKanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieKanaal.DIERMATCH": "DierMatch",
    "advertentieKanaal.BEIDE": "Both",
    "advertentieDetailView.back": "Back to advertisements",
    "advertentieDetailView.edit": "Edit",
    "advertentieDetailView.save": "Save",
    "advertentieDetailView.preview.section": "Live preview",
    "advertentieDetailView.preview.title": "TITLE",
    "advertentieDetailView.preview.cta": "I'd like to meet %s",
    "advertentieDetailView.preview.device.desktop": "Desktop preview",
    "advertentieDetailView.preview.device.mobile": "Mobile preview",
    "advertentieDetailView.preview.device.instagram": "Instagram post",
    "advertentieDetailView.ai.panel.title": "AI assistant",
    "advertentieDetailView.ai.panel.subtitle": "Smart help for a strong, safe, publish-ready ad.",
    "advertentieDetailView.ai.card.concept.title": "Draft copy",
    "advertentieDetailView.ai.card.concept.desc": "Generate a proposal with AI.",
    "advertentieDetailView.ai.card.warmer.title": "Rewrite warmer",
    "advertentieDetailView.ai.card.warmer.desc": "Make the text friendlier and warmer.",
    "advertentieDetailView.ai.card.korter.title": "Make shorter",
    "advertentieDetailView.ai.card.korter.desc": "Summarize into a shorter text.",
    "advertentieDetailView.ai.card.social.title": "Make social posts",
    "advertentieDetailView.ai.card.social.desc": "Generate posts for Facebook, Instagram and WhatsApp.",
    "advertentieDetailView.ai.card.foto.title": "Photo help",
    "advertentieDetailView.ai.card.foto.desc": "Pick the main photo, order and alt text.",
    "advertentieDetailView.cancel": "Cancel",
    "advertentieDetailView.markeerKlaar": "Mark ready for review",
    "advertentieDetailView.ai.label": "AI help:",
    "advertentieDetailView.ai.concept": "Draft concept",
    "advertentieDetailView.ai.verbeter": "Improve “About this animal”",
    "advertentieDetailView.ai.altTekst": "AI alt-text",
    "advertentieDetailView.extraFotos.opslaan": "Save photos",
    "advertentieDetailView.extraFotos.geenMedia": "No media available for this animal.",
    "advertentieDetailView.section.social": "Social media",
    "advertentieDetailView.historie": "History",
    "advertentieWizard.titel": "Draft the advert for %s",
    "advertentieWizard.stapVan": "Step %s of %s",
    "advertentieWizard.vorige": "Back",
    "advertentieWizard.volgende": "Next",
    "advertentieWizard.schrijf": "Write the text",
    "advertentieWizard.schrijft": "Writing…",
    "advertentieWizard.stap1.titel": "Style",
    "advertentieWizard.stap1.uitleg": "How the text reads. On ikzoekbaas.nl both voices occur: the shelter telling the story, or the animal telling it in the first person.",
    "advertentieWizard.stap2.titel": "Who is this animal",
    "advertentieWizard.stap2.uitleg": "Keywords are enough — the AI turns them into sentences. Leave a field empty and it stays out of the text.",
    "advertentieWizard.stap3.titel": "The home we're looking for",
    "advertentieWizard.stap3.uitleg": "What kind of household suits, and what it asks of the new owner.",
    "advertentieWizard.stap4.titel": "Honest and closing",
    "advertentieWizard.stap4.uitleg": "Adverts there name what is difficult — that saves everyone a failed placement.",
    "advertentieWizard.perspectief": "Who is telling the story?",
    "advertentieWizard.perspectief.asiel": "The shelter",
    "advertentieWizard.perspectief.asiel.uitleg": "\"Ygor came to us as a puppy…\"",
    "advertentieWizard.perspectief.dier": "The animal",
    "advertentieWizard.perspectief.dier.uitleg": "\"Hi everyone, I'm Beer!\"",
    "advertentieWizard.toon": "Tone",
    "advertentieWizard.toon.warm": "Warm and personal",
    "advertentieWizard.toon.zakelijk": "Calm and factual",
    "advertentieWizard.lengte": "Length",
    "advertentieWizard.lengte.kort": "Short",
    "advertentieWizard.lengte.gemiddeld": "Average",
    "advertentieWizard.lengte.uitgebreid": "Long",
    "advertentieWizard.emoji": "An emoji here and there is fine",
    "advertentieWizard.herkomst": "How did they come to the shelter?",
    "advertentieWizard.herkomst.hint": "e.g. stray, given up by the owner, returned after a placement, born here",
    "advertentieWizard.achtergrond": "What do you want to say about their past?",
    "advertentieWizard.achtergrond.hint": "e.g. two previous placements did not work out, lived in a kennel outdoors, unknown",
    "advertentieWizard.karakter": "What is their character?",
    "advertentieWizard.karakter.hint": "e.g. affectionate, plenty of energy, cheeky, insecure with strangers",
    "advertentieWizard.blijVan": "What makes them happy?",
    "advertentieWizard.blijVan.hint": "e.g. long walks, a ball, a lap, a snack, training",
    "advertentieWizard.thuis": "What home are you looking for?",
    "advertentieWizard.thuis.hint": "e.g. quiet household, garden required, no flat, children from 12, active family",
    "advertentieWizard.vraagtVan": "What does that ask of the new owner?",
    "advertentieWizard.vraagtVan.hint": "e.g. patience and consistency, experience with herders, time to keep training",
    "advertentieWizard.samenMet": "Placed together with another animal?",
    "advertentieWizard.samenMet.hint": "e.g. with sister Shurly, alone, would like a canine housemate",
    "advertentieWizard.bijzonderheden": "What must someone know beforehand?",
    "advertentieWizard.bijzonderheden.hint": "e.g. heart murmur with daily medication, allergy, chases cats, not house-trained yet",
    "advertentieWizard.contact": "How does someone get in touch?",
    "advertentieWizard.contact.hint": "e.g. email first for an appointment, phone during opening hours, no drop-ins",
    "advertentieWizard.slot": "The text is saved straight into the advert; you can edit everything afterwards.",
    "advertentieWizard.overschrijft": "There is already an advert text. Writing a new one replaces it.",
    "advertentieDetailView.foto.toevoegen": "Add photos",
    "advertentieDetailView.foto.uploadt": "Uploading…",
    "advertentieDetailView.foto.uploadHint": "Take a photo or pick files; they are stored with the animal.",
    "advertentieDetailView.foto.uploadFout": "Uploading failed. Please try again.",
    "advertentieDetailView.notice.onvolledigLeeg": "Not ready yet — see what still needs doing.",
    "advertentieDetailView.punten.titel": "What still needs doing",
    "advertentieDetailView.punt.STATUS": "Mark ready",
    "advertentieDetailView.punt.BLOKKADE": "Dossier blockade",
    "advertentieDetailView.punt.VELDEN": "Fill in",
    "advertentieDetailView.punt.PERSOONSGEGEVENS": "Remove from the text",
    "advertentieDetailView.punt.KENMERKEN": "Questions",
    "advertentieDetailView.punt.PRIVACY": "Privacy check",
    "advertentieDetailView.punt.GOEDKEURING": "Approval",
    "advertentieDetailView.punt.GEEN_ADVERTENTIE": "No advert",
    "advertentieDetailView.punt.OVERIG": "Open",
    "advertentieDetailView.punt.opnieuw": "Check again",
    "advertentieDetailView.check.compleet": "Complete",
    "advertentieDetailView.check.open": "%s open",
    "advertentieDetailView.check.privacySchoon": "Privacy clean",
    "advertentieDetailView.check.privacyLet": "Privacy: %s to check",
    "advertentieDetailView.blok.opnieuw": "Rewrite",
    "advertentieDetailView.blok.verbeter": "Improve",
    "advertentieDetailView.kenmerkenInvullen": "Fill in questions",
    "advertentieDetailView.kenmerken.uitleg": "These are the questions ikzoekbaas.nl asks. What you answer here appears in the ad; what you leave open shows as Unknown.",
    "advertentieDetailView.social.kopieer": "Copy",
    "advertentieDetailView.social.facebook": "Facebook",
    "advertentieDetailView.social.instagram": "Instagram",
    "advertentieDetailView.social.whatsapp": "WhatsApp",
    "advertentieDetailView.social.nieuwsbrief": "Newsletter",
    "advertentieDetailView.ai.unavailable": "AI is not configured — fill the text in manually.",
    "advertentieDetailView.notice.aiApplied": "AI proposal applied — review and save.",
    "advertentieDetailView.notice.aiFailed": "The AI request failed or is unavailable.",
    "advertentieDetailView.notice.aiPrivacyClean": "Privacy check: no warnings.",
    "advertentieDetailView.notice.aiPrivacyWarn": "Privacy check — possible personal data:",
    "advertentieDetailView.goedkeuren": "Approve",
    "advertentieDetailView.publiceer": "Publish",
    "advertentieDetailView.pauzeer": "Pause",
    "advertentieDetailView.hervat": "Resume",
    "advertentieDetailView.markeerVerlopen": "Mark expired",
    "advertentieDetailView.opnieuwVersturen": "Send again",
    "advertentieDetailView.opnieuwVersturenUitleg": "Sends this advertisement to the platform again, unchanged \u2014 for when the settings changed but the advertisement did not.",
    "advertentieDetailView.notice.opnieuwVerstuurd": "Sent to the platform again.",
    // Platformwachtrij: what did not reach DierMatch stays queued and is retried; a rejection is shown as such.
    "advertentieDetailView.notice.platformInWachtrij": "The platform could not be reached. The advertisement is queued and will be sent automatically.",
    "advertentieDetailView.notice.platformAfgewezen": "The platform rejected the advertisement:",
    "advertentieDetailView.wachtrij.wachtend": "Not on the platform yet — queued.",
    "advertentieDetailView.wachtrij.afgewezen": "The platform rejected this advertisement.",
    "advertentieDetailView.wachtrij.volgendePoging": "Next attempt: %s (%s attempt(s) failed).",
    "advertentieDetailView.wachtrij.laatsteFout": "Last error:",
    "advertentieDetailView.wachtrij.nuProberen": "Try again now",
    "advertentieDetailView.field.platformWachtrij": "Platform queue",
    "advertentieWachtrijToestand.WACHTEND": "Waiting for the platform",
    "advertentieWachtrijToestand.VERSTUURD": "Delivered",
    "advertentieWachtrijToestand.AFGEWEZEN": "Rejected",
    "advertentieDetailView.heropen": "Reopen",
    "advertentieDetailView.section.publishGuard": "Publish checklist",
    "advertentieDetailView.publishGuard.ok": "Ready to publish.",
    "advertentieDetailView.notice.approved": "Approved.",
    "advertentieDetailView.notice.published": "Published.",
    "advertentieDetailView.notice.lifecycle": "Status updated.",
    "advertentieDetailView.notice.publishBlocked": "Cannot publish yet:",
    "advertentieDetailView.hoofdfoto": "Main photo",
    "advertentieDetailView.hoofdfoto.geen": "No main photo",
    "advertentieDetailView.hoofdfoto.geenOpties": "No photos available for this animal.",
    "advertentieDetailView.section.extraFotos": "Extra photos",
    "advertentieDetailView.notice.saved": "Saved.",
    "advertentieDetailView.notice.conflict": "Changed by someone else — refresh and try again.",
    "advertentieDetailView.notice.forbidden": "You don't have permission to edit advertisements.",
    "advertentieDetailView.notice.error": "Something went wrong.",
    "advertentieDetailView.notice.klaar": "Marked ready for review.",
    "advertentieDetailView.notice.onvolledig": "Not complete yet — missing:",
    "advertentieDetailView.loadFailed": "Could not load the advertisement.",
    "advertentieDetailView.verouderdBanner": "The dossier changed after publication — this advertisement may be outdated.",
    "advertentieDetailView.dierWegBanner": "This animal left the shelter on %s and should no longer be on the site. Switch off the sites below, or mark the advertisement as expired.",
    "advertentieDetailView.blokkadeBanner": "Publication is blocked.",
    "advertentieDetailView.section.teksten": "Texts",
    "advertentieDetailView.section.kenmerken": "Attributes",
    "advertentieDetailView.section.fotos": "Photos",
    "advertentieDetailView.section.publicatie": "Publication",
    "advertentieDetailView.section.afzender": "Sender (shelter)",
    "advertentieDetailView.bewerk.knop": "Edit",
    "advertentieDetailView.bewerk.tags": "Edit name and tags",
    "advertentieDetailView.bewerk.fotos": "Edit photos",
    "advertentieDetailView.bewerk.kenmerken": "Fill in the questions",
    "advertentieDetailView.bewerk.afzender": "Edit sender details",
    "advertentieDetailView.bewerk.leeg": "Not filled in yet",
    "advertentieDetailView.field.afzenderNaam": "Name",
    "advertentieDetailView.field.afzenderTelefoon": "Phone",
    "advertentieDetailView.field.afzenderEmail": "E-mail",
    "advertentieDetailView.field.afzenderUrl": "Website",
    "advertentieDetailView.field.afzenderHint": "Shown on the public listing under the animal's location.",
    "advertentieDetailView.section.log": "Activity log",
    "advertentieDetailView.field.status": "Status",
    "advertentieDetailView.field.kanaal": "Channel",
    "advertentieDetailView.field.soort": "Species",
    "advertentieDetailView.field.ras": "Breed",
    "advertentieDetailView.field.geslacht": "Sex",
    "advertentieDetailView.field.leeftijd": "Age",
    "advertentieDetailView.field.geboortedatum": "Date of birth",
    "advertentieDetailView.field.locatie": "Location",
    "advertentieDetailView.field.beschikbaarheid": "Availability",
    "advertentieDetailView.section.plaatsing": "On the site",
    "advertentieDetailView.buitenbeentje.label": "Underdog",
    "advertentieDetailView.buitenbeentje.auto": "Automatic",
    "advertentieDetailView.buitenbeentje.wel": "Show",
    "advertentieDetailView.buitenbeentje.niet": "Do not show",
    "advertentieDetailView.buitenbeentje.uitleg.auto":
      "The site decides for itself, based on whether this animal needs special care.",
    "advertentieDetailView.buitenbeentje.uitleg.wel":
      "This animal appears in \"The underdogs\" on the ikzoekbaas home page.",
    "advertentieDetailView.buitenbeentje.uitleg.niet":
      "This animal stays out of \"The underdogs\", even if it needs special care.",
    "advertentieDetailView.ai.vragen": "Let AI answer the questions",
    "advertentieDetailView.ai.vragenBezig": "Reading the file…",
    "advertentieDetailView.ai.vragenUitleg": "Only from what the file says. Nothing is saved until you press Save.",
    "advertentieDetailView.ai.bron": "from the file: %s",
    "advertentieDetailView.notice.aiGeenVoorstellen": "The file says nothing about these questions.",
    "advertentieDetailView.field.succesverhaal": "Success story",
    "advertentieDetailView.field.succesverhaalHint":
      "How the placement went. This is the only thing that stays on the site once the animal is gone: it goes into \"The success stories\" on the home page. About the animal, never about the new owner.",
    "advertentieDetailView.field.altTekst": "Image alt text",
    "advertentieDetailView.field.tags": "Tags (DierMatch)",
    "advertentieDetailView.field.tagsPlaceholder": "Friendly, Active, Can be alone",
    "advertentieDetailView.field.tagsHint": "Short labels, comma-separated \u2014 at most 10, each up to 40 characters. These are the chips on DierMatch.nl.",
    "advertentieDetailView.field.publicatieUrl": "Publication URL",
    "advertentieDetailView.field.externeId": "External ID",
    "advertentieDetailView.field.publicatiedatum": "Published on",
    "advertentieDetailView.field.laatsteSync": "Last sync",
    "advertentieDetailView.field.platformStatus": "Platform status",
    "advertentieDetailView.field.publicatieKanalen": "Channels",
    "advertentieDetailView.field.goedgekeurdDoor": "Approved by",
    "advertentieDetailView.field.foutmelding": "Error",
    "advertentieDetailView.field.naam": "Name",
    "advertentieDetailView.field.telefoon": "Phone",
    "advertentieDetailView.field.email": "Email",
    "advertentieDetailView.field.website": "Website",
    "advertentieDetailView.tekst.overDitDier": "About this animal",
    "advertentieDetailView.tekst.pastBij": "Suited for",
    "advertentieDetailView.tekst.belangrijk": "Important to know",
    "advertentieDetailView.kenmerk.publiceerbaar": "Publishable",
    "advertentieDetailView.empty.kenmerken": "No attributes.",
    "advertentieDetailView.empty.fotos": "No extra photos selected.",
    "advertentieDetailView.empty.log": "No activity yet.",
    "advertentieDetailView.log.column.tijd": "Time",
    "advertentieDetailView.log.column.actor": "By",
    "advertentieDetailView.log.column.actie": "Action",
    "advertentieDetailView.log.column.detail": "Detail",
    "advertentieKenmerk.KAN_BIJ_KINDEREN": "Can be with children",
    "advertentieKenmerk.KAN_BIJ_HONDEN": "Can be with dogs",
    "advertentieKenmerk.KAN_BIJ_KATTEN": "Can be with cats",
    "advertentieKenmerk.ZINDELIJK": "Housetrained",
    "advertentieDetailView.kenmerk.geenAntwoord": "— not filled in —",
    "advertentieDetailView.kenmerk.toelichting": "Note (optional)",
    "advertentieKenmerk.MOET_BIJ_SOORTGENOTEN": "Needs company of its own kind",
    "advertentieKenmerk.GECASTREERD_GESTERILISEERD": "Neutered / spayed",
    "advertentieKenmerk.KAN_ALLEEN_THUISBLIJVEN": "Can stay home alone",
    "advertentieKenmerk.KAN_MEE_IN_DE_AUTO": "Can travel by car",
    "advertentieKenmerk.BASIS_COMMANDOS": "Knows basic commands",
    "advertentieKenmerk.WAAKSHEID": "Watchfulness",
    "advertentieKenmerk.SCHOFTHOOGTE": "Shoulder height",
    "advertentieKenmerk.KAN_LOSLOPEN": "Can be off the leash",
    "advertentieKenmerk.BESCHIKBAARHEID": "Availability",
    "advertentieKenmerk.AAN_DE_LIJN": "On leash",
    "advertentieKenmerk.VACHTVERZORGING": "Coat care",
    "advertentieKenmerk.SPECIALE_ZORG": "Special care",
    "advertentieBlok.intro": "Intro",
    "advertentieBlok.overDitDier": "About this animal",
    "advertentieBlok.pastBij": "Suited for",
    "advertentieBlok.belangrijkOmTeWeten": "Important to know",
    "advertentieLogActor.AI": "AI",
    "advertentieLogActor.MEDEWERKER": "Staff",
    "advertentieLogActor.SYSTEEM": "System",
    "kennelplanning.title": "Planning",
    "kennelplanning.toolbar.refresh": "Refresh",
    "kennelplanning.toolbar.stickers": "Print kennel stickers",
    "kennelplanning.toolbar.stickersUitleg":
      "Prints a sheet of QR stickers, one per kennel. Scanning one in the animal-carers app opens that kennel straight away.",
    "kennelplanning.viewMode.floorplan": "Floor plan",
    "kennelplanning.viewMode.timeline": "Timeline",
    "kennelplanning.viewMode.list": "List view",
    "kennelplanning.viewMode.soon": "Coming soon",
    "kennelplanning.species.honden": "Dogs",
    "kennelplanning.species.katten": "Cats",
    "kennelplanning.species.overig": "Other",
    "kennelplanning.dateMode.dateLabel": "DATE",
    "kennelplanning.dateMode.periodLabel": "PERIOD",
    "kennelplanning.dateMode.from": "From",
    "kennelplanning.dateMode.to": "To",
    "kennelplanning.date.today": "Today",
    "kennelplanning.timeline.invalidRange": "Invalid range.",
    "kennelplanning.timeline.timeTravel": "Time travel",
    "kennelplanning.timeline.empty": "No stays in this period.",
    "kennelplanning.trace.banner.prefix": "Contact trace:",
    "kennelplanning.trace.banner.sameKennel": "same kennel:",
    "kennelplanning.trace.banner.neighbour": "neighbour kennel:",
    "kennelplanning.trace.banner.overlapDays": "overlap days",
    "kennelplanning.trace.banner.noContacts": "no contact animals found",
    "kennelplanning.trace.banner.close": "Close",
    "kennelplanning.trace.bar.source": "SOURCE",
    "kennelplanning.historyDrawer.title": "Animal overview",
    "kennelplanning.historyDrawer.aandachtspunten": "Points of attention",
    "kennelplanning.historyDrawer.medisch": "Medical",
    "kennelplanning.historyDrawer.bijzonderheden": "Notes",
    "kennelplanning.historyDrawer.geenAandachtspunten": "No points of attention",
    "kennelplanning.historyDrawer.verblijfshistorie": "Stay history",
    "kennelplanning.historyDrawer.geenHistorie": "No stay history",
    "kennelplanning.historyDrawer.heden": "present",
    "kennelplanning.historyDrawer.door": "by %s",
    "kennelplanning.historyDrawer.besmettingsonderzoek": "Contact trace",
    "kennelplanning.historyDrawer.besmettingsSub": "Show contacts of %s",
    "kennelplanning.historyDrawer.openDossier": "Open animal record",
    "kennelplanning.historyDrawer.contactonderzoek": "Contact investigation",
    "kennelplanning.historyDrawer.contactenTonen": "Show contacts",
    "kennelplanning.historyDrawer.contactenVerbergen": "Hide contacts",
    "kennelplanning.historyDrawer.geenContacten": "No contact animals found",
    "kennelplanning.historyDrawer.zelfdeKennel": "SAME KENNEL",
    "kennelplanning.historyDrawer.buur": "NEIGHBOUR",
    "kennelplanning.historyDrawer.overlap": "%d days overlap",
    "kennelplanning.historyDrawer.gewicht": "Weight",
    "kennelplanning.historyDrawer.enting": "Vaccination",
    "kennelplanning.historyDrawer.voeding": "Diet",
    "kennelplanning.historyDrawer.recenteNotities": "Recent notes",
    "kennelplanning.historyDrawer.geenNotities": "No notes",
    "kennelplanning.empty.noVestiging": "No branch selected.",
    "kennelplanning.empty.noGroups": "No rooms set up for this branch.",
    "kennelplanning.empty.moduleDisabled": "The kennel-planning module is disabled for this organisation.",
    "kennelplanning.loadFailed": "Could not load the planning.",
    "kennelplanning.tile.empty": "Empty",
    "kennelplanning.tile.daysPrefix": "day",
    "kennelplanning.pending.title": "Animals to place",
    "kennelplanning.pending.dropHint": "Drag an animal out of a kennel to release it",
    "kennelplanning.pending.aiTip": "AI tip",
    "kennelplanning.verplaats.oppakken": "Move",
    "kennelplanning.verplaats.kiesHok": "Tap a kennel for %s",
    "kennelplanning.verplaats.kiesHokOfLos": "Tap a kennel for %s — or the waiting strip to take it out of its kennel",
    "kennelplanning.capacity.title": "Capacity",
    "kennelplanning.capacity.liveLabel": "TODAY · LIVE",
    "kennelplanning.capacity.addRoom": "New room",
    "kennelplanning.capacity.projection.title": "OCCUPANCY FORECAST",
    "kennelplanning.capacity.projection.none":
      "No forecast: too few intake/release mutations (min. 5 in window).",
    "kennelplanning.capacity.projection.full": "Shelter is full",
    "kennelplanning.capacity.projection.days": "Full in %d days",
    "kennelplanning.capacity.projection.basis":
      "Based on 28d: %d intake / %d release (%s net) · trend %s",
    "kennelplanning.capacity.projection.trend.STABIEL": "stable",
    "kennelplanning.capacity.projection.trend.STIJGEND": "rising",
    "kennelplanning.capacity.projection.trend.DALEND": "falling",
    "kennelplanning.suggestion.banner": "AI tip for %s: kennel %s in %s (%d pts)",
    "kennelplanning.suggestion.badge": "+ AI TIP",
    "kennelplanning.suggestion.clear": "Clear suggestions",
    "kennelplanning.suggestion.none": "No free kennel found for this animal.",
    "kennelplanning.rightPanel.collapse": "Collapse capacity panel",
    "kennelplanning.rightPanel.expand": "Expand capacity panel",
    "kennelplanning.roomTypes.title": "Room types",
    "kennelplanning.roomTypes.subtitle": "CONFIGURATION",
    "kennelplanning.roomTypes.addNew": "New type",
    "kennelplanning.list.kamer": "Room",
    "kennelplanning.list.kennel": "Kennel",
    "kennelplanning.list.naam": "Name",
    "kennelplanning.list.geslacht": "Sex",
    "kennelplanning.list.ras": "Breed",
    "kennelplanning.list.dagen": "Days",
    "kennelplanning.list.opname": "Intake date",
    "kennelplanning.list.empty": "(empty)",
    "kennelplanning.ruimtetype.short.STANDARD": "STANDARD",
    "kennelplanning.ruimtetype.short.QUARANTINE": "QUARANTINE",
    "kennelplanning.ruimtetype.short.ISOLATION": "ISOLATION",
    "kennelplanning.ruimtetype.short.PUPPY": "PUPPY",
    "kennelplanning.ruimtetype.short.KITTEN": "KITTEN",
    "kennelplanning.ruimtetype.short.OTHER": "OTHER",
    "kennelplanning.ruimtetype.sub.STANDARD": "Max 1 animal · Standard care",
    "kennelplanning.ruimtetype.sub.QUARANTINE": "On arrival · Min. 10 days",
    "kennelplanning.ruimtetype.sub.ISOLATION": "When ill · Separate entrance",
    "kennelplanning.ruimtetype.sub.PUPPY": "Young animals · Play zone",
    "kennelplanning.ruimtetype.sub.KITTEN": "Young cats · Small",
    "kennelplanning.ruimtetype.sub.OTHER": "Other rooms",
    "kennelplanning.list.velden": "Fields",
    "kennelplanning.fieldSettings.open": "Field settings",
    "kennelplanning.fieldSettings.title": "Field settings",
    "kennelplanning.fieldSettings.subtitle": "Choose which fields show on the planning",
    "kennelplanning.fieldSettings.reset": "Default",
    "kennelplanning.fieldSettings.group.identiteit": "Identity",
    "kennelplanning.fieldSettings.group.status": "Status",
    "kennelplanning.fieldSettings.group.verblijf": "Stay",
    "kennelplanning.fieldSettings.group.medisch": "Medical",
    "kennelplanning.fieldSettings.group.locatie": "Location",
    "kennelplanning.fieldSettings.unit.days": "d",
    "kennelplanning.fieldSettings.unit.years": "y",
    "kennelplanning.fieldSettings.unit.months": "m",
    "kennelplanning.fieldSettings.unit.kg": "kg",
    "kennelplanning.fieldSettings.value.castrated": "Neutered",
    "kennelplanning.fieldSettings.value.geen": "None",
    "kennelplanning.fieldSettings.value.plaatsbaar": "Adoptable",
    "kennelplanning.fieldSettings.value.zindelijk": "House-trained",
    "kennelplanning.fieldSettings.value.drinktFles": "Bottle-fed",
    "kennelplanning.fieldSettings.field.NAME": "Name",
    "kennelplanning.fieldSettings.field.PHOTO": "Photo",
    "kennelplanning.fieldSettings.field.ID": "Chip/pass number",
    "kennelplanning.fieldSettings.field.PASPOORT": "Passport number",
    "kennelplanning.fieldSettings.field.STAMBOOM": "Pedigree number",
    "kennelplanning.fieldSettings.field.TATOEAGE": "Tattoo",
    "kennelplanning.fieldSettings.field.SPECIES": "Species",
    "kennelplanning.fieldSettings.field.RAS": "Breed",
    "kennelplanning.fieldSettings.field.KRUISING": "Cross-breed",
    "kennelplanning.fieldSettings.field.VACHT": "Coat",
    "kennelplanning.fieldSettings.field.KLEUR": "Colour",
    "kennelplanning.fieldSettings.field.KENMERKEN": "Markings",
    "kennelplanning.fieldSettings.field.BIJZONDERHEDEN": "Notes",
    "kennelplanning.fieldSettings.field.GENDER": "Sex",
    "kennelplanning.fieldSettings.field.CASTRATED": "Neutered",
    "kennelplanning.fieldSettings.field.LEEFTIJD": "Age",
    "kennelplanning.fieldSettings.field.GEBOORTE": "Date of birth",
    "kennelplanning.fieldSettings.field.PLAATSBAAR": "Adoptable",
    "kennelplanning.fieldSettings.field.ZINDELIJK": "House-trained",
    "kennelplanning.fieldSettings.field.DRINKT_FLES": "Bottle-fed",
    "kennelplanning.fieldSettings.field.DAYS": "Days in shelter",
    "kennelplanning.fieldSettings.field.OPNAME": "Intake date",
    "kennelplanning.fieldSettings.field.OPNAME_SOORT": "Intake type",
    "kennelplanning.fieldSettings.field.VERTREK_DATUM": "Departure date",
    "kennelplanning.fieldSettings.field.VERBLIJF_NUMMER": "Stay number",
    "kennelplanning.fieldSettings.field.HALSBAND": "Collar number",
    "kennelplanning.fieldSettings.field.GERESERVEERD_TOT": "Reserved until",
    "kennelplanning.fieldSettings.field.OPMERKING_IN": "Intake note",
    "kennelplanning.fieldSettings.field.FLAGS": "Flags (M/!/D)",
    "kennelplanning.fieldSettings.field.GEWICHT": "Weight",
    "kennelplanning.fieldSettings.field.ENTING": "Vaccination",
    "kennelplanning.fieldSettings.field.KENNEL_NUM": "Kennel number",
    "factuurListView.title": "Invoices",
    "factuurListView.search.placeholder": "Search by number or customer…",
    "factuurListView.filter.from": "From",
    "factuurListView.filter.to": "To",
    "factuurListView.refresh": "Refresh",
    "factuurListView.empty": "No invoices.",
    "factuurListView.loadFailed": "Could not load invoices.",
    "factuurListView.column.nummer": "No.",
    "factuurListView.column.datum": "Invoice date",
    "factuurListView.column.status": "Status",
    "factuurListView.column.klant": "Customer",
    "factuurListView.column.totaal": "Total",
    "factuurListView.column.openstaand": "Outstanding",
    "factuurListView.column.type": "Type",
    "factuurListView.status.CONCEPT": "Draft",
    "factuurListView.status.BETAALD": "Paid",
    "factuurListView.status.OPENSTAAND": "Outstanding",
    "factuurListView.status.VERVALLEN": "Overdue",
    "factuurListView.type.C": "Credit note",
    "factuurListView.type.A": "Cancelled",
    "factuurListView.type.F": "Invoice",
    "factuurListView.pagination.range": "%d–%d of %d",
    "factuurListView.pagination.page": "Page %d of %d",
    "factuurListView.pagination.previous": "Previous",
    "factuurListView.pagination.next": "Next",
    "factuurDetailView.heading": "Invoice",
    "factuurDetailView.loadFailed": "Could not load the invoice.",
    "factuurDetailView.status.CONCEPT": "Draft",
    "factuurDetailView.status.BETAALD": "Paid",
    "factuurDetailView.status.OPENSTAAND": "Outstanding",
    "factuurDetailView.status.VERVALLEN": "Overdue",
    "factuurDetailView.tile.klantgegevens": "Customer details",
    "factuurDetailView.tile.factuurinfo": "Invoice information",
    "factuurDetailView.tile.samenvatting": "Payment & Summary",
    "factuurDetailView.tile.tijdlijn": "Timeline / History",
    "factuurDetailView.tile.factuurregels": "Invoice lines",
    "factuurDetailView.tile.betalingen": "Payments overview",
    "factuurDetailView.tile.bijlagen": "Attachments & Notes",
    "factuurDetailView.tile.notitielogboek": "Notes log",
    "factuurDetailView.tile.snelleActies": "Quick actions",
    "factuurDetailView.tile.betaalstatus": "Payment status",
    "factuurDetailView.info.nummer": "Number",
    "factuurDetailView.info.datum": "Invoice date",
    "factuurDetailView.info.verval": "Due date",
    "factuurDetailView.info.status": "Status",
    "factuurDetailView.info.betaalmethode": "Payment method",
    "factuurDetailView.info.referentie": "External reference",
    "factuurDetailView.klant.naam": "Name",
    "factuurDetailView.klant.adres": "Address",
    "factuurDetailView.klant.telefoon": "Phone",
    "factuurDetailView.klant.email": "E-mail",
    "factuurDetailView.klant.debiteur": "Debtor number",
    "factuurDetailView.klant.geen": "No customer linked to this invoice.",
    "factuurDetailView.klant.soort": "KIND OF INVOICE",
    "factuurDetailView.klant.losseVerkoop": "Counter sale",
    "factuurDetailView.klant.geenDebiteur": "No customer — settled at the counter.",
    "factuurDetailView.samenvatting.subtotaal": "Subtotal (excl. VAT)",
    "factuurDetailView.samenvatting.btw": "VAT",
    "factuurDetailView.samenvatting.korting": "Discount",
    "factuurDetailView.samenvatting.totaal": "Total",
    "factuurDetailView.samenvatting.betaald": "Paid",
    "factuurDetailView.samenvatting.openstaand": "Outstanding",
    "factuurDetailView.regels.col.omschrijving": "Description",
    "factuurDetailView.regels.col.aantal": "Qty",
    "factuurDetailView.regels.col.prijs": "Price",
    "factuurDetailView.regels.col.btw": "VAT",
    "factuurDetailView.regels.col.totaal": "Total",
    "factuurDetailView.regels.empty": "This invoice has no lines.",
    "factuurDetailView.betalingen.col.datum": "Date",
    "factuurDetailView.betalingen.col.methode": "Method",
    "factuurDetailView.betalingen.col.referentie": "Reference",
    "factuurDetailView.betalingen.col.bedrag": "Amount",
    "factuurDetailView.betalingen.geannuleerd": "cancelled",
    "factuurDetailView.betalingen.empty": "No payments recorded.",
    "factuurDetailView.betalingen.volledigBetaald": "This invoice is fully paid.",
    "factuurDetailView.tijdlijn.empty": "No events yet.",
    "factuurDetailView.bijlagen.geenNotitie": "No note on this invoice.",
    "factuurDetailView.notitielog.toevoegen": "Add note",
    "factuurDetailView.tijdlijn.door": "by %s",
    "factuurDetailView.notitielog.fout": "The note was not saved. Please try again.",
    "factuurDetailView.notitielog.notitie": "Note",
    "factuurDetailView.notitielog.geen": "No notes log for this invoice.",
    "factuurDetailView.notitielog.verwijder": "Delete note",
    "factuurDetailView.notitielog.verwijderBevestig": "Delete this note from the log?",
    "factuurDetailView.acties.betaling": "Register payment",
    "factuurDetailView.acties.herinnering": "Send reminder",
    "factuurDetailView.acties.crediteren": "Credit",
    "factuurDetailView.acties.dupliceren": "Duplicate",
    "factuurDetailView.acties.annuleren": "Cancel",
    "factuurDetailView.acties.binnenkort": "Available in a later phase",
    "factuurDetailView.betaalstatus.openstaand": "outstanding",
    "factuurDetailView.betaalstatus.totaalBetaald": "Total paid",
    "factuurDetailView.betaalstatus.openstaandLabel": "Outstanding",
    "factuurDetailView.betaalstatus.statusLabel": "Status",
    "factuurDetailView.regels.subtotaal": "Subtotal (excl. VAT)",
    "factuurDetailView.regels.totaal": "Total",
    "factuurDetailView.bijlagen.bijlagen": "Attachments",
    "factuurDetailView.bijlagen.geenBijlagen": "No attachments on this invoice yet.",
    "factuurDetailView.acties.regelToevoegen": "Add line",
    "factuurDetailView.acties.herinneringMax": "Both reminders already sent",
    "factuurDetailView.betaling.bedrag": "Amount",
    "factuurDetailView.betaling.datum": "Date",
    "factuurDetailView.betaling.wijze": "Payment method",
    "factuurDetailView.betaling.volledig": "Full balance",
    "factuurDetailView.betaling.restant": "Remaining after this payment",
    "factuurDetailView.betaling.mailen": "E-mail the invoice to %s",
    "factuurDetailView.betaling.mailenGeenAdres": "E-mail the invoice (the customer has no e-mail address on file)",
    "factuurDetailView.regel.naam": "Description",
    "factuurDetailView.regel.aantal": "Quantity",
    "factuurDetailView.regel.prijs": "Unit price (incl. VAT)",
    "factuurDetailView.regel.btw": "VAT rate",
    "factuurDetailView.regels.verwijder": "Remove line",
    "factuurDetailView.regels.verwijderBevestig": "Remove this invoice line?",
    "factuurDetailView.betalingen.annuleer": "Cancel payment",
    "factuurDetailView.betalingen.afboeken": "Write off",
    "factuurDetailView.betalingen.annuleerBevestig": "Write off (cancel) this payment?",
    "factuurDetailView.bijlagen.notitie": "Note on the invoice",
    "factuurDetailView.bijlagen.notitieUitleg": "This text is printed on the invoice the customer receives. Internal remarks belong under Internal notes below.",
    "factuurDetailView.bijlagen.opDeFactuur": "On the invoice (visible to the customer)",
    "factuurDetailView.bijlagen.bewerken": "Edit note",
    "factuurDetailView.dialog.betaling.titel": "Register payment",
    "factuurDetailView.dialog.regel.titel": "Add invoice line",
    "factuurDetailView.dialog.notitie.titel": "Edit note",
    "factuurDetailView.confirm.herinnering": "Send a reminder for this invoice?",
    "factuurDetailView.confirm.ja": "Confirm",
    "factuurDetailView.notice.conflict": "Changed elsewhere — reloaded, please try again.",
    "factuurDetailView.notice.error": "Something went wrong. Please try again.",
    "factuurDetailView.notice.forbidden": "You are not allowed to perform this action.",
    "factuurDetailView.notice.credited": "Credit note #%s created.",
    "factuurDetailView.notice.duplicated": "Invoice duplicated (#%s).",
    "factuurDetailView.lifecycle.crediteren.titel": "Credit invoice",
    "factuurDetailView.lifecycle.crediteren.bevestig": "Create a credit note for this invoice?",
    "factuurDetailView.lifecycle.dupliceren.titel": "Duplicate invoice",
    "factuurDetailView.lifecycle.dupliceren.bevestig": "Create a copy of this invoice?",
    "factuurDetailView.lifecycle.annuleren.titel": "Cancel invoice",
    "factuurDetailView.lifecycle.annuleren.bevestig": "Cancel this invoice? The outstanding amount is set to zero.",
    "factuurDetailView.export.pdf": "PDF",
    "factuurDetailView.export.csv": "Payments (CSV)",
    "factuurDetailView.export.email": "Send by e-mail",
    "factuurDetailView.export.emailBevestig": "E-mail this invoice as a PDF to the customer?",
    "factuurDetailView.notice.emailSent": "The invoice has been sent to the customer.",
    "factuurDetailView.notice.emailNoEmail": "The customer has no e-mail address on file.",
    "factuurDetailView.notice.exportError": "The download could not be started. Please try again.",
    // Design layout (cards/factuur-detail.html): the document-style detail page.
    "factuurDetailView.subtitle": "Overview and details of this invoice.",
    "factuurDetailView.sectie.koppelingen": "Animal, stay and animal ambulance",
    "factuurDetailView.sectie.opmerkingen": "Remarks",
    "factuurDetailView.sectie.interneNotities": "Internal notes (not visible to the customer)",
    "factuurDetailView.koppeling.verblijf": "Stay",
    "factuurDetailView.koppeling.verblijfNr": "Stay %s",
    "factuurDetailView.koppeling.opname": "Admitted",
    "factuurDetailView.koppeling.vertrek": "Left",
    "factuurDetailView.koppeling.ritnummer": "Trip number",
    "factuurDetailView.koppeling.bekijkDier": "View animal",
    "factuurDetailView.koppeling.jaar": "%s years",
    "factuurDetailView.klant.bekijk": "View customer",
    "factuurDetailView.betaald.op": "Paid on",
    "factuurDetailView.betaald.via": "Paid by",
    "factuurDetailView.samenvatting.over": "on",
    "factuurDetailView.samenvatting.totaalbedrag": "Total amount",
    "factuurDetailView.betalingen.totaalBetaald": "Total paid",
    "factuurDetailView.regels.col.acties": "Actions",
    "factuurDetailView.regels.wijzig": "Edit line",
    "factuurDetailView.acties.meer": "More actions",
    "factuurDetailView.acties.historie": "History",
    "factuurDetailView.terugNaarOverzicht": "Back",
    "factuurDetailView.concept.openstaand": "%s unsaved change(s)",
    "factuurDetailView.concept.nietsOpenstaand": "Everything is saved",
    "factuurDetailView.concept.opslaanKnop": "Save invoice",
    "factuurDetailView.concept.annulerenKnop": "Discard changes",
    "factuurDetailView.concept.bezig": "Saving…",
    "factuurDetailView.concept.verlatenTitel": "You have unsaved changes",
    "factuurDetailView.concept.verlatenUitleg": "%s change(s) to this invoice have not been saved. Save them, discard them, or stay on this page.",
    "factuurDetailView.concept.blijven": "Stay here",
    "factuurDetailView.concept.weggooienEnWeg": "Discard and leave",
    "factuurDetailView.concept.opslaanEnBlijven": "Save",
    "factuurDetailView.concept.actieGeblokkeerd": "Save or cancel your changes first",
    "kennelplanning.dnd.placed": "Animal placed",
    "kennelplanning.dnd.moved": "Animal moved",
    "kennelplanning.dnd.released": "Animal released",
    "kennelplanning.dnd.failed": "Action failed",
    // kp-Epic 4: room + room-type management dialogs.
    "kennelplanning.capacity.editRoom": "Edit room",
    "kennelplanning.roomTypes.edit": "Edit room type",
    "kennelplanning.groepDialog.createTitle": "New room",
    "kennelplanning.groepDialog.editTitle": "Edit room",
    "kennelplanning.groepDialog.naam": "Name",
    "kennelplanning.groepDialog.diersoort": "Species",
    "kennelplanning.groepDialog.diersoortPlaceholder": "Select a species…",
    "kennelplanning.groepDialog.diersoortLocked": "Fixed after creation",
    "kennelplanning.groepDialog.ruimteType": "Room type",
    "kennelplanning.groepDialog.ruimteTypePlaceholder": "No type",
    "kennelplanning.groepDialog.positie": "Position",
    "kennelplanning.groepDialog.maxCapaciteit": "Max capacity",
    "kennelplanning.groepDialog.startNummer": "Start number",
    "kennelplanning.groepDialog.startNummerLocked": "Set at creation",
    "kennelplanning.groepDialog.aantalKennels": "Number of kennels",
    "kennelplanning.groepDialog.naamRequired": "Name is required.",
    "kennelplanning.groepDialog.diersoortRequired": "Species is required.",
    "kennelplanning.groepDialog.positieRequired": "Position is required.",
    "kennelplanning.groepDialog.startNummerRequired": "Start number is required.",
    "kennelplanning.groepDialog.aantalRequired": "Number of kennels is required and cannot be negative.",
    "kennelplanning.groepDialog.shrinkConfirm":
      "Fewer kennels than now: the highest-numbered kennels are removed and any occupants released. Continue?",
    "kennelplanning.groepDialog.shrinkConfirmAccept": "Yes, resize",
    "kennelplanning.groepDialog.deleteConfirm":
      "Delete this room? Its kennels are removed and any occupants released.",
    "kennelplanning.groepDialog.created": "Room created.",
    "kennelplanning.groepDialog.resizeResult": "%d added / %d removed / %d animal(s) released",
    "kennelplanning.groepDialog.deleted": "Room deleted · %d animal(s) released",
    "kennelplanning.groepDialog.conflict": "Room changed in the meantime; reload and try again.",
    "kennelplanning.groepDialog.invalid": "Please check the entered values.",
    "kennelplanning.groepDialog.error": "Action failed.",
    "kennelplanning.ruimteTypeDialog.createTitle": "New room type",
    "kennelplanning.ruimteTypeDialog.editTitle": "Edit room type",
    "kennelplanning.ruimteTypeDialog.naam": "Name",
    "kennelplanning.ruimteTypeDialog.beschrijving": "Description",
    "kennelplanning.ruimteTypeDialog.kleurLabel": "Colour",
    "kennelplanning.ruimteTypeDialog.maxCapaciteit": "Max capacity",
    "kennelplanning.ruimteTypeDialog.kleur.green": "Green",
    "kennelplanning.ruimteTypeDialog.kleur.red": "Red",
    "kennelplanning.ruimteTypeDialog.kleur.orange": "Orange",
    "kennelplanning.ruimteTypeDialog.kleur.blue": "Blue",
    "kennelplanning.ruimteTypeDialog.kleur.grey": "Grey",
    "kennelplanning.ruimteTypeDialog.naamRequired": "Name is required.",
    "kennelplanning.ruimteTypeDialog.deleteConfirm": "Delete this room type?",
    "kennelplanning.ruimteTypeDialog.created": "Room type created.",
    "kennelplanning.ruimteTypeDialog.updated": "Room type updated.",
    "kennelplanning.ruimteTypeDialog.deleted": "Room type deleted.",
    "btw.label": "VAT rate",
    "btw.kies": "Choose a VAT rate",
    "btw.verplicht": "VAT is required: choose a rate (0% is allowed, but it has to be chosen).",
    "btw.kolom": "VAT",
    "picker.btw.label": "VAT percentage",
    "picker.btw.help": "This product or tariff has no VAT yet. Choose the percentage for this line.",
    "picker.btw.verplicht": "Choose the VAT percentage for this line first.",
    // Klantportaal: klantverzoeken en de tegel op de klantkaart.
    "menu.klantverzoeken": "Customer requests",
    "relatieDetailView.tile.whatsapp": "WhatsApp",
    "menu.schermbouwer": "Screen builder",
    "schermbouwer.title": "AI screen builder",
    "schermbouwer.gesprek": "Conversation",
    "schermbouwer.beginUitleg": "Describe what you need, in your own words. You can add a picture as visual inspiration.",
    "schermbouwer.plaatshouder": "For example: show the animal's name, the medicine and the time, and warn me about overdue doses.",
    "schermbouwer.versturen": "Send",
    "schermbouwer.bezig": "Designing…",
    "schermbouwer.afbeelding": "Picture",
    "schermbouwer.weghalen": "Remove",
    "schermbouwer.afbeeldingUitleg": "A picture is used only as visual inspiration; no text or data is copied from it. Do not upload pictures containing personal data, or crop them first.",
    "schermbouwer.versies": "Versions",
    "schermbouwer.geenVersies": "No versions yet.",
    "schermbouwer.doorAi": "By the AI",
    "schermbouwer.metDeHand": "Edited by hand",
    "schermbouwer.terugzetten": "Restore",
    "schermbouwer.teruggezet": "Restored to version %s.",
    "schermbouwer.voorbeeld": "Preview",
    "schermbouwer.echteData": "My real data",
    "schermbouwer.status.CONCEPT": "Draft",
    "schermbouwer.status.GEWIJZIGD": "Draft changes",
    "schermbouwer.status.GEPUBLICEERD": "Published",
    "schermbouwer.nogGeenOntwerp": "No design yet. Ask for one on the left.",
    "schermbouwer.onderdelenInDeTegel": "Parts in this tile",
    "schermbouwer.naarLinks": "Move left",
    "schermbouwer.naarRechts": "Move right",
    "schermbouwer.verwijderen": "Remove",
    "schermbouwer.toevoegen": "Add a part",
    "schermbouwer.velden": "Fields",
    "schermbouwer.acties": "Buttons",
    "schermbouwer.catalogusUitleg": "Only what is listed here exists for this tile type. Missing something? Ask for it anyway — it will be passed on to Docasoft.",
    "schermbouwer.publiceren": "Publish",
    "schermbouwer.gepubliceerd": "Published. The tile can now be added to a dashboard.",
    "schermbouwer.fout.algemeen": "That did not work. Try describing it differently.",
    "schermbouwer.fout.nietOpgeslagen": "This change was not saved.",
    "schermbouwer.nieuweTegel": "New tile",
    "schermbouwer.nieuweTegelMaken": "Design a new tile",
    "schermbouwer.ingangUitleg": "Describe a tile in your own words and see the result straight away. You choose from what Docasoft already supports for this tile type.",
    "schermbouwer.naam": "Name",
    "schermbouwer.naamPlaatshouder": "Name of the tile",
    "schermbouwer.schermtype": "Kind of tile or screen",
    "schermbouwer.beginnen": "Start",
    "schermbouwer.geenCatalogus": "There is no tile type available to design for yet.",
    "schermbouwer.bestaandeTegels": "Tiles in this organisation",
    "schermbouwer.nogGeenTegels": "No tiles have been designed yet.",
    "schermbouwer.openen": "Open",
    "schermbouwer.terugNaarLijst": "Back to the list",
    "schermbouwer.bekijkAls": "View as",
    "schermbouwer.alsMijzelf": "Myself",
    "schermbouwer.zonder": "Someone without %s",
    "schermbouwer.logboek": "History",
    "schermbouwer.gebeurtenis.AANGEMAAKT": "Created",
    "schermbouwer.gebeurtenis.ONTWORPEN_MET_AI": "Designed with the AI",
    "schermbouwer.gebeurtenis.AANGEPAST": "Edited by hand",
    "schermbouwer.gebeurtenis.TERUGGEZET": "Restored an earlier version",
    "schermbouwer.gebeurtenis.GEPUBLICEERD": "Published",
    "schermbouwer.gebeurtenis.PUBLICATIE_AANGEVRAAGD": "Asked to share",
    "schermbouwer.gebeurtenis.PUBLICATIE_GOEDGEKEURD": "Sharing approved",
    "schermbouwer.gebeurtenis.PUBLICATIE_AFGEWEZEN": "Sharing declined",
    "schermbouwer.gebeurtenis.HERNOEMD": "Renamed",
    "schermbouwer.delenAanvragen": "Ask to share",
    "schermbouwer.delenAangevraagd": "Asked. An administrator decides whether this tile goes onto shared dashboards.",
    "schermbouwer.delenMislukt": "That request did not go through. Perhaps one is already open.",
    "schermbouwer.vergelijken": "Compare",
    "schermbouwer.verschilMet": "Version %s compared with %s:",
    "schermbouwer.erbij": "added: %s.",
    "schermbouwer.eraf": "removed: %s.",
    "schermbouwer.geenVerschil": "the same parts, in a different order or styling.",
    "schermbouwer.beheer": "Screen builder administration",
    "schermbouwer.beheerUitleg": "What the AI may use, what people are missing, and which tiles are waiting to be shared.",
    "schermbouwer.aiReady": "Available to the AI",
    "schermbouwer.openVerzoeken": "Waiting to be shared",
    "schermbouwer.geenVerzoeken": "Nothing waiting.",
    "schermbouwer.goedkeuren": "Approve",
    "schermbouwer.afwijzen": "Decline",
    "schermbouwer.gemisteMogelijkheden": "What people are missing",
    "schermbouwer.geenGemist": "Nothing has been asked for that does not exist yet.",
    "schermbouwer.aantalKeer": "%s×",
    "menu.schermbouwerBeheer": "Screen builder",
    "schermbouwer.beheerTitle": "Screen builder administration",
    "whatsapp.naar": "To",
    "whatsapp.plaatshouder": "Type your message…",
    "whatsapp.tekstLabel": "WhatsApp message",
    "whatsapp.versturen": "Send",
    "whatsapp.bezig": "Sending…",
    "whatsapp.verstuurd": "Sent.",
    "whatsapp.mislukt": "Sending failed.",
    "whatsapp.nietIngesteld": "WhatsApp is not set up in this environment.",
    "whatsapp.nietGekoppeld": "WhatsApp has not been linked for this branch yet.",
    "whatsapp.geenNummer": "This relation has no mobile number.",
    "whatsapp.gesprek": "WhatsApp conversation",
    "whatsapp.leegGesprek": "No messages with this number yet.",
    "whatsapp.zonderTekst": "(%s without text)",
    "whatsapp.emoji": "Insert emoji",
    "whatsapp.status.sent": "Sent",
    "whatsapp.status.delivered": "Delivered",
    "whatsapp.status.read": "Read",
    "whatsapp.status.failed": "Not delivered",
    "relatieDetailView.tile.klantportaal": "Customer portal",
    "klantverzoeken.groep.klanten": "Customers",
    "klantverzoeken.groep.dieren": "Animals",
    "klantverzoeken.groep.reserveringen": "Reservations",
    "klantverzoeken.groep.dagopvang": "Daycare",
    "klantverzoeken.groep.overig": "Other",
    "klantverzoeken.groepUitleg.klanten": "Registrations, changed details and added household members.",
    "klantverzoeken.groepUitleg.dieren": "New animals, changed animal details and uploaded documents.",
    "klantverzoeken.groepUitleg.reserveringen": "New reservations, waiting list, changes and cancellations.",
    "klantverzoeken.groepUitleg.dagopvang": "New daycare days, changes and cancellations.",
    "klantverzoeken.groepUitleg.overig": "Requests that do not belong to one of the other groups.",
    "klantverzoeken.tab.alles": "All open",
    "klantverzoeken.tab.nieuw": "New",
    "klantverzoeken.tab.wijzigingen": "Changes",
    "klantverzoeken.tab.gezinsleden": "Household members",
    "klantverzoeken.tab.documenten": "Documents",
    "klantverzoeken.tab.wachtlijst": "Waiting list",
    "klantverzoeken.tab.annuleringen": "Cancellations",
    "klantverzoeken.tab.afmeldingen": "Cancellations",
    "klantverzoeken.tab.afgerond": "Completed",
    "klantverzoeken.fase.nieuw": "New",
    "klantverzoeken.fase.bezig": "In progress",
    "klantverzoeken.fase.klant": "Waiting for customer",
    "klantverzoeken.fase.mislukt": "Failed",
    "klantverzoeken.fase.verwerkt": "Processed",
    "klantverzoeken.fase.afgewezen": "Rejected",
    "klantverzoeken.fase.vervallen": "Withdrawn/expired",
    "klantverzoeken.fase.totaal": "Total",
    "klantverzoeken.zoek": "Search customer, number or request…",
    "klantverzoeken.alle": "All",
    "klantverzoeken.filterTeLang": "New too long",
    "klantverzoeken.nieuweKlanten": "New customers",
    "klantverzoeken.resultaten": "%s request(s)",
    "klantverzoeken.sorteer.nieuwste": "Newest first",
    "klantverzoeken.sorteer.oudste": "Oldest first",
    "klantverzoeken.sorteer.klant": "Customer",
    "klantverzoeken.leegFilter": "No requests match these filters.",
    "klantverzoeken.kolom.wat": "Request",
    "klantverzoeken.bijIemand": "Handled by %s",
    "klantverzoeken.nieuwTeBeoordelen": "%s new request(s) awaiting approval",
    "klantverzoeken.leeggemaakt": "cleared",
    "klantverzoeken.meerVelden": "+ %s more",
    "klantverzoeken.veld.naam": "Name",
    "klantverzoeken.veld.email": "Email",
    "klantverzoeken.veld.telefoon": "Phone",
    "klantverzoeken.veld.mobiel": "Mobile",
    "klantverzoeken.veld.adres": "Address",
    "klantverzoeken.veld.dieren": "Animals",
    "klantverzoeken.veld.voeding": "Food",
    "klantverzoeken.veld.voedingInstructies": "Feeding instructions",
    "klantverzoeken.veld.opmerking": "Remark",
    "klantverzoeken.veld.bijzonderheden": "Particulars",
    "klantverzoeken.veld.medicatie": "Medication",
    "klantverzoeken.veld.verblijf": "Accommodation",
    "klantverzoeken.veld.aankomstTijd": "Arrival time",
    "klantverzoeken.veld.vertrekTijd": "Departure time",
    "klantverzoeken.veld.overigeWensen": "Other wishes",
    "klantverzoeken.veld.annuleringsverzekering": "Cancellation insurance",
    "klantverzoeken.veld.extras": "Extras",
    "klantverzoeken.veld.geslacht": "Sex",
    "klantverzoeken.veld.geboortedatum": "Date of birth",
    "klantverzoeken.veld.chipnummer": "Chip number",
    "klantverzoeken.veld.gewicht": "Weight",
    "klantverzoeken.veld.ras": "Breed",
    "klantverzoeken.veld.soort": "Species",
    "klantverzoeken.veld.kleur": "Colour",
    "klantverzoeken.veld.gecastreerd": "Neutered",
    "klantverzoeken.veld.samenMetGezin": "Together with household",
    "klantverzoeken.veld.relatie": "Relationship",
    "klantverzoeken.veld.reden": "Reason",
    "klantverzoeken.veld.toelichting": "Explanation",
    "klantverzoeken.titel": "Customer requests",
    "klantverzoeken.subtitel": "Everything customers request through the portal. Nothing changes until you approve it.",
    "klantverzoeken.subtitelTeLang": "%s request(s) have been new for more than a working day.",
    "klantverzoeken.filter": "Filter",
    "klantverzoeken.filter.open": "Open",
    "klantverzoeken.filter.registraties": "Registrations",
    "klantverzoeken.filter.mislukt": "Failed",
    "klantverzoeken.filter.afgerond": "Closed",
    "klantverzoeken.filter.alle": "All",
    "klantverzoeken.kolom.status": "Status",
    "klantverzoeken.kolom.nummer": "Number",
    "klantverzoeken.kolom.klant": "Customer",
    "klantverzoeken.kolom.type": "Type",
    "klantverzoeken.kolom.kanaal": "Via",
    "klantverzoeken.kolom.ingediend": "Submitted",
    "klantverzoeken.kolom.bij": "Handled by",
    "klantverzoeken.nieuweKlant": "new customer",
    "klantverzoeken.nieuweKlantUitleg": "Not linked to a customer yet: review the registration first.",
    "klantverzoeken.teLang": "New for more than a working day",
    "klantverzoeken.leeg": "No requests in this list.",
    "klantverzoeken.fout.laden": "The customer requests could not be loaded.",
    "klantverzoeken.fout.actie": "That did not work. Refresh the request and try again.",
    "klantverzoeken.kanaal.PORTAAL": "Portal",
    "klantverzoeken.kanaal.EXTERNE_API": "Website",
    "klantverzoeken.status.NIEUW": "New",
    "klantverzoeken.status.IN_BEHANDELING": "In progress",
    "klantverzoeken.status.AANVULLING_NODIG": "Information requested",
    "klantverzoeken.status.VOORSTEL_KLANT": "Proposal with customer",
    "klantverzoeken.status.GOEDGEKEURD": "Approved",
    "klantverzoeken.status.VERWERKT": "Processed",
    "klantverzoeken.status.MISLUKT": "Failed",
    "klantverzoeken.status.AFGEWEZEN": "Rejected",
    "klantverzoeken.status.INGETROKKEN": "Withdrawn",
    "klantverzoeken.status.VERLOPEN": "Expired",
    "klantverzoeken.type.KLANT_REGISTRATIE": "Registration",
    "klantverzoeken.type.CONTACTPERSOON_TOEVOEGEN": "Add household member",
    "klantverzoeken.type.CONTACTPERSOON_WIJZIGING": "Change contact details",
    "klantverzoeken.type.RESERVERING_NIEUW": "New booking",
    "klantverzoeken.type.RESERVERING_WIJZIGING": "Change booking",
    "klantverzoeken.type.RESERVERING_ANNULERING": "Cancel booking",
    "klantverzoeken.type.RESERVERING_WACHTLIJST": "Waiting list",
    "klantverzoeken.type.DAGOPVANG_NIEUW": "New day care",
    "klantverzoeken.type.DAGOPVANG_WIJZIGING": "Change day care",
    "klantverzoeken.type.DAGOPVANG_ANNULERING": "Cancel day care",
    "klantverzoeken.type.DIER_NIEUW": "Register animal",
    "klantverzoeken.type.DIER_WIJZIGING": "Change animal",
    "klantverzoeken.type.DOCUMENT_UPLOAD": "Document",
    "klantverzoeken.ingediendDoor": "submitted by %s via %s on %s",
    "klantverzoeken.inBehandelingBij": "Handled by %s",
    "klantverzoeken.mislukt.VALIDATIE": "Processing refused",
    "klantverzoeken.mislukt.CONFLICT": "Changed since the customer agreed",
    "klantverzoeken.mislukt.TECHNISCH": "Technical error while processing",
    "klantverzoeken.overlappend": "More requests are open for the same item: %s",
    "klantverzoeken.actie.claimen": "Take on",
    "klantverzoeken.actie.aanvulling": "Ask for information",
    "klantverzoeken.actie.afwijzen": "Reject",
    "klantverzoeken.actie.opnieuw": "Review again",
    "klantverzoeken.actie.voorstel": "Make a proposal",
    "klantverzoeken.actie.goedkeuren": "Approve & process",
    "klantverzoeken.actie.registratieGoedkeuren": "Approve registration",
    "klantverzoeken.boekje.titel": "Vaccination booklet",
    "klantverzoeken.boekje.uitleg": "Check the vaccinations against the photo. On approval the booklet goes into the animal's file.",
    "klantverzoeken.boekje.nogGeen": "The customer sent a vaccination booklet, but the photo has not arrived (yet).",
    "klantverzoeken.aanvraag": "Customer's request",
    "klantverzoeken.reactieAanKlant": "To the customer:",
    "klantverzoeken.matches.titel": "Possible existing customer",
    "klantverzoeken.matches.geen": "No existing customer found by e-mail, phone or address.",
    "klantverzoeken.matches.reden.EMAIL": "same e-mail",
    "klantverzoeken.matches.reden.TELEFOON": "same phone",
    "klantverzoeken.matches.reden.ADRES": "same postcode + house number",
    "klantverzoeken.matches.inactief": "inactive",
    "klantverzoeken.matches.koppelen": "Compare and link",
    "klantverzoeken.matches.registratie": "Registration",
    "klantverzoeken.matches.klant": "Existing customer",
    "klantverzoeken.voorstellen": "Proposals to the customer",
    "klantverzoeken.voorstelVersie": "Proposal %s",
    "klantverzoeken.voorstelStatus.OPEN": "Awaiting customer",
    "klantverzoeken.voorstelStatus.GEACCEPTEERD": "Accepted",
    "klantverzoeken.voorstelStatus.AFGEWEZEN": "Rejected",
    "klantverzoeken.voorstelStatus.VERLOPEN": "Expired",
    "klantverzoeken.voorstelStatus.VERVALLEN": "Replaced",
    "klantverzoeken.voorstelDoor": "by %s on %s · respond before %s",
    "klantverzoeken.historie": "History",
    "klantverzoeken.door.KLANT": "customer",
    "klantverzoeken.door.SYSTEEM": "system",
    "klantverzoeken.door.MEDEWERKER": "staff",
    "klantverzoeken.versies": "Versions of the request",
    "klantverzoeken.versie": "Version %s",
    "klantverzoeken.aanleiding.INGEDIEND": "submitted",
    "klantverzoeken.aanleiding.AANVULLING": "supplement",
    "klantverzoeken.aanleiding.VOORSTEL_GEACCEPTEERD": "proposal accepted",
    "klantverzoeken.conflict.titel": "Changed since the request",
    "klantverzoeken.conflict.uitleg": "The item changed after submission. Compare before you approve.",
    "klantverzoeken.conflict.oud": "At submission",
    "klantverzoeken.conflict.huidig": "Now",
    "klantverzoeken.conflict.gevraagd": "Requested",
    "klantverzoeken.annuleren": "Cancel",
    "klantverzoeken.interneNotitie": "Internal note (not shown to the customer)",
    "klantverzoeken.aanvullingVenster.titel": "Ask for information",
    "klantverzoeken.aanvullingVenster.uitleg": "The customer sees your question in the portal and updates the request.",
    "klantverzoeken.aanvullingVenster.vraag": "Question for the customer",
    "klantverzoeken.aanvullingVenster.termijn": "Deadline in days",
    "klantverzoeken.aanvullingVenster.versturen": "Send question",
    "klantverzoeken.afwijzenVenster.titel": "Reject request",
    "klantverzoeken.afwijzenVenster.reden": "Reason for the customer (optional)",
    "klantverzoeken.goedkeurenVenster.uitleg": "The request is processed as the customer asked, with all normal checks.",
    "klantverzoeken.goedkeurenVenster.registratieUitleg": "Choose: create a new customer or link to an existing one. Linking never overwrites the customer's details.",
    "klantverzoeken.goedkeurenVenster.nieuweKlant": "Create new customer",
    "klantverzoeken.goedkeurenVenster.koppelen": "Link to existing customer",
    "klantverzoeken.goedkeurenVenster.klantnummer": "Customer id",
    "klantverzoeken.goedkeurenVenster.dierenAanmaken": "Create these animals",
    "klantverzoeken.goedkeurenVenster.tochGoedkeuren": "Approve anyway",
    "klantverzoeken.voorstelVenster.titel": "Proposal to the customer",
    "klantverzoeken.voorstelVenster.uitleg": "The customer sees the request and your proposal side by side and must agree. Nothing is processed until then.",
    "klantverzoeken.voorstelVenster.gevraagd": "Requested",
    "klantverzoeken.voorstelVenster.voorstel": "Proposal",
    "klantverzoeken.voorstelVenster.reden": "Explanation for the customer",
    "klantverzoeken.voorstelVenster.prijs": "Price of the proposal (optional)",
    "klantverzoeken.voorstelVenster.bijAfwijzen": "If the customer rejects or does not respond",
    "klantverzoeken.voorstelVenster.terug": "Back to review",
    "klantverzoeken.voorstelVenster.afwijzen": "Reject the request",
    "klantverzoeken.voorstelVenster.afwijsReden": "Reason when rejecting",
    "klantverzoeken.voorstelVenster.versturen": "Send proposal",
    "klantportaalTegel.leeg": "This customer has no access to the customer portal yet.",
    "klantportaalTegel.uitnodigen": "Invite to portal",
    "klantportaalTegel.versturen": "Send invitation",
    "klantportaalTegel.uitleg": "The person receives an e-mail with a link valid for 7 days.",
    "klantportaalTegel.uitlegEerste": "The first person becomes the household's manager and can invite household members.",
    "klantportaalTegel.naam": "Name",
    "klantportaalTegel.email": "E-mail address",
    "klantportaalTegel.rolKiezen": "Role",
    "klantportaalTegel.rolAutomatisch": "Automatic (first person becomes manager)",
    "klantportaalTegel.rol.BEHEERDER": "Manager",
    "klantportaalTegel.rol.GEZINSLID": "Household member",
    "klantportaalTegel.status.ACTIEF": "Active",
    "klantportaalTegel.status.IN_AFWACHTING": "Awaiting approval",
    "klantportaalTegel.status.GEBLOKKEERD": "Blocked",
    "klantportaalTegel.status.INGETROKKEN": "Revoked",
    "klantportaalTegel.blokkeren": "Block",
    "klantportaalTegel.deblokkeren": "Restore access",
    "klantportaalTegel.intrekken": "Revoke invitation",
    "klantportaalTegel.uitgenodigd": "Invited (%s), valid until %s",
    "klantportaalTegel.fout.laden": "Customer portal could not be loaded.",
    "klantportaalTegel.fout.recht": "You are not allowed to manage portal access.",
    "klantportaalTegel.fout.algemeen": "That did not work.",
    "klantverzoeken.reservering.periode": "Period",
    "klantverzoeken.reservering.geenVoorkeur": "no accommodation preference",
    "klantverzoeken.reservering.voeding.STANDAARD": "boarding food",
    "klantverzoeken.reservering.voeding.EIGEN": "own food",
    "klantverzoeken.reservering.medicatie": "medication",
    "klantverzoeken.reservering.samen": "together with the other animals",
    "klantverzoeken.reservering.extras": "Extras for the booking",
    "klantverzoeken.reservering.verzekering": "Cancellation insurance",
    "klantverzoeken.reservering.wensen": "Other wishes",
    "klantverzoeken.reservering.ja": "Yes",
    "klantverzoeken.reservering.nee": "No",
    "klantverzoeken.reservering.wizardVersie": "Wizard version",
    "klantverzoeken.reservering.standaard": "default",
    "klantverzoeken.reservering.prijscontrole": "Price check",
    "klantverzoeken.reservering.gezien": "Price the customer saw",
    "klantverzoeken.reservering.gezienVoorstel": "Price in the accepted proposal",
    "klantverzoeken.reservering.nu": "Price at current rates",
    "klantverzoeken.reservering.akkoordNodig": "Higher than the customer saw: make a proposal first",
    "klantverzoeken.reservering.akkoordUitleg": "A booking is never confirmed at a price the customer has not seen. Allowed without new consent: %s.",
    "klantverzoeken.reservering.voorstelMetPrijs": "Proposal with new price",
    "klantverzoeken.reservering.binnenDrempel": "Within the threshold: approval needs no new consent.",
    "klantverzoeken.reservering.beschikbaarheid": "Availability now",
    "klantverzoeken.reservering.plek": "Space available",
    "klantverzoeken.reservering.geenCapaciteit": "No capacity configured",
    "klantverzoeken.reservering.vol": "full",
    "klantverzoeken.reservering.vrij": "%s left",
    "menu.klantberichten": "Customer messages",
    "klantberichten.overline": "Customer portal",
    "klantberichten.zoek": "Search customer, subject or message…",
    "klantberichten.resultaten": "%s conversation(s)",
    "klantberichten.aantal": "%s message(s)",
    "klantberichten.titel": "Customer messages",
    "klantberichten.subtitel": "Messages from customers in the portal. A message never changes anything by itself; changes go through a request.",
    "klantberichten.filter.open": "Needs reply",
    "klantberichten.filter.alle": "All",
    "klantberichten.kolom.status": "Status",
    "klantberichten.kolom.onderwerp": "Subject",
    "klantberichten.kolom.klant": "Customer",
    "klantberichten.kolom.categorie": "About",
    "klantberichten.kolom.laatste": "Last message",
    "klantberichten.antwoordNodig": "Needs reply",
    "klantberichten.beantwoord": "Up to date",
    "klantberichten.persoonlijk": "Personal (one member)",
    "klantberichten.huishouden": "Whole household",
    "klantberichten.categorie.RESERVERING": "Booking",
    "klantberichten.categorie.VERZOEK": "Request",
    "klantberichten.categorie.FACTUUR": "Invoice",
    "klantberichten.categorie.ALGEMEEN": "General",
    "klantberichten.categorie.ACCOUNT": "Account",
    "klantberichten.kanaal.EMAIL": "e-mail",
    "klantberichten.kanaal.PORTAAL": "portal",
    "klantberichten.kanaal.SYSTEEM": "system",
    "klantberichten.nietBezorgd": "e-mail not delivered",
    "klantberichten.wacht": "being sent",
    "klantberichten.leegOpen": "No messages waiting for a reply.",
    "klantberichten.leeg": "No messages yet.",
    "klantberichten.fout.laden": "The messages could not be loaded.",
    "klantberichten.antwoord": "Reply to the customer",
    "klantberichten.antwoordUitleg": "The customer reads your reply in the portal and gets an e-mail that there is a message, without its content.",
    "klantberichten.versturen": "Send reply",
    "klantportaalTegel.berichtSturen": "Send message",
    "klantportaalTegel.berichtUitleg": "The message appears in the customer's portal; recipients get an e-mail that there is a message.",
    "klantportaalTegel.berichtAan": "To",
    "klantportaalTegel.berichtHuishouden": "The whole household",
    "klantportaalTegel.berichtPersoonlijk": "Only %s",
    "klantportaalTegel.berichtOnderwerp": "Subject",
    "klantverzoeken.dier.naam": "Name",
    "klantverzoeken.dier.soort": "Species",
    "klantverzoeken.dier.ras": "Breed",
    "klantverzoeken.dier.geslacht": "Sex",
    "klantverzoeken.dier.gecastreerd": "neutered",
    "klantverzoeken.dier.geboortedatum": "Date of birth",
    "klantverzoeken.dier.chipnummer": "Microchip",
    "klantverzoeken.dier.kleur": "Colour",
    "klantverzoeken.dier.foto": "Photo of the animal",
    "klantverzoeken.dier.entingen": "Vaccinations (%s)",
    "klantverzoeken.dier.geenEntingen": "The customer did not enter any vaccinations.",
    "klantverzoeken.dier.enting": "Vaccination",
    "klantverzoeken.dier.toegediend": "Given on",
    "klantverzoeken.dier.geldigTot": "Valid until",
    "klantverzoeken.dier.bijzonderheden": "Important information",
    "klantverzoeken.dier.uitleg": "On approval the animal is created for this customer with these details, the photo and the vaccinations.",
    "klantportaalTegel.berichtTekst": "Message",
    "klantportaalTegel.bekijkAlsKlant": "View as customer",
    "klantportaalTegel.wizardTesten": "Test booking wizard",
    "klantportaalTegel.weergaveOpenen": "Open portal",
    "klantportaalTegel.weergaveAls": "View as",
    "klantportaalTegel.weergaveReden": "Reason (logged and visible to the customer)",
    "klantportaalTegel.supportUitleg": "Opens the portal read-only, exactly as this member sees it, for up to 30 minutes. Nothing can be changed.",
    "klantportaalTegel.testUitleg": "Opens the booking wizard as this member in test mode: prices and availability are real, but nothing is created, mailed or saved.",
    "klantportaalTegel.berichtVerstuurd": "The message is in the customer's portal.",
    "klantportaalTegel.berichtVersturen": "Send message",
    "menu.portaalInstellingen": "Portal settings",
    "portaalInstellingen.kop.actief": "Portal is on",
    "portaalInstellingen.kop.uit": "Portal is off",
    "portaalInstellingen.kop.domeinen": "Domains verified",
    "portaalInstellingen.ai.titel": "Write texts with AI",
    "portaalInstellingen.ai.uitleg": "The AI writes a proposal from your name, contact details and portal sections. Check it, adjust it and save.",
    "portaalInstellingen.ai.wens": "Wish for the AI",
    "portaalInstellingen.ai.wensPlaats": "Optional: e.g. mention that we also offer day care, keep it short",
    "portaalInstellingen.ai.alles": "Write all three",
    "portaalInstellingen.ai.een": "Write with AI",
    "portaalInstellingen.ai.bezig": "Writing…",
    "portaalInstellingen.ai.klaar": "The proposal is in the fields below. Not saved yet: check it and press Save.",
    "portaalInstellingen.ai.fout": "The AI could not write a text.",
    "portaalInstellingen.site.titel": "Colours from your website",
    "portaalInstellingen.site.uitleg": "Enter your website: we read its colours and make a portal palette from them. Not saved until you press Save.",
    "portaalInstellingen.site.adres": "Website address",
    "portaalInstellingen.site.knop": "Get colours",
    "portaalInstellingen.site.bezig": "Reading the website…",
    "portaalInstellingen.site.klaar": "A palette from your website is set. Click another colour below to make it the main colour, then press Save.",
    "portaalInstellingen.site.fout": "The colours could not be read from this website.",
    "portaalInstellingen.site.gevonden": "Found on the website:",
    "portaalInstellingen.site.kies": "Use %s as main colour",
    "portaalInstellingen.site.logo": "Colours from the logo",
    "portaalInstellingen.site.gevondenLogo": "Found in the logo:",
    "portaalInstellingen.site.klaarLogo": "A palette from your logo is set. Click another colour below to make it the main colour, then press Save.",
    "portaalInstellingen.thema.donkerder": "%s is too light for white text; the portal shows it slightly darker: %s.",
    "portaalInstellingen.titel": "Portal settings",
    "portaalInstellingen.subtitel": "This boarding's customer portal: look and feel, what customers see and what they can request.",
    "portaalInstellingen.opgeslagen": "Saved.",
    "portaalInstellingen.fout": "Saving failed.",
    "portaalInstellingen.opslaan": "Save",
    "portaalInstellingen.standaard": "Default",
    "portaalInstellingen.naam": "Portal name",
    "portaalInstellingen.actief": "Portal is on",
    "portaalInstellingen.actiefUitleg": "Off: customers cannot reach the portal. Data and accounts are kept.",
    "portaalInstellingen.activeren.titel": "Activate customer portal",
    "portaalInstellingen.activeren.uitleg": "Create the portal. It stays off until you switch it on and link a domain.",
    "portaalInstellingen.activeren.knop": "Create portal",
    "portaalInstellingen.tab.algemeen": "General",
    "portaalInstellingen.tab.thema": "Theme",
    "portaalInstellingen.tab.modules": "Modules & registration",
    "portaalInstellingen.tab.gezin": "Household members",
    "portaalInstellingen.tab.reserveren": "Bookings",
    "portaalInstellingen.tab.berichten": "Messages",
    "portaalInstellingen.tab.financieel": "Finance & documents",
    "portaalInstellingen.tab.api": "API",
    "portaalInstellingen.inloggen.titel": "Signing in",
    "portaalInstellingen.inloggen.bestaandeKlanten": "Existing customers can sign in with the e-mail address on file",
    "portaalInstellingen.inloggen.uitleg": "The login code goes to the address in the customer record; on first login the portal account is linked to that customer automatically, so they do not need to register again. An address shared by more than three customers does not count.",
    "portaalInstellingen.api.uitleg": "Websites that work with the customer portal through the external API. Customers always sign in through the central portal login and approve access themselves; a website never sees login codes.",
    "portaalInstellingen.api.documentatie": "Documentation for the website builder (OpenAPI): %s",
    "portaalInstellingen.api.geen": "No API clients yet.",
    "portaalInstellingen.api.nieuw": "New client",
    "portaalInstellingen.api.wijzigen": "Edit",
    "portaalInstellingen.api.naam": "Name",
    "portaalInstellingen.api.clientId": "Client ID",
    "portaalInstellingen.api.scopes": "Scopes",
    "portaalInstellingen.api.laatst": "Last used",
    "portaalInstellingen.api.ingetrokken": "revoked",
    "portaalInstellingen.api.soort.PUBLIC": "Website (browser, PKCE)",
    "portaalInstellingen.api.soort.CONFIDENTIAL": "Server application (secret)",
    "portaalInstellingen.api.soortLabel": "Type",
    "portaalInstellingen.api.redirects": "Redirect URIs (one per line, exact, https)",
    "portaalInstellingen.api.ip": "IP allowlist (optional)",
    "portaalInstellingen.api.verwerkersovereenkomst": "There is a data processing agreement with the website builder",
    "portaalInstellingen.api.intrekken": "Revoke",
    "portaalInstellingen.api.intrekkenBevestig": "Revoke %s? The website stops working with the portal immediately.",
    "portaalInstellingen.api.nieuwSecret": "New secret",
    "portaalInstellingen.api.secretBevestig": "Create a new secret? The old one stops working immediately.",
    "portaalInstellingen.api.secretEenmalig": "Copy the secret now; it will not be shown again.",
    "portaalInstellingen.api.secretGezien": "I have copied it",
    "portaalInstellingen.api.geenRecht": "You need the right to manage the customer portal.",
    "portaalInstellingen.domeinen.titel": "Domains",
    "portaalInstellingen.domeinen.uitleg": "Where customers open the portal, e.g. my.boardingname.com. A domain works once verified.",
    "portaalInstellingen.domeinen.geen": "No domain linked yet.",
    "portaalInstellingen.domeinen.txt": "Add a TXT record %s with value %s and click Verify.",
    "portaalInstellingen.domeinen.geverifieerd": "Verified",
    "portaalInstellingen.domeinen.nietGeverifieerd": "Not verified yet",
    "portaalInstellingen.domeinen.verifieer": "Verify",
    "portaalInstellingen.domeinen.gelukt": "The domain is verified.",
    "portaalInstellingen.domeinen.verwijder": "Remove domain",
    "portaalInstellingen.domeinen.nieuw": "New domain",
    "portaalInstellingen.domeinen.toevoegen": "Add",
    "portaalInstellingen.thema.logo": "Logo",
    "portaalInstellingen.thema.header": "Header image",
    "portaalInstellingen.thema.welke": "Which image",
    "portaalInstellingen.thema.upload": "Upload image",
    "portaalInstellingen.thema.uploadUitleg": "PNG or JPG; logo at most 1 MB, header at most 3 MB. SVG is not allowed.",
    "portaalInstellingen.thema.primaireKleur": "Primary colour",
    "portaalInstellingen.thema.accentKleur": "Accent colour",
    "portaalInstellingen.thema.lettertype": "Font",
    "portaalInstellingen.thema.hoekstijl": "Corner style",
    "portaalInstellingen.thema.hoek.compact": "Compact",
    "portaalInstellingen.thema.hoek.zacht": "Soft",
    "portaalInstellingen.thema.hoek.rond": "Round",
    "portaalInstellingen.thema.contrast": "This colour is too light for white text; the portal uses %s.",
    "portaalInstellingen.thema.welkomsttekst": "Welcome text",
    "portaalInstellingen.thema.hulptekst": "Help text",
    "portaalInstellingen.thema.footertekst": "Footer text",
    "portaalInstellingen.thema.contact.telefoon": "Phone",
    "portaalInstellingen.thema.contact.email": "E-mail",
    "portaalInstellingen.thema.contact.openingstijden": "Opening hours",
    "portaalInstellingen.thema.voorbeeld": "Preview",
    "portaalInstellingen.thema.voorbeeldTekst": "Welcome to your portal.",
    "portaalInstellingen.thema.voorbeeldKnop": "New booking",
    "portaalInstellingen.modules.titel": "Modules",
    "portaalInstellingen.module.dieren": "Animals",
    "portaalInstellingen.module.reserveringen": "Bookings",
    "portaalInstellingen.module.dagopvang": "Day care",
    "portaalInstellingen.module.communicatie": "Communication",
    "portaalInstellingen.module.financieel": "Finance",
    "portaalInstellingen.module.documenten": "Documents",
    "portaalInstellingen.registratie.titel": "Registration",
    "portaalInstellingen.registratie.zelf": "New customers",
    "portaalInstellingen.registratie.AAN": "May register themselves",
    "portaalInstellingen.registratie.ALLEEN_UITNODIGING": "By invitation only",
    "portaalInstellingen.registratie.UIT": "No access",
    "portaalInstellingen.veld.telefoon": "Phone",
    "portaalInstellingen.veld.noodcontact": "Emergency contact",
    "portaalInstellingen.veld.dierenarts": "Vet",
    "portaalInstellingen.veld.geboortedatum": "Date of birth",
    "portaalInstellingen.veld.dieren": "Animals",
    "portaalInstellingen.veldstand.VERPLICHT": "Required",
    "portaalInstellingen.veldstand.OPTIONEEL": "Optional",
    "portaalInstellingen.veldstand.VERBORGEN": "Hidden",
    "portaalInstellingen.registratie.privacyUrl": "Privacy statement (URL)",
    "portaalInstellingen.registratie.privacyVersie": "Privacy statement version",
    "portaalInstellingen.registratie.voorwaardenUrl": "Terms and conditions (URL)",
    "portaalInstellingen.registratie.voorwaardenVersie": "Terms version",
    "portaalInstellingen.registratie.doorlooptijd": "Expected processing time (text)",
    "portaalInstellingen.registratie.reserverenVoorGoedkeuring": "New customers may book before their registration is approved",
    "portaalInstellingen.dieren.titel": "Animals",
    "portaalInstellingen.dieren.bijzonderheden": "Show animal particulars to customers",
    "portaalInstellingen.gezin.maximum": "Maximum number of household members",
    "portaalInstellingen.gezin.naGoedkeuring": "A household member only gets access after the boarding approves",
    "portaalInstellingen.gezin.standaardProfiel": "Default profile for new members",
    "portaalInstellingen.gezin.profielen": "Profiles a manager may choose",
    "portaalInstellingen.profiel.VOLLEDIG": "Full",
    "portaalInstellingen.profiel.VOLLEDIG_ZONDER_FINANCIEEL": "Full without finance",
    "portaalInstellingen.profiel.RESERVEREN": "Booking",
    "portaalInstellingen.profiel.MEEKIJKEN": "View only",
    "portaalInstellingen.reserveren.vestiging": "Customers book at location",
    "portaalInstellingen.reserveren.uit": "Booking through the portal is off",
    "portaalInstellingen.reserveren.wizardUitleg": "Steps and own questions come from this location's published wizard (Settings › Boarding).",
    "portaalInstellingen.reserveren.beschikbaarheid": "Show availability",
    "portaalInstellingen.beschikbaarheid.NIET_TONEN": "Don't show",
    "portaalInstellingen.beschikbaarheid.INDICATIEF": "Indication (likely / limited)",
    "portaalInstellingen.beschikbaarheid.REALTIME": "Real check; full = no request",
    "portaalInstellingen.reserveren.drempelBedrag": "Price difference without new consent (€)",
    "portaalInstellingen.reserveren.drempelProcent": "Price difference without new consent (%)",
    "portaalInstellingen.reserveren.dagenVooruit": "Earliest start (days ahead)",
    "portaalInstellingen.reserveren.conceptDagen": "Keep drafts (days)",
    "portaalInstellingen.reserveren.voorwaardenUrl": "Booking terms (URL)",
    "portaalInstellingen.reserveren.voorwaardenVersie": "Booking terms version",
    "portaalInstellingen.reserveren.drempelUitleg": "If the price at approval is higher than the customer saw by more than this, make a proposal first.",
    "portaalInstellingen.privacy.titel": "Privacy",
    "portaalInstellingen.privacy.supportZichtbaar": "Customers see in My account › Activity when support viewed their portal",
    "portaalInstellingen.regels.titel": "Conditional questions",
    "portaalInstellingen.regels.uitleg": "IF … AND/OR … THEN show question. A question with a rule stays hidden until one of its rules matches; a hidden question is never required.",
    "portaalInstellingen.regels.eerstVestiging": "Choose a location first and save.",
    "portaalInstellingen.regels.geenVragen": "The booking wizard has no custom questions yet. Add them under Pension settings › Booking wizard.",
    "portaalInstellingen.regels.leeg": "No rules: every question is always shown.",
    "portaalInstellingen.regels.regel": "Rule %s",
    "portaalInstellingen.regels.als": "IF",
    "portaalInstellingen.regels.dan": "THEN",
    "portaalInstellingen.regels.en": "AND",
    "portaalInstellingen.regels.of": "OR",
    "portaalInstellingen.regels.verbinding": "And/or",
    "portaalInstellingen.regels.veld": "Field",
    "portaalInstellingen.regels.operator": "Comparison",
    "portaalInstellingen.regels.waarde": "Value",
    "portaalInstellingen.regels.is": "is",
    "portaalInstellingen.regels.isNiet": "is not",
    "portaalInstellingen.regels.ja": "yes",
    "portaalInstellingen.regels.nee": "no",
    "portaalInstellingen.regels.veld.diersoort": "Species",
    "portaalInstellingen.regels.veld.verblijf": "Accommodation",
    "portaalInstellingen.regels.veld.extra": "Extra",
    "portaalInstellingen.regels.veld.verzekering": "Cancellation insurance",
    "portaalInstellingen.regels.antwoordOp": "Answer to \"%s\"",
    "portaalInstellingen.regels.toon": "Question to show",
    "portaalInstellingen.regels.toonVraag": "show \"%s\"",
    "portaalInstellingen.regels.voorwaardeErbij": "Add condition",
    "portaalInstellingen.regels.voorwaardeWeg": "Remove condition",
    "portaalInstellingen.regels.regelErbij": "Add rule",
    "portaalInstellingen.regels.regelWeg": "Remove rule",
    "portaalInstellingen.versies.titel": "Wizard versions",
    "portaalInstellingen.versies.uitleg": "Restoring publishes an earlier version again as a new version. It only applies to new requests; drafts and submitted requests keep their own version.",
    "portaalInstellingen.versies.geen": "No published versions yet: the wizard uses the standard layout.",
    "portaalInstellingen.versies.versie": "Version",
    "portaalInstellingen.versies.op": "Published",
    "portaalInstellingen.versies.door": "By",
    "portaalInstellingen.versies.actie": "Action",
    "portaalInstellingen.versies.live": "live",
    "portaalInstellingen.versies.terugzetten": "Restore",
    "portaalInstellingen.versies.bevestig": "Publish version %s again as the live wizard?",
    "portaalInstellingen.versies.teruggezet": "Version %s is live again.",
    "portaalInstellingen.versies.geenRecht": "Only pension administrators can restore a version.",
    "portaalInstellingen.berichten.aan": "Customers can message the boarding and reply",
    "portaalInstellingen.berichten.uitleg": "Messages arrive in Customer messages. A message never changes anything by itself.",
    "portaalInstellingen.berichten.categorieen": "What customers may start a new message about",
    "portaalInstellingen.berichten.maxPerDag": "Maximum messages per person per day",
    "portaalInstellingen.berichten.gedeeld": "A customer's new message is visible to the whole household",
    "portaalInstellingen.financieel.onlineBetalen": "Customers can pay online",
    "portaalInstellingen.financieel.provider": "Payment provider",
    "portaalInstellingen.financieel.test": "Test payments (no real money)",
    "portaalInstellingen.financieel.uitleg": "The Mollie key is under Settings › Integrations › iDEAL. Payment status only comes from the provider's confirmation.",
    "portaalInstellingen.documenten.titel": "Documents",
    "portaalInstellingen.documenten.uploaden": "Customers can upload documents (e.g. vaccination proof)",
    "portaalInstellingen.documenten.tonen": "Show documents from the animal file to customers",
    "klantverzoeken.bestanden.titel": "Files",
    "klantverzoeken.bestanden.download": "Download",
    "klantverzoeken.bestanden.fout": "Download failed.",
    "klantverzoeken.bestanden.scan.SCHOON": "Scanned, clean",
    "klantverzoeken.bestanden.scan.NIET_GESCAND": "Not scanned",
    "klantverzoeken.bestanden.scan.BESMET": "Rejected by virus scan",
    "klantverzoeken.bestanden.scan.NVT": "—",
    "financieel.tab.dagafsluitingen": "Day closings",
    "dagafsluitingOverzicht.title": "Day closings",
    "dagafsluitingOverzicht.subtitle": "Per day: who closed it, who approved it and what did not add up.",
    "dagafsluitingOverzicht.kpi.dagen": "Days closed",
    "dagafsluitingOverzicht.kpi.metVerschil": "Days with a difference",
    "dagafsluitingOverzicht.kpi.wachtOpControle": "Awaiting approval",
    "dagafsluitingOverzicht.kpi.nietAfgesloten": "Niet afgesloten",
    "dagafsluitingOverzicht.status.NIET_AFGESLOTEN": "Niet afgesloten",
    "dagafsluitingOverzicht.boekingen": "%s kasboekingen, nooit afgesloten",
    "dagafsluitingOverzicht.col.dag": "Day",
    "dagafsluitingOverzicht.col.vestiging": "Branch",
    "dagafsluitingOverzicht.col.status": "Status",
    "dagafsluitingOverzicht.col.afgeslotenDoor": "Closed by",
    "dagafsluitingOverzicht.col.afgeslotenOp": "Closed at",
    "dagafsluitingOverzicht.col.akkoord": "Approved by",
    "dagafsluitingOverzicht.col.contant": "Cash counted",
    "dagafsluitingOverzicht.col.verschilContant": "Cash difference",
    "dagafsluitingOverzicht.col.pin": "PIN counted",
    "dagafsluitingOverzicht.col.verschilPin": "PIN difference",
    "dagafsluitingOverzicht.col.opmerking": "Note",
    "dagafsluitingOverzicht.geenAkkoord": "Not approved",
    "dagafsluitingOverzicht.tellingTitel": "Counted, with the expected amount below it",
    "dagafsluitingOverzicht.leeg": "No day was closed in this period.",
    "dagafsluitingOverzicht.laadfout": "The day closings could not be loaded.",
    "dagafsluitingOverzicht.status.CONCEPT": "Draft",
    "dagafsluitingOverzicht.status.WACHT_OP_CONTROLE": "Awaiting approval",
    "dagafsluitingOverzicht.status.AKKOORD": "Approved",
    "factuurDetailView.concept.geenRegels": "This invoice has no lines yet — add one, or discard the invoice.",
    "factuurDetailView.concept.losseVerkoopOnbalans": "A counter sale must balance: nothing may be left outstanding.",
    "factuurDetailView.notice.losseVerkoopOnbalans": "This invoice has no debtor, so there is nobody to invoice the remainder to. Register the payment for the full amount, or adjust the lines.",
    "factuurDetailView.concept.weggooienKnop": "Discard invoice",
    "factuurDetailView.notice.geenRegels": "An invoice needs at least one line. Add a line, or discard the invoice.",
    "factuurDetailView.nogGeenNummer": "(no number yet)",
    "uitboeken.payment.teveel": "That is %s more than the amount due. Enter at most the amount due — the remainder can be invoiced later.",
    "communicatieAi.selectie.menu": "Adjust with AI",
    "communicatieAi.selectie.titel": "Adjust the selected text with AI",
    "communicatieAi.selectie.uitleg": "Only the selected text is sent and only that text is replaced. The rest of the template stays as it is.",
    "communicatieAi.selectie.huidig": "Selected text",
    "communicatieAi.selectie.voorstel": "Proposal",
    "communicatieAi.selectie.ongewijzigd": "The proposal is identical to the selected text, so there is nothing to apply.",
    "communicatieAi.selectie.opdracht": "What should change?",
    "communicatieAi.selectie.opdrachtNog": "Anything else to change?",
    "communicatieAi.selectie.opdracht.placeholder": "For example: state the payment method here",
    "communicatieAi.selectie.vraag": "Ask for a proposal",
    "communicatieAi.selectie.bijschaven": "Refine",
    "communicatieAi.selectie.doorvoeren": "Apply",
    "communicatieAi.selectie.velden-kapot": "This proposal changes the fields in the text, so it cannot be applied. Ask for a different wording.",
    "menu.losseVerkoop": "Counter sale",
    "losseVerkoop.title": "Counter sale",
    "losseVerkoop.subtitle": "An invoice without a debtor, settled at the counter right away.",
    "losseVerkoop.fout": "The sale could not be completed.",
    "losseVerkoop.bezig": "Opening a counter sale…",
    "losseVerkoop.opnieuw": "Try again",
    "factuurDetailView.export.emailAdres": "E-mail address",
    "factuurDetailView.export.emailAdresVragen": "This invoice has no debtor, so there is no address on file. Enter the address to send it to.",
    "wachtlijst.titel": "Waiting list",
    "wachtlijst.onderschrift": "Surrender requests and the state of their intake.",
    "wachtlijst.kpi.nieuw": "New requests",
    "wachtlijst.kpi.actieVereist": "Action required",
    "wachtlijst.kpi.klaar": "Ready for review",
    "wachtlijst.kpi.gepland": "Scheduled for intake",
    "wachtlijst.zoek": "Search by number, owner or animal...",
    "wachtlijst.filter.alle": "All statuses",
    "wachtlijst.col.nummer": "#",
    "wachtlijst.col.dieren": "Animal(s)",
    "wachtlijst.col.eigenaar": "Owner",
    "wachtlijst.col.status": "Intake status",
    "wachtlijst.col.compleet": "File complete",
    "wachtlijst.col.ontvangen": "Received",
    "wachtlijst.col.acties": "Actions",
    "wachtlijst.open": "Open file",
    "wachtlijst.leeg": "No requests yet.",
    "wachtlijst.laadfout": "The waiting list could not be loaded.",
    "wachtlijst.handmatig": "Status set manually",
    "wachtlijst.geenTelling": "No questionnaire linked, so there is nothing to count.",
    "wachtlijst.status.NIEUW": "New",
    "wachtlijst.status.ACTIE_VEREIST": "Action required",
    "wachtlijst.status.IN_BEHANDELING": "In progress",
    "wachtlijst.status.COMPLEET": "Complete",
    "wachtlijst.status.GEPLAND": "Scheduled",
    "wachtlijst.status.AFGEHANDELD": "Completed",
    "wachtlijst.status.AFGEWEZEN": "Rejected",
    "wachtlijst.status.INGETROKKEN": "Withdrawn",
    "wachtlijst.status.VERLOPEN": "Expired",
    "menu.wachtlijst": "Waiting list",
    "opvangModules.wachtlijst": "Waiting list",
    "wachtlijst.results.found": "requests found",
    "wachtlijst.results.foundOne": "request found",
    "wachtlijst.weergave": "View",
    "wachtlijst.weergave.card": "Cards",
    "wachtlijst.weergave.compact": "Small cards",
    "wachtlijst.weergave.list": "List",
    "wachtlijstDetail.terug": "Back",
    "wachtlijstDetail.laadfout": "This request could not be loaded.",
    "wachtlijstDetail.ontvangen": "Received",
    "wachtlijstDetail.ingediend": "Submitted",
    "wachtlijstDetail.statusZetten": "Status",
    "wachtlijstDetail.statusFout": "The status could not be changed.",
    "wachtlijstDetail.eigenaar": "Owner",
    "wachtlijstDetail.naam": "Name",
    "wachtlijstDetail.email": "E-mail",
    "wachtlijstDetail.telefoon": "Phone",
    "wachtlijstDetail.adres": "Address",
    "wachtlijstDetail.geenContact": "No contact details yet.",
    "wachtlijstDetail.notitie": "Internal note",
    "wachtlijstDetail.notitieUitleg": "Only visible here. The owner never sees this.",
    "wachtlijstDetail.klantKoppelen": "Link to a relation",
    "wachtlijstDetail.klantKoppelenTitel": "Link this request to a relation",
    "wachtlijstDetail.klantKoppelenUitleg": "The form says “%s”. Find that person among the existing relations, so their animals and history stay on one card instead of a second one being created at intake.",
    "wachtlijstDetail.klantKoppelBevestig": "Link",
    "wachtlijstDetail.klantGekoppeld": "Relation",
    "wachtlijstDetail.klantOntkoppelen": "Unlink",
    "wachtlijstDetail.klantZoek": "Find the relation",
    "wachtlijstDetail.klantZoekInfo": "Search by e-mail or address; create a new relation if this person is not in the system yet.",
    "wachtlijstDetail.klantFout": "Could not change the link.",
    "wachtlijstDossier.verschillenKop": "Differs from the linked relation",
    "wachtlijstDossier.verschilVeld": "Field",
    "wachtlijstDossier.verschilOpgave": "On the request",
    "wachtlijstDossier.verschilRelatie": "On the relation",
    "wachtlijstDetail.vestiging": "Location",
    "wachtlijstDetail.vestigingVerplaatsen": "Move",
    "wachtlijstDetail.vestigingVerplaatsenTitel": "Move to another location",
    "wachtlijstDetail.vestigingVerplaatsenUitleg": "This request arrived at the location closest to postcode %s. Pick another one if it belongs elsewhere \u2014 the owner never sees which locations exist.",
    "wachtlijstDetail.vestigingNaar": "To location",
    "wachtlijstDetail.vestigingVerplaatsBevestig": "Move",
    "wachtlijstDetail.vestigingFout": "The request could not be moved.",
    "wachtlijstDetail.behandelaarFout": "The handler could not be changed.",
    "wachtlijstDetail.beoordelingFout": "The assessment could not be saved.",
    "wachtlijstDetail.labelFout": "The label could not be changed.",
    "wachtlijstDetail.notitiePlaceholder": "What has been agreed, who called, what still needs checking…",
    "wachtlijstDetail.notitieBewaren": "Save note",
    "wachtlijstDetail.notitieBewaard": "Note saved",
    "wachtlijstDetail.notitieFout": "The note could not be saved.",
    "wachtlijstDetail.dieren": "Animals and answers",
    "wachtlijstDetail.geenDieren": "No animals on this request.",
    "wachtlijstDetail.nietIngevuld": "Not answered",
    "wachtlijstDetail.ontbreekt": "%s required questions are still unanswered.",
    "wachtlijstDossier.terugNaarLijst": "Back to list",
    "wachtlijstDossier.meerDieren": "%s animals",
    "wachtlijstDossier.huidigeStap": "Current step",
    "wachtlijstDossier.stap.ontvangen": "Request received",
    "wachtlijstDossier.stap.beoordeling": "Assessment",
    "wachtlijstDossier.stap.inplannen": "Schedule intake",
    "wachtlijstDossier.stap.afronden": "Complete",
    "wachtlijstDossier.onderdelen": "Parts of the questionnaire",
    "wachtlijstDossier.onderdelenUitleg": "Pick a part to read and assess the answers.",
    "wachtlijstDossier.beoordeeldVan": "%s of %s assessed",
    "wachtlijstDossier.aandachtspunten": "%s point(s) of attention",
    "wachtlijstDossier.geenAandachtspunten": "No points of attention",
    "wachtlijstDossier.beoordeelUitleg": "Every answer the owner gave is shown in full. Assess per question whether anything needs following up.",
    "wachtlijstDossier.vraagVanHetAsiel": "Question from the shelter",
    "wachtlijstDossier.antwoordVanDeEigenaar": "Answer from the owner",
    "wachtlijstDossier.beoordeling": "Assessment",
    "wachtlijstDossier.akkoord": "Fine",
    "wachtlijstDossier.aandachtspunt": "Needs attention",
    "wachtlijstDossier.vragenlijstHerkomst": "Questions, order and parts come from the questionnaire your organisation set up.",
    "wachtlijstDossier.tab.dieren": "Animals",
    "wachtlijstDossier.tab.notities": "Notes",
    "wachtlijstDossier.aanvrager": "Applicant",
    "wachtlijstDossier.naam": "Name",
    "wachtlijstDossier.email": "E-mail",
    "wachtlijstDossier.telefoon": "Phone",
    "wachtlijstDossier.adres": "Address",
    "wachtlijstDossier.redenVanAfstand": "Reason for surrender",
    "wachtlijstDossier.geenReden": "The questionnaire does not ask for a reason.",
    "wachtlijstDossier.gewenstePeriode": "Preferred timing",
    "wachtlijstDossier.verblijftNuBij": "Currently staying with",
    "wachtlijstDossier.bijDeRelatie": "With the relation %s",
    "wachtlijstDossier.bijDeEigenaar": "With the owner",
    "wachtlijstDossier.status": "Status",
    "wachtlijstDossier.behandelaar": "Handled by",
    "wachtlijstDossier.nogNiemand": "Not assigned yet",
    "wachtlijstDossier.aanMijToewijzen": "Assign to me",
    "wachtlijstDossier.vrijgeven": "Release",
    "wachtlijstDossier.labels": "Labels",
    "wachtlijstDossier.labelToevoegen": "Add label",
    "wachtlijstDossier.labelWeg": "Remove label %s",
    "wachtlijstDossier.labelPlaceholder": "e.g. urgent",
    "wachtlijstDossier.afdrukken": "Print file",
    "wachtlijstDossier.notitieToevoegen": "Add note",
    "wachtlijstDossier.notitieBewaren": "Save note",
    "wachtlijstDossier.notitiesUitleg": "Only visible here. The owner never sees these.",
    "wachtlijstDossier.geenNotities": "No notes yet.",
    "wachtlijstDossier.onbekendeSchrijver": "Unknown",
    "wachtlijstDossier.stap.algemeen": "General details",
    "wachtlijstDossier.stap.vragen": "Surrender questions",
    "wachtlijstDossier.stap.gezondheid": "Health & vaccinations",
    "wachtlijstDossier.stap.extra": "Extra information",
    "wachtlijstDossier.ingevuld": "Provided",
    "wachtlijstDossier.nietOpgegeven": "Not provided",
    "wachtlijstDossier.geenVragen": "No questions for this species",
    "wachtlijstDossier.optioneel": "Optional",
    "wachtlijstDossier.aantalFotos": "%s photo(s)",
    "wachtlijstDossier.fotos": "Photos",
    "wachtlijstDossier.geenFotos": "The owner did not add photos.",
    "wachtlijstDossier.karakter": "Character",
    "wachtlijstDossier.bijzonderheden": "Anything else",
    "wachtlijstDossier.uitklappen": "Expand",
    "wachtlijstDossier.inklappen": "Collapse",
    "wachtlijstDossier.bewerken": "Edit",
    "wachtlijstDossier.tab.antwoorden": "Answers",
    "wachtlijstDossier.tab.documenten": "Documents",
    "wachtlijstDossier.tab.historie": "History",
    "wachtlijstDossier.diergegevens": "Animal details",
    "wachtlijstDossier.entingen": "Vaccinations from the booklet",
    "wachtlijstDossier.entingenUitleg": "What the owner confirmed after checking the photos — not proof of a valid vaccination. The booklet photos are under Documents.",
    "wachtlijstDossier.dierZonderNaam": "Animal without a name",
    "wachtlijstDossier.enting.vaccin": "Vaccine",
    "wachtlijstDossier.enting.datum": "Date",
    "wachtlijstDossier.enting.geldigTot": "Valid until",
    "wachtlijstDossier.enting.dierenarts": "Vet",
    "wachtlijstDossier.roepnaam": "Name",
    "wachtlijstDossier.diersoort": "Species",
    "wachtlijstDossier.ras": "Breed",
    "wachtlijstDossier.geslacht": "Sex",
    "wachtlijstDossier.geboortedatum": "Date of birth",
    "wachtlijstDossier.chipnummer": "Chip number",
    "wachtlijstDossier.aanvraagvragen": "Request questions",
    "wachtlijstDossier.beantwoord": "%s of %s answered",
    "wachtlijstDossier.groepKlaar": "Complete",
    "wachtlijstDossier.groepOnvolledig": "More information needed",
    "wachtlijstDossier.controle": "File check",
    "wachtlijstDossier.controle.gegevens": "Owner details",
    "wachtlijstDossier.controle.vragen": "Required questions",
    "wachtlijstDossier.ontvangenOp": "Request received",
    "wachtlijstDossier.ingediendOp": "Submitted by the owner",
    "wachtlijstDossier.historieOnvolledig": "What happened to the file afterwards is not logged yet.",
    "wachtlijstInstellingen.titel": "Surrender portal",
    "wachtlijstInstellingen.onderschrift": "Which questions the owner is asked, per species.",
    "wachtlijstInstellingen.vragenlijsten": "Questionnaires",
    "wachtlijstInstellingen.uitleg": "Built in the same questionnaire builder as the aftercare lists. Only published lists are shown in the portal.",
    "wachtlijstInstellingen.geenVragen": "No list yet — no questions for this species",
    "wachtlijstInstellingen.aanpassen": "Edit",
    "wachtlijstInstellingen.maken": "Create",
    "wachtlijstInstellingen.nieuweLijst": "New list",
    "wachtlijstInstellingen.laadfout": "The questionnaires could not be loaded.",
    "wachtlijstInstellingen.status.GEPUBLICEERD": "Published",
    "wachtlijstInstellingen.status.CONCEPT": "Draft — not live",
    "wachtlijstInstellingen.status.GEARCHIVEERD": "Archived",
    "wachtlijst.instellingen": "Portal settings",
    "wachtlijstDetail.documenten": "Documents",
    "wachtlijstDetail.documentenUitleg": "PDF or photo, up to 10 MB each. The owner's files arrive here straight from the portal.",
    "wachtlijstDetail.geenDocumenten": "No documents yet.",
    "wachtlijstDetail.documentToevoegen": "Add document",
    "wachtlijstDetail.uploadBezig": "Uploading…",
    "wachtlijstDetail.uploadFout": "That file could not be added. Only PDF, JPEG, PNG, WebP or HEIC, up to 10 MB.",
    "wachtlijstDetail.documentOpenen": "Open",
    "wachtlijstDetail.documentBewaren": "Save",
    "wachtlijstDetail.documentWeg": "Delete",
    "wachtlijstDetail.documentWegFout": "The document could not be deleted.",
    "wachtlijstDetail.documentenFout": "The documents could not be loaded.",
  },
  nl: {
    "common.loadError": "Kon niet worden geladen.",
    "common.retry": "Opnieuw proberen",
    "common.previous": "Vorige",
    "common.next": "Volgende",
    "common.more": "Meer",
    "common.loading": "Laden…",
    "validatie.emailadres": "Vul een geldig e-mailadres in.",
    "common.opnieuw": "Opnieuw proberen",
    "common.remove": "Verwijderen",
    "common.noMatches": "Niets komt overeen met die zoekopdracht.",
    // Deep-link module guard (App.tsx): shown instead of a page whose owning module is disabled.
    "app.moduleDisabled": "Deze module is uitgeschakeld voor deze organisatie.",
    "serviceAccountDetailView.allowlist.add.placeholder": "bv. 198.51.100.0/29 of 198.51.100.7",
    "common.save": "Opslaan",
    "common.cancel": "Annuleren",
    "entityAdmin.loadFailed": "Dit scherm kon niet worden geladen.",
    "entityAdmin.search": "Zoeken...",
    "entityAdmin.create": "Nieuw",
    "entityAdmin.edit": "Bewerken",
    "entityAdmin.delete": "Verwijderen",
    "entityAdmin.empty": "Nog niets vastgelegd.",
    "entityAdmin.prev": "Vorige",
    "entityAdmin.next": "Volgende",
    "entityAdmin.pageOf": "Pagina %s van %s",
    "entityAdmin.createTitle": "Nieuw %s",
    "entityAdmin.editTitle": "%s bewerken",
    "entityAdmin.saveConflict": "Dit record is door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "entityAdmin.saveError": "Opslaan mislukt.",
    "entityAdmin.deleteTitle": "Verwijderen",
    "entityAdmin.deleteBody": "Weet je zeker dat je dit record wilt verwijderen?",
    "entityAdmin.rowCount": "%s records",
    "entityAdmin.catalogTitle": "Databeheer",
    "entityAdmin.choiceBlank": "(niet ingesteld)",
    // wizard-dialog-mode: the intake/release wizard dialog's "switch to the full-page view" action
    "wizard.openAsPage": "Als volledige pagina openen",
    "common.close": "Sluiten",
    "common.back": "Terug",
    "common.open": "Openen",
    "common.edit": "Bewerken",
    "common.add": "toevoegen",
    "common.view": "bekijken",
    "common.delete": "Verwijderen",
    "common.confirm": "Bevestigen",
    // communicatie (read-foundation UI) — de SPA leesschermen voor sjablonen/log/media. ALLEEN-LEZEN.
    "communicatieRead.title": "Communicatie",
    "communicatieRead.tab.templates": "Sjablonen",
    "communicatieRead.tab.log": "Log",
    "communicatieRead.tab.media": "Media",
    "communicatieRead.refresh": "Vernieuwen",
    "communicatieRead.template.new": "Nieuw sjabloon",
    "communicatieRead.template.delete.title": "Sjabloon verwijderen",
    "communicatieRead.template.delete.confirm": "Weet je zeker dat je dit sjabloon wilt verwijderen?",
    "communicatieRead.template.new.failed": "Het sjabloon kon niet worden aangemaakt.",
    "communicatieRead.loadFailed": "Kon de communicatiegegevens niet laden.",
    "communicatieRead.filter.all": "Alle",
    "communicatieRead.type.EMAIL": "E-mail",
    "communicatieRead.type.PRINT": "Afdruk",
    "communicatieRead.status.ACTIEF": "Actief",
    "communicatieRead.status.CONCEPT": "Concept",
    "communicatieRead.status.INACTIEF": "Inactief",
    "communicatieRead.status.FOUT": "Fout",
    "communicatieRead.origin.STANDAARD": "Standaard",
    "communicatieRead.origin.AANGEPAST": "Aangepast",
    "communicatieRead.category.ASIEL": "Asiel",
    "communicatieRead.category.PENSION": "Pension",
    "communicatieRead.category.FACTUREN": "Facturen",
    "communicatieRead.category.PLANNING": "Planning",
    "communicatieRead.category.DIER": "Dier",
    "communicatieRead.category.RELATIE": "Relatie",
    "communicatieRead.category.ALGEMEEN": "Algemeen",
    "communicatieRead.pagination.range": "%d–%d van %d",
    "communicatieRead.pagination.previous": "Vorige",
    "communicatieRead.pagination.next": "Volgende",
    "communicatieRead.pagination.page": "Pagina %d van %d",
    "communicatieRead.template.title": "Communicatiesjablonen",
    "communicatieRead.template.empty": "Geen sjablonen gevonden.",
    "communicatieRead.template.search.placeholder": "Zoek sjablonen…",
    "communicatieRead.template.filter.search": "Zoeken",
    "communicatieRead.template.edit": "Bewerken",
    "communicatieRead.template.filter.type": "Type",
    "communicatieRead.template.filter.category": "Categorie",
    "communicatieRead.template.filter.status": "Status",
    "communicatieRead.template.column.name": "Naam",
    "communicatieRead.template.column.type": "Type",
    "communicatieRead.template.column.category": "Categorie",
    "communicatieRead.template.column.status": "Status",
    "communicatieRead.template.column.origin": "Herkomst",
    "communicatieRead.template.column.modified": "Laatst gewijzigd",
    "communicatieRead.template.column.modifiedBy": "Gewijzigd door",
    "communicatieRead.template.section.body": "Inhoud",
    "communicatieRead.template.section.settings": "Instellingen",
    "communicatieRead.template.section.versions": "Versiegeschiedenis",
    "communicatieRead.template.body.empty": "(geen inhoud)",
    "communicatieRead.template.field.key": "Sleutel",
    "communicatieRead.template.field.language": "Taal",
    "communicatieRead.template.field.subject": "Onderwerp",
    "communicatieRead.template.field.description": "Omschrijving",
    "communicatieRead.template.field.paperFormat": "Papierformaat",
    "communicatieRead.template.field.orientation": "Oriëntatie",
    "communicatieRead.template.field.margins": "Marges",
    "communicatieRead.template.field.showLogoHeader": "Logo-koptekst",
    "communicatieRead.template.field.showPageNumberFooter": "Paginanummer-voettekst",
    "communicatieRead.template.field.showSignatureBlock": "Ondertekeningsblok",
    "communicatieRead.template.field.sender": "Afzender",
    "communicatieRead.template.field.replyTo": "Antwoordadres",
    "communicatieRead.template.field.cc": "Cc",
    "communicatieRead.template.field.bcc": "Bcc",
    "communicatieRead.template.field.attachmentNote": "Bijlage-notitie",
    "communicatieRead.template.field.sendOnlyOpeningHours": "Alleen tijdens openingstijden versturen",
    "communicatieRead.template.field.logInDossier": "Vastleggen in dossier",
    "communicatieRead.template.field.requiredBlock": "Verplicht blok",
    "communicatieRead.template.field.published": "Gepubliceerd",
    "communicatieRead.template.field.created": "Aangemaakt",
    "communicatieRead.template.field.createdBy": "Aangemaakt door",
    "communicatieRead.template.field.modified": "Gewijzigd",
    "communicatieRead.template.field.modifiedBy": "Gewijzigd door",
    "communicatieRead.template.version.number": "Versie",
    "communicatieRead.template.version.subject": "Onderwerp",
    "communicatieRead.template.version.summary": "Wijzigingssamenvatting",
    "communicatieRead.template.version.changedBy": "Gewijzigd door",
    "communicatieRead.template.version.changedAt": "Gewijzigd op",
    "communicatieRead.template.version.empty": "Geen versies vastgelegd.",
    "communicatieRead.log.title": "Communicatielog",
    "communicatieRead.log.empty": "Geen logregels gevonden.",
    "communicatieRead.log.filter.type": "Type",
    "communicatieRead.log.filter.status": "Status",
    "communicatieRead.log.filter.recipient": "Ontvanger",
    "communicatieRead.log.column.occurredAt": "Datum/tijd",
    "communicatieRead.log.column.type": "Type",
    "communicatieRead.log.column.template": "Template",
    "communicatieRead.log.column.status": "Status",
    "communicatieRead.log.column.subject": "Onderwerp",
    "communicatieRead.log.column.recipient": "Ontvanger",
    "communicatieRead.log.column.related": "Gekoppeld aan",
    "communicatieRead.log.column.sentBy": "Verzonden door",
    "communicatieRead.log.related.dier": "Dier",
    "communicatieRead.log.related.relatie": "Relatie",
    "communicatieRead.log.related.verblijf": "Verblijf",
    "communicatieRead.log.related.factuur": "Factuur",
    "communicatieRead.logType.EMAIL": "E-mail",
    "communicatieRead.logType.PRINT": "Afdruk",
    "communicatieRead.logType.AUTO_HERINNERING": "Auto-herinnering",
    "communicatieRead.logType.TESTMAIL": "Testmail",
    "communicatieRead.logStatus.VERZONDEN": "Verzonden",
    "communicatieRead.logStatus.AFGEDRUKT": "Afgedrukt",
    "communicatieRead.logStatus.CONCEPT": "Concept",
    "communicatieRead.logStatus.MISLUKT": "Mislukt",
    "communicatieRead.media.title": "Mediabibliotheek",
    "communicatieRead.media.empty": "Geen media gevonden.",
    "communicatieRead.media.previewHint": "Voorbeelden zijn nog niet beschikbaar — alleen metadata wordt getoond. Miniaturen volgen in een latere release.",
    "communicatieRead.media.search.placeholder": "Zoek media…",
    "communicatieRead.media.filter.type": "Type",
    "communicatieRead.media.filter.usage": "Gebruik",
    "communicatieRead.media.column.name": "Naam",
    "communicatieRead.media.column.type": "Type",
    "communicatieRead.media.column.usage": "Gebruik toegestaan in",
    "communicatieRead.media.column.fileName": "Bestandsnaam",
    "communicatieRead.media.column.size": "Grootte",
    "communicatieRead.media.column.defaultWidth": "Standaardbreedte",
    "communicatieRead.media.column.created": "Aangemaakt",
    "communicatieRead.mediaType.LOGO": "Logo",
    "communicatieRead.mediaType.AFBEELDING": "Afbeelding",
    "communicatieRead.mediaType.HANDTEKENING": "Handtekening",
    "communicatieRead.mediaType.PICTOGRAM": "Pictogram",
    "communicatieRead.mediaType.QRCODE": "QR-code",
    "communicatieRead.mediaUsage.EMAIL": "E-mail",
    "communicatieRead.mediaUsage.PRINT": "Afdruk",
    "communicatieRead.mediaUsage.BEIDE": "Beide",
    "communicatieRead.media.column.preview": "Voorbeeld",
    "communicatieRead.media.column.actions": "Acties",
    "communicatieRead.media.upload": "Uploaden",
    "communicatieRead.media.edit": "Bewerken",
    "communicatieRead.media.edited": "Het media-item is bijgewerkt.",
    "communicatieRead.media.edit.titel": "Media-item bewerken",
    "communicatieRead.media.edit.bestand": "Bestand: %s (niet te wijzigen — upload een nieuw item om het te vervangen)",
    "communicatieRead.media.edit.naamVerplicht": "Vul een naam in.",
    "communicatieRead.media.edit.breedteOngeldig": "Vul een breedte in pixels in, of laat het leeg.",
    "communicatieRead.media.edit.breedteLeeg": "Leeg = oorspronkelijke grootte",
    "communicatieRead.media.edit.fout": "Het media-item kon niet worden bijgewerkt.",
    "communicatieRead.media.delete": "Verwijderen",
    "communicatieRead.media.uploaded": "Bestand geüpload.",
    "communicatieRead.media.deleted": "Bestand verwijderd.",
    "communicatieRead.media.deleteError": "Kon het bestand niet verwijderen.",
    "communicatieRead.media.upload.title": "Media uploaden",
    "communicatieRead.media.upload.file": "Bestand",
    "communicatieRead.media.upload.name": "Naam",
    "communicatieRead.media.upload.submit": "Uploaden",
    "communicatieRead.media.upload.fileRequired": "Kies eerst een bestand.",
    "communicatieRead.media.upload.error": "Uploaden mislukt.",
    // communicatie (Slice 6) — de WYSIWYG-template-editor (bewerkmodus, veldenpalet, opslaan/publiceren).
    "communicatieEditor.action.edit": "Bewerken",
    "communicatieEditor.action.save": "Concept opslaan",
    "communicatieEditor.action.publish": "Publiceren",
    "communicatieEditor.action.restore": "Standaard herstellen",
    "communicatieEditor.toolbar.label": "Opmaak",
    "communicatieEditor.toolbar.bold": "Vet",
    "communicatieEditor.toolbar.italic": "Cursief",
    "communicatieEditor.toolbar.underline": "Onderstreept",
    "communicatieEditor.toolbar.strike": "Doorhalen",
    "communicatieEditor.toolbar.h1": "Kop 1",
    "communicatieEditor.toolbar.h2": "Kop 2",
    "communicatieEditor.toolbar.paragraph": "Paragraaf",
    "communicatieEditor.toolbar.bulletList": "Opsommingslijst",
    "communicatieEditor.toolbar.orderedList": "Genummerde lijst",
    "communicatieEditor.toolbar.blockquote": "Citaat",
    "communicatieEditor.toolbar.alignLeft": "Links uitlijnen",
    "communicatieEditor.toolbar.alignCenter": "Centreren",
    "communicatieEditor.toolbar.alignRight": "Rechts uitlijnen",
    "communicatieEditor.toolbar.alignJustify": "Uitvullen",
    "communicatieEditor.tegel.link": "Link",
    "communicatieEditor.tegel.image": "Afbeelding",
    "communicatieEditor.tegel.table": "Tabel",
    "communicatieEditor.tegel.signature": "Handtekening",
    "communicatieEditor.tegel.qr": "QR-code",
    "communicatieEditor.tegel.hr": "Lijn",
    "communicatieEditor.tegel.pageBreak": "Pagina-einde",
    "communicatieEditor.toolbar.hr": "Horizontale lijn",
    "communicatieEditor.toolbar.pageBreak": "Pagina-einde",
    "communicatieEditor.tegel.kopVoet": "Kop/voet",
    "communicatieEditor.toolbar.kopVoet": "Koptekst en voettekst: op elke pagina, of een eigen koptekst voor pagina 1",
    "communicatieEditor.kopVoet.kop": "Koptekst — elke pagina",
    "communicatieEditor.kopVoet.kopEerste": "Koptekst — alleen pagina 1",
    "communicatieEditor.kopVoet.voet": "Voettekst — elke pagina",
    "communicatieEditor.kopVoet.add": "Toevoegen",
    "communicatieEditor.kopVoet.edit": "Bewerken",
    "communicatieEditor.kopVoet.remove": "Verwijderen",
    "communicatieEditor.kopVoet.hint": "Komt in de paginamarge en staat op elke pagina. De marge groeit mee met de inhoud.",
    "communicatieEditor.toolbar.signature": "Handtekeningblok",
    "communicatieEditor.toolbar.qr": "QR-code",
    "communicatieEditor.toolbar.undo": "Ongedaan maken",
    "communicatieEditor.toolbar.redo": "Opnieuw",
    "communicatieEditor.toolbar.color": "Tekstkleur",
    "communicatieEditor.toolbar.fill": "Achtergrondkleur (cel of blok)",
    "communicatieEditor.toolbar.noFill": "Geen achtergrondkleur",
    "communicatieEditor.toolbar.indent": "Inspringing vergroten",
    "communicatieEditor.toolbar.outdent": "Inspringing verkleinen",
    "communicatieEditor.toolbar.colorClear": "Kleur verwijderen",
    "communicatieEditor.toolbar.fontFamily": "Lettertype",
    "communicatieEditor.toolbar.fontFamilyDefault": "Standaardlettertype",
    "communicatieEditor.toolbar.fontSize": "Grootte",
    "communicatieEditor.toolbar.fontSizeDefault": "Standaardgrootte",
    "communicatieEditor.toolbar.link": "Hyperlink invoegen / bewerken",
    "communicatieEditor.toolbar.image": "Afbeelding vanaf je computer",
    "communicatieEditor.toolbar.table": "Tabel",
    "communicatieEditor.link.dialogTitle": "Hyperlink",
    "communicatieEditor.link.urlLabel": "Link-URL",
    "communicatieEditor.link.urlPlaceholder": "https://…",
    "communicatieEditor.link.apply": "Toepassen",
    "communicatieEditor.link.remove": "Link verwijderen",
    "communicatieEditor.link.cancel": "Annuleren",
    "communicatieEditor.table.insert": "Tabel invoegen (3×3)",
    "communicatieEditor.table.addRowBefore": "Rij erboven",
    "communicatieEditor.table.addRowAfter": "Rij eronder",
    "communicatieEditor.table.deleteRow": "Rij verwijderen",
    "communicatieEditor.table.addColumnBefore": "Kolom links",
    "communicatieEditor.table.addColumnAfter": "Kolom rechts",
    "communicatieEditor.table.deleteColumn": "Kolom verwijderen",
    "communicatieEditor.table.mergeCells": "Cellen samenvoegen",
    "communicatieEditor.table.splitCell": "Cel splitsen",
    "communicatieEditor.table.toggleHeaderRow": "Koprij aan/uit",
    "communicatieEditor.table.deleteTable": "Tabel verwijderen",
    "communicatieEditor.table.editHeading": "Geselecteerde tabel bewerken",
    "communicatieEditor.palette.title": "Beschikbare velden",
    "communicatieEditor.hulp.titel": "Laat mij je helpen",
    "communicatieEditor.hulp.bezig": "Even denken…",
    "communicatieEditor.hulp.toepassen": "Toepassen",
    "communicatieEditor.hulp.toegepast": "Toegepast op het document.",
    "communicatieEditor.hulp.voorstelKlaar": "Voorstel klaar.",
    "communicatieEditor.hulp.geenVoorstel": "Er kwam geen voorstel terug. Probeer het anders te omschrijven.",
    "communicatieEditor.hulp.tokensKwijt": "In het voorstel raken één of meer {velden} kwijt, dus toepassen kan niet. Probeer een kleinere stap.",
    "communicatieEditor.hulp.mislukt": "Dat lukte niet. Probeer het opnieuw, of gebruik de AI-assistent.",
    "communicatieEditor.hulp.voorbeeld": "bv. ik wil hier een factuurregel hebben",
    "communicatieEditor.hulp.invoegen": "Toevoegen",
    "communicatieEditor.hulp.veldIngevoegd": "%s ingevoegd op de cursor.",
    "communicatieEditor.hulp.ingevoegd": "%s ingevoegd op de cursor.",
    "communicatieEditor.hulp.onbekend": "Dit herken ik nog niet. De blokken hieronder kan ik wel invoegen.",
    "communicatieEditor.palette.search": "Velden filteren…",
    "communicatieEditor.palette.empty": "Geen velden gevonden.",
    "communicatieEditor.preview.title": "Voorbeeld",
    "communicatieEditor.raw.noticeShort": "Afdrukdocument met vaste opmaak",
    "communicatieEditor.raw.notice":
      "Dit is een afdrukdocument met vaste opmaak. Je bewerkt het document zelf; de opmaak blijft precies zoals hij is. Een blok met een stippelrand wordt per record herhaald.",
    "communicatieEditor.raw.sourceLabel": "Documentinhoud",
    "communicatieEditor.raw.readOnlyHint": "Je hebt geen rechten om dit document te bewerken.",
    "communicatieEditor.error.title": "Kan niet publiceren:",
    "communicatieEditor.error.conflict": "Deze template is elders gewijzigd. Herlaad om de nieuwste versie op te halen voordat je opslaat.",
    "communicatieEditor.error.generic": "Er is iets misgegaan.",
    "communicatieEditor.notice.saved": "Concept opgeslagen.",
    "communicatieEditor.notice.published": "Template gepubliceerd.",
    "communicatieEditor.notice.restored": "Hersteld naar de standaardinhoud.",
    "communicatieImport.actie": "Document overnemen",
    "communicatieImport.titel": "Een document overnemen als sjabloon",
    "communicatieImport.formaten": "Een pdf of scan houdt zijn opmaak precies. Uit een Word-bestand (.docx) komen de tekst en de tabellen; lettertypes, kleuren en afbeeldingen blijven achter — sla het op als pdf als de opmaak precies moet kloppen. Het oude .doc kan niet gelezen worden.",
    "communicatieImport.intro": "Upload de brief of het formulier dat je nu met de hand invult. Hij wordt nagebouwd als sjabloon: de waarden die per geval verschillen worden velden, en een blok dat per dier of per kostenregel terugkomt staat er één keer in als herhaalblok.",
    "communicatieImport.kies": "Bestand kiezen",
    "communicatieImport.bezig": "Document wordt nagebouwd…",
    "communicatieImport.bezigUitleg": "Een hele pagina kan een paar minuten duren. Je hoeft niet te wachten: sluit dit venster en werk verder — rechtsonder krijg je een melding als hij klaar is.",
    "communicatieImport.stoppen": "Stoppen",
    "communicatieImport.verderWerken": "Verder werken",
    "communicatieImport.anderSjabloon": "Dit document is nagebouwd voor \"%s\". Je kunt het hier ook overnemen.",
    "communicatieImport.melding.bezig": "Document wordt nagebouwd…",
    "communicatieImport.melding.klaar": "Document nagebouwd",
    "communicatieImport.melding.fout": "Nabouwen mislukt",
    "communicatieImport.melding.voor": "%s · voor %s",
    "communicatieImport.melding.bekijken": "Bekijken",
    "takenAi.melding.bezig": "AI maakt een taakvoorstel…",
    "takenAi.melding.klaar": "Het taakvoorstel is klaar",
    "takenAi.melding.fout": "Het AI-voorstel is mislukt",
    "aiVoorstel.melding.sessie": "Je sessie is verlopen — log opnieuw in",
    "aiVoorstel.melding.bekijken": "Bekijken",
    "aiVoorstel.melding.stoppen": "Stoppen",
    "wizardAi.melding.bezig": "AI bouwt een wizard…",
    "wizardAi.melding.klaar": "De wizard is klaar",
    "wizardAi.melding.fout": "Het bouwen van de wizard is mislukt",
    "communicatieImport.voorbeeld": "Nagebouwd document",
    "communicatieImport.velden": "Herkende velden (%s)",
    "communicatieImport.geenVelden": "Er zijn geen velden herkend — het document is als vaste tekst overgenomen.",
    "communicatieImport.herhaalblokken": "Herhaalblokken (%s)",
    "communicatieImport.herhaalblok.uitleg": "Staat er één keer; wordt afgedrukt per %s",
    "communicatieImport.onbekend": "Genegeerd, geen bestaand veld: %s",
    "communicatieImport.nazien": "Kijk de velden na tegen het origineel voordat je opslaat: wat een gegeven is, is niet altijd aan de opmaak te zien.",
    "communicatieImport.overnemen": "Overnemen",
    "communicatieImport.fout.generiek": "Het document kon niet worden gelezen.",
    "communicatieImport.fout.sessie": "Je sessie is verlopen. Ververs de pagina (F5), log opnieuw in en probeer het nog eens.",
    "communicatieImport.diagnose": "Wat de server zag",
    "communicatieImport.fout.status": "De server weigerde het verzoek (status %s). Probeer het nog eens; blijft het gebeuren, meld het dan.",
    "communicatieEditor.header.title": "Template bewerken",
    "communicatieEditor.header.lastSaved": "Laatst opgeslagen: %s",
    "communicatieEditor.action.more": "Meer acties",
    "communicatieEditor.rail.template": "Sjabloon",
    "communicatieEditor.pane.editor": "Editor",
    "communicatieEditor.pane.preview": "Voorbeeld",
    "communicatieEditor.pane.settings": "Instellingen",
    "communicatieEditor.pane.history": "Geschiedenis",
    "communicatieEditor.pane.historyHint": "Versiegeschiedenis van deze template.",
    "communicatieEditor.pane.settingsReadOnly": "Afdruk- en e-mailinstellingen worden hier beheerd.",
    "communicatieEditor.settings.title": "Template instellingen",
    "communicatieEditor.settings.language": "Taal",
    "communicatieEditor.info.title": "Informatie",
    "communicatieEditor.info.code": "Code",
    "communicatieEditor.info.description": "Beschrijving",
    "communicatieEditor.insert.title": "Invoegen",
    "communicatieEditor.insert.hint": "Klik op een veld om in te voegen",
    "communicatieEditor.preview.hint": "Ingevuld met voorbeeldgegevens, precies zoals het wordt afgedrukt of verstuurd — er wordt niets verzonden.",
    "communicatieEditor.preview.refresh": "Vernieuwen",
    "communicatieEditor.preview.loading": "Voorbeeld wordt opgemaakt…",
    "communicatieEditor.preview.failed": "Het voorbeeld kon niet worden opgemaakt.",
    "communicatieEditor.preview.page": "Pagina %s van %s",
    "communicatieEditor.preview.subject": "Onderwerp",
    "communicatieEditor.validation.none": "Geen problemen gevonden",
    "communicatieEditor.validation.problems": "%s probleem/problemen gevonden",
    "communicatieEditor.testMail.action": "Testmail versturen",
    "communicatieEditor.testMail.title": "Testmail versturen",
    "communicatieEditor.testMail.intro": "Vul een e-mailadres in om een testmail te ontvangen.",
    "communicatieEditor.testMail.recipient": "Aan",
    "communicatieEditor.testMail.placeholder": "naam@voorbeeld.nl",
    "communicatieEditor.testMail.note": "De testmail gebruikt voorbeeldgegevens (Fam. van Diessen, Beertje).",
    "communicatieEditor.testMail.send": "Testmail verzenden",
    "communicatieEditor.testMail.sent": "Testmail verstuurd naar %s.",
    "communicatieEditor.testMail.notConfigured": "Mail is niet geconfigureerd — er is geen testmail verstuurd. Configureer eerst de mailserver in de instellingen.",
    "communicatieEditor.testMail.error.required": "Vul een ontvangeradres in.",
    "communicatieEditor.testMail.error.generic": "Kon de testmail niet versturen.",
    "communicatieEditor.mediaInsert.action": "Afbeelding invoegen (mediabibliotheek)",
    "communicatieEditor.mediaInsert.title": "Afbeelding invoegen uit mediabibliotheek",
    "communicatieEditor.mediaInsert.empty": "Geen afbeeldingen in de mediabibliotheek.",
    "communicatieEditor.mediaInsert.error": "Kon de afbeelding niet laden.",
    "communicatieEditor.letterhead.title": "Briefpapier",
    "communicatieEditor.letterhead.hint": "Pas de kop en voettekst van het afgedrukte document aan. Laat alles leeg om het standaard briefpapier (afgeleid van de vestigingsgegevens) te gebruiken.",
    "communicatieEditor.letterhead.brand": "Merk",
    "communicatieEditor.letterhead.name": "Organisatienaam",
    "communicatieEditor.letterhead.lines": "Adresregels (één per regel)",
    "communicatieEditor.letterhead.footer": "Voettekst",
    "communicatieAi.title": "AI-assistent",
    "communicatieAi.toggle.show": "AI-assistent",
    "communicatieAi.toggle.hide": "AI-assistent sluiten",
    "communicatieAi.strip.friendlier": "Herschrijf vriendelijker",
    "communicatieAi.strip.shorter": "Korter maken",
    "communicatieAi.strip.check": "Controleer velden",
    "communicatieAi.strip.privacy": "Voeg privacyblok toe",
    "communicatieAi.strip.email": "Maak e-mailversie",
    "communicatieAi.apply": "Toepassen",
    "communicatieAi.notPlaceholderSafe": "Dit voorstel laat velden vallen of verandert ze en kan niet veilig worden toegepast.",
    "communicatieAi.busy": "Even bezig…",
    "communicatieAi.error.generic": "De AI-assistent is nu niet beschikbaar.",
    "communicatieAi.rewrite.label": "Herschrijven",
    "communicatieAi.rewrite.friendlier": "Vriendelijker",
    "communicatieAi.rewrite.formal": "Formeler",
    "communicatieAi.rewrite.shorter": "Korter",
    "communicatieAi.rewrite.longer": "Langer",
    "communicatieAi.rewrite.grammar": "Spelling verbeteren",
    "communicatieAi.rewrite.b1": "Eenvoudige (B1) taal",
    "communicatieAi.rewrite.custom": "Eigen instructie…",
    "communicatieAi.rewrite.customPlaceholder": "bv. maak dit geschikt voor een telefonische herinnering",
    "communicatieAi.rewrite.customRun": "Herschrijven",
    "communicatieAi.review.label": "Controleren",
    "communicatieAi.action.check": "Template controleren",
    "communicatieAi.action.suggestFields": "Velden voorstellen",
    "communicatieAi.action.close": "Sluiten",
    "communicatieAi.proposal.title": "Voorstel",
    "communicatieAi.proposal.apply": "Toepassen",
    "communicatieAi.proposal.noProvider": "Er is geen AI-provider ingesteld — dit is een voorbeeldvoorstel zonder echte AI.",
    "communicatieAi.proposal.notApplicable": "Dit voorstel wijzigde of verwijderde variabele velden en kan niet veilig worden toegepast. Annuleer en probeer opnieuw.",
    "communicatieAi.check.title": "Kwaliteitscontrole — score %d/100",
    "communicatieAi.check.allGood": "Geen problemen gevonden.",
    "communicatieAi.suggestFields.title": "Voorgestelde velden",
    "communicatieAi.suggestFields.insert": "Invoegen",
    // Search-migration E3 (FR14–FR16) — verbatim Dutch uit GlobalSearch.java / SearchResultsView.java.
    "search.placeholder": "Zoek dier, relatie, chipnummer, telefoon, factuur of stel een vraag…",
    "search.aria.label": "Zoeken",
    "search.smartPill.label": "Slim zoeken",
    "search.smartPill.title": "Stel een vraag in gewone taal — bv. \"katten met verlopen enting\"",
    "search.tab.all": "Alles",
    "search.tab.animals": "Dieren",
    "search.tab.relations": "Relaties",
    "search.tab.invoices": "Facturen",
    "search.group.animals": "Dieren",
    "search.group.relations": "Relaties",
    "search.group.invoices": "Facturen",
    "search.group.shelters": "Verblijven",
    "search.badge.animal": "Dier",
    "search.badge.relation": "Relatie",
    "search.badge.invoice": "Factuur",
    "search.badge.stay": "Verblijf",
    "search.count.none": "Geen resultaten",
    "search.count.one": "%d resultaat",
    "search.count.many": "%d resultaten",
    "search.minChars": "Type minstens %d tekens om te zoeken.",
    "search.empty": "Geen resultaten gevonden.",
    "search.footer.title": "Alle resultaten bekijken",
    "search.footer.sub": "Bekijk alle %d resultaten in de volledige zoekpagina",
    "search.recent.title": "Recente zoekopdrachten",
    "search.recent.all": "Alle recente zoekopdrachten",
    "search.ai.title": "Slim zoeken: \"%s\"",
    "search.ai.hint":
      "Druk op Enter of klik op Toepassen om deze vraag in gewone taal te laten interpreteren.",
    "search.ai.apply": "Toepassen",
    "search.results.title": "Zoekresultaten",
    "search.results.prompt": "Voer een zoekterm in om resultaten te bekijken.",
    "search.results.empty": "Geen resultaten gevonden voor '%s'.",
    "search.results.aiPending":
      "Slim zoeken (AI-interpretatie) volgt in een vervolgfase; hieronder de gewone resultaten.",
    "search.results.loadFailed": "Het zoeken is mislukt.",
    // Search-migration E4 (FR17–FR23) — verbatim Dutch uit SearchResultsView.java / AISearchPanel.java.
    "zoekresultaten.subtitle.error": "Zoeken kon tijdelijk niet worden uitgevoerd.",
    "zoekresultaten.subtitle.one": "%d resultaat voor '%s'",
    "zoekresultaten.subtitle.many": "%d resultaten voor '%s'",
    "zoekresultaten.empty.noQuery": "Voer een zoekterm in om dieren, relaties en facturen te zoeken.",
    "zoekresultaten.empty.error":
      "Zoeken kon tijdelijk niet worden uitgevoerd. Probeer het opnieuw of wis je zoekterm.",
    "zoekresultaten.empty.facetsEmpty": "Geen resultaten binnen de gekozen filters.",
    "zoekresultaten.action.clearQuery": "Zoekterm wissen",
    "zoekresultaten.action.clearFilters": "Wis filters",
    "zoekresultaten.filter.type": "Type:",
    "zoekresultaten.filter.period": "Periode:",
    "zoekresultaten.sort.prefix": "Sorteren op",
    "zoekresultaten.period.all": "Alles",
    "zoekresultaten.period.week": "Afgelopen week",
    "zoekresultaten.period.month": "Afgelopen maand",
    "zoekresultaten.period.year": "Afgelopen jaar",
    "zoekresultaten.filters.title": "Filters",
    "zoekresultaten.filters.clearAll": "Wis alles",
    "zoekresultaten.tabs.label": "Resultaten filteren op type",
    "zoekresultaten.section.typeResult": "Type resultaat",
    "zoekresultaten.section.species": "Diersoort",
    "zoekresultaten.section.relationRole": "Rol relatie",
    "zoekresultaten.section.sort": "Sorteren",
    "zoekresultaten.sort.relevance": "Relevantie",
    "zoekresultaten.sort.newest": "Nieuwste eerst",
    "zoekresultaten.sort.oldest": "Oudste eerst",
    "zoekresultaten.sort.name_az": "Naam A-Z",
    "zoekresultaten.animalStatus.in_care": "In opvang",
    "zoekresultaten.animalStatus.foster": "Bij pleeggezin",
    "zoekresultaten.animalStatus.placed": "Geplaatst",
    "zoekresultaten.animalStatus.checked_out": "Uitgeboekt",
    "zoekresultaten.animalStatus.deceased": "Overleden",
    "zoekresultaten.animalStatus.beschikbaar": "Beschikbaar",
    "zoekresultaten.species.dog": "Hond",
    "zoekresultaten.species.cat": "Kat",
    "zoekresultaten.species.rabbit": "Konijn",
    "zoekresultaten.species.rodent": "Knaagdier",
    "zoekresultaten.species.bird": "Vogel",
    "zoekresultaten.species.other": "Overig",
    "zoekresultaten.relationType.person": "Persoon",
    "zoekresultaten.relationType.organization": "Organisatie",
    "zoekresultaten.relationRole.eigenaar": "Eigenaar",
    "zoekresultaten.relationRole.vinder": "Vinder",
    "zoekresultaten.relationRole.brenger": "Brenger",
    "zoekresultaten.relationRole.pleeggezin": "Pleeggezin",
    "zoekresultaten.relationRole.donateur": "Donateur",
    "zoekresultaten.relationRole.dierenambulance": "Dierenambulance",
    "zoekresultaten.relationRole.dierenartspraktijk": "Dierenartspraktijk",
    "zoekresultaten.relationRole.leverancier": "Leverancier",
    "zoekresultaten.invoiceStatus.open": "Openstaand",
    "zoekresultaten.invoiceStatus.paid": "Betaald",
    "zoekresultaten.invoiceStatus.expired": "Vervallen",
    "zoekresultaten.invoiceStatus.credited": "Gecrediteerd",
    "zoekresultaten.invoiceStatus.cancelled": "Geannuleerd",
    "zoekresultaten.chip.query": "Zoekterm: %s",
    "zoekresultaten.chip.tab": "Tab: %s",
    "zoekresultaten.chip.hidden": "Niet getoond: %s",
    "zoekresultaten.chip.animalStatus": "Verblijfstatus: %s",
    "zoekresultaten.chip.species": "Diersoort: %s",
    "zoekresultaten.chip.relationType": "Relatietype: %s",
    "zoekresultaten.chip.relationRole": "Rol: %s",
    "zoekresultaten.chip.invoiceStatus": "Factuurstatus: %s",
    "zoekresultaten.chip.minDays": "Verblijfsduur: > %d dagen",
    "zoekresultaten.chip.remove": "Filter verwijderen: %s",
    "zoekresultaten.showMore.dieren": "Bekijk alle dieren",
    "zoekresultaten.showMore.relaties": "Bekijk alle relaties",
    "zoekresultaten.showMore.facturen": "Bekijk alle facturen",
    "zoekresultaten.section.dieren.emptyNone": "Geen dieren gevonden voor '%s'.",
    "zoekresultaten.section.dieren.emptyFiltered": "Geen dieren binnen de gekozen filters.",
    "zoekresultaten.section.relaties.emptyNone": "Geen relaties gevonden voor '%s'.",
    "zoekresultaten.section.relaties.emptyFiltered": "Geen relaties binnen de gekozen filters.",
    "zoekresultaten.section.facturen.emptyNone": "Geen facturen gevonden voor '%s'.",
    "zoekresultaten.section.facturen.emptyFiltered": "Geen facturen binnen de gekozen filters.",
    "zoekresultaten.section.verblijven.emptyNone": "Geen verblijven gevonden voor '%s'.",
    "zoekresultaten.section.verblijven.emptyFiltered": "Geen verblijven binnen de gekozen filters.",
    "zoekresultaten.card.chip": "Chip: %s",
    "zoekresultaten.recent.clearAll": "Alles wissen",
    "zoekresultaten.quickActions.title": "Snelle acties",
    "zoekresultaten.quickActions.newAnimal": "Nieuw dier registreren",
    "zoekresultaten.quickActions.newRelation": "Nieuwe relatie toevoegen",
    "zoekresultaten.quickActions.newInvoice": "Factuur aanmaken",
    "zoekresultaten.quickActions.newStay": "Verblijf aanmaken",
    "zoekresultaten.tip.title": "Tip",
    "zoekresultaten.tip.text":
      'Gebruik aanhalingstekens voor een exacte zoekopdracht, bijvoorbeeld "Kitten Beertje".',
    "zoekresultaten.ai.title": "Slim zoeken: %s",
    "zoekresultaten.ai.interpretedAs": "Geïnterpreteerd als:",
    "zoekresultaten.ai.usedData": "Gebruikte data:",
    "zoekresultaten.ai.unsupported": "Nog niet ondersteund: %s",
    "zoekresultaten.samenvatting.totaal": "Totaal",
    "zoekresultaten.samenvatting.aantal": "Aantal",
    "zoekresultaten.samenvatting.toonOnderliggend": "Toon de onderliggende records",
    "zoekresultaten.samenvatting.onder": "Records onder",
    "zoekresultaten.samenvatting.terug": "Terug naar de samenvatting",
    "zoekresultaten.samenvatting.exportCsv": "Exporteren naar CSV",
    "zoekresultaten.samenvatting.gemiddelde": "Gemiddelde",
    "zoekresultaten.samenvatting.zonderWaarde": "records hadden geen waarde en tellen niet mee",
    "menu.dataInsight": "Data & Insight",
    "dataInsight.title": "Data & Insight",
    "dataInsight.onderdeel": "Onderdeel",
    "dataInsight.uitsplitsen": "Uitsplitsen naar",
    "dataInsight.gebied": "Gemeente of woonplaats",
    "dataInsight.gemeenten": "Gemeenten",
    "dataInsight.woonplaatsen": "Woonplaatsen",
    "dataInsight.ouderDan": "ouder dan",
    "dataInsight.jongerDan": "jonger dan",
    "dataInsight.ouderDanEenheid": "Eenheid van ouder dan",
    "dataInsight.jongerDanEenheid": "Eenheid van jonger dan",
    "dataInsight.leeftijdWeken": "weken",
    "dataInsight.leeftijdMaanden": "maanden",
    "dataInsight.leeftijdJaren": "jaren",
    "dataInsight.vanDatum": "Van datum",
    "dataInsight.totDatum": "Tot datum",
    "dataInsight.periodeSnel": "Snelkeuzes voor de periode",
    "dataInsight.periodeDezeMaand": "Deze maand",
    "dataInsight.periodeDitKwartaal": "Dit kwartaal",
    "dataInsight.periodeDitJaar": "Dit jaar",
    "dataInsight.periodeLaatste12": "Laatste 12 maanden",
    "dataInsight.periodeVorigJaar": "Vorig jaar",
    "dataInsight.periodeVijfJaar": "Laatste 5 jaar",
    "dataInsight.groepHuidige": "Huidige vestiging",
    "dataInsight.groepVestigingen": "Vestigingen",
    "dataInsight.welkeVestigingen": "Welke",
    "dataInsight.huidigeVestiging": "Huidige vestiging",
    "dataInsight.gekozen": "gekozen",
    "dataInsight.groepDiersoort": "Diersoort",
    "dataInsight.groepGemeente": "Gemeente (waar gevonden)",
    "dataInsight.trendlijn": "Trendlijn Landelijk",
    "dataInsight.trendlijnNietBeschikbaar": "Landelijke cijfers staan niet in deze database, dus deze vergelijking is hier niet te tekenen.",
    "dataInsight.periodeAs": "Periode",
    "dataInsight.aantalDieren": "Aantal dieren",
    "dataInsight.diersoort": "Diersoort",
    "dataInsight.alleSoorten": "Alle diersoorten",
    "dataInsight.alleGemeenten": "Alle gemeenten",
    "dataInsight.leeftijd": "Leeftijd",
    "dataInsight.geenOnderdelen": "De lijst met onderdelen kon niet worden geladen. Ververs de pagina; blijft het, dan is de server niet bereikbaar.",
    "dataInsight.leeftijdOnbekend": "Dieren zonder geboortedatum hebben geen leeftijd en vallen buiten deze grens.",
    "dataInsight.periode": "Periode",
    "dataInsight.vanJaar": "Van jaar",
    "dataInsight.totJaar": "Tot jaar",
    "dataInsight.tot": "t/m",
    "dataInsight.eenheid": "Eenheid",
    "dataInsight.perJaar": "Per jaar",
    "dataInsight.perMaand": "Per maand",
    "dataInsight.perKwartaal": "Per kwartaal",
    "dataInsight.perWeek": "Per week",
    "dataInsight.perDag": "Per dag",
    "dataInsight.kgPerKwartaal": "Gemiddeld per kwartaal",
    "dataInsight.kgPerWeek": "Gemiddeld per week",
    "dataInsight.kgPerDag": "Gemiddeld per dag",
    "dataInsight.tovVorigJaar": "t.o.v. dezelfde periode vorig jaar",
    "dataInsight.geenVergelijking": "geen vergelijkbare periode",
    "dataInsight.tabAi": "Vraag AI",
    "dataInsight.tabStandaard": "Standaard analyses",
    "dataInsight.tabKaart": "Herkomstkaart",
    "herkomst.titel": "Waar komen de dieren vandaan?",
    "herkomst.uitleg": "Per opname de gemeente die als vindplaats is ingevuld: bij een zwerver waar hij gevonden is, bij een afstand waar de eigenaar woont.",
    "herkomst.periode": "Periode",
    "herkomst.laatste12": "Laatste 12 maanden",
    "herkomst.ditJaar": "Dit jaar",
    "herkomst.vorigJaar": "Vorig jaar",
    "herkomst.laatste5": "Laatste 5 jaar",
    "herkomst.van": "Van",
    "herkomst.tot": "t/m",
    "herkomst.totDatum": "Tot en met",
    "herkomst.diersoort": "Diersoort",
    "herkomst.alleSoorten": "Alle diersoorten",
    "herkomst.opnamesoort": "Soort opname",
    "herkomst.alleOpnamesoorten": "Alle soorten opname",
    "herkomst.vestigingen": "Vestigingen",
    "herkomst.huidigeVestiging": "Huidige vestiging",
    "herkomst.niveau": "Detail",
    "herkomst.perGemeente": "Per gemeente",
    "herkomst.perPostcode": "Per postcodegebied",
    "herkomst.weergave": "Weergave",
    "herkomst.warmte": "Warmte",
    "herkomst.bollen": "Bollen",
    "herkomst.opnames": "opnames",
    "herkomst.totaal": "Opnames in deze periode",
    "herkomst.opDeKaart": "Op de kaart",
    "herkomst.meesteHerkomst": "Meeste dieren uit",
    "herkomst.postcode": "Postcode",
    "herkomst.zonderGemeente": "opnames zonder gemeente staan niet op de kaart.",
    "herkomst.zonderPostcode": "opnames zonder postcode staan niet op de kaart.",
    "herkomst.nietGevonden": "opnames komen uit een plaats die niet op de kaart te vinden is (bijvoorbeeld een opgeheven gemeente).",
    "herkomst.nogOpzoeken": "plaatsen worden nog opgezocht; de kaart vult zich vanzelf aan.",
    "herkomst.leeg": "Geen opnames met een vindplaats in deze keuze.",
    "herkomst.weinig": "weinig",
    "herkomst.veel": "veel",
    "herkomst.postcodeUitleg": "Per postcode: bij een zwerver de postcode van de vindplaats (die is niet altijd ingevuld), bij een afstand, retour of uitwisseling die van de relatie die het dier bracht.",
    "herkomst.herstel": "Filters herstellen",
    "herkomst.gekozen": "gekozen",
    "herkomst.alleVestigingen": "Alle vestigingen",
    "herkomst.richting": "Opname of vertrek",
    "herkomst.opname": "Opname",
    "herkomst.vertrek": "Vertrek",
    "herkomst.soortOpname": "Soort opname",
    "herkomst.soortVertrek": "Soort vertrek",
    "herkomst.alleSoortenKort": "alle soorten",
    "herkomst.geenSoorten": "Geen soorten gevonden.",
    "herkomst.titelVertrek": "Waar gaan de dieren naartoe?",
    "herkomst.uitlegVertrek": "Per vertrek de woonplaats of postcode van de relatie bij wie het dier terechtkwam: de nieuwe eigenaar, de eigenaar bij een retour, of de opvang bij een uitwisseling.",
    "herkomst.totaalVertrek": "Vertrekken in deze periode",
    "herkomst.meesteBestemming": "Meeste dieren naar",
    "herkomst.vertrekken": "vertrekken",
    "herkomst.zonderAdres": "vertrekken zonder adres staan niet op de kaart, zoals bij euthanasie of overlijden.",
    "herkomst.zonderPostcodeVertrek": "vertrekken zonder postcode staan niet op de kaart.",
    "herkomst.nietGevondenVertrek": "vertrekken gaan naar een plaats die niet op de kaart te vinden is.",
    "herkomst.leegVertrek": "Geen vertrekken met een adres in deze keuze.",
    "herkomst.excel": "Naar Excel",
    "dataInsight.verdelingKop": "Verdeling",
    "dataInsight.eenheidDieren": "dieren",
    "insights.veelgebruikt": "Veelgebruikte analyses",
    "insights.geenSnelkoppelingen": "Geen snelkoppelingen beschikbaar.",
    "dataInsight.recenteKop": "Meest recente binnenkomsten",
    "dataInsight.recenteSub": "De {n} meest recent geregistreerde binnenkomsten",
    "dataInsight.kolomRegistratie": "Registratienummer",
    "dataInsight.kolomRas": "Ras",
    "dataInsight.kolomGeslacht": "Geslacht",
    "dataInsight.kolomHerkomst": "Herkomst",
    "dataInsight.kolomDatum": "Datum binnenkomst",
    "dataInsight.jaar": "jaar",
    "dataInsight.jaren": "jaar",
    "dataInsight.cumulatief": "Cumulatief",
    "dataInsight.filter": "Filter",
    "dataInsight.bezig": "Bezig…",
    "dataInsight.geenPeriode": "Dit cijfer is een stand van nu; een periode heeft er geen invloed op.",
    "dataInsight.eigenVraag": "Of stel je eigen vraag",
    "dataInsight.uitleg": "Ontdek inzichten, stel vragen en maak betere beslissingen.",
    "dataInsight.heroTitel": "Vraag alles over je organisatie",
    "dataInsight.heroSub": "Stel je vraag in gewone taal. Wij maken er een analyse van die je kunt nakijken en bijstellen.",
    "dataInsight.filterKop": "Dit is het cijfer dat je ziet",
    "dataInsight.filterSub": "Controleer de definitie en stel de filters bij waar dat nodig is.",
    "dataInsight.filtersHerstellen": "Filters herstellen",
    "dataInsight.kgTotaal": "Totaal",
    "dataInsight.kgPerJaar": "Gemiddeld per jaar",
    "dataInsight.kgPerMaand": "Gemiddeld per maand",
    "dataInsight.kgOverPeriodes": "over {n} periodes",
    "dataInsight.kgTrend": "Ten opzichte van de vorige periode",
    "samenvatting.weergave": "Weergave",
    "samenvatting.gestapeld": "Gestapeld",
    "samenvatting.staaf": "Staaf",
    "samenvatting.lijn": "Lijn",
    "samenvatting.tabel": "Tabel",
    "samenvatting.onderliggend": "Onderliggende gegevens",
    "dataInsight.tipKop": "Tip van de dag",
    "dataInsight.tipTekst": "Weet je niet hoe je het moet vragen? Begin met een vraag over één ding en bak het daarna af met de filters.",
    "dataInsight.tipVraag": "Wat is de gemiddelde verblijfsduur per diersoort?",
    "dataInsight.placeholder": "Bijvoorbeeld: hoeveel dieren kwamen er per maand binnen?",
    "dataInsight.vraagLabel": "Je vraag",
    "dataInsight.stelVraag": "Vraag AI",
    "dataInsight.voorbeelden": "Voorbeeldvragen:",
    "dataInsight.resultaten": "resultaten",
    "dataInsight.wedervraag": "Kun je het anders zeggen? Ik weet niet zeker wat ik moet tellen.",
    "dataInsight.nietBegrepen": "Niet meegenomen",
    "dataInsight.nietIngeschakeld": "Data & Insight is op deze omgeving niet ingeschakeld. Neem contact op met Docasoft om het aan te zetten.",
    "dataInsight.nietBeschikbaar": "Dit scherm is niet beschikbaar voor jouw account, of de server is niet bereikbaar.",
    "zoekresultaten.samenvatting.exportExcel": "Exporteren naar Excel",
    "zoekresultaten.samenvatting.exportBezig": "Bezig…",
    "zoekresultaten.samenvatting.exportFout": "Het exportbestand kon niet worden gemaakt",
    "insights.kop": "Bewaarde analyses",
    "insights.nogGeen": "Nog niets bewaard.",
    "insights.bewaren": "Deze analyse bewaren",
    "insights.naam": "Naam",
    "insights.naamPlaceholder": "bijv. Maandelijkse instroom zwerfdieren",
    "insights.zichtbaarheid": "Zichtbaarheid",
    "insights.zicht.prive": "Alleen voor mij",
    "insights.zicht.vestiging": "Delen met de vestiging",
    "insights.zicht.organisatie": "Delen met de organisatie",
    "insights.verwijderen": "Verwijderen",
    "insights.foutOnbekend": "Dat lukte niet.",
    "zoekresultaten.ai.notExecuted": "Deze vraag wordt niet uitgevoerd.",
    "zoekresultaten.ai.unavailable": "Slim zoeken is tijdelijk niet beschikbaar.",
    "zoekresultaten.aiMode.structured_filter": "Geïnterpreteerd als",
    "zoekresultaten.aiMode.partial": "Geïnterpreteerd als (deels)",
    "zoekresultaten.aiMode.clarification": "Hulp nodig",
    "zoekresultaten.aiMode.how_to": "Wegwijzer",
    "zoekresultaten.howTo.ganaar": "Ga naar dit scherm",
    "zoekresultaten.howTo.laatZien": "Laat het me zien",
    "zoekresultaten.howTo.watBedoelJe": "Wat bedoel je?",
    "zoekresultaten.howTo.andereKeuze": "Nee, ik bedoelde iets anders",
    "rondleiding.stapVan": "Stap %d van %d",
    "rondleiding.volgende": "Volgende",
    "rondleiding.vorige": "Vorige",
    "rondleiding.klaar": "Klaar",
    "rondleiding.sluiten": "Sluiten",
    "rondleiding.nietGevonden": "Dit staat nog niet op je scherm — klap de groep open of open het onderdeel zelf. Zodra het verschijnt wijs ik het aan; je kunt gewoon doorklikken.",
    "zoekresultaten.aiMode.out_of_scope": "Buiten scope",
    "zoekresultaten.aiMode.rejected": "Geweigerd",
    "zoekresultaten.pagination.prev": "Vorige",
    "zoekresultaten.pagination.next": "Volgende",
    "zoekresultaten.pagination.perPage": "%d per pagina",
    // Sidebar-menu — exact Dutch labels uit de Jmix `menu.xml` / `messages_nl.properties`.
    "menu.application.title": "Applicatie",
    "menu.producten.title": "Producten",
    "picker.title": "Product of tarief toevoegen",
    "picker.intro": "Kies een product of tarief uit een van de beschikbare bronnen.",
    "picker.bronnen": "Bronnen",
    "picker.bron.alle": "Alle bronnen",
    "picker.bron.producten": "Producten & Diensten",
    "picker.bron.pension": "Pension",
    "picker.bron.eerderPension": "Eerder gebruikt bij pension",
    "picker.bron.creche": "Crèche",
    "picker.bron.asiel": "Asiel",
    "picker.bron.ambulance": "Dierenambulance",
    "picker.bron.crematie": "Crematie",
    "picker.bron.vervoer": "Crematie vervoer",
    "picker.hint.title": "Één plek, alle bronnen",
    "picker.hint.body": "Zoek en voeg regels toe uit je product- en tariefbronnen.",
    "picker.zoek": "Zoek op product, code of categorie...",
    "picker.categorie": "Categorie",
    "picker.categorie.alle": "Alle categorieën",
    "picker.sorteren": "Sorteren op",
    "picker.info.bron": "Bron",
    "picker.info.standaardprijs": "Standaard prijs (incl. btw)",
    "picker.info.btw": "BTW-percentage",
    "picker.aantalMinder": "Eén minder",
    "picker.aantalMeer": "Eén meer",
    "picker.tekens": "%s / 255 tekens",
    "picker.totaalOpbouw": "%s × %s (incl. btw)",
    "picker.sorteren.meest": "Meest gebruikt",
    "picker.sorteren.naamAf": "Naam Z → A",
    "picker.sorteren.naam": "Naam A → Z",
    "picker.sorteren.prijsOp": "Prijs (laag → hoog)",
    "picker.sorteren.prijsAf": "Prijs (hoog → laag)",
    "picker.kolom.omschrijving": "Omschrijving",
    "picker.kolom.categorie": "Categorie",
    "picker.kolom.prijs": "Prijs incl. btw",
    "picker.kolom.btw": "Btw",
    "picker.kolom.bron": "Bron",
    "picker.resultaten": "%s–%s van %s resultaten",
    "picker.geenResultaten": "Geen resultaten",
    "picker.perPagina": "%s per pagina",
    "picker.tip": "Tip: gebruik filters en zoeken om snel de juiste regel te vinden.",
    "picker.leeg": "Geen producten of tarieven gevonden.",
    "picker.geenRegels": "Geen product of tarief dat hierbij past.",
    "picker.laadFout": "De product- en tarievenlijst kon niet worden geladen.",
    "picker.leegBron": "Deze bron levert nog geen regels aan.",
    "picker.gekozen": "Geselecteerde regel",
    "picker.gekozen.leeg": "Selecteer een product of tarief om hier de regel samen te stellen.",
    "picker.aantal": "Aantal",
    "picker.prijs": "Prijs incl. btw",
    "picker.regelTotaal": "Regeltotaal",
    "picker.btwRegel": "Btw %s%",
    "picker.toevoegen": "Toevoegen",
    "menu.financieel.title": "Financieel",
    "financieel.title": "Factuuroverzichten",
    "financieel.tab.overzichten": "Overzichten",
    "financieel.tab.facturen": "Facturen",
    "financieel.tab.betalingen": "Betalingen",
    "financieel.tab.omzet": "Omzet",
    "financieel.tab.kasboek": "Kas uitgaven",
    "financieel.tab.dagafsluiting": "Dagafsluiting",
    "financieel.tab.soon": "Dit onderdeel wordt nog gebouwd.",
    "financieel.overzicht.title": "Factuuroverzicht",
    "financieel.overzicht.subtitle": "Overzicht van alle facturen en betaalstatussen",
    "financieel.kpi.omzet": "Omzet",
    "financieel.kpi.openstaand": "Openstaand",
    "financieel.kpi.betaald": "Betaald",
    "financieel.kpi.vervallen": "Vervallen",
    "financieel.kpi.totaal": "Totaal",
    "financieel.kpi.scope": "De bedragen tellen de facturen op deze pagina; het aantal is het totaal van de zoekopdracht.",
    "financieel.filter.zoek": "Zoek op factuurnummer, relatie of dier...",
    "financieel.filter.periode": "Periode",
    "financieel.filter.status": "Status",
    "financieel.filter.vestiging": "Vestiging",
    "financieel.filter.onderdeel": "Onderdeel",
    "financieel.filter.actief": "Actief",
    "financieel.filter.inactief": "Inactief",
    "financieel.sorteren": "Sorteren op",
    "financieel.sorteren.nieuwste": "Nieuwste eerst",
    "financieel.sorteren.oudste": "Oudste eerst",
    "financieel.sorteren.bedrag": "Hoogste bedrag",
    "financieel.sorteren.openstaand": "Meest openstaand",
    "financieel.filter.bedragVanaf": "Bedrag vanaf",
    "financieel.filter.wissen": "Filters wissen",
    "financieel.filter.alle": "Alle",
    "financieel.filter.alleenOpenstaand": "Toon alleen openstaande facturen",
    "financieel.periode.maand": "Deze maand",
    "financieel.periode.kwartaal": "Dit kwartaal",
    "financieel.periode.jaar": "Dit jaar",
    "financieel.periode.alles": "Alles",
    "financieel.periode.eigen": "Eigen periode",
    "financieel.periode.van": "Van",
    "financieel.periode.tot": "Tot",
    "financieel.resultaten": "%s resultaten gevonden",
    "financieel.leeg": "Geen facturen binnen deze filters.",
    "financieel.weergave": "Weergave",
    "financieel.weergave.tabel": "Tabel",
    "financieel.weergave.klein": "Kleine tegels",
    "financieel.weergave.groot": "Grote tegels",
    "financieel.kolom.nummer": "Factuurnummer",
    "financieel.kolom.datum": "Datum",
    "financieel.kolom.relatie": "Relatie",
    "financieel.kolom.dier": "Dier",
    "financieel.kolom.onderdeel": "Onderdeel",
    "financieel.kolom.vestiging": "Vestiging",
    "financieel.kolom.vervaldatum": "Vervaldatum",
    "financieel.kolom.status": "Status",
    "financieel.kolom.totaal": "Totaal",
    "financieel.kolom.betaald": "Betaald",
    "financieel.kolom.openstaand": "Openstaand",
    "financieel.actie.openen": "Openen",
    "financieel.actie.pdf": "PDF downloaden",
    "financieel.concept": "Concept",
    "financieel.kolom.eersteHerinnering": "1e herinnering",
    "financieel.kolom.tweedeHerinnering": "2e herinnering",
    "financieel.kolom.incassoDatum": "Incassodatum",
    "financieel.kolom.klantId": "ID nr. klant",
    "financieel.kolom.klantBedrijf": "Bedrijf",
    "financieel.kolom.klantAdres": "Adres",
    "financieel.kolom.klantPostcode": "Postcode",
    "financieel.kolom.klantWoonplaats": "Woonplaats",
    "financieel.kolom.klantLand": "Land",
    "financieel.kolom.klantTelefoon": "Klant telnr.",
    "financieel.kolom.klantMobiel": "Klant mobnr.",
    "financieel.kolom.klantEmail": "E-mailadres",
    "financieel.kolom.debiteurnummer": "Debiteurnummer",
    "financieel.kolom.externeReferentie": "Boekingsnr.",
    "financieel.kolom.exclBtw": "Excl. btw",
    "financieel.kolom.btw": "Btw",
    "betalingen.overzicht.title": "Betalingsoverzicht",
    "betalingen.overzicht.subtitle": "Overzicht van alle betalingen en betaalstatussen",
    "betalingen.kpi.ontvangen": "Ontvangen",
    "betalingen.kpi.openstaand": "Openstaand",
    "betalingen.kpi.terugbetaald": "Terugbetaald",
    "betalingen.kpi.geannuleerd": "Geannuleerd",
    "betalingen.filter.zoek": "Zoek op betaalreferentie, factuur of relatie...",
    "betalingen.filter.betaalmethode": "Betaalmethode",
    "betalingen.filter.alleenOpenstaand": "Toon alleen openstaande betalingen",
    "betalingen.leeg": "Geen betalingen gevonden met deze filters.",
    "betalingen.kolom.referentie": "Betaalreferentie",
    "betalingen.kolom.factuur": "Factuur",
    "betalingen.kolom.betaalmethode": "Betaalmethode",
    "betalingen.kolom.soort": "Soort",
    "betalingen.kolom.bedrag": "Bedrag",
    "betalingen.kolom.factuurTotaal": "Factuurtotaal",
    "betalingen.kolom.factuurBetaald": "Betaald",
    "betalingen.kolom.factuurOpenstaand": "Openstaand",
    "betalingen.kolom.dier": "Dier",
    "betalingen.kolom.onderdeel": "Onderdeel",
    "betalingen.kolom.vestiging": "Vestiging",
    "betalingen.kolom.vervaldatum": "Vervaldatum",
    "betalingen.status.ONTVANGEN": "Ontvangen",
    "betalingen.status.OPENSTAAND": "Openstaand",
    "betalingen.status.TERUGBETAALD": "Terugbetaald",
    "betalingen.status.GEANNULEERD": "Geannuleerd",
    "betalingen.actie.factuur": "Factuur openen",
    "omzet.title": "Omzetoverzicht",
    "omzet.subtitle": "Overzicht van omzet per grootboekrekening, periode en vestiging",
    "omzet.kpi.totaal": "Totale omzet",
    "omzet.kpi.exclBtw": "Omzet excl. btw",
    "omzet.kpi.btw": "BTW",
    "omzet.kpi.boekingen": "Aantal boekingen",
    "omzet.kpi.gemiddeld": "Gem. boeking",
    "omzet.filter.zoek": "Zoek op grootboekrekening, omschrijving of onderdeel...",
    "omzet.filter.grootboek": "Grootboekrekening",
    "omzet.filter.groeperen": "Groeperen op",
    "omzet.filter.weergave": "Weergave",
    "omzet.filter.alleenMetBoekingen": "Toon alleen omzet met boekingen",
    "omzet.groep.grootboek": "Grootboekrekening",
    "omzet.groep.vestiging": "Vestiging",
    "omzet.groep.onderdeel": "Onderdeel",
    "omzet.groep.maand": "Maand",
    "omzet.weergave.beide": "Excl. + incl. btw",
    "omzet.weergave.excl": "Alleen excl. btw",
    "omzet.weergave.incl": "Alleen incl. btw",
    "omzet.kolom.grootboek": "Grootboekrekening",
    "omzet.kolom.vestiging": "Vestiging",
    "omzet.kolom.onderdeel": "Onderdeel",
    "omzet.kolom.maand": "Maand",
    "omzet.kolom.omschrijving": "Omschrijving",
    "omzet.kolom.exclBtw": "Omzet excl. btw",
    "omzet.kolom.btw": "BTW",
    "omzet.kolom.inclBtw": "Omzet incl. btw",
    "omzet.kolom.aantal": "Aantal boekingen",
    "omzet.kolom.verschil": "Verschil",
    "omzet.sorteren.hoogste": "Hoogste omzet",
    "omzet.sorteren.laagste": "Laagste omzet",
    "omzet.sorteren.boekingen": "Meeste boekingen",
    "omzet.sorteren.sleutel": "Grootboekrekening",
    "omzet.perMaand": "Omzet per maand",
    "omzet.analyse": "Bekijk volledige analyse",
    "omzet.terug": "Terug naar overzicht",
    "omzet.analyse.titel": "Omzettrend per maand",
    "omzet.analyse.titelRekening": "Omzettrend %s %s",
    "omzet.actie.trend": "Trend bekijken",
    "omzet.actie.boekingen": "Boekingen bekijken",
    "omzet.boekingen.titel": "Boekingen %s",
    "omzet.boekingen.regel": "Regel",
    "omzet.boekingen.leeg": "Geen boekingen gevonden.",
    "omzet.zonderRekening": "Geen grootboekrekening",
    "omzet.trendBeperkt": "Laatste %s maanden",
    "omzet.leeg": "Geen omzet in deze periode.",
    "kasboek.title": "Kas uitgaven",
    "kasboek.subtitle": "Boek inkomsten en uitgaven in kas",
    "kasboek.nieuw": "Nieuwe boeking",
    "kasboek.kpi.saldo": "Kas saldo",
    "kasboek.kpi.laatsteMutatie": "Laatste mutatie %s",
    "kasboek.kpi.geenMutatie": "Nog geen mutaties",
    "kasboek.kpi.inkomstenVandaag": "Inkomsten vandaag",
    "kasboek.kpi.uitgavenVandaag": "Uitgaven vandaag",
    "kasboek.kpi.boekingen": "%s boekingen",
    "kasboek.kpi.boekingenLabel": "Boekingen",
    "kasboek.kpi.waarvanVerwerkt": "%s verwerkt",
    "kasboek.open": "Open",
    "kasboek.recente": "Recente boekingen",
    "kasboek.filter.van": "Periode van",
    "kasboek.filter.tot": "tot",
    "kasboek.filter.kas": "Kas",
    "kasboek.filter.alleKassen": "Alle kassen",
    "kasboek.filter.type": "Type",
    "kasboek.filter.zoek": "Zoek in omschrijving of referentie...",
    "kasboek.soort.INKOMST": "Inkomst",
    "kasboek.soort.UITGAVE": "Uitgave",
    "kasboek.kolom.datum": "Datum",
    "kasboek.kolom.type": "Type",
    "kasboek.kolom.omschrijving": "Omschrijving",
    "kasboek.kolom.kas": "Kas",
    "kasboek.kolom.bedrag": "Bedrag",
    "kasboek.kolom.saldo": "Saldo",
    "kasboek.leeg": "Geen boekingen in deze periode.",
    "kasboek.resultaten": "%s-%s van %s resultaten",
    "kasboek.perPagina": "Per pagina",
    "kasboek.perPaginaN": "%s per pagina",
    "kasboek.actie.wijzigen": "Boeking wijzigen",
    "kasboek.dialoog.nieuw": "Nieuwe kasboeking",
    "kasboek.dialoog.wijzig": "Kasboeking wijzigen",
    "kasboek.dialoog.opslaan": "Boeking opslaan",
    "kasboek.veld.datum": "Datum",
    "kasboek.veld.tegenrekening": "Relatie / Tegenrekening",
    "kasboek.veld.referentie": "Referentie",
    "kasboek.veld.notitie": "Notitie",
    "kasboek.veld.geenRekening": "Geen grootboekrekening",
    "kasboek.veld.rekeningZoek": "Zoek op nummer of omschrijving...",
    "kasboek.veld.rekeningGeen": "Geen rekening gevonden.",
    "kasboek.veld.direct": "Direct verwerken",
    "kasboek.veld.directHint": "Boeking direct vastleggen en meenemen in de dagafsluiting.",
    "kasboek.fout.omschrijving": "Vul een omschrijving in.",
    "kasboek.fout.bedrag": "Vul een bedrag groter dan 0 in.",
    "kasboek.fout.vestiging": "Geen vestiging gekozen.",
    "kasboek.fout.opslaan": "De boeking kon niet worden opgeslagen.",
    "dagafsluiting.title": "Dagafsluiting",
    "dagafsluiting.subtitle": "Sluit de kas stap voor stap af en controleer alles punt voor punt.",
    "dagafsluiting.kpi.beginkas": "Beginkas",
    "dagafsluiting.kpi.inkomsten": "Contante inkomsten",
    "dagafsluiting.kpi.uitgaven": "Contante uitgaven",
    "dagafsluiting.kpi.verwacht": "Verwacht kassaldo",
    "dagafsluiting.stap.gegevens": "Gegevens controleren",
    "dagafsluiting.stap.tellen": "Kas tellen",
    "dagafsluiting.stap.verschil": "Verschil controleren",
    "dagafsluiting.stap.afronden": "Vier-ogen controle & afronden",
    "dagafsluiting.stapStand.open": "nog te doen",
    "dagafsluiting.stapStand.ok": "klaar",
    "dagafsluiting.stapStand.letop": "verschil zonder uitleg",
    "dagafsluiting.stapStand.wacht": "wacht op akkoord",
    "dagafsluiting.dagstand.afgesloten": "Afgesloten door %s op %s.",
    "dagafsluiting.dagstand.akkoord": "Akkoord van %s op %s.",
    "dagafsluiting.dagstand.wachtAkkoord": "Nog geen vier-ogen akkoord.",
    "dagafsluiting.stap1.titel": "Stap 1 · Gegevens controleren",
    "dagafsluiting.stap1.uitleg": "Controleer de daggegevens en signalen. Als alles klopt, kun je verder naar het tellen van de kas.",
    "dagafsluiting.stap2.titel": "Stap 2 · Kas tellen",
    "dagafsluiting.stap2.uitleg": "Tel het geld in de kas en controleer of het totaal overeenkomt met het verwachte kassaldo.",
    "dagafsluiting.stap3.titel": "Stap 3 · Verschil controleren",
    "dagafsluiting.stap4.titel": "Stap 4 · Vier-ogen controle & afronden",
    "dagafsluiting.nogTeBouwen": "Deze stap wordt hierna gebouwd.",
    "dagafsluiting.basis": "Basisgegevens",
    "dagafsluiting.basis.datum": "Datum",
    "dagafsluiting.basis.kas": "Kas",
    "dagafsluiting.basis.open": "Open boekingen",
    "dagafsluiting.basis.laatste": "Laatste boeking",
    "dagafsluiting.basis.geenBoeking": "Nog geen boeking vandaag",
    "dagafsluiting.basis.door": "Af te sluiten door",
    "dagafsluiting.cijfers": "Vandaag in cijfers",
    "dagafsluiting.cijfer.geplaatst": "dieren geplaatst",
    "dagafsluiting.cijfer.tovGisteren": "t.o.v. gisteren",
    "dagafsluiting.cijfer.adopties": "adopties afgerond",
    "dagafsluiting.cijfer.herenigd": "dieren herenigd met eigenaar",
    "dagafsluiting.ai.mooieDag": "Mooie dag!",
    "dagafsluiting.ai.rustigeDag": "Rustige dag",
    "dagafsluiting.cijfer.donaties": "donaties ontvangen",
    "dagafsluiting.cijfer.ingeschreven": "dieren ingeschreven",
    "dagafsluiting.ai.geen": "Nog geen samenvatting — zet een AI-provider aan om de dag in één zin te laten samenvatten.",
    "dagafsluiting.ai.opnieuw": "Opnieuw laten samenvatten",
    "dagafsluiting.controle": "Controlepunten",
    "dagafsluiting.check.datum": "Datum klopt",
    "dagafsluiting.check.vestiging": "Juiste vestiging geselecteerd",
    "dagafsluiting.check.open": "Geen open boekingen",
    "dagafsluiting.check.klaar": "Klaar om de kas te tellen",
    "dagafsluiting.check.geteld": "Kas volledig geteld",
    "dagafsluiting.check.losGeld": "Los geld meegeteld",
    "dagafsluiting.concept": "Opslaan als concept",
    "dagafsluiting.conceptOp": "Concept opgeslagen: %s",
    "dagafsluiting.conceptFout": "Het concept kon niet worden opgeslagen. Probeer het opnieuw.",
    "dagafsluiting.verder.tellen": "Verder naar kas tellen",
    "dagafsluiting.verder.verschil": "Verder naar verschil controleren",
    "dagafsluiting.vorige": "Vorige stap",
    "dagafsluiting.biljetten": "Biljetten en munten",
    "dagafsluiting.aantalVan": "Aantal van %s",
    "dagafsluiting.totaalGeteld": "Totaal geteld",
    "dagafsluiting.overnemen": "Overnemen van vorige dag",
    "dagafsluiting.overnemenVan": "Telling van %s",
    "dagafsluiting.overnemenGeenVorige": "Er is nog geen afgesloten dag om van over te nemen",
    "dagafsluiting.kopBiljetten": "Biljetten",
    "dagafsluiting.kopMunten": "Munten",
    "dagafsluiting.subtotaal": "Subtotaal",
    "dagafsluiting.getaldSaldo": "Geteld kassaldo",
    "dagafsluiting.pasAan": "Pas aan indien nodig.",
    "dagafsluiting.tip": "Tip: tel de kas altijd met twee handen en werk van groot naar klein.",
    "dagafsluiting.stap3.uitleg": "Vergelijk de kasopmaak met de geregistreerde kasboekingen van vandaag.",
    "dagafsluiting.stap3.tip": "Komt een bedrag niet overeen? Controleer de kasopmaak of de kasboekingen en pas aan indien nodig.",
    "dagafsluiting.contantGeteld": "Contant geld (geteld)",
    "dagafsluiting.pinGeteld": "Pinautomaat (geteld)",
    "dagafsluiting.totaalContant": "Totaal contant geld",
    "dagafsluiting.aantal": "Aantal",
    "dagafsluiting.munten": "Munten",
    "dagafsluiting.pin": "Pin",
    "dagafsluiting.pinTransacties": "Aantal transacties",
    "dagafsluiting.pinBedrag": "Totaal bedrag",
    "dagafsluiting.pinHint": "Neem het totaal van de pinautomaat over.",
    "dagafsluiting.bijlageToevoegen": "Pinafsluiting bijvoegen",
    "dagafsluiting.bijlageVerwijderen": "Verwijderen",
    "dagafsluiting.bijlageFout": "De pinafsluiting kon niet worden opgeslagen. Probeer het opnieuw.",
    "dagafsluiting.boekingenVandaag": "Kasboekingen van vandaag",
    "dagafsluiting.ontvangsten": "ONTVANGSTEN",
    "dagafsluiting.contant": "Contant",
    "dagafsluiting.totaalOntvangsten": "Totaal ontvangsten",
    "dagafsluiting.uitgavenKop": "UITGAVEN",
    "dagafsluiting.uitgaven": "Uitgaven",
    "dagafsluiting.beginSaldoKop": "BEGIN SALDO",
    "dagafsluiting.beginSaldo": "Begin saldo",
    "dagafsluiting.verwachtEindsaldo": "Verwacht eindsaldo",
    "dagafsluiting.klopt": "Alles klopt!",
    "dagafsluiting.kloptSoort": "%s: klopt",
    "dagafsluiting.erIsVerschil": "Er is een verschil",
    "dagafsluiting.verschilContantMeer": "Er zit %s meer in de kas dan verwacht.",
    "dagafsluiting.verschilContantMinder": "Er zit %s minder in de kas dan verwacht.",
    "dagafsluiting.verschilPinMeer": "Op de pin is %s meer geteld dan geboekt.",
    "dagafsluiting.verschilPinMinder": "Op de pin is %s minder geteld dan geboekt.",
    "dagafsluiting.zoekUit": "Kasboekingen bekijken",
    "dagafsluiting.verbergBoekingen": "Kasboekingen verbergen",
    "dagafsluiting.boekingenVanDag": "Kasboekingen van deze dag",
    "dagafsluiting.bekijkFacturen": "Gemaakte facturen bekijken",
    "dagafsluiting.verbergFacturen": "Facturen verbergen",
    "dagafsluiting.facturenVanDag": "Facturen van deze dag",
    "dagafsluiting.geenFacturenDag": "Er zijn deze dag geen facturen gemaakt.",
    "dagafsluiting.factuurOpenen": "Factuur openen in een nieuw tabblad",
    "dagafsluiting.factuurTip": "Klik op een factuurnummer om hem te openen — bijvoorbeeld om een betaling toe te voegen. Hij opent in een nieuw tabblad, zodat je telling blijft staan.",
    "dagafsluiting.eigenaar": "Eigenaar",
    "dagafsluiting.totaalFacturen": "Totaal",
    "dagafsluiting.geenBoekingenDag": "Er zijn deze dag geen kasboekingen gemaakt.",
    "dagafsluiting.uitzoekTip": "Klopt een boeking niet? Pas hem aan in het kasboek en kom hier terug; de bedragen rekenen dan opnieuw.",
    "dagafsluiting.kloptUitleg": "Het getelde bedrag is gelijk aan het verwachte saldo.",
    "dagafsluiting.meerInLade": "%s meer geteld dan verwacht.",
    "dagafsluiting.minderInLade": "%s minder geteld dan verwacht.",
    "dagafsluiting.verschil.contant": "Verschil op contant geld",
    "dagafsluiting.verschil.pin": "Verschil op pin",
    "dagafsluiting.verder.vierogen": "Verder naar vier-ogencontrole",
    "dagafsluiting.stap4.uitleg": "Een tweede medewerker controleert de dagafsluiting en geeft akkoord voordat deze definitief wordt afgesloten.",
    "dagafsluiting.samenvatting": "Samenvatting dagafsluiting",
    "dagafsluiting.opsteller": "Afsluiten door (opsteller)",
    "dagafsluiting.voltooid": "Voltooid",
    "dagafsluiting.akkoordKop": "Controle & akkoord door collega (vier-ogencontrole)",
    "dagafsluiting.naamCollega": "Naam collega",
    "dagafsluiting.selecteerCollega": "Selecteer collega",
    "dagafsluiting.wachtwoord": "Wachtwoord",
    "dagafsluiting.wachtwoordHint": "Voer wachtwoord in",
    "dagafsluiting.wachtwoordTonen": "Wachtwoord tonen of verbergen",
    "dagafsluiting.akkoordGeven": "Akkoord geven",
    "dagafsluiting.akkoordGegeven": "Akkoord gegeven",
    "dagafsluiting.akkoordFout": "Het akkoord kon niet worden vastgesteld. Controleer de collega en het wachtwoord.",
    "dagafsluiting.vierOgen": "Vier-ogenprincipe",
    "dagafsluiting.vierOgenUitleg": "Een tweede medewerker controleert de dagafsluiting en geeft akkoord. Zonder akkoord kan de dagafsluiting niet definitief worden afgesloten.",
    "dagafsluiting.dagAfsluiten": "Dag afsluiten",
    "dagafsluiting.knopHint": "Deze knop wordt actief zodra een collega akkoord geeft, of als je de controle later laat doen.",
    "dagafsluiting.laterControleren": "Laat een collega later controleren",
    "dagafsluiting.laterGekozen": "Controle volgt later",
    "dagafsluiting.laterGekozenUitleg": "De dag wordt afgesloten met 'wacht op vier-ogencontrole'. Een collega geeft het akkoord op een later moment.",
    "dagafsluiting.tochNu": "Toch nu laten controleren",
    "dagafsluiting.dagAfsluitenLater": "Afsluiten, controle volgt",
    "dagafsluiting.knopHintLater": "De dag wordt vastgelegd en wacht op het akkoord van een collega.",
    "dagafsluiting.opmerkingKop": "Opmerking",
    "dagafsluiting.opmerkingHint": "Bijvoorbeeld: waar het verschil vandaan komt, of wat er verder aan de hand was.",
    "dagafsluiting.afsluitFout": "De dagafsluiting kon niet worden vastgelegd. Probeer het opnieuw.",
    "dagafsluiting.vastgelegd": "Dag afgesloten",
    "dagafsluiting.vastgelegdWacht": "Dag afgesloten — wacht op controle",
    "dagafsluiting.vastgelegdUitleg": "%s, afgesloten door %s op %s.",
    "dagafsluiting.akkoordDoorNaam": "Akkoord gegeven door %s.",
    "dagafsluiting.verschilKop": "Verschil",
    "dagafsluiting.terugNaarAfsluiting": "Terug naar de afsluiting",
    "dagafsluiting.volgendeDag": "Een andere dag afsluiten",
    "dagafsluiting.alAfgesloten": "Deze dag is al afgesloten",
    "dagafsluiting.alAfgeslotenUitleg": "Opnieuw afsluiten corrigeert die afsluiting; er komt geen tweede naast.",
    "dagafsluiting.vierOgenLater": "Is er nu geen collega? Dan kan de dag worden afgesloten met 'wacht op controle' en geeft een collega het akkoord later.",
    "dagafsluiting.geenCollega": "Er is geen tweede medewerker met een account beschikbaar om akkoord te geven.",
    "dagafsluiting.kiesDag": "Kies een dag",
    "dagafsluiting.vorigeMaand": "Vorige maand",
    "dagafsluiting.volgendeMaand": "Volgende maand",
    "dagafsluiting.dagAfgesloten": "Deze dag is afgesloten en goedgekeurd",
    "dagafsluiting.dagAfgeslotenZonderAkkoord": "Deze dag is afgesloten, nog zonder akkoord",
    "dagafsluiting.legendaAf": "Al afgesloten",
    "dagafsluiting.nogNietGeteld": "Nog niets geteld in stap 2.",
    "financieel.velden": "Velden",
    "financieel.filter.zoeken": "Zoeken",
    "financieel.filter.gekozen": "%s gekozen",
    "financieel.filter.allesAan": "Alles aan",
    "financieel.filter.allesUit": "Alles uit",
    "financieel.filter.vestigingZoek": "Zoek vestiging...",
    "financieel.filter.vestigingGeen": "Geen vestiging gevonden.",
    "financieel.pagina": "Pagina %s van %s",
    "menu.betalingen": "Betalingen",
    "menu.financieelOverzichten": "Overzichten",
    "menu.kasboek": "Kas uitgaven",
    "menu.dagafsluiting": "Dagafsluiting",
    "menu.financieelExport": "Export",
    "menu.crematorium.title": "Crematorium",
    "menu.communicatie.title": "Communicatie",
    "menu.security.title": "Security",
    "menu.dashboard": "Dashboard",
    // Dashboard (/home) — Fawkes Command Center
    "dashboard.appName": "Fawkes Command Center",
    "dashboard.greeting": "Welkom terug",
    "dashboard.greeting.morning": "Goedemorgen",
    "dashboard.greeting.afternoon": "Goedemiddag",
    "dashboard.greeting.evening": "Goedenavond",
    "dashboard.greeting.night": "Goedenacht",
    "dashboard.banner.noVestiging": "Kies een vestiging in de zijbalk om vestiging-specifieke informatie te zien.",
    "dashboard.action.newAnimal": "Nieuw dier",
    "dashboard.action.inboeken": "Inboeken",
    "dashboard.action.uitboeken": "Uitboeken",
    "dashboard.kpi.ANIMALS_PRESENT": "Aanwezige dieren",
    "dashboard.kpi.INTAKES_TODAY": "Opnames vandaag",
    "dashboard.kpi.RELEASES_TODAY": "Plaatsingen vandaag",
    "dashboard.kpi.OPEN_INVOICES": "Openstaande facturen",
    "dashboard.kpi.current": "Nu",
    "dashboard.kpi.vsYesterday": "vs. gisteren",
    "dashboard.metric.systemStatus": "Systeemstatus",
    "dashboard.metric.operational": "Alles operationeel",
    "dashboard.section.operation": "Live operatieoverzicht",
    "dashboard.live": "Real-time bijgewerkt",
    "dashboard.chart.title": "Instroom vs. uitstroom",
    "dashboard.chart.period7": "Laatste 7 dagen",
    "dashboard.chart.empty": "Nog geen gegevens om weer te geven.",
    "dashboard.chart.trend.intake": "Instroom",
    "dashboard.chart.trend.outflow": "Uitstroom",
    "dashboard.chart.occupancy": "Bezetting per vestiging",
    "dashboard.capacity.title": "Capaciteitsoverzicht",
    "dashboard.capacity.occupancyLabel": "Bezetting",
    "dashboard.capacity.present": "dieren aanwezig",
    "dashboard.capacity.link": "Naar capaciteit & bezetting",
    "dashboard.occupancy.totalLabel": "Totaal",
    "dashboard.occupancy.present": "aanwezig",
    "dashboard.locations.link": "Alle vestigingen bekijken",
    "dashboard.gewicht.title": "Gewichtssignalen",
    "dashboard.gewicht.buiten": "Dieren buiten streefgewicht",
    "dashboard.gewicht.onder": "Ondergewicht",
    "dashboard.gewicht.boven": "Overgewicht",
    "dashboard.gewicht.verlopen": "Meting verlopen",
    "dashboard.gewicht.allClear": "Alle dieren zitten binnen hun streefgewicht en zijn onlangs gewogen.",
    "dashboard.gewicht.link": "Naar gewichtsoverzicht",
    "dashboard.taken.open": "Open taken",
    "dashboard.taken.mijnTeam": "Open taken van mijn team",
    "dashboard.taken.geen": "Geen open taken.",
    "dashboard.taken.achterstallig": "achterstallig",
    "dashboard.taken.vandaag": "vandaag",
    "dashboard.vacc.title": "Entingen verlopen",
    "dashboard.vacc.attention": "Aandacht",
    "dashboard.vacc.allClear": "Alle aanwezige dieren zijn up-to-date.",
    "dashboard.vacc.today": "vandaag",
    "dashboard.vacc.within7": "binnen 7 dagen",
    "dashboard.vacc.priority": "Hoogste prioriteit:",
    "dashboard.vacc.link": "Naar entingenoverzicht",
    "dashboard.section.actions": "Acties & meldingen",
    "dashboard.tab.all": "Alles",
    "dashboard.tab.tasks": "Taken",
    "dashboard.tab.financial": "Financieel",
    "dashboard.tab.alerts": "Meldingen",
    "dashboard.actions.priorityTasks": "Prioritaire taken",
    "dashboard.actions.noTasks": "Geen prioritaire taken",
    "dashboard.actions.financialHeading": "Financiële meldingen",
    "dashboard.actions.noFinancial": "Geen financiële meldingen",
    "dashboard.actions.overdueSub": "Ouder dan 30 dagen",
    "dashboard.actions.link": "Naar actielogboek",
    "dashboard.alert.highOccSub": "Boven streefbezetting",
    "dashboard.section.today": "Vandaag",
    "dashboard.today.emptyTitle": "Geen geplande activiteiten",
    "dashboard.today.emptySub": "Agenda-koppeling volgt",
    "dashboard.today.link": "Bekijk volledige planning",
    "dashboard.section.sla": "SLA-signalen & aandacht",
    "dashboard.sla.allClear": "Geen openstaande signalen — alles bij.",
    "dashboard.sla.attentionSuffix": "aandachtspunten",
    "dashboard.sla.link": "Naar taken & SLA-dashboard",
    "dashboard.sla.view": "Bekijk",
    "dashboard.sla.overdueSuffix": "vervallen facturen",
    "dashboard.sla.overdueSub": "Totaal openstaand:",
    "dashboard.sla.longStaySuffix": "dieren langer dan 60 dagen",
    "dashboard.sla.longStaySub": "Evaluatie aanbevolen",
    "dashboard.workspaces": "Werkruimtes",
    "dashboard.ws.animals": "Dieren",
    "dashboard.ws.animals.desc": "Beheer dieren, dossiers en medische data",
    "dashboard.ws.relations": "Relaties",
    "dashboard.ws.relations.desc": "Adoptanten, klanten en contacten",
    "dashboard.ws.planning": "Planning",
    "dashboard.ws.planning.desc": "Agenda, diensten en activiteiten",
    "dashboard.ws.exchanges": "Uitwisselingen",
    "dashboard.ws.exchanges.desc": "Transporten en overdrachten",
    "dashboard.ws.invoices": "Facturen",
    "dashboard.ws.invoices.desc": "Facturatie en financieel overzicht",
    "dashboard.ws.settings": "Instellingen",
    "dashboard.ws.settings.desc": "Systeem, gebruikers en voorkeuren",
    "menu.animal": "Dier",
    "animals.empty.title": "Nog geen dier geopend",
    "animals.empty.info": "Open een dier via de zoekbalk bovenin, of boek een nieuw dier in.",
    "animals.empty.action": "Dier inboeken",
    "relaties.empty.title": "Nog geen relatie geopend",
    "relaties.empty.info": "Open een relatie via de zoekbalk bovenin, of maak een nieuwe relatie aan.",
    "relaties.empty.action": "Nieuwe relatie",
    "menu.relaties": "Relaties",
    // sidebar-menu-parity: exacte Jmix-labels — menu-item "Opvangoverzichten" + de vijf tabbladen.
    "menu.opvangOverzichten": "Opvangoverzichten",
    "opvangModules.opvang": "Opvang",
    "opvangModules.pleeggezinnen": "Pleeggezinnen",
    "opvangModules.nazorg": "Nazorg",
    "opvangModules.uitwisselingen": "Uitwisselingen",
    "opvangModules.advertenties": "Advertenties",
    "opvangOverzichten.tab.aanwezig": "Aanwezig",
    "opvangOverzichten.tab.entingen": "Entingen",
    "opvangOverzichten.tab.ontwormen": "Ontwormen & ontvlooien",
    "opvangOverzichten.tab.medicijn": "Medicijn",
    "opvangOverzichten.tab.vertrokken": "Vertrokken",
    "menu.facturen": "Facturen",
    "menu.dierAttendance": "Dier aanwezig",
    "menu.dierPlacement": "Dieren geplaatst",
    "menu.kennelplanning": "Planning",
    "menu.shelterExchanges": "Uitwisselingen",
    "menu.entingenOverzicht": "Entingen overzicht",
    "menu.ontwormenOverzicht": "Ontwormen & ontvlooien",
    "menu.medicijnOverzicht": "Medicijn overzicht",
    "menu.nazorg": "Nazorg",
    // nazorg-beheer (aftercare admin) — Jmix NazorgBeheerView migration.
    "nazorg.title": "Nazorg",
    "nazorg.inzending.laden": "Nazorg-antwoorden laden…",
    "nazorg.inzending.fout": "Deze nazorg-inzending kon niet worden geladen.",
    "nazorg.inzending.terug": "Terug naar overzicht",
    "nazorg.inzending.naarDier": "Dierdossier openen",
    "nazorg.inzending.onbekendDier": "Onbekend dier",
    "nazorg.inzending.adoptant": "Adoptant",
    "nazorg.inzending.moment": "Moment",
    "nazorg.inzending.ingediend": "Ingediend",
    "nazorg.inzending.chip": "Chip",
    "nazorg.inzending.antwoorden": "Beoordeling per vraag",
    "nazorg.inzending.geenAntwoorden": "Geen antwoorden bij deze inzending.",
    "nazorg.inzending.signaal": "Signaal",
    "nazorg.inzending.uitkomst": "Uitkomst",
    "nazorg.inzending.telGroen": "groen",
    "nazorg.inzending.telOranje": "oranje",
    "nazorg.inzending.telRood": "rood",
    "nazorg.inzending.signalen": "Signalen",
    "nazorg.inzending.vragenlijst": "Vragenlijst",
    "nazorg.inzending.prioriteit.groen": "Geen aandacht nodig",
    "nazorg.inzending.prioriteit.oranje": "Aandacht",
    "nazorg.inzending.prioriteit.rood": "Aandacht nodig",
    "nazorg.subtitle": "Volg adopties na plaatsing en signaleer waar het misgaat.",
    "nazorg.empty.moduleDisabled": "De nazorg-module is uitgeschakeld voor deze organisatie.",
    "nazorg.tab.overzicht": "Overzicht",
    "nazorg.tab.vragenlijsten": "Vragenlijsten",
    "nazorg.tab.taken": "Taken",
    "nazorg.tab.huisstijl": "Lay-out en thema",
    "nazorg.huisstijl.title": "Lay-out en thema",
    "nazorg.huisstijl.subtitle": "Zo ziet de nazorgvragenlijst eruit bij de adoptant: jouw kleuren, jouw logo, jouw woorden.",
    "nazorg.huisstijl.opslaan": "Opslaan",
    "nazorg.huisstijl.opgeslagen": "Opgeslagen. Het platform gebruikt deze huisstijl vanaf nu.",
    "nazorg.huisstijl.opslaanFout": "Opslaan mislukt. Probeer het opnieuw.",
    "nazorg.huisstijl.aiKop": "Haal je huisstijl op",
    "nazorg.huisstijl.aiUitleg": "Geef het adres van je website. We halen daar de kleuren en het logo vandaan; daarna stel je alles nog naar smaak bij.",
    "nazorg.huisstijl.aiKnop": "Ophalen",
    "nazorg.huisstijl.bezig": "Bezig…",
    "nazorg.huisstijl.uitWebsiteKlaar": "Kleuren opgehaald van je website.",
    "nazorg.huisstijl.uitWebsiteKlaarMetLogo": "Kleuren en logo opgehaald van je website.",
    "nazorg.huisstijl.uitWebsiteFout": "Ophalen mislukt. Controleer het adres.",
    "nazorg.huisstijl.gevonden": "Gevonden kleuren",
    "nazorg.huisstijl.gebruikAlsHoofdkleur": "Gebruik als hoofdkleur",
    "nazorg.huisstijl.logoKop": "Logo",
    "nazorg.huisstijl.logoKies": "Kies een logo",
    "nazorg.huisstijl.logoUitleg": "Een png, jpg, webp of svg van hoogstens 2 MB. We halen er meteen kleuren uit.",
    "nazorg.huisstijl.logoWeg": "Logo verwijderen",
    "nazorg.huisstijl.logoKlaar": "Logo bijgewerkt.",
    "nazorg.huisstijl.logoFout": "Het logo kon niet opgeslagen worden.",
    "nazorg.huisstijl.kleurenKop": "Kleuren",
    "nazorg.huisstijl.kleur.primair": "Hoofdkleur",
    "nazorg.huisstijl.kleur.accent": "Accentkleur",
    "nazorg.huisstijl.kleur.achtergrond": "Achtergrond",
    "nazorg.huisstijl.kleur.oppervlak": "Vlakken",
    "nazorg.huisstijl.kleur.tekst": "Tekst",
    "nazorg.huisstijl.letterKop": "Lettertype",
    "nazorg.huisstijl.letter.SYSTEEM": "Standaard",
    "nazorg.huisstijl.letter.SCHREEF": "Met schreef",
    "nazorg.huisstijl.letter.ROND": "Rond",
    "nazorg.huisstijl.letter.SMAL": "Smal",
    "nazorg.huisstijl.tekstenKop": "Teksten",
    "nazorg.huisstijl.kopTitel": "Titel bovenaan",
    "nazorg.huisstijl.kopTitelHint": "Bijvoorbeeld: Hoe gaat het met je nieuwe huisgenoot?",
    "nazorg.huisstijl.welkomTekst": "Welkomsttekst",
    "nazorg.huisstijl.welkomTekstHint": "Een paar zinnen die de adoptant als eerste leest.",
    "nazorg.huisstijl.slotTekst": "Afsluitende tekst",
    "nazorg.huisstijl.slotTekstHint": "Bijvoorbeeld: Bedankt, we lezen je antwoorden en nemen contact op als dat nodig is.",
    "nazorg.huisstijl.voorbeeldKop": "Voorbeeld",
    "nazorg.huisstijl.voorbeeldAria": "Voorbeeld van de vragenlijst op een telefoon",
    "nazorg.huisstijl.voorbeeldKicker": "Nazorg",
    "nazorg.huisstijl.voorbeeldTitel": "Hoe gaat het met Balou?",
    "nazorg.huisstijl.voorbeeldWelkom": "Fijn dat je even de tijd neemt. Een paar korte vragen over hoe het gaat.",
    "nazorg.huisstijl.voorbeeldVraag1": "Hoe voelt hij zich thuis?",
    "nazorg.huisstijl.voorbeeldVraag2": "Eet hij goed?",
    "nazorg.huisstijl.voorbeeldNee": "Nee",
    "nazorg.huisstijl.voorbeeldBeetje": "Een beetje",
    "nazorg.huisstijl.voorbeeldPrima": "Prima",
    "nazorg.huisstijl.voorbeeldKnop": "Versturen",
    "nazorg.huisstijl.voorbeeldVoet": "Zo ziet de adoptant de vragenlijst. Op DierMatch komt je logo te staan — de kleuren daar blijven die van DierMatch zelf.",
    "nazorg.prio.rood": "Rood",
    "nazorg.prio.oranje": "Oranje",
    "nazorg.prio.groen": "Groen",
    "nazorg.stat.lopend": "Lopende nazorg",
    "nazorg.stat.rodeVlaggen": "Rode vlaggen",
    "nazorg.stat.teVolgen": "Te volgen",
    "nazorg.stat.huisbezoeken": "Huisbezoeken",
    "nazorg.stat.reactiegraad": "Reactiegraad",
    "nazorg.soort.alle": "Alle diersoorten",
    "nazorg.filter.zoek": "Zoek dier of adoptant…",
    "nazorg.filter.prioriteit": "Uitkomst",
    "nazorg.filter.moment": "Contactmoment",
    "nazorg.filter.status": "Afhandeling",
    "nazorg.filter.alle": "Alle",
    "nazorg.filter.onbehandeld": "Nog oppakken",
    "nazorg.filter.opgepakt": "Gesloten",
    "nazorg.filter.wissen": "Filters wissen",
    "nazorg.moment.DAG_1_2": "1–2 dagen",
    "nazorg.moment.WEEK_1_2": "1–2 weken",
    "nazorg.moment.MAAND_1": "1 maand",
    "nazorg.moment.MAANDEN_6": "6 maanden",
    "nazorg.resultaten.aantal": "%d resultaten",
    "nazorg.resultaten.aantalEen": "1 resultaat",
    "nazorg.resultaten.leegFilter": "Geen nazorg-resultaten voor dit filter.",
    "nazorg.aandacht.vragenlijst": "Vragenlijst:",
    "nazorg.verzending.title": "Nazorg-uitnodigingen",
    "nazorg.verzending.subtitle": "Wat er nog uitgaat en wat er al verstuurd is.",
    "nazorg.verzending.filter.alles": "Alles",
    "nazorg.verzending.filter.gepland": "Nog versturen",
    "nazorg.verzending.filter.verstuurd": "Verstuurd",
    "nazorg.verzending.zoek": "Zoek dier, adoptant of woonplaats",
    "nazorg.verzending.periode": "Periode",
    "nazorg.verzending.van": "Van",
    "nazorg.verzending.tot": "Tot en met",
    "nazorg.verzending.col.dier": "Dier",
    "nazorg.verzending.col.vragenlijst": "Vragenlijst",
    "nazorg.verzending.col.moment": "Contactmoment",
    "nazorg.verzending.col.keer": "Keer",
    "nazorg.verzending.col.adoptant": "Adoptant",
    "nazorg.verzending.col.datum": "Datum",
    "nazorg.verzending.col.status": "Status",
    "nazorg.verzending.keer": "%de",
    "nazorg.verzending.status.GEPLAND": "Staat klaar",
    "nazorg.verzending.status.VERSTUURD": "Verstuurd",
    "nazorg.verzending.status.GEOPEND": "Geopend",
    "nazorg.verzending.status.INGEVULD": "Ingevuld",
    "nazorg.verzending.status.VERLOPEN": "Verlopen",
    "nazorg.verzending.empty": "Er staat niets klaar en er is nog niets verstuurd.",
    "nazorg.verzending.openDossier": "Het nazorgdossier openen",
    "nazorg.verzending.toelichting": "Een geplande uitnodiging gaat automatisch uit op de datum die erbij staat.",
    "nazorg.aandacht.title": "Nazorg-resultaten",
    "nazorg.aandacht.adoptant": "Adoptant:",
    "nazorg.aandacht.moment": "Moment:",
    "nazorg.aandacht.ingediend": "Ingediend:",
    "nazorg.aandacht.resultaat": "Resultaat:",
    "nazorg.aandacht.signaal": "%d signaal",
    "nazorg.aandacht.signalen": "%d signalen",
    "nazorg.aandacht.empty": "Geen adopties die nu aandacht vragen.",
    "nazorg.vragenlijsten.title": "Vragenlijsten",
    "nazorg.vragenlijsten.subtitle": "Nazorg-vragenlijsten per contactmoment en diersoort.",
    "nazorg.vragenlijsten.filterAll": "Alle diersoorten",
    "nazorg.vragenlijsten.empty": "Nog geen vragenlijsten voor dit filter — maak er één met “Nieuwe nazorg-vragenlijst”.",
    "nazorg.vragenlijsten.nieuweLijst": "Nieuwe nazorg-vragenlijst",
    "nazorg.vragenlijsten.openTitel": "Openen in de vragenlijst-builder",
    "nazorg.vragenlijsten.kanaalPlatform": "Platform",
    "nazorg.vragenlijsten.col.naam": "Vragenlijst",
    "nazorg.vragenlijsten.col.diersoort": "Diersoort",
    "nazorg.vragenlijsten.col.contactmoment": "Contactmoment",
    "nazorg.vragenlijsten.col.kanaal": "Kanaal",
    "nazorg.vragenlijsten.col.status": "Status",
    "nazorg.status.gepubliceerd": "Gepubliceerd",
    "nazorg.status.concept": "Concept",
    "nazorg.status.gearchiveerd": "Gearchiveerd",
    // Wizard-builder nazorg-tab (nazorg-authoring epic): de in-SPA vragenlijst-editors. De
    // vocabulaire-labels (contactmomenten, operatoren, kleuren, dimensies) komen uit de api-payload;
    // deze keys dekken alleen de omlijsting.
    "wizards.nazorg.tab": "Nazorg",
    "wizards.nazorg.rowBadge": "Nazorg-vragenlijst",
    "wizards.nazorg.nieuw": "Nieuwe nazorg-vragenlijst",
    "wizards.nazorg.geenVelden": "Voeg eerst vragen toe op het tabblad “Formulier bouwen” — regels wijzen naar een vraag.",
    "wizards.nazorg.verwijderen": "Verwijderen",
    "wizards.nazorg.config.title": "Versturen & opvolging",
    "wizards.nazorg.config.lead": "Wanneer de vragenlijst na adoptie uitgaat en wanneer hij sluit.",
    "wizards.nazorg.config.contactmoment": "Contactmoment",
    "wizards.nazorg.config.doelgroep": "Doelgroep",
    "wizards.nazorg.config.kanaal": "Kanaal",
    "wizards.nazorg.config.autoVersturen": "Automatisch versturen op het contactmoment",
    "wizards.nazorg.config.herinnerNaDagen": "Herinner na (dagen)",
    "wizards.nazorg.config.sluitNaDagen": "Sluit na (dagen)",
    "wizards.nazorg.config.opslaan": "Nazorg-instellingen opslaan",
    "wizards.nazorg.vlagRegels.title": "Rode-vlag-regels",
    "wizards.nazorg.vlagRegels.lead": "Een antwoord dat een regel raakt kleurt de inzending (rood/oranje/groen) in de signalen-inbox.",
    "wizards.nazorg.vlagRegels.leeg": "Nog geen regels.",
    "wizards.nazorg.vlagRegels.toevoegen": "Regel toevoegen",
    "wizards.nazorg.scoreMapping.title": "Welzijnsscore",
    "wizards.nazorg.scoreMapping.lead": "Weeg vragen mee op een welzijnsdimensie; de antwoorden voeden de welzijnsscore van het dier.",
    "wizards.nazorg.scoreMapping.leeg": "Nog geen koppelingen.",
    "wizards.nazorg.scoreMapping.toevoegen": "Koppeling toevoegen",
    "wizards.nazorg.col.veld": "Vraag",
    "wizards.nazorg.col.operator": "Operator",
    "wizards.nazorg.col.waarde": "Waarde",
    "wizards.nazorg.col.kleur": "Kleur",
    "wizards.nazorg.col.dimensie": "Dimensie",
    "wizards.nazorg.col.weging": "Weging",
    "menu.productenCatalogus": "Producten & Diensten",
    "menu.pensionTarief": "Pension tarieven",
    "menu.pensionArrangementen": "Pension arrangementen",
    "pensionArrangement.titel": "Pension arrangementen",
    "pensionArrangement.subtitel": "Arrangementen en extra's die de balie bij een reservering kan kiezen.",
    "pensionArrangement.nieuw": "Nieuw arrangement",
    "pensionArrangement.zoek": "Zoek arrangementen…",
    "pensionArrangement.alles": "Alles",
    "pensionArrangement.niveau.DIER": "Per dier",
    "pensionArrangement.niveau.RESERVERING": "Hele reservering",
    "pensionArrangement.niveau.DIER.uitleg": "de balie kiest het per dier.",
    "pensionArrangement.niveau.RESERVERING.uitleg": "één keer voor de hele reservering, zoals Live volgen.",
    "pensionArrangement.eenheid.PER_KEER": "Per keer",
    "pensionArrangement.eenheid.PER_DAG": "Per dag",
    "pensionArrangement.eenheid.PER_WEEK": "Per week",
    "pensionArrangement.eenheid.PER_VERBLIJF": "Per verblijf",
    "pensionArrangement.eenheid.kort.PER_KEER": "per keer",
    "pensionArrangement.eenheid.kort.PER_DAG": "per dag",
    "pensionArrangement.eenheid.kort.PER_WEEK": "per week",
    "pensionArrangement.eenheid.kort.PER_VERBLIJF": "per verblijf",
    "pensionArrangement.prijs.vast": "%s %s",
    "pensionArrangement.prijs.vanaf": "vanaf %s %s",
    "pensionArrangement.geenPrijs": "Nog geen prijs",
    "pensionArrangement.alleSoorten": "Alle diersoorten",
    "pensionArrangement.filter.elkeSoort": "Diersoort: alles",
    "pensionArrangement.filter.inactief": "Toon niet-actieve",
    "pensionArrangement.max": "max. %s",
    "pensionArrangement.inactief": "Niet actief",
    "pensionArrangement.bewerk": "Bewerken",
    "pensionArrangement.bewerkVan": "%s bewerken",
    "pensionArrangement.prijs.knop": "Prijs",
    "pensionArrangement.prijsVan": "Prijs van %s",
    "pensionArrangement.verwijderVan": "%s verwijderen",
    "pensionArrangement.laadFout": "De arrangementen konden niet worden geladen.",
    "pensionArrangement.leeg": "Nog geen arrangementen. Maak het eerste aan met Nieuw arrangement.",
    "pensionArrangement.geenTreffers": "Geen arrangementen die hierbij passen.",
    "pensionArrangement.venster.nieuw": "Nieuw arrangement",
    "pensionArrangement.venster.bewerk": "%s bewerken",
    "pensionArrangement.veld.naam": "Naam",
    "pensionArrangement.veld.omschrijving": "Omschrijving",
    "pensionArrangement.veld.diersoort": "Diersoort",
    "pensionArrangement.veld.eenheid": "Prijs geldt",
    "pensionArrangement.veld.niveau": "Kiezen per",
    "pensionArrangement.veld.maxAantal": "Maximaal aantal",
    "pensionArrangement.veld.positie": "Volgorde",
    "pensionArrangement.veld.vanaf": "De prijs is een vanafprijs",
    "pensionArrangement.veld.actief": "Actief: de balie kan het kiezen",
    "pensionArrangement.veld.foto": "Foto",
    "pensionArrangement.veld.effectdatum": "Vanaf",
    "pensionArrangement.veld.bedrag": "Bedrag incl. btw",
    "pensionArrangement.veld.reden": "Reden",
    "pensionArrangement.foto.kies": "Foto kiezen",
    "pensionArrangement.foto.anders": "Andere foto",
    "pensionArrangement.foto.weg": "Foto weghalen",
    "pensionArrangement.foto.voorbeeld": "Foto van het arrangement",
    "pensionArrangement.foto.uitleg": "JPG, PNG of WEBP. Grote foto's worden verkleind.",
    "pensionArrangement.fout.recht": "Je mag geen tarieven wijzigen.",
    "pensionArrangement.fout.ongeldig": "Controleer de gegevens.",
    "pensionArrangement.fout.algemeen": "Opslaan is mislukt. Probeer het opnieuw.",
    "pensionArrangement.fout.foto": "Kies een JPG, PNG of WEBP.",
    "pensionArrangement.fout.naam": "De naam is verplicht.",
    "pensionArrangement.fout.bedrag": "Vul een datum en een bedrag in.",
    "pensionArrangement.fout.verleden": "Een prijs met terugwerkende kracht vraagt beheerrechten voor tarieven.",
    "pensionArrangement.prijs.titel": "Prijs van %s",
    "pensionArrangement.prijs.huidig": "Nu:",
    "pensionArrangement.prijs.legend": "Prijs",
    "pensionArrangement.prijs.nieuwUitleg": "Vul de prijs in die geldt vanaf de ingangsdatum.",
    "pensionArrangement.prijs.wijzigUitleg": "Vul een nieuw bedrag in om de prijs vanaf de opgegeven datum te wijzigen; de eerdere prijzen blijven in de tabel hieronder staan.",
    "pensionArrangement.prijs.geenHistorie": "Nog geen prijs.",
    "pensionArrangement.prijs.velduitleg": "Laat het bedrag leeg om de prijs te laten zoals hij is. Een nieuw bedrag gaat in op de opgegeven datum en blijft in de prijshistorie staan.",
    "pensionArrangement.prijs.bedragPlaats": "bijv. 23,50",
    "pensionArrangement.prijs.sinds": "sinds %s",
    "pensionArrangement.prijs.opslaan": "Prijs opslaan",
    "pensionArrangement.prijs.opgeslagen": "De prijs is opgeslagen.",
    "pensionArrangement.verwijder.titel": "%s verwijderen",
    "pensionArrangement.verwijder.bevestig": "Verwijderen",
    "pensionArrangement.verwijder.uitleg": "Het arrangement en zijn prijzen verdwijnen. Wat al op een reservering staat, blijft daar staan.",
    "menu.crecheTarief": "Crèche tarieven",
    "menu.asielTarief": "Asiel tarieven",
    "menu.dierenambulanceTarief": "Dierenambulance tarieven",
    "menu.crematoriumTarief": "Crematorium tarieven",
    "menu.crematoriumVervoer": "Crematorium vervoer",
    "menu.crematoriumDashboard": "Dashboard",
    "menu.crematoriumAanmeldingen": "Aanmeldingen",
    "menu.crematoriumCrematies": "Dossiers",
    "menu.crematoriumPlanning": "Planning",
    "menu.crematoriumRuns": "Crematieruns",
    "menu.crematoriumAsRetour": "As & urn retour",
    "menu.crematoriumFacturen": "Facturen",
    "menu.crematoriumInstellingen": "Instellingen / tarieven",
    "menu.communicatie": "Communicatie",
    // sidebar-menu-parity: Vestigingen (Security) legacy hand-off — exact Jmix-label.
    "menu.vestigingen": "Vestigingen",
    "menu.users": "Gebruikers",
    // vestigingen-beheer: het vestigingenbeheerscherm (Security-menu). Alleen-bewerken master/detail.
    "vestigingenBeheer.new": "Nieuwe",
    "vestigingenBeheer.new.disabled": "Een vestiging kan hier niet worden aangemaakt: elke vestiging hoort één-op-één bij zijn eigen klant, en die moet er eerst zijn.",
    "vestigingenBeheer.eyebrow": "Vestiging",
    "vestigingenBeheer.field.status": "Status",
    "vestigingenBeheer.field.ubn": "UBN",
    "vestigingenBeheer.field.defaultModule": "Openen in module",
    "vestigingenBeheer.groep.add": "Groep toevoegen",
    "vestigingenBeheer.groep.change": "Groep wijzigen",
    "vestigingenBeheer.groep.linked": "Gekoppelde groep",
    "vestigingenBeheer.groep.remove": "Groep loskoppelen",
    "vestigingenBeheer.groep.empty": "Niet aan een groep gekoppeld",
    "vestigingenBeheer.title": "Vestigingen",
    "vestigingenBeheer.searchLabel": "Zoeken",
    "vestigingenBeheer.searchPlaceholder": "Naam, plaats of code…",
    "vestigingenBeheer.filterLabel": "Status",
    "vestigingenBeheer.filter.all": "Alle",
    "vestigingenBeheer.filter.active": "Actief",
    "vestigingenBeheer.filter.inactive": "Inactief",
    "vestigingenBeheer.col.naam": "Vestiging",
    "vestigingenBeheer.col.status": "Status",
    "vestigingenBeheer.status.active": "Actief",
    "vestigingenBeheer.status.inactive": "Inactief",
    "vestigingenBeheer.loadFailed": "Vestigingen konden niet worden geladen.",
    "vestigingenBeheer.saveFailed": "Opslaan mislukt.",
    "vestigingenBeheer.empty": "Geen vestigingen gevonden.",
    "vestigingenBeheer.detail.empty": "Selecteer een vestiging om de gegevens te bekijken.",
    "vestigingenBeheer.group.basis": "Basisinformatie",
    "vestigingenBeheer.group.contact": "Contactgegevens",
    "vestigingenBeheer.group.bedrijf": "Bedrijfsgegevens",
    "vestigingenBeheer.group.adres": "Adresgegevens",
    "vestigingenBeheer.group.postadres": "Postadres",
    "vestigingenBeheer.postadres.empty": "Geen afwijkend postadres ingesteld",
    "vestigingenBeheer.group.groep": "Groepen",
    "vestigingenBeheer.group.logo": "Logo",
    "vestigingenBeheer.logo.choose": "Logo kiezen",
    "vestigingenBeheer.logo.replace": "Logo vervangen",
    "vestigingenBeheer.logo.remove": "Weghalen",
    "vestigingenBeheer.logo.busy": "Bezig…",
    "vestigingenBeheer.logo.hint": "Een png, jpg, webp of svg van hoogstens 2 MB. Komt op de eigen pagina van deze vestiging op DierMatch.",
    "vestigingenBeheer.logo.failed": "Het logo kon niet bewaard worden.",
    "vestigingenBeheer.group.whatsapp": "WhatsApp",
    "vestigingenBeheer.whatsapp.gekoppeld": "Gekoppeld nummer",
    "vestigingenBeheer.whatsapp.gekoppeldOp": "Gekoppeld op",
    "vestigingenBeheer.whatsapp.door": "door",
    "vestigingenBeheer.whatsapp.nietGekoppeld": "Deze vestiging heeft nog geen eigen WhatsApp-nummer.",
    "vestigingenBeheer.whatsapp.uitleg": "Log in met het Facebook-account van de vestiging en kies of maak een WhatsApp-nummer. Berichten vanuit de relatietegel gaan daarna vanaf dit nummer.",
    "vestigingenBeheer.whatsapp.koppelen": "WhatsApp koppelen",
    "vestigingenBeheer.whatsapp.opnieuw": "Ander nummer koppelen",
    "vestigingenBeheer.whatsapp.bezig": "Bezig met koppelen…",
    "vestigingenBeheer.whatsapp.ontkoppelen": "Ontkoppelen",
    "vestigingenBeheer.whatsapp.ontkoppelenVraag": "Dit WhatsApp-nummer loskoppelen van de vestiging? Bij Meta blijft het nummer van jullie.",
    "vestigingenBeheer.whatsapp.nietIngericht": "Koppelen met WhatsApp is voor deze organisatie nog niet ingericht.",
    "vestigingenBeheer.whatsapp.afgebroken": "Het koppelen is afgebroken; er is niets veranderd.",
    "vestigingenBeheer.whatsapp.metaFout": "Meta meldde een fout tijdens het koppelen.",
    "vestigingenBeheer.whatsapp.geenNummer": "Meta gaf geen nummer terug. Probeer het opnieuw.",
    "vestigingenBeheer.whatsapp.sdkFout": "De Facebook-inlog kon niet geladen worden. Staat er een blokkering aan in de browser?",
    "vestigingenBeheer.whatsapp.mislukt": "Koppelen lukte niet.",
    "vestigingenBeheer.whatsapp.laadFout": "De WhatsApp-stand kon niet geladen worden.",
    "vestigingenBeheer.field.code": "Code",
    "vestigingenBeheer.field.naamKort": "Kort",
    "vestigingenBeheer.field.naam": "Naam",
    "vestigingenBeheer.field.telefoonnummer": "Telefoonnr. 1",
    "vestigingenBeheer.field.mobielnummer": "Telefoonnr. 2",
    "vestigingenBeheer.field.noodnummer": "Noodnummer pleeggezin",
    "vestigingenBeheer.field.noodnummer.placeholder": "Staat in de pleeggezin-app, 24/7 bereikbaar",
    "vestigingenBeheer.field.emailAdres": "E-mailadres",
    "vestigingenBeheer.field.website": "Website",
    "vestigingenBeheer.field.kvkNummer": "KvK nr.",
    "vestigingenBeheer.field.btwNummer": "BTW nr.",
    "vestigingenBeheer.field.bankRekeningNummer": "Bank/giro",
    "vestigingenBeheer.field.straat": "Straat",
    "vestigingenBeheer.field.huisnummer": "Huisnummer",
    "vestigingenBeheer.field.postcode": "Postcode",
    "vestigingenBeheer.field.woonplaats": "Woonplaats",
    "vestigingenBeheer.field.land": "Land",
    "vestigingenBeheer.field.postbusNummer": "Postbus",
    "vestigingenBeheer.field.postbusPostcode": "Postcode",
    "vestigingenBeheer.field.postbusWoonplaats": "Woonplaats",
    "vestigingenBeheer.field.groep": "Groep",
    "vestigingenBeheer.field.groep.placeholder": "Naam van de groep",
    "vestigingenBeheer.postadres.copy": "Overnemen van bezoekadres",
    "menu.serviceAccounts": "Service Accounts",
    "menu.moduleManagement": "Modulebeheer",
    "menu.legacyHint": "Opent in de klassieke Backoffice",
    "menu.devTools.title": "Ontwikkeling",
    "menu.gallery.components": "Componenten gallery",
    "menu.gallery.tiles": "Tegels gallery",
    "moduleManagementView.title": "Modulebeheer",
    "moduleManagementView.intro":
      "Zet functionele modules organisatie-breed aan of uit. Een sub-module is niet beschikbaar zolang de bovenliggende module uit staat.",
    "moduleManagementView.loadFailed": "De modules konden niet worden geladen.",
    "module.dashboard": "Dashboard",
    "module.communicatie": "Communicatie",
    "module.backofficeTest": "Testgereedschap",
    "module.group.kern": "Kern",
    "module.group.opvang": "Opvang",
    "module.group.communicatie": "Communicatie",
    "module.group.modules": "Modules",
    "module.group.datatools": "Datagereedschap",
    "module.asiel": "Asiel (opvang)",
    "module.asiel.desc":
      "Kern shelter-operatie: opname, aanwezigheid, plaatsingen, asiel-/ambulance-tarief en verblijven. Hieronder vallen pleeggezin, verblijfplanning, uitwisselingen en donateur.",
    "module.pleeggezin": "Pleeggezin",
    "module.pleeggezin.desc": "Pleeggezin-tab op het relatiescherm (foster-programma).",
    "module.kennelplanning": "Verblijfplanning",
    "module.kennelplanning.desc": "Planning en bezetting van verblijven/verblijven.",
    "module.shelterExchanges": "Uitwisselingen",
    "module.shelterExchanges.desc": "Onderlinge uitwisseling van dieren tussen asielen.",
    "module.donateur": "Donateur",
    "module.donateur.desc": "Donateur-tab op het relatiescherm (donaties, periodieke giften, fiscaal).",
    "module.pension": "Pension",
    "module.pension.desc": "Dierenpension (boarding) met eigen tarief-scherm.",
    "module.creche": "Crèche",
    "module.creche.desc": "Dagopvang/crèche met eigen tarief-scherm.",
    "module.crematorium": "Crematorium",
    "module.crematorium.desc":
      "Crematie- en uitvaartproces voor huisdieren: aanmelding, ophalen, dossier, planning, as-retour en facturatie.",
    "module.advertentie": "Advertentie & AI",
    "module.advertentie.desc":
      "Adoptieadvertenties opstellen met AI-hulp, controleren en goedkeuren, publiceren naar ikzoekbaas.nl en social-media materiaal genereren.",
    "module.taken": "Taken",
    "module.taken.desc":
      "Automatische en handmatige taken rond een dier: tegel en tab Taken op het dierprofiel en de beheerschermen voor automatische taakregels en takenpakketten.",
    "module.wizards": "Registraties & Wizards",
    "module.wizards.desc":
      "Configureerbare registratiewizards (stappen en velden) met een dynamische tegel op het dier; beheerd via Instellingen → Registraties & Wizards.",
    "module.nazorg": "Nazorg",
    "module.nazorg.desc":
      "Adoptie-nazorg: vragenlijsten per contactmoment, ingevuld door de adoptant via het platform, met rode-vlag-signalering, welzijnsscore en een nazorg-dossier op het dier.",
    "module.leverancier": "Leverancier",
    "module.leverancier.desc": "Leveranciersbeheer (eigen scherm in de menugroep Modules).",
    "serviceAccountSelfServiceView.title": "Mijn account",
    "serviceAccountCreateView.title": "Nieuw serviceaccount",
    "serviceAccountListView.empty": "Geen serviceaccounts.",
    "serviceAccountListView.loadFailed": "Kon serviceaccounts niet laden.",
    "serviceAccountDetailView.loadFailed": "Kon serviceaccount niet laden.",
    "serviceAccountDetailView.edit": "Bewerken",
    "serviceAccountDetailView.credentials.none": "Geen credentials.",
    "serviceAccountDetailView.allowlist.none": "Geen IP-reeksen.",
    "productListView.title": "Producten & Diensten",
    "productListView.empty": "Geen producten.",
    "productListView.loadFailed": "Kon producten niet laden.",
    "productListView.search.placeholder": "Zoeken…",
    "productListView.refresh": "Vernieuwen",
    "productListView.kpi.totaleOmzet": "Totale omzet",
    "productListView.kpi.totaleOmzet.sub": "Laatste 12 maanden",
    "productListView.kpi.dezeMaand": "Verkocht deze maand",
    "productListView.kpi.korting": "Korting gegeven",
    "productListView.column.naam": "Naam",
    "productListView.column.artikelCode": "Artikelcode",
    "productListView.column.onderdeel": "Onderdeel",
    "productListView.column.type": "Type",
    "productListView.column.prijs": "Prijs",
    "productListView.column.scope": "Scope",
    "productListView.column.omzet": "Omzet",
    "productListView.column.stock": "Huidige voorraad",
    "productListView.onderdeel.fallback": "Algemeen",
    "productListView.stock.restricted": "Afgeschermd",
    "productListView.stock.value": "Voorraad: %d",
    "productListView.column.open": "",
    "productListView.open": "Openen",
    "productListView.scope.label": "Scope",
    "productListView.filter.onderdeel": "Onderdeel",
    "productListView.filter.type": "Type",
    "productListView.filter.all": "Alle",
    "catalogus.weergave": "Weergave",
    "catalogus.weergave.kaart": "Kaarten",
    "catalogus.weergave.compact": "Compacte kaarten",
    "catalogus.weergave.lijst": "Lijst",
    "productListView.sort.label": "Sorteren op",
    "productListView.actions.label": "Rij-acties",
    "productListView.actions.edit": "Bewerken",
    "productListView.actions.delete": "Verwijderen",
    "productListView.delete.title": "Product verwijderen",
    "productListView.delete.body": "%s verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "productListView.delete.confirm": "Verwijderen",
    "productListView.delete.failed": "Het product kon niet worden verwijderd.",
    "productListView.actions.priceChange": "Prijs wijzigen…",
    "productListView.actions.history": "Historie tonen…",
    "productListView.pagination.range": "%d–%d van %d",
    "pager.range": "%d–%d van %d resultaten",
    "pager.pageSize": "Rijen per pagina:",
    "pager.page": "Pagina %d",
    "productListView.pagination.page": "Pagina %d van %d",
    "productListView.pagination.previous": "Vorige",
    "productListView.pagination.next": "Volgende",
    // tarief-bewerkscherm (Story 1.6) — prijswijziging- + historie-dialogs gekoppeld aan het seam.
    "productPrijsWijziging.title": "Prijs wijzigen: %s",
    "productPrijsWijziging.current": "Huidige prijs",
    "productPrijsWijziging.bedrag": "Nieuwe prijs",
    "productPrijsWijziging.effectdatum": "Effectdatum",
    "productPrijsWijziging.reden": "Reden (optioneel)",
    "productPrijsWijziging.strategy.label": "Lopende reserveringen",
    "productPrijsWijziging.strategy.BEHOUDEN_OUDE_PRIJS": "Niet aanpassen — oude prijs blijft op die reserveringen",
    "productPrijsWijziging.strategy.ALLEMAAL_AANPASSEN": "Allemaal aanpassen",
    "productPrijsWijziging.strategy.HANDMATIGE_SELECTIE": "Selectie tonen en handmatig kiezen",
    "productPrijsWijziging.mailen": "Klanten van aangepaste reserveringen mailen",
    "productPrijsWijziging.banner": "Er zijn %d lopende reserveringen vanaf de effectdatum die de oude prijs gebruiken.",
    "productPrijsWijziging.bedragRequired": "Vul een nieuwe prijs in.",
    "productPrijsWijziging.submit": "Doorvoeren",
    "productPrijsWijziging.cancel": "Annuleren",
    "productPrijsWijziging.success": "Prijs gewijzigd. Nieuwe versie aangemaakt.",
    "productPrijsWijziging.successAffected": "Prijs gewijzigd. %d reserveringen herrekend.",
    "productPrijsWijziging.error": "Prijswijziging mislukt.",
    "productPrijsWijziging.pastForbidden": "Alleen een beheerder mag een prijswijziging terugwerkend doorvoeren.",
    "productTariefHistorie.title": "Tariefhistorie: %s",
    "productTariefHistorie.empty": "Geen tariefversies bekend voor dit product.",
    "productTariefHistorie.loadFailed": "Kon de tariefhistorie niet laden.",
    "productTariefHistorie.column.vanaf": "Vanaf",
    "productTariefHistorie.column.tot": "Tot",
    "productTariefHistorie.column.bedrag": "Bedrag",
    "productTariefHistorie.column.reden": "Reden",
    "productTariefHistorie.column.status": "Status",
    "productTariefHistorie.status.GEPLAND": "Gepland",
    "productTariefHistorie.status.ACTIEF": "Actief",
    "productTariefHistorie.status.VERVALLEN": "Vervallen",
    "productTariefHistorie.count": "%d versie(s) gevonden",
    "productTariefHistorie.close": "Sluiten",
    // products-migration Story 1.3 — read-only productdetail (zes tegels, Jmix-pariteit).
    "productDetailView.loadFailed": "Kon product niet laden.",
    "productDetailView.identity.subtitle": "Product",
    "productDetailView.tile.basis": "Basisinformatie",
    "productDetailView.tile.classificatie": "Classificatie & codes",
    "productDetailView.tile.voorraad": "Voorraad",
    "productDetailView.tile.prijzen": "Prijzen",
    "productDetailView.tile.boekhouding": "Boekhouding",
    "productDetailView.tile.metadata": "Metadata & eigenschappen",
    "productDetailView.basis.naam": "Productnaam",
    "productDetailView.basis.onderdeel": "Onderdeel",
    "productDetailView.onderdeel.fallback": "Algemeen",
    "productDetailView.basis.type": "Type",
    "productDetailView.basis.scope": "Scope",
    "productDetailView.basis.omschrijving": "Korte omschrijving",
    "productDetailView.classificatie.artikelCode": "Artikelcode / SKU",
    "productDetailView.classificatie.leverancier": "Leverancier",
    "productDetailView.classificatie.ean": "EAN",
    "productDetailView.classificatie.eanPlaceholder": "EAN code",
    "productDetailView.classificatie.leverancierProductNrPlaceholder": "Leverancier productnr.",
    "productDetailView.classificatie.eenheidPlaceholder": "Selecteer eenheid",
    "productDetailView.metadata.jsonPlaceholder": "Bijv. { \"medisch\": true, \"koeling\": \"ja\", \"online\": false }",
    "productDetailView.classificatie.leverancierProductNr": "Leverancier productnr.",
    "productDetailView.classificatie.verkoopeenheid": "Verkoopeenheid",
    "productDetailView.classificatie.inkoopeenheid": "Eenheid inkoop",
    "productDetailView.voorraad.beheer": "Voorraadbeheer voor dit product",
    "productDetailView.voorraad.beheer.on": "Aan",
    "productDetailView.voorraad.beheer.off": "Uit",
    "productDetailView.voorraad.minimum": "Minimum voorraad",
    "productDetailView.voorraad.maximum": "Maximum voorraad",
    "productDetailView.voorraad.huidig": "Huidige voorraad",
    "productDetailView.voorraad.besteleenheid": "Bestelhoeveelheid",
    "productDetailView.prijzen.vanaf": "Vanaf",
    "productDetailView.prijzen.verkoop": "Verkoop",
    "productDetailView.prijzen.inkoop": "Inkoop",
    "productDetailView.prijzen.btw": "BTW",
    "productDetailView.prijzen.empty": "Geen prijsregels.",
    "productDetailView.prijzen.add": "Prijsregel toevoegen",
    "productDetailView.prijzen.remove": "Prijsregel verwijderen",
    "productDetailView.prijzen.remove.confirm": "Deze prijsregel verwijderen?",
    "productDetailView.prijzen.dialog.title": "Prijsregel toevoegen",
    "productDetailView.prijzen.dialog.vanaf": "Vanaf",
    "productDetailView.prijzen.dialog.btw": "BTW",
    "productDetailView.prijzen.dialog.verkoop": "Verkoopprijs",
    "productDetailView.prijzen.dialog.inkoop": "Inkoopprijs",
    "productDetailView.prijzen.dialog.inkoop.optional": "(Optioneel)",
    "productDetailView.prijzen.dialog.submit": "Toevoegen",
    "productDetailView.prijzen.dialog.required": "Een verkoopprijs en BTW zijn verplicht.",
    "productDetailView.prijzen.dialog.error": "Kon de prijsregel niet toevoegen.",
    "productDetailView.prijzen.remove.error": "Kon de prijsregel niet verwijderen.",
    // products-migration Story 4.3 — Voorraadmutatie tijdlijn + boeken.
    "productDetailView.voorraad.mutaties": "↗ Mutaties",
    "productDetailView.mutaties.dialog.title": "Voorraadmutaties — %s",
    "productDetailView.mutaties.huidig": "Huidige voorraad:",
    "productDetailView.mutaties.book": "Mutatie boeken",
    "productDetailView.mutaties.close": "Sluiten",
    "productDetailView.mutaties.empty": "Geen voorraadmutaties.",
    "productDetailView.factuurregel.view": "Factuurregel bekijken",
    "productDetailView.factuurregel.title": "Factuurregel",
    "productDetailView.factuurregel.close": "Sluiten",
    "productDetailView.factuurregel.nummer": "Factuurnummer",
    "productDetailView.factuurregel.datum": "Factuurdatum",
    "productDetailView.factuurregel.soort": "Soort",
    "productDetailView.factuurregel.product": "Product",
    "productDetailView.factuurregel.regelAantal": "Aantal op regel",
    "productDetailView.factuurregel.stuksPrijs": "Stuksprijs incl. btw",
    "productDetailView.factuurregel.effect": "Effect op voorraad",
    "productDetailView.mutaties.col.datum": "Datum",
    "productDetailView.mutaties.col.bron": "Bron",
    "productDetailView.mutaties.col.soort": "Soort",
    "productDetailView.mutaties.col.omschrijving": "Omschrijving",
    "productDetailView.mutaties.col.aantal": "Aantal",
    "productDetailView.mutaties.col.voorraadNa": "Voorraad na",
    "productDetailView.mutaties.bron.HANDMATIG": "Handmatig",
    "productDetailView.mutaties.bron.VERKOOP": "Verkoop",
    "productDetailView.mutaties.book.title": "Voorraadmutatie boeken",
    "productDetailView.mutaties.book.datum": "Datum",
    "productDetailView.mutaties.book.richting": "Richting",
    "productDetailView.mutaties.book.opboeking": "Opboeking (bij voorraad)",
    "productDetailView.mutaties.book.afboeking": "Afboeking (uit voorraad)",
    "productDetailView.mutaties.book.aantal": "Aantal",
    "productDetailView.mutaties.book.soort": "Soort",
    "productDetailView.mutaties.book.reden": "Reden / toelichting",
    "productDetailView.mutaties.book.submit": "Boeken",
    "productDetailView.mutaties.book.required": "Een aantal groter dan 0 is verplicht.",
    "productDetailView.mutaties.book.error": "Kon de mutatie niet boeken.",
    "productDetailView.mutaties.soort.INKOOP": "Inkoop / ontvangst",
    "productDetailView.mutaties.soort.RETOUR": "Retour van klant",
    "productDetailView.mutaties.soort.CORRECTIE": "Telcorrectie",
    "productDetailView.mutaties.soort.AFSCHRIJVING": "Afschrijving / breuk",
    "productDetailView.mutaties.soort.OVERIG": "Overig",
    "productDetailView.boekhouding.advanced": "Geavanceerd",
    "productDetailView.boekhouding.grootboekrekening": "Grootboekrekening",
    "productDetailView.boekhouding.projectcode": "Projectcode",
    "productDetailView.boekhouding.grootboekrekeningKorting": "Grootboekrekening korting",
    "productDetailView.boekhouding.kostenplaats": "Kostenplaats",
    "productDetailView.metadata.json": "JSON eigenschappen",
    "productDetailView.metadata.helper": "Vul JSON in om extra metadata te bewaren (medisch, voorraad, online, …).",
    "productDetailView.metadata.invalid": "Geen geldige JSON — corrigeer dit voor het opslaan.",
    "productDetailView.productType.VERKOOP": "Verkoop",
    "productDetailView.productType.DIENST": "Dienst",
    "productDetailView.productType.ENTING": "Enting",
    "productDetailView.productType.MEDICIJN": "Medicijn",
    "productDetailView.productType.APOTHEEK": "Apotheek",
    "productDetailView.productType.ONTWORMEN": "Ontwormen & ontvlooien",
    "productDetailView.productType.ONTVLOOIEN": "Ontvlooien",
    "productDetailView.scopeType.ORGANISATIE": "Hele organisatie",
    // The catalogue chip is a narrow column; acc labels it just "Organisatie" so it stays on one line.
    "productListView.scope.ORGANISATIE": "Organisatie",
    "productDetailView.scopeType.VESTIGING": "Alleen deze vestiging",
    "productDetailView.scopeType.BEIDE": "Beide",
    // products-migration Story 2.4 — bewerkbare tegels + aanmaken.
    "productEditView.title": "Product wijzigen",
    "productEditView.edit": "Bewerken",
    "productEditView.cancel": "Annuleren",
    "productEditView.save": "Opslaan",
    "productEditView.saved": "Opgeslagen.",
    "productEditView.saveError": "Kon niet opslaan. Probeer het opnieuw.",
    "productEditView.saveConflict": "Gewijzigd door iemand anders — laad het scherm opnieuw en probeer het nogmaals.",
    "productEditView.naamRequired": "Een productnaam is verplicht.",
    "productEditView.select.none": "—",
    "productEditView.new": "Nieuw",
    "productEditView.create.title": "Nieuw product",
    "productEditView.create.naam": "Productnaam",
    "productEditView.create.onderdeel": "Onderdeel",
    "productEditView.create.type": "Type",
    "productEditView.create.scope": "Scope",
    "productEditView.create.submit": "Aanmaken",
    "productEditView.create.error": "Kon het product niet aanmaken.",
    // products-migration Story 5.1 — Tegels (zichtbaarheid) dialog.
    "productDetailView.tegels": "Tegels",
    "productDetailView.tegels.title": "Tegels tonen / verbergen",
    "productDetailView.tegels.error": "Kon de tegelinstellingen niet opslaan.",
    // products-migration Story 5.2 — beveiligd verwijderen.
    "productDetailView.delete": "Verwijderen",
    "productDetailView.delete.confirm": "Dit product definitief verwijderen?",
    "productDetailView.delete.done": "Product verwijderd.",
    "productDetailView.delete.error": "Kon het product niet verwijderen. Probeer het opnieuw.",
    "productDetailView.tab.product": "Product",
    "productDetailView.tab.entingen": "Entingen",
    "productDetailView.tab.behandeling": "Ontwormen & ontvlooien",
    "productDetailView.tab.medicijn": "Medicijn",
    // products-migration (analytics tabs) — overzicht-tabstrip + Statistieken + Trends.
    "productOverview.tabs.label": "Producten & Diensten tabbladen",
    "productOverview.tab.catalogus": "Catalogus",
    "productOverview.tab.statistieken": "Statistieken",
    "productOverview.tab.trends": "Trends",
    // verblijf-wizard-tarief Epic 2 — Asiel tarief overzicht (Hond & Kat regel-tab).
    "asielTarief.tabs.label": "Asiel tarieven tabbladen",
    "asielTarief.tab.hondkat": "Hond & Kat",
    "asielTarief.tab.overige": "Overige diersoorten",
    "asielTarief.tab.retour": "Retour eigenaar",
    "asielTarief.placeholder.overige": "Tarieven overige diersoorten — volgt.",
    "asielTarief.placeholder.retour": "Retour-eigenaar tarieven — volgt.",
    "asielTarief.search": "Zoek regels",
    "asielTarief.empty": "Nog geen actieve regels.",
    "asielTarief.load.error": "De regels konden niet worden geladen.",
    "asielTarief.action.add": "Regel toevoegen",
    "asielTarief.action.ai": "Laat AI je helpen",
    "asielTarief.action.test": "Test tarief",
    "asielTarief.action.parallelRun": "Parallelle run",
    "asielTarief.action.parallelRun.todo": "Reconciliatie (Epic 6) — volgt",
    "asielTarief.recon.title": "Parallelle run — legacy versus tariefmotor",
    "asielTarief.recon.summary": "%s vergelijkingen — %s gelijk, %s afwijkend",
    "asielTarief.recon.summary.aligned": "✓ Legacy en motor zijn volledig in lijn; legacy kan verborgen worden.",
    "asielTarief.recon.summary.diff": "— los de afwijkingen op vóór het verbergen van legacy.",
    "asielTarief.recon.col.vestiging": "Vestiging",
    "asielTarief.recon.col.diersoort": "Diersoort",
    "asielTarief.recon.col.proces": "Proces",
    "asielTarief.recon.col.legacy": "Legacy",
    "asielTarief.recon.col.motorStatus": "Motor-status",
    "asielTarief.recon.col.motor": "Motor",
    "asielTarief.recon.col.status": "Status",
    "asielTarief.recon.col.opmerking": "Opmerking",
    "asielTarief.recon.gelijk": "gelijk",
    "asielTarief.recon.afwijkend": "afwijkend",
    "asielTarief.recon.empty": "Geen legacy-prijscategorieën om te vergelijken.",
    "asielTarief.recon.error": "Het reconciliatierapport kon niet worden geladen.",
    "asielTarief.action.refresh": "Vernieuwen",
    "asielTarief.action.deactivate": "Deactiveren",
    "asielTarief.deactivate.confirm": "Regel \"%s\" deactiveren?",
    "asielTarief.col.naam": "Naam",
    "asielTarief.col.condities": "Voorwaarden",
    "asielTarief.col.resultaat": "Resultaat",
    "asielTarief.col.prioriteit": "Prioriteit",
    "asielTarief.col.acties": "Acties",
    "asielTarief.result.none": "—",
    "asielTarief.result.useLabel": "(vrije omschrijving gebruiken)",
    "asielTarief.condition.any": "Alles (matcht altijd)",
    "asielTarief.notice.conflict": "Opslaan mislukt: de regel is intussen gewijzigd.",
    "asielTarief.notice.forbidden": "U bent niet gemachtigd om tarieven te bewerken.",
    "asielTarief.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "asielTarief.dialog.new.title": "Nieuwe tariefregel",
    "asielTarief.dialog.edit.title": "Tariefregel bewerken",
    "asielTarief.dialog.warnings.title": "Mogelijke conflicten (de regel is opgeslagen):",
    "asielTarief.dialog.warnings.continue": "Begrepen, doorgaan",
    "asielTarief.section.voorwaarden": "Voorwaarden",
    "asielTarief.section.resultaat": "Resultaat",
    "asielTarief.section.berekening": "Berekening",
    "asielTarief.field.naam": "Naam",
    "asielTarief.field.naam.required": "Naam is verplicht.",
    "asielTarief.field.conditieOperator": "Voorwaarden combineren met",
    "asielTarief.operator.and": "EN (alle moeten matchen)",
    "asielTarief.operator.or": "OF (één mag matchen)",
    "asielTarief.cond.attribuut": "Attribuut",
    "asielTarief.cond.operator": "Operator",
    "asielTarief.cond.waarde": "Waarde",
    "asielTarief.cond.add": "Voorwaarde toevoegen",
    "asielTarief.cond.remove": "Voorwaarde verwijderen",
    "asielTarief.field.resultaatProduct": "Resultaatproduct",
    "asielTarief.field.resultaatLabel": "Vrije resultaat-omschrijving",
    "asielTarief.field.priceMode": "Prijsmodus",
    "asielTarief.field.calculationMethod": "Berekeningsmethode",
    "asielTarief.field.eigenBedrag": "Eigen bedrag (€)",
    "asielTarief.field.dagBedrag": "Dagbedrag (€)",
    "asielTarief.field.bedragPerKm": "Bedrag per km (€)",
    "asielTarief.field.minDagen": "Minimum dagen",
    "asielTarief.field.dagTelling": "Dagtelling",
    "asielTarief.field.factureerPer": "Factureer per",
    "asielTarief.field.afronding": "Afronding",
    "asielTarief.field.btwCode": "Btw-code",
    "asielTarief.field.prioriteit": "Prioriteit",
    "asielTarief.field.alleMatches": "Alle matchende regels toepassen",
    "asielTarief.option.none": "(geen)",
    "asielTarief.attr.DIERSOORT": "Diersoort",
    "asielTarief.attr.DIERSOORT_GROEP": "Diersoortgroep",
    "asielTarief.attr.GESLACHT": "Geslacht",
    "asielTarief.attr.VERTREK_TYPE": "Proces",
    "asielTarief.attr.LEEFTIJD": "Leeftijd (maanden)",
    "asielTarief.attr.GEWICHT": "Gewicht (kg)",
    "asielTarief.attr.GECASTREERD": "Gecastreerd",
    "asielTarief.attr.CHIP": "Gechipt",
    "asielTarief.op.EQUALS": "is gelijk aan",
    "asielTarief.op.IN": "in",
    "asielTarief.op.LT": "kleiner dan",
    "asielTarief.op.GT": "groter dan",
    "asielTarief.op.BETWEEN": "tussen",
    "asielTarief.calc.FIXED_AMOUNT": "Vast bedrag",
    "asielTarief.calc.PER_DAY": "Per dag",
    "asielTarief.calc.BASE_PLUS_DISTANCE": "Basis + afstand",
    "asielTarief.calc.SURCHARGE": "Toeslag",
    "asielTarief.calc.NONE": "Geen",
    "asielTarief.priceMode.FIXED": "Vast",
    "asielTarief.priceMode.FROM_AMOUNT": "Vanaf bedrag",
    "asielTarief.priceMode.FREE": "Gratis",
    "asielTarief.priceMode.MANUAL_QUOTE": "Handmatige offerte",
    "asielTarief.priceMode.IN_CONSULTATION": "In overleg",
    "asielTarief.dayCount.INCLUSIVE_BOTH": "Beide dagen inclusief",
    "asielTarief.dayCount.INCLUSIVE_FIRST": "Eerste dag inclusief",
    "asielTarief.dayCount.PER_NIGHT": "Per nacht",
    "asielTarief.billPer.DAY": "Dag",
    "asielTarief.billPer.NIGHT": "Nacht",
    "asielTarief.rounding.GEEN": "Geen",
    "asielTarief.rounding.CENTEN_HALF_UP": "Centen (naar boven)",
    "asielTarief.status.MATCHED": "Match",
    "asielTarief.status.NO_MATCH": "Geen match",
    "asielTarief.status.CONFLICT": "Conflict",
    "asielTarief.status.MANUAL_QUOTE": "Handmatige offerte",
    "asielTarief.test.title": "Test tarief (dry run)",
    "asielTarief.test.run": "Test uitvoeren",
    "asielTarief.test.diersoort": "Diersoort",
    "asielTarief.test.proces": "Proces",
    "asielTarief.test.leeftijd": "Leeftijd (maanden)",
    "asielTarief.test.gewicht": "Gewicht (kg)",
    "asielTarief.test.geslacht": "Geslacht",
    "asielTarief.test.datum": "Peildatum",
    "asielTarief.test.kilometers": "Afstand (km)",
    "asielTarief.test.dagen": "Aantal dagen",
    "asielTarief.test.gecastreerd": "Gecastreerd",
    "asielTarief.test.gechipt": "Gechipt",
    "asielTarief.test.kandidaten": "Kandidaat-regels",
    "asielTarief.test.noKandidaten": "Geen kandidaat-regels.",
    "asielTarief.test.col.regel": "Regel",
    "asielTarief.test.col.bereik": "Bereik",
    "asielTarief.test.col.specificiteit": "Specificiteit",
    "asielTarief.test.col.vestiging": "Vestiging-specifiek",
    "asielTarief.test.col.gekozen": "Gekozen",
    "asielTarief.test.col.reden": "Reden",
    "asielTarief.ai.title": "Regel beschrijven met AI",
    "asielTarief.ai.prompt": "Beschrijf de regel in gewone taal",
    "asielTarief.ai.generate": "Genereren",
    "asielTarief.ai.adopt": "Overnemen",
    // ── Overige diersoorten (DiersoortTariefknoop tree) ──
    "asielTarief.overige.empty": "Nog geen diersoort-knopen.",
    "asielTarief.overige.load.error": "De diersoort-boom kon niet worden geladen.",
    "asielTarief.overige.add": "Knoop toevoegen",
    "asielTarief.overige.col.naam": "Naam",
    "asielTarief.overige.col.plaatsing": "Plaatsing",
    "asielTarief.overige.col.afstand": "Afstand",
    "asielTarief.overige.col.adoptie": "Adoptie",
    "asielTarief.overige.col.acties": "Acties",
    "asielTarief.overige.inherited": "(geërfd)",
    "asielTarief.overige.none": "—",
    "asielTarief.overige.delete.confirm": "Knoop \"%s\" verwijderen?",
    "asielTarief.overige.dialog.new.title": "Nieuwe diersoort-knoop",
    "asielTarief.overige.dialog.edit.title": "Diersoort-knoop bewerken",
    "asielTarief.overige.field.naam": "Naam",
    "asielTarief.overige.field.naam.required": "Naam is verplicht.",
    "asielTarief.overige.field.parent": "Bovenliggende knoop",
    "asielTarief.overige.field.parent.none": "(bovenste niveau)",
    "asielTarief.overige.field.diersoortId": "Diersoort-id (optioneel)",
    "asielTarief.overige.field.bedragPlaatsing": "Bedrag plaatsing (€)",
    "asielTarief.overige.field.bedragAfstand": "Bedrag afstand (€)",
    "asielTarief.overige.field.bedragAdoptie": "Bedrag adoptie (€)",
    "asielTarief.overige.field.ervenVanParent": "Lege bedragen erven van bovenliggende knoop",
    "asielTarief.overige.field.positie": "Positie",
    "asielTarief.overige.legacyGrid.note":
      "De oude prijscategorie-tabel (AsielPrijsCategorie) valt onder reconciliatie (Epic 6) en wordt hier niet getoond.",
    // ── Retour Eigenaar (retour-eigenaar dagprijzen) ──
    "asielTarief.retour.empty": "Nog geen retour-eigenaar tarieven.",
    "asielTarief.retour.load.error": "De retour-eigenaar tarieven konden niet worden geladen.",
    "asielTarief.retour.add": "Tarief toevoegen",
    "asielTarief.retour.col.diersoort": "Diersoort",
    "asielTarief.retour.col.dagprijs": "Dagprijs",
    "asielTarief.retour.col.geldigVanaf": "Geldig vanaf",
    "asielTarief.retour.col.acties": "Acties",
    "asielTarief.retour.badge.nieuw": "Nieuw",
    "asielTarief.retour.none": "—",
    "asielTarief.retour.deactivate": "Deactiveren",
    "asielTarief.retour.deactivate.confirm": "Het tarief voor \"%s\" deactiveren?",
    "asielTarief.retour.dialog.title": "Retour-eigenaar tarieven toevoegen",
    "asielTarief.retour.field.diersoorten": "Diersoorten",
    "asielTarief.retour.field.diersoorten.required": "Kies minimaal één diersoort.",
    "asielTarief.retour.field.dagprijs": "Dagprijs (€)",
    "asielTarief.retour.field.dagprijs.required": "Een dagprijs is verplicht.",
    "asielTarief.retour.field.effectdatum": "Geldig vanaf",
    "asielTarief.retour.create": "Aanmaken",
    "asielTarief.retour.report.created": "%s tarief/tarieven aangemaakt.",
    "asielTarief.retour.report.skipped": "Overgeslagen (al actief): %s",
    "asielTarief.retour.notice.forbiddenPast":
      "Een datum in het verleden vereist tarief-beheerrechten.",
    "asielTarief.retour.notice.forbidden": "U bent niet bevoegd om tarieven te bewerken.",
    "asielTarief.retour.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "pensionTarief.dagprijs.accommodatie": "Accommodatie",
    "pensionTarief.dagprijs.standaard": "Standaard dagprijs",
    "pensionTarief.dagprijs.standaardWisselt": "wisselt binnen deze periode",
    "pensionTarief.dagprijs.geenStandaard": "nog niet ingesteld",
    "pensionTarief.dagprijs.geenTypes": "Deze vestiging heeft nog geen accommodatietypes.",
    "pensionTarief.dagprijs.vorige": "Vorige 3 maanden",
    "pensionTarief.dagprijs.vandaag": "Vandaag",
    "pensionTarief.dagprijs.volgende": "Volgende 3 maanden",
    "pensionTarief.dagprijs.legenda": "Legenda",
    "pensionTarief.dagprijs.afwijkend": "Afwijkende prijs",
    "pensionTarief.dagprijs.weekdagen": "Ma,Di,Wo,Do,Vr,Za,Zo",
    "pensionTarief.dagprijs.venstertitel": "Dagprijs",
    "pensionTarief.dagprijs.luxe": "Luxe",
    "pensionTarief.dagprijs.diersoort": "Diersoort",
    "pensionTarief.dagprijs.maxDieren": "Max. aantal dieren",
    "pensionTarief.dagprijs.dagAanpassen": "Dagprijs aanpassen",
    "pensionTarief.dagprijs.dagprijs": "Dagprijs",
    "pensionTarief.dagprijs.opslaan": "Opslaan",
    "pensionTarief.dagprijs.gebruikStandaard": "Gebruik standaard",
    "pensionTarief.dagprijs.periode": "Periodeprijs instellen",
    "pensionTarief.dagprijs.van": "Van",
    "pensionTarief.dagprijs.tot": "Tot en met",
    "pensionTarief.dagprijs.toepassen": "Toepassen",
    "pensionTarief.dagprijs.periodeHint": "Laat het bedrag leeg om deze dagen terug te zetten op de standaardprijs.",
    "pensionTarief.dagprijs.opslaanFout": "De dagprijs kon niet worden opgeslagen.",
    "pensionTarief.seizoen.laag": "Laagseizoen",
    "pensionTarief.seizoen.hoog": "Hoogseizoen",
    "pensionTarief.seizoen.perDag": "per dag",
    "pensionTarief.section.huidigVanaf": "Huidige actieve prijs (vanaf %s)",
    "pensionTarief.geenSeizoensprijs": "geen seizoensprijs",
    "pensionTarief.verwijder.knop": "Verwijderen",
    "pensionTarief.verwijder.bevestig": "Het tarieftype \"%s\" verwijderen?",
    "pensionTarief.verwijder.fout": "Dit tarieftype kon niet worden verwijderd.",
    "pensionTarief.col.rassen": "Rassen",
    "pensionTarief.col.rassen.aantal": "%s rassen",
    "pensionTarief.rassen.sectie": "Gekoppelde rassen",
    "pensionTarief.rassen.uitleg": "Beheer welke rassen bij dit tarieftype horen.",
    "pensionTarief.rassen.beheren": "Rassen beheren",
    "pensionTarief.rassen.titel": "Rassen bij %s",
    "pensionTarief.rassen.zoek": "Zoek op ras",
    "pensionTarief.rassen.gekozen": "%s gekozen",
    "pensionTarief.rassen.geen": "Voor deze diersoort staan nog geen rassen in het systeem.",
    "pensionTarief.rassen.elders": "hoort nu bij %s",
    "pensionTarief.rassen.fout": "De rassen konden niet worden opgeslagen.",
    "pensionTarief.prijsmodel.slotDicht": "Vergrendeld",
    "pensionTarief.prijsmodel.slotOpen": "Ontgrendeld",
    "pensionTarief.prijsmodel.slotVraag": "Het prijsmodel bepaalt welke tarieven een reservering rekent. Bestaande reserveringen veranderen niet, alles daarna wel. Wil je de keuze openzetten?",
    "pensionTarief.hist.grootboek": "Grootboekrekening",
    "pensionTarief.hist.kostenplaats": "Kostenplaats",
    "pensionTarief.hist.projectcode": "Projectcode",
    "pensionTarief.financieel.geen": "— geen —",
    "pensionTarief.accommodatie.nieuw.knop": "Accommodatietype toevoegen",
    "pensionTarief.accommodatie.nieuw.titel": "Nieuw accommodatietype",
    "pensionTarief.accommodatie.nieuw.naam": "Naam",
    "pensionTarief.accommodatie.nieuw.diersoort": "Diersoort",
    "pensionTarief.accommodatie.nieuw.kiesSoort": "— kies een diersoort —",
    "pensionTarief.accommodatie.nieuw.omschrijving": "Omschrijving",
    "pensionTarief.accommodatie.nieuw.luxe": "Luxe verblijf",
    "pensionTarief.accommodatie.nieuw.quarantaine": "Quarantaineverblijf",
    "pensionTarief.accommodatie.nieuw.hint": "Het type staat meteen in de verblijfplanning. De ruimtes zelf, en het icoon en de kleur, stel je daar in.",
    "pensionTarief.accommodatie.nieuw.verplicht": "Vul een naam in en kies een diersoort.",
    "pensionTarief.accommodatie.nieuw.bestaat": "Er bestaat al een accommodatietype met deze naam.",
    "pensionTarief.accommodatie.nieuw.fout": "Het accommodatietype kon niet worden aangemaakt.",
    "pensionTarief.dagprijs.ai.titel": "Laat AI je helpen",
    "pensionTarief.dagprijs.ai.beschrijf": "Beschrijf welke dagen anders moeten kosten",
    "pensionTarief.dagprijs.ai.voorbeeld": "Bijvoorbeeld: maak 24-12 t/m 02-01 15% duurder",
    "pensionTarief.dagprijs.ai.vraag": "Voorstel maken",
    "pensionTarief.dagprijs.ai.toepassen": "Toepassen",
    "pensionTarief.dagprijs.ai.onvolledig": "Vul de zin aan en maak opnieuw een voorstel.",
    "pensionTarief.dagprijs.ai.fout": "Het voorstel kon niet worden gemaakt.",
    "pensionTarief.actief.uit": "Uit gebruik nemen",
    "pensionTarief.actief.aan": "Weer in gebruik nemen",
    "pensionTarief.actief.bevestig": "\"%s\" uit gebruik nemen? Het tarief verdwijnt uit de keuzelijsten; de prijshistorie blijft staan.",
    "pensionTarief.actief.fout": "Dit tarief kon niet worden gewijzigd.",
    "pensionTarief.col.status": "Status",
    "pensionTarief.status.actief": "In gebruik",
    "pensionTarief.status.inactief": "Uit gebruik",
    "pensionTarief.volgorde.kolom": "Volgorde",
    "pensionTarief.volgorde.sleep": "Sleep om de volgorde te wijzigen",
    "pensionTarief.volgorde.omhoog": "%s omhoog",
    "pensionTarief.volgorde.omlaag": "%s omlaag",
    "pensionTarief.volgorde.fout": "De volgorde kon niet worden opgeslagen.",
    "dierTegel.entingen.verlopen": "%s verlopen",
    "dierTegel.entingen.geldigTot": "geldig tot %s",
    "dierTegel.entingen.eersteAfloop": "eerste loopt af op %s",
    "dierTegel.behandeling.volgende": "volgende: %s",
    "dierTegel.medicatie.aantal": "%s middelen",
    "dierTegel.medicatie.meer": "en nog %s ander middel",
    "dierTegel.nogNiets": "nog niets geregistreerd",
    "dierTegel.gewicht.kg": "%s kg",
    "dierTegel.gewicht.nieuw": "Nieuwe weging",
    "dierTegel.gewicht.label": "Gewicht (kg)",
    "dierTegel.gewicht.datum": "Datum",
    "dierTegel.gewicht.opmerking": "Notitie",
    "dierTegel.gewicht.vandaag": "De weging wordt op vandaag vastgelegd.",
    "dierTegel.gewicht.wordt": "Na opslaan staat er %s kg op de tegel.",
    "dierTegel.gewicht.ongeldig": "Vul een gewicht in dat groter is dan nul.",
    "dierTegel.gewicht.fout": "De weging kon niet worden opgeslagen.",
    "dierTegel.voeding.wijzigen": "Voedingsschema wijzigen",
    "dierTegel.voeding.merk": "Merk",
    "dierTegel.voeding.soort": "Soort voer",
    "dierTegel.voeding.hoeveelheid": "Hoeveelheid",
    "dierTegel.voeding.tijden": "Voertijden",
    "dierTegel.voeding.notitie": "Notitie",
    "dierTegel.voeding.geenSchema": "geen voedingsschema vastgelegd",
    "dierTegel.voeding.hint": "Het schema is de instructie voor iedereen die dit dier voert. Eén voermoment bijschrijven doe je op de voerlijst.",
    "dierTegel.voeding.fout": "Het voedingsschema kon niet worden opgeslagen.",
    "dierTegel.voeding.conflict": "Iemand anders heeft dit schema gewijzigd. Sluit en open opnieuw om de huidige versie te zien.",
    "dierTegel.chip.paspoort": "paspoort %s",
    "dierTegel.chip.wijzigen": "Chip en paspoort wijzigen",
    "dierTegel.chip.nummer": "Chipnummer",
    "dierTegel.chip.paspoortnummer": "Paspoortnummer",
    "dierTegel.chip.vijftien": "Een chipnummer is precies 15 cijfers, of laat het leeg.",
    "dierTegel.chip.nogCijfers": "Nog %s cijfers te gaan.",
    "dierTegel.chip.ongeldig": "Een chipnummer is precies 15 cijfers, of leeg.",
    "dierTegel.chip.dubbel": "Dit chipnummer hoort al bij %s. Eén chip, één dier.",
    "dierTegel.chip.anderDier": "een ander dier",
    "dierTegel.chip.controleMislukt": "De dubbelcontrole kon niet draaien, dus er is niets opgeslagen. Probeer het opnieuw.",
    "dierTegel.chip.conflict": "Iemand anders heeft dit dier gewijzigd. Sluit en open opnieuw om de huidige versie te zien.",
    "dierTegel.chip.fout": "Het chip- en paspoortnummer kon niet worden opgeslagen.",
    "dierTegel.gedrag.uitLogboek": "uit het gedragslogboek",
    "dierTegel.verzorging.borstelen": "borstelen %s",
    "dierTegel.verzorging.wassen": "wassen %s",
    "dierTegel.dagprijs.perDag": "%s per dag",
    "dierTegel.dagprijs.hoogseizoen": "%s in het hoogseizoen",
    "dierTegel.allergie.titel": "Allergieën",
    "dierTegel.allergie.nogGeen": "Nog geen allergieën vastgelegd.",
    "dierTegel.allergie.toevoegen": "Allergie toevoegen",
    "dierTegel.allergie.stof": "Allergisch voor",
    "dierTegel.allergie.reactie": "Reactie",
    "dierTegel.allergie.ernst": "Ernst",
    "dierTegel.allergie.vastgesteldOp": "Bekend sinds",
    "dierTegel.allergie.stofVerplicht": "Vul in waar het dier allergisch voor is.",
    "dierTegel.allergie.zekerWeten": "Echt weghalen?",
    "dierTegel.allergie.hint": "Alleen de stof is verplicht. De reactie vertelt verzorgers waar ze op moeten letten als het toch gebeurt.",
    "dierTegel.allergie.fout": "Dat kon niet worden opgeslagen.",
    "dierTegel.ring.openen": "Open het volledige dieroverzicht",
    "dierTegel.ring.nietGewogen": "niet gewogen",
    "dierTegel.ring.status.inOrde": "in orde",
    "dierTegel.ring.status.aandacht": "vraagt aandacht",
    "dierTegel.ring.status.verlopen": "verlopen",
    "dierTegel.ring.status.onbekend": "onbekend",
    "dierTegel.ring.samenvatting.inOrde": "Gezondheid: alles in orde",
    "dierTegel.ring.samenvatting.aandacht": "Gezondheid: er vraagt iets aandacht",
    "dierTegel.ring.samenvatting.verlopen": "Gezondheid: er is iets verlopen",
    "dierTegel.ring.samenvatting.onbekend": "Gezondheid: niets geregistreerd",
    "dierTegel.ontwerp.gezondheidsring": "Gezondheidsring",
    "dierTegel.ontwerp.zorgmeter": "Dagelijkse zorgmeter",
    "dierTegel.ontwerp.inEenOogopslag": "In één oogopslag",
    "dierTegel.ontwerp.voedingEnGewicht": "Voeding en gewicht",
    "dierTegel.ontwerp.medischeVeiligheid": "Medische veiligheid",
    "dierTegel.ontwerp.gedragEnSociaal": "Gedrag en sociaal",
    "dierTegel.ontwerp.verzorgingsprofiel": "Verzorgingsprofiel",
    "dierTegel.ontwerp.tariefPerDier": "Tarief per dier",
    "dierTegel.ontwerp.identiteitEnGezondheid": "Identiteit en gezondheid",
    "dierTegel.ontwerp.aandachtsmeter": "Aandachtsmeter",
    "dierTegel.ontwerp.dierkompas": "Dierkompas",
    "dierTegel.bouwer.maken": "Tegel maken",
    "dierTegel.bouwer.instellen": "%s instellen",
    "dierTegel.bouwer.beschikbaar": "Onderdelen kiezen",
    "dierTegel.bouwer.beschikbaarUitleg": "Kies maximaal 6 onderdelen.",
    "dierTegel.bouwer.zoek": "Zoek een onderdeel...",
    "dierTegel.bouwer.groep": "Categorie",
    "dierTegel.bouwer.nietsGevonden": "Geen onderdeel dat daarop lijkt.",
    "dierTegel.bouwer.opbouw": "Indeling bepalen",
    "dierTegel.bouwer.opbouwUitleg": "Sleep de onderdelen om de volgorde te bepalen.",
    "dierTegel.bouwer.sleep": "Sleep om de volgorde te wijzigen",
    "dierTegel.bouwer.vanMax": "%s van %s",
    "dierTegel.bouwer.verplaats": "%s verplaatsen; gebruik de pijltjestoetsen",
    "dierTegel.bouwer.weghalen": "%s weghalen",
    "dierTegel.bouwer.snelleActieSoort": "Snelle actie: %s",
    "dierTegel.bouwer.sleepHierheen": "Sleep hierheen of voeg links toe",
    "dierTegel.bouwer.voorbeeldUitleg": "Hier zie je een live voorbeeld van je samengestelde tegel.",
    "dierTegel.bouwer.naastElkaar": "Tegels naast elkaar",
    "dierTegel.bouwer.eenTegel": "1 tegel",
    "dierTegel.bouwer.aantalTegels": "%s tegels",
    "dierTegel.bouwer.stijl": "Visuele stijl",
    "dierTegel.bouwer.schaaltMee": "De inhoud schaalt automatisch mee.",
    "dierTegel.bouwer.automatischUitleg": "De tegel past zich automatisch aan de beschikbare ruimte aan.",
    "dierTegel.bouwer.snelleActiesUitleg": "Toon acties zoals snel bewerken of registreren.",
    "dierTegel.bouwer.toevoegen": "Tegel toevoegen",
    "dierTegel.bouwer.fotoInMidden": "Toon foto",
    "dierTegel.bouwer.fotoInMiddenUitleg": "Zet de foto van het dier in het midden van de tegel.",
    "dierTegel.stijl.rond": "Rond",
    "dierTegel.stijl.raster": "Raster",
    "dierTegel.stijl.lijst": "Lijst",
    "dierTegel.bouwer.titel": "Samengestelde tegel maken",
    "dierTegel.bouwer.uitleg": "Kies welke informatie je samen in één tegel wilt zien.",
    "dierTegel.bouwer.naam": "Tegelnaam",
    "dierTegel.bouwer.stijlUitleg": "Kies hoe de informatie wordt weergegeven in de tegel.",
    "dierTegel.bouwer.schalen": "Automatisch schalen",
    "dierTegel.bouwer.schalenUitleg": "De tegel past zich aan het aantal tegels op het dashboard aan.",
    "dierTegel.bouwer.maat.compact": "Compact",
    "dierTegel.bouwer.maat.compactUitleg": "Kleine tegel, minder details",
    "dierTegel.bouwer.maat.normaal": "Normaal",
    "dierTegel.bouwer.maat.normaalUitleg": "Standaard formaat, balans in informatie",
    "dierTegel.bouwer.maat.uitgebreid": "Uitgebreid",
    "dierTegel.bouwer.maat.uitgebreidUitleg": "Extra ruimte voor meer details",
    "dierTegel.bouwer.instellingen": "Instellingen",
    "dierTegel.bouwer.instellingenUitleg": "Bepaal welke extra informatie je wilt tonen.",
    "dierTegel.bouwer.toonHerkomst": "Toon datum en tijd",
    "dierTegel.bouwer.toonHerkomstUitleg": "Toon bij elk onderdeel wanneer het voor het laatst is geregistreerd.",
    "dierTegel.bouwer.naamUitleg": "Geef deze samengestelde tegel een naam.",
    "dierTegel.bouwer.vorm": "Vorm",
    "dierTegel.bouwer.onderdelen": "Onderdelen (%s van %s)",
    "dierTegel.bouwer.grens": "Een tegel houdt hoogstens %s onderdelen; zo blijft hij leesbaar.",
    "dierTegel.bouwer.reden.vol": "tegel is vol",
    "dierTegel.bouwer.reden.nietVanToepassing": "hier niet in gebruik",
    "dierTegel.bouwer.volgorde": "Volgorde",
    "dierTegel.bouwer.omhoog": "%s omhoog",
    "dierTegel.bouwer.omlaag": "%s omlaag",
    "dierTegel.bouwer.automatisch": "Automatisch schalen",
    "dierTegel.bouwer.vasteMaat": "Vaste maat",
    "dierTegel.bouwer.dichtheid.compact": "Compact",
    "dierTegel.bouwer.dichtheid.normaal": "Normaal",
    "dierTegel.bouwer.dichtheid.uitgebreid": "Uitgebreid",
    "dierTegel.bouwer.snelleActies": "Snelle acties tonen",
    "dierTegel.bouwer.actiesHint": "Zonder schrijfrecht verdwijnt de knop sowieso; deze schakelaar kan er geen tevoorschijn toveren.",
    "dierTegel.bouwer.voorbeeld": "Voorbeeld",
    "dierTegel.bouwer.voorbeeldHint": "Voorbeeldwaarden. De tegel geldt voor elk dier en toont hier dus geen echte gegevens.",
    "dierTegel.bouwer.waarde": "voorbeeld",
    "dierTegel.bouwer.nogNiets": "Kies een onderdeel om de tegel te zien.",
    "dierTegel.bouwer.verwijderen": "Tegel verwijderen",
    "dierTegel.vorm.ring": "Ring",
    "dierTegel.vorm.halvemeter": "Halve meter",
    "dierTegel.vorm.satellieten": "Satellieten",
    "dierTegel.vorm.gesplitst": "Gesplitst",
    "dierTegel.vorm.statuslijst": "Statuslijst",
    "dierTegel.vorm.radiaal": "Radiaal",
    "dierTegel.vorm.prijskaart": "Prijskaart",
    "dierTegel.vorm.tweekolommen": "Twee kolommen",
    "dierTegel.vorm.boogmeter": "Boogmeter",
    "dierTegel.vorm.waardenboog": "Waardenboog",
    "dierTegel.ontwerp.inEenBoog": "In een boog",
    "dierTegel.vorm.kwadranten": "Kwadranten",
    "dierTegel.meter.aandacht": "%s vragen aandacht",
    "dierTegel.meter.inOrde": "Alles in orde",
    "dierTegel.meter.nietsBekend": "Nog niets bekend",
    "dierTegel.meter.onbekend": "%s onbekend",
    "dierTegel.uitleg.gewicht": "Laatste meting en trend",
    "dierTegel.uitleg.voeding": "Schema, voer en hoeveelheid",
    "dierTegel.uitleg.medicatie": "Actief middel en toediening",
    "dierTegel.uitleg.vaccinaties": "Status en geldigheid",
    "dierTegel.uitleg.ontworming": "Laatste en volgende behandeling",
    "dierTegel.uitleg.ontvlooiing": "Laatste en volgende behandeling",
    "dierTegel.uitleg.allergieen": "Actieve waarschuwingen",
    "dierTegel.uitleg.gedrag": "Kenmerken en omgang",
    "dierTegel.uitleg.verzorging": "Behoefte en uitvoering",
    "dierTegel.uitleg.chipPaspoort": "Chipnummer en paspoort",
    "dierTegel.uitleg.dierenarts": "Praktijk en contact",
    "dierTegel.uitleg.dagprijs": "Gekozen tarief en dagprijs",
    "dierTegel.groep.alles": "Alles",
    "dierTegel.groep.dagelijks": "Dagelijkse zorg",
    "dierTegel.groep.medisch": "Medisch",
    "dierTegel.groep.identiteit": "Identiteit",
    "dierTegel.component.gewicht": "Gewicht",
    "dierTegel.component.voeding": "Voeding",
    "dierTegel.component.medicatie": "Medicatie",
    "dierTegel.component.vaccinaties": "Vaccinaties",
    "dierTegel.component.ontworming": "Ontworming",
    "dierTegel.component.ontvlooiing": "Ontvlooiing",
    "dierTegel.component.allergieen": "Allergieën",
    "dierTegel.component.gedrag": "Gedrag",
    "dierTegel.component.verzorging": "Verzorging",
    "dierTegel.component.chipPaspoort": "Chip en paspoort",
    "dierTegel.component.dierenarts": "Dierenarts",
    "dierTegel.component.diersoort": "Diersoort",
    "dierTegel.component.ras": "Ras",
    "dierTegel.component.geslacht": "Geslacht",
    "dierTegel.component.leeftijd": "Leeftijd",
    "dierTegel.component.kenmerken": "Kenmerken",
    "dierTegel.component.bijzonderheden": "Bijzonderheden",
    "dierTegel.uitleg.diersoort": "Hond, kat, konijn",
    "dierTegel.uitleg.ras": "Ras van het dier",
    "dierTegel.uitleg.geslacht": "Geslacht en of het dier gecastreerd is",
    "dierTegel.uitleg.leeftijd": "Leeftijd en geboortedatum",
    "dierTegel.uitleg.kenmerken": "Kleur, aftekening en andere kenmerken",
    "dierTegel.uitleg.bijzonderheden": "Vrije tekst bij het dier",
    "dierTegel.leeftijd.geboren": "geboren %s",
    "dierTegel.bouwer.breedte.heel": "Hele rij",
    "dierTegel.bouwer.breedte.half": "Halve rij",
    "dierTegel.bouwer.breedte.kwart": "Kwart",
    "dierTegel.bouwer.breedteHint": "Zo breed komt de tegel op het dierscherm te staan.",
    "dierTegel.component.dagprijs": "Dagprijs per dier",
    "dierTegel.status.inOrde": "In orde",
    "dierTegel.status.aandacht": "Aandacht",
    "dierTegel.status.verlopen": "Verlopen",
    "dierTegel.actie.registratie": "Nieuwe registratie",
    "dierTegel.actie.wijziging": "Wijzigen",
    "pensionTarief.subtitel": "Beheer hier de tarieven per dier en ras voor pension en dagopvang.",
    "pensionTarief.tab.prijsberekening": "Prijsberekening",
    "pensionTarief.prijsmodel.titel": "Prijsmodel",
    "pensionTarief.prijsmodel.dier.naam": "Tarief per dier",
    "pensionTarief.prijsmodel.dier.uitleg": "Het dier bepaalt de dagprijs. Geschikt voor kleine hond, grote hond, kat, etc.",
    "pensionTarief.prijsmodel.accommodatie.naam": "Tarief per accommodatie",
    "pensionTarief.prijsmodel.accommodatie.uitleg": "De accommodatie heeft een dagprijs per kalenderdag. Je kunt per dag of periode afwijkende prijzen instellen.",
    "pensionTarief.prijsmodel.opslaanFout": "Het prijsmodel kon niet worden opgeslagen.",
    "pensionTarief.prijsmodel.alleenLezen": "Alleen een pensionbeheerder kan het prijsmodel wijzigen.",
    "pensionTarief.soort.label": "Soort tarief",
    "pensionTarief.soort.pension": "Pension",
    "pensionTarief.soort.dagopvang": "Dagopvang",
    "pensionTarief.tabs.label": "Pension tarieven tabbladen",
    "pensionTarief.tab.tarieven": "Tarieven",
    "pensionTarief.tab.hoogseizoen": "Hoogseizoen",
    "pensionTarief.tab.kortingen": "Kortingen",
    "pensionTarief.tab.aanbetaling": "Aanbetaling",
    "pensionTarief.tab.verzekering": "Reserveringsproducten",
    "pensionTarief.tab.accommodaties": "Accommodaties",
    "pensionTarief.accommodatie.uitleg.ACCOMMODATIE": "Deze vestiging rekent met dagprijzen per accommodatie: de prijs hieronder is de dagprijs van het verblijf.",
    "pensionTarief.accommodatie.uitleg.PENSIONPRIJZEN": "Deze vestiging rekent met de pensionprijzen: de prijs hieronder is een toeslag per dag bovenop het tarief van het dier. Leeg betekent geen toeslag.",
    "pensionTarief.accommodatie.beheer": "De accommodatietypes maak je aan bij de verblijfplanning; dagprijs of toeslag kies je bij Instellingen › Pension › Prijsberekening.",
    "pensionTarief.accommodatie.col.diersoort": "Diersoort",
    "pensionTarief.accommodatie.col.naam": "Accommodatie",
    "pensionTarief.accommodatie.col.laag.ACCOMMODATIE": "Dagprijs",
    "pensionTarief.accommodatie.col.laag.PENSIONPRIJZEN": "Toeslag laagseizoen",
    "pensionTarief.accommodatie.col.hoog.ACCOMMODATIE": "Dagprijs hoogseizoen",
    "pensionTarief.accommodatie.col.hoog.PENSIONPRIJZEN": "Toeslag hoogseizoen",
    "pensionTarief.accommodatie.col.geldigVanaf": "Geldig vanaf",
    "pensionTarief.accommodatie.col.acties": "Acties",
    "pensionTarief.accommodatie.luxe": "Luxe",
    "pensionTarief.accommodatie.quarantaine": "Quarantaine",
    "pensionTarief.accommodatie.geenPrijs": "Geen prijs",
    "pensionTarief.accommodatie.leeg": "Nog geen accommodatietypes. Maak ze aan bij de verblijfplanning.",
    "pensionTarief.accommodatie.laden": "De accommodaties konden niet worden geladen.",
    "pensionTarief.accommodatie.wijzig": "Prijs wijzigen",
    "pensionTarief.accommodatie.wijzigVan": "Prijs van %s wijzigen",
    "pensionTarief.accommodatie.dialoog.titel": "Prijs van %s",
    "pensionTarief.accommodatie.section.huidig": "Huidige prijs",
    "pensionTarief.accommodatie.section.wijziging": "Prijswijziging",
    "pensionTarief.accommodatie.section.historie": "Tariefoverzicht",
    "pensionTarief.accommodatie.hint": "Voeg een prijs toe met een ingangsdatum. Meerdere regels worden achter elkaar ingepland.",
    "pensionTarief.accommodatie.editRow": "Prijsregel van %s wijzigen",
    "pensionTarief.accommodatie.regel.nieuw": "Nieuwe prijsregel",
    "pensionTarief.accommodatie.regel.wijzig": "Prijsregel wijzigen",
    "pensionTarief.accommodatie.regel.uitleg": "De regel komt in de lijst te staan; er wordt pas iets bewaard als je Prijs opslaan kiest.",
    "pensionTarief.accommodatie.regel.voegToe": "Toevoegen",
    "pensionTarief.accommodatie.regel.bijwerken": "Bijwerken",
    "pensionTarief.accommodatie.regel.onvolledig": "Vul een ingangsdatum en een bedrag in.",
    "pensionTarief.accommodatie.add": "Prijsregel toevoegen",
    "pensionTarief.accommodatie.remove": "Prijsregel weghalen",
    "pensionTarief.accommodatie.submit": "Prijs opslaan",
    "pensionTarief.accommodatie.field.effectdatum": "Ingangsdatum",
    "pensionTarief.accommodatie.field.reden": "Reden",
    "pensionTarief.accommodatie.opgeslagen": "Prijs opgeslagen",
    "pensionTarief.accommodatie.fout.error": "Opslaan lukte niet. Controleer bedrag, datum en btw.",
    "pensionTarief.accommodatie.fout.forbidden": "Je hebt geen recht om tarieven te wijzigen.",
    "pensionTarief.accommodatie.fout.forbiddenPast": "Een ingangsdatum in het verleden vraagt beheerrechten voor tarieven.",
    "pensionTarief.aanbetaling.title": "Aanbetaling bij een reservering",
    "pensionTarief.aanbetaling.intro": "Het percentage geldt voor het verblijf alleen, zonder wassen en andere extra's. De dagen tellen vanaf de bevestiging van de reservering. 0% betekent: geen aanbetaling.",
    "pensionTarief.aanbetaling.scope": "Voor vestiging %s.",
    "pensionTarief.aanbetaling.field.percentage": "Percentage van het verblijf",
    "pensionTarief.aanbetaling.field.herinnering": "Herinnering na (dagen)",
    "pensionTarief.aanbetaling.field.annuleren": "Vervalt na (dagen)",
    "pensionTarief.aanbetaling.save": "Opslaan",
    "pensionTarief.aanbetaling.saved": "Opgeslagen.",
    "pensionTarief.aanbetaling.load.error": "De aanbetalingsinstellingen konden niet worden geladen.",
    "pensionTarief.none": "—",
    "pensionTarief.action.add": "Tarief toevoegen",
    "pensionTarief.action.delete": "Verwijderen",
    "pensionTarief.action.refresh": "Vernieuwen",
    "pensionTarief.search": "Zoek tarieven",
    "pensionTarief.peildatum": "Geldig op",
    "pensionTarief.sort.label": "Sorteren op",
    "pensionTarief.sort.dir": "Richting",
    "pensionTarief.sort.asc": "Oplopend",
    "pensionTarief.sort.desc": "Aflopend",
    "pensionTarief.empty": "Nog geen tarieven.",
    "pensionTarief.load.error": "De tarieven konden niet worden geladen.",
    "pensionTarief.badge.nieuw": "Nieuw",
    "pensionTarief.col.verblijftype": "Verblijftype",
    "pensionTarief.col.diersoort": "Diersoort",
    "pensionTarief.col.dagprijs": "Laagseizoen",
    "pensionTarief.col.dagprijsHoog": "Hoogseizoen",
    "pensionTarief.col.geldigVanaf": "Geldig vanaf",
    "pensionTarief.col.laatstGewijzigd": "Laatst gewijzigd",
    "pensionTarief.col.acties": "Acties",
    "pensionTarief.dagprijsHoog.missing": "geen seizoensprijs",
    "pensionTarief.delete.confirm": "Tarief \"%s\" verwijderen?",
    "pensionTarief.paging.prev": "Vorige",
    "pensionTarief.paging.next": "Volgende",
    "pensionTarief.paging.info": "Pagina %s van %s",
    "pensionTarief.banner.hoogseizoen": "Hoogseizoen is actief op de peildatum — de hoge dagprijs geldt.",
    "pensionTarief.hoog.label": "Hoogseizoen",
    "pensionTarief.hoog.alle": "Alle",
    "tariefAi.action": "Laat AI je helpen",
    "tariefAi.title": "Laat AI je helpen met een tarief",
    "tariefAi.intro": "Beschrijf in uw eigen woorden wat u wilt: een nieuw tarief, een prijswijziging, of een tarief verwijderen.",
    "tariefAi.veld": "Uw beschrijving",
    "tariefAi.submit": "Voorstel maken",
    "tariefAi.apply.NIEUW": "Openen als nieuw tarief",
    "tariefAi.apply.WIJZIG": "Dit tarief openen",
    "tariefAi.apply.VERWIJDER": "Dit tarief verwijderen",
    "tariefAi.notFound": "Dat tarief staat niet meer in de lijst.",
    "tariefAi.notHere": "Dit scherm heeft daar geen formulier voor.",
    "tariefAi.error": "Ik kon dit niet lezen. Probeer het anders te omschrijven.",
    "tariefAi.voorbeeld.pension": "bijv. verhoog Hond naar 18 euro per 1 maart",
    "tariefAi.voorbeeld.creche": "bijv. dagopvang kat 9 euro, 14 met overnachting",
    "tariefAi.voorbeeld.ambulance": "bijv. verhoog Dierenambulance Enschede naar 42 euro, 0,55 per km",
    "pensionTarief.ai.action": "Laat AI je helpen",
    "pensionTarief.ai.title": "Laat AI je helpen met een tarief",
    "pensionTarief.ai.intro": "Beschrijf in uw eigen woorden wat u wilt: een nieuw tarief, een prijswijziging, of een tarief verwijderen.",
    "pensionTarief.ai.veld": "Uw beschrijving",
    "pensionTarief.ai.placeholder": "bijv. verhoog Hond naar 18 euro per 1 maart",
    "pensionTarief.ai.submit": "Voorstel maken",
    "pensionTarief.ai.apply.NIEUW": "Openen als nieuw tarief",
    "pensionTarief.ai.apply.WIJZIG": "Dit tarief openen",
    "pensionTarief.ai.apply.VERWIJDER": "Dit tarief verwijderen",
    "pensionTarief.ai.notFound": "Dat tarief staat niet meer in de lijst.",
    "pensionTarief.ai.error": "Ik kon dit niet lezen. Probeer het anders te omschrijven.",
    "pensionTarief.field.diersoort": "Diersoort",
    "pensionTarief.field.diersoort.placeholder": "Kies een diersoort…",
    "pensionTarief.field.diersoort.required": "Kies een diersoort.",
    "pensionTarief.hoog.eigen": "Eigen hoogseizoenprijs",
    "pensionTarief.hoog.gelijk": "Gelijk aan laagseizoen",
    "pensionTarief.hoog.geen": "Geen hoogseizoentoeslag",
    "pensionTarief.kpi.actief": "Actieve tarieven",
    "pensionTarief.kpi.aankomend": "Aankomende wijzigingen (≤30 dagen)",
    "pensionTarief.kpi.ontbrekend": "Ontbrekende seizoensprijzen",
    "pensionTarief.notice.conflict": "Dit tarief is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "pensionTarief.notice.forbidden": "U bent niet bevoegd om tarieven te bewerken.",
    "pensionTarief.notice.forbiddenPast": "Een datum in het verleden vereist de tarief-beheerdersrol (ROLE_TARIEF_ADMIN).",
    "pensionTarief.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "pensionTarief.field.naam": "Naam",
    "pensionTarief.field.naam.required": "Een naam is verplicht.",
    "pensionTarief.field.diersoortId": "Diersoort-id (leeg = algemeen)",
    "pensionTarief.field.omschrijving": "Omschrijving",
    "pensionTarief.field.dagprijs": "Dagprijs (laag)",
    "pensionTarief.field.dagprijs.required": "Een dagprijs is verplicht.",
    "pensionTarief.field.dagprijsHoog": "Dagprijs (hoog)",
    "pensionTarief.field.effectdatum": "Ingangsdatum",
    "pensionTarief.field.reden": "Reden",
    "pensionTarief.field.vestiging": "Vestiging",
    "pensionTarief.vestiging.org": "Hele organisatie",
    "pensionTarief.nieuw.title": "Nieuw pensiontarief",
    "pensionTarief.bewerk.title": "Tarief bewerken — %s",
    "pensionTarief.section.basis": "Basisinformatie",
    "pensionTarief.section.huidig": "Huidig tarief",
    "pensionTarief.section.gepland": "Geplande tarieven",
    "pensionTarief.section.historie": "Historie",
    "pensionTarief.gepland.empty": "Er staat niets ingepland.",
    "pensionTarief.basis.save": "Basisinformatie opslaan",
    "pensionTarief.basis.saved": "Basisinformatie opgeslagen.",
    "pensionTarief.current": "Huidig",
    "pensionTarief.prijswijziging.hint": "Voeg een of meer toekomstige prijswijzigingen toe. Eén wijziging wordt direct toegepast; meerdere worden ingepland.",
    "pensionTarief.prijswijziging.add": "Prijswijziging toevoegen",
    "pensionTarief.prijswijziging.remove": "Prijswijziging verwijderen",
    "pensionTarief.prijswijziging.submit": "Prijswijziging opslaan",
    "pensionTarief.hist.vanaf": "Vanaf",
    "pensionTarief.hist.tot": "Tot",
    "pensionTarief.hist.bedrag": "Prijs (laag)",
    "pensionTarief.hist.bedragHoog": "Prijs (hoog)",
    "pensionTarief.hist.reden": "Reden",
    "pensionTarief.hist.status": "Status",
    "pensionTarief.hist.status.GEPLAND": "Gepland",
    "pensionTarief.hist.status.ACTIEF": "Actief",
    "pensionTarief.hist.status.VERVALLEN": "Vervallen",
    "pensionTarief.hist.empty": "Nog geen versies.",
    "pensionTarief.hoogseizoen.new.title": "Nieuwe hoogseizoenperiode",
    "pensionTarief.hoogseizoen.add": "Periode toevoegen",
    "pensionTarief.hoogseizoen.field.naam": "Naam",
    "pensionTarief.hoogseizoen.field.vanaf": "Geldig vanaf",
    "pensionTarief.hoogseizoen.field.tm": "Geldig t/m (incl.)",
    "pensionTarief.hoogseizoen.col.naam": "Naam",
    "pensionTarief.hoogseizoen.col.vanaf": "Vanaf",
    "pensionTarief.hoogseizoen.col.tm": "T/m (incl.)",
    "pensionTarief.hoogseizoen.col.scope": "Bereik",
    "pensionTarief.hoogseizoen.scope.org": "Hele organisatie",
    "pensionTarief.hoogseizoen.empty": "Nog geen hoogseizoenperiodes.",
    "pensionTarief.hoogseizoen.load.error": "De periodes konden niet worden geladen.",
    "pensionTarief.hoogseizoen.delete.confirm": "Periode \"%s\" verwijderen?",
    "pensionTarief.korting.add": "Korting toevoegen",
    "pensionTarief.korting.ai": "Met AI beschrijven",
    "pensionTarief.korting.empty": "Nog geen kortingsregels.",
    "pensionTarief.korting.load.error": "De kortingsregels konden niet worden geladen.",
    "pensionTarief.korting.delete.confirm": "Korting \"%s\" deactiveren?",
    "pensionTarief.korting.col.naam": "Naam",
    "pensionTarief.korting.col.type": "Type",
    "pensionTarief.korting.col.waarde": "Waarde",
    "pensionTarief.korting.col.toepassing": "Toepassing",
    "pensionTarief.korting.col.actief": "Actief",
    "pensionTarief.korting.actief.yes": "Actief",
    "pensionTarief.korting.actief.no": "Inactief",
    "pensionTarief.korting.type.PERCENTAGE": "Percentage",
    "pensionTarief.korting.type.VAST_BEDRAG": "Vast bedrag",
    "pensionTarief.korting.toepassing.ALLEEN_EXTRA_DIEREN": "Alleen extra dieren",
    "pensionTarief.korting.toepassing.ALLE_DIEREN": "Alle dieren",
    "pensionTarief.korting.toepassing.LANGSTE_VERBLIJF": "Langste verblijf",
    "pensionTarief.korting.dialog.new.title": "Nieuwe kortingsregel",
    "pensionTarief.korting.dialog.edit.title": "Kortingsregel bewerken",
    "pensionTarief.korting.field.naam": "Naam",
    "pensionTarief.korting.field.naam.required": "Een naam is verplicht.",
    "pensionTarief.korting.field.conditie": "Voorwaarde (ALS / EN)",
    "pensionTarief.korting.field.type": "Kortingstype (DAN)",
    "pensionTarief.korting.field.waarde": "Waarde",
    "pensionTarief.korting.field.waarde.required": "Een waarde is verplicht.",
    "pensionTarief.korting.field.toepassing": "Toepassing (OP)",
    "pensionTarief.korting.field.geldigVanaf": "Geldig vanaf",
    "pensionTarief.korting.field.geldigTm": "Geldig t/m (incl.)",
    "pensionTarief.korting.field.actief": "Actief",
    "pensionTarief.korting.ai.title": "Korting met AI beschrijven",
    "pensionTarief.korting.ai.prompt": "Beschrijf de korting in gewone taal",
    "pensionTarief.korting.ai.generate": "Genereren",
    "pensionTarief.korting.ai.adopt": "Overnemen",
    "crecheTarief.tabs.label": "Crèche tarieven tabbladen",
    "crecheTarief.tab.losseDagen": "Losse dagen",
    "crecheTarief.tab.rittenkaarten": "Rittenkaarten",
    "crecheTarief.tab.abonnementen": "Abonnementen",
    "crecheTarief.none": "—",
    "crecheTarief.yes": "Ja",
    "crecheTarief.no": "Nee",
    "crecheTarief.action.add": "Tarief toevoegen",
    "crecheTarief.action.delete": "Verwijderen",
    "crecheTarief.action.refresh": "Vernieuwen",
    "crecheTarief.search": "Zoek tarieven",
    "crecheTarief.peildatum": "Geldig op",
    "crecheTarief.sort.label": "Sorteren op",
    "crecheTarief.sort.dir": "Richting",
    "crecheTarief.sort.asc": "Oplopend",
    "crecheTarief.sort.desc": "Aflopend",
    "crecheTarief.empty": "Nog geen tarieven.",
    "crecheTarief.load.error": "De tarieven konden niet worden geladen.",
    "crecheTarief.badge.nieuw": "Nieuw",
    "crecheTarief.col.categorie": "Categorie",
    "crecheTarief.col.diersoort": "Diersoort",
    "crecheTarief.col.dagprijs": "Dagprijs",
    "crecheTarief.col.dagprijsOvernachting": "Dagprijs incl. overnachting",
    "crecheTarief.col.geldigVanaf": "Geldig vanaf",
    "crecheTarief.col.acties": "Acties",
    "crecheTarief.dagprijsOvernachting.missing": "geen overnachtingsprijs",
    "crecheTarief.delete.confirm": "Tarief \"%s\" verwijderen?",
    "crecheTarief.paging.prev": "Vorige",
    "crecheTarief.paging.next": "Volgende",
    "crecheTarief.paging.info": "Pagina %s van %s",
    "crecheTarief.notice.conflict": "Dit tarief is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "crecheTarief.notice.forbidden": "U bent niet bevoegd om tarieven te bewerken.",
    "crecheTarief.notice.forbiddenPast": "Een datum in het verleden vereist de tarief-beheerdersrol (ROLE_TARIEF_ADMIN).",
    "crecheTarief.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "crecheTarief.field.categorie": "Categorienaam",
    "crecheTarief.field.categorie.required": "Een categorienaam is verplicht.",
    "crecheTarief.field.diersoortId": "Diersoort-id (leeg = algemeen)",
    "crecheTarief.field.omschrijving": "Omschrijving",
    "crecheTarief.field.dagprijs": "Dagprijs",
    "crecheTarief.field.dagprijs.required": "Een dagprijs is verplicht.",
    "crecheTarief.field.dagprijsOvernachting": "Dagprijs incl. overnachting",
    "crecheTarief.field.effectdatum": "Ingangsdatum",
    "crecheTarief.field.geldigVanaf": "Geldig vanaf",
    "crecheTarief.field.reden": "Reden",
    "crecheTarief.field.vestiging": "Vestiging",
    "crecheTarief.vestiging.org": "Hele organisatie",
    "crecheTarief.nieuw.title": "Nieuw crèchetarief",
    "crecheTarief.bewerk.title": "Tarief bewerken — %s",
    "crecheTarief.section.basis": "Basisinformatie",
    "crecheTarief.section.huidig": "Huidig tarief",
    "crecheTarief.section.prijswijziging": "Prijswijziging inplannen",
    "crecheTarief.section.overzicht": "Tariefoverzicht",
    "crecheTarief.basis.save": "Basisinformatie opslaan",
    "crecheTarief.basis.saved": "Basisinformatie opgeslagen.",
    "crecheTarief.prijswijziging.hint": "Voeg een of meer toekomstige prijswijzigingen toe. Eén wijziging wordt direct toegepast; meerdere worden ingepland.",
    "crecheTarief.prijswijziging.add": "Prijswijziging toevoegen",
    "crecheTarief.prijswijziging.remove": "Prijswijziging verwijderen",
    "crecheTarief.prijswijziging.submit": "Prijswijziging opslaan",
    "crecheTarief.hist.vanaf": "Vanaf",
    "crecheTarief.hist.tot": "Tot",
    "crecheTarief.hist.bedrag": "Dagprijs",
    "crecheTarief.hist.bedragHoog": "Incl. overnachting",
    "crecheTarief.hist.reden": "Reden",
    "crecheTarief.hist.status": "Status",
    "crecheTarief.hist.status.GEPLAND": "Gepland",
    "crecheTarief.hist.status.ACTIEF": "Actief",
    "crecheTarief.hist.status.VERVALLEN": "Vervallen",
    "crecheTarief.hist.empty": "Nog geen versies.",
    "crecheTarief.rittenkaart.add": "Rittenkaart toevoegen",
    "crecheTarief.rittenkaart.empty": "Nog geen rittenkaarten.",
    "crecheTarief.rittenkaart.load.error": "De rittenkaarten konden niet worden geladen.",
    "crecheTarief.rittenkaart.delete.confirm": "Rittenkaart \"%s\" deactiveren?",
    "crecheTarief.rittenkaart.col.naam": "Naam",
    "crecheTarief.rittenkaart.col.aantalRitten": "Ritten",
    "crecheTarief.rittenkaart.col.prijs": "Prijs",
    "crecheTarief.rittenkaart.col.geldigheidMaanden": "Geldigheid (maanden)",
    "crecheTarief.rittenkaart.col.overdraagbaar": "Overdraagbaar",
    "crecheTarief.rittenkaart.col.verlengen": "Automatisch verlengen",
    "crecheTarief.rittenkaart.dialog.new.title": "Nieuwe rittenkaart",
    "crecheTarief.rittenkaart.dialog.edit.title": "Rittenkaart bewerken",
    "crecheTarief.rittenkaart.field.naam": "Naam",
    "crecheTarief.rittenkaart.field.naam.required": "Een naam is verplicht.",
    "crecheTarief.rittenkaart.field.aantalRitten": "Aantal ritten",
    "crecheTarief.rittenkaart.field.aantalRitten.required": "Het aantal ritten is verplicht.",
    "crecheTarief.rittenkaart.field.prijs": "Prijs",
    "crecheTarief.rittenkaart.field.prijs.required": "Een prijs is verplicht.",
    "crecheTarief.rittenkaart.field.geldigheidMaanden": "Geldigheid (maanden, leeg = onbeperkt)",
    "crecheTarief.rittenkaart.field.overdraagbaar": "Overdraagbaar",
    "crecheTarief.rittenkaart.field.verlengen": "Verlengen bij laatste rit",
    "crecheTarief.abonnement.add": "Abonnement toevoegen",
    "crecheTarief.abonnement.empty": "Nog geen abonnementen.",
    "crecheTarief.abonnement.load.error": "De abonnementen konden niet worden geladen.",
    "crecheTarief.abonnement.delete.confirm": "Abonnement \"%s\" deactiveren?",
    "crecheTarief.abonnement.col.naam": "Naam",
    "crecheTarief.abonnement.col.dagenPerWeek": "Dagen/week",
    "crecheTarief.abonnement.col.prijsPerMaand": "Prijs/maand",
    "crecheTarief.abonnement.col.strategy": "Extra dagen",
    "crecheTarief.abonnement.col.looptijd": "Looptijd",
    "crecheTarief.abonnement.col.status": "Status",
    "crecheTarief.abonnement.action.publiceren": "Publiceren",
    "crecheTarief.abonnement.action.depubliceren": "Depubliceren",
    "crecheTarief.abonnement.status.ACTIEF": "Actief",
    "crecheTarief.abonnement.status.CONCEPT": "Concept",
    "crecheTarief.abonnement.strategy.RITTENKAART": "Van rittenkaart",
    "crecheTarief.abonnement.strategy.LOSSE_DAGPRIJS": "Tegen losse dagprijs",
    "crecheTarief.abonnement.looptijd.DOORLOPEND": "Doorlopend",
    "crecheTarief.abonnement.looptijd.BEPAALDE_TIJD": "Bepaalde tijd",
    "crecheTarief.abonnement.dialog.new.title": "Nieuw abonnement",
    "crecheTarief.abonnement.dialog.edit.title": "Abonnement bewerken",
    "crecheTarief.abonnement.field.naam": "Naam",
    "crecheTarief.abonnement.field.naam.required": "Een naam is verplicht.",
    "crecheTarief.abonnement.field.dagenPerWeek": "Dagen per week",
    "crecheTarief.abonnement.field.dagenPerWeek.required": "Dagen per week is verplicht.",
    "crecheTarief.abonnement.field.prijsPerMaand": "Prijs per maand",
    "crecheTarief.abonnement.field.prijsPerMaand.required": "Een maandprijs is verplicht.",
    "crecheTarief.abonnement.field.strategy": "Strategie extra dagen",
    "crecheTarief.abonnement.field.looptijd": "Looptijdtype",
    "crecheTarief.abonnement.field.looptijdMaanden": "Looptijd (maanden)",
    "crecheTarief.pakketsaldo.title": "Pakketsaldo opzoeken",
    "crecheTarief.pakketsaldo.hint": "Zoek het crèche-pakketsaldo van een klant op via klant-id (alleen-lezen).",
    "crecheTarief.pakketsaldo.field.klantId": "Klant-id",
    "crecheTarief.pakketsaldo.lookup": "Opzoeken",
    "crecheTarief.pakketsaldo.empty": "Geen pakketsaldo voor deze klant.",
    "crecheTarief.pakketsaldo.load.error": "Het pakketsaldo kon niet worden geladen.",
    "crecheTarief.pakketsaldo.col.dier": "Dier",
    "crecheTarief.pakketsaldo.col.rittenkaart": "Rittenkaart",
    "crecheTarief.pakketsaldo.col.rittenOver": "Ritten over",
    "crecheTarief.pakketsaldo.col.verloop": "Verloopt",
    "crecheTarief.pakketsaldo.col.abonnement": "Abonnement",
    "productStatistiek.filter.van": "Periode van",
    "productStatistiek.filter.tot": "Periode tot",
    "productStatistiek.filter.vestiging": "Vestiging",
    "productStatistiek.filter.organisatie": "Hele organisatie",
    "productStatistiek.export": "Exporteren CSV",
    "productStatistiek.empty": "Geen verkopen in deze periode.",
    "productStatistiek.loadFailed": "Kon de statistieken niet laden.",
    "productStatistiek.col.product": "Product",
    "productStatistiek.col.aantal": "Aantal",
    "productStatistiek.col.omzetExcl": "Omzet excl. btw",
    "productStatistiek.col.omzetIncl": "Omzet incl. btw",
    "productStatistiek.col.korting": "Korting",
    "productStatistiek.col.netto": "Netto",
    "productStatistiek.kpi.topProduct": "Topproduct",
    "productStatistiek.kpi.gemKorting": "Gem. korting %",
    "productStatistiek.kpi.aantalVerkopen": "Aantal verkopen",
    "productTrends.filter.weergave": "Weergave",
    "productTrends.weergave.aantal": "Aantal",
    "productTrends.weergave.omzet": "Omzet",
    "productTrends.filter.product": "Product",
    "productTrends.product.none": "Geen producten met verkopen.",
    "productTrends.filter.periode": "Periode",
    "productTrends.periode.maanden": "%d maanden",
    "productTrends.filter.vestiging": "Vestiging",
    "productTrends.filter.organisatie": "Hele organisatie",
    "productTrends.empty": "Geen gegevens voor dit product in deze periode.",
    "productTrends.loadFailed": "Kon de trends niet laden.",
    "productTrends.chart.label": "Verkopen per maand",
    "productTrends.insight.title": "Inzicht",
    "productTrends.insight.groei": "Groei",
    "productTrends.insight.piek": "Piekmaand",
    "entingenTab.loadFailed": "Kon de enting-instellingen niet laden.",
    "entingenTab.saved": "Opgeslagen.",
    "entingenTab.saveError": "Kon niet opslaan. Probeer het opnieuw.",
    "entingenTab.saveConflict": "Gewijzigd door iemand anders — laad het scherm opnieuw en probeer het nogmaals.",
    "entingenTab.section.toepassing": "Toepassing",
    "entingenTab.section.geldigheidsduur": "Geldigheidsduur & herhaling",
    "entingenTab.section.verplichting": "Verplichting",
    "entingenTab.section.vervolg": "Vervolgenting",
    "entingenTab.section.overige": "Overige instellingen",
    "entingenTab.section.notities": "Notities",
    "entingenTab.section.geldigheidsregeling": "Geldigheidsregeling",
    "entingenTab.diersoort": "Diersoort",
    "entingenTab.diersoort.all": "Alle diersoorten",
    "entingenTab.vanafLeeftijd": "Vanaf leeftijd",
    "entingenTab.totLeeftijd": "Tot leeftijd",
    "entingenTab.totLeeftijd.helper": "(leeg = onbeperkt)",
    "entingenTab.toepassenStatus": "Toepassen bij status",
    "entingenTab.toepassenAanwezig": "Aanwezig in asiel",
    "entingenTab.toepassenPleeggezin": "Pleeggezin",
    "entingenTab.geldigheidsduur": "Geldigheidsduur",
    "entingenTab.geldigheidsduur.info": "De enting is %s geldig vanaf de toedieningsdatum.",
    "entingenTab.waarschuwingVooraf": "Waarschuwing vooraf",
    "entingenTab.waarschuwingVooraf.helper":
      "Het dier verschijnt %s voor het verlopen van de enting in het overzicht.",
    "entingenTab.verplicht": "Is deze enting verplicht?",
    "entingenTab.vrijstelling": "Vrijstelling toegestaan?",
    "entingenTab.vervolg.geen": "Geen vervolgenting",
    "entingenTab.vervolg.zelfde": "Zelfde enting",
    "entingenTab.vervolg.andere": "Andere enting",
    "entingenTab.vervolg.info": "Een vervolgenting kan dezelfde enting zijn, maar ook een andere.",
    "entingenTab.vervolg.product": "Vervolgenting",
    "entingenTab.vervolg.moment": "Vervolg na (dagen)",
    "entingenTab.vervolg.stap1": "Stap 1:",
    "entingenTab.vervolg.stap1.value": "1ste enting",
    "entingenTab.vervolg.stap2": "Stap 2:",
    "entingenTab.vervolg.stap2.zelfde": "Herhaling",
    "entingenTab.vervolg.stap2.andere": "Vervolgenting",
    "entingenTab.vervolg.stap2.dagen": "na %s dagen",
    "entingenTab.combineerbaar": "Mag gecombineerd worden met andere entingen?",
    "entingenTab.interneOpmerking": "Interne opmerking",
    "entingenTab.actief": "Actief",
    "entingenTab.notities.placeholder": "Eventuele notities…",
    "entingenTab.geldigVanaf": "Geldig vanaf",
    "entingenTab.geldigVanaf.TOEDIENINGSDATUM": "Toedieningsdatum",
    "entingenTab.geldigVanaf.REGISTRATIEDATUM": "Registratiedatum",
    "entingenTab.geldigTot": "Geldig tot",
    "entingenTab.geldigTot.GELDIGHEIDSDUUR": "Einddatum berekenen op basis van geldigheidsduur",
    "entingenTab.geldigTot.VASTE_EINDDATUM": "Vaste einddatum",
    "entingenTab.geldigheidsregeling.info":
      "Bij registratie van deze enting wordt de vervaldatum automatisch berekend op basis van de toedieningsdatum en de bovenstaande instellingen.",
    "entingenTab.toggle.ja": "Ja",
    "entingenTab.toggle.jaVerplicht": "Ja, verplicht",
    "entingenTab.toggle.nee": "Nee",
    "entingenTab.eenheid.dagen": "dagen",
    "entingenTab.eenheid.weken": "weken",
    "entingenTab.eenheid.maanden": "maanden",
    "entingenTab.eenheid.jaren": "jaren",
    // The source singularises at 1 ("1 jaar", not "1 jaren").
    "entingenTab.eenheidEnkelvoud.dagen": "dag",
    "entingenTab.eenheidEnkelvoud.weken": "week",
    "entingenTab.eenheidEnkelvoud.maanden": "maand",
    "entingenTab.eenheidEnkelvoud.jaren": "jaar",
    "entingenTab.vrijstellingReden": "Reden vrijstelling (optioneel)",
    "entingenTab.vrijstellingReden.placeholder": "Selecteer reden vrijstelling",
    "entingenTab.geldigheidsduur.1maand": "1 maand",
    "entingenTab.geldigheidsduur.3maanden": "3 maanden",
    "entingenTab.geldigheidsduur.6maanden": "6 maanden",
    "entingenTab.geldigheidsduur.1jaar": "1 jaar",
    "entingenTab.geldigheidsduur.2jaar": "2 jaar",
    "entingenTab.geldigheidsduur.3jaar": "3 jaar",
    "medicijnTab.loadFailed": "De medicijn-instellingen konden niet worden geladen.",
    "medicijnTab.section.toepassing": "Toepassing",
    "medicijnTab.section.dosering": "Dosering",
    "medicijnTab.diersoort": "Diersoort",
    "medicijnTab.diersoort.all": "Alle diersoorten",
    "medicijnTab.toedieningsvorm": "Toedieningsvorm",
    "medicijnTab.toedieningsvorm.select": "Selecteer vorm",
    "medicijnTab.vanafGewicht": "Vanaf gewicht",
    "medicijnTab.totGewicht": "Tot gewicht",
    "medicijnTab.gewicht.helper": "(leeg = onbeperkt)",
    "medicijnTab.toepassenStatus": "Toepassen bij status",
    "medicijnTab.toepassenAanwezig": "Aanwezig in asiel",
    "medicijnTab.toepassenPleeggezin": "Pleeggezin",
    "medicijnTab.dosering": "Dosering",
    "medicijnTab.doseringEenheid": "Eenheid dosering",
    "medicijnTab.dosering.placeholder": "Bijv. 10",
    "medicijnTab.frequentie": "Frequentie toediening",
    "medicijnTab.freqUnit.dag": "per dag",
    "medicijnTab.freqUnit.week": "per week",
    "medicijnTab.freqUnit.maand": "per maand",
    "medicijnTab.freqUnit.uur": "om de … uur",
    "medicijnTab.freq.per.dag": "%sx per dag",
    "medicijnTab.freq.per.week": "%sx per week",
    "medicijnTab.freq.per.maand": "%sx per maand",
    "medicijnTab.freq.omDe": "Om de %s uur",
    "medicijnTab.kuur": "Duur van de kuur (optioneel)",
    "medicijnTab.kuur.placeholder": "Bijv. 7",
    "medicijnTab.reden": "Reden medicatie (optioneel)",
    "medicijnTab.reden.select": "Selecteer reden",
    "medicijnTab.instructie": "Toedieningsinstructie (optioneel)",
    "medicijnTab.instructie.placeholder": "Bijv. Toedienen met voer. Zorg voor voldoende water.",
    "medicijnTab.saved": "Opgeslagen",
    "medicijnTab.saveConflict": "Deze medicijn-instellingen zijn intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "medicijnTab.saveError": "Opslaan mislukt. Probeer het opnieuw.",
    "behandelingTab.loadFailed": "De behandel-instellingen konden niet worden geladen.",
    "behandelingTab.section.toepassing": "Toepassing",
    "behandelingTab.section.overige": "Overige instellingen",
    "behandelingTab.section.vervolg": "Vervolgbehandeling",
    "behandelingTab.diersoort": "Diersoort",
    "behandelingTab.diersoort.all": "Alle diersoorten",
    "behandelingTab.vanafLeeftijd": "Vanaf leeftijd",
    "behandelingTab.totLeeftijd": "Tot leeftijd",
    "behandelingTab.totLeeftijd.helper": "(leeg = onbeperkt)",
    "behandelingTab.toepassenStatus": "Toepassen bij status",
    "behandelingTab.toepassenAanwezig": "Aanwezig in asiel",
    "behandelingTab.toepassenPleeggezin": "Pleeggezin",
    "behandelingTab.interneOpmerking": "Interne opmerking",
    "behandelingTab.actief": "Actief",
    "behandelingTab.herhalen": "Herhalen elke",
    "behandelingTab.herhalen.info": "De volgende behandeling vindt plaats %s na de toedieningsdatum.",
    "behandelingTab.vervolg.softInfo": "Voor behandelen is meestal alleen een eenvoudige herhaling nodig.",
    "behandelingTab.waarschuwingVooraf": "Waarschuwing vooraf",
    "behandelingTab.waarschuwingVooraf.helper": "Het dier verschijnt %s voor de volgende behandeling in het overzicht.",
    "behandelingTab.vervolg.geen": "Geen automatische vervolgbehandeling",
    "behandelingTab.vervolg.zelfde": "Zelfde product opnieuw",
    "behandelingTab.vervolg.andere": "Andere behandeling daarna",
    "behandelingTab.vervolg.geen.info": "Geen automatische herhaling. Het dier verschijnt hierna niet opnieuw in het overzicht.",
    "behandelingTab.vervolg.product": "Vervolgbehandeling product",
    "behandelingTab.vervolg.product.select": "Selecteer product",
    "behandelingTab.vervolg.stap1": "Stap 1: Behandelen",
    "behandelingTab.vervolg.stap1.value": "vandaag",
    "behandelingTab.vervolg.stap2": "Stap 2: Herhaling",
    "behandelingTab.vervolg.stap2.value": "na %s",
    "behandelingTab.toggle.ja": "Ja",
    "behandelingTab.toggle.nee": "Nee",
    "behandelingTab.saved": "Opgeslagen",
    "behandelingTab.saveConflict": "Deze behandel-instellingen zijn intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "behandelingTab.saveError": "Opslaan mislukt. Probeer het opnieuw.",
    "behandelingTab.eenheid.dagen": "dagen",
    "behandelingTab.eenheidEnkelvoud.dagen": "dag",
    "behandelingTab.eenheidEnkelvoud.weken": "week",
    "behandelingTab.eenheidEnkelvoud.maanden": "maand",
    "behandelingTab.eenheidEnkelvoud.jaren": "jaar",
    "behandelingTab.eenheid.weken": "weken",
    "behandelingTab.eenheid.maanden": "maanden",
    "behandelingTab.eenheid.jaren": "jaren",
    "productNav": "Producten",
    "animalTagNav": "Dier-tags",
    "animalTagListView.empty": "Geen dier-tags.",
    "animalTagListView.loadFailed": "Kon dier-tags niet laden.",
    "animalTagListView.column.color": "Kleur",
    "animalTagListView.create": "Nieuwe tag",
    "animalTagListView.edit": "Bewerken",
    "animalTagListView.delete": "Verwijderen",
    "animalTagDetailView.create.title": "Nieuwe dier-tag",
    "animalTagDetailView.label": "Label",
    "animalTagDetailView.color": "Kleur",
    "animalTagDetailView.saveFailed": "Kon de dier-tag niet opslaan.",
    "tagsHubNav": "Tags",
    "tagsHub.title": "Tags",
    "tagsHub.category.label": "Categorie",
    "tagsHub.category.customer": "Relatie",
    "tagsHub.category.animal": "Dier",
    "tagsHub.category.note": "Notitie",
    "tagsHub.category.file": "Bestand (dier)",
    "tagsHub.category.relatieFile": "Bestand (relatie)",
    "tagsHub.category.pensionReservering": "Pensionreservering",
    "tagsHub.delete.inUse": "%d item(s) gebruiken \"%s\". Kies wat er gebeurt vóór verwijderen:",
    "tagsHub.delete.transferTo": "Gebruik overzetten naar",
    "tagsHub.delete.choosePlaceholder": "Kies een tag…",
    "tagsHub.delete.transferAndDelete": "Overzetten & verwijderen",
    "tagsHub.delete.removeAndDelete": "Overal verwijderen & verwijderen",
    "wassenSoortListView.title": "Wassen soorts",
    "wassenSoortListView.column.naam": "Naam",
    "wassenSoortListView.empty": "Geen wassoorten.",
    "wassenSoortListView.loadFailed": "Kon wassoorten niet laden.",
    "wassenSoortListView.new": "Nieuw",
    "wassenSoortListView.edit": "Bewerken",
    "wassenSoortListView.delete": "Verwijderen",
    "wassenSoortListView.delete.confirm": "Deze wassoort verwijderen?",
    "wassenSoortListView.delete.error": "Kon de wassoort niet verwijderen.",
    "wassenSoortDetailView.title": "Wassen soort",
    "wassenSoortDetailView.new.title": "Nieuwe wassoort",
    "wassenSoortDetailView.naam": "Naam",
    "wassenSoortDetailView.naam.required": "Naam is verplicht.",
    "wassenSoortDetailView.save.conflict": "Deze wassoort is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "wassenSoortDetailView.save.error": "Kon de wassoort niet opslaan.",
    "wassenSoortDetailView.loadFailed": "Kon wassoort niet laden.",
    // Categorie-neutrale kaart-/modal-teksten (de Jmix-hub gebruikte één neutrale set voor alle 5 categorieën).
    "tagsHub.empty": "Nog geen tags.",
    "tagsHub.loadFailed": "Kon tags niet laden.",
    "tagsHub.create.title": "Tag toevoegen",
    "tagsHub.edit.title": "Tag wijzigen",
    // Login-pagina (recreatie van de Jmix LoginView.* / loginForm.* bundle).
    "login.headerTitle": "Docasoft",
    "login.username": "Gebruikersnaam",
    "login.password": "Wachtwoord",
    "login.rememberMe": "Onthoud mij",
    "login.submit": "Inloggen",
    "login.locale": "Taal",
    "login.showPassword": "Wachtwoord tonen",
    "login.hidePassword": "Wachtwoord verbergen",
    "login.provisioningLogin": "Inloggen met HelloID",
    "login.badCredentials":
      "Controleer of je de juiste gebruikersnaam en wachtwoord hebt ingevoerd en probeer het opnieuw",
    // Wachtwoord-instellen-pagina (recreatie van de Jmix SetPasswordView — anoniem /set-password).
    "setPassword.title": "Wachtwoord instellen",
    "setPassword.intro": "Kies een nieuw wachtwoord voor je account.",
    "setPassword.newPassword": "Nieuw wachtwoord",
    "setPassword.confirmPassword": "Bevestig wachtwoord",
    "setPassword.submit": "Wachtwoord instellen",
    "setPassword.success": "Je wachtwoord is ingesteld. Je kunt nu inloggen.",
    "setPassword.toLogin": "Naar inloggen",
    "setPassword.error.confirmMismatch": "De wachtwoorden komen niet overeen.",
    "setPassword.error.weakPassword": "Kies een sterker wachtwoord (minimaal 8 tekens).",
    "setPassword.error.uniform": "De link is verlopen of ongeldig.",
    // Beheer gebruikers-scherm (migratie van de Jmix `users` view).
    "userListView.title": "Gebruikers",
    "userListView.createButton": "Nieuwe gebruiker",
    "userListView.showRemoved": "Verwijderde tonen",
    "userListView.empty": "Geen gebruikers.",
    "userListView.loadFailed": "Kon gebruikers niet laden.",
    "userListView.column.username": "Gebruikersnaam",
    "userListView.column.name": "Naam",
    "userListView.column.email": "E-mail",
    "userListView.column.status": "Status",
    "userListView.status.active": "Actief",
    "userListView.status.disabled": "Inactief",
    "userListView.status.removed": "Verwijderd",
    "userListView.migrateLegacyButton": "Legacy-gebruikers migreren",
    "userListView.search.placeholder": "Zoek op gebruikersnaam, naam of e-mailadres…",
    "userListView.pagination.range": "%d–%d van %d",
    "userListView.pagination.page": "Pagina %d van %d",
    "userListView.pagination.previous": "Vorige",
    "userListView.pagination.next": "Volgende",
    "legacyMigrationDialog.title": "Legacy-gebruikers migreren",
    "legacyMigrationDialog.intro":
      "Accounts uit de legacy docasoft-database. Gemigreerde accounts behouden hun wachtwoord en rollen en kunnen hier direct inloggen.",
    "legacyMigrationDialog.empty": "Geen legacy-accounts.",
    "legacyMigrationDialog.loadFailed": "Kon legacy-accounts niet laden.",
    "legacyMigrationDialog.selectAll": "Alles selecteren",
    "legacyMigrationDialog.selectAllOnPage": "Alles op deze pagina selecteren",
    "legacyMigrationDialog.filter.status": "Tonen",
    "legacyMigrationDialog.filter.status.pending": "Niet gemigreerd",
    "legacyMigrationDialog.filter.status.migrated": "Al gemigreerd",
    "legacyMigrationDialog.filter.status.all": "Beide",
    "legacyMigrationDialog.filter.username": "Gebruikersnaam",
    "legacyMigrationDialog.filter.linkedUser": "Gemigreerd naar",
    "legacyMigrationDialog.selectRow": "Selecteer %s",
    "legacyMigrationDialog.column.linkedUser": "Gemigreerd naar",
    "legacyMigrationDialog.status.migrated": "Gemigreerd",
    "legacyMigrationDialog.status.matchedByName": "Bestaande gebruiker met deze naam",
    "legacyMigrationDialog.status.notMigrated": "Niet gemigreerd",
    "legacyMigrationDialog.status.noPassword": "Geen wachtwoord",
    "legacyMigrationDialog.migrateButton": "Selectie migreren (%d)",
    "legacyMigrationDialog.result.success": "%d account(s) gemigreerd.",
    "legacyMigrationDialog.result.partial": "%d account(s) gemigreerd, %d overgeslagen of mislukt.",
    "legacyMigrationDialog.failed": "Migratie mislukt.",
    "userDetailView.loadFailed": "Kon deze gebruiker niet laden.",
    "userDetailView.field.username": "Gebruikersnaam",
    "userDetailView.field.name": "Naam",
    "userDetailView.field.firstName": "Voornaam",
    "userDetailView.field.lastName": "Achternaam",
    "userDetailView.field.email": "E-mail",
    "userDetailView.field.employeeId": "Medewerker-ID",
    "userDetailView.field.active": "Actief",
    "userDetailView.field.status": "Status",
    "userDetailView.field.password": "Wachtwoord",
    "userDetailView.password.set": "Ingesteld",
    "userDetailView.password.unset": "Niet ingesteld — stuur een resetlink",
    "userDetailView.password.mustChange": "Moet bij volgende login gewijzigd worden",
    "userDetailView.setPassword.button": "Wachtwoord instellen",
    "userDetailView.setPassword.title": "Wachtwoord instellen",
    "userDetailView.setPassword.field.password": "Nieuw wachtwoord",
    "userDetailView.setPassword.field.confirm": "Bevestig wachtwoord",
    "userDetailView.setPassword.field.mustChange": "Gebruiker moet het bij de volgende login wijzigen",
    "userDetailView.setPassword.help":
      "Gebruik dit voor een gebruiker zonder e-mailadres; geef het wachtwoord persoonlijk door. Anders is een resetlink veiliger.",
    "userDetailView.setPassword.submit": "Wachtwoord instellen",
    "userDetailView.setPassword.error.mismatch": "De wachtwoorden komen niet overeen.",
    "userDetailView.setPassword.error.weak": "Kies een sterker wachtwoord (minimaal 8 tekens).",
    "userDetailView.setPassword.error.generic": "Kon het wachtwoord niet instellen.",
    "forcePasswordChange.title": "Wijzig je wachtwoord",
    "forcePasswordChange.intro":
      "Je wachtwoord is door een beheerder ingesteld. Kies je eigen wachtwoord om verder te gaan.",
    "forcePasswordChange.currentPassword": "Huidig wachtwoord",
    "forcePasswordChange.newPassword": "Nieuw wachtwoord",
    "forcePasswordChange.confirmPassword": "Bevestig wachtwoord",
    "forcePasswordChange.submit": "Wachtwoord wijzigen",
    "forcePasswordChange.logout": "Uitloggen",
    "forcePasswordChange.error.confirmMismatch": "De wachtwoorden komen niet overeen.",
    "forcePasswordChange.error.weakPassword": "Kies een sterker wachtwoord (minimaal 8 tekens).",
    "forcePasswordChange.error.badCurrentPassword": "Dat is niet je huidige wachtwoord.",
    "forcePasswordChange.error.unreachable": "Kon de server niet bereiken. Probeer het opnieuw.",
    "forcePasswordChange.error.generic": "Kon het wachtwoord niet wijzigen.",
    "userDetailView.action.delete": "Verwijderen",
    "userDetailView.action.deleteTitle": "Gebruiker verwijderen",
    "userDetailView.action.deleteBody":
      "Het account \u201c%s\u201d verwijderen? De gebruiker verliest direct toegang. Het account kan daarna hersteld worden.",
    "userDetailView.action.restore": "Herstellen",
    "userDetailView.action.failed": "De actie is mislukt. Probeer het opnieuw.",
    "userDetailView.resetLink.button": "Wachtwoord-resetlink genereren",
    "userDetailView.resetLink.revealed": "Deel deze eenmalige link met de gebruiker (wordt één keer getoond):",
    "userDetailView.resetLink.copy": "Kopiëren",
    "userDetailView.resetLink.copied": "Gekopieerd",
    "userDetailView.resetLink.failed": "Kon geen resetlink genereren.",
    "userDetailView.teams.title": "Teams",
    "userDetailView.teams.none": "Nog in geen team. Het team bepaalt welke taken deze gebruiker krijgt en ziet.",
    "userDetailView.teams.add": "Team toevoegen",
    "userDetailView.teams.addTitle": "Team toevoegen",
    "userDetailView.teams.addNoneLeft": "Deze gebruiker zit al in elk team.",
    "userDetailView.teams.removeTitle": "Uit team halen",
    "userDetailView.teams.removeBody": "Deze gebruiker uit %s halen?",
    "userDetailView.teams.removeAria": "Uit %s halen",
    "userDetailView.teams.searchPlaceholder": "Zoek een team",
    "userDetailView.teams.loadFailed": "De teams konden niet worden geladen.",
    "userDetailView.teams.saveFailed": "De teams konden niet worden opgeslagen.",
    "teamsBeheer.knop": "Teams beheren",
    "mijnTeams.titel": "Mijn teams",
    "mijnTeams.uitleg": "Teams waarvoor je momenteel werkt",
    "mijnTeams.actief": "%s actief",
    "mijnTeams.vast": "Vast",
    "mijnTeams.vandaag": "Vandaag",
    "mijnTeams.vandaagKort": "vandaag",
    "mijnTeams.totMiddernacht": "Tijdelijk actief tot 23:59 uur",
    "mijnTeams.tijdelijk": "Tijdelijk een team toevoegen",
    "mijnTeams.voegToe": "Team voor vandaag toevoegen",
    "mijnTeams.loslaten": "%s voor vandaag loslaten",
    "mijnTeams.geen": "Je zit nog in geen team. Voeg er hieronder een voor vandaag toe, of vraag beheer om een vast team.",
    "mijnTeams.nietsTeKiezen": "Er zijn geen andere teams om te kiezen.",
    "mijnTeams.mislukt": "Dat is niet gelukt.",
    "mijnTeams.beheren": "Teams beheren",
    "mijnTeams.kiezen": "Team kiezen",
    "dashboard.aanpassen.knop": "Dashboard aanpassen",
    "dashboard.aanpassen.titel": "Dashboard aanpassen",
    "dashboard.aanpassen.uitleg": "Kies welke tegels je ziet en in welke volgorde. Dit geldt alleen voor jou.",
    "dashboard.aanpassen.standaard": "Standaard herstellen",
    "dashboard.aanpassen.mislukt": "Opslaan is niet gelukt.",
    "dashboard.aanpassen.omhoog": "%s omhoog",
    "dashboard.aanpassen.omlaag": "%s omlaag",
    "berichten.titel": "Berichten & teams",
    "berichten.ongelezenBadge": "%s ongelezen berichten",
    "berichten.ongelezenBadgeEen": "%s ongelezen bericht",
    "berichten.ongelezenEen": "Ongelezen",
    "berichten.versturenNaar": "Versturen naar",
    "berichten.alleTeamsChip": "Alle teams",
    "berichten.alleTeams": "alle teams",
    "berichten.tekstLabel": "Bericht",
    "berichten.placeholder": "Typ je bericht… De eerste regel wordt de titel.",
    "berichten.hint": "Zonder team of persoon gaat het bericht naar iedereen.",
    "berichten.persoonZoeken": "Zoek een persoon",
    "berichten.persoonPlaceholder": "+ Persoon toevoegen (zoek op naam)…",
    "berichten.persoonGeen": "Niemand gevonden.",
    "berichten.gekozenPersonen": "Gekozen personen",
    "berichten.persoonWeg": "%s weghalen",
    "berichten.verstuurd": "Bericht verstuurd.",
    "berichten.versturen": "Versturen",
    "berichten.typEerst": "Typ eerst een bericht.",
    "berichten.mislukt": "Versturen is niet gelukt.",
    "berichten.recent": "Recente berichten",
    "berichten.geen": "Nog geen berichten.",
    "berichten.allesBekijken": "Alles bekijken",
    "berichten.alleBerichten": "Alle berichten",
    "berichten.bericht": "Bericht",
    "berichten.vanMij": "Jij",
    "berichten.aan": "Aan %s",
    "berichten.reacties": "%s reacties",
    "berichten.zojuist": "zojuist",
    "berichten.minGeleden": "%s min geleden",
    "berichten.uurGeleden": "%s uur geleden",
    "berichten.gisteren": "gisteren",
    "berichten.nietGevonden": "Dit bericht kon niet worden geopend.",
    "berichten.reageerLabel": "Reactie",
    "berichten.reageerPlaceholder": "Typ een reactie…",
    "berichten.reageren": "Reageren",
    "teamsBeheer.titel": "Teams",
    "teamsBeheer.uitleg": "De teams waaraan taken worden toegewezen. Een uitgezet team is niet meer te kiezen; bestaande taken houden het.",
    "teamsBeheer.nieuw": "Nieuw team",
    "teamsBeheer.nieuwPlaats": "Naam van een nieuw team, bijv. Management",
    "teamsBeheer.toevoegen": "Toevoegen",
    "teamsBeheer.naamVan": "Naam van %s",
    "teamsBeheer.actief": "Actief",
    "teamsBeheer.uitgezet": "Uitgezet",
    "teamsBeheer.mislukt": "Opslaan is niet gelukt.",
    "teamsBeheer.naam": "Naam van het team",
    "teamsBeheer.leden": "%s leden",
    "teamsBeheer.eenLid": "1 lid",
    "teamsBeheer.kiesTeam": "Kies links een team.",
    "teamsBeheer.uitgezetUitleg": "Dit team is niet meer te kiezen bij nieuwe taken. Bestaande taken en leden blijven staan.",
    "teamsBeheer.ledenTitel": "Leden",
    "teamsBeheer.lidZoeken": "Lid toevoegen: zoek op naam of e-mail",
    "teamsBeheer.geenGebruikers": "Geen gebruikers gevonden (of al lid van dit team).",
    "teamsBeheer.geenLeden": "Nog niemand in dit team. Zoek hierboven om iemand toe te voegen.",
    "teamsBeheer.accountUit": "Account uitgezet",
    "teamsBeheer.lidWeg": "%s uit dit team halen",
    "userDetailView.roles.title": "Rollen",
    "userDetailView.roles.none": "Deze gebruiker heeft geen rollen.",
    "userDetailView.roles.add": "Rol toevoegen",
    "userDetailView.roles.addTitle": "Rol toevoegen",
    "userDetailView.roles.addNoneLeft": "Deze gebruiker heeft alle rollen al.",
    "userDetailView.roles.searchPlaceholder": "Zoek rollen…",
    "userDetailView.roles.removeTitle": "Rol verwijderen",
    "userDetailView.roles.removeBody": "De rol \u201c%s\u201d van deze gebruiker verwijderen?",
    "userDetailView.roles.removeAria": "Rol %s verwijderen",
    "userDetailView.roles.loadFailed": "Kon de rollen van deze gebruiker niet laden.",
    "userDetailView.roles.saveFailed": "Kon de rollen niet opslaan. Er is niets gewijzigd.",
    "userDetailView.vestigingen.title": "Vestigingen",
    "userDetailView.vestigingen.help":
      "De vestigingen waar deze gebruiker bij kan. Toevoegen of verwijderen gaat direct in.",
    "userDetailView.vestigingen.none": "Deze gebruiker heeft geen toegang tot vestigingen.",
    "userDetailView.vestigingen.add": "Vestiging toevoegen",
    "userDetailView.vestigingen.addTitle": "Vestiging toevoegen",
    "userDetailView.vestigingen.addNoneLeft": "Deze gebruiker heeft alle toewijsbare vestigingen al.",
    "userDetailView.vestigingen.searchPlaceholder": "Zoek vestigingen…",
    "userDetailView.vestigingen.removeTitle": "Vestiging verwijderen",
    "userDetailView.vestigingen.removeBody": "De toegang tot \u201c%s\u201d voor deze gebruiker verwijderen?",
    "userDetailView.vestigingen.removeAria": "Vestiging %s verwijderen",
    "userDetailView.vestigingen.loadFailed": "Kon de vestigingen van deze gebruiker niet laden.",
    "userDetailView.vestigingen.writeFailed": "Kon de vestigingstoegang niet wijzigen. Er is niets gewijzigd.",
    "userDetailView.vestigingen.refused":
      "Deze vestiging kan niet los gewijzigd worden — zie de uitleg ernaast. Er is niets gewijzigd.",
    "userDetailView.vestigingen.notLinked":
      "Dit account is niet gekoppeld aan een docaserver-gebruikersaccount; vestigingstoegang kan er niet aan toegewezen worden.",
    "userDetailView.vestigingen.koppelen": "Account koppelen",
    "userDetailView.vestigingen.koppelenUitleg":
      "Koppelen maakt het docaserver-account aan dat deze gebruiker nodig heeft voor vestigingstoegang (of koppelt het bestaande met dezelfde gebruikersnaam).",
    "userDetailView.vestigingen.koppelenMislukt": "Koppelen is mislukt. Er is niets gewijzigd.",
    "userDetailView.vestigingen.fullAccess":
      "Deze gebruiker heeft een rol met volledige toegang en komt bij alle vestigingen, ongeacht de lijst hieronder.",
    "userDetailView.vestigingen.blocked.noGroup": "Geen enkele groep geeft toegang tot deze vestiging.",
    "userDetailView.vestigingen.blocked.ambiguous": "Meerdere groepen geven toegang tot deze vestiging (%s); hier niet te wijzigen.",
    "userDetailView.vestigingen.blocked.shared": "De groep geeft ook toegang tot %s; hier verwijderen zou die ook intrekken.",
    // Voorkeuren (persoonlijke voorkeuren — migratie van de Jmix UserPreferencesView).
    "voorkeuren.title": "Mijn voorkeuren",
    "voorkeuren.tab.apparaten": "Mijn apparaten",
    "voorkeuren.apparaten.uitleg": "De telefoons en tablets waarop je de dierverzorgers-app gebruikt. Maak een koppelcode aan en scan hem in de app — of voer het adres en de code met de hand in.",
    "voorkeuren.apparaten.codeMaken": "Koppelcode aanmaken",
    "voorkeuren.apparaten.codeMislukt": "Er kon geen koppelcode worden aangemaakt. Probeer het opnieuw.",
    "voorkeuren.apparaten.intrekkenMislukt": "Het intrekken is niet gelukt. Probeer het opnieuw.",
    "voorkeuren.apparaten.adres": "Adres",
    "voorkeuren.apparaten.code": "Code",
    "voorkeuren.apparaten.opvang": "Opvang",
    "voorkeuren.apparaten.kopieer": "Kopieer",
    "voorkeuren.apparaten.qrAlt": "QR-code met het adres en de koppelcode",
    "voorkeuren.apparaten.gekopieerd": "Gekopieerd.",
    "voorkeuren.apparaten.geldigNog": "Nog %s geldig. De code werkt één keer.",
    "voorkeuren.apparaten.handmatig": "Kun je niet scannen? Kies in de app \"Handmatig invoeren\" en tik het adres en de code hierboven over.",
    "voorkeuren.apparaten.adresOnbruikbaar": "Dit adres wijst naar de machine zelf, dus geen enkele telefoon komt erbij. Stel fawkes.api.devices.base-url in op het adres waarop de app deze server bereikt, en maak daarna een nieuwe code aan.",
    "voorkeuren.apparaten.gekoppeld": "Gekoppelde apparaten",
    "voorkeuren.apparaten.geen": "Er is nog geen apparaat gekoppeld.",
    "logboek.periode": "Periode",
    "logboek.periode.week": "Laatste 7 dagen",
    "logboek.periode.maand": "Laatste 30 dagen",
    "logboek.periode.kwartaal": "Laatste 90 dagen",
    "logboek.periode.alles": "Alles",
    "logboek.categorie": "Categorie",
    "logboek.categorie.alle": "Alle",
    "logboek.zoeken": "Zoeken",
    "logboek.zoekenPlaceholder": "Zoeken…",
    "logboek.uitleg": "Dagelijkse verzorgingsacties en observaties",
    "logboek.leeg": "Niets vastgelegd in deze periode.",
    "logboek.ophalenMislukt": "Het logboek kon niet worden opgehaald.",
    "logboek.opslaanMislukt": "De logregel kon niet worden opgeslagen.",
    "logboek.vandaag": "Vandaag",
    "logboek.gisteren": "Gisteren",
    "logboek.door": "door %s",
    "logboek.doorOnbekend": "auteur onbekend",
    "logboek.uitTaak": "uit een taak",
    "logboek.uitFormulier": "uit een formulier",
    "logboek.allesBekijken": "Alles bekijken",
    "logboek.allesTitel": "Logboek — alles",
    "logboek.nieuw": "Nieuwe logregel",
    "logboek.wat": "Wat is er gebeurd?",
    "logboek.watPlaceholder": "Uitgelaten, slecht gegeten, blaft naar andere honden…",
    "logboek.snelleActies": "Snelle acties",
    "logboek.snelUitleg": "Eén tik voor wat elke dag terugkomt. De rest tik je zelf.",
    "logboek.snel.uitgelaten": "Uitgelaten",
    "logboek.snel.water": "Water ververst",
    "logboek.snel.hok": "Verblijf schoongemaakt",
    "logboek.snel.goedGegeten": "Goed gegeten",
    "logboek.snel.slechtGegeten": "Slecht gegeten",
    "animalDetailView.tile.logboek": "Logboek",
    "voorkeuren.apparaten.zojuistGekoppeld": "%s is gekoppeld. De code is gebruikt en werkt niet meer.",
    "voorkeuren.apparaten.wachtOpToestel": "Wachten tot een toestel deze code gebruikt…",
    "voorkeuren.apparaten.intrekken": "Intrekken",
    "voorkeuren.apparaten.nooitGebruikt": "Nooit gebruikt",
    "voorkeuren.apparaten.kolom.naam": "Apparaat",
    "voorkeuren.apparaten.kolom.platform": "Platform",
    "voorkeuren.apparaten.kolom.gekoppeld": "Gekoppeld",
    "voorkeuren.apparaten.kolom.laatstGebruikt": "Laatst gebruikt",
    "voorkeuren.tab.profiel": "Profiel",
    "voorkeuren.tab.taal": "Taal",
    "voorkeuren.tab.vestiging": "Vestiging",
    "voorkeuren.tab.notificaties": "Notificaties",
    "voorkeuren.tab.filters": "Standaard filters",
    // Toestelkoppeling voor de dierverzorgers-app (D2/D3/D5). De code zelf tonen we nooit als tekst:
    // er is niets dat je er met de hand mee doet, en een getoond geheim wordt overgeschreven.
    "voorkeuren.apparaten.koppel": "Toestel koppelen",
    "voorkeuren.apparaten.scan": "Scan deze code met de app",
    "voorkeuren.apparaten.geldig": "Nog geldig:",
    "voorkeuren.apparaten.verberg": "Code verbergen",
    "voorkeuren.apparaten.qrFout": "De koppelcode kon niet getekend worden.",
    "voorkeuren.apparaten.codeFout": "Er kon geen koppelcode worden aangemaakt. Probeer het opnieuw.",
    "voorkeuren.apparaten.leeg": "Je hebt nog geen toestel gekoppeld.",
    "voorkeuren.apparaten.gekoppeldOp": "Gekoppeld op",
    "voorkeuren.apparaten.laatstGebruikt": "Laatst gebruikt",
    "voorkeuren.apparaten.intrekkenTitel": "Toestel intrekken",
    "voorkeuren.apparaten.intrekkenUitleg": "{naam} komt hierna niet meer in de app. Ben je het toestel kwijt, trek het dan in en koppel het nieuwe. Je andere toestellen blijven gewoon werken.",
    "voorkeuren.apparaten.intrekkenFout": "Het toestel kon niet worden ingetrokken.",
    "voorkeuren.profiel.lokaal": "Lokale users: bewerkbaar.",
    "voorkeuren.profiel.foto": "Profielfoto",
    "voorkeuren.profiel.fotoKiezen": "Foto kiezen",
    "voorkeuren.profiel.fotoVerwijderen": "Foto verwijderen",
    "voorkeuren.profiel.fotoHint": "JPG of PNG, max 2 MB.",
    "voorkeuren.profiel.fotoFout": "De foto kon niet worden opgeslagen. Kies een JPG of PNG van maximaal 2 MB.",
    "voorkeuren.vestiging.uitleg": "Deze vestiging wordt automatisch geselecteerd bij inloggen.",
    "voorkeuren.vestiging.label": "Standaard vestiging",
    "voorkeuren.thema.uitleg": "Klik op een thema voor een live preview. Druk op Opslaan om te bevestigen.",
    "voorkeuren.taal.uitleg": "Taal van de interface.",
    "voorkeuren.notificaties.uitleg": "Aan- en uitzetten per type.",
    "voorkeuren.notificaties.leeg": "Notificatie-types zijn nog niet beschikbaar — komen later.",
    "voorkeuren.filters.uitleg": "Standaard tijdsfilter per tegel op het Dier-scherm.",
    "voorkeuren.opslaanFout": "Je voorkeuren konden niet worden opgeslagen. Probeer het opnieuw.",
    "voorkeuren.theme.docasoft-green.uitleg": "Standaard look — neutraal, helder.",
    "voorkeuren.theme.warm.uitleg": "Cream + bruin + gouden accent, editorial uitstraling.",
    "voorkeuren.theme.dark.uitleg": "Dark mode met groen-getinte surfaces.",
    "voorkeuren.theme.high-contrast.uitleg": "Toegankelijkheid — hoog contrast, harde randen.",
    "voorkeuren.tab.thema": "Thema",
    "voorkeuren.profiel.username": "Gebruikersnaam",
    "voorkeuren.profiel.firstName": "Voornaam",
    "voorkeuren.profiel.lastName": "Achternaam",
    "voorkeuren.profiel.email": "E-mail",
    "voorkeuren.profiel.saved": "Opgeslagen.",
    "voorkeuren.profiel.loadFailed": "Kon je profiel niet laden.",
    "voorkeuren.profiel.managedExternally": "Je profiel wordt beheerd via HelloID en kan hier niet worden gewijzigd.",
    "voorkeuren.password.hint": "We sturen een verificatie-link naar je e-mailadres; de wijziging wordt actief na klikken op de link.",
    "voorkeuren.password.button": "Wachtwoord wijzigen",
    "voorkeuren.password.sent": "Verificatie-link naar je e-mailadres verstuurd.",
    "voorkeuren.password.noEmail": "Je hebt geen e-mailadres ingesteld. Vul er eerst een in en sla op.",
    "voorkeuren.password.oidcDisabled": "Wachtwoord wordt beheerd via HelloID.",
    "voorkeuren.password.failed": "Kon de wachtwoordwijziging niet starten. Probeer het opnieuw.",
    "voorkeuren.taal.label": "Taal van de interface",
    "voorkeuren.thema.label": "Thema",
    "voorkeuren.thema.saved": "Thema toegepast.",
    "voorkeuren.theme.docasoft-green": "Docasoft Groen",
    "voorkeuren.theme.warm": "Warm / Aardetinten",
    "voorkeuren.theme.dark": "Donker",
    "voorkeuren.theme.high-contrast": "Hoog Contrast",
    "voorkeuren.theme.eigen": "Eigen thema (AI)",
    "voorkeuren.theme.eigen.uitleg": "Gegenereerd uit een website-URL — AI kiest de dominante kleuren.",
    "voorkeuren.thema.eigenUitleg": "Plak een website-URL en klik 'AI thema genereren'. De kleuren van de site worden opgehaald en tot een thema gemaakt; kleuren uit ingesloten filmpjes tellen niet mee.",
    "voorkeuren.thema.website": "Website-URL",
    "voorkeuren.thema.genereer": "AI thema genereren",
    "voorkeuren.thema.bezig": "Bezig…",
    "voorkeuren.thema.gevonden": "Gevonden op de site:",
    "voorkeuren.thema.eigenFout": "Van deze pagina kon geen thema worden gemaakt. Probeer een andere URL.",
    "userCreateView.title": "Nieuwe gebruiker",
    "userCreateView.field.username": "Gebruikersnaam",
    "userCreateView.field.password": "Wachtwoord (optioneel)",
    "userCreateView.field.passwordHelp": "Laat leeg om de gebruiker het via een resetlink te laten instellen.",
    "userCreateView.submit": "Gebruiker aanmaken",
    "userCreateView.error.usernameRequired": "Vul een gebruikersnaam in.",
    "userCreateView.error.duplicate": "Die gebruikersnaam is al in gebruik.",
    "userCreateView.error.generic": "Kon de gebruiker niet aanmaken. Probeer het opnieuw.",
    // Vestiging-selector + wissel-dialoog (port van de Jmix vestigingSelector.* bundle).
    "vestigingSelector.label": "Vestiging",
    // Korte pill-label in de sidebar-kaartkop (de live Jmix "Wisselen"-knop).
    "vestigingSelector.switchLabel": "Wisselen",
    "vestigingSelector.empty": "Geen actieve vestigingen beschikbaar",
    "vestigingSelector.dialogTitle": "Andere vestiging openen",
    "vestigingSelector.dialogIntro": "Kies de vestiging waarin je wilt werken.",
    "vestigingSelector.current": "Huidige",
    "vestigingSelector.loadFailed": "Kon vestigingen niet laden.",
    "vestigingSelector.searchPlaceholder": "Zoeken op naam of plaats…",
    "vestigingSelector.noResults": "Geen vestigingen gevonden.",
    // Asiel/Pension-schakelaar in de vestigingskaart (alleen zichtbaar als beide modules aanstaan).
    "vestigingSelector.modus.label": "Werkmodus",
    "vestigingSelector.modus.asiel": "Asiel",
    "vestigingSelector.modus.pension": "Pension",
    "vestigingSelector.modus.crematorium": "Crematorium",
    "menu.crematoriumKlanten": "Klanten",
    "menu.crematieTarieven": "Crematietarieven",
    "menu.ophaalkosten": "Ophaalkosten",
    "crematoriumTarief.sub": "Prijzen per gewichtsklasse en uitvaartvorm",
    "crematoriumTarief.kpi.versie": "Actieve versie sinds",
    "crematoriumTarief.kpi.klassen": "Gewichtsklassen",
    "crematoriumTarief.kpi.regels": "Tariefregels",
    "crematoriumTarief.kpi.toeslagen": "Actieve toeslagen",
    "crematoriumTarief.tab.tarieven": "Tarieven",
    "crematoriumTarief.klasse.col.diersoort": "Diersoort",
    "crematoriumTarief.klasse.uitleg": "Grenzen sluiten zonder overlap op elkaar aan.",
    "crematoriumTarief.diersoort.alle": "Alle soorten",
    "crematoriumTarief.filter.geldigOp": "Geldig op",
    "crematoriumTarief.filter.alleenActief": "Alleen actief",
    "crematoriumTarief.filter.wissen": "Wissen",
    "crematoriumTarief.tarief.versieUitleg": "Een wijziging maakt een nieuwe versie. Uitgegeven facturen blijven aan hun eigen versie hangen en veranderen niet mee.",
    "crematoriumTarief.toeslag.title": "Toeslagen",
    "crematoriumTarief.toeslag.add": "Toeslag toevoegen",
    "crematoriumTarief.toeslag.add.title": "Nieuwe toeslag",
    "crematoriumTarief.toeslag.edit.title": "Toeslag bewerken",
    "crematoriumTarief.toeslag.empty": "Nog geen toeslagen.",
    "crematoriumTarief.toeslag.uitleg": "Energie- en administratietoeslag bovenop het tarief, per uitvaartvorm.",
    "crematoriumTarief.toeslag.col.naam": "Naam",
    "crematoriumTarief.toeslag.col.bedrag": "Bedrag",
    "crematoriumTarief.toeslag.col.geldigVanaf": "Geldig vanaf",
    "crematoriumTarief.toeslag.col.geldigTot": "Geldig tot",
    "crematoriumTarief.toeslag.col.automatisch": "Automatisch als factuurregel",
    "crematoriumTarief.toeslag.alleVormen": "Alle vormen",
    "crematoriumTarief.toeslag.alleKlassen": "Alle gewichtsklassen",
    "crematoriumTarief.klasse.controleer": "Controleer met de andere klassen",
    "crematoriumTarief.klasse.advies.voorstel": "Voorgestelde aanpassingen:",
    "crematoriumTarief.klasse.advies.toepassen": "Deze aanpassingen doorvoeren",
    "crematoriumTarief.klasse.advies.eigenNaam": "De naam die bij deze grenzen hoort is \"%s\".",
    "crematoriumTarief.klasse.advies.naamOvernemen": "Die naam overnemen",
    "crematoriumTarief.toeslag.verplicht": "Naam en bedrag zijn verplicht.",
    "crematoriumTarief.toeslag.geldigTotUitleg": "Laat \"geldig tot\" leeg zolang de toeslag doorloopt. Bij een nieuwe versie wordt de vorige automatisch afgesloten.",
    "crematoriumTarief.toeslag.status.ACTIEF": "Actief",
    "crematoriumTarief.toeslag.status.GEPLAND": "Gepland",
    "crematoriumTarief.toeslag.status.VERLOPEN": "Verlopen",
    "crematoriumTarief.toeslag.status.INACTIEF": "Inactief",
    "relatieDetailView.tab.documenten": "Documenten",
    "crematoriumKlantDocumenten.col.document": "Document",
    "crematoriumKlantDocumenten.col.categorie": "Categorie",
    "crematoriumKlantDocumenten.col.kanaal": "Kanaal",
    "crematoriumKlantDocumenten.col.datum": "Datum",
    "crematoriumKlantDocumenten.col.uitvaart": "Uitvaart",
    "crematoriumKlantDocumenten.col.status": "Status",
    "crematoriumKlantDocumenten.dossier": "Dossier openen",
    "crematoriumKlantDocumenten.empty": "Nog geen documenten.",
    "crematoriumVervoer.sub": "Standaardregel en afspraken per praktijk",
    "crematoriumVervoer.nieuweVersie": "Nieuwe versie",
    "crematoriumVervoer.standaardregel": "Standaard ophaalregel",
    "crematoriumVervoer.actiefSinds": "Actief sinds",
    "crematoriumVervoer.veld.naam": "Naam",
    "crematoriumVervoer.veld.starttarief": "Starttarief",
    "crematoriumVervoer.veld.starttariefTot": "Starttarief tot en met",
    "crematoriumVervoer.veld.starttariefVanaf": "Starttarief vanaf",
    "crematoriumVervoer.veld.grensKm": "Grens (km)",
    "crematoriumVervoer.veld.prijsPerKm": "Prijs per extra km",
    "crematoriumVervoer.veld.vrijeKm": "Vrije km in rayon",
    "crematoriumVervoer.veld.spoedtoeslag": "Spoedtoeslag",
    "crematoriumVervoer.veld.btw": "Btw",
    "crematoriumVervoer.veld.retour": "Retour rekenen",
    "crematoriumVervoer.veld.ingangsdatum": "Ingangsdatum",
    "crematoriumVervoer.proef.title": "Proefberekening",
    "crematoriumVervoer.proef.exclBtw": "Exclusief btw",
    "crematoriumVervoer.proef.enkeleReis": "Enkele reis (km)",
    "crematoriumVervoer.proef.moment": "Ophaalmoment",
    "crematoriumVervoer.proef.regulier": "Regulier",
    "crematoriumVervoer.proef.spoed": "Spoed",
    "crematoriumVervoer.proef.retour": "retour",
    "crematoriumVervoer.proef.start": "starttarief",
    "crematoriumVervoer.proef.geenRegel": "Geen actieve regel om mee te rekenen.",
    "crematoriumVervoer.proef.uitleg": "De gebruikte regel én de uitkomst worden bij het uitgeven van de factuur als momentopname bewaard.",
    "crematoriumVervoer.afspraken.title": "Afwijkende praktijkafspraken",
    "crematoriumVervoer.afspraken.uitleg": "Afgesproken op de relatie (tabblad Dierenarts); hier bij elkaar zodat je ziet wie van de standaardregel afwijkt.",
    "crematoriumVervoer.afspraken.empty": "Geen praktijk wijkt af van de standaardregel.",
    "crematoriumVervoer.afspraak.col.praktijk": "Praktijk",
    "crematoriumVervoer.afspraak.col.regel": "Regel",
    "crematoriumVervoer.afspraak.col.prijs": "Vervoersprijs",
    "crematoriumVervoer.afspraak.col.geldigVanaf": "Geldig vanaf",
    "crematoriumVervoer.afspraak.col.status": "Status",
    "crematoriumVervoer.afspraak.vast": "Vast tarief binnen rayon",
    "crematoriumVervoer.status.actief": "Actief",
    "crematoriumVervoer.status.gepland": "Gepland",
    "crematoriumVervoer.status.vorig": "Vorige",
    "crematoriumVervoer.versies.title": "Eerdere versies",
    "crematoriumVervoer.fout.verplicht": "Starttarief en prijs per km zijn verplicht.",
    "crematoriumVervoer.fout.opslaan": "De regel kon niet worden opgeslagen.",
    "menu.crematoriumVergoedingen": "Vergoedingen",
    "crematoriumVergoedingen.title": "Vergoedingen",
    "crematoriumVergoedingen.sub": "Afspraken met verwijzende praktijken en derde partijen",
    "crematoriumVergoedingen.tab.afspraken": "Afspraken",
    "crematoriumVergoedingen.tab.uitbetaling": "Uitbetalingslijst",
    "crematoriumVergoedingen.zoek": "Zoeken",
    "crematoriumVergoedingen.peildatum": "Peildatum",
    "crematoriumVergoedingen.alleenActief": "Alleen actief",
    "crematoriumVergoedingen.uitleg": "Een afspraak wijzig je op de relatie zelf; deze lijst laat zien wie wat krijgt.",
    "crematoriumVergoedingen.empty": "Geen afspraken op deze datum.",
    "crematoriumVergoedingen.col.relatie": "Praktijk",
    "crematoriumVergoedingen.col.rol": "Rol",
    "crematoriumVergoedingen.col.type": "Vergoedingstype",
    "crematoriumVergoedingen.col.waarde": "Waarde",
    "crematoriumVergoedingen.col.vervoer": "Vervoersprijs",
    "crematoriumVergoedingen.col.uitbetaling": "Uitbetaling",
    "crematoriumVergoedingen.col.geldigVanaf": "Geldig vanaf",
    "crematoriumVergoedingen.col.status": "Status",
    "crematoriumVergoedingen.col.uitvaarten": "Uitvaarten",
    "crematoriumVergoedingen.col.totaal": "Totaal",
    "crematoriumVergoedingen.rol.alle": "Alle rollen",
    "crematoriumVergoedingen.rol.praktijk": "Dierenartspraktijk",
    "crematoriumVergoedingen.rol.derdePartij": "Derde partij",
    "crematoriumVergoedingen.type.bedrag": "Bedrag per uitvaart",
    "crematoriumVergoedingen.type.percentage": "Percentage",
    "crematoriumVergoedingen.uitbetaling.maand": "Maand",
    "crematoriumVergoedingen.uitbetaling.kwartaal": "Kwartaal",
    "crematoriumVergoedingen.status.actief": "Actief",
    "crematoriumVergoedingen.status.gepland": "Gepland",
    "crematoriumVergoedingen.van": "Van",
    "crematoriumVergoedingen.tot": "Tot",
    "crematoriumVergoedingen.dezeMaand": "Deze maand",
    "crematoriumVergoedingen.uitbetaling.uitleg": "Per praktijk: de uitvaarten die er in de periode via binnenkwamen, maal de vergoeding die op elke aanmelddatum gold.",
    "crematoriumVergoedingen.uitbetaling.empty": "Geen uitvaarten via een praktijk in deze periode.",
    "crematoriumVergoedingen.uitbetaling.totaal": "Totaal uit te betalen",
    // Werkmodus Pension: de APPLICATIE-sectie wordt herschreven (eigen dashboard, Dier + Relaties
    // samengevoegd tot één "Relatie", Opvangoverzichten onder zijn pensionnaam, Planning ongewijzigd).
    "menu.pensionRelatie": "Relatie",
    "menu.pensionOverzichten": "Pensionoverzichten",
    "pensionOverzichten.title": "Dieren in het pension",
    "pensionOverzichten.subtitle": "Wie er op deze dag ligt, wie er komt en wie er weggaat",
    "pensionOverzichten.onderdelen": "Onderdelen",
    "pensionOverzichten.onderdeel.PENSION": "Pension",
    "pensionOverzichten.onderdeel.DAGOPVANG": "Dagopvang",
    "pensionOverzichten.onderdeel.RESERVERINGEN": "Reserveringen",
    "pensionOverzichten.onderdeel.BEZETTING": "Bezetting",
    "pensionOverzichten.kop.PENSION": "Dieren in het pension",
    "pensionOverzichten.kop.DAGOPVANG": "Dieren in de dagopvang",
    "pensionOverzichten.kop.RESERVERINGEN": "Komende reserveringen",
    "pensionOverzichten.kop.BEZETTING": "Bezetting",
    "pensionOverzichten.ondertitel.PENSION": "Overzicht van dieren die vandaag aanwezig zijn, aankomen of vertrekken",
    "pensionOverzichten.ondertitel.DAGOPVANG": "De dieren die op deze dag in de dagopvang zijn",
    "pensionOverzichten.ondertitel.RESERVERINGEN": "Wie er de komende twee weken komt, in pension en dagopvang",
    "pensionOverzichten.tabs": "Overzichten",
    "pensionOverzichten.tab.aanwezig": "Aanwezig",
    "pensionOverzichten.tab.aankomsten": "Aankomsten",
    "pensionOverzichten.tab.vertrekken": "Vertrekken",
    "pensionOverzichten.tab.reserveringen": "Reserveringen",
    "pensionOverzichten.soort": "Diersoort",
    "pensionOverzichten.soort.HOND": "Hond",
    "pensionOverzichten.soort.KAT": "Kat",
    "pensionOverzichten.soort.OVERIG": "Overig",
    "pensionOverzichten.teller.aankomst": "Aankomst",
    "pensionOverzichten.teller.vertrek": "Vertrek",
    "pensionOverzichten.teller.totaal": "Totaal",
    "pensionOverzichten.filters": "Filters",
    "pensionOverzichten.zoek": "Zoek op naam, chipnummer, eigenaar…",
    "pensionOverzichten.datum": "Datum",
    "pensionOverzichten.alle": "Alle",
    "pensionOverzichten.wis": "Filters wissen",
    "pensionOverzichten.toonDagopvang": "Toon dagopvang",
    "pensionOverzichten.toonDagopvang.uitleg": "Toon ook dieren die in de dagopvang verblijven",
    "pensionOverzichten.groeperen": "Groeperen op:",
    "pensionOverzichten.groeperen.GEEN": "Geen",
    "pensionOverzichten.groeperen.RESERVERING": "Reservering",
    "pensionOverzichten.weergave": "Weergave",
    "pensionOverzichten.weergave.GROOT": "Grote tegels",
    "pensionOverzichten.weergave.KLEIN": "Kleine tegels",
    "pensionOverzichten.weergave.LIJST": "Lijst",
    "pensionOverzichten.velden": "Velden",
    "pensionOverzichten.velden.titel": "Velden op de tegel",
    "pensionOverzichten.velden.uitleg.GEEN": "Voor de dieren los: hier hoort de klant in de tegel.",
    "pensionOverzichten.velden.uitleg.RESERVERING": "Per reservering: de klant en de pensionopmerking staan al in de kop.",
    "pensionOverzichten.velden.standaard": "Terug naar standaard",
    "pensionOverzichten.sorteren": "Sorteren op:",
    "pensionOverzichten.sortering.AANKOMST_NIEUW": "Aankomstdatum (nieuwste)",
    "pensionOverzichten.sortering.AANKOMST_OUD": "Aankomstdatum (oudste)",
    "pensionOverzichten.sortering.VERTREK": "Vertrekdatum",
    "pensionOverzichten.sortering.NAAM": "Naam dier",
    "pensionOverzichten.sortering.EIGENAAR": "Eigenaar",
    "pensionOverzichten.sortering.KENNEL": "Verblijf",
    "pensionOverzichten.veld.verblijfnr": "Verblijfnr",
    "pensionOverzichten.veld.status": "Status",
    "pensionOverzichten.veld.ras": "Ras en geslacht",
    "pensionOverzichten.veld.eigenaar": "Eigenaar",
    "pensionOverzichten.veld.telefoon": "Telefoon",
    "pensionOverzichten.veld.email": "E-mail",
    "pensionOverzichten.veld.woonplaats": "Woonplaats",
    "pensionOverzichten.veld.reservering": "Reservering",
    "pensionOverzichten.veld.kennel": "Verblijf",
    "pensionOverzichten.veld.verblijf": "Periode",
    "pensionOverzichten.veld.nachten": "Nachten",
    "pensionOverzichten.veld.voeding": "Voeding",
    "pensionOverzichten.veld.medicatie": "Medicatie",
    "pensionOverzichten.veld.bijzonderheden": "Bijzonderheden",
    "pensionOverzichten.veld.opmerking": "Pensionopmerking",
    "pensionOverzichten.kolom.foto": "Foto",
    "pensionOverzichten.kolom.dier": "Dier",
    "pensionOverzichten.kolom.van": "Van",
    "pensionOverzichten.kolom.tot": "Tot",
    "pensionOverzichten.kolom.verzorging": "Verzorging",
    "pensionOverzichten.kolom.acties": "Acties",
    "pensionOverzichten.status.GEPLAND": "Gepland",
    "pensionOverzichten.status.KOMT": "Komt",
    "pensionOverzichten.status.KOMT.vandaag": "Komt vandaag",
    "pensionOverzichten.status.AANWEZIG": "Aanwezig",
    "pensionOverzichten.status.VERTREKT": "Vertrekt",
    "pensionOverzichten.status.VERTREKT.vandaag": "Vertrekt vandaag",
    "pensionOverzichten.status.VERTROKKEN": "Vertrokken",
    "pensionOverzichten.chip.voeding": "Voeding",
    "pensionOverzichten.chip.eigenVoeding": "Eigen voeding",
    "pensionOverzichten.chip.medicatie": "Medicatie",
    "pensionOverzichten.chip.bijzonderheden": "Bijzonderheden",
    "pensionOverzichten.chip.dagopvang": "Dagopvang",
    "pensionOverzichten.chip.aankomstVandaag": "Aankomst vandaag",
    "pensionOverzichten.geslacht.HOND.M": "Reu",
    "pensionOverzichten.geslacht.HOND.V": "Teef",
    "pensionOverzichten.geslacht.KAT.M": "Kater",
    "pensionOverzichten.geslacht.KAT.V": "Poes",
    "pensionOverzichten.geslacht.OVERIG.M": "Mannelijk",
    "pensionOverzichten.geslacht.OVERIG.V": "Vrouwelijk",
    "pensionOverzichten.nachten": "%d nachten",
    "pensionOverzichten.nietIngedeeld": "Nog niet ingedeeld",
    "pensionOverzichten.aantalDieren": "%d dieren",
    "pensionOverzichten.aantalDieren.een": "%d dier",
    "pensionOverzichten.aantal.HOND.een": "%d hond",
    "pensionOverzichten.aantal.HOND.meer": "%d honden",
    "pensionOverzichten.aantal.KAT.een": "%d kat",
    "pensionOverzichten.aantal.KAT.meer": "%d katten",
    "pensionOverzichten.aantal.OVERIG.een": "%d overig",
    "pensionOverzichten.aantal.OVERIG.meer": "%d overig",
    "pensionOverzichten.gevonden.reserveringen.een": "%d reservering gevonden",
    "pensionOverzichten.gevonden.reserveringen.meer": "%d reserveringen gevonden",
    "pensionOverzichten.gevonden.dieren.een": "%d dier gevonden",
    "pensionOverzichten.gevonden.dieren.meer": "%d dieren gevonden",
    "pensionOverzichten.groep.reservering": "Reservering",
    "pensionOverzichten.groep.dagopvang": "Dagopvang",
    "pensionOverzichten.groep.inklappen": "Reservering van %s inklappen",
    "pensionOverzichten.groep.uitklappen": "Reservering van %s uitklappen",
    "pensionOverzichten.acties": "Acties voor %s",
    "pensionOverzichten.openDier": "Dier openen",
    "pensionOverzichten.openKlant": "Klant openen",
    "pensionOverzichten.loadFailed": "Het overzicht kon niet worden geladen.",
    "pensionOverzichten.leeg.aanwezig": "Op deze dag liggen er geen dieren in het pension.",
    "pensionOverzichten.leeg.aankomsten": "Op deze dag komt er geen dier aan.",
    "pensionOverzichten.leeg.vertrekken": "Op deze dag gaat er geen dier weg.",
    "pensionOverzichten.leeg.reserveringen": "De komende twee weken komt er niemand nieuw.",
    "pensionOverzichten.leeg.DAGOPVANG": "Op deze dag is er niemand in de dagopvang.",
    "pensionOverzichten.leeg.RESERVERINGEN": "De komende twee weken komt er niemand nieuw.",
    "pensionOverzichten.leeg.filters": "Geen dieren die bij deze filters passen.",
    "pensionOverzichten.bezetting.planning": "Open verblijfplanning",
    "pensionOverzichten.bez.aankomsten": "Aankomsten",
    "pensionOverzichten.bez.aankomstenVandaag": "Aankomsten vandaag",
    "pensionOverzichten.bez.vertrekken": "Vertrekken",
    "pensionOverzichten.bez.vertrekkenVandaag": "Vertrekken vandaag",
    "pensionOverzichten.bez.bezet": "Bezet",
    "pensionOverzichten.bez.capaciteit": "Capaciteit",
    "pensionOverzichten.bez.dagenVol": "Dagen (bijna) vol",
    "pensionOverzichten.bez.dezeDag": "Op deze dag",
    "pensionOverzichten.bez.dieren": "dieren",
    "pensionOverzichten.bez.drukste": "Drukste dagen in periode",
    "pensionOverzichten.bez.drukste.uitleg": "Dagen met de hoogste bezetting.",
    "pensionOverzichten.bez.geenRuimtes": "Er zijn nog geen verblijfgroepen voor deze vestiging. Richt ze in via de verblijfplanning.",
    "pensionOverzichten.bez.geenRuimte": "geen eigen ruimte",
    "pensionOverzichten.bez.geenVakantie": "Er is geen komende vakantieperiode (hoogseizoen) ingesteld.",
    "pensionOverzichten.bez.gem": "Gem. bezetting",
    "pensionOverzichten.bez.hoogste": "Hoogste bezetting",
    "pensionOverzichten.bez.graad": "Bezetting",
    "pensionOverzichten.bez.inPeriode": "in deze periode",
    "pensionOverzichten.bez.kaarten": "Kaarten",
    "pensionOverzichten.bez.kennels": "Verblijven",
    "pensionOverzichten.bez.meestBezet": "Meest bezette ruimtes",
    "pensionOverzichten.bez.meestBezet.uitleg": "Ruimtes met de hoogste bezettingsgraad.",
    "pensionOverzichten.bez.mini.aankomsten": "aankomsten",
    "pensionOverzichten.bez.mini.vertrekken": "vertrekken",
    "pensionOverzichten.bez.mini.bijnaVol": "ruimtes bijna vol",
    "pensionOverzichten.bez.mini.dagopvang": "dagopvang",
    "pensionOverzichten.bez.nDagen": "%d dagen",
    "pensionOverzichten.bez.nVrij": "%d vrij",
    "pensionOverzichten.bez.nietIngedeeld": "Nog niet ingedeeld",
    "pensionOverzichten.bez.nietIngedeeld.uitleg": "Dieren die er zijn maar nog geen verblijf hebben.",
    "pensionOverzichten.bez.nieuw": "Nieuwe ruimte toevoegen",
    "pensionOverzichten.bez.nieuw.uitleg": "Beheer verblijven en ruimtes via de verblijfplanning.",
    "pensionOverzichten.bez.ondertitel": "Huidige bezetting van het pension en de beschikbare capaciteit per ruimte of diergroep.",
    "pensionOverzichten.bez.ondertitel.periode": "Bezetting en beschikbare capaciteit over een gekozen periode.",
    "pensionOverzichten.bez.ongeldig": "De periode loopt van de begindatum tot hoogstens %d dagen later.",
    "pensionOverzichten.bez.perDag": "Bezetting per dag",
    "pensionOverzichten.bez.perDag.kort": "Bezetting per dag",
    "pensionOverzichten.bez.perDag.uitleg": "Overzicht van totale bezetting en beschikbare capaciteit per dag in de gekozen periode.",
    "pensionOverzichten.bez.perRuimte": "Bezetting per ruimte / groep",
    "pensionOverzichten.bez.perRuimte.periode": "Bezetting per ruimte / groep in periode",
    "pensionOverzichten.bez.perRuimte.periode.uitleg": "Gedetailleerd overzicht per verblijf of groep, met gemiddelde en piekbezetting in de gekozen periode.",
    "pensionOverzichten.bez.plek": "Plek beschikbaar",
    "pensionOverzichten.bez.presets": "Snelkeuze periode",
    "pensionOverzichten.bez.punt.vol": "%s: %s vol (%d / %d)",
    "pensionOverzichten.bez.punt.bijnaVol": "%s: %s bijna vol (%d / %d)",
    "pensionOverzichten.bez.punt.drukste": "Nog %d vrije plekken op de drukste dag (%s)",
    "pensionOverzichten.bez.punt.rustig": "Geen ruimtes die vol of bijna vol raken.",
    "pensionOverzichten.bez.punten": "Aandachtspunten",
    "pensionOverzichten.bez.punten.uitleg": "Belangrijke signalen in deze periode.",
    "pensionOverzichten.bez.rij.bezetting": "Bezetting",
    "pensionOverzichten.bez.rij.bezet": "Bezet / totaal",
    "pensionOverzichten.bez.rij.vrij": "Vrije plekken",
    "pensionOverzichten.bez.ruimte": "Ruimte / groep",
    "pensionOverzichten.bez.spark": "Bezetting per dag van %s",
    "pensionOverzichten.bez.stand": "Dag of periode",
    "pensionOverzichten.bez.stand.DAG": "Dag",
    "pensionOverzichten.bez.stand.PERIODE": "Periode",
    "pensionOverzichten.bez.van": "Van",
    "pensionOverzichten.bez.tot": "Tot",
    "pensionOverzichten.bez.totaal": "Totale bezetting",
    "pensionOverzichten.bez.vakantie": "Vakantieperiode",
    "pensionOverzichten.bez.vanPlekken": "van %d plekken",
    "pensionOverzichten.bez.vanTotaal": "van %d totaal",
    "pensionOverzichten.bez.vandaag": "Vandaag",
    "pensionOverzichten.bez.vandaag.uitleg": "Verwachte bewegingen en aandachtspunten.",
    "pensionOverzichten.bez.volOp": "Vol op %s",
    "pensionOverzichten.bez.vrij": "Vrije plekken",
    "pensionOverzichten.bez.vrijDrukste": "Vrije plekken op drukste dag",
    "pensionOverzichten.bez.vrijKort": "Vrij",
    "pensionOverzichten.bez.zone": "Ruimte / zone",
    "pensionOverzichten.bez.aantalKennels.een": "%d verblijf",
    "pensionOverzichten.bez.aantalKennels.meer": "%d verblijven",
    "pensionOverzichten.bez.legenda.groen": "0 – 60%",
    "pensionOverzichten.bez.legenda.groen.uitleg": "Ruim beschikbaar",
    "pensionOverzichten.bez.legenda.geel": "61 – 80%",
    "pensionOverzichten.bez.legenda.geel.uitleg": "Goed bezet",
    "pensionOverzichten.bez.legenda.oranje": "81 – 95%",
    "pensionOverzichten.bez.legenda.oranje.uitleg": "Bijna vol",
    "pensionOverzichten.bez.legenda.rood": "96 – 100%",
    "pensionOverzichten.bez.legenda.rood.uitleg": "Vol",
    "pensionOverzichten.bez.soort.HOND": "Honden",
    "pensionOverzichten.bez.soort.KAT": "Katten",
    "pensionOverzichten.bez.soort.OVERIG": "%s",
    "pensionOverzichten.bez.sortering.HOOG": "Bezettingsgraad (hoog → laag)",
    "pensionOverzichten.bez.sortering.LAAG": "Bezettingsgraad (laag → hoog)",
    "pensionOverzichten.bez.sortering.VRIJ": "Meeste plekken vrij",
    "pensionOverzichten.bez.sortering.NAAM": "Naam",
    "pensionOverzichten.bez.staat.VOL": "Vol",
    "pensionOverzichten.bez.staat.BIJNA_VOL": "Bijna vol",
    "pensionOverzichten.bez.staat.RUIMTE": "Ruimte",
    "pensionDashboard.title": "Pension",
    "pensionDashboard.subtitle": "Je startpunt in de pensionadministratie.",
    "pensionDashboard.note":
      "De pensioncijfers zijn er nog niet: het asieldashboard telt opnames, entingen en asielbezetting, en dat gaat over andere dieren. Tot pension eigen cijfers heeft, brengt dit scherm je rechtstreeks naar de vier pensionschermen.",
    "pensionDashboard.open": "Openen ›",
    "pensionDashboard.tile.planning.desc": "Verblijven, aankomsten en vertrekken op de tijdlijn.",
    "pensionDashboard.tile.relatie.desc": "Klanten en de dieren die bij hen horen.",
    "pensionDashboard.tile.overzichten.desc": "De overzichten van de dieren die hier logeren.",
    "pensionDashboard.tile.tarief.desc": "Tarieven, hoogseizoen en kortingen.",
    "pensionDashboard.loadFailed": "Kon de pensioncijfers niet laden.",
    "pensionDashboard.kpi.aanwezig": "Dieren in pension",
    "pensionDashboard.kpi.aankomsten": "Komen vandaag",
    "pensionDashboard.kpi.vertrekken": "Gaan vandaag",
    "pensionDashboard.kpi.vrij": "Vrije plaatsen",
    "pensionDashboard.kpi.vanCapaciteit": "van %d plaatsen",
    "pensionDashboard.kpi.geenCapaciteit": "capaciteit niet ingesteld",
    "pensionDashboard.bezetting.title": "Bezetting, komende twee weken",
    "pensionDashboard.bezetting.leeg": "Geen boekingen in de komende twee weken.",
    "pensionDashboard.bezetting.capaciteitLijn": "De streeplijn is de capaciteit: %d plaatsen.",
    "pensionDashboard.bezetting.geenCapaciteit":
      "Voor deze vestiging is geen capaciteit ingesteld, dus er is geen lijn om tegen af te lezen — dat stel je in bij Instellingen → Pension.",
    "pensionDashboard.bezetting.omschrijving":
      "Dieren in pension per dag voor de komende %d dagen; de drukste dag telt er %d.",
    // Werkmodus Pension — het planbord (dagen als rijen, verblijven als kolommen) en de boekingen eronder.
    "pensionPlanning.title": "Verblijfplanning",
    "pensionPlanning.subtitle": "Overzicht van verblijven, kamers en plaatsingen",
    "pensionPlanning.zoek": "Zoek op dier, eigenaar of reservering…",
    "pensionPlanning.loadFailed": "Kon de verblijfplanning niet laden.",
    "pensionPlanning.opnieuw": "Opnieuw",
    "pensionPlanning.kpi.aria": "Kerncijfers",
    "pensionPlanning.kpi.aankomsten": "Aankomsten vandaag",
    "pensionPlanning.kpi.aankomstenOp": "Aankomsten op %s",
    "pensionPlanning.kpi.vertrekken": "Vertrekken vandaag",
    "pensionPlanning.kpi.vertrekkenOp": "Vertrekken op %s",
    "pensionPlanning.kpi.nogTePlaatsen": "Nog te plaatsen",
    "pensionPlanning.filters.titel": "Filters",
    "pensionPlanning.filters.inklappen": "Filters inklappen",
    "pensionPlanning.filters.uitklappen": "Filters uitklappen",
    "pensionPlanning.nogTePlaatsen.velden": "Velden op het kaartje",
    "pensionPlanning.nogTePlaatsen.sleepHier": "Laat hier los om het dier uit zijn verblijf te halen",
    "pensionPlanning.nogTePlaatsen.veldenStandaard": "Terug naar standaard",
    "pensionPlanning.kaartveld.soort": "Soort en ras",
    "pensionPlanning.kaartveld.geslacht": "Geslacht",
    "pensionPlanning.kaartveld.eigenaar": "Eigenaar",
    "pensionPlanning.kaartveld.telefoon": "Telefoon",
    "pensionPlanning.kaartveld.woonplaats": "Woonplaats",
    "pensionPlanning.kaartveld.periode": "Periode",
    "pensionPlanning.kaartveld.nachten": "Nachten",
    "pensionPlanning.kaartveld.tarief": "Tarief",
    "pensionPlanning.kaartveld.reservering": "Reservering",
    "pensionPlanning.kaartveld.opmerking": "Opmerking",
    "pensionPlanning.kaartveld.chips": "Tekens (eerste bezoek, medicatie)",
    "pensionPlanning.filters.wissen": "Wissen",
    "pensionPlanning.filters.periode": "Periode",
    "pensionPlanning.filters.van": "Van",
    "pensionPlanning.filters.tm": "t/m",
    "pensionPlanning.filters.tot": "Tot en met",
    "pensionPlanning.filters.diersoort": "Diersoort",
    "pensionPlanning.filters.accommodatie": "Accommodatie",
    "pensionPlanning.filters.status": "Status",
    "pensionPlanning.filters.extra": "Extra filters",
    "pensionPlanning.diersoort.alles": "Alles",
    "pensionPlanning.status.GERESERVEERD": "Gereserveerd",
    "pensionPlanning.status.INGECHECKT": "Ingecheckt",
    "pensionPlanning.status.UITGECHECKT": "Uitgecheckt",
    "pensionPlanning.status.GEBLOKKEERD": "Geblokkeerd",
    "pensionPlanning.extra.eersteBezoek": "Alleen eerste bezoek",
    "pensionPlanning.extra.luxe": "Alleen luxe suite geboekt",
    "pensionPlanning.extra.nogTePlaatsen": "Alleen nog te plaatsen",
    "pensionPlanning.vandaag": "Vandaag",
    "pensionPlanning.periode.wijzigen": "Periode wijzigen",
    "pensionPlanning.vorige": "Vorige periode",
    "pensionPlanning.volgende": "Volgende periode",
    "pensionPlanning.weergave.aria": "Weergave",
    "pensionPlanning.weergave.1": "Dag",
    "pensionPlanning.weergave.7": "Week",
    "pensionPlanning.weergave.14": "2 weken",
    "pensionPlanning.weergave.31": "Maand",
    "pensionPlanning.bord.aria": "Verblijfplanning per verblijf en dag",
    "pensionPlanning.bord.kop": "Verblijf / Kamer",
    "pensionPlanning.bord.leeg": "Deze vestiging heeft geen verblijven.",
    "pensionPlanning.bord.geenGroep": "Zonder groep",
    "pensionPlanning.blokkade.ONDERHOUD": "Onderhoud",
    "pensionPlanning.blokkade.GEBLOKKEERD": "Geblokkeerd",
    "pensionPlanning.chip.eersteBezoek": "Eerste bezoek",
    "pensionPlanning.chip.luxe": "Luxe suite",
    "pensionPlanning.nachten": "%d nachten",
    "pensionPlanning.nogTePlaatsen.titel": "Nog te plaatsen",
    "pensionPlanning.nogTePlaatsen.leeg": "Alle dieren in deze periode hebben een plek.",
    "pensionPlanning.nogTePlaatsen.urgent": "Komt vandaag of is er al",
    "pensionPlanning.legenda.ingecheckt": "Ingecheckt / aanwezig",
    "pensionPlanning.legenda.gereserveerd": "Gereserveerd",
    "pensionPlanning.legenda.uitgecheckt": "Uitgecheckt",
    "pensionPlanning.legenda.geblokkeerd": "Geblokkeerd / onderhoud",
    "pensionPlanning.legenda.quarantaine": "Quarantaine",
    "pensionPlanning.legenda.gezin": "Zelfde eigenaar / gezin",
    "pensionPlanning.legenda.eersteBezoek": "Eerste bezoek",
    "pensionPlanning.bijgewerkt": "Laatst bijgewerkt: %s",
    "pensionPlanning.verversen": "Verversen",
    "pensionPlanning.paneel.sluiten": "Sluiten",
    "pensionPlanning.paneel.inGebruik": "In gebruik",
    "pensionPlanning.paneel.vrij": "Vrij",
    "pensionPlanning.paneel.gereserveerd": "Gereserveerd",
    "pensionPlanning.paneel.uitgecheckt": "Uitgecheckt",
    "pensionPlanning.paneel.nietGeplaatst": "Nog niet geplaatst",
    "pensionPlanning.paneel.geblokkeerd": "Geblokkeerd",
    "pensionPlanning.paneel.dieren": "%d dieren",
    "pensionPlanning.paneel.bewoners": "Bewoners",
    "pensionPlanning.paneel.eigenaar": "Eigenaar",
    "pensionPlanning.paneel.periode": "Gereserveerde periode",
    "pensionPlanning.paneel.ingecheckt": "Ingecheckt op %s",
    "pensionPlanning.paneel.dagenAanwezig": "(%d dagen)",
    "pensionPlanning.paneel.geboekt": "Geboekte accommodatie",
    "pensionPlanning.paneel.geboektUitleg": "Het tarief dat op de reservering staat.",
    "pensionPlanning.paneel.geplaatstIn": "Werkelijk geplaatst in",
    "pensionPlanning.paneel.kiesHok": "Kies een verblijf",
    "pensionPlanning.tip.voorstel": "%s past het best",
    "pensionPlanning.tip.plaats": "Plaats hier",
    "pensionPlanning.tip.geen": "Er past geen verblijf in deze periode.",
    "pensionPlanning.paneel.profiel": "Groepsprofiel / notities",
    "pensionPlanning.paneel.geenNotities": "Geen notities.",
    "pensionPlanning.paneel.arrangementen": "Arrangementen / verzorging",
    "pensionPlanning.paneel.geenArrangementen": "Geen arrangementen.",
    "pensionPlanning.paneel.details": "Details openen",
    "pensionPlanning.paneel.verplaatsen": "Verplaatsen",
    "pensionPlanning.paneel.groepsmatch": "Groepsmatch",
    "pensionPlanning.paneel.uitHok": "Uit verblijf halen",
    "pensionPlanning.paneel.mislukt": "Dat lukte niet. Probeer het opnieuw.",
    "pensionPlanning.paneel.nuInHok": "In deze periode in dit verblijf",
    "pensionPlanning.paneel.leegHok": "Er zit in deze periode niemand.",
    "pensionPlanning.paneel.instellingen": "Instellingen",
    "pensionPlanning.paneel.capaciteit": "Capaciteit",
    "pensionPlanning.paneel.capaciteitStandaard": "standaard",
    "pensionPlanning.paneel.opslaan": "Opslaan",
    "pensionPlanning.paneel.blokkades": "Blokkades",
    "pensionPlanning.paneel.geenBlokkades": "Geen blokkades in deze periode.",
    "pensionPlanning.paneel.opheffen": "Opheffen",
    "pensionPlanning.paneel.blokkeren": "Verblijf blokkeren",
    "pensionPlanning.paneel.soort": "Soort",
    "pensionPlanning.paneel.omschrijving": "Omschrijving",
    "pensionPlanning.match.titel": "Groepsmatch voor %s",
    "pensionPlanning.match.hokTitel": "Wie past in %s",
    "pensionPlanning.match.geen": "Er is in deze periode geen passend verblijf vrij.",
    "pensionPlanning.match.geenDieren": "Er is niemand die hier past.",
    "pensionPlanning.match.plaatsen": "Plaatsen",
    "pensionPlanning.match.plaatsenIn": "Plaatsen in %s",
    "pensionPlanning.match.plaatsDier": "%s plaatsen",
    "pensionPlanning.match.reden.luxe": "Luxe geboekt",
    "pensionPlanning.match.reden.gezin": "Bij eigen gezin",
    "pensionPlanning.match.reden.leeg": "Heeft het verblijf alleen",
    "pensionPlanning.match.reden.accommodatie": "Andere accommodatie dan geboekt",
    "pensionPlanning.match.reden.ruimte": "%d van %d plekken vrij",
    "pensionPlanning.verplaatsen.titel": "%s verplaatsen",
    "pensionPlanning.verplaatsen.vol": "Past niet",
    "pensionPlanning.filters.zonderType": "Zonder accommodatietype",
    "pensionPlanning.filters.beheren": "Accommodaties beheren",
    "pensionPlanning.beheer.titel": "Accommodatietypes en prijsberekening",
    "pensionPlanning.kpi.bezetting": "%s bezetting",
    "pensionPlanning.legenda.medicatie": "Medicatie",
    "pensionPlanning.chip.medicatie": "Medicatie",
    "pensionPlanning.paneel.accommodatie": "Accommodatietype",
    "pensionPlanning.paneel.accommodatieAfgeleid": "afgeleid uit de groepsnaam",
    "pensionPlanning.paneel.prijsDag": "%s per dag",
    "pensionPlanning.paneel.prijsToeslag": "+ %s per dag toeslag",
    "pensionAccommodatie.types.titel": "Accommodatietypes",
    "pensionAccommodatie.algemeen.titel": "Algemeen",
    "pensionAccommodatie.omschrijving.uitleg": "Wat het verblijf is; staat in de wizard Nieuwe reservering.",
    "pensionAccommodatie.ruimtes.titel": "Verblijven van dit type",
    "pensionAccommodatie.ruimtes.uitleg": "In totaal %d verblijven voor %s, verdeeld over de ruimtes hieronder.",
    "pensionAccommodatie.ruimtes.aantal": "Aantal verblijven",
    "pensionAccommodatie.ruimtes.aantalVan": "Aantal verblijven in %s",
    "pensionAccommodatie.ruimtes.verblijven": "verblijven",
    "pensionAccommodatie.ruimtes.bijwerken": "Bijwerken",
    "pensionAccommodatie.ruimtes.nieuweNaam": "Nieuwe ruimte",
    "pensionAccommodatie.ruimtes.toevoegen": "Ruimte toevoegen",
    "pensionAccommodatie.ruimtes.nieuwUitleg": "Er komt een ruimte \"%s\" met dit aantal verblijven, genummerd vanaf 1.",
    "pensionAccommodatie.ruimtes.bewaard": "De verblijven zijn bijgewerkt.",
    "pensionAccommodatie.ruimtes.inGebruik": "Een verblijf dat weg zou moeten is al eens gebruikt; het blijft staan. Kies een hoger aantal.",
    "pensionAccommodatie.model.titel": "Capaciteitsmodel",
    "pensionAccommodatie.model.PER_DIER": "Eén verblijf per dier",
    "pensionAccommodatie.model.PER_DIER.uitleg": "Elk dier krijgt een eigen verblijf. Capaciteit wordt per dier berekend.",
    "pensionAccommodatie.model.PER_DIER.telt": "Capaciteit wordt in dit type per dier geteld.",
    "pensionAccommodatie.model.PER_RESERVERING": "Eén verblijf per reservering",
    "pensionAccommodatie.model.PER_RESERVERING.uitleg": "%s uit dezelfde reservering delen één verblijf. Capaciteit wordt per reservering berekend.",
    "pensionAccommodatie.model.PER_RESERVERING.telt": "Capaciteit wordt in dit type per reservering geteld, niet per dier.",
    "pensionAccommodatie.model.GROEP": "Groepsverblijf",
    "pensionAccommodatie.model.GROEP.uitleg": "Meerdere %s, ook uit verschillende reserveringen, delen één verblijf. Capaciteit wordt per groep berekend.",
    "pensionAccommodatie.model.GROEP.telt": "Capaciteit wordt in dit type per groep geteld; er kunnen dieren van verschillende reserveringen bij.",
    "pensionAccommodatie.regels.titel": "Regels binnen dit model",
    "pensionAccommodatie.regels.max": "Max. %s binnen één verblijf",
    "pensionAccommodatie.regels.min": "Minimaal aantal %s",
    "pensionAccommodatie.regels.buffer": "Buffer na vertrek",
    "pensionAccommodatie.regels.buffer.geen": "Geen buffer",
    "pensionAccommodatie.regels.buffer.minuten": "%d minuten",
    "pensionAccommodatie.regels.delen": "Verblijven delen tussen verschillende reserveringen",
    "pensionAccommodatie.regels.zelfdeEigenaar": "Alleen %s van dezelfde eigenaar",
    "pensionAccommodatie.regels.voorkeur": "Voorkeursverblijf in automatische planning",
    "pensionAccommodatie.regels.actief": "Actief",
    "pensionAccommodatie.regels.schoonmaak": "Automatisch schoonmaakblok na vertrek",
    "pensionAccommodatie.plaatsing.titel": "Plaatsingsregels",
    "pensionAccommodatie.plaatsing.uitleg": "Wat er meeweegt als er meerdere dieren in één verblijf komen.",
    "pensionAccommodatie.plaatsing.geslacht": "Geslacht meenemen",
    "pensionAccommodatie.plaatsing.castratie": "Castratie of sterilisatie meenemen",
    "pensionAccommodatie.plaatsing.formaat": "Formaat meenemen",
    "pensionAccommodatie.plaatsing.leeftijd": "Leeftijd meenemen",
    "pensionAccommodatie.plaatsing.sociaal": "Alleen sociaal geschikte dieren",
    "pensionAccommodatie.plaatsing.goedkeuring": "Handmatige goedkeuring verplicht",
    "pensionAccommodatie.voorbeeld.titel": "Voorbeeld capaciteitsberekening",
    "pensionAccommodatie.voorbeeld.situatie": "Situatie",
    "pensionAccommodatie.voorbeeld.bezet": "Bezette verblijven",
    "pensionAccommodatie.voorbeeld.een": "1 %s van reservering A",
    "pensionAccommodatie.voorbeeld.drie": "3 %s van reservering A",
    "pensionAccommodatie.voorbeeld.twee": "2 %s van reservering A + 1 van reservering B",
    "pensionAccommodatie.voorbeeld.ruimtes": "%d bezet",
    "pensionAccommodatie.samenvatting.titel": "Samenvatting capaciteit",
    "pensionAccommodatie.samenvatting.teltOp": "Capaciteit telt op",
    "pensionAccommodatie.samenvatting.PER_DIER": "Per dier",
    "pensionAccommodatie.samenvatting.PER_RESERVERING": "Per reservering",
    "pensionAccommodatie.samenvatting.GROEP": "Per groep",
    "pensionAccommodatie.samenvatting.max": "Max. %s per verblijf",
    "pensionAccommodatie.samenvatting.geenGrens": "Geen grens",
    "pensionAccommodatie.samenvatting.samen": "Samenplaatsen",
    "pensionAccommodatie.samenvatting.nooit": "Nooit samen",
    "pensionAccommodatie.samenvatting.zelfdeReservering": "Alleen zelfde reservering",
    "pensionAccommodatie.samenvatting.ookAndere": "Ook andere reserveringen",
    "pensionAccommodatie.notities.titel": "Interne notities",
    "pensionAccommodatie.notities.uitleg": "Alleen voor medewerkers; staat niet in de wizard of op de bevestiging.",
    "pensionAccommodatie.types.uitleg": "Per diersoort de verblijven die er zijn: welke types, in welke ruimtes en hoeveel. Pas het aantal hier aan of voeg een type toe.",
    "pensionAccommodatie.overzicht.overig": "Zonder diersoort",
    "pensionAccommodatie.overzicht.eenVerblijf": "1 verblijf",
    "pensionAccommodatie.overzicht.verblijven": "%d verblijven",
    "pensionAccommodatie.overzicht.typeToevoegen": "Type toevoegen",
    "pensionAccommodatie.overzicht.typeToevoegenVoor": "Type toevoegen voor %s",
    "pensionAccommodatie.overzicht.leegSoort": "Nog geen verblijven voor %s. Voeg een type toe om ze aan te maken.",
    "pensionAccommodatie.overzicht.geenVerblijven": "Nog geen verblijven van dit type.",
    "pensionAccommodatie.overzicht.verblijvenToevoegen": "Verblijven toevoegen",
    "pensionAccommodatie.overzicht.los.titel": "Nog niet aan een type gekoppeld",
    "pensionAccommodatie.overzicht.los.uitleg": "Deze ruimtes staan in de planning, maar horen nog bij geen accommodatietype. Koppel ze, dan tellen ze mee.",
    "pensionAccommodatie.overzicht.los.koppelVan": "Koppel %s aan een type",
    "pensionAccommodatie.overzicht.los.kies": "Koppel aan type…",
    "pensionAccommodatie.overzicht.ruimteToevoegen": "Ruimte toevoegen",
    "pensionAccommodatie.overzicht.ruimteToevoegenVoor": "Ruimte toevoegen voor %s",
    "pensionAccommodatie.overzicht.ruimteBijType": "Ruimte toevoegen bij %s",
    "pensionAccommodatie.overzicht.eerstEenType": "Voeg eerst een type toe; een ruimte hoort altijd bij een type.",
    "pensionAccommodatie.overzicht.type": "Type",
    "pensionAccommodatie.overzicht.automatisch": "automatisch",
    "pensionAccommodatie.overzicht.automatischUitleg": "Niet ingesteld: de planning kiest dit type op grond van de naam van de ruimte. Bijwerken legt het vast.",
    "pensionAccommodatie.types.leeg": "Nog geen accommodatietypes.",
    "pensionAccommodatie.nieuw": "Nieuw type",
    "pensionAccommodatie.bewerken": "%s bewerken",
    "pensionAccommodatie.verwijderen.knop": "%s verwijderen",
    "pensionAccommodatie.verwijderen.vraag": "Accommodatietype '%s' verwijderen? Groepen met dit type krijgen weer het type dat bij hun naam past.",
    "pensionAccommodatie.luxe": "Luxe",
    "pensionAccommodatie.quarantaine": "Quarantaine",
    "pensionAccommodatie.geenDagprijs": "Nog geen dagprijs",
    "pensionAccommodatie.perDag": "%s per dag",
    "pensionAccommodatie.toeslagPerDag": "+ %s per dag toeslag",
    "pensionAccommodatie.opgeslagen": "Opgeslagen",
    "pensionAccommodatie.prijzenBijTarieven": "De prijzen stel je in bij Producten › Pensiontarieven, tabblad Accommodaties. Of dat een dagprijs of een toeslag is, kies je bij Instellingen › Pension › Prijsberekening.",
    "pensionPrijsberekening.titel": "Prijsberekening",
    "pensionBenaming.titel": "Benaming",
    "pensionBenaming.laden": "De benaming kon niet worden geladen.",
    "pensionBenaming.alleenLezen": "Alleen een pensionbeheerder kan de benaming wijzigen.",
    "pensionBenaming.fout": "Opslaan is mislukt. Probeer het opnieuw.",
    "pensionBenaming.opgeslagen": "Opgeslagen.",
    "pensionPrijsberekening.uitleg": "Hoe deze vestiging de prijs van een verblijf berekent.",
    "pensionPrijsberekening.PENSIONPRIJZEN": "Pensionprijzen",
    "pensionPrijsberekening.PENSIONPRIJZEN.uitleg": "Het tarief van het dier, zoals het nu in het systeem staat. De prijs van een accommodatietype is dan een toeslag per dag bovenop, bijvoorbeeld voor een luxe suite.",
    "pensionPrijsberekening.ACCOMMODATIE": "Dagprijzen per accommodatie",
    "pensionPrijsberekening.ACCOMMODATIE.uitleg": "Elk accommodatietype heeft zijn eigen dagprijs in laag- en hoogseizoen, zoals Comfortroom en Luxe suite.",
    "pensionPrijsberekening.gratisTot": "Uitchecken gratis tot",
    "pensionPrijsberekening.halveDagTot": "Halve dag tot",
    "pensionPrijsberekening.halveDagOngeldig": "De halve dag moet eindigen na het gratis uitchecken.",
    "pensionPrijsberekening.incheckdag": "De dag van inchecken telt helemaal",
    "pensionPrijsberekening.prijzen": "De prijzen zelf stel je in bij Producten › Pensiontarieven; kortingen, zoals op het tweede dier, op het tabblad Kortingen daar.",
    "pensionPrijsberekening.later": "Nieuwe reserveringen rekenen hiermee; bestaande reserveringen veranderen niet.",
    "pensionPrijsberekening.alleenLezen": "Alleen een pensionbeheerder kan de prijsberekening wijzigen.",
    "pensionPrijsberekening.laden": "De prijsberekening kon niet worden geladen.",
    "pensionPrijsberekening.fout": "Opslaan lukte niet. Probeer het opnieuw.",
    "pensionPrijsberekening.opgeslagen": "Opgeslagen",
    "pensionAccommodatie.fout.bestaat": "Er is al een type met deze naam voor deze diersoort.",
    "pensionAccommodatie.fout.geenRecht": "Je hebt geen recht om accommodaties te beheren.",
    "pensionAccommodatie.fout.ongeldig": "Controleer de gegevens: naam, kleur en logo.",
    "pensionAccommodatie.fout.mislukt": "Opslaan lukte niet. Probeer het opnieuw.",
    "pensionAccommodatie.fout.laden": "De accommodatietypes konden niet worden geladen.",
    "pensionAccommodatie.fout.logo": "Kies een PNG-, JPEG-, WebP-, GIF- of SVG-bestand van hooguit 150 kB.",
    "pensionAccommodatie.veld.naam": "Naam",
    "pensionAccommodatie.veld.diersoort": "Diersoort",
    "pensionAccommodatie.veld.kleur": "Kleur",
    "pensionAccommodatie.veld.icoon": "Icoon",
    "pensionAccommodatie.icoon.home": "Verblijf",
    "pensionAccommodatie.icoon.crown": "Luxe",
    "pensionAccommodatie.icoon.gem": "Suite",
    "pensionAccommodatie.icoon.star": "Ster",
    "pensionAccommodatie.icoon.sparkles": "Verwenverblijf",
    "pensionAccommodatie.icoon.bed": "Bed",
    "pensionAccommodatie.icoon.bed-double": "Dubbel bed",
    "pensionAccommodatie.icoon.bed-single": "Eenpersoonsbed",
    "pensionAccommodatie.icoon.building": "Gebouw",
    "pensionAccommodatie.icoon.warehouse": "Loods",
    "pensionAccommodatie.icoon.tent": "Tent",
    "pensionAccommodatie.icoon.house": "Huis",
    "pensionAccommodatie.icoon.house-plus": "Huis plus",
    "pensionAccommodatie.icoon.trees": "Buiten",
    "pensionAccommodatie.icoon.sun": "Zonnig",
    "pensionAccommodatie.icoon.door-open": "Open verblijf",
    "pensionAccommodatie.icoon.door-closed": "Dicht verblijf",
    "pensionAccommodatie.icoon.lock": "Afgesloten",
    "pensionAccommodatie.icoon.siren": "Isolatie",
    "pensionAccommodatie.icoon.alert-triangle": "Quarantaine",
    "pensionAccommodatie.icoon.cat": "Kat",
    "pensionAccommodatie.icoon.cat-2": "Kattenkamer",
    "pensionAccommodatie.icoon.dog": "Hond",
    "pensionAccommodatie.icoon.dog-2": "Hondenkamer",
    "pensionAccommodatie.icoon.bird": "Vogel",
    "pensionAccommodatie.icoon.rabbit": "Konijn",
    "pensionAccommodatie.icoon.gamepad": "Speelverblijf",
    "pensionAccommodatie.icoon.wrench": "Onderhoud",
    "pensionAccommodatie.icoon.paw-print": "Algemeen",
    "pensionAccommodatie.veld.logo": "Eigen logo",
    "pensionAccommodatie.veld.luxe": "Luxe (de groepsmatch zet luxe boekingen hier het liefst)",
    "pensionAccommodatie.veld.quarantaine": "Quarantaine (de groepsmatch plaatst hier nooit zelf)",
    "pensionAccommodatie.logo.kies": "Eigen logo uploaden",
    "pensionAccommodatie.logo.weg": "Logo weghalen",
    "pensionAccommodatie.logo.uitleg": "PNG, JPEG, WebP, GIF of SVG, hooguit 150 kB. Een logo gaat voor het icoon.",
    "pensionAccommodatie.alleenLezen": "Alleen een pensionbeheerder kan accommodatietypes wijzigen.",
    // Werkmodus Pension — het klantscherm: de eigen dieren van de klant, hun boekingen en wat het
    // brengen van vandaag vraagt (medicatie, voer, waarschuwingen).
    "pensionKlant.galerij": "Pension — klantscherm",
    "pensionKlant.chip.actief": "Actieve klant",
    "pensionKlant.chip.bijzonderheden": "Bijzonderheden aanwezig",
    "pensionKlant.chip.inactief": "Inactieve klant",
    "pensionKlant.dieren.zoek": "Zoek in dieren…",
    "dierCreate.titel": "Nieuw dier",
    "dierCreate.naam": "Naam",
    "dierCreate.diersoort": "Diersoort",
    "dierCreate.ras": "Ras",
    "dierCreate.geslacht": "Geslacht",
    "dierCreate.gecastreerd": "Gecastreerd",
    "dierCreate.geboortedatum": "Geboortedatum",
    "dierCreate.chip": "Chipnummer",
    "dierCreate.kies": "Kies…",
    "dierCreate.onbekend": "Onbekend",
    "dierCreate.mannelijk": "Mannelijk",
    "dierCreate.vrouwelijk": "Vrouwelijk",
    "dierCreate.melding.verplicht": "Naam en diersoort zijn verplicht.",
    "dierCreate.melding.chip": "Een chipnummer is precies 15 cijfers.",
    "dierCreate.melding.verboden": "Je mag geen dieren aanmaken.",
    "dierCreate.melding.fout": "Het dier kon niet worden opgeslagen.",
    "pensionKlant.dieren.nieuwDier": "Nieuw dier",
    "pensionKlant.dieren.geenTreffer": "Geen dier gevonden met deze zoekterm.",
    "pensionKlant.dieren.bezoek": "Bezoek %d",
    "pensionKlant.dieren.eersteBezoek": "Eerste bezoek",
    "pensionKlant.dieren.jaar": "%d jaar",
    "pensionKlant.dieren.maanden": "%d mnd",
    "pensionKlant.dier.bewerken": "Dier bewerken",
    "pensionKlant.actie.bewerken": "Bewerken",
    "pensionKlant.contact.noodcontact": "Noodcontact",
    "pensionKlant.contact.geenNoodcontact": "Niet vastgelegd",
    "pensionKlant.contact.email": "E-mail",
    "pensionKlant.kpi.dieren": "Dieren",
    "pensionKlant.kpi.openstaand": "Openstaand",
    "pensionKlant.melding.waarschuwing.een": "Bij één dier staan bijzonderheden die je vóór het brengen wilt lezen.",
    "pensionKlant.melding.waarschuwing.meer": "Bij %d dieren staan bijzonderheden die je vóór het brengen wilt lezen.",
    "pensionKlant.dieren.geen": "Deze klant heeft geen dieren geregistreerd.",
    "pensionKlant.laadFout": "De dieren en reserveringen van deze klant konden niet worden geladen.",
    "pensionKlant.kop.aria": "Klant",
    "pensionKlant.tabs.aria": "Onderdelen van de klant",
    "pensionKlant.tab.relatie": "Relatie",
    "pensionKlant.tab.dieren": "Dieren",
    "pensionKlant.tab.pension": "Pension",
    "pensionKlant.tab.dagopvang": "Dagopvang",
    "pensionKlant.tab.reserveringen": "Reserveringen",
    "pensionKlant.tab.facturen": "Facturen",
    "pensionKlant.tab.notities": "Notities",
    "pensionKlant.tab.geschiedenis": "Geschiedenis",
    "pensionKlant.facturen.totalenAria": "Totalen van de facturen",
    "pensionKlant.facturen.zoek": "Zoek op factuurnummer",
    "pensionKlant.facturen.wisFilters": "Filters wissen",
    "pensionKlant.facturen.geenGevonden": "Geen facturen gevonden.",
    "pensionKlant.facturen.onderdeel": "Onderdeel",
    "pensionKlant.facturen.zoekStatus": "Zoek status...",
    "pensionKlant.facturen.geenStatus": "Geen status gevonden.",
    "pensionKlant.facturen.zoekOnderdeel": "Zoek onderdeel...",
    "pensionKlant.facturen.geenOnderdeel": "Geen onderdeel gevonden.",
    "pensionKlant.facturen.vestiging": "Vestiging",
    "pensionKlant.facturen.betaald": "Betaald",
    "pensionKlant.facturen.openstaand": "Openstaand",
    "pensionKlant.facturen.openAria": "Open factuur %s",
    "pensionKlant.relatie.asielverblijven": "Asielverblijven",
    "pensionKlant.blad.laadFout": "Dit kon niet worden geladen.",
    "pensionKlant.blad.opnieuw": "Opnieuw",
    "pensionKlant.blad.minder": "Minder tonen",
    "pensionKlant.blad.meer": "Meer tonen",
    "pensionKlant.blad.alle": "Alle %s tonen",
    "pensionKlant.blad.verberg": "Verbergen",
    "pensionKlant.blad.toon": "Tonen",
    "pensionKlant.pension.geen": "Deze klant heeft nog geen pensionverblijven.",
    "pensionKlant.res.titel": "Reservering %s",
    "pensionKlant.res.bewerk.dierIngecheckt": "Een dier van een ingecheckte reservering halen kan niet.",
    "pensionKlant.res.bewerk.laatsteDier": "Er moet minstens één dier op de reservering blijven.",
    "pensionKlant.res.terugdraaien.bevestig": "Annulering terugdraaien",
    "pensionKlant.res.terugdraaien.uitleg": "De reservering is daarna weer bevestigd.",
    "pensionKlant.res.terugdraaien.titel": "Annulering van %s terugdraaien",
    "pensionKlant.res.annuleren.mislukt": "Dat is niet gelukt. Misschien is de reservering intussen gewijzigd of ingecheckt; hij is ververst.",
    "pensionKlant.res.annuleren.terug": "Terug",
    "pensionKlant.res.annuleren.bevestig": "Reservering annuleren",
    "pensionKlant.res.annuleren.reden": "Reden (komt als notitie op de reservering)",
    "pensionKlant.res.annuleren.uitleg": "De reservering krijgt de status Geannuleerd. Een factuur blijft zoals hij is.",
    "pensionKlant.res.annuleren.titel": "Reservering %s annuleren",
    "pensionKlant.res.menu.kanNietIngecheckt": "Een ingecheckte reservering kun je niet annuleren.",
    "pensionKlant.res.menu.terugdraaien": "Annulering terugdraaien",
    "pensionKlant.res.menu.annuleren": "Reservering annuleren",
    "pensionKlant.res.bewerk.voorVan": "Voor wie %s is",
    "pensionKlant.res.bewerk.geenDierenOver": "Alle dieren van deze klant staan al op de reservering.",
    "pensionKlant.res.bewerk.dierKiezenUitleg": "Kies een dier van deze klant. Het komt op de reservering zodra je opslaat.",
    "pensionKlant.res.bewerk.dierKiezen": "Dier toevoegen",
    "pensionKlant.res.bewerk.dierZoeken": "Zoek een dier...",
    "pensionKlant.res.bewerk.geenDierGevonden": "Geen dier gevonden.",
    "pensionKlant.res.bewerk.nieuw": "Nieuw",
    "pensionKlant.res.bewerk.klitvrijVan": "Vacht klitvrij: %s",
    "pensionKlant.res.bewerk.kortingVan": "Korting van %s",
    "pensionKlant.res.bewerk.btwVan": "BTW van %s",
    "pensionKlant.res.bewerk.aantalVan": "Aantal van %s",
    "pensionKlant.res.bewerk.prijsVan": "Prijs van %s",
    "pensionKlant.res.bewerk.naamVan": "Omschrijving van %s",
    "pensionKlant.res.bewerk.totDatum": "Tot (gereserveerd)",
    "pensionKlant.res.bewerk.vanDatum": "Van (gereserveerd)",
    "pensionKlant.res.bewerk.terugzetten": "Terugzetten",
    "pensionKlant.res.bewerk.kanNiet": "Een geannuleerde reservering kun je niet bewerken.",
    "pensionKlant.res.bewerk.ongeldig": "Controleer de periode en de bedragen: tot kan niet vóór van liggen, bedragen kunnen niet negatief zijn en elk product heeft een omschrijving nodig.",
    "pensionKlant.res.bewerk.mislukt": "Opslaan is niet gelukt. Probeer het opnieuw.",
    "pensionKlant.res.bewerk.conflict": "Iemand anders heeft deze reservering intussen gewijzigd. De nieuwe gegevens staan er nu; voer je wijziging opnieuw in.",
    "pensionKlant.res.bewerk.annuleren": "Annuleren",
    "pensionKlant.res.opslaan": "Opslaan",
    "pensionKlant.res.doc.factuur": "Factuur",
    "pensionKlant.res.tagToevoegen": "Tag",
    "pensionKlant.res.tags.titel": "Tags op deze reservering",
    "pensionKlant.res.tags.geen": "Nog geen tags; maak ze aan bij Instellingen › Tags.",
    "pensionKlant.res.tags.laadfout": "De tags konden niet worden geladen.",
    "pensionKlant.res.tags.mislukt": "De tag kon niet worden opgeslagen.",
    "pensionKlant.res.minderVerblijven": "Minder verblijven tonen",
    "pensionKlant.res.alleVerblijven": "Alle verblijven bekijken",
    "pensionKlant.res.nacht": "1 nacht",
    "pensionKlant.res.fin.ontvangen": "Ontvangen",
    "pensionKlant.res.fin.aanbetalingVereist": "Aanbetaling vereist (%s)",
    "pensionKlant.res.fin.btwPercentage": "BTW (%s)",
    "pensionKlant.res.fin.kortingOverig": "Korting (overig)",
    "pensionKlant.res.fin.klantkorting": "Klantkorting",
    "pensionKlant.res.fin.subtotaal": "Subtotaal",
    "pensionKlant.res.verblijfHoog": "%s, hoogseizoen",
    "pensionKlant.res.verblijfCategorie": "Pension %s",
    "pensionKlant.res.verblijfRegel": "Pensionverblijf",
    "pensionKlant.res.reserveringRegel": "Reservering",
    "pensionKlant.res.verwijderRegel": "Regel verwijderen",
    "pensionKlant.res.bewerkRegel": "Regel bewerken",
    "pensionKlant.res.kol.omschrijving": "Omschrijving",
    "pensionKlant.res.kol.dierReservering": "Dier / Reservering",
    "pensionKlant.res.kol.acties": "Acties",
    "pensionKlant.res.kol.kennelKamer": "Verblijf / Kamer",
    "pensionKlant.res.kol.geslacht": "Geslacht",
    "pensionKlant.res.kol.dierRas": "Dier / Ras",
    "pensionKlant.res.dierenAantal": "Dieren (%s)",
    "pensionKlant.res.sig.geenActie": "Geen actie nodig",
    "pensionKlant.res.sig.geenBijzonderheden": "Geen bijzonderheden",
    "pensionKlant.res.sig.vereist": "%s vereist",
    "pensionKlant.res.sig.geldigTot": "Geldig tot %s",
    "pensionKlant.res.nietUitgecheckt": "Nog niet uitgecheckt",
    "pensionKlant.res.uitgechecktOp": "Uitgecheckt op %s",
    "pensionKlant.res.ingechecktOp": "Ingecheckt op %s",
    "pensionKlant.res.uitgechecktDoorOp": "Uitgecheckt door %s op %s",
    "pensionKlant.res.ingechecktDoorOp": "Ingecheckt door %s op %s",
    "pensionKlant.res.baliOpmerking": "Balie-opmerking voor verzorger",
    "pensionKlant.res.duur": "Verblijfsduur",
    "pensionKlant.res.tot": "Tot",
    "pensionKlant.res.van": "Van",
    "pensionKlant.res.bevestigdOp": "Bevestigd op %s",
    "pensionKlant.res.aangemaaktOp": "Aangemaakt op %s",
    "pensionKlant.res.status.NIEUW": "Nieuw",
    "pensionKlant.res.status.BEVESTIGD": "Bevestigd",
    "pensionKlant.res.status.AFGEROND": "Afgerond",
    "pensionKlant.res.status.GEANNULEERD": "Geannuleerd",
    "pensionKlant.res.status.ONBEKEND": "Onbekend",
    "pensionKlant.res.eersteBezoek": "Eerste bezoek",
    "pensionKlant.res.bezoek": "%se bezoek",
    "pensionKlant.res.online": "Online geboekt",
    "pensionKlant.res.bewerken": "Bewerken",
    "pensionKlant.res.meer": "Meer acties",
    "pensionKlant.res.volgt": "Komt in een volgende stap",
    "pensionKlant.res.verblijf": "Verblijf & check-in/out",
    "pensionKlant.res.gereserveerd": "Gereserveerde periode",
    "pensionKlant.res.werkelijk": "Werkelijk verblijf",
    "pensionKlant.res.dagdeel.VM": "VM",
    "pensionKlant.res.dagdeel.NM": "NM",
    "pensionKlant.res.dag": "1 dag",
    "pensionKlant.res.dagen": "%s dagen",
    "pensionKlant.res.nietIngecheckt": "Nog niet ingecheckt",
    "pensionKlant.res.inchecken": "Inchecken",
    "pensionKlant.res.uitchecken": "Uitchecken",
    "pensionKlant.res.checkin.titel.inchecken": "Inchecken %s",
    "pensionKlant.res.checkin.titel.uitchecken": "Uitchecken %s",
    "pensionKlant.res.checkin.info.inchecken": "Wie brengt het dier, en wat moeten de verzorgers weten?",
    "pensionKlant.res.checkin.info.uitchecken": "Wie haalt het dier op, en wat is er meegegeven?",
    "pensionKlant.res.checkin.annuleren": "Annuleren",
    "pensionKlant.res.checkin.mislukt": "Dat is niet gelukt. Misschien is de reservering intussen gewijzigd; hij is ververst.",
    "pensionKlant.res.akkoord": "Klant is akkoord met voorwaarden",
    "pensionKlant.res.geschiedenis": "Geschiedenis",
    "pensionKlant.res.gesch.aangemaakt": "Reservering aangemaakt",
    "pensionKlant.res.gesch.bevestigd": "Bevestigd",
    "pensionKlant.res.gesch.ingecheckt": "Ingecheckt",
    "pensionKlant.res.gesch.uitgecheckt": "Uitgecheckt",
    "pensionKlant.res.gesch.geannuleerd": "Geannuleerd",
    "pensionKlant.res.gesch.door": "door %s",
    "pensionKlant.res.gesch.naar": "naar %s",
    "pensionKlant.res.gesch.soort.EMAIL": "E-mail",
    "pensionKlant.res.gesch.soort.BRIEF": "Brief",
    "pensionKlant.res.gesch.soort.AFDRUK": "Afdruk",
    "pensionKlant.res.gesch.soort.SMS": "Sms",
    "pensionKlant.res.gesch.soort.overig": "Verstuurd",
    "pensionKlant.res.gesch.uitleg": "De momenten van de reservering en alles wat er naar deze klant is verstuurd. Tussentijdse wijzigingen aan de reservering worden niet vastgelegd, en wat verstuurd is geldt voor de hele klant en niet alleen voor deze reservering.",
    "pensionKlant.res.reserveringsproducten": "Reserveringsproducten",
    "pensionKlant.res.beheren": "Beheren",
    "pensionKlant.res.geenReserveringsproducten": "Geen producten op deze reservering.",
    "pensionKlant.res.respro.afgesloten": "Afgesloten",
    "pensionKlant.res.respro.toegevoegd": "Toegevoegd",
    "pensionKlant.res.dier.hierPlaatsen": "In %s plaatsen",
    "pensionKlant.res.dier.hierheenVerplaatsen": "Verplaatsen naar %s",
    "pensionKlant.res.dier.hierKort": "hier plaatsen",
    "pensionKlant.res.dier.hierheenKort": "hierheen",
    "pensionKlant.res.verblijfKort": "Verblijf",
    "pensionKlant.res.aankomst": "Aankomst",
    "pensionKlant.res.vertrek": "Vertrek",
    "pensionKlant.res.dagdeelUit.VM": "ochtend",
    "pensionKlant.res.dagdeelUit.NM": "middag",
    "pensionKlant.res.verblijvenOpenen": "Alle verblijven bekijken",
    "pensionKlant.res.kern.klant": "Klant",
    "pensionKlant.res.kern.verblijf": "Verblijf",
    "pensionKlant.res.kern.dieren": "Dieren",
    "pensionKlant.res.kern.eenDier": "1 dier",
    "pensionKlant.res.kern.aantalDieren": "%s dieren",
    "pensionKlant.res.kern.totaal": "Totaalbedrag",
    "pensionKlant.res.kern.aandachtEen": "1 aandachtspunt",
    "pensionKlant.res.kern.aandacht": "%s aandachtspunten",
    "pensionKlant.res.kern.geenAandacht": "Niets dat aandacht vraagt",
    "pensionKlant.res.signalen": "Signalen",
    "pensionKlant.res.sig.enting.inOrde": "Entingen in orde",
    "pensionKlant.res.sig.enting.verlopen": "Entingen verlopen",
    "pensionKlant.res.sig.enting.binnenkort": "Entingen verlopen binnenkort",
    "pensionKlant.res.sig.enting.onbekend": "Entingen onbekend",
    "pensionKlant.res.sig.open": "%s open",
    "pensionKlant.res.sig.vanTotaal": "van %s",
    "pensionKlant.res.sig.betaald": "Betaald",
    "pensionKlant.res.sig.geenBedrag": "Nog geen bedrag",
    "pensionKlant.res.sig.aanbetaling.OPEN": "Aanbetaling open",
    "pensionKlant.res.sig.aanbetaling.VERLOPEN": "Aanbetaling verlopen",
    "pensionKlant.res.sig.aanbetaling.VOLDAAN": "Aanbetaling ontvangen",
    "pensionKlant.res.sig.uiterlijk": "uiterlijk %s",
    "pensionKlant.res.sig.receptie": "T.a.v. receptie",
    "pensionKlant.res.sig.actie": "Actie nodig",
    "pensionKlant.res.sig.geenKennel": "%s: nog geen verblijf",
    "pensionKlant.res.sig.voorwaarden": "Voorwaarden niet getekend",
    "pensionKlant.res.sig.luxe": "Luxe suite geboekt",
    "pensionKlant.res.dieren": "Dieren",
    "pensionKlant.res.dierToevoegen": "Dier toevoegen aan deze reservering",
    "pensionKlant.res.geenDieren": "Geen dieren op deze reservering.",
    "pensionKlant.res.kol.foto": "Foto",
    "pensionKlant.res.kol.naam": "Naam",
    "pensionKlant.res.kol.startgewicht": "Startgewicht",
    "pensionKlant.res.kol.huidigGewicht": "Huidig gewicht",
    "pensionKlant.res.kol.verblijf": "Verblijf",
    "pensionKlant.res.kol.entingen": "Entingen",
    "pensionKlant.res.kol.klitvrij": "Vacht klitvrij",
    "pensionKlant.res.kol.tags": "Tags",
    "pensionKlant.res.kol.aantal": "Aantal",
    "pensionKlant.res.dier.instellingen": "Dierinstellingen",
    "pensionKlant.res.dier.instellingenVan": "Instellingen van %s op deze boeking",
    "pensionKlant.res.kol.arrangementen": "Arrangementen",
    "pensionKlant.res.kol.productDienst": "Product / dienst",
    "pensionKlant.res.wijzigen": "Wijzigen",
    "pensionKlant.res.kol.arrangement": "Arrangement",
    "pensionKlant.res.dier.boeking": "Boeking",
    "pensionKlant.res.bekijkDier": "Bekijk dier",
    "pensionKlant.res.bekijkDierVan": "Bekijk %s",
    "pensionKlant.res.klitvrijJa": "Klitvrij",
    "pensionKlant.res.klitvrijNee": "Niet op klitten gecontroleerd",
    "pensionKlant.res.kol.prijs": "Prijs",
    "pensionKlant.res.kol.korting": "Korting",
    "pensionKlant.res.kol.btw": "BTW",
    "pensionKlant.res.kol.totaal": "Totaal",
    "pensionKlant.res.bekijk": "Bekijk",
    "pensionKlant.res.bekijkAria": "Bekijk %s",
    "pensionKlant.res.geenKennel": "Nog niet ingedeeld",
    "pensionKlant.res.dier.titel": "%s in deze reservering",
    "pensionKlant.res.dier.bekijkAria": "Bekijk wat er voor dit dier geboekt is",
    "pensionKlant.res.dier.naarDier": "Naar het dier",
    "pensionKlant.res.dier.verblijf": "Verblijf",
    "pensionKlant.res.dier.periode": "Periode",
    "pensionKlant.res.dier.dagen": "Dagen",
    "pensionKlant.res.dier.tarief": "Tarief",
    "pensionKlant.res.dier.dagprijs": "Dagprijs",
    "pensionKlant.res.dier.hoogseizoen": "Hoogseizoen",
    "pensionKlant.res.dier.maal": "%d × %s",
    "pensionKlant.res.dier.toeslag": "Toeslag",
    "pensionKlant.res.dier.korting": "Korting",
    "pensionKlant.res.dier.verblijfkosten": "Verblijfkosten",
    "pensionKlant.res.dier.kennel": "Verblijf",
    "pensionKlant.res.dier.kennelUitleg": "Indelen doe je in de verblijfplanning.",
    "pensionKlant.res.dier.advies.kop": "Verblijfadvies",
    "pensionKlant.res.dier.advies.plaats": "Plaats hier",
    "pensionKlant.res.dier.advies.verplaats": "Andere verblijven tonen",
    "pensionKlant.res.dier.advies.ligtHier": "Ligt hier",
    "pensionKlant.res.dier.advies.geen": "Er past geen verblijf in deze periode.",
    "pensionKlant.res.dier.advies.fout": "Indelen is niet gelukt. Probeer het opnieuw.",
    "pensionKlant.res.dier.advies.strookAria": "Bezetting tijdens deze reservering",
    "pensionKlant.res.dier.advies.vrij": "vrij",
    "pensionKlant.res.dier.advies.reden.HUIDIG_HOK": "Ligt hier al",
    "pensionKlant.res.dier.advies.reden.VRIJ": "De hele periode vrij",
    "pensionKlant.res.dier.advies.reden.ZELFDE_ALS_VORIGE_KEER": "Zelfde verblijf als de vorige keer",
    "pensionKlant.res.dier.advies.reden.SAMEN_MET": "Samen met %s",
    "pensionKlant.res.dier.advies.reden.GEBOEKTE_ACCOMMODATIE": "Geboekt als %s",
    "pensionKlant.res.dier.advies.reden.JUISTE_DIERSOORT": "Voor %s",
    "pensionKlant.res.dier.advies.reden.GEEN_DIERSOORT": "Geen diersoort ingesteld",
    "pensionKlant.res.dier.advies.reden.DEELS_BEZET": "Deels bezet",
    "pensionKlant.res.dier.advies.reden.MOET_ALLEEN": "Moet alleen liggen",
    "pensionKlant.res.dier.geboekt": "Arrangementen & extra producten",
    "pensionKlant.res.dier.geenProducten": "Er is verder niets voor dit dier geboekt.",
    "pensionKlant.res.dier.verzorging": "Verzorging",
    "pensionKlant.res.dier.voorstel": "AI plaatsingsvoorstel",
    "pensionKlant.res.dier.aiAdvies": "AI advies",
    "pensionKlant.res.dier.tarieven": "Tarieven",
    "pensionKlant.res.dier.reservering": "Reserveringsgegevens",
    "pensionKlant.res.dier.status": "Status",
    "pensionKlant.res.dier.nummer": "Reserveringsnummer",
    "pensionKlant.res.dier.gemaaktOp": "Gemaakt op",
    "pensionKlant.res.dier.door": "Door",
    "pensionKlant.res.dier.online": "Online geboekt",
    "pensionKlant.res.dier.klant": "Klant",
    "pensionKlant.res.dier.opmerkingKlant": "Opmerkingen klant",
    "pensionKlant.res.dier.opmerkingen": "Opmerkingen",
    "pensionKlant.res.dier.pensionverblijf": "Pensionverblijf",
    "pensionKlant.res.dier.dagenMaal": "%d × %s",
    "pensionKlant.res.dier.totaal": "Totaalbedrag",
    "pensionKlant.res.dier.tarievenAanpassen": "Aanpassen",
    "pensionKlant.res.dier.kortingVeld": "Korting",
    "pensionKlant.res.dier.stukprijs": "Stukprijs",
    "pensionKlant.res.dier.aantal": "Aantal",
    "pensionKlant.res.dier.geboektPil": "Geboekt",
    "pensionKlant.res.dier.verzorgingElders": "Bijzonderheden voor de verzorging staan in de dierenkaart.",
    "pensionKlant.res.dier.vandaag": "Vandaag",
    "pensionKlant.res.dier.eerder": "Eerder",
    "pensionKlant.res.dier.later": "Later",
    "pensionKlant.res.dier.dag": "Dag",
    "pensionKlant.res.dier.week": "Week",
    "pensionKlant.res.dier.openPlanning": "Open in verblijfplanning",
    "pensionKlant.res.dier.plankjeAria": "Verblijven tijdens deze reservering",
    "pensionKlant.res.dier.zonderGroep": "Zonder groep",
    "pensionKlant.res.dier.geenHokken": "Deze vestiging heeft nog geen verblijven.",
    "pensionKlant.res.dier.meerHokken": "Alle verblijven tonen (%d meer)",
    "pensionKlant.res.dier.minderHokken": "Alleen dit verblijf en de buren",
    "pensionKlant.res.dier.hierheen": "%s hierheen",
    "pensionKlant.res.dier.blokkade.ONDERHOUD": "Onderhoud",
    "pensionKlant.res.dier.blokkade.QUARANTAINE": "Quarantaine",
    "pensionKlant.res.dier.blokkade.OVERIG": "Geblokkeerd",
    "pensionKlant.res.dier.advies.voorstelKop": "%s past het best. ",
    "pensionKlant.res.klitvrij": "Ja",
    "pensionKlant.res.nietGecontroleerd": "Nee",
    "pensionKlant.res.meerTags": "+%s",
    "pensionKlant.res.alleenInKennel": "Alleen in verblijf",
    "pensionKlant.res.sociaalGeval": "Sociaal geval",
    "pensionKlant.res.staat.verlopen": "Verlopen",
    "pensionKlant.res.staat.binnenkort": "Verloopt binnenkort",
    "pensionKlant.res.staat.inOrde": "In orde",
    "pensionKlant.res.staat.onbekend": "Onbekend",
    "pensionKlant.res.producten": "Producten en diensten",
    "pensionKlant.res.productToevoegen": "Product toevoegen",
    "pensionKlant.res.geenProducten": "Geen producten of diensten.",
    "pensionKlant.res.financieel": "Financieel overzicht",
    "pensionKlant.res.fin.exclBtw": "Totaal (excl. BTW)",
    "pensionKlant.res.fin.btw": "BTW",
    "pensionKlant.res.fin.totaal": "Totaal",
    "pensionKlant.res.fin.betaald": "Betaald",
    "pensionKlant.res.fin.openstaand": "Openstaand",
    "pensionKlant.res.verblijven": "Eerdere verblijven",
    "pensionKlant.res.verblijvenAria": "Kies een verblijf",
    "pensionKlant.res.bijzonderheden": "Bijzonderheden & communicatie",
    "pensionKlant.res.aanvraag.titel": "Uit de reserveringswizard",
    "pensionKlant.res.aanvraag.concept": "Opgeslagen als concept",
    "pensionKlant.res.geenNotities": "Geen notities bij deze reservering.",
    "pensionKlant.res.documenten": "Documenten & acties",
    "pensionKlant.res.factuur": "Factuur %s",
    "pensionKlant.res.geenFactuur": "Nog geen factuur.",
    "pensionKlant.res.doc.bevestiging": "Bevestiging",
    "pensionKlant.res.doc.overeenkomst": "Overeenkomst",
    "pensionKlant.res.doc.voedingssticker": "Voedingssticker",
    "pensionKlant.res.doc.klantkaart": "Klantkaart",
    "pensionKlant.res.doc.whatsapp": "Bericht sturen (WhatsApp)",
    "pensionKlant.res.doc.email": "E-mail sturen",
    "pensionKlant.dagopvang.geen": "Deze klant doet nog niet aan dagopvang. Plan een dag in om te beginnen.",
    "pensionKlant.dagopvang.contracten": "Contracten",
    "nieuweReservering.knop": "Nieuwe reservering",
    "nieuweReservering.knopBoeking": "Nieuwe boeking",
    "nieuweReservering.stap.verblijf": "Verblijf & verzorging",
    "nieuweReservering.stap.arrangementen": "Arrangementen & extra's",
    "nieuweReservering.stap.keuzes": "Reserveringskeuzes",
    "nieuweReservering.verblijf.periode": "Geselecteerde periode",
    "nieuweReservering.verblijf.periodeAanpassen": "Periode aanpassen",
    "nieuweReservering.verblijf.titel": "Verblijf & verzorging",
    "nieuweReservering.verblijf.uitleg": "Kies per dier het type verblijf en geef de verzorgingsgegevens door.",
    "nieuweReservering.verblijf.verwijder": "Dier verwijderen",
    "nieuweReservering.verblijf.verwijderAria": "%s van de reservering halen",
    "nieuweReservering.verblijf.inklappen": "%s inklappen",
    "nieuweReservering.verblijf.uitklappen": "%s uitklappen",
    "nieuweReservering.verblijf.type": "Type verblijf",
    "nieuweReservering.verblijf.kiesType": "Kies een verblijf",
    "nieuweReservering.verblijf.tarief": "Tarief",
    "nieuweReservering.verblijf.kiesTarief": "Tarief van het dier",
    "nieuweReservering.verblijf.geenTarieven": "Er zijn nog geen pensiontarieven voor deze diersoort. Stel ze in bij Producten › Pensiontarieven.",
    "nieuweReservering.verblijf.tariefNodig": "%s heeft nog geen eigen dagprijs: kies een tarief.",
    "nieuweReservering.verblijf.kiesTariefNodig": "Kies een tarief…",
    "nieuweReservering.verblijf.geenTypes": "Er zijn nog geen verblijfstypes voor %s.",
    "nieuweReservering.verblijf.meerprijs": "Meerprijs %s p/dag",
    "nieuweReservering.verblijf.prijsTitel": "Prijs van dit verblijf",
    "nieuweReservering.verblijf.prijsUitTarief": "Pensiontarief van het dier",
    "nieuweReservering.verblijf.prijsUitAccommodatie": "Dagprijs van het verblijf",
    "nieuweReservering.verblijf.prijsDagen": "%s dagen × %s",
    "nieuweReservering.verblijf.prijsDagenHoog": "%s dagen hoogseizoen × %s",
    "nieuweReservering.verblijf.prijsMeerprijs": "meerprijs %s %s",
    "nieuweReservering.verblijf.prijsKalender": "%s voor dagen met een eigen prijs",
    "nieuweReservering.verblijf.dagprijs": "%s p/dag",
    "nieuweReservering.verblijf.voeding": "Voeding",
    "nieuweReservering.verblijf.typeVoeding": "Type voeding",
    "nieuweReservering.verblijf.voedingSTANDAARD": "Standaard voeding",
    "nieuweReservering.verblijf.voedingEIGEN": "Eigen voeding meenemen",
    "nieuweReservering.verblijf.voedingPension": "Voer van het pension",
    "nieuweReservering.verblijf.voedingInstructies": "Voedingsinstructies",
    "nieuweReservering.verblijf.voedingPlaats": "Bijv. merk, hoeveelheid, frequentie, bijzonderheden",
    "nieuweReservering.verblijf.medicatie": "Medicatie",
    "nieuweReservering.verblijf.medicatieNodig": "Medicatie nodig?",
    "nieuweReservering.verblijf.medicatieInstructies": "Instructies medicatie",
    "nieuweReservering.verblijf.medicatiePlaats": "Bijv. naam medicatie, dosering, tijden",
    "nieuweReservering.verblijf.verzorging": "Verzorging",
    "nieuweReservering.verblijf.borstelen": "Borstelen",
    "nieuweReservering.verblijf.wassen": "Wassen voor vertrek",
    "nieuweReservering.verblijf.samen": "Samen met eigen gezin",
    "nieuweReservering.verblijf.nee": "Nee",
    "nieuweReservering.verblijf.ja": "Ja",
    "nieuweReservering.verblijf.jaGraag": "Ja, graag",
    "nieuweReservering.verblijf.bijzonderheden": "Bijzonderheden",
    "nieuweReservering.verblijf.bijzonderhedenPlaats": "Bijv. gedrag, extra aandacht, allergieën, etc.",
    "nieuweReservering.verblijf.terug": "Terug naar periode",
    "nieuweReservering.verblijf.volgende": "Volgende: Arrangementen & extra's",
    "nieuweReservering.som.titel": "Samenvatting",
    "nieuweReservering.som.periode": "Periode",
    "nieuweReservering.som.dieren": "Dieren",
    "nieuweReservering.som.verblijven": "Verblijven",
    "nieuweReservering.som.geenVerblijf": "Geen verblijf gekozen",
    "nieuweReservering.som.extras": "Arrangementen & extra's",
    "nieuweReservering.som.verzekering": "Reserveringskeuzes",
    "nieuweReservering.som.opbouw": "Opbouw van de prijs",
    "nieuweReservering.som.verblijf": "Verblijf",
    "nieuweReservering.som.totaal": "Totaal indicatie",
    "nieuweReservering.som.totaalUitleg": "Incl. btw, kortingen volgen bij goedkeuring",
    "nieuweReservering.som.naGoedkeuring": "Na goedkeuring",
    "nieuweReservering.som.aanbetaling": "Aanbetaling (%s%)",
    "nieuweReservering.keuzes.titel": "Reserveringskeuzes",
    "nieuweReservering.keuzes.uitleg": "Kies de overige opties voor deze reservering.",
    "nieuweReservering.keuzes.verzekering": "Annuleringsverzekering",
    "nieuweReservering.keuzes.verzekeringUitleg": "Wil de klant een annuleringsverzekering voor deze reservering?",
    "nieuweReservering.keuzes.productUitleg": "Wil je %s bij deze reservering?",
    "nieuweReservering.keuzes.productJa": "Ja, graag",
    "nieuweReservering.keuzes.productNee": "Nee, dank je",
    "nieuweReservering.keuzes.verzekeringJa": "Ja, annuleringsverzekering toevoegen",
    "nieuweReservering.keuzes.verzekeringNee": "Nee, geen annuleringsverzekering",
    "nieuweReservering.keuzes.wensen": "Overige wensen",
    "nieuweReservering.keuzes.wensenUitleg": "Wensen van de klant voor deze reservering.",
    "nieuweReservering.keuzes.wensenPlaats": "Bijv. later op de dag aankomen, neemt eigen mand mee",
    "nieuweReservering.keuzes.notitie": "Interne notities",
    "nieuweReservering.keuzes.notitieUitleg": "Alleen zichtbaar voor medewerkers.",
    "nieuweReservering.keuzes.notitiePlaats": "Notities voor collega's",
    "nieuweReservering.keuzes.info": "De reservering wordt aangemaakt als aanvraag. De klant krijgt een bevestiging zodra het pension hem heeft goedgekeurd.",
    "nieuweReservering.keuzes.terug": "Terug naar arrangementen",
    "nieuweReservering.keuzes.volgende": "Volgende: Controle & aanmaken",
    "nieuweReservering.controle.titel": "Controle & aanmaken",
    "nieuweReservering.controle.uitleg": "Controleer de gegevens en maak de reserveringsaanvraag aan.",
    "nieuweReservering.controle.wijzig": "Wijzigen",
    "nieuweReservering.controle.wijzigAria": "%s wijzigen",
    "nieuweReservering.controle.dieren": "Dieren & verblijven",
    "nieuweReservering.controle.verblijf": "Verblijf",
    "nieuweReservering.controle.geen": "Geen",
    "nieuweReservering.controle.geenExtras": "Geen arrangementen of extra's gekozen.",
    "nieuweReservering.controle.type": "Type",
    "nieuweReservering.controle.aanvraag": "Reserveringsaanvraag",
    "nieuweReservering.controle.status": "Status na aanmaken",
    "nieuweReservering.controle.ontvangen": "Aanvraag ontvangen",
    "nieuweReservering.controle.info": "Na het aanmaken staat de reservering als nieuwe aanvraag bij de klant en op het dashboard van het pension.",
    "nieuweReservering.controle.ongeldig": "De reservering kon niet worden aangemaakt: niet alle gegevens kloppen. Controleer de stappen.",
    "nieuweReservering.controle.fout": "De reservering kon niet worden aangemaakt. Probeer het opnieuw.",
    "nieuweReservering.controle.terug": "Terug naar reserveringskeuzes",
    "nieuweReservering.controle.concept": "Opslaan als concept",
    "nieuweReservering.controle.aanmaken": "Reserveringsaanvraag aanmaken",
    "nieuweReservering.klaar.aanvraag": "Reserveringsaanvraag aangemaakt",
    "nieuweReservering.klaar.concept": "Concept opgeslagen",
    "nieuweReservering.klaar.nummer": "Reserveringsnummer %s",
    "nieuweReservering.klaar.aanvraagUitleg": "De aanvraag heeft de status Aanvraag ontvangen en kan nu worden goedgekeurd.",
    "nieuweReservering.klaar.conceptUitleg": "Het concept staat bij de reserveringen van de klant en kan later worden afgemaakt.",
    "nieuweReservering.klaar.sluiten": "Sluiten",
    "nieuweReservering.volgendeNaar": "Volgende: %s",
    "nieuweReservering.voorbeeld": "Voorbeeld: je kunt alles bekijken, maar er wordt niets aangemaakt of opgeslagen.",
    "nieuweReservering.eigen.kies": "Kies…",
    "nieuweReservering.eigen.verplicht": "Vul nog in: %s",
    "nieuweReservering.controle.vragen": "Vragen bij %s",
    "pensionWizard.titel": "Wizard Nieuwe reservering",
    "pensionWizard.status.standaard": "De standaardindeling is actief",
    "pensionWizard.status.versie": "Versie %s gepubliceerd op %s",
    "pensionWizard.status.concept": "Concept met wijzigingen",
    "pensionWizard.status.nietOpgeslagen": "Niet opgeslagen",
    "pensionWizard.knop.voorbeeld": "Voorbeeld",
    "pensionWizard.knop.standaard": "Terug naar standaard",
    "pensionWizard.knop.verwerpen": "Concept verwerpen",
    "pensionWizard.knop.opslaan": "Opslaan",
    "pensionWizard.knop.publiceren": "Publiceren",
    "pensionWizard.knop.sluiten": "Sluiten",
    "pensionWizard.sluiten.vraag": "Je hebt wijzigingen die nog niet zijn opgeslagen.",
    "pensionWizard.sluiten.terug": "Verder bewerken",
    "pensionWizard.sluiten.weggooien": "Wijzigingen weggooien",
    "pensionWizard.stappen": "Stappen",
    "pensionWizard.stap.eigen": "Eigen stap",
    "pensionWizard.stap.vast": "Vaste stap",
    "pensionWizard.stap.vastePlek": "Vaste plek",
    "pensionWizard.stap.uit": "Staat uit",
    "pensionWizard.stap.nieuw": "Eigen stap toevoegen",
    "pensionWizard.stap.omhoog": "%s omhoog",
    "pensionWizard.stap.omlaag": "%s omlaag",
    "pensionWizard.stap.tonen": "%s tonen",
    "pensionWizard.stap.verbergen": "%s verbergen",
    "pensionWizard.stap.verwijder": "%s verwijderen",
    "pensionWizard.stap.nr": "Stap %s van %s",
    "pensionWizard.stap.naam": "Naam van de stap",
    "pensionWizard.stap.uitlegVeld": "Uitleg bij de stap",
    "pensionWizard.stap.nodig": "Nodige stap",
    "pensionWizard.stap.kern": "Deze stap is nodig om een reservering te maken en staat altijd aan.",
    "pensionWizard.stap.aan": "Deze stap tonen in de wizard",
    "pensionWizard.stap.standaardNaam": "Standaardnaam: %s. Maak het veld leeg om die weer te gebruiken.",
    "pensionWizard.stapUitleg.ZOEKEN": "De balie zoekt de klant op e-mail en/of adres. Vanaf het klantscherm slaat de wizard deze stap over.",
    "pensionWizard.stapUitleg.KIEZEN": "De gevonden klanten, de gekozen klant controleren, of een nieuwe klant aanmaken.",
    "pensionWizard.stapUitleg.DIEREN": "De dieren van de klant om uit te kiezen, met de mogelijkheid een nieuw dier toe te voegen.",
    "pensionWizard.stapUitleg.PERIODE": "Aankomst en vertrek met tijden, de verblijfsduur en de beschikbaarheid.",
    "pensionWizard.stapUitleg.VERBLIJF": "Per dier het type verblijf en de verzorging. Vragen per dier komen in de kaart van elk dier.",
    "pensionWizard.stapUitleg.ARRANGEMENTEN": "De arrangementen en extra's per dier en voor de hele reservering.",
    "pensionWizard.stapUitleg.KEUZES": "Annuleringsverzekering, overige wensen en interne notities, met de samenvatting.",
    "pensionWizard.stapUitleg.CONTROLE": "Alles op een rij, de antwoorden op de vragen, en de reserveringsaanvraag aanmaken.",
    "pensionWizard.stapUitleg.EIGEN": "Een eigen stap met vragen en tekstblokken. De antwoorden komen bij de reservering.",
    "pensionWizard.element.omhoog": "%s omhoog",
    "pensionWizard.element.omlaag": "%s omlaag",
    "pensionWizard.element.tonen": "%s tonen",
    "pensionWizard.element.verbergen": "%s verbergen",
    "pensionWizard.element.verwijder": "%s verwijderen",
    "pensionWizard.element.kies": "%s bewerken",
    "pensionWizard.element.vast": "Vast onderdeel",
    "pensionWizard.element.verplicht": "Verplicht",
    "pensionWizard.element.perDier": "Per dier",
    "pensionWizard.element.uit": "Verborgen",
    "pensionWizard.element.leeg": "Sleep hier een vraag of tekstblok naartoe, of klik rechts op wat je wilt toevoegen.",
    "pensionWizard.toevoegen": "Toevoegen aan deze stap",
    "pensionWizard.toevoegenUitleg": "Klik, of sleep naar de stap.",
    "pensionWizard.toevoegenKlant": "Bij het zoeken en kiezen van de klant kun je alleen tekst toevoegen.",
    "pensionWizard.soort.TEKST": "Tekstblok",
    "pensionWizard.soort.TEXT": "Korte tekst",
    "pensionWizard.soort.TEXTAREA": "Lange tekst",
    "pensionWizard.soort.NUMBER": "Getal",
    "pensionWizard.soort.BOOLEAN": "Ja / nee",
    "pensionWizard.soort.DATE": "Datum",
    "pensionWizard.soort.SELECT": "Eén keuze",
    "pensionWizard.soort.MULTISELECT": "Meerdere keuzes",
    "pensionWizard.eigenschappen": "Eigenschappen",
    "pensionWizard.eigenschappen.leeg": "Kies een onderdeel in de stap om het aan te passen.",
    "pensionWizard.blok.EMAIL": "Zoekveld voor het e-mailadres van de klant.",
    "pensionWizard.blok.ADRES": "Zoekveld voor postcode, huisnummer of adres.",
    "pensionWizard.blok.NIEUW_DIER": "Knop om meteen een nieuw dier toe te voegen.",
    "pensionWizard.blok.BESCHIKBAARHEID": "Controleert of er plek is in de gekozen periode.",
    "pensionWizard.blok.TYPE_VERBLIJF": "Het type verblijf per dier, met foto en prijs.",
    "pensionWizard.blok.TARIEF": "Het pensiontarief waar de dagprijs vandaan komt, per dier.",
    "pensionWizard.blok.VOEDING": "Soort voeding en voedingsinstructies per dier.",
    "pensionWizard.blok.MEDICATIE": "Of het dier medicatie krijgt, met instructies.",
    "pensionWizard.blok.VERZORGING": "Borstelen, wassen en samen met het eigen gezin.",
    "pensionWizard.blok.BIJZONDERHEDEN": "Bijzonderheden voor dit verblijf.",
    "pensionWizard.blok.ARRANGEMENTEN": "De arrangementen uit Producten › Pension arrangementen, per dier en voor de reservering.",
    "pensionWizard.blok.VERZEKERING": "De annuleringsverzekering, als de vestiging die aanbiedt.",
    "pensionWizard.blok.WENSEN": "Overige wensen van de klant.",
    "pensionWizard.blok.NOTITIE": "Interne notities voor medewerkers.",
    "pensionWizard.blok.INFO": "Een informatieblok.",
    "pensionWizard.blok.SAMENVATTING": "De samenvatting met de prijs; hoort altijd bij de controle.",
    "pensionWizard.blok.CONCEPT": "De knop om de reservering als concept op te slaan.",
    "pensionWizard.veld.naam": "Naam",
    "pensionWizard.veld.titel": "Titel",
    "pensionWizard.veld.naamStandaard": "Leeg laten voor de standaardnaam.",
    "pensionWizard.veld.uitleg": "Uitleg",
    "pensionWizard.veld.plaatshouder": "Voorbeeldtekst in het veld",
    "pensionWizard.veld.tekst": "Tekst",
    "pensionWizard.veld.vraag": "Vraag",
    "pensionWizard.veld.soort": "Soort antwoord",
    "pensionWizard.veld.keuzes": "Keuzes (één per regel)",
    "pensionWizard.veld.verplicht": "Verplicht om in te vullen",
    "pensionWizard.veld.perDier": "Per dier vragen",
    "pensionWizard.veld.perDierNiet": "Kan alleen in een stap na de dieren.",
    "pensionWizard.veld.tonen": "Tonen in de wizard",
    "pensionWizard.veld.nodig": "Dit onderdeel is nodig en blijft zichtbaar.",
    "pensionWizard.veld.verwijder": "Verwijderen",
    "pensionWizard.nieuw.vraag": "Nieuwe vraag",
    "pensionWizard.nieuw.tekst": "Nieuw tekstblok",
    "pensionWizard.nieuw.stap": "Nieuwe stap",
    "pensionWizard.nieuw.optie": "Optie %s",
    "pensionWizard.regel.klantEerst": "Klant zoeken en klant kiezen blijven de eerste twee stappen.",
    "pensionWizard.regel.controleLaatst": "Controle & aanmaken blijft de laatste stap.",
    "pensionWizard.regel.dierenVoorPeriode": "De dieren komen voor de periode.",
    "pensionWizard.regel.naPeriode": "Verblijf, arrangementen en reserveringskeuzes komen na de periode.",
    "pensionWizard.regel.perDierNaDieren": "Een vraag per dier hoort in een stap na de dieren.",
    "pensionWizard.regel.eigenStapNaam": "Geef elke eigen stap een naam.",
    "pensionWizard.regel.eigenStapLeeg": "Een eigen stap heeft minstens één vraag of tekstblok.",
    "pensionWizard.regel.zoekenLeeg": "Klant zoeken heeft minstens het zoeken op e-mail of op adres.",
    "pensionWizard.regel.vraagTekst": "Elke vraag heeft een tekst.",
    "pensionWizard.regel.vraagOpties": "Een keuzevraag heeft minstens één keuze.",
    "pensionWizard.regel.tekstLeeg": "Een tekstblok heeft een titel of tekst.",
    "pensionWizard.melding.opgeslagen": "Concept opgeslagen. Publiceer het om de wizard te wijzigen.",
    "pensionWizard.melding.gepubliceerd": "Gepubliceerd: de wizard gebruikt nu versie %s.",
    "pensionWizard.melding.verworpen": "Concept verworpen.",
    "pensionWizard.melding.standaard": "De standaardindeling staat klaar als concept.",
    "pensionWizard.fout.laden": "De indeling kon niet worden geladen.",
    "pensionWizard.fout.opslaan": "Opslaan is mislukt. %s",
    "pensionWizard.fout.alleenBeheer": "Alleen een pensionbeheerder kan de wizard indelen.",
    "nieuweReservering.arrangementen.titel": "Arrangementen & extra's",
    "nieuweReservering.arrangementen.uitleg": "Kies per dier de gewenste arrangementen en extra's. Deze zijn optioneel.",
    "nieuweReservering.arrangementen.voorWie": "Voor wie",
    "nieuweReservering.arrangementen.reservering": "Reservering",
    "nieuweReservering.arrangementen.reserveringUitleg": "Extra's voor de hele reservering",
    "nieuweReservering.arrangementen.laadFout": "De arrangementen konden niet worden geladen.",
    "nieuweReservering.arrangementen.geen": "Hier zijn geen arrangementen. Richt ze in bij Producten › Pension arrangementen.",
    "nieuweReservering.arrangementen.gekozen": "Geselecteerde extra's",
    "nieuweReservering.arrangementen.gekozenUitleg": "Overzicht van alle gekozen arrangementen en extra's.",
    "nieuweReservering.arrangementen.minder": "Eén %s minder",
    "nieuweReservering.arrangementen.meer": "Eén %s meer",
    "nieuweReservering.arrangementen.weg": "%s weghalen",
    "nieuweReservering.arrangementen.nogNiets": "Nog niets gekozen.",
    "nieuweReservering.arrangementen.totaal": "Totaal extra's",
    "nieuweReservering.arrangementen.overslaanTitel": "Geen extra's gewenst?",
    "nieuweReservering.arrangementen.overslaanUitleg": "Je kunt deze stap overslaan als er geen arrangementen of extra's nodig zijn.",
    "nieuweReservering.arrangementen.overslaan": "Deze stap overslaan",
    "nieuweReservering.arrangementen.terug": "Terug naar verblijf",
    "pensionAccommodatie.veld.omschrijving": "Omschrijving",
    "pensionAccommodatie.veld.foto": "Foto",
    "pensionAccommodatie.foto.kies": "Foto kiezen",
    "pensionAccommodatie.foto.weg": "Foto weghalen",
    "pensionAccommodatie.foto.uitleg": "Een foto van het verblijf, voor de wizard Nieuwe reservering.",
    "pensionAccommodatie.fout.foto": "Kies een PNG, JPEG of WebP.",
    "nieuweReservering.titel": "Maak een nieuwe reservering",
    "nieuweReservering.subtitel": "Registreer een nieuwe pensionreservering",
    "nieuweReservering.groot": "Groter weergeven",
    "nieuweReservering.klein": "Kleiner weergeven",
    "nieuweReservering.sluiten": "Sluiten",
    "nieuweReservering.stappen": "Stappen",
    "nieuweReservering.stap.zoeken": "Klant zoeken",
    "nieuweReservering.stap.kiezen": "Klant kiezen",
    "nieuweReservering.stap.controleren": "Klant controleren",
    "nieuweReservering.stap.dieren": "Dieren selecteren",
    "nieuweReservering.stap.nieuwDier": "Nieuw dier toevoegen",
    "nieuweReservering.stap.periode": "Periode selecteren",
    "nieuweReservering.stap.perDier": "Instellingen per dier",
    "nieuweReservering.stap.verzorging": "Arrangementen & extra's",
    "nieuweReservering.stap.controle": "Controle & aanmaken",
    "nieuweReservering.volgt": "Deze stap wordt nog gebouwd.",
    "nieuweReservering.terug": "Terug",
    "nieuweReservering.volgende": "Volgende",
    "nieuweReservering.annuleren": "Annuleren",
    "nieuweReservering.zoeken.titel": "Zoek klant",
    "nieuweReservering.zoeken.uitleg": "Voor wie wordt de reservering gemaakt?",
    "nieuweReservering.zoeken.email": "Zoeken op e-mailadres",
    "nieuweReservering.zoeken.emailPlaats": "E-mailadres",
    "nieuweReservering.zoeken.enOf": "en/of",
    "nieuweReservering.zoeken.adres": "Zoek op adres",
    "nieuweReservering.zoeken.adresPlaats": "Typ straat, stad of postcode…",
    "nieuweReservering.adres.suggesties": "Adressuggesties",
    "nieuweReservering.adres.nietBeschikbaar": "Adres zoeken (Postcode.eu) is niet ingesteld op deze server; typ het adres zelf.",
    "nieuweReservering.nieuw.adresZoeken": "Adres zoeken",
    "nieuweReservering.nieuw.adresZoekenPlaats": "Typ straat, huisnummer en plaats",
    "nieuweReservering.zoeken.knop": "Zoeken",
    "nieuweReservering.zoeken.fout": "Zoeken is mislukt. Probeer het opnieuw.",
    "nieuweReservering.kiezen.titel": "Gevonden klanten",
    "nieuweReservering.kiezen.uitleg": "Kies de juiste klant voor deze reservering of maak een nieuwe klant aan.",
    "nieuweReservering.kiezen.voor": "Zoekresultaten voor:",
    "nieuweReservering.kiezen.inactief": "Niet actief",
    "nieuweReservering.kiezen.dierEen": "1 dier",
    "nieuweReservering.kiezen.dieren": "%s dieren",
    "nieuweReservering.kiezen.boekingEen": "1 pension boeking",
    "nieuweReservering.kiezen.boekingen": "%s pension boekingen",
    "nieuweReservering.kiezen.selecteerAria": "%s selecteren",
    "nieuweReservering.kiezen.selecteren": "Selecteren",
    "nieuweReservering.kiezen.geselecteerd": "Geselecteerd",
    "nieuweReservering.kiezen.meer": "Er passen meer klanten dan hier staan; zoek preciezer.",
    "nieuweReservering.kiezen.nietGevonden": "Niet de juiste klant gevonden?",
    "nieuweReservering.kiezen.nietGevondenUitleg": "Maak eenvoudig een nieuwe klant aan en ga direct verder met de reservering.",
    "nieuweReservering.kiezen.nieuw": "Nieuwe klant aanmaken",
    "nieuweReservering.controleren.titel": "Klant controleren",
    "nieuweReservering.controleren.uitleg": "Kloppen deze gegevens voor deze reservering?",
    "nieuweReservering.controleren.naam": "Naam",
    "nieuweReservering.controleren.adres": "Adres",
    "nieuweReservering.controleren.dieren": "Dieren",
    "nieuweReservering.controleren.boekingen": "Pension boekingen",
    "nieuweReservering.controleren.klopt": "Klopt er iets niet? Pas het na de reservering aan op het klantscherm.",
    "nieuweReservering.controleren.aanpassen": "Gegevens aanpassen",
    "nieuweReservering.controleren.opslaan": "Gegevens opslaan",
    "nieuweReservering.controleren.opgeslagen": "De gegevens zijn opgeslagen.",
    "nieuweReservering.controleren.telefoon2": "Tweede telefoonnummer",
    "nieuweReservering.controleren.laadFout": "De gegevens van de klant konden niet worden geladen.",
    "nieuweReservering.controleren.fout": "Opslaan is mislukt. Probeer het opnieuw.",
    "nieuweReservering.controleren.geenRecht": "Je mag de gegevens van een relatie niet wijzigen.",
    "nieuweReservering.controleren.conflict": "Iemand anders heeft deze klant net gewijzigd. De gegevens zijn opnieuw geladen.",
    "nieuweReservering.nieuw.titel": "Nieuwe klant aanmaken",
    "nieuweReservering.nieuw.uitleg": "Vul de gegevens in. Na opslaan wordt deze klant direct geselecteerd.",
    "nieuweReservering.nieuw.persoon": "Persoonsgegevens",
    "nieuweReservering.nieuw.contactpersoon": "Contactpersoon",
    "nieuweReservering.nieuw.bedrijfsnaam": "Bedrijfsnaam",
    "nieuweReservering.nieuw.voorletters": "Voorletters",
    "nieuweReservering.nieuw.tussenvoegsel": "Tussenvoegsel",
    "nieuweReservering.nieuw.achternaam": "Achternaam",
    "nieuweReservering.nieuw.geslacht": "Geslacht",
    "nieuweReservering.nieuw.geslachtLeeg": "—",
    "nieuweReservering.nieuw.geslachtMAN": "Man",
    "nieuweReservering.nieuw.geslachtVROUW": "Vrouw",
    "nieuweReservering.nieuw.geboortedatum": "Geboortedatum",
    "nieuweReservering.nieuw.contact": "Contactgegevens",
    "nieuweReservering.nieuw.email": "E-mailadres",
    "nieuweReservering.nieuw.telefoon": "Telefoonnummer",
    "nieuweReservering.nieuw.emailOngeldig": "Dit is geen geldig e-mailadres.",
    "nieuweReservering.nieuw.adres": "Adresgegevens",
    "nieuweReservering.nieuw.straat": "Straat",
    "nieuweReservering.nieuw.huisnummer": "Huisnummer",
    "nieuweReservering.nieuw.toevoeging": "Toevoeging",
    "nieuweReservering.nieuw.postcode": "Postcode",
    "nieuweReservering.nieuw.plaats": "Plaats",
    "nieuweReservering.nieuw.opzoeken": "Adres opzoeken",
    "nieuweReservering.nieuw.adresNietGevonden": "Bij deze postcode en dit huisnummer is geen adres gevonden.",
    "nieuweReservering.nieuw.organisatie": "Opslaan als zakelijke relatie / organisatie",
    "nieuweReservering.nieuw.verplicht": "Vul de verplichte velden in.",
    "nieuweReservering.nieuw.geenRecht": "Je mag geen klanten aanmaken.",
    "nieuweReservering.nieuw.ongeldig": "Controleer de gegevens.",
    "nieuweReservering.nieuw.fout": "Aanmaken is mislukt. Probeer het opnieuw.",
    "nieuweReservering.nieuw.opslaan": "Klant aanmaken en verder",
    "nieuweReservering.dieren.klant": "Geselecteerde klant",
    "nieuweReservering.dieren.klantWijzigen": "Klant wijzigen",
    "nieuweReservering.dieren.titel": "Dieren selecteren",
    "nieuweReservering.dieren.uitleg": "Kies één of meerdere dieren voor deze reservering.",
    "nieuweReservering.dieren.zoek": "Zoek in dieren…",
    "nieuweReservering.dieren.soort": "Diersoort",
    "nieuweReservering.dieren.alles": "Alles",
    "nieuweReservering.dieren.nieuw": "Nieuw dier toevoegen",
    "nieuweReservering.dieren.laadFout": "De dieren konden niet worden geladen.",
    "nieuweReservering.dieren.geen": "Deze klant heeft nog geen dieren.",
    "nieuweReservering.dieren.inPension": "Nu in pension",
    "nieuweReservering.dieren.gepland": "Gepland: %s",
    "nieuweReservering.dieren.laatste": "Laatste verblijf: %s",
    "nieuweReservering.dieren.geenReservering": "Geen reservering",
    "nieuweReservering.dieren.entingVerlopen": "Enting verlopen",
    "nieuweReservering.dieren.medicatie": "Medicatie",
    "nieuweReservering.dieren.geselecteerd": "Geselecteerd",
    "nieuweReservering.dier.titel": "Nieuw dier toevoegen",
    "nieuweReservering.dier.voor": "Dier toevoegen aan",
    "nieuweReservering.dier.andereKlant": "Andere klant kiezen",
    "nieuweReservering.dier.uitleg": "Vul de gegevens van het dier in. Na opslaan kun je dit dier direct selecteren voor de reservering.",
    "nieuweReservering.dier.gegevens": "Diergegevens",
    "nieuweReservering.dier.naam": "Naam",
    "nieuweReservering.dier.naamPlaats": "Naam van het dier",
    "nieuweReservering.dier.chip": "Chipnummer",
    "nieuweReservering.dier.chipPlaats": "Vul het 15-cijferige chipnummer in",
    "nieuweReservering.dier.chipOngeldig": "Een chipnummer heeft 15 cijfers.",
    "nieuweReservering.dier.geslacht": "Geslacht",
    "nieuweReservering.dier.onbekend": "Onbekend",
    "nieuweReservering.dier.mannelijk": "Mannelijk",
    "nieuweReservering.dier.vrouwelijk": "Vrouwelijk",
    "nieuweReservering.dier.gecastreerd": "Cas./Ster.",
    "nieuweReservering.dier.geboortedatum": "Geboortedatum",
    "nieuweReservering.dier.diersoort": "Diersoort",
    "nieuweReservering.dier.kiesSoort": "Kies een diersoort",
    "nieuweReservering.dier.ras": "Ras",
    "nieuweReservering.dier.kiesRas": "Kies een ras",
    "nieuweReservering.dier.kruising": "Kruising",
    "nieuweReservering.dier.vacht": "Vacht",
    "nieuweReservering.dier.kiesVacht": "Selecteer vacht",
    "nieuweReservering.dier.kleur": "Kleur",
    "nieuweReservering.dier.kiesKleur": "Selecteer kleur",
    "nieuweReservering.dier.bijzonderheden": "Bijzonderheden",
    "nieuweReservering.dier.bijzonderhedenPlaats": "Bijvoorbeeld karakter, medische bijzonderheden, voeding, etc.",
    "nieuweReservering.dier.verplicht": "Naam en diersoort zijn verplicht.",
    "nieuweReservering.dier.foto": "Foto van het dier",
    "nieuweReservering.dier.fotoUitleg": "Upload een foto van het dier (ook via camera).",
    "nieuweReservering.dier.fotoUitlegAi": "Upload een foto van het dier (ook via camera) voor AI-voorinvulling.",
    "nieuweReservering.dier.fotoKiezen": "Foto kiezen",
    "nieuweReservering.dier.fotoVoorbeeld": "Gekozen foto",
    "nieuweReservering.dier.fotoKlik": "Klik om een foto te uploaden",
    "nieuweReservering.dier.fotoAnders": "Andere foto kiezen",
    "nieuweReservering.dier.fotoSleep": "of sleep een bestand hierheen",
    "nieuweReservering.dier.fotoFormaten": "Ondersteunde formaten: JPG, PNG, WEBP · Max. 10 MB",
    "nieuweReservering.dier.fotoOngeldig": "Kies een JPG, PNG of WEBP van hoogstens 10 MB.",
    "nieuweReservering.dier.fotoNietOpgeslagen": "Het dier is toegevoegd, maar de foto kon niet worden opgeslagen.",
    "nieuweReservering.dier.of": "of",
    "nieuweReservering.dier.paspoort": "Scan foto van paspoort",
    "nieuweReservering.dier.paspoortUitleg": "We proberen de gegevens automatisch in te vullen.",
    "nieuweReservering.dier.aiTitel": "AI-voorinvulling",
    "nieuweReservering.dier.aiUitleg": "Upload een foto of paspoortfoto en we vullen automatisch zoveel mogelijk gegevens in.",
    "nieuweReservering.dier.aiBezig": "De foto wordt uitgelezen…",
    "nieuweReservering.dier.aiIngevuld": "%s velden ingevuld. Controleer ze voor je opslaat.",
    "nieuweReservering.dier.aiNiets": "Er is niets bruikbaars gevonden.",
    "nieuweReservering.dier.aiFout": "De foto kon niet worden uitgelezen.",
    "nieuweReservering.dier.geenRecht": "Je mag geen dieren toevoegen.",
    "nieuweReservering.dier.ongeldig": "Controleer de gegevens.",
    "nieuweReservering.dier.fout": "Toevoegen is mislukt. Probeer het opnieuw.",
    "nieuweReservering.dier.terug": "Terug naar dieren",
    "nieuweReservering.dier.toevoegen": "Dier toevoegen",
    "nieuweReservering.periode.klantBekijken": "Klantgegevens bekijken",
    "nieuweReservering.periode.dieren": "Geselecteerde dieren",
    "nieuweReservering.periode.dierenAanpassen": "Dieren aanpassen",
    "nieuweReservering.periode.titel": "Periode selecteren",
    "nieuweReservering.periode.uitleg": "Kies wanneer de dieren worden gebracht en opgehaald.",
    "nieuweReservering.periode.aankomst": "Aankomst",
    "nieuweReservering.periode.aankomstVraag": "Wanneer worden de dieren gebracht?",
    "nieuweReservering.periode.aankomstdatum": "Aankomstdatum",
    "nieuweReservering.periode.aankomsttijd": "Aankomsttijd",
    "nieuweReservering.periode.vertrek": "Vertrek",
    "nieuweReservering.periode.vertrekVraag": "Wanneer worden de dieren opgehaald?",
    "nieuweReservering.periode.vertrekdatum": "Vertrekdatum",
    "nieuweReservering.periode.vertrektijd": "Vertrektijd",
    "nieuweReservering.periode.en": "en",
    "nieuweReservering.periode.brengenOp": "Brengen kan op deze dag van %s",
    "nieuweReservering.periode.halenOp": "Ophalen kan op deze dag van %s",
    "nieuweReservering.periode.brengenDicht": "Op deze dag neemt het pension geen dieren aan. Kies een andere datum.",
    "nieuweReservering.periode.halenDicht": "Op deze dag geeft het pension geen dieren mee. Kies een andere datum.",
    "nieuweReservering.periode.duur": "Verblijfsduur",
    "nieuweReservering.periode.nacht": "1 nacht",
    "nieuweReservering.periode.nachten": "%s nachten",
    "nieuweReservering.periode.kies": "Kies aankomst en vertrek",
    "nieuweReservering.periode.ongeldig": "Vertrek moet na aankomst liggen",
    "nieuweReservering.periode.kiesTijd": "Kies een aankomst- en vertrektijd",
    "nieuweReservering.periode.verblijf": "Type verblijf",
    "nieuweReservering.periode.verblijfUitleg": "Kies per dier het gewenste verblijf.",
    "nieuweReservering.periode.verblijfKeuze": "Verblijf voor %s",
    "nieuweReservering.periode.verblijfGeen": "Er zijn nog geen accommodatietypes voor %s.",
    "nieuweReservering.periode.meerprijs": "Meerprijs %s p/dag",
    "nieuweReservering.periode.dagprijs": "%s p/dag",
    "nieuweReservering.periode.locatie": "Locatie",
    "nieuweReservering.periode.locatieUitleg": "Plek, tarieven en openingstijden verschillen per locatie.",
    "nieuweReservering.periode.locatieKiezen": "Boeken bij",
    "nieuweReservering.periode.beschikbaarheid": "Beschikbaarheid controleren",
    "nieuweReservering.periode.tm": "%s t/m %s",
    "nieuweReservering.periode.kiesEerst": "Kies eerst een periode.",
    "nieuweReservering.periode.bezig": "Bezig met controleren…",
    "nieuweReservering.periode.ok": "Er is capaciteit beschikbaar voor deze periode.",
    "nieuweReservering.periode.okUitleg": "Je kunt verder naar de volgende stap.",
    "nieuweReservering.periode.geenCapaciteit": "Er is geen capaciteit ingesteld; alleen volle dagen zijn gecontroleerd.",
    "nieuweReservering.periode.vol": "Niet op elke dag plaats",
    "nieuweReservering.periode.knelpuntVol": "%s: vol voor %s",
    "nieuweReservering.periode.knelpuntCapaciteit": "%s: %s, nog %s plaatsen vrij",
    "nieuweReservering.periode.fout": "De beschikbaarheid kon niet worden gecontroleerd.",
    "nieuweReservering.periode.opnieuw": "Opnieuw controleren",
    "pensionKlant.opvang.titel": "Dagopvangprofiel",
    "pensionKlant.opvang.vasteKlant": "Vaste klant",
    "pensionKlant.opvang.eenDier": "1 dier",
    "pensionKlant.opvang.dieren.aantal": "%s dieren",
    "pensionKlant.opvang.doorlopend": "Doorlopend",
    "pensionKlant.opvang.bewerken": "Bewerken",
    "pensionKlant.opvang.dagPlannen": "Dag plannen",
    "pensionKlant.opvang.meer": "Meer acties",
    "pensionKlant.opvang.rittenkaartVerkopen": "Rittenkaart verkopen",
    "pensionKlant.opvang.afrekenwijzeWijzigen": "Afrekenwijze wijzigen",
    "pensionKlant.opvang.kalender": "Kalender dagopvang",
    "pensionKlant.opvang.eerder": "Eerdere maanden",
    "pensionKlant.opvang.later": "Latere maanden",
    "pensionKlant.opvang.vandaag": "Vandaag",
    "pensionKlant.opvang.filter": "Dieren in de kalender",
    "pensionKlant.opvang.alleDieren": "Alle dieren",
    "pensionKlant.opvang.soort.vast": "Gepland (vaste dag)",
    "pensionKlant.opvang.soort.extra": "Extra dag",
    "pensionKlant.opvang.soort.afwezig": "Afwezig",
    "pensionKlant.opvang.soort.proefdag": "Proefdag",
    "pensionKlant.opvang.soort.feestdag": "Feestdag",
    "pensionKlant.opvang.soort.verwacht": "Vaste dag, nog niet ingepland",
    "pensionKlant.opvang.legenda.dieren": "Dieren op deze dag",
    "pensionKlant.opvang.gepland": "Geplande opvangdagen",
    "pensionKlant.opvang.maandKeuze": "Maand",
    "pensionKlant.opvang.alleMaanden": "Alle maanden in beeld",
    "pensionKlant.opvang.alleBekijken": "Alle opvangdagen bekijken",
    "pensionKlant.opvang.minderBekijken": "Eén maand tonen",
    "pensionKlant.opvang.geenDagen": "Geen opvangdagen in deze periode.",
    "pensionKlant.opvang.kolom.datum": "Datum",
    "pensionKlant.opvang.kolom.dieren": "Dieren",
    "pensionKlant.opvang.kolom.type": "Type",
    "pensionKlant.opvang.kolom.status": "Status",
    "pensionKlant.opvang.kolom.afrekening": "Afrekening",
    "pensionKlant.opvang.kolom.opmerking": "Opmerking",
    "pensionKlant.opvang.kolom.acties": "Acties",
    "pensionKlant.opvang.type.VASTE_DAG": "Vaste dag",
    "pensionKlant.opvang.type.EXTRA_DAG": "Extra dag",
    "pensionKlant.opvang.type.PROEFDAG": "Proefdag",
    "pensionKlant.opvang.afrekening.INBEGREPEN": "Inbegrepen",
    "pensionKlant.opvang.afrekening.eenRit": "1 rit",
    "pensionKlant.opvang.afrekening.ritten": "%s ritten",
    "pensionKlant.opvang.afrekening.DAGPRIJS": "Dagprijs",
    "pensionKlant.opvang.afrekening.PROEFDAG": "Proefdag",
    "pensionKlant.opvang.gefactureerd": "Gefactureerd",
    "pensionKlant.opvang.actie.bewerk": "%s bewerken",
    "pensionKlant.opvang.actie.afmelden": "%s afmelden",
    "pensionKlant.opvang.actie.terugzetten": "%s terugzetten",
    "pensionKlant.opvang.actie.verwijder": "%s verwijderen",
    "pensionKlant.opvang.dieren.titel": "Dagopvangdieren",
    "pensionKlant.opvang.dieren.geen": "Er staan nog geen dieren op het contract.",
    "pensionKlant.opvang.geenVasteDagen": "Geen vaste dagen",
    "pensionKlant.opvang.alleenInKennel": "Alleen in verblijf",
    "pensionKlant.opvang.medicatie": "Medicatie",
    "pensionKlant.opvang.laatsteBezoek": "Laatste bezoek: %s",
    "pensionKlant.opvang.afrekenwijze": "Afrekenwijze",
    "pensionKlant.opvang.wijze.RITTENKAART": "Rittenkaart",
    "pensionKlant.opvang.wijze.PERIODE": "Periodefacturatie",
    "pensionKlant.opvang.wijze.MAANDCONTRACT": "Maandcontract",
    "pensionKlant.opvang.wijze.RITTENKAART.uitleg": "De klant koopt een kaart met ritten; elk dier dat komt boekt één rit af.",
    "pensionKlant.opvang.wijze.PERIODE.uitleg": "Elke dag tegen de dagprijs, gefactureerd per periode (meestal een maand).",
    "pensionKlant.opvang.wijze.MAANDCONTRACT.uitleg": "Vaste dagen per week; extra dagen via de rittenkaart of tegen de losse dagprijs.",
    "pensionKlant.opvang.rit.stand": "%s ritten gekocht | %s resterend",
    "pensionKlant.opvang.rit.perDier": "Per aanwezig dier 1 rit",
    "pensionKlant.opvang.rit.verloopt": "Geldig tot %s",
    "pensionKlant.opvang.periode.stand": "%s per dag | facturatie per maand",
    "pensionKlant.opvang.periode.geenPrijs": "Nog geen dagprijs; stel die in bij Producten › Dagopvangtarieven.",
    "pensionKlant.opvang.maand.vast": "Vaste dagen: %s",
    "pensionKlant.opvang.maand.geenVast": "Nog geen vaste dagen",
    "pensionKlant.opvang.maand.inbegrepen": "%s inbegrepen per maand",
    "pensionKlant.opvang.maand.extra.RITTENKAART": "Extra dagen via de rittenkaart",
    "pensionKlant.opvang.maand.extra.LOSSE_DAGPRIJS": "Extra dagen tegen de losse dagprijs",
    "pensionKlant.opvang.maand.abonnement": "%s, %s per maand",
    "pensionKlant.opvang.afgeleid": "Nog niet ingesteld: afgeleid uit het contract in het oude pakket.",
    "pensionKlant.opvang.en": "en",
    "pensionKlant.opvang.samenvatting": "Samenvatting huidige maand",
    "pensionKlant.opvang.som.inbegrepen": "Inbegrepen",
    "pensionKlant.opvang.som.gebruikt": "Gebruikt",
    "pensionKlant.opvang.som.extra": "Extra dagen",
    "pensionKlant.opvang.som.beschikbaar": "Nog beschikbaar",
    "pensionKlant.opvang.som.openstaand": "Openstaand deze maand",
    "pensionKlant.opvang.volgende": "Volgende opvangdag",
    "pensionKlant.opvang.geenVolgende": "Er staat geen opvangdag meer gepland.",
    "pensionKlant.opvang.brengen": "Brengen",
    "pensionKlant.opvang.halen": "Halen",
    "pensionKlant.opvang.annuleren": "Annuleren",
    "pensionKlant.opvang.opslaan": "Opslaan",
    "pensionKlant.opvang.dag.planTitel": "Opvangdag plannen",
    "pensionKlant.opvang.dag.bewerkTitel": "Opvangdag %s",
    "pensionKlant.opvang.dag.plannen": "Dag plannen",
    "pensionKlant.opvang.dag.datum": "Datum",
    "pensionKlant.opvang.dag.dieren": "Dieren",
    "pensionKlant.opvang.dag.extra": "Extra dag",
    "pensionKlant.opvang.dag.extraAfgeleid": "Niet elk dier heeft dit als vaste dag.",
    "pensionKlant.opvang.dag.vastAfgeleid": "Een vaste dag van deze dieren.",
    "pensionKlant.opvang.dag.proefdag": "Proefdag",
    "pensionKlant.opvang.dag.opmerking": "Opmerking",
    "pensionKlant.opvang.dag.toevoegenTitel": "Dagopvang toevoegen",
    "pensionKlant.opvang.dag.bewerkTitel2": "Dagopvang bewerken",
    "pensionKlant.opvang.dag.toevoegen": "Toevoegen",
    "pensionKlant.opvang.dag.andereDag": "andere dag",
    "pensionKlant.opvang.dag.geselecteerd": "%d geselecteerd",
    "pensionKlant.opvang.dag.tijd": "Tijd",
    "pensionKlant.opvang.dag.soort": "Soort opvang",
    "pensionKlant.opvang.dag.regulier": "Regulier",
    "pensionKlant.opvang.dag.opmerkingHint": "Extra informatie toevoegen…",
    "pensionKlant.opvang.afmelden.titel": "%s afmelden",
    "pensionKlant.opvang.afmelden.uitleg": "De dag blijft staan als afwezig; hij telt niet mee voor de afrekening.",
    "pensionKlant.opvang.afmelden.reden": "Reden",
    "pensionKlant.opvang.afmelden.bevestig": "Afmelden",
    "pensionKlant.opvang.verwijderen.titel": "%s verwijderen",
    "pensionKlant.opvang.verwijderen.uitleg": "De dag verdwijnt helemaal. Kwam het dier gewoon niet, meld hem dan liever af.",
    "pensionKlant.opvang.verwijderen.bevestig": "Verwijderen",
    "pensionKlant.opvang.vast.titel": "Vaste dagen per dier",
    "pensionKlant.opvang.vast.uitleg": "Op deze dagen komt het dier vast. Kies hieronder de periode die meteen ingepland moet worden.",
    "pensionKlant.opvang.vast.periode": "Periode inplannen",
    "pensionKlant.opvang.vast.van": "Van",
    "pensionKlant.opvang.vast.tot": "Tot en met",
    "pensionKlant.opvang.vast.periodeUitleg": "De vaste dagen in deze periode worden geboekt; dagen die niet meer passen vervallen. Extra dagen, proefdagen, dagen met een opmerking en gefactureerde dagen blijven staan, en wat al voorbij is blijft ongemoeid.",
    "pensionKlant.opvang.vast.periodeLeeg": "Zonder periode verandert alleen het weekpatroon; er wordt niets ingepland.",
    "pensionKlant.opvang.vast.periodeHalf": "Geef zowel een begin als een einde, of laat ze allebei leeg.",
    "pensionKlant.opvang.vast.periodeOmgekeerd": "Het einde ligt voor het begin.",
    "pensionKlant.opvang.afrekening.hoe": "Hoe wordt de dagopvang afgerekend?",
    "pensionKlant.opvang.afrekening.abonnement": "Abonnement",
    "pensionKlant.opvang.afrekening.kies": "Kies…",
    "pensionKlant.opvang.afrekening.geenAbonnementen": "Er zijn nog geen actieve abonnementen; maak ze aan bij Producten › Dagopvangtarieven.",
    "pensionKlant.opvang.afrekening.perWeek": "%s dagen per week",
    "pensionKlant.opvang.afrekening.dagprijs": "Losse dagprijs",
    "pensionKlant.opvang.afrekening.standaardPrijs": "Standaard van de vestiging",
    "pensionKlant.opvang.afrekening.brengen": "Vaste brengtijd",
    "pensionKlant.opvang.afrekening.halen": "Vaste haaltijd",
    "pensionKlant.opvang.rittenkaart.welke": "Welke rittenkaart?",
    "pensionKlant.opvang.rittenkaart.geen": "Er zijn nog geen rittenkaarten; maak ze aan bij Producten › Dagopvangtarieven.",
    "pensionKlant.opvang.rittenkaart.ritten": "%s ritten",
    "pensionKlant.opvang.rittenkaart.geldig": "%s maanden geldig",
    "pensionKlant.opvang.rittenkaart.verkoop": "Verkopen",
    "pensionKlant.opvang.fout.conflict": "Dat kan niet: op die dag staat al opvang, de dag is al gefactureerd of het dier is er al geweest.",
    "pensionKlant.opvang.fout.geenContract": "Op die datum loopt geen dagopvangcontract.",
    "pensionKlant.opvang.fout.ongeldig": "Controleer de gegevens.",
    "pensionKlant.opvang.fout.algemeen": "Opslaan is mislukt. Probeer het opnieuw.",
    "pensionKlant.opvang.fout.tijden": "Halen moet na brengen liggen.",
    "pensionKlant.dagopvang.geenLopend": "Geen lopend contract.",
    "pensionKlant.dagopvang.toonEerdere": "%s eerdere contracten tonen",
    "pensionKlant.dagopvang.toonEerdereEen": "1 eerder contract tonen",
    "pensionKlant.dagopvang.verbergEerdere": "Eerdere contracten verbergen",
    "pensionKlant.dagopvang.komend": "Komende dagen",
    "pensionKlant.dagopvang.geenKomend": "Er staat geen dagopvang gepland.",
    "pensionKlant.dagopvang.eerste": "De eerste %s van %s dagen.",
    "pensionKlant.dagopvang.geweest": "Eerdere dagen",
    "pensionKlant.dagopvang.geenGeweest": "Nog geen eerdere dagen.",
    "pensionKlant.dagopvang.laatste": "De laatste %s van %s dagen.",
    "pensionKlant.dagopvang.vanafOnbeperkt": "Vanaf %s, onbeperkt",
    "pensionKlant.dagopvang.dagenPerWeek": "%s dagen per week",
    "pensionKlant.dagopvang.contract": "Contract %s",
    "pensionKlant.dagopvang.rittenkaart": "Rittenkaart",
    "pensionKlant.dagopvang.opgezegd": "Opgezegd per %s",
    "pensionKlant.dagopvang.extraDag": "Extra dag",
    "pensionKlant.contractstatus.LOPEND": "Lopend",
    "pensionKlant.contractstatus.TOEKOMSTIG": "Gaat nog in",
    "pensionKlant.contractstatus.OPGEZEGD": "Opgezegd",
    "pensionKlant.contractstatus.AFGELOPEN": "Afgelopen",
    "pensionKlant.contractstatus.GEANNULEERD": "Geannuleerd",
    "pensionKlant.dagstatus.AANWEZIG": "Aanwezig",
    "pensionKlant.dagstatus.VANDAAG": "Vandaag",
    "pensionKlant.dagstatus.GEPLAND": "Gepland",
    "pensionKlant.dagstatus.OPGEHAALD": "Opgehaald",
    "pensionKlant.dagstatus.GEWEEST": "Geweest",
    "pensionKlant.dagstatus.GEANNULEERD": "Geannuleerd",
    "pensionKlant.reserveringen.filterAria": "Toon reserveringen voor",
    "pensionKlant.reserveringen.filter.alles": "Alles",
    "pensionKlant.reserveringen.filter.pension": "Pension",
    "pensionKlant.reserveringen.filter.dagopvang": "Dagopvang",
    "pensionKlant.reserveringen.komend": "Komend en nu",
    "pensionKlant.reserveringen.geenKomend": "Er komt niets aan.",
    "pensionKlant.factuur.geen": "Niet gefactureerd",
    "pensionKlant.factuur.status.CONCEPT": "Conceptfactuur",
    "pensionKlant.factuur.status.OPEN": "Gefactureerd",
    "pensionKlant.factuur.status.BETAALD": "Betaald",
    "pensionKlant.factuur.status.VERVALLEN": "Vervallen",
    "pensionKlant.factuur.nummer.CONCEPT": "Conceptfactuur %s",
    "pensionKlant.factuur.nummer.OPEN": "Factuur %s",
    "pensionKlant.factuur.nummer.BETAALD": "Factuur %s betaald",
    "pensionKlant.factuur.nummer.VERVALLEN": "Factuur %s vervallen",
    "pensionKlant.factuur.openstaand": "%s openstaand",
    "pensionKlant.reserveringen.geweest": "Eerder",
    "pensionKlant.reserveringen.geenGeweest": "Nog niets geweest.",
    "pensionKlant.reserveringen.nachten": "%s nachten",
    "pensionKlant.reserveringen.dagopvangBegrensd": "Van de dagopvang staan hier alleen de 30 meest recente dagen.",
    "pensionKlant.notities.zoek": "Zoek in notities",
    "pensionKlant.notities.soortAria": "Welke notities",
    "pensionKlant.notities.soort.alles": "Alles",
    "pensionKlant.notities.soort.notities": "Notities",
    "pensionKlant.notities.soort.logboek": "Logboek",
    "pensionKlant.notities.geen": "Nog geen notities.",
    "pensionKlant.notities.geenGevonden": "Geen notities gevonden.",
    "pensionKlant.notities.automatisch": "Automatisch",
    "pensionKlant.notities.nieuw": "Nieuwe notitie",
    "pensionKlant.notities.tekst": "Notitie",
    "pensionKlant.notities.opmerking": "Opmerking (niet verplicht)",
    "pensionKlant.notities.opslaan": "Notitie toevoegen",
    "pensionKlant.notities.opgeslagen": "Notitie toegevoegd.",
    "pensionKlant.notities.opslaanMislukt": "De notitie kon niet worden opgeslagen.",
    "pensionKlant.kpi.pensionBoekingen": "Pension boekingen",
    "pensionKlant.kpi.dagopvangBoekingen": "Dagopvang boekingen",
    "pensionKlant.dieren.titelAantal": "Dieren (%s)",
    "pensionKlant.dieren.lijstAria": "Dieren van deze klant",
    "pensionKlant.status.gereserveerd": "Gereserveerd",
    "pensionKlant.dier.subtabsAria": "Over dit dier",
    "pensionKlant.sub.overzicht": "Overzicht",
    "pensionKlant.sub.verzorging": "Verzorging",
    "pensionKlant.sub.medisch": "Medisch",
    "pensionKlant.sub.notities": "Notities & logboek",
    "pensionKlant.signaal.entingVerlopen": "Enting verlopen",
    "pensionKlant.signaal.entingBinnenkort": "Enting verloopt binnenkort",
    "pensionKlant.signaal.medicatieActief": "Medicatie actief",
    "pensionKlant.tegel.basis": "Basisgegevens",
    "pensionKlant.tegel.verzorging": "Verzorging",
    "pensionKlant.tegel.medisch": "Medisch",
    "pensionKlant.tegel.gewicht": "Gewicht",
    "pensionKlant.tegel.bijzonderheden": "Bijzonderheden",
    "pensionKlant.tegel.fotos": "Media & Documenten",
    "pensionKlant.tegel.activiteiten": "Recente activiteiten",
    "pensionKlant.tegel.verblijf": "Huidig / volgend verblijf",
    "pensionKlant.tegel.instellen": "Tegel instellen",
    "pensionKlant.tegel.instellenAria": "Stel de tegel %s in",
    "pensionKlant.tegel.open": "Groot openen",
    "pensionKlant.tegel.openAria": "Open %s",
    "pensionKlant.regel.ras": "Ras",
    "pensionKlant.regel.kleur": "Kleur",
    "pensionKlant.regel.geboortedatum": "Geboortedatum",
    "pensionKlant.regel.geslacht": "Geslacht",
    "pensionKlant.regel.chipnummer": "Chipnummer",
    "pensionKlant.regel.paspoortnummer": "Paspoortnummer",
    "pensionKlant.regel.soort": "Diersoort",
    "pensionKlant.regel.vacht": "Vacht",
    "pensionKlant.regel.registratienummer": "Registratienummer",
    "pensionKlant.regel.dierenarts": "Dierenarts",
    "pensionKlant.regel.voeding": "Voeding",
    "pensionKlant.regel.hoeveelheid": "Hoeveelheid",
    "pensionKlant.regel.schema": "Schema",
    "pensionKlant.regel.voerBijzonderheden": "Bijzonderheden",
    "pensionKlant.regel.gedrag": "Gedrag",
    "pensionKlant.regel.vaccinaties": "Vaccinaties",
    "pensionKlant.regel.medicatie": "Medicatie",
    "pensionKlant.regel.ontworming": "Ontworming",
    "pensionKlant.regel.ontvlooien": "Ontvlooien",
    "pensionKlant.regel.actGewicht": "Wegingen",
    "pensionKlant.regel.actMedicatie": "Gestarte medicatie",
    "pensionKlant.regel.actNotitie": "Notities",
    "pensionKlant.regel.actLogboek": "Logboekregels",
    "pensionKlant.regel.status": "Status",
    "pensionKlant.regel.foto": "Foto",
    "pensionKlant.regel.leeftijd": "Leeftijd",
    "pensionKlant.regel.bijzonderheden": "Bijzonderheden",
    "pensionKlant.regel.reservering": "Eerstvolgende boeking",
    "pensionKlant.regel.periode": "Periode",
    "pensionKlant.regel.kennel": "Verblijf",
    "pensionKlant.regel.bezoeknummer": "Bezoeknummer",
    "pensionKlant.regel.nachten": "Nachten",
    "pensionKlant.regel.tarief": "Tarief",
    "pensionKlant.regel.totaal": "Totaal",
    "pensionKlant.regel.gecastreerd": "gecastreerd",
    "pensionKlant.regel.nietGecastreerd": "niet gecastreerd",
    "pensionKlant.optie.maanden": "Periode van de grafiek",
    "pensionKlant.optie.maanden.3": "3 maanden",
    "pensionKlant.optie.maanden.6": "6 maanden",
    "pensionKlant.optie.maanden.12": "12 maanden",
    "pensionKlant.optie.aantalFotos": "Aantal foto's en documenten",
    "pensionKlant.optie.aantalActiviteiten": "Aantal activiteiten",
    "pensionKlant.staat.inOrde": "In orde",
    "pensionKlant.staat.verlopen": "Verlopen",
    "pensionKlant.staat.verlooptOp": "Verloopt %s",
    "pensionKlant.kopieer.aria": "Kopieer %s",
    "pensionKlant.kopieer.titel": "Kopiëren",
    "pensionKlant.kopieer.klaar": "Gekopieerd",
    "pensionKlant.en": "en",
    "pensionKlant.waarde.perDag": "%s %sx per dag",
    "pensionKlant.waarde.daags": "%s %sx daags",
    "pensionKlant.waarde.geenSchema": "Geen schema",
    "pensionKlant.waarde.geen": "Geen",
    "pensionKlant.waarde.actief": "Actief",
    "pensionKlant.waarde.kg": "%s kg",
    "pensionKlant.waarde.laatsteMeting": "Laatste meting: %s",
    "pensionKlant.waarde.grafiekAria": "Gewicht over de laatste %s maanden",
    "pensionKlant.waarde.nietGewogen": "Nog niet gewogen.",
    "pensionKlant.waarde.trend": "%s sinds %s",
    "pensionKlant.waarde.trendGelijk": "Gelijk sinds %s",
    "pensionKlant.waarde.grafiekLeeg": "Geen metingen in deze periode.",
    "pensionKlant.waarde.grafiekBuitenPeriode": "ouder dan %d maanden",
    "pensionKlant.waarde.geenBijzonderheden": "Geen bijzonderheden",
    "pensionKlant.bijzonderheden.wijzigen": "Bijzonderheden wijzigen",
    "pensionKlant.bijzonderheden.labels": "Labels",
    "pensionKlant.bijzonderheden.labelsHint": "Eén per regel, of met komma's ertussen. Elk wordt een label op de tegel.",
    "pensionKlant.bijzonderheden.notitie": "Notitie",
    "pensionKlant.bijzonderheden.fout": "De bijzonderheden konden niet worden opgeslagen.",
    "pensionKlant.bijzonderheden.teLang": "De labels zijn samen te lang (maximaal 250 tekens). Kort er een paar in of haal er een weg.",
    "pensionKlant.bijzonderheden.conflict": "Iemand anders heeft dit dier gewijzigd. Sluit en open opnieuw om de huidige versie te zien.",
    "pensionKlant.waarde.fotoToevoegen": "Toevoegen",
    "pensionKlant.waarde.nietIngedeeld": "Nog niet ingedeeld",
    "pensionKlant.waarde.nacht": "%s nacht",
    "pensionKlant.waarde.nachten": "%s nachten",
    "pensionKlant.waarde.perDagBedrag": "%s / dag",
    "pensionKlant.activiteit.gewicht": "Gewicht geregistreerd",
    "pensionKlant.activiteit.medicatie": "Medicatie gestart",
    "pensionKlant.activiteit.notitie": "Notitie toegevoegd",
    "pensionKlant.activiteit.logboek": "Logboekregel",
    "pensionKlant.activiteit.geen": "Er is de laatste tijd niets vastgelegd.",
    "pensionKlant.activiteit.alle": "Alle activiteiten bekijken",
    "pensionKlant.verblijf.open": "Alle verblijven",
    "pensionKlant.resstatus.GEANNULEERD": "Geannuleerd",
    "pensionKlant.resstatus.AFGEROND": "Afgerond",
    "pensionKlant.resstatus.IN_PENSION": "In pension",
    "pensionKlant.resstatus.GEPLAND": "Gereserveerd",
    "pensionKlant.instellen.tegelsKnop": "Tegels instellen",
    "pensionKlant.instellen.tegelsTitel": "Tegels instellen",
    "pensionKlant.instellen.tegelsUitleg": "Kies welke tegels je ziet en in welke volgorde. Dit geldt voor elk dier.",
    "pensionKlant.instellen.lijstTitel": "Velden op het kaartje",
    "pensionKlant.instellen.lijstUitleg": "Kies wat je op een dierkaartje in de lijst ziet, en in welke volgorde. Dit geldt bij elke klant.",
    "pensionKlant.instellen.opKaartje": "Op het kaartje",
    "pensionKlant.instellen.nietsBeschikbaar": "Alles staat al op het kaartje",
    "pensionKlant.dieren.velden": "Velden op het kaartje kiezen",
    "pensionKlant.instellen.tegelTitel": "Tegel instellen: %s",
    "pensionKlant.instellen.hoe": "Hoe staat het erin",
    "pensionKlant.instellen.geenTegels": "Alle tegels staan uit. Zet ze terug met “Tegels instellen”.",
    "pensionKlant.instellen.verplaatst": "%s staat nu op plek %s van %s.",
    "pensionKlant.instellen.verplaatsAria": "Verplaats %s (pijltjestoetsen)",
    "pensionKlant.instellen.sleep": "Sleep om te verplaatsen",
    "pensionKlant.instellen.standaard": "Standaard herstellen",
    "pensionKlant.instellen.mislukt": "Opslaan is niet gelukt. Probeer het opnieuw.",
    "pensionKlant.regel.waarde": "Laatste gewicht",
    "pensionKlant.regel.datum": "Datum meting",
    "pensionKlant.regel.grafiek": "Grafiek",
    "pensionKlant.regel.kenmerken": "Kenmerken",
    "pensionKlant.regel.notitie": "Notitie bijzonderheden",
    "pensionKlant.instellen.sleepUitleg": "Sleep onderdelen op de tegel en in jouw volgorde. Sleep ze terug naar Beschikbaar om ze weg te halen.",
    "pensionKlant.instellen.opDeTegel": "Op de tegel",
    "pensionKlant.instellen.beschikbaar": "Beschikbaar",
    "pensionKlant.instellen.sleepHierheen": "Sleep hier onderdelen naartoe",
    "pensionKlant.instellen.allesErop": "Alles staat op de tegel",
    "pensionKlant.instellen.voegToeAria": "Zet %s op de tegel",
    "pensionKlant.instellen.haalWegAria": "Haal %s van de tegel",
    "pensionKlant.instellen.weggehaald": "%s is weggehaald.",
    "pensionKlant.instellen.voorbeeld": "Voorbeeld",
    "pensionKlant.instellen.zichtbaar": "In het overzicht",
    "pensionKlant.instellen.verborgen": "Verborgen",
    "pensionKlant.instellen.nietsVerborgen": "Geen verborgen tegels",
    "pensionKlant.instellen.toonAria": "Toon %s",
    "pensionKlant.instellen.verbergAria": "Verberg %s",
    "pensionKlant.instellen.opKaartjeAria": "Zet %s op het kaartje",
    "pensionKlant.instellen.vanKaartjeAria": "Haal %s van het kaartje",
    "pensionKlant.dieren.kiesEen": "Kies een dier om zijn gegevens te zien.",
    "pensionKlant.status.inPension": "In pension",
    "pensionKlant.status.geenReservering": "Geen reservering",
    // Elk kaartje eindigt in een doorgang naar het dierdossier, waar het onderwerp thuishoort.
    "pensionKlant.dier.gecastreerdJa": "Gecastreerd",
    "pensionKlant.dier.gecastreerdNee": "Niet gecastreerd",
    "pensionKlant.actie.naarFacturen": "Naar de openstaande facturen",
    // Werkmodus Pension — het overzicht "Wegen".
    "pensionModules.overzichten": "Overzichten",
    "pensionLijst.soort": "Soort",
    "pensionLijst.zoek": "Zoek op dier, klant of verblijf…",
    "pensionLijst.resultaten": "%s dier(en)",
    "menu.pensionWegen": "Wegen",
    "menu.pensionVoerlijst": "Voerlijst",
    "pensionVoerlijst.galerij": "Pension — voerlijst",
    "pensionVoerlijst.title": "Voerlijst",
    "pensionVoerlijst.subtitle": "Wat er wanneer in de bak gaat, en wie het gaf.",
    "pensionVoerlijst.loadFailed": "Kon de voerlijst niet laden.",
    "pensionVoerlijst.datum": "Datum",
    "pensionVoerlijst.vandaag": "Vandaag",
    "pensionVoerlijst.initialen": "Initialen",
    "pensionVoerlijst.gedrag": "Eetgedrag",
    "pensionVoerlijst.stickers": "Stickers afdrukken",
    "pensionVoerlijst.dagdeel": "Dagdeel",
    "pensionVoerlijst.dagdeel.ALLE": "Hele dag",
    "pensionVoerlijst.dagdeel.OCHTEND": "Ochtend",
    "pensionVoerlijst.dagdeel.MIDDAG": "Middag",
    "pensionVoerlijst.dagdeel.AVOND": "Avond",
    "pensionVoerlijst.teller.teVoeren": "Te voeren",
    "pensionVoerlijst.teller.gevoerd": "Gevoerd",
    "pensionVoerlijst.teller.achterstallig": "Achterstallig",
    "pensionVoerlijst.teller.zonderPlan": "Zonder voedingsplan",
    "pensionVoerlijst.leeg": "Geen voermomenten op deze datum.",
    "pensionVoerlijst.kolom.tijd": "Tijd",
    "pensionVoerlijst.kolom.dier": "Dier",
    "pensionVoerlijst.kolom.kennel": "Verblijf",
    "pensionVoerlijst.kolom.voer": "Voer",
    "pensionVoerlijst.kolom.hoeveelheid": "Hoeveelheid",
    "pensionVoerlijst.kolom.staat": "Staat",
    "pensionVoerlijst.kolom.afvinken": "Afvinken",
    "pensionVoerlijst.staat.GEPLAND": "Gepland",
    "pensionVoerlijst.staat.ACHTERSTALLIG": "Achterstallig",
    "pensionVoerlijst.staat.GEVOERD": "Gevoerd",
    "pensionVoerlijst.staat.GEEN_PLAN": "Geen voedingsplan",
    "pensionVoerlijst.gevoerd": "Gevoerd",
    "pensionVoerlijst.klaar": "Klaar",
    "pensionVoerlijst.geenPlan": "Eerst een plan vastleggen",
    "pensionVoerlijst.mislukt": "Opslaan is niet gelukt.",
    "pensionVoerlijst.gram.titel": "Gevoerd %s",
    "pensionVoerlijst.gram.uitleg":
        "Het plan zegt \"%s\" — daar staat geen getal in. Hoeveel gram ging er in de bak?",
    "pensionVoerlijst.gram.veld": "Gram",
    "pensionVoerlijst.sticker.titel": "Voerstickers",
    "pensionVoerlijst.sticker.tijden": "Tijden",
    "pensionVoerlijst.sticker.dieet": "Dieet",
    "pensionVoerlijst.sticker.notitie": "Let op",
    "menu.pensionMedicatie": "Medicatie",
    "pensionMedicatie.galerij": "Pension — medicatie",
    "pensionMedicatie.title": "Medicatie",
    "pensionMedicatie.subtitle": "Welke gift wanneer moet, en wie hem gaf.",
    "pensionMedicatie.loadFailed": "Kon de medicatielijst niet laden.",
    "pensionMedicatie.datum": "Datum",
    "pensionMedicatie.vandaag": "Vandaag",
    "pensionMedicatie.initialen": "Initialen",
    "pensionMedicatie.soort": "Diersoort",
    "pensionMedicatie.soort.ALLE": "Alle",
    "pensionMedicatie.soort.HOND": "Honden",
    "pensionMedicatie.soort.KAT": "Katten",
    "pensionMedicatie.soort.OVERIG": "Overig",
    "pensionMedicatie.teller.teGeven": "Te geven",
    "pensionMedicatie.teller.gegeven": "Gegeven",
    "pensionMedicatie.teller.achterstallig": "Achterstallig",
    "pensionMedicatie.teller.dieren": "Dieren",
    "pensionMedicatie.leeg": "Geen medicatie bij de gasten op deze datum.",
    "pensionMedicatie.kolom.tijd": "Tijd",
    "pensionMedicatie.kolom.dier": "Dier",
    "pensionMedicatie.kolom.kennel": "Verblijf",
    "pensionMedicatie.kolom.medicijn": "Medicijn",
    "pensionMedicatie.kolom.dosering": "Dosering",
    "pensionMedicatie.kolom.staat": "Staat",
    "pensionMedicatie.kolom.afvinken": "Afvinken",
    "pensionMedicatie.staat.GEPLAND": "Gepland",
    "pensionMedicatie.staat.ACHTERSTALLIG": "Achterstallig",
    "pensionMedicatie.staat.GEGEVEN": "Gegeven",
    "pensionMedicatie.gegeven": "Gegeven",
    "pensionMedicatie.klaar": "Klaar",
    "pensionMedicatie.mislukt": "Opslaan is niet gelukt.",
    "menu.pensionBorstelen": "Borstelen",
    "pensionBorstelen.galerij": "Pension — borstelen",
    "pensionBorstelen.title": "Borstelen",
    "pensionBorstelen.subtitle": "Wie er vandaag geborsteld moet worden, op de frequentie die de klant vroeg.",
    "pensionBorstelen.loadFailed": "Kon de borstellijst niet laden.",
    "pensionBorstelen.datum": "Datum",
    "pensionBorstelen.vandaag": "Vandaag",
    "pensionBorstelen.initialen": "Initialen",
    "pensionBorstelen.soort": "Diersoort",
    "pensionBorstelen.soort.ALLE": "Alle",
    "pensionBorstelen.soort.HOND": "Honden",
    "pensionBorstelen.soort.KAT": "Katten",
    "pensionBorstelen.soort.OVERIG": "Overig",
    "pensionBorstelen.teller.teDoen": "Te borstelen",
    "pensionBorstelen.teller.gedaan": "Gedaan",
    "pensionBorstelen.teller.bijzonderheid": "Iets gezien",
    "pensionBorstelen.teller.zonderFrequentie": "Zonder frequentie",
    "pensionBorstelen.leeg": "Geen gasten op deze datum.",
    "pensionBorstelen.kolom.dier": "Dier",
    "pensionBorstelen.kolom.klant": "Klant",
    "pensionBorstelen.kolom.kennel": "Verblijf",
    "pensionBorstelen.kolom.frequentie": "Frequentie",
    "pensionBorstelen.kolom.laatst": "Laatst geborsteld",
    "pensionBorstelen.kolom.reden": "Vandaag",
    "pensionBorstelen.kolom.afvinken": "Afvinken",
    "pensionBorstelen.frequentieVoor": "Borstelfrequentie voor %s",
    "pensionBorstelen.geenFrequentie": "Niet opgegeven",
    "pensionBorstelen.reden.GEEN_FREQUENTIE": "Geen frequentie",
    "pensionBorstelen.reden.VOLGENS_SCHEMA": "Aan de beurt",
    "pensionBorstelen.reden.ONBEKEND_SCHEMA": "Frequentie onleesbaar",
    "pensionBorstelen.reden.NIET_VANDAAG": "Niet vandaag",
    "pensionBorstelen.reden.GEDAAN": "Vandaag gedaan",
    "pensionBorstelen.gedaan": "Geborsteld",
    "pensionBorstelen.bijzonderheid": "Iets gezien",
    "pensionBorstelen.bijzonderheid.titel": "Borstelen %s",
    "pensionBorstelen.bijzonderheid.wat": "Wat heb je gezien?",
    "pensionBorstelen.mislukt": "Opslaan is niet gelukt.",
    "menu.pensionBodycheck": "Bodycheck",
    "pensionBodycheck.galerij": "Pension — bodycheck",
    "pensionBodycheck.title": "Bodycheck",
    "pensionBodycheck.subtitle": "Wie er nagelopen moet worden, en wat er de vorige keer gezien is.",
    "pensionBodycheck.loadFailed": "Kon de bodychecklijst niet laden.",
    "pensionBodycheck.datum": "Datum",
    "pensionBodycheck.vandaag": "Vandaag",
    "pensionBodycheck.initialen": "Initialen",
    "pensionBodycheck.soort": "Diersoort",
    "pensionBodycheck.soort.ALLE": "Alle",
    "pensionBodycheck.soort.HOND": "Honden",
    "pensionBodycheck.soort.KAT": "Katten",
    "pensionBodycheck.soort.OVERIG": "Overig",
    "pensionBodycheck.teller.teDoen": "Na te lopen",
    "pensionBodycheck.teller.gedaan": "Gedaan",
    "pensionBodycheck.teller.bijzonderheid": "Iets gezien",
    "pensionBodycheck.teller.nooitGedaan": "Nog niet nagelopen",
    "pensionBodycheck.leeg": "Geen gasten op deze datum.",
    "pensionBodycheck.kolom.dier": "Dier",
    "pensionBodycheck.kolom.klant": "Klant",
    "pensionBodycheck.kolom.kennel": "Verblijf",
    "pensionBodycheck.kolom.laatst": "Laatst nagelopen",
    "pensionBodycheck.kolom.bevinding": "Bevinding",
    "pensionBodycheck.kolom.reden": "Reden",
    "pensionBodycheck.kolom.afvinken": "Afvinken",
    "pensionBodycheck.reden.NOOIT_GEDAAN": "Nog niet nagelopen",
    "pensionBodycheck.reden.INTERVAL": "Aan de beurt",
    "pensionBodycheck.reden.DAG_VOOR_VERTREK": "Dag voor vertrek",
    "pensionBodycheck.reden.GEDAAN": "Nagelopen",
    "pensionBodycheck.bevinding.OK": "Niets aan de hand",
    "pensionBodycheck.bevinding.BIJZONDERHEID": "Iets gezien",
    "pensionBodycheck.ok": "Niets aan de hand",
    "pensionBodycheck.bijzonderheid": "Iets gezien",
    "pensionBodycheck.bijzonderheid.titel": "Bodycheck %s",
    "pensionBodycheck.bijzonderheid.wat": "Wat heb je gezien?",
    "pensionBodycheck.mislukt": "Opslaan is niet gelukt.",
    "pensionBodycheck.instellingen.knop": "Bodycheck-instellingen",
    "pensionBodycheck.instellingen.titel": "Bodycheck-instellingen",
    "pensionBodycheck.instellingen.uitleg":
        "Om de hoeveel dagen een pensiondier wordt nagelopen, per vestiging.",
    "pensionBodycheck.instellingen.interval": "Elke … dagen nalopen",
    "pensionBodycheck.instellingen.dagVoorVertrek": "Ook de dag voor vertrek nalopen",
    "pensionBodycheck.instellingen.mislukt": "Kon de instellingen niet opslaan.",
    "pensionWegen.galerij": "Pension — wegen",
    "pensionWegen.title": "Wegen",
    "pensionWegen.subtitle": "Wie moet er op de weegschaal, en waar het gewicht om actie vraagt.",
    "pensionWegen.loadFailed": "Kon de weeglijst niet laden.",
    "pensionWegen.datum": "Datum",
    "pensionWegen.vandaag": "Vandaag",
    "pensionWegen.soort": "Diersoort",
    "pensionWegen.soort.ALLE": "Alle",
    "pensionWegen.soort.HOND": "Honden",
    "pensionWegen.soort.KAT": "Katten",
    "pensionWegen.soort.OVERIG": "Overig",
    "pensionWegen.teller.teWegen": "Te wegen",
    "pensionWegen.teller.gewogen": "Gewogen",
    "pensionWegen.teller.actieNodig": "Actie nodig",
    "pensionWegen.teller.zonderStart": "Zonder startgewicht",
    "pensionWegen.leeg": "Geen gasten op deze datum.",
    "pensionWegen.kolom.dier": "Dier",
    "pensionWegen.kolom.klant": "Klant",
    "pensionWegen.kolom.kennel": "Verblijf",
    "pensionWegen.kolom.laatst": "Laatst gewogen",
    "pensionWegen.kolom.gewicht": "Gewicht",
    "pensionWegen.kolom.verschil": "Verschil",
    "pensionWegen.kolom.reden": "Reden",
    "pensionWegen.kolom.registreren": "Registreren",
    "pensionWegen.reden.GEEN_STARTGEWICHT": "Geen startgewicht",
    "pensionWegen.reden.INTERVAL": "Aan de beurt",
    "pensionWegen.reden.DAG_VOOR_VERTREK": "Dag voor vertrek",
    "pensionWegen.reden.GEWOGEN": "Gewogen",
    "pensionWegen.kg": "kg",
    "pensionWegen.kgVoor": "Gewicht in kg voor %s",
    "pensionWegen.opslaan": "Opslaan",
    "pensionWegen.instellingen.knop": "Weeginstellingen",
    "pensionWegen.instellingen.titel": "Weeginstellingen",
    "pensionWegen.instellingen.uitleg":
      "Elk pension weegt anders, dus deze gelden alleen voor deze vestiging.",
    "pensionWegen.instellingen.interval": "Wegen om de … dagen",
    "pensionWegen.instellingen.dagVoorVertrek": "Ook wegen op de dag vóór vertrek",
    "pensionWegen.instellingen.drempelLicht": "Actie nodig boven … % (onder de gewichtsgrens)",
    "pensionWegen.instellingen.drempelZwaar": "Actie nodig boven … % (vanaf de gewichtsgrens)",
    "pensionWegen.instellingen.grens": "Gewichtsgrens (kg)",
    "pensionWegen.instellingen.mislukt": "Kon de instellingen niet opslaan.",
    // Instellingen-dashboard (port van de Jmix SettingsDashboardView — route `instellingen`).
    "instellingen.title": "Instellingen",
    "instellingen.contextLabel": "Instellingen voor:",
    "instellingen.context.organization": "Organisatie",
    "instellingen.activeContext": "Actieve context: %s",
    "instellingen.section.algemeen": "Algemeen",
    "instellingen.section.dieren": "Dieren",
    "instellingen.tile.advertentie.title": "Advertentie",
    "instellingen.tile.advertentie.desc": "Op welk platform de advertenties terechtkomen — in één keer voor alle asielen",
    "instellingen.advertentie.uitleg": "Geldt voor alle asielen van deze organisatie. De live preview bij het dier laat zien hoe de advertentie op het gekozen platform komt te staan.",
    "instellingen.advertentie.kanaal.DIERMATCH": "DierMatch.nl",
    "instellingen.advertentie.kanaal.DIERMATCH.uitleg": "Voor asielen die op DierMatch.nl publiceren.",
    "instellingen.advertentie.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "instellingen.advertentie.kanaal.IKZOEKBAAS.uitleg": "Het platform van de Dierenbescherming.",
    "instellingen.advertentie.kanaal.BEIDE": "Allebei",
    "instellingen.advertentie.kanaal.BEIDE.uitleg": "De preview laat je kiezen welke van de twee je bekijkt.",
    "instellingen.advertentie.fout": "De instellingen konden niet worden opgeslagen. Probeer het opnieuw.",
    "instellingen.advertentie.afvoeren": "Dieren automatisch van de site halen",
    "instellingen.advertentie.afvoerenUitleg":
      "Een dier op de site zetten blijft mensenwerk. Dit gaat alleen over het einde: zodra een dier de opvang uit is, verdwijnt het vanzelf.",
    "instellingen.advertentie.geplaatstDagen": "Nog zichtbaar als \"Geplaatst\" (dagen)",
    "instellingen.advertentie.geplaatstDagenUitleg":
      "Een geplaatst dier blijft zoveel dagen als \"Geplaatst\" op de site staan en gaat er daarna af. Vertrekt een dier om een andere reden, dan gaat het er meteen af.",
    "instellingen.advertentie.geplaatstDagenNul":
      "Een geplaatst dier gaat meteen van de site af.",
    "instellingen.advertentie.nieuwDagen": "Te zien als \"Nieuw in het asiel\" (dagen)",
    "instellingen.advertentie.nieuwDagenUitleg":
      "Zoveel dagen na opname draagt het dier het lint \"Nieuw in het asiel\"; daarna leest het als \"Zoekt een thuis\".",
    "instellingen.advertentie.nieuwDagenNul":
      "Geen enkel dier heet nieuw; het lint leest meteen \"Zoekt een thuis\".",
    "instellingen.advertentie.contactTekst": "Tekst onder \"Neem contact op\"",
    "instellingen.advertentie.contactHint": "bijv. Bel ons of loop binnen tijdens de openingstijden; een afspraak is niet nodig.",
    "advertentieDetailView.preview.kanaal": "Platform",
    "advertentieDetailView.site.aan": "staat erop",
    "advertentieDetailView.site.uit": "staat er niet op",
    "advertentieDetailView.kanaal.label": "Op welke site",
    "advertentieDetailView.kanaal.uitleg": "Kies waar dit dier komt te staan; de instelling van de organisatie geldt alleen voor een nieuwe advertentie.",
    "advertentieDetailView.kanaal.DIERMATCH": "DierMatch.nl",
    "advertentieDetailView.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieDetailView.kanaal.BEIDE": "Allebei",
    "advertentieDetailView.preview.kanaal.DIERMATCH": "DierMatch.nl",
    "advertentieDetailView.preview.kanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieIkzoekbaas.dieren": "Dieren",
    "advertentieIkzoekbaas.andereDieren": "Andere dieren op deze locatie",
    "advertentieIkzoekbaas.deelProfiel": "Deel profiel van %s",
    "advertentieIkzoekbaas.deelTekst": "Ik zoek een baas! Vertel het door aan je partner, huisgenoot, vrienden en familie.",
    "advertentieIkzoekbaas.kenmerken": "Kenmerken",
    "advertentieIkzoekbaas.stap1": "Stap 1: Ontdek of ik bij je pas",
    "advertentieIkzoekbaas.stap2": "Stap 2: Ken onze tarieven",
    "advertentieIkzoekbaas.naarWebsite": "Naar de tarieven",
    "advertentieIkzoekbaas.onbekend": "Onbekend",
    "advertentieIkzoekbaas.kenmerkenInvullen": "Deze vragen invullen",
    "advertentieIkzoekbaas.fotos": "Foto's beheren",
    "advertentieIkzoekbaas.doneer": "DONEER",
    "advertentieIkzoekbaas.ig.likes": "Leuk gevonden door dierenbescherming en anderen",
    "advertentieIkzoekbaas.ig.meer": "… meer",
    "advertentieIkzoekbaas.ig.tijd": "Zojuist",
    "advertentieDetailView.publicatie.leeg": "Nog niet gepubliceerd.",
    "advertentieIkzoekbaas.neemContact": "Neem contact op",
    "advertentieIkzoekbaas.stap3": "Stap 3: Neem contact op",
    "advertentieIkzoekbaas.stap3.tekst": "Denk je dat %s bij je past? Neem dan contact op met de opvang.",
    "advertentieIkzoekbaas.geenTekst": "Er is nog geen tekst over dit dier ingevuld.",
    "instellingen.section.financieel": "Financieel",
    "instellingen.cta.open": "Openen ›",
    "instellingen.comingSoon.body":
      "Deze instelling wordt naar het nieuwe platform gemigreerd en is hier nog niet beschikbaar. Gebruik voorlopig de klassieke weergave.",
    "instellingen.comingSoon.items": "Bevat:",
    // Gemeente-tegel detail (settings-gemeente — de eerste gemigreerde tegel).
    "instellingen.gemeente.title": "Gemeenten & woonplaatsen",
    "instellingen.gemeente.searchLabel": "Zoeken",
    "instellingen.gemeente.searchPlaceholder": "Naam, provincie of woonplaats…",
    "instellingen.gemeente.filterLabel": "Status",
    "instellingen.gemeente.filter.all": "Alle",
    "instellingen.gemeente.filter.active": "Actief",
    "instellingen.gemeente.filter.inactive": "Inactief",
    "instellingen.gemeente.new": "Nieuwe gemeente",
    "instellingen.gemeente.col.naam": "Naam",
    "instellingen.gemeente.col.provincie": "Provincie",
    "instellingen.gemeente.col.status": "Status",
    "instellingen.gemeente.col.woonplaatsen": "Woonplaatsen",
    "instellingen.gemeente.status.active": "Actief",
    "instellingen.gemeente.status.inactive": "Inactief",
    "instellingen.gemeente.empty": "Geen gemeenten gevonden.",
    "instellingen.gemeente.loadFailed": "Kon gemeenten niet laden.",
    "instellingen.gemeente.detail.empty": "Selecteer een gemeente om de details te bekijken.",
    "instellingen.gemeente.detail.edit": "Wijzigen",
    "instellingen.gemeente.detail.delete": "Verwijderen",
    "instellingen.gemeente.detail.active": "Actief",
    "instellingen.gemeente.delete.confirm": "Weet je zeker dat je gemeente \"%s\" wilt verwijderen?",
    "instellingen.gemeente.create.title": "Nieuwe gemeente",
    "instellingen.gemeente.edit.title": "Gemeente wijzigen",
    "instellingen.gemeente.form.naam": "Naam",
    "instellingen.gemeente.form.provincie": "Provincie",
    "instellingen.gemeente.woonplaatsen.title": "Woonplaatsen",
    "instellingen.gemeente.woonplaatsen.add": "Woonplaats toevoegen",
    "instellingen.gemeente.woonplaatsen.edit": "Wijzigen",
    "instellingen.gemeente.woonplaatsen.delete": "Verwijderen",
    "instellingen.gemeente.woonplaatsen.empty": "Nog geen woonplaatsen.",
    "instellingen.gemeente.woonplaatsen.label": "Woonplaats",
    "instellingen.gemeente.woonplaatsen.col.naam": "Woonplaats",
    "instellingen.gemeente.woonplaatsen.col.actions": "Acties",
    "instellingen.gemeente.error.nameRequired": "Naam is verplicht.",
    "instellingen.gemeente.error.duplicateNaam": "Deze gemeente bestaat al.",
    "instellingen.gemeente.error.townRequired": "Woonplaats is verplicht.",
    "instellingen.gemeente.error.duplicateWoonplaats": "Deze woonplaats bestaat al.",
    "instellingen.tile.animals.title": "Dieren",
    "instellingen.tile.animals.desc": "Beheer stamgegevens voor dieren",
    "instellingen.tile.breedWeights.title": "Gewichtsbandbreedtes",
    "instellingen.tile.breedWeights.desc": "Beheer verwachte gewichtsbandbreedtes per ras",
    "instellingen.item.breedWeights.bands": "Bandbreedtes per leeftijdsblok",
    "instellingen.item.breedWeights.ai": "AI-voorstellen",
    "instellingen.item.breedWeights.review": "Nakijken & activeren",
    "instellingen.gewichtsbandbreedte.title": "Gewichtsbandbreedtes",
    "instellingen.gewichtsbandbreedte.subtitle": "Scope: %s",
    "instellingen.gewichtsbandbreedte.noAccess": "Je hebt geen rechten om gewichtsbandbreedtes te beheren.",
    "instellingen.gewichtsbandbreedte.speciesLabel": "Diersoort",
    "instellingen.gewichtsbandbreedte.breedLabel": "Ras",
    "instellingen.gewichtsbandbreedte.choosBreed": "Kies een ras…",
    "instellingen.gewichtsbandbreedte.pickBreedHint": "Kies een diersoort en ras om de gewichtsbandbreedtes te beheren.",
    "instellingen.gewichtsbandbreedte.add": "Regel toevoegen",
    "instellingen.gewichtsbandbreedte.edit": "Wijzigen",
    "instellingen.gewichtsbandbreedte.remove": "Deactiveren",
    "instellingen.gewichtsbandbreedte.review": "Activeer + accordeer",
    "instellingen.gewichtsbandbreedte.aiSuggest": "AI-voorstel genereren",
    "instellingen.gewichtsbandbreedte.create": "Bandbreedte toevoegen",
    "instellingen.gewichtsbandbreedte.editTitle": "Bandbreedte wijzigen",
    "instellingen.gewichtsbandbreedte.saved": "Regel opgeslagen.",
    "instellingen.gewichtsbandbreedte.deactivated": "Regel gedeactiveerd.",
    "instellingen.gewichtsbandbreedte.activated": "Regel geaccordeerd en geactiveerd.",
    "instellingen.gewichtsbandbreedte.aiBusy": "AI-voorstel genereren…",
    "instellingen.gewichtsbandbreedte.aiAdded": "%s AI-conceptregel(s) toegevoegd (nog niet gereviewd).",
    "instellingen.gewichtsbandbreedte.aiNone": "AI heeft geen betrouwbaar voorstel voor dit ras geleverd.",
    "instellingen.gewichtsbandbreedte.empty": "Nog geen regels voor dit ras.",
    "instellingen.gewichtsbandbreedte.conceptHint": "AI-conceptregels zijn inactief en niet gereviewd; ze worden pas voor de grafiek gebruikt na accorderen.",
    "instellingen.gewichtsbandbreedte.months": "mnd",
    "instellingen.gewichtsbandbreedte.col.age": "Leeftijd",
    "instellingen.gewichtsbandbreedte.col.sex": "Geslacht",
    "instellingen.gewichtsbandbreedte.col.neutered": "Gecastreerd",
    "instellingen.gewichtsbandbreedte.col.min": "Min (kg)",
    "instellingen.gewichtsbandbreedte.col.ideal": "Ideaal (kg)",
    "instellingen.gewichtsbandbreedte.col.max": "Max (kg)",
    "instellingen.gewichtsbandbreedte.col.source": "Bron",
    "instellingen.gewichtsbandbreedte.col.confidence": "Betrouwbaarheid",
    "instellingen.gewichtsbandbreedte.col.status": "Status",
    "instellingen.gewichtsbandbreedte.col.scope": "Scope",
    "instellingen.gewichtsbandbreedte.status.ACTIEF": "Actief",
    "instellingen.gewichtsbandbreedte.status.CONCEPT": "Concept — nog niet nagekeken",
    "instellingen.gewichtsbandbreedte.status.INACTIEF": "Inactief",
    "instellingen.gewichtsbandbreedte.scope.platform": "Platform",
    "instellingen.gewichtsbandbreedte.scope.vestiging": "Vestiging",
    "instellingen.gewichtsbandbreedte.field.ageFrom": "Leeftijd vanaf (maanden)",
    "instellingen.gewichtsbandbreedte.field.ageTo": "Leeftijd t/m (maanden)",
    "instellingen.gewichtsbandbreedte.field.sex": "Geslacht (leeg = beide)",
    "instellingen.gewichtsbandbreedte.field.neutered": "Castratie (leeg = beide)",
    "instellingen.gewichtsbandbreedte.field.both": "Beide",
    "instellingen.gewichtsbandbreedte.field.min": "Minimum gewicht (kg)",
    "instellingen.gewichtsbandbreedte.field.ideal": "Ideaal gewicht (kg, optioneel)",
    "instellingen.gewichtsbandbreedte.field.max": "Maximum gewicht (kg)",
    "instellingen.gewichtsbandbreedte.field.confidence": "Betrouwbaarheid",
    "instellingen.gewichtsbandbreedte.field.sourceName": "Bron-naam",
    "instellingen.gewichtsbandbreedte.field.sourceUrl": "Bron-URL",
    "instellingen.gewichtsbandbreedte.field.changeReason": "Reden wijziging (optioneel)",
    "instellingen.gewichtsbandbreedte.field.actief": "Actief",
    "instellingen.gewichtsbandbreedte.field.reviewed": "Gereviewd",
    "instellingen.gewichtsbandbreedte.err.age": "Vul een geldig leeftijdsblok in (vanaf ≤ t/m, beide ≥ 0).",
    "instellingen.gewichtsbandbreedte.err.minmaxRequired": "Minimum en maximum gewicht zijn verplicht.",
    "instellingen.gewichtsbandbreedte.err.positive": "Gewichten moeten groter zijn dan 0.",
    "instellingen.gewichtsbandbreedte.err.minLtMax": "Minimum moet kleiner zijn dan maximum.",
    "instellingen.gewichtsbandbreedte.err.idealBetween": "Ideaal-gewicht moet tussen minimum en maximum liggen.",
    "instellingen.tile.gemeente.title": "Gemeente",
    "instellingen.tile.gemeente.desc": "Beheer de lijst van gemeenten",
    "instellingen.tile.finance.title": "Financieel",
    "instellingen.tile.finance.desc": "Configureer boekhouding en grootboek",
    "instellingen.tile.communication.title": "Communicatie & contracten",
    "instellingen.tile.communication.desc": "Beheer contracten en e-mailtemplates",
    "instellingen.tile.integrations.title": "Koppelingen",
    "instellingen.tile.integrations.desc": "Beheer externe integraties",
    "instellingen.tile.pension.title": "Pension",
    "instellingen.tile.pension.desc": "Beheer pensionregels en capaciteit",
    "instellingen.tile.pleeggezinnen.title": "Pleeggezinnen",
    "instellingen.tile.pleeggezinnen.desc": "Beheer pleeggezinnen en opvanginstellingen",
    "instellingen.tile.taken.title": "Taken",
    "instellingen.tile.taken.desc": "Automatische taakregels, deadline-regels en takenpakketten",
    "instellingen.tile.wizards.title": "Registraties & Wizards",
    "instellingen.tile.wizards.desc": "Configureerbare registratiewizards met dynamische tegel",
    "instellingen.item.vacht": "Vacht",
    "instellingen.item.kleur": "Kleur",
    "instellingen.item.kenneleigenschap": "Verblijfeigenschap",
    "instellingen.item.ras": "Ras",
    "instellingen.item.gemeente": "Gemeente",
    "instellingen.item.koppelingBoekhouding": "Koppeling boekhouding",
    "instellingen.item.grootboeknummers": "Grootboeknummers",
    "instellingen.item.afdrukken": "Afdrukken",
    "instellingen.item.contracten": "Contracten",
    "instellingen.item.emailBerichten": "Email berichten",
    "instellingen.item.aiKoppeling": "AI koppeling",
    "instellingen.item.berekeningPension": "Berekening pension",
    "instellingen.item.hoogseizoenDagen": "Hoogseizoen dagen",
    "instellingen.item.capaciteit": "Capaciteit",
    "instellingen.item.accommodaties": "Accommodatietypes",
    "instellingen.item.pensionVol": "Pension vol",
    "instellingen.pension.pensionVol.desc": "Dagen waarop het pension vol zit voor een diersoort; voor die dieren kun je dan niet boeken",
    "instellingen.item.opvangcategorieen": "Opvangcategorieën",
    "instellingen.item.vestigingSpecifiek": "Vestiging-specifiek",
    "instellingen.item.boekhouden": "Boekhouden",
    "instellingen.item.grootboek": "Grootboek",
    "instellingen.item.mailLayout": "Mail lay-out",
    "instellingen.item.idealMollie": "iDEAL/Mollie",
    "instellingen.item.pinapparaat": "Pinapparaat",
    "instellingen.item.petbase": "PetBase",
    "instellingen.item.automatischeTaken": "Automatische taken",
    "instellingen.item.wizardsBeheren": "Wizards beheren",
    "instellingen.ai.title": "AI koppeling",
    "instellingen.tile.platform.title": "Platformkoppeling",
    "instellingen.tile.platform.desc": "Koppel deze backoffice aan het Fawkes-platform (pleeggezinnen, afwezigheden, nazorg, DierMatch).",
    "instellingen.item.platformKoppeling": "Koppelen & verbinding testen",
    "platformKoppeling.title": "Platformkoppeling",
    "platformKoppeling.description": "De verbinding met het Fawkes-platform. Koppel met een code van het platform en test hier beide richtingen.",
    "platformKoppeling.loadFailed": "De platformkoppeling kon niet geladen worden.",
    "platformKoppeling.status.connected": "Gekoppeld",
    "platformKoppeling.status.legacy": "Uit de applicatie-instellingen",
    "platformKoppeling.status.none": "Niet gekoppeld",
    "platformKoppeling.origin.PAIRING": "gekoppeld met een code",
    "platformKoppeling.origin.MANUAL": "handmatig ingevoerd",
    "platformKoppeling.field.platform": "Platform",
    "platformKoppeling.field.organization": "Organisatie-ID",
    "platformKoppeling.field.clientId": "Client-ID",
    "platformKoppeling.field.secret": "Geheim",
    "platformKoppeling.field.features": "Functies",
    "platformKoppeling.field.updated": "Laatst gewijzigd",
    "platformKoppeling.feature.FOSTER_WEBHOOKS": "Pleeggezinnen",
    "platformKoppeling.feature.ABSENCES": "Afwezigheden",
    "platformKoppeling.feature.NAZORG": "Nazorg",
    "platformKoppeling.feature.PUBLICATIONS": "DierMatch",
    "platformKoppeling.feature.WHATSAPP": "WhatsApp",
    "platformKoppeling.test": "Verbinding testen",
    "platformKoppeling.unpair": "Ontkoppelen",
    "platformKoppeling.unpair.confirm": "De opgeslagen koppeling verwijderen? Dan gelden weer de applicatie-instellingen.",
    "platformKoppeling.unpaired": "De opgeslagen koppeling is verwijderd.",
    "platformKoppeling.pair.title": "Koppelen met het platform",
    "platformKoppeling.pair.intro": "Een beheerder van het platform maakt een koppelcode voor deze organisatie. Plak die hier; de code is kort geldig en werkt één keer. De huidige koppeling blijft werken tot de nieuwe is bevestigd.",
    "platformKoppeling.pair.code": "Koppelcode",
    "platformKoppeling.pair.backofficeUrl": "Adres van deze backoffice",
    "platformKoppeling.pair.backofficeUrl.help": "Het platform roept deze backoffice op dit adres aan.",
    "platformKoppeling.pair.redeem": "Code inwisselen",
    "platformKoppeling.pending.title": "Koppeling bevestigen",
    "platformKoppeling.pending.intro": "Het platform heeft de code geaccepteerd. Sta de adressen van het platform toe en bevestig; het platform controleert dan of het deze backoffice kan bereiken.",
    "platformKoppeling.pending.confirmBefore": "Bevestigen vóór %s.",
    "platformKoppeling.pending.egress": "Toe te staan platformadressen",
    "platformKoppeling.pending.noEgress": "Het platform gaf geen adressen door. Vul het adres in waarvandaan het belt, of bevestig en sta het geweigerde adres daarna toe.",
    "platformKoppeling.pending.extraIp": "Ander adres (optioneel)",
    "platformKoppeling.pending.confirm": "Bevestigen",
    "platformKoppeling.pending.cancel": "Koppeling annuleren",
    "platformKoppeling.confirmed": "De koppeling is actief.",
    "platformKoppeling.confirmFailed": "Het platform kon deze backoffice niet bereiken: %s",
    "platformKoppeling.rejections.title": "Recent geweigerde tokenaanvragen",
    "platformKoppeling.rejections.none": "Geen geweigerde aanvragen.",
    "platformKoppeling.rejections.allowAndRetry": "%s toestaan en opnieuw bevestigen",
    "platformKoppeling.test.title": "Testresultaat",
    "platformKoppeling.test.column.check": "Controle",
    "platformKoppeling.test.column.status": "Resultaat",
    "platformKoppeling.test.column.detail": "Toelichting",
    "platformKoppeling.test.check.OUTBOUND": "Backoffice → platform",
    "platformKoppeling.test.check.ORGANIZATION": "Organisatie",
    "platformKoppeling.test.check.INBOUND": "Platform → backoffice",
    "platformKoppeling.test.status.OK": "In orde",
    "platformKoppeling.test.status.FAILED": "Mislukt",
    "platformKoppeling.test.status.SKIPPED": "Overgeslagen",
    "platformKoppeling.test.callerIp": "Het platform ziet deze backoffice als %s.",
    "platformKoppeling.error.generic": "Het verzoek is mislukt.",
    "tokenRejection.column.time": "Tijdstip",
    "tokenRejection.column.reason": "Reden",
    "tokenRejection.column.ip": "IP-adres aanroeper",
    "tokenRejection.reason.ip_mismatch": "Adres niet toegestaan",
    "tokenRejection.reason.bad_secret": "Onjuist geheim",
    "tokenRejection.reason.removed_credential": "Sleutel verwijderd",
    "tokenRejection.reason.expired_credential": "Sleutel verlopen",
    "tokenRejection.reason.disabled_account": "Account uitgeschakeld",
    "tokenRejection.reason.no_authorities": "Geen rollen",
    "tokenRejection.allowIp": "IP toevoegen",
    "tokenRejection.proxyAddress": "Proxy-adres — niet toe te staan",
    "tokenRejection.proxyAddress.help": "Een of meer weigeringen komen van een intern adres (zoals 0:0:0:0:0:0:0:1 of 127.0.0.1). Dat is de eigen reverse proxy van deze backoffice, niet de echte aanroeper: dat adres toestaan laat iedere aanroeper door. Stel fawkes.api.service-account-token.trusted-proxies in (bijvoorbeeld 127.0.0.1/32,::1/128) en herstart de backoffice; dan verschijnt hier het echte adres.",
    "serviceAccountDetailView.credentials.column.lastUsedIp": "Laatste IP",
    "serviceAccountDetailView.rejections.title": "Geweigerde tokenaanvragen (laatste 7 dagen)",
    "serviceAccountDetailView.rejections.none": "Geen geweigerde aanvragen.",
    "instellingen.ai.description":
      "Kies welke AI-provider standaard antwoordt, en een optionele fallback wanneer deze niet beschikbaar is.",
    "instellingen.ai.defaultProvider": "Standaardprovider",
    "instellingen.ai.fallbackEnabled": "Fallback inschakelen",
    "instellingen.ai.fallbackProvider": "Fallbackprovider",
    "instellingen.ai.saved": "Instellingen opgeslagen.",
    "instellingen.ai.loadFailed": "De AI-instellingen konden niet worden geladen.",
    "instellingen.ai.providersTitle": "API-sleutels per provider",
    "instellingen.ai.providersDescription":
      "Stel per AI-provider de API-sleutel en het model in. Laat de sleutel leeg om de opgeslagen sleutel te behouden.",
    "instellingen.ai.field.apiKey": "API-sleutel",
    "instellingen.ai.field.apiKey.keep": "Laat leeg om de opgeslagen sleutel te behouden",
    "instellingen.ai.field.model": "Model",
    "instellingen.ai.modellen.kies": "Kies een model…",
    "instellingen.ai.modellen.onbekend": "%s — wordt niet aangeboden",
    "instellingen.ai.modellen.onbekendUitleg": "Deze aanbieder kent \"%s\" niet. Kies er een uit de lijst, anders blijven de aanroepen mislukken.",
    "instellingen.ai.modellen.mislukt": "De modellen konden niet opgehaald worden; typ de naam zelf.",
    "instellingen.ai.modellen.eerstSleutel": "Vul een API-sleutel in en sla op; daarna kunnen de modellen opgehaald worden.",
    "instellingen.ai.field.enabled": "Ingeschakeld",
    "instellingen.ai.providerSaved": "Sleutel opgeslagen.",
    "instellingen.communicatie.subtitle":
      "Beheer contracten, afdrukken en e-mailtemplates. Templates kunnen per vestiging aangepast worden indien toegestaan.",
    "instellingen.communicatie.search": "Zoek",
    "instellingen.communicatie.empty": "Geen items.",
    "instellingen.communicatie.breadcrumb.organisatie": "Organisatie",
    "instellingen.communicatie.breadcrumb.vestiging": "Vestiging",
    "instellingen.communicatie.column.naam": "Naam",
    "instellingen.communicatie.column.pad": "Pad",
    "instellingen.communicatie.column.volgorde": "Volgorde",
    "instellingen.communicatie.column.acties": "Acties",
    "instellingen.communicatie.column.onderwerp": "Onderwerp",
    "instellingen.communicatie.column.ontvanger": "Ontvanger",
    "instellingen.communicatie.column.type": "Type",
    "instellingen.communicatie.column.nummer": "Nummer",
    "instellingen.communicatie.column.vestiging": "Vestiging",
    "instellingen.communicatie.column.dagenPerWeek": "Dagen/week",
    "instellingen.communicatie.column.periode": "Periode",
    "instellingen.communicatie.column.status": "Status",
    "instellingen.communicatie.type.email": "E-mail",
    "instellingen.communicatie.type.afdruk": "Afdruk",
    "instellingen.communicatie.status.actief": "Actief",
    "instellingen.communicatie.status.geannuleerd": "Geannuleerd",
    "instellingen.communicatie.periode.onbeperkt": "Onbeperkt",
    "instellingen.communicatie.add.afdruk": "Nieuwe afdruk",
    "instellingen.communicatie.edit.afdruk": "Afdruk bewerken",
    "instellingen.communicatie.edit.email": "E-mailbericht bewerken",
    "instellingen.communicatie.mailLayout.readOnly":
      "Deze vestiging mag de mail lay-out van de organisatie niet aanpassen.",
    "instellingen.communicatie.field.naam": "Naam",
    "instellingen.communicatie.field.pad": "Pad (JasperReports-template)",
    "instellingen.communicatie.field.rapportinstelling": "Rapportinstelling",
    "instellingen.communicatie.field.kies": "Kies…",
    "instellingen.communicatie.field.volgorde": "Volgorde",
    "instellingen.communicatie.field.onderwerp": "Onderwerp",
    "instellingen.communicatie.field.ontvanger": "Standaard ontvanger",
    "instellingen.communicatie.field.bericht": "Bericht",
    // Koppelingen-tegel (integraties) — vestigingscontext. Geheimen zijn write-only/gemaskeerd.
    "instellingen.integraties.loadError": "De koppelingsinstellingen konden niet worden geladen.",
    "instellingen.integraties.status.configured": "Ingesteld",
    "instellingen.integraties.status.configuredTail": "Ingesteld (•••• %s)",
    "instellingen.integraties.status.notConfigured": "Niet ingesteld",
    "instellingen.integraties.secret.empty": "Niet ingesteld",
    "instellingen.integraties.field.apiKey": "API-sleutel",
    "instellingen.integraties.field.profileId": "Profiel-ID",
    "instellingen.integraties.field.methods": "Betaalmethoden",
    "instellingen.integraties.field.webhook": "Webhook-URL",
    "instellingen.integraties.field.active": "Actief",
    "instellingen.integraties.field.provider": "Betaalprovider",
    "instellingen.integraties.field.merchantId": "Merchant-ID",
    "instellingen.integraties.field.merchantAccount": "Merchant-account",
    "instellingen.integraties.field.clientId": "Client-ID",
    "instellingen.integraties.field.username": "Gebruikersnaam",
    "instellingen.integraties.field.password": "Wachtwoord",
    "instellingen.integraties.field.locale": "Locale (e-mailtaal)",
    // Financieel-tegel → Koppeling boekhouding (boekhoudkoppeling).
    "instellingen.boekhouding.title": "Boekhoudkoppeling",
    "instellingen.boekhouding.subtitle": "Koppeling met extern boekhoudpakket",
    "instellingen.boekhouding.providerLabel": "Boekhoudpakket",
    "instellingen.boekhouding.status.connected": "Verbonden met %s",
    "instellingen.boekhouding.status.disconnected": "Nog niet verbonden met %s",
    "instellingen.boekhouding.account": "Account: %s",
    "instellingen.boekhouding.account.none": "Account: nog niet gekoppeld",
    "instellingen.boekhouding.lastSync": "Laatst gesynchroniseerd: %s",
    "instellingen.boekhouding.lastSync.never": "nog niet",
    "instellingen.boekhouding.badge.connected": "Verbonden",
    "instellingen.boekhouding.badge.disconnected": "Niet verbonden",
    "instellingen.boekhouding.action.connect": "Koppelen",
    "instellingen.boekhouding.action.resync": "Opnieuw synchroniseren",
    "instellingen.boekhouding.action.settings": "Instellingen",
    "instellingen.boekhouding.action.disconnect": "Ontkoppelen",
    "instellingen.boekhouding.form.connectTitle": "%s koppelen",
    "instellingen.boekhouding.form.settingsTitle": "Instellingen %s",
    "instellingen.boekhouding.form.clientId": "Client ID",
    "instellingen.boekhouding.form.clientSecret": "Client secret",
    "instellingen.boekhouding.form.clientSecret.keep": "Laat leeg om het opgeslagen secret te behouden",
    "instellingen.boekhouding.form.redirectUri": "Redirect-URI",
    "instellingen.boekhouding.extra.division": "Divisie",
    "instellingen.boekhouding.extra.officeCode": "Administratiecode",
    "instellingen.boekhouding.extra.administrationId": "Administratie-ID",
    "instellingen.boekhouding.extra.environmentId": "Omgeving-ID",
    "instellingen.boekhouding.secret.configured": "Er is een client secret ingesteld",
    "instellingen.boekhouding.error.generic": "Er ging iets mis. Probeer het opnieuw.",
    "instellingen.boekhouding.error.connectRequired": "Client ID, redirect-URI en client secret zijn verplicht om te koppelen.",
    "instellingen.boekhouding.save": "Opslaan",
    // Financieel-tegel → Grootboeknummers.
    "instellingen.grootboek.title": "Grootboeknummers",
    "instellingen.grootboek.search.placeholder": "Zoek op nummer of omschrijving…",
    "instellingen.grootboek.empty": "Geen grootboeknummers.",
    "instellingen.grootboek.loadFailed": "Kon grootboeknummers niet laden.",
    "instellingen.grootboek.create": "Nieuw grootboeknummer",
    "instellingen.grootboek.edit": "Bewerken",
    "instellingen.grootboek.delete": "Verwijderen",
    "instellingen.grootboek.column.nummer": "Nummer",
    "instellingen.grootboek.column.omschrijving": "Omschrijving",
    "instellingen.grootboek.column.type": "Type",
    "instellingen.grootboek.column.status": "Status",
    "instellingen.grootboek.column.actions": "Acties",
    "instellingen.grootboek.status.active": "Actief",
    "instellingen.grootboek.status.inactive": "Inactief",
    "instellingen.grootboek.field.nummer": "Grootboeknummer",
    "instellingen.grootboek.field.omschrijving": "Omschrijving",
    "instellingen.grootboek.field.type": "Type",
    "instellingen.grootboek.field.actief": "Actief",
    "instellingen.grootboek.type.activa": "Activa",
    "instellingen.grootboek.type.passiva": "Passiva",
    "instellingen.grootboek.type.kosten": "Kosten",
    "instellingen.grootboek.type.opbrengst": "Opbrengst",
    "instellingen.grootboek.create.title": "Nieuw grootboeknummer",
    "instellingen.grootboek.edit.title": "Grootboeknummer bewerken",
    "instellingen.grootboek.delete.title": "Grootboeknummer verwijderen",
    "instellingen.grootboek.delete.inUse":
      "%d verwijzing(en) gebruiken nog \"%s\". Kies een vervangend grootboeknummer; de verwijzingen worden daar naartoe verplaatst vóór verwijderen:",
    "instellingen.grootboek.delete.replacementLabel": "Verwijzingen verplaatsen naar",
    "instellingen.grootboek.delete.choosePlaceholder": "Kies een grootboeknummer…",
    "instellingen.grootboek.delete.transferAndDelete": "Omzetten & verwijderen",
    "instellingen.grootboek.saveFailed": "Kon grootboeknummer niet opslaan. Het nummer bestaat mogelijk al.",
    "instellingen.grootboek.deleteFailed": "Kon grootboeknummer niet verwijderen.",

    // settings-rest: migrated Pension / Pleeggezinnen / Dieren-stamgegevens tile keys.
    "common.yes": "Ja",
    "common.no": "Nee",
    "instellingen.pension.new": "Nieuw",
    "instellingen.pension.edit": "Bewerken",
    "instellingen.pension.delete": "Verwijderen",
    "instellingen.pension.field.naam": "Naam",
    "instellingen.pension.field.kleur": "Verblijfplanning-kleur",
    "instellingen.pension.field.toon": "Tonen in verblijfplanning",
    "instellingen.pension.field.datum": "Datum",
    "instellingen.pension.field.diersoort": "Diersoort",
    "instellingen.pension.diersoort.placeholder": "Kies een diersoort…",
    "instellingen.pension.berekening.title": "Berekening pension",
    "instellingen.pension.berekening.desc": "Beheer pensioneigenschappen en verblijfplanning-kleuren",
    "instellingen.pension.berekening.col.naam": "Naam",
    "instellingen.pension.berekening.col.kleur": "Kleur",
    "instellingen.pension.berekening.col.toon": "In verblijfplanning",
    "instellingen.pension.berekening.empty": "Nog geen pensioneigenschappen.",
    "instellingen.pension.berekening.loadFailed": "Kon de pensioneigenschappen niet laden.",
    "instellingen.pension.hoogseizoen.title": "Hoogseizoen dagen",
    "instellingen.pension.hoogseizoen.desc": "Beheer volpension-dagen per diersoort voor deze vestiging",
    "instellingen.pension.hoogseizoen.col.datum": "Datum",
    "instellingen.pension.hoogseizoen.col.diersoort": "Diersoort",
    "instellingen.pension.hoogseizoen.empty": "Nog geen dagen waarop het pension vol zit.",
    "instellingen.pension.hoogseizoen.loadFailed": "Kon de dagen waarop het pension vol zit niet laden.",
    "instellingen.pension.capaciteit.title": "Capaciteit",
    "instellingen.pension.capaciteit.desc": "Stel de pensioncapaciteit voor deze vestiging in",
    "instellingen.pension.accommodaties.desc": "Accommodatietypes per diersoort, met icoon of logo",
    "instellingen.item.prijsberekening": "Prijsberekening",
    "instellingen.pension.prijsberekening.desc": "Reken met pensionprijzen of met dagprijzen per accommodatie, en de regels voor in- en uitchecken",
    "instellingen.item.benaming": "Benaming: pension of hotel",
    "instellingen.pension.benaming.desc": "Noem uw pension overal in de backoffice en het klantportaal een hotel",
    "instellingen.item.annuleringsverzekering": "Annuleringsverzekering",
    "instellingen.pension.annuleringsverzekering.desc": "Wat de annuleringsverzekering per reservering kost, aangeboden in de wizard Nieuwe reservering",
    "instellingen.item.brengHaaltijden": "Breng- en haaltijden",
    "instellingen.pension.brengHaaltijden.desc": "Per dag van de week wanneer dieren gebracht en opgehaald kunnen worden; de wizard Nieuwe reservering biedt alleen die tijden aan",
    "pensionBrengHaaltijden.titel": "Breng- en haaltijden",
    "pensionBrengHaaltijden.uitleg": "Per dag van de week de blokken waarin dieren worden aangenomen en meegegeven. De wizard Nieuwe reservering biedt alleen deze tijden aan; een dag zonder blokken telt als gesloten. Richt je niets in, dan kiest de balie vrij.",
    "pensionBrengHaaltijden.stap": "Elke",
    "pensionBrengHaaltijden.minuten": "%s minuten een tijd",
    "pensionBrengHaaltijden.dag": "Dag",
    "pensionBrengHaaltijden.brengen": "Brengen",
    "pensionBrengHaaltijden.halen": "Halen",
    "pensionBrengHaaltijden.blokToevoegen": "Blok toevoegen",
    "pensionBrengHaaltijden.blok.brengen": "Brengblok toevoegen op %s",
    "pensionBrengHaaltijden.blok.halen": "Haalblok toevoegen op %s",
    "pensionBrengHaaltijden.van.brengen": "Brengen %s blok %s vanaf",
    "pensionBrengHaaltijden.tot.brengen": "Brengen %s blok %s tot",
    "pensionBrengHaaltijden.weg.brengen": "Brengen %s blok %s verwijderen",
    "pensionBrengHaaltijden.van.halen": "Halen %s blok %s vanaf",
    "pensionBrengHaaltijden.tot.halen": "Halen %s blok %s tot",
    "pensionBrengHaaltijden.weg.halen": "Halen %s blok %s verwijderen",
    "pensionBrengHaaltijden.dicht": "Gesloten",
    "pensionBrengHaaltijden.kopieer": "%s naar de andere dagen kopiëren",
    "pensionBrengHaaltijden.kopieerKolom": "Kopiëren",
    "pensionBrengHaaltijden.ongeldig": "Elk blok eindigt na het begin.",
    "pensionBrengHaaltijden.alleenLezen": "Alleen een pensionbeheerder kan deze tijden wijzigen.",
    "pensionBrengHaaltijden.laden": "De tijden konden niet worden geladen.",
    "pensionBrengHaaltijden.fout": "Opslaan is mislukt. Probeer het opnieuw.",
    "pensionBrengHaaltijden.opgeslagen": "Opgeslagen.",
    "instellingen.item.wizardIndeling": "Wizard Nieuwe reservering",
    "instellingen.pension.wizardIndeling.desc": "De stappen, onderdelen en eigen vragen van de wizard Nieuwe reservering indelen",
    "pensionReserveringsproducten.titel": "Reserveringsproducten",
    "pensionReserveringsproducten.uitleg": "De extra diensten die deze vestiging per reservering verkoopt: een annuleringsverzekering, een medifonds, een borg.",
    "pensionReserveringsproducten.nogGeen": "Nog geen producten.",
    "pensionReserveringsproducten.nieuw": "Nieuw product",
    "pensionReserveringsproducten.wijzigen": "Product wijzigen",
    "pensionReserveringsproducten.naam": "Naam",
    "pensionReserveringsproducten.aanbieden": "Aanbieden bij nieuwe reserveringen",
    "pensionReserveringsproducten.inactief": "wordt niet aangeboden",
    "pensionReserveringsproducten.minimumVan": "minimaal %s",
    "pensionReserveringsproducten.per.PER_RESERVERING": "per reservering",
    "pensionReserveringsproducten.per.PER_DIER": "per dier",
    "pensionReserveringsproducten.per.PER_NACHT": "per nacht",
    "pensionReserveringsproducten.per.PER_DIER_PER_NACHT": "per dier per nacht",
    "pensionReserveringsproducten.per.PERCENTAGE": "van het verblijf plus extras",
    "pensionAnnuleringsverzekering.titel": "Annuleringsverzekering",
    "pensionAnnuleringsverzekering.uitleg": "Wat de annuleringsverzekering kost en hoe dat bedrag een premie wordt. De wizard Nieuwe reservering biedt hem de klant aan en toont de premie van die reservering.",
    "pensionAnnuleringsverzekering.bedrag.PER_RESERVERING": "Bedrag per reservering (incl. btw)",
    "pensionAnnuleringsverzekering.bedrag.PER_DIER": "Bedrag per dier (incl. btw)",
    "pensionAnnuleringsverzekering.bedrag.PER_NACHT": "Bedrag per nacht (incl. btw)",
    "pensionAnnuleringsverzekering.bedrag.PER_DIER_PER_NACHT": "Bedrag per dier per nacht (incl. btw)",
    "pensionAnnuleringsverzekering.berekening": "Hoe wordt hij berekend",
    "pensionAnnuleringsverzekering.berekening.PER_RESERVERING": "Eén bedrag per reservering",
    "pensionAnnuleringsverzekering.berekening.PER_DIER": "Per dier",
    "pensionAnnuleringsverzekering.berekening.PER_NACHT": "Per nacht",
    "pensionAnnuleringsverzekering.berekening.PER_DIER_PER_NACHT": "Per dier per nacht",
    "pensionAnnuleringsverzekering.berekening.PERCENTAGE": "Een percentage van de reservering",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_RESERVERING": "Hetzelfde bedrag, hoe de reservering er ook uitziet.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_DIER": "Het bedrag maal het aantal dieren op de reservering.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_NACHT": "Het bedrag maal het aantal nachten; een dagopvang telt als één.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PER_DIER_PER_NACHT": "Het bedrag maal de dieren maal de nachten.",
    "pensionAnnuleringsverzekering.berekeningUitleg.PERCENTAGE": "Een percentage van het verblijf plus de extra's — niet van dit product zelf.",
    "pensionAnnuleringsverzekering.percentage": "Percentage van de reservering",
    "pensionAnnuleringsverzekering.minimum": "Minimumbedrag (optioneel)",
    "pensionAnnuleringsverzekering.voorbeeld": "Voorbeeld: twee dieren, vier nachten, € 240,00 aan verblijf en extra's → %s.",
    "pensionAnnuleringsverzekering.btw": "Btw-percentage",
    "pensionAnnuleringsverzekering.geenBedrag": "Zonder bedrag wordt dit product niet aangeboden.",
    "pensionAnnuleringsverzekering.ongeldig": "Vul een bedrag tussen 0 en 100.000 in, een percentage tussen 0 en 100 en een btw-percentage tussen 0 en 100. Een minimumbedrag hoort bij een bedrag.",
    "pensionAnnuleringsverzekering.alleenLezen": "Alleen een pensionbeheerder kan deze producten wijzigen.",
    "pensionAnnuleringsverzekering.laden": "De reserveringsproducten konden niet worden geladen.",
    "pensionAnnuleringsverzekering.fout": "Opslaan is mislukt. Probeer het opnieuw.",
    "pensionAnnuleringsverzekering.opgeslagen": "Opgeslagen.",
    "instellingen.pension.capaciteit.loadFailed": "Kon de capaciteit niet laden.",
    "instellingen.pension.capaciteit.uitleg": "Hoeveel dieren er per diersoort tegelijk in het pension kunnen. De wizard meldt de dagen waarop een boeking daaroverheen gaat. Laat je een soort leeg, dan geldt er geen grens.",
    "instellingen.pension.capaciteit.uitKennelplanning": "Bereken de capaciteit uit de verblijfplanning",
    "instellingen.pension.capaciteit.uitKennelplanningUitleg": "De verblijven van die diersoort tellen mee, elk voor zijn eigen capaciteit — zo telt een nieuw verblijf er meteen bij.",
    "instellingen.pension.capaciteit.soort": "Diersoort",
    "instellingen.pension.capaciteit.plaatsen": "Plaatsen",
    "instellingen.pension.capaciteit.plaatsenVan": "Plaatsen voor %s",
    "instellingen.pension.capaciteit.kennelplanning": "Verblijfplanning",
    "instellingen.pension.capaciteit.hokken": "%d verblijven, %d plaatsen",
    "instellingen.pension.capaciteit.geenHokken": "geen verblijven",
    "instellingen.pension.capaciteit.effectief": "Waarmee gerekend wordt",
    "instellingen.pension.capaciteit.plaatsenAantal": "%d plaatsen",
    "instellingen.pension.capaciteit.geenGrens": "geen grens",
    "instellingen.pension.capaciteit.geenSoorten": "Nog geen diersoorten. Voeg er een toe om de capaciteit in te stellen.",
    "instellingen.pension.capaciteit.soortToevoegen": "Diersoort toevoegen",
    "instellingen.pension.capaciteit.kies": "Kies…",
    "instellingen.pension.capaciteit.verwijderen": "%s verwijderen",
    "instellingen.pension.capaciteit.alleenLezen": "Je kunt de capaciteit bekijken, maar niet wijzigen.",
    "instellingen.pension.capaciteit.fout": "Kon de capaciteit niet opslaan.",
    "instellingen.pension.capaciteit.saved": "Capaciteit opgeslagen.",
    "instellingen.opvangcat.title": "Opvangcategorieën",
    "instellingen.opvangcat.intro": "Beheer de opvangcategorieën die pleeggezinnen binnen deze vestiging kunnen aanbieden, per diersoort.",
    "instellingen.opvangcat.add": "Nieuwe categorie",
    "instellingen.opvangcat.empty": "Nog geen opvangcategorieën.",
    "instellingen.opvangcat.loadFailed": "Kon de opvangcategorieën niet laden.",
    "instellingen.opvangcat.col.diersoort": "Diersoort",
    "instellingen.opvangcat.col.naam": "Naam",
    "instellingen.opvangcat.col.omschrijving": "Omschrijving",
    "instellingen.opvangcat.col.status": "Status",
    "instellingen.opvangcat.col.sortering": "Volgorde",
    "instellingen.opvangcat.col.acties": "Acties",
    "instellingen.opvangcat.status.actief": "Actief",
    "instellingen.opvangcat.status.inactief": "Inactief",
    "instellingen.opvangcat.edit": "Bewerken",
    "instellingen.opvangcat.create.title": "Nieuwe opvangcategorie",
    "instellingen.opvangcat.edit.title": "Opvangcategorie bewerken",
    "instellingen.opvangcat.field.diersoort": "Diersoort",
    "instellingen.opvangcat.field.diersoortPlaceholder": "Kies een diersoort…",
    "instellingen.opvangcat.field.naam": "Naam",
    "instellingen.opvangcat.field.omschrijving": "Omschrijving",
    "instellingen.opvangcat.field.sortering": "Volgorde",
    "instellingen.opvangcat.field.actief": "Actief",
    "instellingen.opvangcat.delete": "Verwijderen",
    "instellingen.opvangcat.deleteInUse": "Deze categorie is in gebruik bij een pleeggezin en kan alleen worden gedeactiveerd.",
    "instellingen.opvangcat.saveFailed": "Kon de categorie niet opslaan.",
    "instellingen.opvangcat.pleeggezinActief": "Pleeggezinnen actief",
    "instellingen.opvangcat.pleeggezinFout": "Kon pleeggezinnen niet omzetten voor {soort}.",
    "instellingen.opvangcat.geenDiersoorten": "Er zijn nog geen diersoorten geconfigureerd.",
    "instellingen.opvangcat.geenCategorieen": "Nog geen categorieën voor deze diersoort.",
    "instellingen.dieren.title": "Dieren",
    "instellingen.dieren.subtitle": "Beheer stamgegevens voor dieren",
    "instellingen.dieren.speciesLabel": "Diersoort:",
    "instellingen.dieren.create": "Nieuw item",
    "instellingen.dieren.edit": "Bewerken",
    "instellingen.dieren.naam": "Naam",
    "instellingen.dieren.kleurLabel": "Kleur",
    "instellingen.dieren.editRow": "Bewerken",
    "instellingen.dieren.deleteRow": "Verwijderen",
    "instellingen.dieren.empty": "Geen items gevonden voor deze diersoort.",
    "instellingen.dieren.noResults": "Geen resultaten voor deze zoekterm.",
    "instellingen.dieren.loadFailed": "Kon de lijst niet laden.",
    "instellingen.dieren.vacht.title": "Vachten",
    "instellingen.dieren.vacht.subtitle": "Beheer vachtsoorten",
    "instellingen.dieren.vacht.add": "Nieuwe vacht toevoegen",
    "instellingen.dieren.vacht.search": "Zoek vacht…",
    "instellingen.dieren.kleur.title": "Kleuren",
    "instellingen.dieren.kleur.subtitle": "Beheer kleuren",
    "instellingen.dieren.kleur.add": "Nieuwe kleur toevoegen",
    "instellingen.dieren.kleur.search": "Zoek kleur…",
    "instellingen.dieren.kenneleigenschap.title": "Verblijfeigenschappen",
    "instellingen.dieren.kenneleigenschap.subtitle": "Beheer verblijfeigenschappen",
    "instellingen.dieren.kenneleigenschap.add": "Nieuwe verblijfeigenschap toevoegen",
    "instellingen.dieren.kenneleigenschap.search": "Zoek verblijfeigenschap…",
    "instellingen.dieren.ras.title": "Rassen",
    "instellingen.dieren.ras.subtitle": "Beheer rassen",
    "instellingen.dieren.ras.add": "Nieuw ras toevoegen",
    "instellingen.dieren.ras.search": "Zoek ras…",
    "instellingen.dieren.delete.title": "Verwijderen",
    "instellingen.dieren.delete.inUse": "Dit item is gekoppeld aan %s dier(en) (\"%s\"). Kies wat er gebeurt vóór verwijderen:",
    "instellingen.dieren.delete.transferTo": "Koppelingen omzetten naar",
    "instellingen.dieren.delete.choosePlaceholder": "Kies een vervanger…",
    "instellingen.dieren.delete.removeLinks": "Koppelingen verwijderen & verwijderen",
    "instellingen.dieren.delete.transfer": "Omzetten & verwijderen",
    // dier-detail migratie: lijst + detailweergave i18n (samengevoegd uit feature/animal-detail-spa)
    "animalListView.title": "Dieren",
    // Dier aanwezig (present-animals overview) — SPA migration of the Jmix DierAttendanceOverview.
    "dierAanwezig.title": "Dier aanwezig",
    "dierAanwezig.subtitle": "Overzicht van de dieren in de opvang",
    "dierAanwezig.results.found": "resultaten gevonden",
    "dierAanwezig.filter.all": "Alle",
    "dierAanwezig.filter.speciesSelected": "%d geselecteerd",
    "dierAanwezig.sortLabel": "Sorteren op",
    "dierAanwezig.search.placeholder": "Zoek dier op naam, chipnummer, ras, kleur…",
    "dierAanwezig.filter.age": "Leeftijd",
    "dierAanwezig.filter.age.young": "< 1 jaar",
    "dierAanwezig.filter.age.adult": "1 t/m 7 jaar",
    "dierAanwezig.filter.age.senior": "8 jaar en ouder",
    "dierAanwezig.filter.age.under3m": "Jonger dan 3 maanden",
    "dierAanwezig.filter.age.under6m": "Jonger dan 6 maanden",
    "dierAanwezig.filter.age.range": "Tussen…",
    "dierAanwezig.filter.age.rangeLabel": "Leeftijd tussen",
    "dierAanwezig.filter.age.from": "van",
    "dierAanwezig.filter.age.to": "tot",
    "dierAanwezig.filter.age.unit": "Eenheid",
    "dierAanwezig.filter.age.months": "maanden",
    "dierAanwezig.filter.age.weeks": "weken",
    "dierAanwezig.filter.age.weeksShort": "wk",
    "dierAanwezig.filter.age.years": "jaar",
    "dierAanwezig.filter.age.rangeHint": "De tot-grens telt niet mee: 3 tot 6 maanden = minstens 3, jonger dan 6 maanden.",
    "dierAanwezig.filter.age.apply": "Toepassen",
    "dierAanwezig.filter.age.cancel": "Annuleren",
    "dierAanwezig.filter.age.edit": "wijzigen",
    "dierAanwezig.filter.age.monthsShort": "mnd",
    "dierAanwezig.filter.age.yearsShort": "jr",
    "dierAanwezig.filter.age.fromShort": "vanaf",
    "dierAanwezig.filter.age.toShort": "tot",
    "dierAanwezig.field.gewichtsignaal": "Gewichtssignaal",
    "dierAanwezig.filter.gewicht": "Gewicht",
    "dierAanwezig.gewicht.onder": "Onder streefgewicht",
    "dierAanwezig.gewicht.boven": "Boven streefgewicht",
    "dierAanwezig.gewicht.binnen": "Binnen streefgewicht",
    "dierAanwezig.gewicht.buiten": "Buiten streefgewicht",
    "dierAanwezig.gewicht.verlopen": "Meting verlopen",
    "dierAanwezig.gewicht.geen": "Geen streefgewicht",
    "dierAanwezig.filter.dumped": "Gedumpt",
    "dierAanwezig.filter.minDays": "Min. dagen in asiel",
    "pleeg.titel": "Pleeggezinnen",
    "pleeg.geen": "Geen",
    "pleeg.beide": "Beide",
    "pleeg.alleen": "Alleen pleeggezinnen",
    "pleeg.aantal": "%s in pleeggezin",
    "pleeg.aantalEen": "1 in pleeggezin",
    "dierAanwezig.filter.showFoster": "Toon %d dieren in pleeggezin",
    "dierAanwezig.filter.showFosterOne": "Toon %d dier in pleeggezin",
    "dierAanwezig.filter.fosterActive": "Actief",
    "dierAanwezig.filter.fosterInactive": "Inactief",
    "dierAanwezig.results.foundOne": "resultaat gevonden",
    "dierAanwezig.filter.more": "Meer filters",
    "filter.inklap": "Filters",
    "dierAanwezig.filter.opnameVan": "Opname vanaf",
    "dierAanwezig.filter.opnameTot": "Opname t/m",
    "dierAanwezig.filter.vertrekVan": "Vertrek vanaf",
    "dierAanwezig.filter.vertrekTot": "Vertrek t/m",
    "dierAanwezig.filter.vertrekSoort": "Status",
    "dierAanwezig.filter.gemeente": "Gemeente",
    "dierAanwezig.filter.clear": "Filters wissen",
    "dierAanwezig.sort.newest": "Nieuwste eerst",
    "dierAanwezig.sort.name": "Naam (A-Z)",
    "dierAanwezig.sort.oldest": "Langst in de opvang",
    "dierAanwezig.sort.departedNewest": "Laatst vertrokken eerst",
    "dierAanwezig.sort.departedOldest": "Eerst vertrokken eerst",
    "dierAanwezig.sort.nameDesc": "Naam (Z-A)",
    "dierAanwezig.sort.youngest": "Jongste dier eerst",
    "dierAanwezig.sort.oldestAge": "Oudste dier eerst",
    "dierAanwezig.sort.species": "Diersoort",
    "dierAanwezig.sort.verblijfnr": "Verblijfnummer",
    "dierAanwezig.viewMode": "Weergave",
    "dierAanwezig.cardMode": "Kaarten",
    "dierAanwezig.compactMode": "Compact",
    "dierAanwezig.listMode": "Lijst",
    "dierAanwezig.fieldChooser.open": "Velden",
    "dierAanwezig.fieldChooser.title": "Kaartvelden",
    "dierAanwezig.loadFailed": "Kon dieren niet laden.",
    "dierAanwezig.empty": "Geen dieren aanwezig.",
    "dierAanwezig.yes": "Ja",
    "dierAanwezig.no": "Nee",
    "dierAanwezig.kruising": "kruising",
    "dierAanwezig.onbekendRas": "Onbekend ras",
    "dierAanwezig.stat.total": "Totaal",
    "dierAanwezig.card.noPhoto": "Foto nog niet beschikbaar",
    "dierAanwezig.card.foster": "Pleeggezin",
    "dierAanwezig.card.inShelterSince": "In asiel sinds",
    "dierAanwezig.card.day": "dag",
    "dierAanwezig.card.days": "dagen",
    "dierAanwezig.card.chipLabel": "Chipnummer",
    "dierAanwezig.card.details": "Details bekijken",
    "dierAanwezig.field.ras": "Ras",
    "dierAanwezig.field.kleur": "Kleur",
    "dierAanwezig.field.vacht": "Vacht",
    "dierAanwezig.field.leeftijd": "Leeftijd",
    "dierAanwezig.field.geboortedatum": "Geboortedatum",
    "dierAanwezig.field.geslacht": "Geslacht",
    "dierAanwezig.field.gecastreerd": "Gecastreerd",
    "dierAanwezig.field.status": "Status",
    "dierAanwezig.field.herkomst": "Herkomst",
    "dierAanwezig.field.diersoort": "Diersoort",
    "dierAanwezig.field.opnamedatum": "Opnamedatum",
    "dierAanwezig.field.gewicht": "Laatste gewicht",
    "dierAanwezig.field.entingen": "Entingen ok",
    "dierAanwezig.field.ontwormen": "Ontwormen ok",
    "dierAanwezig.field.ontvlooien": "Ontvlooien ok",
    "dierAanwezig.field.pleegdagen": "Dagen in pleeggezin",
    "dierAanwezig.veld.pleegdagen": "%s dagen",
    "dierAanwezig.veld.pleegdagEen": "1 dag",
    "dierAanwezig.field.bijzonderheden": "Bijzonderheden",
    "dierAanwezig.field.castratiedatum": "Castratiedatum",
    "dierAanwezig.field.paspoortnummer": "Paspoortnummer",
    "dierAanwezig.field.chipnummer": "Chipnummer",
    "dierAanwezig.field.foto": "Foto",
    // products-migration (vaccinations): de twee dier-gebonden statusoverzichten — entingen +
    // ontwormen/ontvlooien. Letterlijke labels uit de Jmix-iframe-bronnen.
    "entingenOverzicht.title": "Entingen",
    "entingenOverzicht.subtitle": "Overzicht van entingsstatus en openstaande vaccinatie-acties",
    "entingenOverzicht.kpi.aria": "Entingsstatus",
    "entingenOverzicht.kpi.verlopen": "Enting verlopen",
    "entingenOverzicht.kpi.binnenkort": "Verloopt binnenkort",
    "entingenOverzicht.kpi.binnenkortSub": "(binnen 30 dagen)",
    "entingenOverzicht.kpi.ontbreekt": "Enting ontbreekt",
    "entingenOverzicht.kpi.ok": "Entingen ok",
    "entingenOverzicht.kpi.totaal": "Totaal dieren",
    "entingenOverzicht.status.VERLOPEN": "Enting verlopen",
    "entingenOverzicht.status.BINNENKORT": "Verloopt binnenkort",
    "entingenOverzicht.status.ONTBREEKT": "Enting ontbreekt",
    "entingenOverzicht.status.OK": "Entingen ok",
    "entingenOverzicht.search.placeholder": "Zoeken op diernaam, chipnummer, verblijf…",
    "entingenOverzicht.filter.all": "Alle",
    "entingenOverzicht.filter.diersoort": "Diersoort",
    "entingenOverzicht.filter.type": "Entingstype",
    "entingenOverzicht.filter.clear": "Filters wissen",
    "entingenOverzicht.filter.vervaldatumVan": "Vervaldatum van",
    "entingenOverzicht.filter.vervaldatumTot": "Vervaldatum tot",
    "entingenOverzicht.stat.total": "Totaal",
    "entingenOverzicht.results.found": "resultaten gevonden",
    "entingenOverzicht.results.foundOne": "resultaat gevonden",
    "entingenOverzicht.pager.range": "%a - %b van %n dieren",
    "entingenOverzicht.pager.empty": "0 dieren",
    "entingenOverzicht.sortLabel": "Sorteren op",
    "entingenOverzicht.sort.urgent": "Meest urgent eerst",
    "entingenOverzicht.sort.name": "Naam (A-Z)",
    "entingenOverzicht.sort.due": "Vervaldatum (oplopend)",
    "entingenOverzicht.sort.species": "Diersoort",
    "entingenOverzicht.sort.nameDesc": "Naam (Z-A)",
    "entingenOverzicht.sort.youngest": "Jongste dier eerst",
    "entingenOverzicht.sort.oldestAge": "Oudste dier eerst",
    "entingenOverzicht.sort.intakeNewest": "Laatst opgenomen eerst",
    "entingenOverzicht.sort.intakeOldest": "Langst in de opvang",
    "entingenOverzicht.sort.kennel": "Kennel",
    "entingenOverzicht.foster.show": "Toon %d dieren in pleeggezin",
    "entingenOverzicht.foster.showOne": "Toon %d dier in pleeggezin",
    "entingenOverzicht.foster.active": "Actief",
    "entingenOverzicht.foster.inactive": "Inactief",
    "entingenOverzicht.card.foster": "Pleeggezin",
    "entingenOverzicht.filter.status": "Entingsstatus",
    "entingenOverzicht.filter.statusNone": "Geen",
    "entingenOverzicht.filter.statusN": "%d geselecteerd",
    "entingenOverzicht.empty": "Geen dieren gevonden met deze filters.",
    "entingenOverzicht.loadFailed": "Kon het overzicht niet laden.",
    "entingenOverzicht.field.diersoort": "Diersoort",
    "entingenOverzicht.field.leeftijd": "Leeftijd",
    "entingenOverzicht.field.kennel": "Verblijf",
    "entingenOverzicht.field.entingstype": "Entingstype",
    "entingenOverzicht.field.laatsteEnting": "Laatste enting",
    "entingenOverzicht.field.vervaldatum": "Vervaldatum",
    "entingenOverzicht.field.kleur": "Kleur",
    "entingenOverzicht.field.vacht": "Vacht",
    "entingenOverzicht.field.geboortedatum": "Geboortedatum",
    "entingenOverzicht.field.geslacht": "Geslacht",
    "entingenOverzicht.field.gecastreerd": "Gecastreerd",
    "entingenOverzicht.field.castratiedatum": "Castratiedatum",
    "entingenOverzicht.field.herkomst": "Herkomst",
    "entingenOverzicht.field.opnamedatum": "Opnamedatum",
    "entingenOverzicht.field.paspoortnummer": "Paspoortnummer",
    "entingenOverzicht.field.bijzonderheden": "Bijzonderheden",
    "entingenOverzicht.field.chipnummer": "Chipnummer",
    "entingenOverzicht.veldkiezer.open": "Velden",
    "entingenOverzicht.veldkiezer.title": "Velden kiezen",
    "entingenOverzicht.veldkiezer.cancel": "Annuleren",
    "entingenOverzicht.veldkiezer.save": "Opslaan",
    "entingenOverzicht.weergave.grid": "Kaarten",
    "entingenOverzicht.weergave.compact": "Compact",
    "entingenOverzicht.weergave.lijst": "Lijst",
    "entingenOverzicht.table.status": "Status",
    "entingenOverzicht.table.dier": "Dier",
    "entingenOverzicht.card.chipLabel": "Chipnummer",
    "entingenOverzicht.card.details": "Details",
    "entingenOverzicht.card.bewerken": "Enting toevoegen",
    "entingenOverzicht.card.instellingen": "Instellingen (producten)",
    "entingenOverzicht.card.today": "vandaag",
    "entingenOverzicht.card.inDays": "%d dagen",
    "entingenOverzicht.card.daysAgo": "%d dagen geleden",
    "entingenOverzicht.card.daysSigned": "%d dagen",
    "ontwormenOverzicht.title": "Ontwormen & ontvlooien",
    "ontwormenOverzicht.subtitle": "Overzicht van ontworm-/ontvlooistatus en openstaande behandelingen",
    "ontwormenOverzicht.kpi.aria": "Behandelstatus",
    "ontwormenOverzicht.kpi.verlopen": "Behandeling verlopen",
    "ontwormenOverzicht.kpi.binnenkort": "Verloopt binnenkort",
    "ontwormenOverzicht.kpi.binnenkortSub": "(binnen 30 dagen)",
    "ontwormenOverzicht.kpi.ontbreekt": "Behandeling ontbreekt",
    "ontwormenOverzicht.kpi.ok": "Behandelingen ok",
    "ontwormenOverzicht.kpi.totaal": "Totaal dieren",
    "ontwormenOverzicht.status.VERLOPEN": "Behandeling verlopen",
    "ontwormenOverzicht.status.BINNENKORT": "Verloopt binnenkort",
    "ontwormenOverzicht.status.ONTBREEKT": "Behandeling ontbreekt",
    "ontwormenOverzicht.status.OK": "Behandelingen ok",
    "ontwormenOverzicht.search.placeholder": "Zoeken op diernaam, chipnummer, verblijf…",
    "ontwormenOverzicht.filter.all": "Alle",
    "ontwormenOverzicht.filter.diersoort": "Diersoort",
    "ontwormenOverzicht.filter.type": "Behandeltype",
    "ontwormenOverzicht.filter.clear": "Filters wissen",
    "ontwormenOverzicht.filter.vervaldatumVan": "Vervaldatum van",
    "ontwormenOverzicht.filter.vervaldatumTot": "Vervaldatum tot",
    "ontwormenOverzicht.stat.total": "Totaal",
    "ontwormenOverzicht.results.found": "resultaten gevonden",
    "ontwormenOverzicht.results.foundOne": "resultaat gevonden",
    "ontwormenOverzicht.pager.range": "%a - %b van %n dieren",
    "ontwormenOverzicht.pager.empty": "0 dieren",
    "ontwormenOverzicht.sortLabel": "Sorteren op",
    "ontwormenOverzicht.sort.urgent": "Meest urgent eerst",
    "ontwormenOverzicht.sort.name": "Naam (A-Z)",
    "ontwormenOverzicht.sort.due": "Volgende behandeling (oplopend)",
    "ontwormenOverzicht.sort.species": "Diersoort",
    "ontwormenOverzicht.sort.nameDesc": "Naam (Z-A)",
    "ontwormenOverzicht.sort.youngest": "Jongste dier eerst",
    "ontwormenOverzicht.sort.oldestAge": "Oudste dier eerst",
    "ontwormenOverzicht.sort.intakeNewest": "Laatst opgenomen eerst",
    "ontwormenOverzicht.sort.intakeOldest": "Langst in de opvang",
    "ontwormenOverzicht.sort.kennel": "Kennel",
    "ontwormenOverzicht.foster.show": "Toon %d dieren in pleeggezin",
    "ontwormenOverzicht.foster.showOne": "Toon %d dier in pleeggezin",
    "ontwormenOverzicht.foster.active": "Actief",
    "ontwormenOverzicht.foster.inactive": "Inactief",
    "ontwormenOverzicht.card.foster": "Pleeggezin",
    "ontwormenOverzicht.filter.status": "Behandelstatus",
    "ontwormenOverzicht.filter.statusNone": "Geen",
    "ontwormenOverzicht.filter.statusN": "%d geselecteerd",
    "ontwormenOverzicht.empty": "Geen dieren gevonden met deze filters.",
    "ontwormenOverzicht.loadFailed": "Kon het overzicht niet laden.",
    "ontwormenOverzicht.field.diersoort": "Diersoort",
    "ontwormenOverzicht.field.leeftijd": "Leeftijd",
    "ontwormenOverzicht.field.kennel": "Verblijf",
    "ontwormenOverzicht.field.entingstype": "Behandeltype",
    "ontwormenOverzicht.field.laatsteEnting": "Laatste behandeling",
    "ontwormenOverzicht.field.vervaldatum": "Volgende behandeling",
    "ontwormenOverzicht.field.kleur": "Kleur",
    "ontwormenOverzicht.field.vacht": "Vacht",
    "ontwormenOverzicht.field.geboortedatum": "Geboortedatum",
    "ontwormenOverzicht.field.geslacht": "Geslacht",
    "ontwormenOverzicht.field.gecastreerd": "Gecastreerd",
    "ontwormenOverzicht.field.castratiedatum": "Castratiedatum",
    "ontwormenOverzicht.field.herkomst": "Herkomst",
    "ontwormenOverzicht.field.opnamedatum": "Opnamedatum",
    "ontwormenOverzicht.field.paspoortnummer": "Paspoortnummer",
    "ontwormenOverzicht.field.bijzonderheden": "Bijzonderheden",
    "ontwormenOverzicht.field.chipnummer": "Chipnummer",
    "ontwormenOverzicht.veldkiezer.open": "Velden",
    "ontwormenOverzicht.veldkiezer.title": "Velden kiezen",
    "ontwormenOverzicht.veldkiezer.cancel": "Annuleren",
    "ontwormenOverzicht.veldkiezer.save": "Opslaan",
    "ontwormenOverzicht.weergave.grid": "Kaarten",
    "ontwormenOverzicht.weergave.compact": "Compact",
    "ontwormenOverzicht.weergave.lijst": "Lijst",
    "ontwormenOverzicht.table.status": "Status",
    "ontwormenOverzicht.table.dier": "Dier",
    "ontwormenOverzicht.card.chipLabel": "Chipnummer",
    "ontwormenOverzicht.card.details": "Details",
    "ontwormenOverzicht.card.bewerken": "Behandeling toevoegen",
    "ontwormenOverzicht.card.instellingen": "Instellingen (producten)",
    "ontwormenOverzicht.card.today": "vandaag",
    "ontwormenOverzicht.card.inDays": "%d dagen",
    "ontwormenOverzicht.card.daysAgo": "%d dagen geleden",
    "ontwormenOverzicht.card.daysSigned": "%d dagen",
    "medicijnOverzicht.title": "Medicijnen",
    "medicijnOverzicht.subtitle": "Overzicht van lopende medicatie, toedieningen en stopmomenten",
    "medicijnOverzicht.kpi.aria": "Medicijnstatus",
    "medicijnOverzicht.kpi.vandaag": "Toediening vandaag",
    "medicijnOverzicht.kpi.binnenkort": "Binnenkort stoppen",
    "medicijnOverzicht.kpi.binnenkortSub": "(binnen 7 dagen)",
    "medicijnOverzicht.kpi.actief": "Medicatie actief",
    "medicijnOverzicht.kpi.historisch": "Historisch",
    "medicijnOverzicht.kpi.totaal": "Totaal dieren",
    "medicijnOverzicht.stat.total": "Totaal",
    "medicijnOverzicht.card.foster": "Pleeggezin",
    "medicijnOverzicht.foster.show": "Toon %d dieren in pleeggezin",
    "medicijnOverzicht.foster.showOne": "Toon %d dier in pleeggezin",
    "medicijnOverzicht.foster.active": "Actief",
    "medicijnOverzicht.foster.inactive": "Inactief",
    "medicijnOverzicht.status.TOEDIENING_VANDAAG": "Toediening vandaag",
    "medicijnOverzicht.status.BINNENKORT_STOPPEN": "Binnenkort stoppen",
    "medicijnOverzicht.status.ACTIEF": "Medicatie actief",
    "medicijnOverzicht.status.HISTORISCH": "Historisch",
    "medicijnOverzicht.search.placeholder": "Zoeken op diernaam, chipnummer, medicijn…",
    "medicijnOverzicht.filter.all": "Alle",
    "medicijnOverzicht.filter.diersoort": "Diersoort",
    "medicijnOverzicht.filter.categorie": "Categorie",
    "medicijnOverzicht.filter.status": "Medicijnstatus",
    "medicijnOverzicht.filter.statusNone": "Geen",
    "medicijnOverzicht.filter.statusN": "%d geselecteerd",
    "medicijnOverzicht.filter.vanaf": "Toediening van",
    "medicijnOverzicht.filter.tot": "Toediening tot",
    "medicijnOverzicht.sort.label": "Sorteren op",
    "medicijnOverzicht.sort.urgent": "Meest urgent eerst",
    "medicijnOverzicht.sort.naam": "Naam (A-Z)",
    "medicijnOverzicht.sort.volgende": "Volgende toediening",
    "medicijnOverzicht.sort.diersoort": "Diersoort",
    "medicijnOverzicht.sort.naamDesc": "Naam (Z-A)",
    "medicijnOverzicht.sort.jongste": "Jongste dier eerst",
    "medicijnOverzicht.sort.oudste": "Oudste dier eerst",
    "medicijnOverzicht.sort.opnameNieuwste": "Laatst opgenomen eerst",
    "medicijnOverzicht.sort.opnameOudste": "Langst in de opvang",
    "medicijnOverzicht.sort.kennel": "Kennel",
    "medicijnOverzicht.filter.clear": "Filters wissen",
    "medicijnOverzicht.results.found": "resultaten gevonden",
    "medicijnOverzicht.results.foundOne": "resultaat gevonden",
    "medicijnOverzicht.pager.range": "%a - %b van %n dieren",
    "medicijnOverzicht.pager.empty": "0 dieren",
    "medicijnOverzicht.empty": "Geen dieren met medicatie gevonden met deze filters.",
    "medicijnOverzicht.loadFailed": "Kon het overzicht niet laden.",
    "medicijnOverzicht.field.medicijn": "Medicijn",
    "medicijnOverzicht.field.dosering": "Dosering",
    "medicijnOverzicht.field.frequentie": "Frequentie",
    "medicijnOverzicht.field.laatsteToediening": "Laatste toediening",
    "medicijnOverzicht.field.kennel": "Verblijf",
    "medicijnOverzicht.field.volgendeToediening": "Volgende toediening",
    "medicijnOverzicht.field.categorie": "Categorie",
    "medicijnOverzicht.field.toedieningsvorm": "Toedieningsvorm",
    "medicijnOverzicht.field.startDatum": "Startdatum",
    "medicijnOverzicht.field.stopDatum": "Stopdatum",
    "medicijnOverzicht.field.voorgeschrevenDoor": "Voorgeschreven door",
    "medicijnOverzicht.field.diersoort": "Diersoort",
    "medicijnOverzicht.field.kleur": "Kleur",
    "medicijnOverzicht.field.vacht": "Vacht",
    "medicijnOverzicht.field.leeftijd": "Leeftijd",
    "medicijnOverzicht.field.geboortedatum": "Geboortedatum",
    "medicijnOverzicht.field.geslacht": "Geslacht",
    "medicijnOverzicht.field.gecastreerd": "Gecastreerd",
    "medicijnOverzicht.field.castratiedatum": "Castratiedatum",
    "medicijnOverzicht.field.herkomst": "Herkomst",
    "medicijnOverzicht.field.opnamedatum": "Opnamedatum",
    "medicijnOverzicht.field.paspoortnummer": "Paspoortnummer",
    "medicijnOverzicht.field.bijzonderheden": "Bijzonderheden",
    "medicijnOverzicht.field.chipnummer": "Chipnummer",
    "medicijnOverzicht.veldkiezer.open": "Velden",
    "medicijnOverzicht.veldkiezer.title": "Velden kiezen",
    "medicijnOverzicht.veldkiezer.cancel": "Annuleren",
    "medicijnOverzicht.veldkiezer.save": "Opslaan",
    "medicijnOverzicht.weergave.grid": "Kaarten",
    "medicijnOverzicht.weergave.compact": "Compact",
    "medicijnOverzicht.weergave.lijst": "Lijst",
    "medicijnOverzicht.table.status": "Status",
    "medicijnOverzicht.table.dier": "Dier",
    "medicijnOverzicht.card.chipLabel": "Chipnummer",
    "medicijnOverzicht.card.details": "Details",
    "medicijnOverzicht.card.bewerken": "Toediening registreren",
    "medicijnOverzicht.card.instellingen": "Instellingen (producten)",
    "dierAanwezig.column.verblijfNummer": "Verblijfnr",
    "dierAanwezig.column.animalName": "Diernaam",
    // dieren-geplaatst (Dieren geplaatst — Jmix DierPlacementOverview migratie).
    "dierGeplaatst.title": "Dieren vertrokken",
    "dierGeplaatst.subtitle": "Overzicht van de vertrokken dieren",
    "animalListView.search.placeholder": "Zoek op naam, chip of ras…",
    "animalListView.refresh": "Vernieuwen",
    "animalListView.empty": "Geen dieren.",
    "animalListView.loadFailed": "Kon dieren niet laden.",
    "relatieListView.title": "Relaties",
    "relatieListView.search.placeholder": "Zoek op naam, nummer, e-mailadres of plaats…",
    "relatieListView.refresh": "Vernieuwen",
    "relatieListView.create.button": "Nieuwe relatie",
    "relatieListView.create.title": "Nieuwe relatie",
    "relatieDubbel.kopEen": "Deze relatie bestaat mogelijk al.",
    "relatieDubbel.kop": "Er zijn %s relaties die hierop lijken.",
    "relatieDubbel.openen": "Openen",
    "relatieDubbel.reden.EMAIL": "zelfde e-mailadres",
    "relatieDubbel.reden.TELEFOON": "zelfde telefoonnummer",
    "relatieDubbel.reden.KVK": "zelfde KvK-nummer",
    "relatieDubbel.reden.BEDRIJFSNAAM": "zelfde bedrijfsnaam",
    "relatieDubbel.reden.NAAM_ADRES": "zelfde achternaam op dit adres",
    "relatieDubbel.tochAanmaken": "Toch aanmaken",
    "relatieSamenvoegen.knop": "Samenvoegen",
    "relatieSamenvoegen.title": "Relaties samenvoegen",
    "relatieSamenvoegen.uitleg": "Alles van deze relatie gaat naar de relatie die u kiest: dieren, facturen, verblijven, notities en documenten. Deze relatie staat daarna niet meer in de lijst; links ernaartoe komen uit bij de relatie die blijft.",
    "relatieSamenvoegen.zoek": "Zoek op naam, nummer, e-mail of woonplaats",
    "relatieSamenvoegen.geenResultaat": "Geen relaties gevonden.",
    "relatieSamenvoegen.kiezen": "Kiezen",
    "relatieSamenvoegen.gekozen": "Alles gaat naar %s.",
    "relatieSamenvoegen.bevestig": "Samenvoegen",
    "relatieSamenvoegen.annuleer": "Annuleren",
    "relatieSamenvoegen.bezig": "Bezig met samenvoegen…",
    "relatieSamenvoegen.klaar": "Samengevoegd: %s gegevens verplaatst.",
    "relatieSamenvoegen.fout": "Het samenvoegen is niet gelukt. Er is niets gewijzigd.",
    "relatieSamenvoegen.alSamengevoegd": "Deze relatie is samengevoegd met een andere relatie.",
    "relatieSamenvoegen.naarDoel": "Open die relatie",
    "relatieListView.create.contactpersoon": "Contactpersoon",
    "relatieListView.empty": "Geen relaties.",
    "relatieListView.loadFailed": "Kon relaties niet laden.",
    "relatieListView.column.nummer": "Nr.",
    "relatieListView.column.naam": "Naam",
    "relatieListView.column.plaats": "Woonplaats",
    "relatieListView.column.email": "E-mailadres",
    "relatieListView.column.rollen": "Rollen",
    "relatieListView.type.persoon": "Persoon",
    "relatieListView.type.organisatie": "Organisatie",
    "relatieListView.pagination.range": "%d–%d van %d",
    "relatieListView.pagination.page": "Pagina %d van %d",
    "relatieListView.pagination.previous": "Vorige",
    "relatieListView.pagination.next": "Volgende",
    "relatieDetailView.title": "Relatie",
    "relatieDetailView.loadFailed": "Kon de relatie niet laden.",
    "relatieDetailView.tileLoadFailed": "Kon dit onderdeel niet laden.",
    "relatieDetailView.blokkade.title": "Op zwarte lijst",
    "relatieDetailView.blokkade.geenAdoptie": "Geen adoptie toegestaan",
    "relatieDetailView.blokkade.sinds": "sinds",
    "relatieDetailView.blokkade.tot": "tot",
    "relatieDetailView.blokkade.details": "Bekijk details",
    "relatieDetailView.blokkade.opheffen": "Blokkade opheffen",
    "relatieDetailView.blokkade.plaatsen": "Op zwarte lijst plaatsen",
    "relatieDetailView.blokkade.ingetrokkenLabel": "Ingetrokken",
    "relatieDetailView.blokkade.dialog.nieuwTitle": "Op zwarte lijst plaatsen",
    "relatieDetailView.blokkade.dialog.detailsTitle": "Blokkade-details",
    "relatieDetailView.blokkade.dialog.opheffenTitle": "Blokkade opheffen",
    "relatieDetailView.blokkade.plaatsenPrimary": "Plaatsen op zwarte lijst",
    "relatieDetailView.blokkade.form.reden": "Reden",
    "relatieDetailView.blokkade.form.toelichting": "Toelichting",
    "relatieDetailView.blokkade.form.geldigVan": "Geblokkeerd vanaf",
    "relatieDetailView.blokkade.form.geldigTot": "Tot (optioneel)",
    "relatieDetailView.blokkade.form.geldigTotHelp": "Leeg laten = permanent",
    "relatieDetailView.blokkade.form.opheffenReden": "Reden voor opheffen",
    "relatieDetailView.blokkade.err.reden": "Reden is verplicht.",
    "relatieDetailView.blokkade.err.van": "Datum 'Geblokkeerd vanaf' is verplicht.",
    "relatieDetailView.blokkade.err.totVoorVan": "Datum 'Tot' mag niet vóór 'Geblokkeerd vanaf' liggen.",
    "relatieDetailView.blokkade.err.andersToelichting": "Toelichting is verplicht bij reden 'Anders'.",
    "relatieDetailView.blokkade.err.opheffenReden": "Toelichting is verplicht (minimaal 5 karakters).",
    "relatieDetailView.blokkade.saved": "Opgeslagen.",
    "relatieDetailView.blokkade.saveConflict": "Intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "relatieDetailView.blokkade.saveForbidden": "Je hebt geen rechten om blokkades te beheren.",
    "relatieDetailView.blokkade.saveError": "Opslaan mislukt. Probeer opnieuw.",
    "relatieDetailView.status.inactief": "Inactief",
    "relatieDetailView.tab.algemeen": "Algemeen",
    "relatieDetailView.tab.geschiedenis": "Geschiedenis",
    "relatieDetailView.tile.persoonsgegevens": "Persoonsgegevens",
    "relatieDetailView.tile.relatiegegevens": "Relatiegegevens",
    "relatieDetailView.section.persoon": "Persoonsgegevens",
    "relatieDetailView.section.bedrijf": "Bedrijfsgegevens",
    "relatieDetailView.tile.bedrijfsgegevens": "Bedrijfsgegevens",
    "relatieDetailView.tile.facturen": "Facturen",
    "relatieDetailView.facturen.empty": "Er zijn nog geen facturen voor deze relatie.",
    "relatieDetailView.rest": "Rest bekijken (%s)",
    "relatieDetailView.nogMeer": "Nog %s meer · %s totaal",
    "relatieDetailView.restKort": "Rest bekijken",
    "relatieDetailView.facturen.bekijkAlle": "Bekijk alle facturen",
    "relatieDetailView.facturen.nieuwe": "Nieuwe factuur",
    "relatieDetailView.facturen.nieuweGeenRecht": "Je mag geen facturen aanmaken.",
    "relatieDetailView.facturen.nieuweMislukt": "De factuur kon niet worden aangemaakt.",
    "relatieDetailView.facturen.nieuweNietBeschikbaar": "Een factuur aanmaken kan nog niet",
    "relatieDetailView.verblijven.bekijkAlle": "Bekijk alle verblijven",
    "relatieDetailView.velden.titel": "Relatiegegevens velden",
    "relatieDetailView.velden.AANHEF": "Aanhef",
    "relatieDetailView.velden.TUSSENVOEGSEL": "Tussenvoegsel",
    "relatieDetailView.velden.ADRES": "Adresgegevens",
    "relatieDetailView.velden.CONTACT": "Contactgegevens",
    "relatieDetailView.velden.ROL_CATEGORIE": "Rol / categorie",
    "relatieDetailView.velden.knop": "Velden tonen of verbergen",
    "relatieDetailView.velden.FACTUREN_OPENSTAAND": "Totaal openstaand",
    "relatieDetailView.velden.FACTUREN_BETAALD": "Totaal betaald",
    "relatieDetailView.velden.FACTUREN_VERVALLEN": "Totaal vervallen",
    "relatieDetailView.velden.FACTUREN_TOTAAL": "Totaal facturen",
    "relatieDetailView.facturen.totalenTitel": "Facturen totalen",
    "relatieDetailView.facturen.totalenKnop": "Facturen-tile instellingen",
    "relatieDetailView.verblijven.instellingenKnop": "Verblijven-tile instellingen",
    "relatieDetailView.media.instellingenKnop": "Media-tile instellingen",
    "relatieDetailView.tegels.knop": "Tegels tonen of verbergen",
    "relatieDetailView.tegels.titel": "Tegels tonen of verbergen",
    "relatieDetailView.facturen.alleTitel": "Alle facturen",
    "relatieDetailView.verblijven.alleTitel": "Alle verblijven",
    "relatieDetailView.media.restBekijken": "Rest bekijken",
    "relatieDetailView.media.bekijkAlle": "Bekijk alle bestanden",
    "relatieDetailView.media.alleTitel": "Alle bestanden",
    "relatieDetailView.facturen.onderdelen": "Filter op onderdeel",
    "relatieDetailView.facturen.module.ALLE": "Alle onderdelen",
    "relatieDetailView.facturen.module.ASIEL": "Asiel",
    "relatieDetailView.facturen.module.PENSION": "Pension",
    "relatieDetailView.facturen.module.LOSSE_VERKOOP": "Losse verkoop",
    "relatieDetailView.facturen.module.CRECHE": "Crèche",
    "relatieDetailView.facturen.module.OVERIG": "Overig",
    "relatieDetailView.facturen.meer": "Nog %d meer · %d totaal",
    "relatieDetailView.facturen.totaalOpenstaand": "Totaal openstaand",
    "relatieDetailView.facturen.totaalBetaald": "Totaal betaald",
    "relatieDetailView.facturen.totaalVervallen": "Totaal vervallen",
    "relatieDetailView.facturen.totaalFacturen": "Totaal facturen",
    "relatieDetailView.facturen.countOpenstaand": "%d openstaand",
    "relatieDetailView.facturen.countBetaald": "%d betaald",
    "relatieDetailView.facturen.countVervallen": "%d vervallen",
    "relatieDetailView.facturen.col.nummer": "Nr.",
    "relatieDetailView.facturen.col.datum": "Datum",
    "relatieDetailView.facturen.col.verval": "Verval",
    "relatieDetailView.facturen.col.status": "Status",
    "relatieDetailView.facturen.col.bedrag": "Bedrag",
    "relatieDetailView.facturen.status.CONCEPT": "Concept",
    "relatieDetailView.facturen.status.BETAALD": "Betaald",
    "relatieDetailView.facturen.status.OPENSTAAND": "Openstaand",
    "relatieDetailView.verblijven.filter.vestiging": "Vestiging",
    "relatieDetailView.verblijven.filter.alleVestigingen": "Alle vestigingen",
    "relatieDetailView.verblijven.filter.periode": "Periode",
    "relatieDetailView.verblijven.filter.alles": "Alles",
    "relatieDetailView.verblijven.filter.actief": "Lopend",
    "relatieDetailView.verblijven.filter.afgerond": "Afgerond",
    "relatieDetailView.verblijven.filter.geen": "Geen verblijven binnen dit filter.",
    "relatieDetailView.facturen.status.VERVALLEN": "Vervallen",
    "relatieDetailView.tile.verblijven": "Verblijven",
    "relatieDetailView.verblijven.empty": "Er zijn nog geen verblijven bekend voor deze relatie.",
    "relatieDetailView.verblijven.meer": "Nog %d meer · %d totaal",
    "relatieDetailView.verblijven.actief": "Actief verblijf",
    "relatieDetailView.verblijven.totaal": "Totaal verblijven",
    "relatieDetailView.verblijven.laatsteVertrek": "Laatste vertrek",
    "relatieDetailView.verblijven.heden": "heden",
    "relatieDetailView.verblijven.dagen": "%d dagen aanwezig",
    "relatieDetailView.verblijven.dag": "%d dag aanwezig",
    "relatieDetailView.verblijven.col.dier": "Dier",
    "relatieDetailView.verblijven.col.rol": "Rol",
    "relatieDetailView.verblijven.col.vestiging": "Vestiging",
    "relatieDetailView.verblijven.col.opnameSoort": "Opnamesoort",
    "relatieDetailView.verblijven.col.periode": "Periode",
    "relatieDetailView.verblijven.col.duur": "Duur",
    "relatieDetailView.verblijven.col.status": "Status",
    "relatieDetailView.verblijven.status.ACTIEF": "Actief",
    "relatieDetailView.verblijven.status.AFGEROND": "Afgerond",
    "relatieDetailView.tab.pleeggezin": "Pleeggezin",
    "relatieDetailView.pleeggezin.instellingenTitel": "Pleeggezin instellingen",
    "relatieDetailView.pleeggezin.profielTitle": "Pleeggezin instellingen & opvangprofiel",
    "relatieDetailView.pleeggezin.huidigeTitle": "Huidige dieren",
    "relatieDetailView.pleeggezin.dierPlaatsen": "Dier plaatsen",
    "relatieDetailView.pleeggezin.plaatsTitel": "Dier plaatsen bij dit pleeggezin",
    "relatieDetailView.pleeggezin.plaatsen": "Plaatsen",
    "relatieDetailView.pleeggezin.plaatsUitleg": "We tonen alleen aanwezige asieldieren die nog geen pleeggezin hebben en waarvan de diersoort past bij dit pleeggezin. Welke soorten passen, stel je in bij \"Categorieën welkom\" op het tabblad Pleeggezin.",
    "relatieDetailView.pleeggezin.dagenInOpvang": "%s dagen in opvang",
    "relatieDetailView.pleeggezin.zoekDier": "Zoek op diernaam...",
    "relatieDetailView.pleeggezin.geenPlaatsbaar": "Geen plaatsbare dieren.",
    "relatieDetailView.pleeggezin.geenZoekresultaat": "Geen dieren gevonden met deze zoekterm.",
    "relatieDetailView.pleeggezin.plaatsFout": "Het plaatsen van het dier is mislukt.",
    "relatieDetailView.pleeggezin.historieTitle": "Historie dieren",
    "relatieDetailView.pleeggezin.afwTitle": "Afwezigheid",
    "relatieDetailView.pleeggezin.geenProfiel": "Deze relatie heeft nog geen pleeggezin-profiel.",
    "relatieDetailView.pleeggezin.profielAanmaken": "Profiel aanmaken",
    "relatieDetailView.pleeggezin.loginActiefUitleg": "Ja, dit pleeggezin mag inloggen",
    "relatieDetailView.pleeggezin.loginEmailHint": "Standaard overgenomen van de relatiegegevens.",
    "relatieDetailView.pleeggezin.portaalUitleg": "Wanneer login actief is, heeft dit pleeggezin toegang tot het pleeggezinportaal.",
    "relatieDetailView.pleeggezin.loginActief": "Login actief",
    "relatieDetailView.pleeggezin.loginEmail": "E-mailadres login",
    "relatieDetailView.pleeggezin.interneOpmerking": "Interne opmerking",
    "relatieDetailView.pleeggezin.emailVerplicht": "Een e-mailadres is verplicht om de pleeggezin-login te activeren.",
    "relatieDetailView.pleeggezin.opslaanMislukt": "Opslaan mislukt. Probeer het opnieuw.",
    "relatieDetailView.pleeggezin.opgeslagen": "Pleeggezin-profiel opgeslagen.",
    "relatieDetailView.pleeggezin.laatsteLogin": "Laatste login",
    "relatieDetailView.pleeggezin.stuurUitnodiging": "Stuur uitnodiging",
    "relatieDetailView.pleeggezin.resetInloglink": "Reset wachtwoord",
    "relatieDetailView.pleeggezin.uitnodigingVerstuurd": "Uitnodiging verstuurd.",
    "relatieDetailView.pleeggezin.capaciteit": "Capaciteit & voorkeuren per diersoort",
    "relatieDetailView.pleeggezin.geenCapaciteit": "Geen capaciteit ingesteld.",
    "relatieDetailView.pleeggezin.cap.diersoort": "Diersoort",
    "relatieDetailView.pleeggezin.cap.max": "Max. capaciteit",
    "relatieDetailView.pleeggezin.cap.uitleg": "Geef per diersoort de maximale opvangcapaciteit op en selecteer welke categorieën welkom zijn.",
    "relatieDetailView.pleeggezin.cap.min": "Eén minder",
    "relatieDetailView.pleeggezin.cap.plus": "Eén meer",
    "relatieDetailView.pleeggezin.cap.huidig": "Huidig aanwezig",
    "relatieDetailView.pleeggezin.cap.vrij": "Vrij beschikbaar",
    "relatieDetailView.pleeggezin.cap.klaar": "Klaar",
    "relatieDetailView.pleeggezin.cap.geenVestiging": "Geen actieve vestiging geselecteerd — capaciteit bewerken is niet beschikbaar.",
    "relatieDetailView.pleeggezin.cap.geenDiersoorten": "Er staan nog geen diersoorten op pleeggezinnen actief voor deze vestiging.",
    "relatieDetailView.pleeggezin.welkom": "Categorieën welkom",
    "relatieDetailView.pleeggezin.huidigeEmpty": "Op dit moment zijn er geen dieren bij dit pleeggezin.",
    "relatieDetailView.pleeggezin.historieEmpty": "Er zijn nog geen eerdere verblijven voor dit pleeggezin.",
    "relatieDetailView.pleeggezin.cap.voet": "Huidig aanwezig = aantal dieren dat op dit moment bij dit pleeggezin verblijft in de actieve vestiging.",
    "relatieDetailView.pleeggezin.huidigeVoet": "Dagen aanwezig = aantal dagen dat het dier op dit moment bij dit pleeggezin verblijft.",
    "relatieDetailView.pleeggezin.historieVoet": "Hier worden de dieren getoond die eerder bij dit pleeggezin hebben verbleven.",
    "relatieDetailView.pleeggezin.laatsteUpdate": "Laatste update: %s",
    "relatieDetailView.pleeggezin.aanwezig": "Aanwezig",
    "relatieDetailView.pleeggezin.totaalVerblijven": "Totaal verblijven",
    "relatieDetailView.pleeggezin.laatsteVerblijf": "Laatste verblijf",
    "relatieDetailView.pleeggezin.retour": "Retour",
    "relatieDetailView.pleeggezin.retourBevestig": "Plaatsing van %s beëindigen? Het dier komt terug naar het asiel.",
    "relatieDetailView.pleeggezin.retourFout": "De plaatsing kon niet worden beëindigd. Probeer het opnieuw.",
    "relatieDetailView.pleeggezin.dagenVerbleven": "%s dagen verbleven",
    "relatieDetailView.pleeggezin.col.categorie": "Categorie",
    "relatieDetailView.pleeggezin.afw.unavailable": "Afwezigheden tijdelijk niet beschikbaar — probeer het later opnieuw.",
    "relatieDetailView.pleeggezin.afw.empty": "Geen afwezigheden gepland.",
    "relatieDetailView.pleeggezin.afw.col.type": "Type",
    "relatieDetailView.pleeggezin.afw.col.bron": "Bron",
    "relatieDetailView.pleeggezin.afw.bron.person": "Door pleeggezin",
    "relatieDetailView.pleeggezin.afw.bron.organization": "Door opvang",
    "relatieDetailView.pleeggezin.afw.type.vacation": "Vakantie",
    "relatieDetailView.pleeggezin.afw.type.sick": "Ziekte",
    "relatieDetailView.pleeggezin.afw.type.other": "Anders",
    "relatieDetailView.pleeggezin.afw.col.acties": "Acties",
    "relatieDetailView.pleeggezin.afw.toevoegen": "Afwezigheid toevoegen",
    "relatieDetailView.pleeggezin.afw.van": "Van",
    "relatieDetailView.pleeggezin.afw.tot": "Tot",
    "relatieDetailView.pleeggezin.afw.verwijderen": "Verwijderen",
    "relatieDetailView.pleeggezin.afw.momenteel": "Momenteel",
    "relatieDetailView.pleeggezin.afw.volgende": "Volgende afwezigheid",
    "relatieDetailView.pleeggezin.afw.afwezig": "Afwezig",
    "relatieDetailView.pleeggezin.afw.beschikbaar": "Beschikbaar",
    "relatieDetailView.tile.media": "Media & Documenten",
    "relatieDetailView.media.empty": "Er zijn nog geen bestanden voor deze relatie.",
    "relatieDetailView.media.filter.datum": "Datum",
    "relatieDetailView.media.filter.soort": "Soort",
    "relatieDetailView.media.filter.tag": "Tag",
    "relatieDetailView.media.filter.alles": "Alles",
    "relatieDetailView.media.filter.alleTags": "Alle tags",
    "relatieDetailView.media.filter.zesMaanden": "Laatste 6 maanden",
    "relatieDetailView.media.filter.jaar": "Laatste jaar",
    "relatieDetailView.media.filterGeen": "Geen bestanden binnen dit filter.",
    "relatieDetailView.media.download": "Downloaden",
    "relatieDetailView.media.toevoegen": "Bestand toevoegen",
    "relatieDetailView.media.uploaden": "Uploaden",
    "relatieDetailView.media.kiesBestanden": "Bestanden kiezen",
    "relatieDetailView.media.omschrijving": "Omschrijving",
    "relatieDetailView.media.geupload": "Bestand toegevoegd.",
    "relatieDetailView.media.uploadFout": "Uploaden is mislukt.",
    "relatieDetailView.media.verwijderen": "Verwijderen",
    "relatieDetailView.media.verwijderTitel": "Bestand verwijderen",
    "relatieDetailView.media.verwijderBevestiging": "Dit bestand verwijderen?",
    "relatieDetailView.media.verwijderd": "Bestand verwijderd.",
    "relatieDetailView.media.verwijderFout": "Verwijderen is mislukt.",
    "relatieDetailView.tab.donateur": "Donateur",
    "relatieDetailView.donateur.geen": "Geen donateurgegevens voor deze relatie.",
    "relatieDetailView.donateur.geenDonaties": "Geen donaties in deze periode.",
    "relatieDetailView.donateur.periodiekToevoegen": "Periodieke donatie toevoegen",
    "relatieDetailView.donateur.periodiekHint": "Periodieke donaties worden automatisch opgevolgd via betaalafspraken of incasso.",
    "relatieDetailView.donateur.geenPeriodiek": "Er is nog geen periodieke donatie ingesteld.",
    "relatieDetailView.donateur.donateurschapTitle": "Donateurschap",
    "relatieDetailView.donateur.overzichtTitle": "Donatieoverzicht",
    "relatieDetailView.donateur.periodiekTitle": "Periodieke donatie",
    "relatieDetailView.donateur.fiscaalTitle": "Fiscale gegevens",
    "relatieDetailView.donateur.communicatieTitle": "Communicatie & bedankmomenten",
    "relatieDetailView.donateur.communicatieKolom": "Communicatie",
    "relatieDetailView.donateur.bedankmomenten": "Bedankmomenten",
    "relatieDetailView.donateur.bedankmail": "Bedankmail",
    "relatieDetailView.donateur.jaarbedankje": "Jaarbedankje",
    "relatieDetailView.donateur.persoonlijkeKaart": "Persoonlijke kaart",
    "relatieDetailView.donateur.bedank.verzondenOp": "Verzonden op %s",
    "relatieDetailView.donateur.bedank.nogTeVersturen": "Nog te versturen",
    "relatieDetailView.donateur.bedank.teVersturenVanaf": "Te versturen vanaf %s",
    "relatieDetailView.donateur.bedank.nietGepland": "Niet gepland",
    "relatieDetailView.donateur.statusLabel": "Status",
    "relatieDetailView.donateur.statusHint": "Status wordt automatisch bepaald op basis van donaties; zet de schuif uit om het donateurschap handmatig te stoppen.",
    "relatieDetailView.donateur.donateurSinds": "Donateur sinds",
    "relatieDetailView.donateur.status.ACTIEF": "Actief",
    "relatieDetailView.donateur.status.GEPAUZEERD": "Gepauzeerd",
    "relatieDetailView.donateur.status.GESTOPT": "Gestopt",
    "relatieDetailView.donateur.status.INACTIEF": "Inactief",
    "relatieDetailView.donateur.totaalGedoneerd": "Totaal gedoneerd",
    "relatieDetailView.donateur.ditJaar": "Dit jaar",
    "relatieDetailView.donateur.laatsteDonatie": "Laatste donatie",
    "relatieDetailView.donateur.aantal": "Aantal donaties",
    "relatieDetailView.donateur.col.datum": "Datum",
    "relatieDetailView.donateur.col.type": "Type",
    "relatieDetailView.donateur.col.status": "Status",
    "relatieDetailView.donateur.col.bedrag": "Bedrag",
    "relatieDetailView.donateur.type.EENMALIG": "Eenmalig",
    "relatieDetailView.donateur.type.PERIODIEK": "Periodiek",
    "relatieDetailView.donateur.dstatus.BETAALD": "Betaald",
    "relatieDetailView.donateur.dstatus.OPENSTAAND": "Openstaand",
    "relatieDetailView.donateur.dstatus.GEPLAND": "Gepland",
    "relatieDetailView.donateur.periode.alle": "Alle",
    "relatieDetailView.donateur.periode.label": "Periode",
    "relatieDetailView.donateur.periode.maanden": "Laatste %d mnd \u00b7 komende %d mnd",
    "relatieDetailView.donateur.aantalGepland": "%s gepland",
    "relatieDetailView.donateur.bekijkAlleDonaties": "Bekijk alle donaties",
    "relatieDetailView.donateur.onbekend": "Onbekend",
    "relatieDetailView.donateur.geenWaarde": "Geen",
    "relatieDetailView.donateur.inningEnStart": "Volgende inning %s · gestart %s",
    "relatieDetailView.donateur.geenNotitie": "Geen opmerking vastgelegd.",
    "relatieDetailView.donateur.bedankmailSturen": "Bedankmail sturen",
    "relatieDetailView.donateur.berichtVersturen": "Bericht versturen",
    "relatieDetailView.donateur.kaartjePlannen": "Kaartje plannen",
    "relatieDetailView.donateur.actieLater": "Deze actie komt in een latere fase.",
    "relatieDetailView.donateur.betaalwijze": "Betaalwijze",
    "relatieDetailView.donateur.volgendeInning": "Volgende inning",
    "relatieDetailView.donateur.gestartOp": "Gestart op",
    "relatieDetailView.donateur.freq.MAANDELIJKS": "per maand",
    "relatieDetailView.donateur.freq.PER_KWARTAAL": "per kwartaal",
    "relatieDetailView.donateur.freq.JAARLIJKS": "per jaar",
    "relatieDetailView.donateur.payment.AUTOMATISCHE_INCASSO": "Automatische incasso (SEPA)",
    "relatieDetailView.donateur.payment.BANKOVERSCHRIJVING": "Bankoverschrijving",
    "relatieDetailView.donateur.payment.CONTANT": "Contant",
    "relatieDetailView.donateur.payment.PIN": "Pin",
    "relatieDetailView.donateur.payment.IDEAL": "iDEAL",
    "relatieDetailView.donateur.totaalJaar": "Totaal %d",
    "relatieDetailView.donateur.verwachtRestKort": "+ verwacht %s",
    "relatieDetailView.donateur.jaaroverzichtGewenst": "Jaaroverzicht gewenst",
    "relatieDetailView.donateur.bekijken": "Bekijken",
    "relatieDetailView.donateur.contactmoment": "Contactmoment",
    "relatieDetailView.donateur.jaaroverzicht": "Jaaroverzicht",
    "relatieDetailView.donateur.fiscaalHint": "Fiscale documenten en jaaroverzichten worden automatisch opgebouwd vanuit geregistreerde donaties.",
    "relatieDetailView.donateur.verwachtRest": "+ verwacht dit jaar",
    "relatieDetailView.donateur.laatsteOverzicht": "Laatste overzicht",
    "relatieDetailView.donateur.referentie": "Referentie",
    "relatieDetailView.donateur.laatsteContact": "Laatste contact",
    "relatieDetailView.donateur.laatsteBedankmail": "Laatste bedankmail",
    "relatieDetailView.donateur.nieuwsbrief.label": "Nieuwsbrief",
    "relatieDetailView.donateur.nieuwsbrief.aan": "Aangemeld",
    "relatieDetailView.donateur.nieuwsbrief.uit": "Afgemeld",
    "relatieDetailView.donateur.nieuwsbrief.onbekend": "Onbekend",
    "relatieDetailView.donateur.voorkeur": "Voorkeur",
    "relatieDetailView.donateur.interneNotitie": "Interne opmerking",
    "relatieDetailView.donateur.alleDonaties": "Alle donaties",
    "relatieDetailView.donateur.nieuweDonatie": "Nieuwe donatie",
    "relatieDetailView.donateur.nieuwePeriodiek": "Periodieke donatie",
    "relatieDetailView.donateur.bewerken": "Bewerken",
    "relatieDetailView.donateur.hervatten": "Hervatten",
    "relatieDetailView.donateur.geenMandaat": "Geen mandaat",
    "relatieDetailView.donateur.pauzeren": "Pauzeren",
    "relatieDetailView.donateur.stoppen": "Stoppen",
    "relatieDetailView.donateur.dialog.donatieTitle": "Nieuwe donatie",
    "relatieDetailView.donateur.dialog.periodiekTitle": "Periodieke donatie",
    "relatieDetailView.donateur.dialog.periodiekEditTitle": "Periodieke donatie bewerken",
    "relatieDetailView.donateur.dialog.stopTitle": "Periodieke donatie stoppen",
    "relatieDetailView.donateur.dialog.stopConfirm": "Deze periodieke donatie stoppen? De afspraak blijft bewaard voor de geschiedenis.",
    "relatieDetailView.donateur.form.datum": "Datum",
    "relatieDetailView.donateur.form.bedrag": "Bedrag",
    "relatieDetailView.donateur.form.type": "Type",
    "relatieDetailView.donateur.form.frequentie": "Frequentie",
    "relatieDetailView.donateur.form.betaalwijze": "Betaalwijze",
    "relatieDetailView.donateur.form.status": "Status",
    "relatieDetailView.donateur.form.iban": "IBAN",
    "relatieDetailView.donateur.form.omschrijving": "Omschrijving",
    "relatieDetailView.donateur.form.bedankmail": "Bedankmail versturen",
    "relatieDetailView.donateur.form.startdatum": "Startdatum",
    "relatieDetailView.donateur.form.mandaat": "Mandaat aanwezig",
    "relatieDetailView.donateur.form.opmerking": "Opmerking",
    "relatieDetailView.donateur.freqOpt.MAANDELIJKS": "Maandelijks",
    "relatieDetailView.donateur.freqOpt.PER_KWARTAAL": "Per kwartaal",
    "relatieDetailView.donateur.freqOpt.JAARLIJKS": "Jaarlijks",
    "relatieDetailView.donateur.err.datumBedrag": "Datum en bedrag zijn verplicht.",
    "relatieDetailView.donateur.err.bedragStart": "Bedrag en startdatum zijn verplicht.",
    "relatieDetailView.donateur.err.ibanRequired": "IBAN is verplicht bij Automatische incasso.",
    "relatieDetailView.donateur.err.mandaatRequired": "Mandaat is verplicht bij Automatische incasso.",
    "relatieDetailView.donateur.saved": "Opgeslagen.",
    "relatieDetailView.donateur.saveConflict": "Intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "relatieDetailView.donateur.saveForbidden": "Je hebt geen rechten om donateurgegevens te wijzigen.",
    "relatieDetailView.donateur.saveError": "Opslaan mislukt. Probeer opnieuw.",
    "relatieDetailView.donateur.actiefToggle": "Donateurschap actief",
    "relatieDetailView.donateur.dialog.stopProfileTitle": "Donateurschap stoppen",
    "relatieDetailView.donateur.dialog.stopProfileIntro": "Met het stoppen van het donateurschap worden de volgende lopende periodieke donaties direct beëindigd:",
    "relatieDetailView.donateur.dialog.stopProfileConfirm": "Weet je zeker dat je het donateurschap wilt stoppen?",
    "relatieDetailView.tab.dierenarts": "Dierenartspraktijk",
    "relatieDetailView.tab.derdePartij": "Derde partij",
    "relatieDetailView.crematie.huidige": "Huidige prijsafspraken",
    "relatieDetailView.crematie.wijzigen": "Wijzigen",
    "relatieDetailView.crematie.col.datum": "Datum",
    "relatieDetailView.crematie.prijswijzigingen": "Prijswijzigingen",
    "relatieDetailView.crematie.nieuweWijziging": "Nieuwe prijswijziging",
    "relatieDetailView.crematie.nieuwTitel": "Nieuwe prijswijziging",
    "relatieDetailView.crematie.wijzigTitel": "Prijswijziging wijzigen",
    "relatieDetailView.crematie.geenWijzigingen": "Nog geen prijsafspraak vastgelegd.",
    "relatieDetailView.crematie.gewijzigdDoor": "Gewijzigd door",
    "relatieDetailView.crematie.status": "Status",
    "relatieDetailView.crematie.status.ACTIEF": "Actief",
    "relatieDetailView.crematie.status.GEPLAND": "Gepland",
    "relatieDetailView.crematie.status.VERVALLEN": "Vervallen",
    "relatieDetailView.crematie.verwijderTitel": "Prijswijziging verwijderen",
    "relatieDetailView.crematie.verwijderBevestiging": "Deze prijswijziging verwijderen?",
    "relatieDetailView.crematie.opslaanFout": "Het opslaan van de prijswijziging is mislukt.",
    "relatieDetailView.crematie.verwijderFout": "Het verwijderen van de prijswijziging is mislukt.",
    "relatieDetailView.crematie.interneOpmerking": "Interne opmerking",
    "relatieDetailView.crematie.vergoeding": "Vergoeding per aanmelding",
    "relatieDetailView.crematie.vervoersprijs": "Vervoersprijs",
    "relatieDetailView.crematie.btw": "BTW %",
    "relatieDetailView.crematie.ingangsdatum": "Ingangsdatum",
    "relatieDetailView.dierenarts.geenTegels": "Nog geen tegels voor deze rol — de crematoriummodule staat uit.",
    "relatieDetailView.dierenarts.geen": "Deze relatie heeft nog geen prijsafspraak als dierenartspraktijk.",
    "relatieDetailView.derdePartij.geen": "Deze relatie heeft nog geen prijsafspraak als derde partij.",
    "relatieDetailView.section.contactpersoon": "Contactpersoon",
    "relatieDetailView.section.contact": "Contactgegevens",
    "relatieDetailView.section.adres": "Adresgegevens",
    "relatieDetailView.section.rol": "Rollen & labels",
    "relatieDetailView.section.rolCategorie": "Rol / categorie",
    "relatieDetailView.section.rolCategorieHint": "Selecteer één of meerdere rollen die van toepassing zijn",
    "relatieDetailView.section.rolCategorieNote": "Op basis van je selectie worden hieronder extra secties getoond.",
    "relatieDetailView.section.tags": "Tags",
    "relatieDetailView.section.tagsHint": "Voeg labels toe om deze relatie sneller terug te vinden.",
    "relatieDetailView.section.tagToevoegen": "Tag toevoegen",
    "relatieDetailView.section.tagToevoegenKort": "Toevoegen",
    "relatieDetailView.section.tagsDialoog": "Tags toevoegen",
    "relatieDetailView.section.tagsGeen": "Er zijn nog geen tags ingericht.",
    "relatieDetailView.field.aanhef": "Aanhef",
    "relatieDetailView.field.voorletters": "Voorletters",
    "relatieDetailView.field.voornaam": "Voornaam",
    "relatieDetailView.field.tussenvoegsel": "Tussenvoegsel",
    "relatieDetailView.field.achternaam": "Achternaam",
    "relatieDetailView.field.geboortedatum": "Geboortedatum",
    "relatieDetailView.field.bedrijfsnaam": "Bedrijfsnaam (volledig)",
    "relatieDetailView.field.kvk": "KvK-nummer",
    "relatieDetailView.field.btw": "BTW-nummer",
    "relatieDetailView.field.email": "E-mailadres",
    "relatieDetailView.field.telefoon1": "Telefoon 1",
    "relatieDetailView.field.telefoon2": "Telefoon 2",
    "relatieDetailView.field.adres": "Straat",
    "relatieDetailView.field.postcodeWoonplaats": "Postcode / woonplaats",
    "relatieDetailView.field.land": "Land",
    "relatieDetailView.field.type": "Type",
    "relatieDetailView.type.persoon": "Persoon",
    "relatieDetailView.type.organisatie": "Organisatie",
    "relatieDetailView.field.straat": "Straat",
    "relatieDetailView.field.huisnummer": "Huisnr.",
    "relatieDetailView.field.toevoeging": "Toevoeging",
    "relatieDetailView.adres.bestaandeRelaties": "Er staan al %s relaties op dit adres.",
    "relatieDetailView.adres.bekijken": "Bekijken",
    "relatieDetailView.adres.dialoogTitel": "Bestaande relaties op dit adres",
    "relatieDetailView.adres.openen": "Openen",
    "relatieDetailView.field.postcode": "Postcode",
    "relatieDetailView.field.woonplaats": "Woonplaats",
    "relatieDetailView.edit.button": "Bewerken",
    "relatieDetailView.edit.save": "Opslaan",
    "relatieDetailView.edit.cancel": "Annuleren",
    "relatieDetailView.edit.saved": "Opgeslagen.",
    "relatieDetailView.edit.conflict": "Intussen door iemand anders gewijzigd — herlaad en probeer opnieuw.",
    "relatieDetailView.edit.forbidden": "Je hebt geen rechten om relaties te bewerken.",
    "relatieDetailView.edit.error": "Opslaan mislukt. Probeer opnieuw.",
    "relatieDetailView.edit.required": "Achternaam is verplicht.",
    "relatieDetailView.edit.requiredBedrijf": "Bedrijfsnaam is verplicht.",
    "relatieDetailView.edit.rollen": "Rollen",
    "relatieDetailView.edit.labels": "Labels",
    "relatieDetailView.edit.pleeggezinInUse": "Pleeggezin-rol kan niet worden uitgezet: er zijn nog actieve pleegdier-verblijven.",
    "relatieDetailView.history.search": "Zoek in geschiedenis…",
    "relatieDetailView.history.toonMeer": "Toon meer",
    "relatieDetailView.history.systeem": "systeem",
    "relatieDetailView.history.empty": "Nog geen geschiedenis voor deze relatie.",
    "relatieDetailView.history.emptyFiltered": "Geen wijzigingen gevonden voor deze zoekterm.",
    "inboeken.title": "Inboeken",
    "inboeken.editTitle": "Inboeken wijzigen",
    "inboeken.subtitle": "Registreer nieuwe dieren in de opvang",
    "inboeken.editSubtitle": "Pas deze inboeking en de reden ervan aan",
    "inboeken.start": "Inboeken",
    "inboeken.editStart": "Inboeken wijzigen",
    "inboeken.finish": "Inboeken afronden",
    "inboeken.editFinish": "Wijzigingen opslaan",
    // wizard cost-line catalog picker — verbatim FactuurRegelDialog (picker mode) texts
    "wizard.productPicker.title": "Product of tarief toevoegen",
    "wizard.productPicker.subtitle": "Kies een product of tarief uit een van de beschikbare bronnen.",
    "wizard.productPicker.search": "Zoek op product, code of categorie...",
    "wizard.productPicker.selectedTitle": "Geselecteerde regel",
    "wizard.productPicker.selectEmpty": "Selecteer een product of tarief om hier de regel samen te stellen.",
    "wizard.productPicker.aantal": "Aantal",
    "wizard.productPicker.prijs": "Prijs (incl. btw)",
    "wizard.productPicker.prijsHelp": "Prijs is bewerkbaar",
    "wizard.productPicker.omschrijving": "Omschrijving",
    "wizard.productPicker.totaal": "Totaal regel",
    "wizard.productPicker.add": "Toevoegen",
    "wizard.productPicker.aantalInvalid": "Vul een aantal groter dan nul in.",
    "wizard.productPicker.prijsInvalid": "Vul een prijs in.",
    "wizard.productPicker.omschrijvingInvalid": "Vul een omschrijving in.",
    // wizard-jmix-parity: the StepWizard accordion chrome + the animal-count step
    "wizard.confirm": "Bevestigen",
    "wizard.editStep": "Stap bewerken",
    "wizard.count.sub": "De keuze bepaalt hoe de volgende stappen worden ingevuld",
    "wizard.count.single": "Eén dier",
    "wizard.count.multiple": "Meerdere dieren",
    "wizard.count.amount": "Aantal dieren",
    "wizard.count.summary": "Geselecteerd aantal",
    "wizard.animals.add": "Toevoegen",
    "wizard.agreed": "Akkoord",
    "inboeken.count.header": "Hoeveel dieren wil je inboeken?",
    "inboeken.count.singleDesc": "Ik wil één individueel dier inboeken",
    "inboeken.count.multiDesc": "Ik wil meerdere dieren tegelijk inboeken",
    "inboeken.summary.type": "Opname",
    "uitboeken.count.header": "Hoeveel dieren wil je uitboeken?",
    "uitboeken.count.singleDesc": "Ik wil één individueel dier uitboeken",
    "uitboeken.count.multiDesc": "Ik wil meerdere dieren tegelijk uitboeken",
    "uitboeken.summary.type": "Vertrek",
    "wizard.step.count": "Aantal",
    "inboeken.step.type": "Soort",
    "inboeken.step.animals": "Dieren",
    "inboeken.step.ownerConfirm": "Eigenaar controleren",
    "inboeken.step.details": "Gegevens",
    "inboeken.step.chip": "Chipregistratie",
    "inboeken.step.summary": "Controle",
    "inboeken.ownerConfirm.title": "Eigenaar controleren",
    "inboeken.ownerConfirm.question": "Is dit de eigenaar die afstand doet?",
    "inboeken.ownerConfirm.yes": "Ja, dit is de juiste eigenaar",
    "inboeken.ownerConfirm.no": "Nee, dit is niet de juiste eigenaar",
    "inboeken.ownerConfirm.required": "Kies Ja of Nee om door te gaan.",
    "inboeken.ownerConfirm.none": "Geen bekende eigenaar voor dit dier — kies de brenger in de volgende stap.",
    "inboeken.ownerConfirm.changeBringer": "Andere brenger kiezen",
    "inboeken.chip.header": "Chipregistratie",
    "inboeken.chip.info": "Registreer of controleer de chipgegevens voor PetBase.",
    "inboeken.chip.outage": "PetBase is niet bereikbaar. Chipregistratie wordt overgeslagen; je kunt verdergaan met de wizard.",
    "inboeken.chip.field.name": "Diernaam",
    "inboeken.chip.field.gender": "Geslacht",
    "inboeken.chip.field.species": "Diersoort",
    "inboeken.chip.field.breed": "Ras",
    "inboeken.chip.field.coat": "Vacht",
    "inboeken.chip.field.color": "Kleur",
    "inboeken.chip.field.birthDate": "Geboortedatum",
    "inboeken.chip.field.passport": "Paspoortnummer",
    "inboeken.chip.field.features": "Kenmerken",
    "inboeken.chip.field.castrated": "Gecastreerd / gesteriliseerd",
    "inboeken.chip.field.crossBreed": "Kruising",
    "inboeken.chip.field.aanvoerType": "Type registratie",
    "inboeken.chip.field.eventDate": "Datum gebeurtenis",
    "inboeken.chip.field.chipNumber": "Chipnummer",
    "inboeken.chip.field.chipNumber.placeholder": "15 cijfers",
    "inboeken.chip.field.countryOfOrigin": "Land van herkomst",
    "inboeken.chip.field.motherChip": "Chipnummer moeder",
    "inboeken.chip.field.motherChip.placeholder": "15 cijfers, verplicht bij geboorte",
    "inboeken.chip.field.chipInsertDate": "Datum chip ingebracht",
    "inboeken.chip.field.chipper": "Chipper",
    "inboeken.chip.field.chipper.placeholder": "Kies een chipper…",
    "inboeken.chip.field.chipReadDate": "Chip-/afleesdatum",
    "inboeken.chip.aanvoerType.AANVOER_NIEUWE_EIGENAAR": "Aanvoer - Nieuwe eigenaar",
    "inboeken.chip.aanvoerType.AANVOER_NIEUWE_CHIP": "Aanvoer - Nieuwe chip",
    "inboeken.chip.aanvoerType.AANVOER_GEBOORTE": "Aanvoer - Geboorte",
    "inboeken.chip.aanvoerType.AANVOER_IMPORT": "Aanvoer - Import",
    "inboeken.chip.validation.aanvoerType": "Kies een type registratie.",
    "inboeken.chip.validation.eventDate": "Datum gebeurtenis is verplicht.",
    "inboeken.chip.validation.chipFormat": "Chipnummer moet precies 15 cijfers bevatten.",
    "inboeken.chip.validation.countryOfOrigin": "Land van herkomst is verplicht.",
    "inboeken.chip.validation.chipper": "Selecteer een chipper.",
    "inboeken.chip.validation.chipReadDate": "Chip-/afleesdatum is verplicht.",
    "inboeken.chip.validation.motherChip": "Chipnummer moeder is verplicht bij geboorte.",
    "inboeken.chip.validation.motherChipFormat": "Chipnummer moeder moet precies 15 cijfers bevatten.",
    "inboeken.chip.validation.chipInsertDate": "Datum chip ingebracht is verplicht bij nieuwe chip.",
    "inboeken.field.soort": "Soort binnenkomst",
    "inboeken.field.soort.placeholder": "Kies een soort…",
    "inboeken.field.datum": "Datum binnenkomst",
    "inboeken.field.brenger": "Brenger",
    "inboeken.field.vinder": "Vinder",
    "inboeken.field.relatie": "Relatie",
    "inboeken.field.straat": "Straat",
    "inboeken.field.huisnummer": "Huisnummer",
    "inboeken.field.postcode": "Postcode",
    "inboeken.field.plaats": "Plaats",
    "inboeken.field.gemeente": "Gemeente",
    "inboeken.field.gemeente.placeholder": "Kies een gemeente…",
    "inboeken.field.opmerking": "Opmerking",
    "inboeken.field.redenAfstand": "Reden afstand",
    "inboeken.field.retourReden": "Reden retour",
    "inboeken.field.moeder": "Moeder",
    "inboeken.field.geboortedatum": "Geboortedatum",
    "inboeken.birth.dateInfo": "De binnenkomstdatum wordt gelijkgesteld aan de geboortedatum.",
    "inboeken.soort.unavailable": "Deze opname reden is tijdelijk niet beschikbaar.",
    "inboeken.soort.unavailableShort": "tijdelijk niet beschikbaar",
    "inboeken.field.woonplaats.placeholder": "Kies een woonplaats",
    "inboeken.foundLocation.title": "Vindplaats",
    "inboeken.foundLocation.info": "Waar is het dier aangetroffen? Zo nauwkeurig mogelijk.",
    "inboeken.ambulance.question": "Is het dier door een dierenambulance binnengebracht?",
    "inboeken.ambulance.info": "Geef aan of het dier is gebracht door een dierenambulance.",
    "inboeken.ambulance.yes": "Ja",
    "inboeken.ambulance.yes.desc": "Het dier is afgegeven door een dierenambulance",
    "inboeken.ambulance.no": "Nee",
    "inboeken.ambulance.no.desc": "Op een andere manier gebracht",
    "inboeken.field.dierenambulance": "Dierenambulance",
    "inboeken.field.dierenambulance.placeholder": "Maak een keuze",
    "inboeken.field.dierenambulance.required": "Kies de dierenambulance die het dier heeft gebracht.",
    "inboeken.terms.printFailed": "De verklaring kon niet worden afgedrukt. Probeer het opnieuw.",
    "animalDetailView.stay.field.gevondenOpmerking": "Opmerking vindplaats",
    "animalDetailView.stay.v2.map.expand": "Kaart vergroten",
    "inboeken.field.ritnummer": "Ritnummer (optioneel)",
    "inboeken.field.redenAfstand.placeholder": "Maak een keuze",
    "inboeken.field.redenAfstand.required": "Kies een reden voor afstand voordat u verder gaat.",
    "inboeken.field.eigenaar": "Eigenaar",
    "inboeken.field.woonplaats": "Woonplaats",
    "inboeken.field.toevoeging": "Toevoeging",
    "inboeken.field.opmerkingVindplaats": "Opmerking vindplaats (optioneel)",
    "inboeken.field.gedumpt": "Gedumpt",
    "inboeken.gedumpt.ja": "Ja",
    "inboeken.gedumpt.nee": "Nee",
    "inboeken.field.moederdier": "Moederdier",
    "inboeken.field.gemeente.birthPlaceholder": "Selecteer gemeente",
    "inboeken.field.gemeente.birthHelper": "Standaard de gemeente van de huidige vestiging.",
    "inboeken.field.gemeente.required": "Kies een gemeente voordat je doorgaat.",
    "inboeken.field.gemeente.strayRequired": "Kies een gemeente waar het dier is aangetroffen.",
    "inboeken.mother.search": "Zoek op naam of chipnummer",
    "inboeken.mother.notFound": "Geen moederdier gevonden.",
    "inboeken.summary.vindplaats": "Vindplaats",
    "inboeken.animals.openStay": "Dit dier heeft al een lopend verblijf.",
    "inboeken.animals.openStayShort": "al aanwezig",
    "inboeken.relation.email": "E-mailadres",
    "inboeken.relation.postcode": "Postcode",
    "inboeken.relation.huisnummer": "Huisnummer",
    "inboeken.type.header": "Hoe is het dier binnengekomen?",
    "inboeken.type.stray.info": "Gevonden zonder eigenaar",
    "inboeken.type.surrender.info": "Afgestaan door eigenaar",
    "inboeken.type.return.info": "Teruggekomen na adoptie",
    "inboeken.type.exchange.info": "Van/naar ander asiel",
    "inboeken.type.birth.info": "Geboren in het asiel",
    "inboeken.type.wildcatCatsOnly": "Alleen beschikbaar voor katten",
    "inboeken.exchangeSource.title": "Herkomst asiel",
    "inboeken.exchangeSource.info": "Kies het asiel waar het dier vandaan komt.",
    "inboeken.exchangeSource.search": "Zoek op naam of plaats van asiel...",
    "inboeken.exchangeSource.empty": "Er zijn geen asielen beschikbaar om van uit te wisselen.",
    "inboeken.exchangeSource.noMatches": "Geen asielen gevonden voor deze zoekopdracht.",
    "inboeken.exchangeSource.card.email": "E-mail",
    "inboeken.exchangeSource.card.phone": "Telefoon",
    "inboeken.exchangeSource.card.address": "Adres",
    "inboeken.summary.opname": "Opname",
    "inboeken.summary.adres": "Adres",
    "inboeken.summary.afstand": "Afstand",
    "inboeken.summary.retour": "Retour",
    "inboeken.summary.geboorte": "Geboorte",
    "inboeken.summary.title": "Samenvatting registratie",
    "inboeken.summary.title.return": "Samenvatting",
    "inboeken.summary.info": "Controleer de gegevens hieronder voordat je de registratie afrondt.",
    "inboeken.summary.info.surrender": "Controleer de gegevens voor afronden.",
    "inboeken.summary.info.return": "Controleer alle gegevens voordat u de registratie definitief afrondt.",
    "inboeken.summary.section.registratie": "Registratie",
    "inboeken.summary.section.dier": "Dier",
    "inboeken.summary.section.binnenkomst": "Binnenkomst",
    "inboeken.summary.section.vinder": "Vinder",
    "inboeken.summary.section.verklaring": "Afstandsverklaring",
    "inboeken.summary.section.chip": "Chipregistratie",
    "inboeken.summary.section.betaling": "Betaling",
    "inboeken.summary.section.kostenRestitutie": "Kosten & restitutie",
    "inboeken.summary.section.relatie": "Relatie",
    "inboeken.summary.label.naam": "Naam",
    "inboeken.summary.label.chip": "Chipnummer",
    "inboeken.summary.label.geslacht": "Geslacht",
    "inboeken.summary.label.type": "Type",
    "inboeken.summary.label.diersoortRas": "Diersoort / ras",
    "inboeken.summary.label.vachtKleur": "Vacht / kleur",
    "inboeken.summary.label.straat": "Straat",
    "inboeken.summary.label.postcodePlaats": "Postcode / plaats",
    "inboeken.summary.label.ritnummer": "Ritnummer",
    "inboeken.summary.label.telefoon": "Telefoon",
    "inboeken.summary.label.email": "E-mail",
    "inboeken.summary.label.totaal": "Totaal",
    "inboeken.summary.label.paid": "Voldaan",
    "inboeken.summary.label.paymentMethod": "Betaalmethode",
    "inboeken.summary.label.intakeType": "Type binnenkomst",
    "inboeken.summary.label.placedOn": "Geplaatst op",
    "inboeken.summary.label.returnedOn": "Retour op",
    "inboeken.summary.label.duration": "Duur plaatsing",
    "inboeken.summary.label.totalPaid": "Totaal betaalde adoptiekosten",
    "inboeken.summary.label.adoptionCosts": "Adoptiekosten",
    "inboeken.summary.label.chipCosts": "Chipregistratie",
    "inboeken.summary.label.refunded": "Terugbetaald",
    "inboeken.summary.label.restitutionCompleted": "Restitutie verleend",
    "inboeken.summary.label.bedrag": "Bedrag",
    "inboeken.summary.label.rekening": "Rekening",
    "inboeken.summary.label.geboortedatum": "Geboortedatum",
    "inboeken.summary.label.rol": "Rol",
    "inboeken.summary.rol.brenger": "Brenger",
    "inboeken.summary.rol.vinder": "Vinder",
    "inboeken.summary.days": "dagen",
    "inboeken.summary.value.yes": "ja",
    "inboeken.summary.value.no": "nee",
    "inboeken.summary.terms.accepted": "Verklaring gelezen en akkoord",
    "inboeken.summary.terms.acceptedLater": "Niet gelezen en akkoord gegeven",
    "inboeken.summary.terms.notAccepted": "Verklaring niet geaccepteerd",
    "inboeken.summary.terms.signed": "Digitaal ondertekend",
    "inboeken.summary.terms.notSigned": "Niet ondertekend",
    "inboeken.summary.chip.update": "Chipregistratie wordt bijgewerkt",
    "inboeken.summary.chip.none": "Kan niet registreren - geen chipnummer bekend",
    "inboeken.summary.chip.infoReturn": "De chipregistratie zal worden bijgewerkt met de gegevens van onze opvang.",
    "inboeken.summary.notPaid": "Niet voldaan",
    "inboeken.summary.signedOn": "Ondertekend op %s door %s",
    "inboeken.summary.finder.none": "Geen vinder opgegeven.",
    "inboeken.summary.printStray": "Print vindersverklaring",
    "inboeken.summary.printSurrender": "Print afstandsverklaring",
    "inboeken.summary.printReturn": "Print retourverklaring",
    "inboeken.summary.footerNote": "Door op afronden te klikken wordt de registratie definitief opgeslagen.",
    "inboeken.map.label": "Kaart",
    "inboeken.map.info": "Klik op de kaart om de vindplaats te markeren.",
    "inboeken.step.terms": "Verklaring",
    "inboeken.terms.header": "Vindersverklaring",
    "inboeken.terms.info": "Lees onderstaande verklaring zorgvuldig en onderteken om door te gaan.",
    "inboeken.terms.finder": "Gegevens vinder",
    "inboeken.terms.declTitle": "Vindersverklaring",
    "inboeken.terms.declIntro": "De ondergetekende verklaart hierbij:",
    "inboeken.terms.declText": "1. dat het hierboven omschreven dier hem/haar niet in eigendom toebehoort en dat hij/zij geen vermoeden heeft wie de eigenaar en/of verzorger van het dier is;\n2. dat hij/zij van het aantreffen en onder zich nemen van het onbeheerde dier wel/geen aangifte heeft gedaan op grond van art. 5:5 BW;\n3. dat hij/zij alle rechten en plichten die het vinderschap met zich meebrengt overdraagt aan het beheer van het asiel.",
    "inboeken.terms.agree": "Ik heb de vindersverklaring gelezen en ga akkoord met de inhoud *",
    "inboeken.terms.agreeRequired": "Je moet de vindersverklaring accepteren om door te gaan.",
    "inboeken.terms.signature": "Handtekening",
    "inboeken.terms.signaturePlaceholder": "Plaats hier uw handtekening",
    "inboeken.terms.signatureRetry": "Opnieuw tekenen",
    "inboeken.terms.date": "Datum",
    "inboeken.terms.place": "Plaats",
    "inboeken.terms.print": "Print verklaring",
    "inboeken.terms.signatureRequired": "Je moet een handtekening zetten om door te gaan.",
    "inboeken.step.costs": "Kosten",
    "inboeken.step.surrenderTerms": "Voorwaarden",
    "inboeken.costs.header": "Afstandskosten",
    "inboeken.costs.info": "Vul de kosten voor deze afstand in.",
    "inboeken.costs.product": "Omschrijving",
    "inboeken.costs.amount.placeholder": "0,00",
    "inboeken.costs.add": "Product toevoegen",
    "inboeken.costs.empty": "Nog geen kosten toegevoegd.",
    "inboeken.costs.total": "Totale kosten",
    "korting.label": "Korting",
    "betaling.tegengesteld": "Een negatief bedrag kan alleen bij een negatieve factuur — geld terugbetalen gaat via crediteren.",
    "betaling.restantTitel": "Blijft er een bedrag openstaan?",
    "betaling.restantVraag": "Na deze betaling blijft %s openstaan. Klopt dat?",
    "betaling.restantJa": "Ja, laat openstaan",
    "betaling.restantNee": "Nee, terug",
    "korting.placeholder": "Korting",
    "korting.teHoog": "Korting kan niet hoger zijn dan de regel waar hij op staat. Geld terugbetalen gaat via crediteren.",
    "inboeken.returnTerms.total": "Totaal terug",
    "inboeken.costs.propose": "Tarief voorstellen",
    "inboeken.costs.propose.matched": "Tarief voorgesteld: %s — %s",
    "inboeken.costs.propose.none": "Geen passend tarief gevonden voor deze selectie. Voer het bedrag handmatig in.",
    "inboeken.costs.propose.conflict": "Meerdere tarieven matchen even specifiek (%s). Geef er één een hogere prioriteit of verfijn de voorwaarden, of kies handmatig.",
    "inboeken.costs.propose.manual": "Tarief is op aanvraag / in overleg — voer het bedrag handmatig in.",
    "inboeken.costs.propose.noAmount": "Een regel matcht maar heeft geen bedrag (stel een eigen bedrag of een product met prijs in).",
    "inboeken.costs.propose.error": "Kon geen tariefvoorstel ophalen.",
    "inboeken.surrenderTerms.header": "Voorwaarden akkoord",
    "inboeken.surrenderTerms.info": "Lees en accepteer de afstandsvoorwaarden.",
    "inboeken.terms.tag.eigenaar": "Gegevens eigenaar",
    "inboeken.terms.tag.vinder": "Gegevens vinder",
    "inboeken.terms.fact.naam": "Naam",
    "inboeken.terms.fact.adres": "Adres",
    "inboeken.terms.fact.telefoon": "Telefoon",
    "inboeken.terms.fact.email": "E-mail",
    "inboeken.terms.fact.diernaam": "Diernaam",
    "inboeken.terms.fact.chipnummer": "Chipnummer",
    "inboeken.terms.fact.soortRas": "Diersoort / ras",
    "inboeken.surrenderTerms.declTitle": "Afstandsverklaring",
    "inboeken.surrenderTerms.declIntro": "De ondergetekende verklaart voorts:",
    "inboeken.surrenderTerms.declText": "1. eigenaar te zijn van het omschreven dier en dit dier in eigendom over te dragen aan het asiel, zonder voorbehoud afstand te doen van alle rechten en alle stamboompapieren en het dierenpaspoort af te geven;\n2. de enige eigenaar te zijn, of dat een eventuele mede-eigenaar/houder op de hoogte is van en akkoord is met de afstand, en het asiel te vrijwaren tegen claims van derden;\n3. de vragen over de gezondheid en het gedrag van het dier naar waarheid te hebben beantwoord en geen relevante feiten te hebben verzwegen;\n4. akkoord te gaan met de betaling van de met de afstand gepaard gaande kosten en met het bijgaande privacy statement.",
    "inboeken.surrenderTerms.agree": "Ik heb de afstandsverklaring gelezen en ga akkoord met de inhoud en kosten *",
    "inboeken.surrenderTerms.agreeRequired": "Je moet de afstandsverklaring accepteren om door te gaan.",
    "inboeken.surrenderTerms.signLater": "Eigenaar tekent later",
    "inboeken.step.payment": "Betaling",
    "inboeken.step.restitution": "Restitutie",
    "inboeken.payment.header": "Betaling",
    "inboeken.payment.info": "Kies een betaalmethode en voldoe de afstandskosten.",
    "inboeken.payment.due": "Totaal te betalen",
    "inboeken.payment.step1": "1. Betaalmethode",
    "inboeken.payment.step2": "2. Betalingsgegevens",
    "inboeken.payment.combi": "Combinatie",
    "inboeken.payment.invoice": "Op factuur",
    "inboeken.payment.invoiceOpen": "Factuur (openstaand)",
    "inboeken.payment.invoiceRemark": "Factuuropmerking (optioneel)",
    "inboeken.payment.invoiceRemark.placeholder": "Bijvoorbeeld: Restbedrag volgens afspraak",
    "inboeken.payment.invoiceNote": "Factuur wordt aangemaakt voor het openstaande bedrag.",
    "inboeken.payment.overview": "Betalingsoverzicht",
    "inboeken.payment.open": "Openstaand",
    "inboeken.payment.pin": "Pinbetaling",
    "inboeken.payment.cash": "Contant",
    "inboeken.payment.later": "Betaalt later",
    "inboeken.payment.paid": "Totaal voldaan",
    "inboeken.payment.remaining": "Nog te betalen",
    "inboeken.restitution.header": "Overzicht retour",
    "inboeken.restitution.info": "Krijgt de klant geld terug?",
    "inboeken.restitution.yes": "Ja, (gedeeltelijke) restitutie",
    "inboeken.restitution.no": "Nee, geen restitutie",
    "inboeken.restitution.amount": "Restitutiebedrag",
    "inboeken.returnPayment.header": "Terugbetalen",
    "inboeken.returnPayment.info": "Kies een betaalmethode en verwerk de restitutie.",
    "inboeken.returnPayment.toRefund": "Totale terugbetaling",
    "inboeken.returnPayment.method": "Methode",
    "inboeken.returnPayment.method.placeholder": "Maak een keuze",
    "inboeken.returnPayment.transfer": "Terugstorten op rekening",
    "inboeken.returnPayment.pin": "Terug pinnen",
    "inboeken.returnPayment.cash": "Contant terugbetalen",
    "inboeken.returnPayment.iban": "IBAN",
    "inboeken.returnPayment.ibanRequired": "IBAN is verplicht voor terugstorten op rekening.",
    "inboeken.returnPayment.ibanInvalid": "Voer een geldig IBAN-nummer in.",
    "inboeken.returnPayment.ibanPlaceholder": "NL00 BANK 0000 0000 00",
    "inboeken.returnPayment.amount": "Bedrag",
    "inboeken.returnPayment.amountDue": "Terug te betalen bedrag",
    "inboeken.returnPayment.add": "Toevoegen",
    "inboeken.returnPayment.paymentsTitle": "Terugbetalingen",
    "inboeken.returnPayment.colAmount": "Bedrag (€)",
    "inboeken.returnPayment.colAction": "Actie",
    "inboeken.returnPayment.totalRefund": "Totale terugbetaling:",
    "inboeken.returnPayment.totalPaidOut": "Uitgekeerd bedrag:",
    "inboeken.returnPayment.remaining": "Restitutie resterend:",
    "inboeken.returnPayment.remarkLabel": "Opmerking (optioneel):",
    "inboeken.returnPayment.remarkPlaceholder": "Eventuele opmerkingen",
    "inboeken.returnPayment.remark": "Opmerking (optioneel)",
    "inboeken.returnPayment.paidOut": "Totaal uitbetaald",
    "inboeken.returnPayment.open": "Openstaand",
    "inboeken.returnPayment.stillToPay": "Nog uit te betalen",
    "inboeken.ownerConfirm.summary": "Eigenaar bevestigd",
    "inboeken.ownerConfirm.ownerTitle": "Eigenaar",
    "inboeken.ownerConfirm.contactTitle": "Contactgegevens",
    "inboeken.returnOwnerConfirm.title": "Retour na plaatsing",
    "inboeken.returnOwnerConfirm.question": "Is dit de correcte eigenaar?",
    "inboeken.returnOwnerConfirm.changeOwner": "Andere eigenaar kiezen",
    "inboeken.field.retourReden.placeholder": "Kies een reden",
    "inboeken.restitution.overview": "Overzicht van de plaatsing en betaalde adoptiekosten",
    "inboeken.restitution.placedOn": "Geplaatst op:",
    "inboeken.restitution.returnOn": "Retour op:",
    "inboeken.restitution.daysAtOwner": "Dier is bij de eigenaar geweest:",
    "inboeken.restitution.daysSuffix": "dagen",
    "inboeken.restitution.costsTitle": "Adoptiekosten",
    "inboeken.restitution.costsDescription": "Omschrijving",
    "inboeken.restitution.costsAmount": "Bedrag",
    "inboeken.restitution.totalPaid": "Totaal betaald",
    "inboeken.restitution.max": "Maximaal",
    "inboeken.restitution.ownerMismatch": "Let op: geselecteerde eigenaar komt niet overeen met de eigenaar op de factuur.",
    "inboeken.restitution.remarkPlaceholder": "Toelichting op de retour (optioneel)",
    "inboeken.animals.search": "Zoek een dier op naam, chip of ras…",
    "inboeken.animals.none": "Nog geen dieren gekozen.",
    "inboeken.animals.countRange": "Vul een aantal tussen 2 en 10 dieren in",
    "inboeken.animals.remove": "Verwijderen",
    "inboeken.newAnimal.start": "Nieuw dier",
    "inboeken.newAnimal.naam": "Naam",
    "inboeken.newAnimal.diersoort": "Diersoort",
    "inboeken.newAnimal.diersoort.placeholder": "Kies een diersoort…",
    "inboeken.newAnimal.geslacht": "Geslacht",
    "inboeken.newAnimal.geslacht.placeholder": "Onbekend",
    "inboeken.newAnimal.add": "Dier toevoegen",
    "inboeken.newAnimal.chip": "Chipnummer",
    "inboeken.newAnimal.chip.placeholder": "Vul het 15-cijferige chipnummer in",
    "inboeken.newAnimal.chipFormat": "Chipnummer moet exact 15 cijfers bevatten (of leeg zijn).",
    "inboeken.newAnimal.chipDuplicate": "Chipnummer %s is al geregistreerd bij \"%s\". Dit dier kan niet opnieuw worden ingeschreven.",
    "inboeken.newAnimal.chipDuplicate.use": "Gebruik bestaand dier",
    "inboeken.newAnimal.naamRequired": "Vul een diernaam in voordat je verdergaat.",
    "inboeken.newAnimal.diersoortRequired": "Selecteer een diersoort voordat je verdergaat.",
    "inboeken.newAnimal.ras": "Ras",
    "inboeken.newAnimal.ras.placeholder": "Ras",
    "inboeken.newAnimal.vacht": "Vacht",
    "inboeken.newAnimal.vacht.placeholder": "Selecteer vacht",
    "inboeken.newAnimal.kleur": "Kleur",
    "inboeken.newAnimal.kleur.placeholder": "Kleur",
    "inboeken.newAnimal.casSter": "Cas./Ster",
    "inboeken.newAnimal.kruising": "Kruising",
    "inboeken.search.header": "Zoek dier",
    "inboeken.search.naam": "Naam dier",
    "inboeken.search.button": "Zoeken",
    "inboeken.search.minOne": "Vul minimaal één zoekveld in om te zoeken.",
    "inboeken.search.chipAutoSelected": "Eén chipmatch gevonden. Dier is automatisch geselecteerd.",
    "inboeken.results.header": "Zoekresultaten",
    "inboeken.results.none": "Geen dieren gevonden.",
    "inboeken.results.select": "Selecteer",
    "inboeken.results.view": "Weergave",
    "inboeken.results.cardView": "Kaartweergave",
    "inboeken.results.listView": "Lijstweergave",
    "inboeken.results.noPhoto": "Geen foto",
    "inboeken.results.alreadySelected": "Dier is al geselecteerd voor deze intake.",
    "inboeken.details.header": "Dier",
    "inboeken.details.newBanner": "Geen resultaten gevonden – vul de gegevens in voor het nieuwe dier.",
    "inboeken.details.confirm": "Bevestig dier",
    "inboeken.photo.upload": "Upload foto van het dier",
    "inboeken.photo.info": "Upload een foto van het dier (ook via camera) voor AI-voorinvulling",
    "inboeken.photo.aiPrefillApplied": "AI heeft beschikbare gegevens uit het bestand ingevuld.",
    "inboeken.photo.passportScan": "Scan foto van paspoort",
    "inboeken.photo.passportError": "Fout bij verwerken paspoortfoto",
    "inboeken.photo.previewAlt": "Foto van het dier",
    "uitboeken.animals.presentHeader": "Aanwezige dieren",
    "inboeken.relation.none": "Geen",
    "inboeken.relation.change": "Wijzigen",
    "inboeken.relation.close": "Sluiten",
    "inboeken.relation.clear": "Wissen",
    "inboeken.relation.search": "Zoek een relatie op naam…",
    // Relatie-subwizard (stapvariant — Jmix relation-find / -search-results fragments).
    "inboeken.relation.edit.info": "Controleer en vul de gegevens van de eigenaar aan.",
    "inboeken.relation.edit.save": "Gegevens opslaan",
    "inboeken.relation.edit.saved": "Gegevens opgeslagen.",
    "inboeken.relation.edit.error": "Opslaan van de gegevens is mislukt.",
    "inboeken.relation.edit.other": "Andere eigenaar kiezen",
    "inboeken.field.opmerkingen": "Opmerkingen",
    "inboeken.field.redenAfstand.remarkPlaceholder": "Eventuele toelichting op de reden van afstand",
    "inboeken.relation.findTitle": "Zoek eigenaar",
    "inboeken.relation.findFinderTitle": "Zoek vinder",
    "inboeken.relation.findInfo.surrender": "Wie doet afstand?",
    "inboeken.relation.findInfo.return": "Wie brengt het dier terug?",
    "inboeken.relation.findInfo.stray": "Wie is de vinder?",
    "inboeken.relation.emailSearch.title": "Zoeken op e-mailadres",
    "inboeken.relation.addressSearch.title": "Zoek op adres",
    "inboeken.relation.addressSearch.placeholder": "Typ straat, stad of postcode…",
    "inboeken.relation.addressSearch.unavailable": "Adres zoeken is niet beschikbaar: deze server heeft geen Postcode.eu-sleutel.",
    "inboeken.relation.separator": "en/of",
    "inboeken.relation.searchAction": "Zoeken",
    "inboeken.relation.results.title": "Zoekresultaten",
    "inboeken.relation.results.info":
      "Kies een bestaande relatie uit de zoekresultaten of ga verder om een nieuwe relatie vast te leggen.",
    "inboeken.relation.results.empty": "Geen relaties gevonden op basis van de zoekcriteria.",
    "inboeken.relation.search.hint": "Typ een naam, e-mailadres of postcode om te zoeken.",
    "inboeken.relation.select": "Selecteren",
    "inboeken.relation.blocked": "Op zwarte lijst",
    "inboeken.relation.noFinder": "Geen vinder",
    "inboeken.relation.create.start": "Nieuwe relatie aanmaken",
    "inboeken.relation.create.title": "Nieuwe relatie",
    "inboeken.relation.create.bedrijfsnaam": "Bedrijfsnaam",
    "inboeken.relation.create.aanhef": "Aanhef",
    "inboeken.relation.create.voorletters": "Voorletters",
    "inboeken.relation.create.tussenvoegsel": "Tussenvoegsel",
    "inboeken.relation.create.achternaam": "Achternaam",
    "inboeken.relation.create.postcode": "Postcode",
    "inboeken.relation.create.adresVerplicht": "Postcode en huisnummer zijn verplicht, zodat het adres bij de relatie wordt opgeslagen.",
    "inboeken.relation.create.adresNodig": "Verplicht",
    "inboeken.relation.create.huisnummer": "Huisnummer",
    "inboeken.relation.create.toevoeging": "Toevoeging",
    "inboeken.relation.create.straat": "Straatnaam",
    "inboeken.relation.create.woonplaats": "Plaats",
    "inboeken.relation.create.land": "Land",
    "inboeken.relation.create.email": "E-mailadres",
    "inboeken.relation.create.telefoon": "Telefoonnummer",
    "inboeken.relation.create.telefoon2": "Telefoonnummer 2",
    "inboeken.relation.create.opmerking": "Opmerking",
    "inboeken.relation.create.submit": "Relatie aanmaken",
    "inboeken.relation.create.forbidden": "U heeft geen rechten om een nieuwe relatie aan te maken.",
    "inboeken.relation.create.error": "De relatie kon niet worden aangemaakt.",
    "inboeken.notice.conflict": "Dit verblijf is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "inboeken.notice.invalid": "Het inboeken kon niet worden afgerond — controleer de velden.",
    "inboeken.notice.error": "Er ging iets mis bij het inboeken.",
    // Uitboeken (release) wizard — de tegenhanger van inboeken (hergebruikt veel inboeken.*-sleutels).
    "uitboeken.title": "Uitboeken",
    "uitboeken.start": "Uitboeken",
    "uitboeken.finish": "Bevestigen en afronden",
    "uitboeken.step.type": "Soort",
    "uitboeken.step.animals": "Dieren",
    "uitboeken.step.newOwner": "Nieuwe eigenaar",
    "uitboeken.step.owner": "Eigenaar",
    "uitboeken.step.costs": "Kosten",
    "uitboeken.step.terms": "Voorwaarden",
    "uitboeken.step.payment": "Betaling",
    "uitboeken.step.details": "Gegevens",
    "uitboeken.step.declaration": "Verklaring",
    "uitboeken.step.chip": "Chip afmelden",
    "uitboeken.step.petbaseChip": "Chipregistratie",
    "uitboeken.step.summary": "Controle",
    "uitboeken.blokkade.title": "Relatie staat op de zwarte lijst",
    "uitboeken.blokkade.subtitle": "Adoptie naar deze relatie is geblokkeerd",
    "uitboeken.blokkade.overrideReden": "Reden voor het overrulen van de blokkade",
    "uitboeken.blokkade.overridePlaceholder": "Licht toe waarom deze adoptie ondanks de blokkade is toegestaan (min. 10 tekens)…",
    "uitboeken.blokkade.noOverrule": "Je hebt geen rechten om deze blokkade te overrulen — kies een andere relatie of neem contact op met een beheerder.",
    "uitboeken.type.header": "Hoe verlaat het dier het asiel?",
    "uitboeken.type.adoption.info": "Het dier wordt geplaatst bij een nieuwe eigenaar.",
    "uitboeken.type.return.info": "Het dier gaat retour naar de oorspronkelijke eigenaar.",
    "uitboeken.type.euthanasia.info": "Het dier is geëuthanaseerd.",
    "uitboeken.type.deceased.info": "Het dier is overleden.",
    "uitboeken.type.nature.info": "Het dier wordt teruggezet in de natuur.",
    "uitboeken.type.exchange.info": "Overdracht naar een ander asiel.",
    "uitboeken.animals.info": "Selecteer het dier of de dieren om uit te boeken. Alleen dieren die in het asiel aanwezig zijn kunnen worden uitgeboekt.",
    "uitboeken.animals.notResident": "Dit dier heeft geen open verblijf om af te sluiten.",
    "uitboeken.animals.notResidentShort": "niet aanwezig",
    "uitboeken.field.releaseDate": "Vertrekdatum",
    "uitboeken.field.newOwner": "Nieuwe eigenaar",
    "uitboeken.field.owner": "Oorspronkelijke eigenaar",
    "uitboeken.field.soort": "Soort vertrek",
    "uitboeken.costs.header": "Plaatsingskosten",
    "uitboeken.costs.info": "Voeg de plaatsingskostenregels toe. Bij afronden wordt een conceptfactuur voor de nieuwe eigenaar aangemaakt.",
    "uitboeken.payment.header": "Betaling",
    "uitboeken.payment.info": "Kies een betaalmethode en voldoe de adoptiekosten.",
    "uitboeken.payment.methodRequired": "Registreer minimaal één betaling voordat je verdergaat.",
    // Betaal-UI methode-rijen — verbatim AdoptionPaymentFragment (messages_nl) teksten
    "uitboeken.payment.method.pin": "Pin",
    "uitboeken.payment.method.cash": "Contant",
    "uitboeken.payment.method.later": "Later betalen",
    "uitboeken.payment.add": "Toevoegen",
    "uitboeken.payment.paymentsTitle": "Betalingen",
    "uitboeken.payment.colMethod": "Methode",
    "uitboeken.payment.colAmount": "Bedrag",
    "uitboeken.payment.totalDue": "Totaal te betalen",
    "uitboeken.payment.totalPaid": "Totaal betaald",
    "uitboeken.payment.remaining": "Resterend",
    "uitboeken.payment.remarkPlaceholder": "Optionele opmerking bij de betaling",
    // Nazorg-kaart op het adoptieoverzicht — verbatim AdoptionSummaryFragment-teksten
    "uitboeken.nazorg.check": "Taak voor nazorg aanmaken",
    "uitboeken.nazorg.hint": "Het systeem maakt een taak bij het dier om na de ingestelde dagen automatisch een nazorg-uitnodiging te versturen.",
    // Completion-feedback — verbatim ShelterReleaseDetailView-notificatie
    "uitboeken.done.factuur": "Concept-factuur #%s aangemaakt voor de adoptie.",
    "uitboeken.adoptionTerms.header": "Plaatsingsovereenkomst",
    "uitboeken.adoptionTerms.info": "Neem de plaatsingsovereenkomst door met de nieuwe eigenaar en leg de handtekening vast.",
    "uitboeken.adoptionTerms.declTitle": "Plaatsingsovereenkomst",
    "uitboeken.adoptionTerms.declIntro": "De nieuwe eigenaar gaat akkoord met de volgende plaatsingsvoorwaarden.",
    "uitboeken.adoptionTerms.declText": "Ondergetekende neemt het hierboven omschreven dier in ontvangst en verklaart er verantwoord voor te zorgen en de getoonde plaatsingskosten te voldoen.",
    "uitboeken.adoptionTerms.agree": "De nieuwe eigenaar gaat akkoord met de plaatsingsvoorwaarden.",
    "uitboeken.adoptionTerms.signLater": "Eigenaar tekent later",
    "uitboeken.adoptionTerms.agreeRequired": "Je moet de plaatsingsovereenkomst accepteren om door te gaan.",
    "uitboeken.returnCosts.header": "Retourkosten",
    "uitboeken.returnCosts.info": "Deze kosten staan op de retourverklaring die de eigenaar tekent en kunnen aan de balie worden betaald. Er wordt geen factuur aangemaakt.",
    "uitboeken.returnCosts.opvang": "Opvangkosten",
    "uitboeken.returnCosts.ambulance": "Dierenambulance",
    "uitboeken.returnCosts.vet": "Dierenarts",
    "uitboeken.returnCosts.admin": "Administratiekosten",
    "uitboeken.returnCosts.day": "dag",
    "uitboeken.returnCosts.days": "dagen",
    "uitboeken.returnPayment.header": "Betaling",
    "uitboeken.returnPayment.info": "Kies een betaalmethode en voldoe de retourkosten.",
    "uitboeken.return.stay.intakeDate": "Binnengekomen op",
    "uitboeken.return.stay.releaseDate": "Retour op",
    "uitboeken.return.stay.ambulance": "Dierenambulance",
    "uitboeken.return.ownerSuggestion.note": "Voorgesteld op basis van de inname van het dier.",
    "uitboeken.return.ownerSuggestion.search": "Andere eigenaar zoeken",
    "uitboeken.relation.findInfo.adoption": "Wie wordt de nieuwe eigenaar?",
    "uitboeken.relation.findInfo.return": "Wie is de eigenaar?",
    "uitboeken.adoption.knownOwner.title": "Eigenaar controleren",
    "uitboeken.adoption.knownOwner.question": "Wordt het dier bij deze eigenaar geplaatst?",
    "uitboeken.adoption.knownOwner.yes": "Ja, deze eigenaar",
    "uitboeken.adoption.knownOwner.no": "Nee, andere eigenaar zoeken",
    "uitboeken.return.knownOwner.question": "Gaat het dier terug naar deze eigenaar?",
    "uitboeken.return.knownOwner.yes": "Ja, deze eigenaar",
    "uitboeken.return.knownOwner.no": "Nee, andere eigenaar zoeken",
    "uitboeken.returnDeclaration.header": "Retourverklaring",
    "uitboeken.returnDeclaration.info": "Neem de retourverklaring door met de eigenaar en leg de handtekening vast.",
    "uitboeken.returnDeclaration.declTitle": "Retourverklaring",
    "uitboeken.returnDeclaration.declIntro": "De eigenaar bevestigt dat hij/zij het dier ophaalt.",
    "uitboeken.returnDeclaration.declText": "Ondergetekende bevestigt eigenaar te zijn van het hierboven omschreven dier en dat het in goede gezondheid uit het asiel wordt opgehaald.",
    "uitboeken.returnDeclaration.agree": "De eigenaar gaat akkoord met de retourverklaring.",
    "uitboeken.returnDeclaration.agreeRequired": "Je moet de retourverklaring accepteren om door te gaan.",
    "uitboeken.euthanasia.date": "Datum euthanasie",
    "uitboeken.euthanasia.performer": "Uitgevoerd door",
    "uitboeken.euthanasia.performer.placeholder": "Kies…",
    "uitboeken.euthanasia.vetName": "Naam dierenarts",
    "uitboeken.euthanasia.vetPractice": "Praktijk (optioneel)",
    "uitboeken.euthanasia.reason": "Reden euthanasie",
    "uitboeken.euthanasia.reason.placeholder": "Kies…",
    "uitboeken.euthanasia.remarks": "Opmerkingen",
    "uitboeken.chip.header": "Chip afmelden",
    "uitboeken.chip.info": "Meld elk dier af bij de chipregistratie.",
    "uitboeken.chip.none": "Geen van de geselecteerde dieren heeft een chipnummer.",
    "uitboeken.chip.deregister": "Chipregistratie is afgemeld",
    "uitboeken.petbaseChip.header": "Chipregistratie",
    "uitboeken.petbaseChip.info": "Controleer of corrigeer de chipgegevens vóór het uitboeken; de bijwerking naar PetBase (afvoer en, bij een adoptie/retour, de nieuwe eigenaar) wordt op de achtergrond verstuurd.",
    "uitboeken.petbaseChip.registered": "Chip is geregistreerd",
    "uitboeken.petbaseChip.validation.chipFormat": "Chipnummer moet exact 15 cijfers bevatten.",
    "uitboeken.deceased.date": "Datum overlijden",
    "uitboeken.deceased.cause": "Oorzaak overlijden",
    "uitboeken.deceased.cause.placeholder": "Kies…",
    "uitboeken.deceased.causeOther": "Andere oorzaak",
    "uitboeken.deceased.externalVet": "Was er een externe dierenarts betrokken?",
    "uitboeken.deceased.vetName": "Naam dierenarts",
    "uitboeken.deceased.vetReference": "Referentienummer (optioneel)",
    "uitboeken.deceased.remarks": "Opmerkingen",
    "uitboeken.nature.date": "Uitzetdatum",
    "uitboeken.nature.remark": "Opmerking uitzetlocatie (optioneel)",
    "uitboeken.nature.vetCheck": "Dierenarts-fitheidscontrole uitgevoerd",
    "uitboeken.nature.mapInfo": "De kaart start rondom de geselecteerde vestiging. Klik op de kaart om de uitzetlocatie met een pin te markeren.",
    "uitboeken.nature.place.label": "Uitzetlocatie",
    "uitboeken.nature.place.found": "Op de gevonden/gevangen locatie",
    "uitboeken.nature.place.other": "Andere locatie",
    "uitboeken.nature.place.otherInfo": "Vul het adres in of klik op de kaart",
    "uitboeken.nature.place.foundUnknown": "Geen vindplaats vastgelegd bij de intake",
    "uitboeken.nature.mapLocked": "Het dier gaat terug naar de vindplaats; kies \"Andere locatie\" om dit te wijzigen.",
    "uitboeken.details.required": "Vul de verplichte velden in om door te gaan.",
    "uitboeken.soort.unavailable": "Deze uitgifte reden is tijdelijk niet beschikbaar.",
    "uitboeken.count.helper": "Voer een aantal tussen 2 en 10 in",
    "uitboeken.typeChange.title": "Vertreksoort wijzigen?",
    "uitboeken.typeChange.body": "Door de vertreksoort te wijzigen worden de reeds ingevulde vervolgstappen verwijderd. Doorgaan?",
    "uitboeken.typeChange.confirm": "Ja, wijzigen",
    "uitboeken.summary.vertrek": "Vertrek",
    "uitboeken.summary.printReturn": "Print retourverklaring",
    "uitboeken.summary.euthanasia": "Euthanasie",
    "uitboeken.summary.deceased": "Overlijden",
    "uitboeken.summary.nature": "Uitzetlocatie",
    "uitboeken.summary.title": "Samenvatting",
    "uitboeken.summary.title.adoption": "Adoptieoverzicht",
    "uitboeken.summary.title.return": "Retour eigenaar — samenvatting",
    "uitboeken.summary.title.nature": "Uitzetten — samenvatting",
    "uitboeken.summary.title.exchange": "Uitwisseling — samenvatting",
    "uitboeken.summary.info": "Controleer alle gegevens zorgvuldig voordat de uitschrijving wordt afgerond.",
    "uitboeken.summary.info.adoption": "Controleer alle gegevens en rond de plaatsing af.",
    "uitboeken.summary.info.euthanasia": "Controleer alle gegevens voordat je de euthanasie definitief afrondt.",
    "uitboeken.summary.info.deceased": "Controleer alle gegevens zorgvuldig voordat je de uitboeking definitief afrondt.",
    "uitboeken.summary.section.dier": "Dier",
    "uitboeken.summary.section.plaatsing": "Plaatsing",
    "uitboeken.summary.section.newOwner": "Nieuwe eigenaar",
    "uitboeken.summary.section.betaling": "Betaling",
    "uitboeken.summary.section.kosten": "Kosten",
    "uitboeken.summary.section.overeenkomst": "Plaatsingsovereenkomst",
    "uitboeken.summary.section.chip": "Chipregistratie",
    "uitboeken.summary.section.owner": "Oorspronkelijke eigenaar",
    "uitboeken.summary.section.retour": "Retour gegevens",
    "uitboeken.summary.section.remarks": "Opmerkingen",
    "uitboeken.summary.section.release": "Uitzetgegevens",
    "uitboeken.summary.section.party": "Ontvangende organisatie",
    "uitboeken.summary.section.exchange": "Uitwisselingsgegevens",
    "uitboeken.summary.label.naam": "Naam",
    "uitboeken.summary.label.chip": "Chipnummer",
    "uitboeken.summary.label.diersoortRas": "Diersoort / ras",
    "uitboeken.summary.label.geslacht": "Geslacht",
    "uitboeken.summary.label.status": "Status",
    "uitboeken.summary.status.adoption": "Geplaatst",
    "uitboeken.summary.status.return": "Retour eigenaar",
    "uitboeken.summary.status.euthanasia": "Geëuthanaseerd",
    "uitboeken.summary.status.deceased": "Overleden",
    "uitboeken.summary.status.nature": "TNRC",
    "uitboeken.summary.status.exchange": "Uitgewisseld",
    "uitboeken.summary.label.releaseType": "Type plaatsing",
    "uitboeken.summary.label.releaseDate": "Datum plaatsing",
    "uitboeken.summary.label.adres": "Adres",
    "uitboeken.summary.label.email": "E-mail",
    "uitboeken.summary.label.telefoon": "Telefoon",
    "uitboeken.summary.label.paid": "Voldaan",
    "uitboeken.summary.label.paymentMethod": "Betaald via",
    "uitboeken.summary.label.total": "Totaal",
    "uitboeken.summary.notPaid": "Niet voldaan",
    "uitboeken.summary.costs.empty": "Geen kostenregels",
    "uitboeken.summary.terms.accepted": "Overeenkomst gelezen en akkoord",
    "uitboeken.summary.terms.signed": "Digitaal ondertekend",
    "uitboeken.summary.terms.notSigned": "Niet ondertekend",
    "uitboeken.summary.label.signatureDate": "Datum ondertekening",
    "uitboeken.summary.label.signaturePlace": "Plaats ondertekening",
    "uitboeken.summary.chip.note": "De chipregistratie zal worden bijgewerkt met de gegevens van de nieuwe eigenaar.",
    "uitboeken.summary.chip.none": "Geen chipnummer bekend",
    "uitboeken.summary.chip.updatedFor": "Chipregistratie bijgewerkt voor",
    "uitboeken.summary.chip.noChipReturn": "Dier heeft geen chipnummer",
    "uitboeken.summary.label.owner": "Eigenaar",
    "uitboeken.summary.label.contact": "Contact",
    "uitboeken.summary.label.returnDate": "Retourdatum",
    "uitboeken.summary.label.notes": "Opmerkingen",
    "uitboeken.summary.notes.none": "Geen opmerkingen",
    "uitboeken.summary.label.euthDate": "Datum euthanasie",
    "uitboeken.summary.label.performer": "Uitgevoerd door",
    "uitboeken.summary.label.practice": "Praktijk",
    "uitboeken.summary.label.reason": "Reden",
    "uitboeken.summary.remarks.none": "Geen opmerking toegevoegd",
    "uitboeken.summary.label.dateOfDeath": "Datum overlijden",
    "uitboeken.summary.label.causeOfDeath": "Oorzaak",
    "uitboeken.summary.label.externalVet": "Externe dierenarts",
    "uitboeken.summary.label.natureDate": "Uitzetdatum",
    "uitboeken.summary.label.vetCheck": "Dierenarts-fitheidscontrole",
    "uitboeken.summary.vetCheck.done": "Uitgevoerd",
    "uitboeken.summary.vetCheck.notDone": "Niet uitgevoerd",
    "uitboeken.summary.label.straat": "Straat",
    "uitboeken.summary.label.postcodePlaats": "Postcode / woonplaats",
    "uitboeken.summary.label.receivingParty": "Ontvangende organisatie",
    "uitboeken.summary.label.exchangeDate": "Uitwisselingsdatum",
    "uitboeken.summary.reason.none": "Geen reden opgegeven",
    "uitboeken.step.party": "Ontvangend asiel",
    "uitboeken.exchange.partyHeader": "Ontvangende organisatie",
    "uitboeken.exchange.partyInfo": "Kies het asiel dat het dier of de dieren ontvangt.",
    "uitboeken.exchange.noShelters": "Geen beschikbare asielen.",
    "uitboeken.exchange.reason": "Reden van uitwisseling",
    "uitboeken.exchange.reasonPlaceholder": "Beschrijf de reden van de uitwisseling",
    "uitboeken.exchange.detailsRequired": "Vul de verplichte velden in voor de uitwisselingsgegevens.",
    "uitboeken.exchange.receivingShelter": "Ontvangend asiel",
    "uitboeken.notice.conflict": "Dit verblijf is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "uitboeken.notice.invalid": "Het uitboeken kon niet worden afgerond — controleer de velden.",
    "uitboeken.notice.error": "Er ging iets mis bij het uitboeken.",
    // Uitwisselingen (shelter exchange) inbox/outbox — Epic 3.
    "uitwisselingen.title": "Uitwisselingen",
    "uitwisselingen.heading": "Asielwisselingen",
    "uitwisselingen.subtitle": "Inkomende en uitgaande uitwisselingen met andere asielen",
    "uitwisselingen.filter.status": "Status",
    "uitwisselingen.filter.status.all": "Alle statussen",
    "uitwisselingen.filter.asiel": "Asiel",
    "uitwisselingen.filter.asiel.all": "Alle asielen",
    "uitwisselingen.filter.diersoort": "Diersoort",
    "uitwisselingen.filter.diersoort.all": "Alle diersoorten",
    "uitwisselingen.tab.inbox": "Inkomend",
    "uitwisselingen.tab.outbox": "Uitgaand",
    "uitwisselingen.empty": "Geen uitwisselingen.",
    "uitwisselingen.col.status": "Status",
    "uitwisselingen.col.source": "Bron-asiel",
    "uitwisselingen.col.target": "Doel-asiel",
    "uitwisselingen.col.animals": "Dieren",
    "uitwisselingen.col.sentAt": "Verzonden op",
    "uitwisselingen.col.createdAt": "Aangemaakt op",
    "uitwisselingen.col.actions": "Acties",
    "uitwisselingen.action.open": "Openen",
    "uitwisselingen.action.accept": "Accepteren",
    "uitwisselingen.action.reject": "Afwijzen",
    "uitwisselingen.action.cancel": "Annuleren",
    "uitwisselingen.action.complete": "Afronden",
    "uitwisselingen.action.intake": "Inboeken",
    "uitwisselingen.status.DRAFT": "Concept",
    "uitwisselingen.status.SENT": "Verzonden",
    "uitwisselingen.status.SENT_INBOX": "Ontvangen",
    "uitwisselingen.status.ACCEPTED": "Geaccepteerd",
    "uitwisselingen.status.REJECTED": "Afgewezen",
    "uitwisselingen.status.CANCELLED": "Geannuleerd",
    "uitwisselingen.status.COMPLETED": "Afgerond",
    "uitwisselingen.animals.one": "dier",
    "uitwisselingen.animals.many": "dieren",
    "uitwisselingen.animals.unknownSpecies": "Onbekend",
    "uitwisselingen.external.label": "Extern",
    "uitwisselingen.external.tooltip": "Extern asiel — geen in-app reactie; melding gaat per e-mail",
    "uitwisselingen.cancel.title": "Uitwisseling annuleren",
    "uitwisselingen.cancel.warning": "Dit kan niet ongedaan gemaakt worden. Het doel-asiel ziet deze uitwisseling daarna niet meer.",
    "uitwisselingen.cancel.confirm": "Annuleren",
    "uitwisselingen.cancel.back": "Niet annuleren",
    "uitwisselingen.notif.accepted": "Uitwisseling geaccepteerd.",
    "uitwisselingen.notif.rejected": "Uitwisseling afgewezen.",
    "uitwisselingen.notif.cancelled": "Uitwisseling geannuleerd.",
    "uitwisselingen.notif.completed": "Uitwisseling afgerond.",
    "uitwisselingen.detail.title": "Uitwisseling",
    "uitwisselingen.detail.external": "Extern asiel",
    "uitwisselingen.detail.reason": "Reden",
    "uitwisselingen.detail.reason.empty": "(geen reden opgegeven)",
    "uitwisselingen.detail.createdAt": "Aangemaakt",
    "uitwisselingen.detail.rejectionReason": "Reden van afwijzing",
    "uitwisselingen.detail.rejectionRemark": "Toelichting",
    "uitwisselingen.detail.col.chipStatus": "Chip-registratie",
    "uitwisselingen.chipStatus.REGISTERED": "Geregistreerd",
    "uitwisselingen.chipStatus.NOT_REGISTERED": "Niet geregistreerd",
    "uitwisselingen.chipStatus.SKIPPED_NO_CHIP": "Geen chip",
    "uitwisselingen.chipStatus.SKIPPED_OUTAGE": "Overgeslagen (storing)",
    "uitwisselingen.detail.acceptedAt": "Geaccepteerd",
    "uitwisselingen.detail.rejectedAt": "Afgewezen",
    "uitwisselingen.detail.cancelledAt": "Geannuleerd",
    "uitwisselingen.detail.completedAt": "Afgerond",
    "uitwisselingen.detail.animals": "Dieren",
    "uitwisselingen.detail.history": "Geschiedenis",
    "uitwisselingen.history.empty": "Nog geen geschiedenis.",
    "uitwisselingen.history.EXCHANGE_CREATED": "Uitwisseling aangemaakt",
    "uitwisselingen.history.EXCHANGE_SENT": "Uitwisseling verzonden",
    "uitwisselingen.history.EXCHANGE_ACCEPTED": "Uitwisseling geaccepteerd",
    "uitwisselingen.history.EXCHANGE_REJECTED": "Uitwisseling afgewezen",
    "uitwisselingen.history.EXCHANGE_CANCELLED": "Uitwisseling geannuleerd",
    "uitwisselingen.history.EXCHANGE_COMPLETED": "Uitwisseling afgerond",
    "uitwisselingen.reject.title": "Uitwisseling afwijzen",
    "uitwisselingen.reject.reason": "Reden",
    "uitwisselingen.reject.reasonPlaceholder": "Kies een reden…",
    "uitwisselingen.reject.codeHelper": "Kies een categorie. Wordt gedeeld met het bron-asiel.",
    "uitwisselingen.reject.remark": "Toelichting (optioneel)",
    "uitwisselingen.reject.remarkHelper": "Maximaal 500 tekens. Wordt gedeeld met het bron-asiel.",
    "uitwisselingen.reason.WRONG_SHELTER": "Verkeerd asiel",
    "uitwisselingen.reason.ANIMAL_DECLINED": "Dieren niet geaccepteerd",
    "uitwisselingen.reason.CAPACITY_FULL": "Geen capaciteit",
    "uitwisselingen.reason.OPERATOR_RECONSIDERED": "Herzien na acceptatie",
    "uitwisselingen.reason.OTHER": "Anders (zie toelichting)",
    "uitwisselingen.notice.conflict": "Deze uitwisseling is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "uitwisselingen.notice.invalid": "Deze actie is niet toegestaan voor deze uitwisseling.",
    "uitwisselingen.notice.error": "Er ging iets mis bij het verwerken van de uitwisseling.",
    "animalListView.column.naam": "Naam",
    "animalListView.column.diersoort": "Diersoort",
    "animalListView.column.ras": "Ras",
    "animalListView.column.geslacht": "Geslacht",
    "animalListView.column.geboortedatum": "Geboortedatum",
    "animalListView.column.chip": "Chipnummer",
    "animalDetailView.title": "Dier",
    "animalDetailView.loadFailed": "Kon het dier niet laden.",
    "animalDetailView.placeholder": "Dit onderdeel volgt in een volgende migratiestap.",
    "animalDetailView.layout.edit": "Indeling aanpassen",
    "animalDetailView.layout.done": "Klaar",
    "animalDetailView.layout.hide": "Tegel verbergen",
    "animalDetailView.layout.drag": "Versleep om te ordenen",
    "animalDetailView.layout.hiddenSection": "Verborgen tegels",
    // tile field-visibility migration — de Nederlandse teksten zijn de Jmix-dialoogteksten (parity).
    "animalDetailView.fieldConfig.edit": "Velden configureren",
    "animalDetailView.fieldConfig.basisTitle": "Basisinformatie velden",
    "animalDetailView.fieldConfig.voedingTitle": "Voeding tegel — secties",
    "animalDetailView.fieldConfig.gewichtenTitle": "Gewichten tegel",
    "animalDetailView.fieldConfig.foto": "Foto",
    // Dialoog-specifieke veldlabels — exact de Jmix-dialoogteksten (die wijken af van de tegel-labels).
    "animalDetailView.fieldConfig.gecastreerd": "Gecas/ster",
    "animalDetailView.fieldConfig.castratieDatum": "Castratiedatum",
    "animalDetailView.fieldConfig.chipPasnummer": "Chipnummer",
    "animalDetailView.fieldConfig.paspoortNummer": "Paspoortnummer",
    "animalDetailView.fieldConfig.voedingSchema": "Voedingsschema (incl. knop Schema bewerken)",
    "animalDetailView.fieldConfig.voedingLog": "Voedingslog (incl. log acties en Volledig log)",
    "animalDetailView.fieldConfig.gewichtenChart": "Grafiek tonen",
    "animalDetailView.fieldConfig.saveError": "Kon de veldinstellingen niet opslaan.",
    "animalDetailView.foster.lockTitle": "Pleeggezin-toegang",
    "animalDetailView.foster.title": "Pleeggezin — %s",
    "animalDetailView.foster.rule": "Per regel: Niet zien · Alleen lezen · Wijzigen · Verwijderen. Een pleeggezin krijgt nooit meer dan de backoffice. Deze instelling geldt voor álle dieren tegelijk.",
    "animalDetailView.foster.colBackoffice": "In de backoffice",
    "animalDetailView.foster.colFoster": "Pleeggezin",
    "animalDetailView.foster.tileRow": "Tegel",
    "animalDetailView.foster.level.hidden": "Niet zien",
    "animalDetailView.foster.level.readonly": "Alleen lezen",
    "animalDetailView.foster.level.editable": "Wijzigen",
    "animalDetailView.foster.level.deletable": "Verwijderen",
    "animalDetailView.foster.boVisible": "Zichtbaar in de backoffice",
    "animalDetailView.foster.boHidden": "Verborgen in de backoffice",
    "animalDetailView.foster.boHiddenTooltip": "Verborgen in de backoffice — kan niet aan voor het pleeggezin",
    "animalDetailView.foster.tileOffTooltip": "Deze tegel staat uit in de backoffice",
    "animalDetailView.foster.notAvailableTooltip": "Deze tegel is (nog) niet beschikbaar voor het pleeggezin-portaal",
    "animalDetailView.foster.conflict": "De instellingen zijn intussen gewijzigd — de dialoog is ververst. Controleer je keuzes en sla opnieuw op.",
    "animalDetailView.foster.saveError": "Kon de pleeggezin-toegang niet opslaan.",
    "animalDetailView.status.overleden": "Overleden",
    "animalDetailView.tab.general": "Algemeen",
    "animalDetailView.tab.verblijf": "Verblijf",
    "animalDetailView.tab.geschiedenis": "Geschiedenis",
    "animalDetailView.tab.advertentie": "Advertentie",
    "animalDetailView.advertentie.geen": "Dit dier heeft nog geen advertentie.",
    "animalDetailView.advertentie.laadFout": "De advertentie kon niet worden geladen.",
    "animalDetailView.tile.basis": "Basisinformatie",
    "animalDetailView.tile.bescherming": "Bescherming",
    "animalDetailView.tile.medicijnen": "Medicijnen",
    "animalDetailView.medicijnen.status.ACTIEF": "Actief",
    "animalDetailView.medicijnen.status.BINNENKORT": "Binnenkort",
    "animalDetailView.medicijnen.status.HISTORISCH": "Historisch",
    "animalDetailView.medicijnen.field.dosering": "Dosering",
    "animalDetailView.medicijnen.field.frequentie": "Frequentie",
    "animalDetailView.medicijnen.field.toedieningsvorm": "Toedieningsvorm",
    "animalDetailView.medicijnen.field.categorie": "Categorie",
    "animalDetailView.medicijnen.field.startDatum": "Startdatum",
    "animalDetailView.medicijnen.field.stopDatum": "Stopdatum",
    "animalDetailView.medicijnen.field.voorgeschrevenDoor": "Voorgeschreven door",
    "animalDetailView.medicijnen.field.indicatie": "Indicatie",
    "animalDetailView.medicijnen.toedienlijst": "Toedieningen",
    "animalDetailView.medicijnen.toegediend": "Toegediend",
    "animalDetailView.medicijnen.toegediendDoor": "Toegediend door %s",
    "animalDetailView.medicijnen.gepland": "Gepland",
    "animalDetailView.medicijnen.field.naam": "Medicijn",
    "animalDetailView.medicijnen.field.product": "Medicijn (uit catalogus)",
    "animalDetailView.medicijnen.field.productAnders": "— Anders (vrije tekst) —",
    "animalDetailView.medicijnen.ai.button": "AI invullen",
    "animalDetailView.medicijnen.ai.busy": "Bezig…",
    "animalDetailView.medicijnen.ai.done": "Velden ingevuld met AI-suggestie.",
    "animalDetailView.medicijnen.ai.unavailable": "AI-suggesties zijn niet beschikbaar (geen provider ingesteld).",
    "animalDetailView.medicijnen.ai.error": "Kon geen AI-suggestie ophalen.",
    "animalDetailView.medicijnen.tab.actueel": "Actueel",
    "animalDetailView.medicijnen.tab.toedienlijst": "Toedienlijst",
    "animalDetailView.medicijnen.tab.historie": "Historie",
    "animalDetailView.medicijnen.searchPlaceholder": "Zoek medicijn…",
    "animalDetailView.medicijnen.noMatch": "Geen medicijn gevonden voor deze zoekopdracht.",
    "animalDetailView.medicijnen.tabEmpty": "Niets hier.",
    "animalDetailView.medicijnen.showAll": "Toon alles (%d)",
    "animalDetailView.medicijnen.showLess": "Minder tonen",
    "animalDetailView.medicijnen.field.opmerkingen": "Opmerkingen",
    "animalDetailView.medicijnen.field.actief": "Actief voorschrift",
    "animalDetailView.medicijnen.add": "Nieuw medicijn",
    "animalDetailView.medicijnen.edit": "Medicijn bewerken",
    "animalDetailView.medicijnen.delete": "Medicijn verwijderen",
    "animalDetailView.medicijnen.addTitle": "Nieuw medicijn",
    "animalDetailView.medicijnen.editTitle": "Medicijn bewerken",
    "animalDetailView.medicijnen.deleteTitle": "Medicijn verwijderen",
    "animalDetailView.medicijnen.deleteBody": "Het voorschrift \"%s\" verwijderen? De toedieningen worden ook verwijderd.",
    "animalDetailView.medicijnen.deleteConfirm": "Verwijderen",
    "animalDetailView.medicijnen.saved": "Medicijn opgeslagen.",
    "animalDetailView.medicijnen.deleted": "Medicijn verwijderd.",
    "animalDetailView.medicijnen.saveConflict": "Dit medicijn is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.medicijnen.saveInvalid": "Controleer de ingevoerde waarden.",
    "animalDetailView.medicijnen.saveError": "Opslaan mislukt. Probeer opnieuw.",
    "animalDetailView.medicijnen.err.naamRequired": "Vul een medicijnnaam in.",
    "animalDetailView.medicijnen.err.stopBeforeStart": "De stopdatum kan niet vóór de startdatum liggen.",
    "animalDetailView.medicijnen.toediening.add": "Toevoegen",
    "animalDetailView.medicijnen.toediening.addTitle": "Toediening registreren",
    "animalDetailView.medicijnen.toediening.register": "Registreren",
    "animalDetailView.medicijnen.toediening.delete": "Toediening verwijderen",
    "animalDetailView.medicijnen.toediening.empty": "Nog geen toedieningen.",
    "animalDetailView.medicijnen.toediening.datum": "Datum",
    "animalDetailView.medicijnen.toediening.tijd": "Tijd",
    "animalDetailView.medicijnen.toediening.door": "Toegediend door",
    "animalDetailView.medicijnen.toediening.opmerking": "Opmerking",
    "animalDetailView.medicijnen.toediening.toegediend": "Toegediend",
    "animalDetailView.medicijnen.toediening.err.momentRequired": "Vul datum en tijd in.",
    "animalDetailView.medicijnen.genereer.button": "Genereren",
    "animalDetailView.medicijnen.genereer.title": "Toedieningen genereren",
    "animalDetailView.medicijnen.genereer.submit": "Genereren",
    "animalDetailView.medicijnen.genereer.aantal": "Aantal",
    "animalDetailView.medicijnen.genereer.eenheid": "Frequentie",
    "animalDetailView.medicijnen.genereer.eenheid.DAG": "× per dag",
    "animalDetailView.medicijnen.genereer.eenheid.WEEK": "× per week",
    "animalDetailView.medicijnen.genereer.eenheid.MAAND": "× per maand",
    "animalDetailView.medicijnen.genereer.eenheid.UUR": "om de … uur",
    "animalDetailView.medicijnen.genereer.hint": "Bouwt het schema vanaf de startdatum (08:00) tot de stopdatum. Reeds toegediende momenten blijven behouden.",
    "animalDetailView.medicijnen.genereer.err.aantal": "Vul een aantal van minstens 1 in.",
    "animalDetailView.tile.gewichten": "Gewichten",
    "animalDetailView.tile.voeding": "Voeding",
    "animalDetailView.tile.notities": "Notities",
    "animalDetailView.tile.media": "Media & Documenten",
    "animalDetailView.tile.taken": "Taken & planning",
    // taken-runtime (Epic T5): de Taken-tegel op het dierprofiel + de "Alles bekijken"-weergave. Alleen
    // UI-chrome — de datalabels (status/prioriteit/team/bron) komen letterlijk uit de server-payload.
    "taken.kpi.open": "Open",
    "taken.kpi.vandaag": "Vandaag",
    "taken.kpi.achterstallig": "Achterstallig",
    "taken.kpi.afgerond": "Afgerond",
    "taken.kpi.totaal": "Totaal",
    "taken.tile.empty": "Geen open taken",
    "taken.tile.meer": "+%d meer open taken",
    "taken.tile.alles": "Alles bekijken →",
    "taken.tab.title": "Taken & planning",
    "taken.tab.subtitle": "Open, geplande en afgeronde taken voor dit dier.",
    "taken.nieuw": "Nieuwe taak",
    "taken.leeg": "Geen taken gevonden.",
    "taken.vandaag": "Vandaag",
    "taken.fout": "Opslaan van de taak is niet gelukt. Probeer het opnieuw.",
    "taken.fout.conflict": "Deze automatische taak is inmiddels opnieuw aangemaakt. Werk de nieuwere taak bij in plaats van deze.",
    "taken.automatisch": "Automatisch aangemaakt",
    "taken.automatisch.sjabloon": "sjabloon %s",
    "taken.automatisch.regel": "regel %s",
    "taken.filter.zoek": "Zoeken in taken…",
    "taken.filter.bron": "Bron",
    "taken.filter.alleBronnen": "Alle bronnen",
    "taken.filter.team": "Team",
    "taken.filter.alleTeams": "Alle teams",
    "taken.filter.mijnTeam": "Mijn team",
    "taken.filter.toonAfgerond": "Toon afgerond/geannuleerd",
    "taken.actie.inBehandeling": "In behandeling",
    "taken.nieuw.titel": "Nieuwe taak",
    "taken.nieuw.taak": "Taak",
    "taken.nieuw.kies": "Kies een taak…",
    "taken.nieuw.dezeSoort": "Voor deze soort",
    "taken.nieuw.elkeSoort": "Voor elke soort",
    "taken.nieuw.andere": "Andere taak (zelf typen)",
    "taken.nieuw.handeling": "Bij uitvoeren opent deze taak het invoerscherm voor %s, en is hij af zodra dat is opgeslagen.",
    "taken.actie.uitvoeren": "Uitvoeren: %s",
    "taken.uitvoeren.geenTegel": "De tegel voor deze taak staat niet aan bij dit dier. Zet hem aan, of rond de taak zelf af.",
    "taken.actie.afronden": "Afronden",
    "taken.actie.wizardStarten": "Wizard starten",
    "taken.actie.bewerken": "Bewerken",
    "taken.actie.annuleren": "Annuleren",
    "taken.actie.heropenen": "Heropenen",
    "taken.form.titel": "Titel van de taak",
    "taken.form.omschrijving": "Omschrijving (optioneel)",
    "taken.nieuw.kiesOfTyp": "Kies een taak of typ zelf…",
    "taken.actie.verwijderen": "Verwijderen",
    "taken.bewerk.titel": "Taak wijzigen",
    "taken.verwijder.titel": "Taak verwijderen?",
    "taken.verwijder.uitleg": "“%s” is niet meer nodig en verdwijnt uit de open taken. Bij de geannuleerde taken blijft hij terug te vinden.",
    "taken.nieuw.kiesEerst": "Kies een taak uit de lijst of typ er zelf een.",
    "taken.nieuw.toonLijst": "Takenlijst tonen",
    "taken.nieuw.eigen": "Eigen taak: “%s”",
    "taken.nieuw.leeg": "Nog geen taken in de lijst; typ er gewoon een.",
    "taken.nieuw.omschrijvingPlaats": "Voeg eventueel een omschrijving toe…",
    "taken.form.prioriteit": "Prioriteit",
    "taken.form.deadline": "Deadline",
    "taken.form.team": "Team",
    "taken.form.geenTeam": "Geen team",
    "taken.form.toevoegen": "Toevoegen",
    // WIZARDS-tegel (Registraties & Wizards): alleen UI-chrome — wizardnamen, veldlabels,
    // samenvattingswaarden en statuschips komen letterlijk uit de server-payload (wizard-builder).
    // De Nederlandse teksten zijn 1-op-1 de strings van de hybride app (frontend-react/wizard).
    "animalDetailView.tile.wizards": "Registraties & Wizards",
    "wizards.badge.enkel": "registratie",
    "wizards.badge.meer": "registraties",
    "wizards.historie": "Historie",
    "wizards.historie.leeg": "Nog geen registraties.",
    "wizards.nieuw": "Nieuwe registratie",
    "wizards.leeg": "Nog geen gepubliceerde wizards beschikbaar.",
    "wizards.laatstBijgewerkt": "Laatst bijgewerkt",
    "wizards.nogGeenRegistratie": "Nog geen registratie ingevuld",
    "wizards.meerDetails": "Meer details",
    "wizards.kiezer.titel": "Welke registratie wil je starten?",
    "wizards.runner.titel": "%s uitvoeren",
    "wizards.verplicht": "\"%s\" is verplicht.",
    "wizards.geenVelden": "Geen velden in deze stap.",
    "wizards.vorige": "Vorige",
    "wizards.volgende": "Volgende",
    "wizards.concept": "Opslaan als concept",
    "wizards.afronden": "Afronden",
    "wizards.fout": "Opslaan van de registratie is niet gelukt. Probeer het opnieuw.",
    "wizards.ja": "Ja",
    "wizards.nee": "Nee",
    "wizards.chipnummer": "Chipnummer",
    "wizards.geboortedatum": "Geboortedatum",
    "wizards.geslacht": "Geslacht",
    "wizards.leeftijd": "Leeftijd",
    "wizards.inAsielSinds": "In asiel sinds %d dgn",
    "wizards.verblijfstatus": "Verblijfstatus",
    "wizards.actief": "ACTIEF",
    "wizards.sinds": "sinds",
    "wizards.dagen": "dagen",
    "wizards.samenvatting": "Wizard samenvatting",
    "wizards.stap.ingevuld": "Ingevuld",
    "wizards.stap.bezig": "Bezig…",
    "wizards.stap.wacht": "Wacht op vorige stap",
    "wizards.detail.titel": "Registratie",
    "wizards.detail.leeg": "Geen waarden.",
    "animalDetailView.field.naam": "Naam",
    "animalDetailView.field.geslacht": "Geslacht",
    "animalDetailView.field.gecastreerd": "Gecastreerd/gesteriliseerd",
    "animalDetailView.field.castratieDatum": "Castratiedatum",
    "animalDetailView.field.diersoort": "Diersoort",
    "animalDetailView.field.ras": "Ras",
    "animalDetailView.field.kruising": "Kruising",
    "animalDetailView.field.rasKruising": "Ras kruising",
    "animalDetailView.field.vacht": "Vacht",
    "animalDetailView.field.eartip": "Eartip",
    "animalDetailView.field.eartipOor": "Welk oor",
    "animalDetailView.field.eartipOorLeeg": "Niet genoteerd",
    "animalDetailView.field.eartipLinks": "Linkeroor",
    "animalDetailView.field.eartipRechts": "Rechteroor",
    "animalDetailView.field.kleur": "Kleur",
    "animalDetailView.field.chip": "Chipnummer",
    "animalDetailView.field.paspoort": "Paspoortnummer",
    "animalDetailView.field.stamboom": "Stamboomnummer",
    "animalDetailView.field.kenmerken": "Uiterlijke kenmerken",
    "animalDetailView.field.geboortedatum": "Geboortedatum",
    "animalDetailView.field.overledendatum": "Datum overleden",
    "animalDetailView.field.casSter": "Cas/ster",
    "animalDetailView.field.vachtKleur": "Vacht kleur",
    "animalDetailView.basis.photo": "Foto uploaden",
    "animalDetailView.basis.photoChange": "Foto wijzigen",
    "animalDetailView.photo.dialogTitle": "Foto wijzigen",
    "animalDetailView.photo.helper": "Kies een foto via upload of maak direct een foto met de camera.",
    "animalDetailView.photo.choose": "Bestand kiezen",
    "animalDetailView.photo.camera": "Foto maken (camera)",
    "animalDetailView.photo.cameraFallback": "Werkt de camera niet op dit apparaat? Gebruik dan 'Bestand kiezen'.",
    "animalDetailView.photo.cameraSnap": "Neem foto",
    "animalDetailView.photo.cameraCancel": "Annuleren",
    "animalDetailView.photo.cameraBack": "Terug",
    "animalDetailView.photo.cameraUnsupported": "Camera niet ondersteund op dit apparaat/browser.",
    "animalDetailView.photo.cameraDenied": "Camera niet beschikbaar of permissie geweigerd.",
    "animalDetailView.photo.previewAlt": "Nieuwe foto preview",
    "animalDetailView.photo.horizontal": "Horizontaal",
    "animalDetailView.photo.vertical": "Verticaal",
    "animalDetailView.photo.rotation": "Rotatie",
    "animalDetailView.photo.left": "Naar links",
    "animalDetailView.photo.right": "Naar rechts",
    "animalDetailView.photo.up": "Naar boven",
    "animalDetailView.photo.down": "Naar beneden",
    "animalDetailView.photo.center": "Centreren",
    "animalDetailView.photo.rotateLeft": "Linksom draaien",
    "animalDetailView.photo.rotateRight": "Rechtsom draaien",
    "animalDetailView.photo.save": "Opslaan foto",
    "animalDetailView.photo.cancel": "Annuleren",
    "animalDetailView.photo.empty": "Kies eerst een foto via upload of camera",
    "animalDetailView.photo.unsupported": "Alleen JPG, PNG en WEBP worden ondersteund",
    "animalDetailView.photo.tooLarge": "Foto is te groot (max 15 MB)",
    "animalDetailView.photo.saveError": "Opslaan van foto mislukt",
    "animalDetailView.photo.aiAnalyze": "AI-analyse",
    "animalDetailView.photo.aiAnalyzing": "Analyseren…",
    "animalDetailView.photo.aiTitle": "AI suggesties",
    "animalDetailView.photo.aiHelper": "Selecteer welke suggesties je wilt toepassen op de basisinformatie.",
    "animalDetailView.photo.aiApply": "Toepassen",
    "animalDetailView.photo.aiRetry": "Opnieuw analyseren",
    "animalDetailView.photo.aiBack": "Annuleren",
    "animalDetailView.photo.aiOverwrites": "overschrijft bestaande waarde",
    "animalDetailView.photo.aiNone": "AI vond geen bruikbare suggesties",
    "animalDetailView.photo.aiUnavailable": "Geen AI-provider geconfigureerd",
    "animalDetailView.photo.aiError": "AI-analyse mislukt",
    "basis.subtitel": "Gegevens van het dier",
    "basis.sectie.identiteit": "Identiteit",
    "basis.sectie.identiteitOnder": "Basisgegevens van het dier",
    "basis.sectie.kenmerken": "Kenmerken",
    "basis.sectie.kenmerkenOnder": "Ras en uiterlijke kenmerken",
    "basis.sectie.registratie": "Registratie",
    "basis.sectie.registratieOnder": "Officiële gegevens en datums",
    "basis.sectie.overige": "Overige",
    "basis.sectie.overigeOnder": "Aanvullende informatie",
    "animalDetailView.basis.tags": "Tags",
    "animalDetailView.basis.tagsAdd": "+ toevoegen",
    "animalDetailView.basis.tagsEmpty": "Nog geen tags",
    "animalDetailView.basis.tagsDialogTitle": "Tags bewerken",
    "animalDetailView.basis.stamboomPlaceholder": "Bijv. NHSB 1234567",
    "animalDetailView.basis.chipDuplicateTitle": "Chipnummer bestaat al",
    "animalDetailView.basis.chipDuplicateMessage": "Chipnummer %s staat al bij dier \"%s\". Wil je dat dier openen?",
    "animalDetailView.basis.chipDuplicateStay": "Nee, hier blijven",
    "animalDetailView.basis.chipDuplicateOpen": "Ja, open bestaand dier",
    "animalDetailView.basis.chipDuplicateNoName": "(zonder naam)",
    "animalDetailView.basis.reset": "Herstellen",
    "animalDetailView.basis.saved": "Opgeslagen",
    "animalDetailView.basis.saveError": "Opslaan mislukt.",
    "animalDetailView.basis.saveConflict": "Dit dier is intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.basis.diersoortRequired": "Diersoort is verplicht.",
    "animalDetailView.basis.aiApplied": "AI suggesties toegepast (%s)",
    "animalDetailView.basis.age.y": "j",
    "animalDetailView.basis.age.mo": "mnd",
    "animalDetailView.basis.age.wk": "wk",
    "animalDetailView.basis.age.day": "dag",
    "animalDetailView.basis.age.days": "dagen",
    "animalDetailView.tileLoadFailed": "Kon dit onderdeel niet laden.",
    "animalDetailView.tileEmpty": "Nog niets vastgelegd.",
    "animalDetailView.weights.target": "Streefbandbreedte",
    "animalDetailView.weights.latest": "Laatste meting",
    "animalDetailView.weights.min": "Minimum",
    "animalDetailView.weights.idealLabel": "Ideaal",
    "animalDetailView.weights.max": "Maximum",
    "animalDetailView.weights.status.within": "Op streefgewicht",
    "animalDetailView.weights.status.below": "Onder streefgewicht",
    "animalDetailView.weights.status.above": "Boven streefgewicht",
    "animalDetailView.weights.status.noTarget": "Geen streefgewicht bekend",
    "animalDetailView.weights.status.pending": "Nog geen meting",
    "animalDetailView.weights.col.datum": "Datum",
    "animalDetailView.weights.col.gewicht": "Gewicht",
    "animalDetailView.weights.col.opmerking": "Opmerking",
    "animalDetailView.weights.chartTitle": "Gewicht (kg)",
    "animalDetailView.weights.noChart": "Nog geen metingen voor grafiek",
    "animalDetailView.weights.none": "Nog geen metingen geregistreerd",
    "animalDetailView.weights.add": "Toevoegen",
    "animalDetailView.weights.edit": "Wijzigen",
    "animalDetailView.weights.delete": "Verwijderen",
    "animalDetailView.weights.remove": "Verwijderen",
    "animalDetailView.weights.addTitle": "Gewicht toevoegen",
    "animalDetailView.weights.editTitle": "Gewicht wijzigen",
    "animalDetailView.weights.targetTitle": "Streefbandbreedte instellen",
    "animalDetailView.weights.targetEditTitle": "Streefbandbreedte wijzigen",
    "animalDetailView.weights.changeReason": "Reden wijziging (optioneel)",
    "animalDetailView.weights.deleteTitle": "Meting verwijderen",
    "animalDetailView.weights.deleteConfirm": "Weet je zeker dat je deze meting wilt verwijderen?",
    "animalDetailView.weights.range.3m": "Laatste 3 maanden",
    "animalDetailView.weights.range.1m": "Laatste maand",
    "animalDetailView.weights.range.all": "Alle",
    "animalDetailView.weights.viewAll": "Alles bekijken",
    "animalDetailView.weights.addSubtitle": "Registreer een nieuwe gewichtsmeting voor dit dier.",
    "animalDetailView.weights.editSubtitle": "Pas deze gewichtsmeting aan.",
    "animalDetailView.weights.targetSubtitle": "Stel de gewichtsband in waarbinnen dit dier gezond is.",
    "animalDetailView.weights.dateHint": "Selecteer de datum waarop het gewicht is gemeten.",
    "animalDetailView.weights.weegschaal": "Weegschaal / opmerking",
    "animalDetailView.weights.weegschaalPlaats": "Bijv. kleine weegschaal, kattenafdeling",
    "animalDetailView.weights.weegschaalHint": "Op welke weegschaal is gewogen. Weegschalen verschillen; zo is een sprong te verklaren.",
    "animalDetailView.weights.weightHint": "Voer het gemeten gewicht in kilogrammen in.",
    "animalDetailView.weights.weightPlaceholder": "bijv. 17,5 of 17.5",
    "animalDetailView.weights.current": "Huidig gewicht",
    "animalDetailView.weights.sincePrevious": "sinds vorige meting",
    "animalDetailView.weights.bandRange": "Streefband",
    "animalDetailView.weights.band.within": "Binnen streefband",
    "animalDetailView.weights.band.below": "Onder streefband",
    "animalDetailView.weights.band.above": "Boven streefband",
    "animalDetailView.weights.band.noTarget": "Geen streefband bekend",
    "animalDetailView.weights.band.pending": "Nog geen meting",
    "animalDetailView.weights.recent": "Laatste metingen",
    "animalDetailView.weights.pickRow": "Kies eerst een meting in de lijst",
    "animalDetailView.weights.periodLabel": "Periode",
    "animalDetailView.weights.period.3m": "Laatste 3 maanden",
    "animalDetailView.weights.period.1m": "Laatste maand",
    "animalDetailView.weights.period.all": "Alle metingen",
    "animalDetailView.weights.restTitle": "Overige gewichtsmetingen",
    "animalDetailView.weights.tipStatus": "Status",
    "animalDetailView.weights.tipSource": "Bron",
    "animalDetailView.weights.saved": "Opgeslagen",
    "animalDetailView.weights.saveError": "Opslaan mislukt. Probeer opnieuw.",
    "animalDetailView.weights.saveConflict": "Deze gegevens zijn intussen gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.weights.saveInvalid": "Controleer de ingevoerde waarden.",
    "animalDetailView.weights.err.dateRequired": "Datum is verplicht",
    "animalDetailView.weights.err.dateFuture": "Datum mag niet in de toekomst liggen",
    "animalDetailView.weights.err.weightRequired": "Gewicht is verplicht",
    "animalDetailView.weights.err.weight": "Gewicht moet groter zijn dan 0",
    "animalDetailView.weights.err.minMaxRequired": "Minimum en maximum zijn verplicht",
    "animalDetailView.weights.err.minLtMax": "Minimum moet kleiner zijn dan maximum",
    "animalDetailView.weights.err.idealBetween": "Ideaal-gewicht moet tussen minimum en maximum liggen",
    "animalDetailView.weights.err.weightsPositive": "Gewichten moeten groter zijn dan 0",
    "animalDetailView.weights.optional": "optioneel",
    "animalDetailView.weights.minPlaceholder": "bijv. 25,0",
    "animalDetailView.weights.idealPlaceholder": "bijv. 30,0",
    "animalDetailView.weights.maxPlaceholder": "bijv. 36,0",
    "animalDetailView.weights.reasonPlaceholder": "bijv. advies dierenarts, diet, herstel",
    "animalDetailView.feeding.log": "Voedingslog",
    "animalDetailView.feeding.field.feedType": "Voertype",
    "animalDetailView.feeding.field.brand": "Merk",
    "animalDetailView.feeding.field.amount": "Hoeveelheid",
    "animalDetailView.feeding.field.times": "Voertijden",
    "animalDetailView.feeding.field.dietStatus": "Dieetstatus",
    "animalDetailView.feeding.field.note": "Opmerking",
    "animalDetailView.feeding.col.fedAt": "Wanneer",
    "animalDetailView.feeding.col.amount": "Hoeveelheid",
    "animalDetailView.feeding.col.behavior": "Gedrag",
    "animalDetailView.feeding.col.note": "Opmerking",
    "animalDetailView.feeding.behavior.GOED_GEGETEN": "Goed gegeten",
    "animalDetailView.feeding.behavior.ALLES_GEGETEN": "Alles gegeten",
    "animalDetailView.feeding.behavior.BIJNA_OP": "Bijna op",
    "animalDetailView.feeding.behavior.SLECHT_GEGETEN": "Slecht gegeten",
    "animalDetailView.feeding.behavior.ONBEKEND": "Onbekend",
    "animalDetailView.feeding.col.date": "Datum",
    "animalDetailView.feeding.noLog": "Nog geen voeding geregistreerd",
    "animalDetailView.feeding.add": "Toevoegen",
    "animalDetailView.feeding.edit": "Wijzigen",
    "animalDetailView.feeding.delete": "Verwijderen",
    "animalDetailView.feeding.editPlan": "Schema bewerken",
    "voedingsplan.nieuw": "Nieuw voedingsplan",
    "voedingsschema.knop": "Voedingsschema",
    "voedingsschema.bewerken": "Bewerken",
    "voedingsschema.bewerkTitel": "Voedingsschema bewerken",
    "voedingsschema.bewerkUitleg": "Corrigeer het huidige schema. Verandert de voeding echt, maak dan een nieuw schema: dan blijft de historie kloppen.",
    "voedingsschema.wijzigingOpslaan": "Wijzigingen opslaan",
    "voedingsschema.titel": "Voedingsschema’s",
    "voedingsschema.uitleg": "Overzicht van alle voedingsschema’s voor dit dier.",
    "voedingsschema.nieuw": "Nieuw schema",
    "voedingsschema.geen": "Nog geen voedingsschema. Maak het eerste met “Nieuw schema”.",
    "voedingsschema.huidig": "Huidig schema",
    "voedingsschema.aangemaaktOp": "Aangemaakt op",
    "voedingsschema.door": "Door",
    "voedingsschema.detail.titel": "Schema details",
    "voedingsschema.detail.uitleg": "Alles wat is vastgelegd én gegeven binnen dit voedingsschema.",
    "voedingsschema.terug": "Terug naar overzicht",
    "voedingsschema.opBasisVan": "Nieuw schema op basis van dit schema",
    "voedingsschema.huidigSchema": "Huidig schema",
    "voedingsschema.huidigUitleg": "Dit schema is momenteel actief voor dit dier.",
    "voedingsschema.eerderSchema": "Eerder schema",
    "voedingsschema.eerderUitleg": "Dit schema is vervangen door een nieuwer schema.",
    "voedingsschema.periode": "Periode",
    "voedingsschema.actiefSinds": "Actief sinds",
    "voedingsschema.tot": "Tot",
    "voedingsschema.nogActief": "Nog actief",
    "voedingsschema.informatie": "Voedingsinformatie",
    "voedingsschema.voertype": "Voertype",
    "voedingsschema.product": "Product / merk",
    "voedingsschema.frequentie": "Frequentie",
    "voedingsschema.totaalPerDag": "Totaal per dag",
    "voedingsschema.voertijden": "Voertijden",
    "voedingsschema.samenstelling": "Samenstelling",
    "voedingsschema.calorisch": "Calorische waarde",
    "voedingsschema.perDag": "per dag",
    "voedingsschema.kcalOnbekend": "Onbekend: de producten hebben geen calorische waarde.",
    "voedingsschema.gegeven": "Gegeven voedingen binnen dit schema",
    "voedingsschema.registraties": "%s registraties",
    "voedingsschema.eenRegistratie": "1 registratie",
    "voedingsschema.opgegeten": "opgegeten",
    "voedingsschema.geweigerd": "Geweigerd",
    "voedingsschema.kolom.datum": "Datum",
    "voedingsschema.kolom.tijd": "Tijd",
    "voedingsschema.kolom.moment": "Moment",
    "voedingsschema.kolom.status": "Status",
    "voedingsschema.nieuwTitel": "Nieuw voedingsschema",
    "voedingsschema.nieuwUitleg": "Maak een nieuw voedingsschema voor dit dier. Het vorige blijft in het overzicht staan.",
    "voedingsschema.opslaan": "Schema opslaan",
    "voedingsschema.portieKort": "Portie",
    "voedingsschema.productMerk": "Product / merk",
    "voedingsschema.productPlaceholder": "Kies uit de lijst of typ een naam",
    "voedingsschema.perDagKlein": "(per dag)",
    "voedingsschema.kcalOnbekendKort": "kcal onbekend",
    "voedingsschema.tijdToevoegen": "Tijd toevoegen",
    "voedingsschema.tijdWeg": "Tijd %s weghalen",
    "voedingsschema.nieuwProduct": "Nieuw product. Wil je het in de productenlijst zetten?",
    "voedingsschema.gram": "gram",
    "voedingsschema.ml": "ml",
    "voedingsschema.referentie": "Huidig schema (ter referentie)",
    "voedingsschema.eerdere": "Alle schema’s bekijken (%s eerdere)",
    "voedingsschema.eenEerder": "Alle schema’s bekijken (1 eerder)",
    "voedingsplan.bekijkVoerbeurten": "Voerbeurten bekijken",
    "voedingsplan.vorigeSchemas": "Vorige schema's",
    "voedingsplan.huidigSchema": "Huidig schema",
    "voedingsplan.vorigSchema": "Vorig schema",
    "voedingsplan.nu": "nu",
    "voedingsplan.voerbeurten": "voerbeurten",
    "voedingsplan.gegeven": "Gegeven",
    "voedingsplan.gegeten": "Gegeten",
    "voedingsplan.opgegeten": "opgegeten van wat gegeven is",
    "voedingsplan.geenVoerbeurten": "Onder dit schema zijn geen voerbeurten geregistreerd.",
    "instellingen.tile.voeding.title": "Voeding",
    "instellingen.tile.voeding.desc": "Producten voor voedingsplannen, met hun calorische waarde.",
    "instellingen.item.voeding.producten": "Brok, natvoer en vocht",
    "instellingen.item.voeding.kcal": "kcal per 100 g",
    "instellingen.item.voeding.locatie": "Per locatie of voor alle locaties",
    "voedingsproducten.kolom.product": "Product",
    "voedingsproducten.kolom.kcal": "Calorische waarde",
    "voedingsproducten.kolom.locatie": "Locatie",
    "voedingsproducten.kolom.status": "Status",
    "voedingsproducten.alleLocaties": "Alle locaties",
    "voedingsproducten.uitlegVestiging": "De producten van deze locatie. Producten voor alle locaties staan er ook bij; die wijzig je onder Organisatie.",
    "voedingsproducten.uitlegOrganisatie": "Producten voor alle locaties. Elke locatie kan er eigen producten bij zetten.",
    "voedingsproducten.voorAlle": "Dit product geldt voor alle locaties.",
    "voedingsproducten.voorVestiging": "Dit product geldt voor %s.",
    "voedingsproducten.titel": "Voedingsproducten",
    "voedingsproducten.uitleg": "Brok, natvoer en vocht met hun calorische waarde, om uit te kiezen in een voedingsplan.",
    "voedingsproducten.zoek": "Zoek product",
    "voedingsproducten.leeg": "Nog geen producten van deze soort.",
    "voedingsproducten.nieuw": "Nieuw product",
    "voedingsproducten.wijzig": "Product wijzigen",
    "voedingsproducten.geenKcal": "kcal onbekend",
    "voedingsproducten.kcalHint": "Staat op de verpakking: energie per 100 g (bij vocht per 100 ml). Zonder deze waarde toont het plan geen kcal voor dit product.",
    "voedingsplan.titel": "Nieuw voedingsplan",
    "voedingsplan.ondertitel": "Het huidige plan blijft als historie staan.",
    "voedingsplan.opslaan": "Nieuw plan opslaan",
    "voedingsplan.huidig": "Huidig plan",
    "voedingsplan.hoeVaak": "Hoe vaak per dag",
    "voedingsplan.perMaaltijd": "Per maaltijd",
    "voedingsplan.soort": "Soort",
    "voedingsplan.soort.BROK": "Brok",
    "voedingsplan.soort.NATVOER": "Natvoer / vlees",
    "voedingsplan.soort.VOCHT": "Vocht",
    "voedingsplan.product": "Product",
    "voedingsplan.kiesProduct": "Kies een product",
    "voedingsplan.eigenProduct": "+ Nieuw product…",
    "voedingsplan.eigenNaam": "Naam van het product",
    "voedingsplan.hoeveelheid": "Hoeveelheid",
    "voedingsplan.regelWeg": "Regel weghalen",
    "voedingsplan.productToevoegen": "Product aan de lijst toevoegen",
    "voedingsplan.productNaam": "Naam van het product",
    "voedingsplan.kcalPer100": "kcal per 100 g/ml",
    "voedingsplan.productBewaren": "Opslaan in lijst",
    "voedingsplan.portie": "Portie per maaltijd",
    "voedingsplan.perDag": "Per dag",
    "voedingsplan.kcalPerDag": "%s kcal per dag",
    "voedingsplan.kcalPerDagMinstens": "minstens %s kcal per dag (niet elk product heeft een calorische waarde)",
    "voedingsplan.kcalOnbekend": "kcal onbekend: geef het product een calorische waarde",
    "voedingsplan.voertijden": "Voertijden (niet verplicht)",
    "voedingsplan.voertijd": "Voertijd",
    "voedingsplan.onvolledig": "Kies op elke regel een product en een hoeveelheid.",
    "voedingsplan.fout": "Het plan kon niet worden opgeslagen.",
    "voedingsplan.voergift": "Voergift",
    "voedingsplan.keerPerDag": "%s× per dag",
    "voedingsplan.historie": "Historie",
    "voedingsplan.meer": "Alles tonen",
    "voedingsplan.minder": "Minder tonen",
    "animalDetailView.feeding.viewRest": "Rest bekijken",
    "animalDetailView.feeding.planAddSubtitle": "Voeg een nieuw voedingsschema toe aan dit dier.",
    "animalDetailView.feeding.planEditSubtitle": "Pas het voedingsschema van dit dier aan.",
    "animalDetailView.feeding.form.feedTypePlaceholder": "Bijv. brokken, natvoer, vers vlees",
    "animalDetailView.feeding.form.brandPlaceholder": "Bijv. Royal Canin, Hill's",
    "animalDetailView.feeding.form.amountPlaceholder": "Bijv. 3 × 75 gram per dag, 1 blik, 50 ml",
    "animalDetailView.feeding.form.timesTitle": "Voertijden",
    "animalDetailView.feeding.form.timesHint": "Kies op welke tijden er gevoerd wordt.",
    "animalDetailView.feeding.form.planNotePlaceholder": "Eventuele aanvullende informatie…",
    "animalDetailView.feeding.logAddSubtitle": "Registreer een nieuwe voeding in het dagboek.",
    "animalDetailView.feeding.logEditSubtitle": "Pas deze registratie in het dagboek aan.",
    "animalDetailView.feeding.form.fedAtHint": "Kies de datum en tijd waarop er is gevoerd.",
    "animalDetailView.feeding.form.amountHint": "Vul de hoeveelheid voeding in gram in.",
    "animalDetailView.feeding.form.amountPrefilled": "Alvast ingevuld uit het voedingsschema — pas aan als het niet klopt.",
    "animalDetailView.feeding.form.eaten": "Gegeten (gram)",
    "animalDetailView.feeding.form.eatenHint": "Hoeveel er van de portie op is. Weet je het nog niet, laat het leeg en vul het bij de volgende voerbeurt in.",
    "animalDetailView.feeding.eatenTooMuch": "Er kan niet meer gegeten zijn dan er gegeven is.",
    "animalDetailView.feeding.eaten": "%s g gegeten (%p%)",
    "animalDetailView.feeding.eatenOpen": "Gegeten: nog invullen",
    "animalDetailView.feeding.col.eaten": "Gegeten",
    "animalDetailView.feeding.form.behaviorHint": "Geef aan hoe er is gegeten.",
    "animalDetailView.feeding.form.notePlaceholder": "Eventuele bijzonderheden…",
    "animalDetailView.feeding.form.noteHint": "Voeg indien nodig een extra opmerking toe.",
    "animalDetailView.feeding.subtitle": "Alles over de voeding van dit dier",
    "animalDetailView.feeding.next": "Volgende voerbeurt",
    "animalDetailView.feeding.onSchedule": "Volgens schema",
    "animalDetailView.feeding.behindSchedule": "Achter op schema",
    "animalDetailView.feeding.countOne": "1 registratie",
    "animalDetailView.feeding.countMany": "%s registraties",
    "animalDetailView.feeding.inHoursMinutes": "Over %s uur en %s minuten",
    "animalDetailView.feeding.inHours": "Over %s uur",
    "animalDetailView.feeding.inMinutes": "Over %s minuten",
    "animalDetailView.feeding.today": "Vandaag",
    "animalDetailView.feeding.yesterday": "Gisteren",
    "animalDetailView.feeding.tomorrow": "Morgen",
    "animalDetailView.feeding.meal.breakfast": "Ontbijt",
    "animalDetailView.feeding.meal.lunch": "Middagvoer",
    "animalDetailView.feeding.meal.dinner": "Avondvoer",
    "animalDetailView.feeding.meal.generic": "Voeding",
    "animalDetailView.feeding.rowActions": "Acties voor deze registratie",
    "animalDetailView.feeding.planAddTitle": "Voedingsschema toevoegen",
    "animalDetailView.feeding.planEditTitle": "Voedingsschema bewerken",
    "animalDetailView.feeding.logAddTitle": "Voedingsregel toevoegen",
    "animalDetailView.feeding.logEditTitle": "Voedingsregel bewerken",
    "animalDetailView.feeding.restTitle": "Overige voedingsregels",
    "animalDetailView.feeding.form.time1": "Voertijd 1",
    "animalDetailView.feeding.form.time2": "Voertijd 2",
    "animalDetailView.feeding.form.time3": "Voertijd 3 (optioneel)",
    "animalDetailView.feeding.form.fedAt": "Datum en tijd",
    "animalDetailView.feeding.form.amountGrams": "Hoeveelheid (gram)",
    "animalDetailView.feeding.form.behavior": "Gedrag",
    "animalDetailView.feeding.saved": "Opgeslagen",
    "animalDetailView.feeding.saveConflict": "Dit is intussen door iemand anders gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.feeding.saveError": "Opslaan mislukt",
    "animalDetailView.feeding.timeRequired": "Vul minimaal 1 voertijd in",
    "animalDetailView.feeding.fedAtRequired": "Datum en tijd zijn verplicht",
    "animalDetailView.feeding.amountInvalid": "Hoeveelheid moet groter zijn dan 0",
    "animalDetailView.feeding.behaviorRequired": "Gedrag is verplicht",
    "animalDetailView.vaccination.col.naam": "Naam",
    "animalDetailView.vaccination.col.merk": "Merk",
    "animalDetailView.vaccination.col.begin": "Datum",
    "animalDetailView.vaccination.col.eind": "Geldig tot",
    "animalDetailView.vaccination.col.vet": "Dierenarts",
    "animalDetailView.vaccination.type.enting": "Enting",
    "animalDetailView.vaccination.type.ontwormen": "Ontwormen",
    "animalDetailView.vaccination.type.ontvlooien": "Ontvlooien",
    "animalDetailView.vaccination.type.combo": "Ontwormen/ontvlooien",
    "animalDetailView.vaccination.status.actueel": "Actueel",
    "animalDetailView.vaccination.status.binnenkort": "Binnenkort",
    "animalDetailView.vaccination.status.verlopen": "Verlopen",
    "animalDetailView.vaccination.status.onbekend": "Onbekend",
    "animalDetailView.vaccination.givenBy": "Gegeven door",
    "animalDetailView.vaccination.next": "Volgende",
    "animalDetailView.vaccination.by": "Door",
    "animalDetailView.vaccination.filter.all": "Alle",
    "animalDetailView.vaccination.filter.typeLabel": "Type",
    "animalDetailView.vaccination.filter.statusLabel": "Status",
    "animalDetailView.vaccination.filter.searchPlaceholder": "Zoeken...",
    "animalDetailView.vaccination.filter.clear": "+ Filters wissen",
    "animalDetailView.vaccination.empty": "Geen behandelingen gevonden",
    "animalDetailView.vaccination.viewRemaining": "Rest bekijken",
    "animalDetailView.vaccination.remainingTitle": "Overige behandelingen",
    "bescherming.subtitel": "Entingen, ontwormen en ontvlooien",
    "bescherming.volgendeOver": "volgende over",
    "bescherming.geenVolgende": "niets gepland",
    "bescherming.aandacht": "Toon wat aandacht vraagt",
    "bescherming.sorteren": "Sorteren",
    "bescherming.sorteer.nieuwste": "Nieuwste eerst",
    "bescherming.sorteer.oudste": "Oudste eerst",
    "bescherming.uitgevoerd": "Uitgevoerd",
    "bescherming.acties": "Acties",
    "bescherming.add.ontwormen": "Nieuwe ontworming",
    "bescherming.add.ontvlooien": "Nieuwe ontvlooiing",
    "bescherming.eenheid.dag": "%d dagen",
    "bescherming.eenheid.week": "%d weken",
    "bescherming.eenheid.maand": "%d maanden",
    "animalDetailView.vaccination.add.enting": "Nieuwe enting",
    "animalDetailView.vaccination.add.parasiet": "Nieuwe ontworm/ontvlooiing",
    "animalDetailView.vaccination.passport.import": "Importeer uit paspoort",
    "animalDetailView.vaccination.passport.uploadHelper": "Upload paspoortfoto's (jpg/png/webp) en lees ze automatisch uit.",
    "animalDetailView.vaccination.passport.choose": "Bestanden kiezen",
    "animalDetailView.vaccination.passport.uploadFirst": "Upload eerst paspoortfoto's",
    "animalDetailView.vaccination.passport.scan": "AI uitlezen",
    "animalDetailView.vaccination.passport.scanning": "Analyseren…",
    "animalDetailView.vaccination.passport.scanError": "AI-analyse mislukt",
    "animalDetailView.vaccination.passport.unavailable": "Geen AI-provider geconfigureerd",
    "animalDetailView.vaccination.passport.none": "AI vond geen duidelijke vaccinaties",
    "animalDetailView.vaccination.passport.reviewSummary": "Gevonden: %s regel(s). Kies product en controleer data.",
    "animalDetailView.vaccination.passport.lineFallback": "Vaccinatie",
    "animalDetailView.vaccination.passport.noProduct": "geen productmatch",
    "animalDetailView.vaccination.passport.titer": "titerbepaling, geen enting",
    "animalDetailView.vaccination.passport.titerUitleg": "Een titerbepaling meet antistoffen en laat zien of enten nodig is. Hij wordt hier niet als enting vastgelegd.",
    "animalDetailView.vaccination.passport.alAanwezig": "staat al in het dossier",
    "animalDetailView.vaccination.passport.alAanwezigUitleg": "Deze enting staat al op dezelfde datum bij dit dier. Hij wordt niet nog een keer toegevoegd.",
    "animalDetailView.vaccination.passport.mogelijkDubbel": "staat er mogelijk al",
    "animalDetailView.vaccination.passport.mogelijkDubbelUitleg": "Er staat al een bijna gelijke enting bij dit dier (zelfde product, datum scheelt hooguit een dag). Kijk hem na voordat je hem toevoegt.",
    "animalDetailView.vaccination.passport.zonderProductUitleg": "Geen enkel product uit de lijst past hierbij. Hij wordt vastgelegd op de naam en het merk uit het paspoort; kies alsnog een product als je dat wilt.",
    "animalDetailView.vaccination.passport.titersKop": "Gevonden titerbepalingen",
    "animalDetailView.vaccination.passport.titersUitleg": "Dit zijn metingen, geen entingen. Ze worden apart bij het dier vastgelegd.",
    "animalDetailView.vaccination.passport.titerVoldoende": "voldoende",
    "animalDetailView.vaccination.passport.titerOnvoldoende": "onvoldoende",
    "animalDetailView.vaccination.passport.titerAlAanwezigUitleg": "Deze titerbepaling staat al op dezelfde datum bij dit dier. Hij wordt niet nog een keer toegevoegd.",
    "animalDetailView.vaccination.titers.kop": "Titerbepalingen",
    "animalDetailView.vaccination.titers.meting": "Titerbepaling",
    "animalDetailView.vaccination.passport.product": "Product",
    "animalDetailView.vaccination.passport.type": "Type",
    "animalDetailView.vaccination.passport.brand": "Product/merk",
    "animalDetailView.vaccination.passport.toedien": "Toedien",
    "animalDetailView.tileVisibility.open": "Tegels tonen of verbergen",
    "animalDetailView.tileVisibility.title": "Tegels tonen of verbergen",
    "animalDetailView.tileSettings.open": "Instellingen van de tegel",
    "animalDetailView.tileSettings.title": "%s instellen",
    "animalDetailView.tileSettings.intro": "Bepaal welke velden zichtbaar zijn in de backoffice en wat het pleeggezin mag zien of bewerken.",
    "animalDetailView.tileSettings.introBackoffice": "Bepaal welke velden zichtbaar zijn in de backoffice.",
    "animalDetailView.tileSettings.ruleTitle": "Niet zichtbaar in backoffice = ook niet zichtbaar voor pleeggezin.",
    "animalDetailView.tileSettings.ruleText": "Als een veld is uitgeschakeld in de backoffice, is het automatisch niet zichtbaar voor het pleeggezin.",
    "animalDetailView.tileSettings.colField": "Veld",
    "animalDetailView.tileSettings.colBackoffice": "Backoffice zichtbaar",
    "animalDetailView.tileSettings.colFoster": "Wat mag het pleeggezin?",
    "animalDetailView.tileSettings.colBackofficeHint": "Jouw eigen weergave: of je dit veld op de dierpagina ziet.",
    "animalDetailView.tileSettings.colFosterHint": "Geldt voor alle pleeggezinnen van de organisatie. Nooit meer dan wat de backoffice toont.",
    "animalDetailView.tileSettings.wholeTile": "Hele tegel",
    "animalDetailView.tileSettings.followsTile": "Volgt de tegel",
    "animalDetailView.tileSettings.defaults": "Standaardinstellingen",
    "animalDetailView.tileSettings.defaultsHint": "Alle velden weer tonen in de backoffice",
    "animalDetailView.tileVisibility.intro": "Kies welke informatie je wilt tonen op de dierpagina en bepaal de volgorde.",
    "animalDetailView.tileVisibility.search": "Zoek een tegel…",
    "animalDetailView.tileVisibility.category": "Categorie",
    "animalDetailView.tileVisibility.allCategories": "Alle categorieën",
    "animalDetailView.tileVisibility.available": "Beschikbare tegels (niet zichtbaar)",
    "animalDetailView.tileVisibility.availableHint": "Sleep of klik om toe te voegen",
    "animalDetailView.tileVisibility.selected": "Geselecteerde tegels (zichtbaar)",
    "animalDetailView.tileVisibility.selectedHint": "Sleep of wijzig de volgorde met de pijltjes.",
    "animalDetailView.tileVisibility.defaultOrder": "Standaard volgorde",
    "animalDetailView.tileVisibility.add": "Toevoegen",
    "animalDetailView.tileVisibility.up": "Omhoog",
    "animalDetailView.tileVisibility.down": "Omlaag",
    "animalDetailView.tileVisibility.hide": "Verbergen",
    "animalDetailView.tileVisibility.pinned": "Deze tegel staat altijd bovenaan",
    "animalDetailView.tileVisibility.noMatch": "Geen verborgen tegel gevonden.",
    "animalDetailView.tileVisibility.allVisible": "Alle tegels zijn zichtbaar.",
    "animalDetailView.tileVisibility.cat.algemeen": "Algemeen",
    "animalDetailView.tileVisibility.cat.medisch": "Medisch",
    "animalDetailView.tileVisibility.cat.verzorging": "Verzorging",
    "animalDetailView.tileVisibility.cat.registratie": "Registratie",
    "animalDetailView.tileVisibility.cat.documentatie": "Documentatie",
    "animalDetailView.tileVisibility.desc.basis": "Naam, ras, geslacht, geboren",
    "animalDetailView.tileVisibility.desc.bescherming": "Entingen, ontworming en ontvlooiing",
    "animalDetailView.tileVisibility.desc.taken": "Taken, herinneringen, planning",
    "animalDetailView.tileVisibility.desc.wizards": "Registraties en controles",
    "animalDetailView.tileVisibility.desc.medicijnen": "Actuele medicatie en toediening",
    "animalDetailView.tileVisibility.desc.gewichten": "Grafiek en overzicht",
    "animalDetailView.tileVisibility.desc.voeding": "Voedingsschema en voedingslog",
    "animalDetailView.tileVisibility.desc.logboek": "Recente gebeurtenissen",
    "animalDetailView.tileVisibility.desc.notities": "Laatste notities en opmerkingen",
    "animalDetailView.tileVisibility.desc.media": "Foto's, bestanden en documenten",
    "animalDetailView.vaccination.dialog.header.chip": "Chipnummer",
    "animalDetailView.vaccination.dialog.header.last": "Laatste enting",
    "animalDetailView.vaccination.dialog.header.expires": "Vervaldatum",
    "animalDetailView.vaccination.dialog.header.days": "dagen",
    "animalDetailView.vaccination.dialog.header.kruising": "kruising",
    "animalDetailView.vaccination.dialog.header.kruisingAlleen": "Kruising",
    "animalDetailView.vaccination.dialog.header.onbekend": "Onbekend",
    "animalDetailView.vaccination.dialog.uploadedFile": "%d bestand klaar voor opslag",
    "animalDetailView.vaccination.dialog.uploadedFiles": "%d bestanden klaar voor opslag",
    "animalDetailView.vaccination.dialog.clearUploads": "Uploads wissen",
    "animalDetailView.vaccination.dialog.dropzone": "Klik om te uploaden of sleep bestanden hierheen (jpg/png/pdf)",
    "animalDetailView.vaccination.dialog.takePhoto": "Foto maken",
    "animalDetailView.vaccination.dialog.takeAnotherPhoto": "Nog een foto maken",
    "animalDetailView.vaccination.dialog.nogEenFotoVraag": "Nog een bladzijde te fotograferen? Voeg hem toe — ze worden samen uitgelezen.",
    "animalDetailView.vaccination.passport.vanaf": "Vanaf",
    "animalDetailView.vaccination.passport.tot": "Tot",
    "animalDetailView.vaccination.passport.execute": "Uitvoeren",
    "animalDetailView.vaccination.passport.result": "AI import: %s toegevoegd, %s overgeslagen",
    "animalDetailView.vaccination.passport.resultDetailed": "AI import: %s toegevoegd, %s al aanwezig, %s mogelijk duplicaat · %s bestand(en) bewaard",
    "animalDetailView.vaccination.dialog.newEnting": "Nieuwe enting",
    "animalDetailView.vaccination.dialog.newParasiet": "Nieuwe ontworm/ontvlooiing",
    "animalDetailView.vaccination.dialog.edit": "Behandeling wijzigen",
    "animalDetailView.vaccination.dialog.type": "Type",
    "animalDetailView.vaccination.dialog.product": "Type",
    "animalDetailView.vaccination.dialog.productPlaceholder": "Kies product...",
    "animalDetailView.vaccination.dialog.brand": "Product/Merk",
    "animalDetailView.vaccination.dialog.givenDate": "Gegeven op",
    "animalDetailView.vaccination.dialog.nextDate": "Volgende op",
    "animalDetailView.vaccination.dialog.delete": "Verwijderen",
    "animalDetailView.vaccination.dialog.givenDateRequired": "Datum 'Gegeven op' is verplicht",
    "animalDetailView.vaccination.dialog.productRequired": "Type is verplicht",
    "animalDetailView.vaccination.dialog.conflict": "Deze behandeling is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.vaccination.dialog.saveError": "Kon de behandeling niet opslaan",
    "animalDetailView.vaccination.dialog.deleteError": "Kon de behandeling niet verwijderen",
    "animalDetailView.note.col.date": "Datum",
    "animalDetailView.note.col.title": "Titel",
    "animalDetailView.note.col.note": "Notitie",
    "animalDetailView.note.col.author": "Auteur",
    "animalDetailView.note.col.tags": "Labels",
    "animalDetailView.note.pinned": "Vastgepind",
    "animalDetailView.note.followUp": "Opvolgen",
    "animalDetailView.note.by": "Door",
    "animalDetailView.note.add": "Nieuwe notitie",
    "animalDetailView.note.viewRest": "Rest bekijken",
    "animalDetailView.note.empty": "Geen notities gevonden",
    "animalDetailView.note.filter.dateRange": "Periode",
    "animalDetailView.note.filter.range.3m": "Laatste 3 maanden",
    "animalDetailView.note.filter.range.1m": "Laatste maand",
    "animalDetailView.note.filter.range.all": "Alle",
    "animalDetailView.note.filter.tag": "Label",
    "animalDetailView.note.filter.tagPlaceholder": "Alle",
    "animalDetailView.note.filter.search": "Zoeken...",
    "animalDetailView.note.filter.clear": "+ Filters wissen",
    "animalDetailView.note.action.edit": "Bewerken",
    "animalDetailView.note.action.delete": "Verwijderen",
    "animalDetailView.note.action.pin": "Vastpinnen",
    "animalDetailView.note.action.unpin": "Losmaken",
    "animalDetailView.note.dialog.createTitle": "Nieuwe Notitie",
    "animalDetailView.note.dialog.editTitle": "Notitie bewerken",
    "animalDetailView.note.dialog.remainingTitle": "Overige notities",
    "animalDetailView.note.field.title": "Titel",
    "animalDetailView.note.field.date": "Datum",
    "animalDetailView.note.field.note": "Notitie",
    "animalDetailView.note.field.tags": "Tags",
    "animalDetailView.note.field.followUp": "Opvolgdatum (optioneel)",
    "animalDetailView.note.field.author": "Auteur",
    "animalDetailView.note.field.pinned": "Vastgepind",
    "animalDetailView.note.delete.title": "Notitie verwijderen",
    "animalDetailView.note.delete.message": "Weet je zeker dat je deze notitie wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "animalDetailView.note.validation.title": "Titel is verplicht",
    "animalDetailView.note.validation.date": "Datum is verplicht",
    "animalDetailView.note.validation.note": "Notitie is verplicht",
    "animalDetailView.note.validation.author": "Auteur is verplicht",
    "animalDetailView.note.saved": "Notitie opgeslagen",
    "animalDetailView.note.deleted": "Notitie verwijderd",
    "animalDetailView.note.saveConflict": "Deze notitie is intussen gewijzigd. Herlaad en probeer opnieuw.",
    "animalDetailView.note.saveError": "Opslaan mislukt",
    "animalDetailView.media.col.file": "Bestand",
    "animalDetailView.media.col.category": "Categorie",
    "animalDetailView.media.col.size": "Grootte",
    "animalDetailView.media.col.uploaded": "Geüpload",
    "animalDetailView.media.col.tags": "Labels",
    "animalDetailView.media.filter.date": "Datum:",
    "animalDetailView.media.filter.date.6m": "Laatste 6 maanden",
    "animalDetailView.media.filter.date.12m": "Laatste 12 maanden",
    "animalDetailView.media.filter.date.alles": "Alles",
    "animalDetailView.media.filter.kind": "Soort",
    "animalDetailView.media.filter.kind.alles": "Alles",
    "animalDetailView.media.filter.kind.foto": "Foto's",
    "animalDetailView.media.filter.kind.video": "Video's",
    "animalDetailView.media.filter.kind.document": "Documenten",
    "animalDetailView.media.filter.tag": "Tag:",
    "animalDetailView.media.filter.tag.all": "Alle tags",
    "animalDetailView.media.addFile": "Bestand toevoegen",
    "animalDetailView.media.tabs": "Media en documenten",
    "animalDetailView.media.tab.media": "Media",
    "animalDetailView.media.tab.documents": "Documenten",
    "animalDetailView.media.kindLabel": "Soort bestand",
    "animalDetailView.media.kindMedia": "Foto / video",
    "animalDetailView.media.kindDocument": "Document",
    "animalDetailView.media.dropInDialog": "Sleep bestanden hierheen of klik om te kiezen",
    "animalDetailView.media.maxPerFile": "(max. 15 MB per bestand)",
    "animalDetailView.media.removeFile": "Weghalen",
    "animalDetailView.media.descriptionPlaceholder": "Geef een korte beschrijving van de bestanden…",
    "animalDetailView.media.fosterVisible": "Direct zichtbaar in pleeggezin",
    "animalDetailView.media.fosterVisibleHint": "Bestanden zijn direct zichtbaar voor het gekoppelde pleeggezin.",
    "animalDetailView.media.actions": "Acties",
    "animalDetailView.media.dropTitle": "Sleep foto's, video's of bestanden hierheen",
    "animalDetailView.media.dropHint": "of klik om te kiezen (max. 15 MB)",
    "animalDetailView.media.showAll": "Alle %s bekijken",
    "animalDetailView.media.month.current": "Deze maand",
    "animalDetailView.media.month.previous": "Vorige maand",
    "animalDetailView.media.month.unknown": "Datum onbekend",
    "animalDetailView.media.emptyMedia": "Nog geen foto's of video's — voeg er een toe",
    "animalDetailView.media.emptyDocuments": "Nog geen documenten — voeg er een toe",
    "animalDetailView.media.uploadTitle": "Bestand toevoegen",
    "animalDetailView.media.editTitle": "Bestand bewerken",
    "animalDetailView.media.deleteTitle": "Bestand verwijderen",
    "animalDetailView.media.deleteConfirm": "Weet je zeker dat je dit bestand wilt verwijderen?",
    "animalDetailView.media.chooseFiles": "Bestanden kiezen…",
    "animalDetailView.media.noFiles": "Nog geen bestand geselecteerd",
    "animalDetailView.media.maxSizeHint": "Sleep hierheen of klik om te bladeren (max 15 MB)",
    "animalDetailView.media.filesSelectedSuffix": "bestanden geselecteerd",
    "animalDetailView.media.fileRejected": "Bestand geweigerd (te groot of niet toegestaan):",
    "animalDetailView.media.descriptionLabel": "Beschrijving (optioneel)",
    "animalDetailView.media.tagsLabel": "Tags",
    "animalDetailView.media.view": "Direct openen",
    "animalDetailView.media.enlarge": "Vergroten",
    "animalDetailView.media.copyLink": "Link kopiëren",
    "animalDetailView.media.copied": "Link gekopieerd",
    "animalDetailView.media.download": "Downloaden",
    "animalDetailView.media.rotate": "Draaien",
    "animalDetailView.media.rotateError": "De afbeelding kon niet worden gedraaid.",
    "animalDetailView.media.editTags": "Tags bewerken",
    "animalDetailView.media.delete": "Verwijderen",
    "animalDetailView.media.saved": "Opgeslagen.",
    "animalDetailView.media.uploaded": "Geüpload.",
    "animalDetailView.media.deleted": "Verwijderd.",
    "animalDetailView.media.saveError": "Opslaan mislukt. Probeer opnieuw.",
    "animalDetailView.media.uploadError": "Uploaden mislukt. Probeer opnieuw.",
    "animalDetailView.media.deleteError": "Verwijderen mislukt. Probeer opnieuw.",
    "animalDetailView.media.saveConflict": "Dit bestand is intussen gewijzigd — herlaad en probeer opnieuw.",
    "animalDetailView.stay.col.gemeente": "Gemeente",
    "animalDetailView.stay.title": "Verblijf",
    "animalDetailView.stay.active": "Actief",
    "animalDetailView.stay.in": "IN",
    "animalDetailView.stay.uit": "UIT",
    "animalDetailView.stay.days": "dagen",
    "animalDetailView.stay.notReleased": "Nog niet uitgeboekt",
    "animalDetailView.stay.current": "Huidig",
    "animalDetailView.stay.now": "heden",
    "animalDetailView.stay.tile.overzicht": "Verblijven overzicht",
    "animalDetailView.stay.tile.in": "IN",
    "animalDetailView.stay.tile.uit": "UIT",
    "animalDetailView.stay.tile.pleeggezin": "Pleeggezin",
    "animalDetailView.stay.tile.chipRegistration": "Chipregistratie (PetBase)",
    "animalDetailView.stay.tile.nazorg": "Nazorg",

    "menu.pleeggezinOverzicht": "Pleeggezin overzichten",
    "pgOverzicht.title": "Pleeggezin overzichten",
    "pgOverzicht.pleeggezin": "Pleeggezin",
    "pgOverzicht.pleeggezinBij": "Pleeggezin bij",
    "pgOverzicht.tab.dieren": "Dieren in pleeggezin",
    "pgOverzicht.tab.pleeggezinnen": "Pleeggezinnen",
    "pgOverzicht.tab.historie": "Historie",
    "pgOverzicht.totaal": "Totaal",
    "pgOverzicht.alle": "Alle",
    "pgOverzicht.wisFilters": "Filters wissen",
    "pgOverzicht.zoek.placeholder": "Zoek dier op naam, chipnummer, ras, kleur, pleeggezin…",
    "pgOverzicht.pgZoek.placeholder": "Zoek pleeggezin op naam of plaats…",
    "pgOverzicht.filter.beschikbaar": "Beschikbaar (plek vrij)",
    "pgOverzicht.filter.metDieren": "Met dieren in huis",
    "pgOverzicht.leeftijd.young": "< 1 jaar",
    "pgOverzicht.leeftijd.adult": "1 t/m 7 jaar",
    "pgOverzicht.leeftijd.senior": "8 jaar en ouder",
    "pgOverzicht.sorterenOp": "Sorteren op",
    "pgOverzicht.sorteer.pleeggezin": "Pleeggezin (gegroepeerd)",
    "pgOverzicht.sorteer.nieuwste": "Nieuwste eerst",
    "pgOverzicht.sorteer.naam": "Naam (A-Z)",
    "pgOverzicht.sorteer.plaats": "Plaats",
    "pgOverzicht.sorteer.inhuis": "Meeste dieren in huis",
    "pgOverzicht.sorteer.vrij": "Meeste vrije plek",
    "pgOverzicht.velden": "Velden",
    "pgOverzicht.velden.kiezen": "Velden kiezen",
    "pgOverzicht.weergave.kaarten": "Kaarten",
    "pgOverzicht.weergave.compact": "Compact",
    "pgOverzicht.weergave.lijst": "Lijst",
    "pgOverzicht.resultaat.een": "1 resultaat",
    "pgOverzicht.resultaat.meer": "%d resultaten",
    "pgOverzicht.pgResultaat.een": "1 pleeggezin",
    "pgOverzicht.pgResultaat.meer": "%d pleeggezinnen",
    "pgOverzicht.dieren.leeg": "Geen dieren gevonden met deze filters.",
    "pgOverzicht.relaties.geen": "Geen relaties als pleeggezin ingesteld voor deze vestiging.",
    "pgOverzicht.relaties.leegFilter": "Geen pleeggezinnen gevonden met deze filters.",
    "pgOverzicht.openDier": "Open dier",
    "pgOverzicht.onbekendRas": "Onbekend ras",
    "pgOverzicht.periode": "Periode:",
    "pgOverzicht.sinds": "Sinds:",
    "pgOverzicht.nu": "nu",
    "pgOverzicht.dag.een": "1 dag in pleeggezin",
    "pgOverzicht.dag.meer": "%d dagen in pleeggezin",
    "pgOverzicht.asielDag.een": "1 dag in asiel",
    "pgOverzicht.asielDag.meer": "%d dagen in asiel",
    "pgOverzicht.dagBij.een": "1 dag bij pleeggezin",
    "pgOverzicht.dagBij.meer": "%d dagen bij pleeggezin",
    "pgOverzicht.details": "Details",
    "pgOverzicht.kolom.dier": "Dier",
    "pgOverzicht.kolom.nuInHuis": "Nu in huis",
    "pgOverzicht.nuInHuis": "nu in huis",
    "pgOverzicht.nuInHuis.title": "Dieren nu in huis",
    "pgOverzicht.capaciteitTitel": "Capaciteit & beschikbaarheid",
    "pgOverzicht.plekkenVrij": "%v van %m plekken vrij",
    "pgOverzicht.plaats.een": "1 plaats",
    "pgOverzicht.plaats.meer": "%d plaatsen",
    "pgOverzicht.plek.een": "1 plek vrij",
    "pgOverzicht.plek.meer": "%d plekken vrij",
    "pgOverzicht.bezet": "%d bezet",
    "pgOverzicht.cat.vrij": "%d vrij",
    "pgOverzicht.cat.welkom": "welkom",
    "pgOverzicht.stat.vrij": "%s vrij",
    "pgOverzicht.stat.totaalVrij": "Totaal vrij",
    "pgOverzicht.status.actief": "Actief",
    "pgOverzicht.status.inactief": "Inactief",
    "pgOverzicht.historie.van": "Van",
    "pgOverzicht.historie.tot": "Tot en met",
    "pgOverzicht.historie.zoek": "Zoeken",
    "pgOverzicht.historie.zoeken": "Zoeken…",
    "pgOverzicht.historie.kies": "Kies een periode en klik op Zoeken.",
    "pgOverzicht.historie.afgekapt": "Alleen de eerste %d plaatsingen; kies een kortere periode voor de rest.",
    "pgOverzicht.historie.leeg": "Geen plaatsingen in deze periode.",
    "pgOverzicht.pager.geen": "0 dieren",
    "pgOverzicht.pager.bereik": "%f - %t van %n",
    "pgOverzicht.pager.pagina": "pagina %p / %n",
    "pgOverzicht.veld.foto": "Foto",
    "pgOverzicht.veld.ras": "Ras",
    "pgOverzicht.veld.woonplaats": "Plaats pleeggezin",
    "pgOverzicht.veld.leeftijd": "Leeftijd",
    "pgOverzicht.veld.diersoort": "Diersoort",
    "pgOverzicht.veld.kleur": "Kleur",
    "pgOverzicht.veld.vacht": "Vacht",
    "pgOverzicht.veld.geslacht": "Geslacht",
    "pgOverzicht.veld.gecastreerd": "Gecastreerd",
    "pgOverzicht.veld.geboortedatum": "Geboortedatum",
    "pgOverzicht.veld.herkomst": "Herkomst",
    "pgOverzicht.veld.opnamedatum": "Opnamedatum",
    "pgOverzicht.veld.gewicht": "Laatste gewicht",
    "pgOverzicht.veld.entingen": "Entingen ok",
    "pgOverzicht.veld.bijzonderheden": "Bijzonderheden",
    "pgOverzicht.veld.castratiedatum": "Castratiedatum",
    "pgOverzicht.veld.paspoortnummer": "Paspoortnummer",
    "pgOverzicht.veld.chipnummer": "Chipnummer",
    "pgOverzicht.pgveld.klantnummer": "Relatienummer",
    "pgOverzicht.pgveld.email": "E-mail",
    "pgOverzicht.pgveld.telefoon": "Telefoon",
    "pgOverzicht.pgveld.plaats": "Plaats",
    "pgOverzicht.pgveld.vestiging": "Pleeggezin bij",
    "pgOverzicht.pgveld.diersoorten": "Diersoorten",
    "pgOverzicht.pgveld.capaciteit": "Capaciteit",
    "pgOverzicht.pgveld.status": "Status",

    "nazorg.tile.title": "Nazorg",
    "nazorg.tegel.actief": "Nazorg actief",
    "nazorg.tegel.nietGestart": "Nog geen nazorg gestart",
    "nazorg.tegel.geenVragenlijst": "Nog geen ingevulde vragenlijst",
    "nazorg.tegel.actieNodig": "Actie nodig",
    "nazorg.tegel.overwegendGoed": "Overwegend goed",
    "nazorg.tegel.allesGoed": "Alles goed",
    "nazorg.tegel.badge.actieNodig": "Actie nodig",
    "nazorg.tegel.badge.aandacht": "Aandacht",
    "nazorg.tegel.badge.opKoers": "Op koers",
    "nazorg.tegel.laatsteContact": "Laatste contact",
    "nazorg.tegel.volgendeMoment": "Volgende moment",
    "nazorg.tegel.opmerking": "Opmerking",
    "nazorg.tegel.laatsteScore": "Laatste score",
    "nazorg.tegel.nGroen": "%d groen",
    "nazorg.tegel.nOranje": "%d oranje",
    "nazorg.tegel.nRood": "%d rood",
    "nazorg.tile.geenScore": "Nog geen score",
    "nazorg.tile.bijgewerkt": "bijgewerkt %s",
    "nazorg.tile.verstuur": "Verstuur nazorg-uitnodiging",
    "nazorg.tile.nogGeenAntwoorden": "Nog geen antwoorden van de adoptant. Zodra die binnen zijn, open je ze met \"Bekijk dossier\".",
    "nazorg.tile.dossier": "Bekijk dossier →",
    "nazorg.tile.alleenLezen": "Dit verblijf is afgesloten — het dossier blijft leesbaar, nieuwe nazorgmomenten versturen kan niet meer.",
    "nazorg.tile.linkLabel": "Deel deze link met de adoptant",
    "nazorg.tile.linkKopieer": "Kopiëren",
    "nazorg.tile.linkGekopieerd": "Gekopieerd",
    "nazorg.tile.linkLeeg": "Er is nog geen gepubliceerde nazorg-vragenlijst beschikbaar.",
    "nazorg.dim.VOEDING": "Voeding",
    "nazorg.dim.GEDRAG": "Gedrag",
    "nazorg.dim.GEZONDHEID": "Gezondheid",
    "nazorg.dim.HECHTING": "Hechting",
    "nazorg.dim.STRESS": "Stress",
    "animalDetailView.chipReg.flow.INTAKE": "Aanvoer",
    "animalDetailView.chipReg.flow.RELEASE": "Afvoer",
    "animalDetailView.chipReg.attempts": "Pogingen",
    "animalDetailView.chipReg.lastError": "Laatste fout",
    "animalDetailView.chipReg.requeue": "Registratie opnieuw versturen",
    "animalDetailView.chipReg.requeued": "Opnieuw in de wachtrij geplaatst.",
    "animalDetailView.chipReg.requeueFailed": "Opnieuw versturen is mislukt.",
    "animalDetailView.chipReg.status.QUEUED": "In wachtrij",
    "animalDetailView.chipReg.status.REGISTERED": "Geregistreerd",
    "animalDetailView.chipReg.status.NOT_REGISTERED": "Niet geregistreerd",
    "animalDetailView.chipReg.status.AFVOER_DONE": "Afvoer gedaan",
    "animalDetailView.chipReg.status.COMPLETED": "Voltooid",
    "animalDetailView.chipReg.status.FAILED_AFVOER": "Afvoer mislukt",
    "animalDetailView.chipReg.status.FAILED_AANVOER": "Aanvoer mislukt",
    "animalDetailView.chipReg.status.SKIPPED_NO_CHIP": "Geen chip",
    "animalDetailView.chipReg.status.SKIPPED_OUTAGE": "Overgeslagen (PetBase offline)",
    "animalDetailView.chipReg.status.DEAD_LETTERED": "Mislukt (handmatig opnieuw)",
    "animalDetailView.stay.field.brenger": "Gebracht door",
    "animalDetailView.stay.field.opname": "Opnamedatum",
    "animalDetailView.stay.field.opnamesoort": "Reden opname",
    "animalDetailView.stay.field.gemeente": "Gevonden gemeente",
    "animalDetailView.stay.field.opmerking": "Opmerking",
    "animalDetailView.stay.field.haler": "Opgehaald door",
    "animalDetailView.stay.field.vertrek": "Vertrekdatum",
    "animalDetailView.stay.field.vertreksoort": "Reden vertrek",
    "animalDetailView.stay.empty.overzicht": "Nog geen verblijfshistorie beschikbaar",
    "animalDetailView.stay.empty.in": "Nog geen binnenkomst geregistreerd",
    "animalDetailView.stay.empty.uit": "Nog geen vertrek geregistreerd",
    "animalDetailView.stay.empty.pleeggezin": "Geen pleeggezin-verblijf",
    "animalDetailView.stay.field.van": "Van datum",
    "animalDetailView.stay.field.tot": "Tot datum",
    "animalDetailView.stay.action.edit": "Bewerken",
    // Stray intake tile — verbatim from the Jmix fragment (it hard-codes Dutch, no message bundle).
    "animalDetailView.stay.v2.eyebrow": "Intake",
    "animalDetailView.stay.v2.broughtAsPrefix": "%s is binnengebracht als ",
    "animalDetailView.stay.v2.strayFallback": "zwerver",
    "animalDetailView.stay.v2.dossier": "Dossiernummer %s",
    "animalDetailView.stay.v2.organisation": "Organisatie",
    "animalDetailView.stay.v2.person": "Persoon",
    "animalDetailView.stay.v2.complete": "Volledig",
    "animalDetailView.stay.v2.unknown": "Onbekend",
    "animalDetailView.stay.v2.brenger.role": "Brenger",
    "animalDetailView.stay.v2.brenger.rit": "Rit %s",
    "animalDetailView.stay.v2.brenger.noRit": "Geen ritnummer geregistreerd",
    "animalDetailView.stay.v2.vinder.role": "Vinder",
    "animalDetailView.stay.v2.vinder.none": "Geen vinder aangegeven",
    "animalDetailView.stay.v2.vinder.noneHint": "Bij de intake is aangegeven dat er geen vinder bekend is.",
    "animalDetailView.stay.v2.openRelation": "Relatie openen",
    "animalDetailView.stay.v2.vindplaats.eyebrow": "Vindplaats",
    "animalDetailView.stay.v2.vindplaats.unknown": "Locatie onbekend",
    "animalDetailView.stay.v2.vindplaats.gemeente": "Gemeente %s",
    "animalDetailView.stay.v2.note.label": "Opmerking",
    "animalDetailView.stay.v2.note.empty": "Geen opmerking toegevoegd",
    // Legacy IN variants — verbatim from the Jmix fall-through path.
    "animalDetailView.stay.v2.legacyTitle": "INTAKE",
    "animalDetailView.stay.v2.summary.opnamePrefix": "Opname ",
    "animalDetailView.stay.v2.summary.bornPrefix": "%s is ",
    "animalDetailView.stay.v2.summary.bornEm": "geboren",
    "animalDetailView.stay.v2.summary.bornSuffix": " in het asiel",
    "animalDetailView.stay.v2.releaseTitle": "VERTREK",
    "animalDetailView.stay.v2.summary.releasePrefix": "%s is na ",
    "animalDetailView.stay.v2.duration.day": "1 dag",
    "animalDetailView.stay.v2.duration.days": "%d dagen",
    "animalDetailView.stay.v2.summary.releasePrefixNoDuration": "%s is ",
    "animalDetailView.stay.v2.release.adoption": "geplaatst",
    "animalDetailView.stay.v2.release.returnOwner": "retour",
    "animalDetailView.stay.v2.release.deceased": "overleden",
    "animalDetailView.stay.v2.release.euthanasia": "geëuthanaseerd",
    "animalDetailView.stay.v2.release.natureRelease": "uitgezet",
    "animalDetailView.stay.v2.release.tijdstip": "Tijdstip",
    "animalDetailView.stay.v2.release.doodsoorzaak": "Doodsoorzaak",
    "animalDetailView.stay.v2.release.indicatie": "Medische indicatie",
    "animalDetailView.stay.v2.release.besluitDoor": "Besluit genomen door",
    "animalDetailView.stay.v2.release.onbekend": "Onbekend",
    "animalDetailView.stay.v2.release.dierenarts": "Dierenarts",
    "animalDetailView.stay.v2.release.redenUitzetten": "Reden uitzetten",
    "animalDetailView.stay.v2.release.opmerking": "Opmerking",
    "animalDetailView.stay.v2.release.hersteld": "Volledig hersteld",
    "animalDetailView.stay.v2.release.habitat": "Klaar voor terugkeer naar habitat",
    "animalDetailView.stay.v2.release.externeVetBetrokken": "Externe dierenarts betrokken",
    "animalDetailView.stay.v2.release.geenExterneVet": "Geen externe dierenarts betrokken",
    "animalDetailView.stay.v2.uitzetlocatie.eyebrow": "Uitzetlocatie",
    "animalDetailView.stay.v2.uitzetlocatie.unknown": "Locatie onbekend",
    "animalDetailView.stay.v2.adoptant.role": "Adoptant",
    "animalDetailView.stay.v2.verklaring.plaatsing": "Plaatsingsovereenkomst",
    "animalDetailView.stay.v2.verklaring.retourEigenaar": "Retourverklaring",
    "animalDetailView.stay.v2.eigenaar.role": "Eigenaar",
    "animalDetailView.stay.v2.reden.afstand": "Reden afstand",
    "animalDetailView.stay.v2.reden.retour": "Reden retour",
    "animalDetailView.stay.v2.reden.choose": "Maak een keuze",
    "animalDetailView.stay.v2.verklaring.afstand": "Afstandsverklaring",
    "animalDetailView.stay.v2.verklaring.vinder": "Vindersverklaring",
    "animalDetailView.stay.v2.verklaring.signedOn": "Ondertekend op",
    "animalDetailView.stay.v2.verklaring.open": "Openen",
    "animalDetailView.stay.v2.verklaring.notFound": "Nog geen opgeslagen %s gevonden voor dit verblijf",
    "animalDetailView.stay.v2.verklaring.openFailed": "Het document kon niet worden geopend.",
    "animalDetailView.stay.v2.factuur.title": "Factuur",
    "animalDetailView.stay.v2.factuur.open": "Open factuur",
    "animalDetailView.stay.v2.factuur.empty": "Nog geen factuur aangemaakt voor dit verblijf.",
    "animalDetailView.stay.v2.factuur.nummer": "Factuurnummer",
    "animalDetailView.stay.v2.factuur.datum": "Factuurdatum",
    "animalDetailView.stay.v2.factuur.col.omschrijving": "Omschrijving",
    "animalDetailView.stay.v2.factuur.col.aantal": "Aantal",
    "animalDetailView.stay.v2.factuur.col.prijs": "Prijs",
    "animalDetailView.stay.v2.factuur.col.totaal": "Totaal",
    "animalDetailView.stay.v2.factuur.totaal": "Totaal",
    "animalDetailView.stay.v2.factuur.betaald": "Betaald",
    "animalDetailView.stay.v2.factuur.openstaand": "Openstaand",
    "animalDetailView.stay.v2.reden.saveFailed": "Opslaan van %s mislukt",
    "animalDetailView.stay.v2.moeder.role": "Moeder",
    "animalDetailView.stay.v2.moeder.type": "Dier",
    "animalDetailView.stay.v2.moeder.unknown": "Moeder onbekend",
    "animalDetailView.stay.v2.moeder.unknownHint": "Bij de intake is geen moeder geregistreerd.",
    "animalDetailView.stay.v2.moeder.chip": "Chip %s",
    "animalDetailView.stay.v2.moeder.born": "Geboren %s",
    "animalDetailView.stay.v2.moeder.toProfile": "Naar dierprofiel",
    "animalDetailView.stay.action.registerDeparture": "Vertrek registreren",
    "animalDetailView.stay.action.delete": "Verwijderen",
    "animalDetailView.stay.action.retour": "Retour naar asiel",
    "animalDetailView.stay.editIntakeTitle": "Binnenkomst bewerken",
    "animalDetailView.stay.typeChange": "Wijzigen",
    "animalDetailView.stay.typeChange.title": "Type binnenkomst wijzigen?",
    "animalDetailView.stay.typeChange.body": "Je gaat de inboek-wizard opnieuw doorlopen. De huidige binnenkomst wordt overschreven — er komt geen nieuw verblijf bij. Niet-opgeslagen wijzigingen in dit scherm gaan verloren.",
    "animalDetailView.stay.typeChange.confirm": "Wizard starten",
    "animalDetailView.stay.releaseTypeChange.title": "Type vertrek wijzigen?",
    "animalDetailView.stay.releaseTypeChange.body": "Je gaat de uitboek-wizard opnieuw doorlopen. Het huidige vertrek wordt overschreven. Niet-opgeslagen wijzigingen in dit scherm gaan verloren.",
    "animalDetailView.stay.edit.chip.organisatie": "Organisatie",
    "animalDetailView.stay.edit.chip.persoon": "Persoon",
    "animalDetailView.stay.edit.reden": "Reden",
    "animalDetailView.stay.editReleaseTitle": "Vertrek bewerken",
    "animalDetailView.stay.editFosterTitle": "Datums aanpassen",
    "animalDetailView.stay.confirmDeleteTitle": "Pleeggezin-verblijf verwijderen",
    "animalDetailView.stay.confirmDeleteBody": "Weet je zeker dat je dit pleeggezin-verblijf wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "animalDetailView.stay.confirmRetourTitle": "Retour naar asiel",
    "animalDetailView.stay.confirmRetourBody": "Het huidige pleeggezin-verblijf wordt afgesloten per vandaag. Doorgaan?",
    "animalDetailView.stay.notice.saved": "Opgeslagen",
    "animalDetailView.stay.notice.error": "Opslaan mislukt — probeer het opnieuw.",
    "animalDetailView.stay.notice.conflict": "Dit verblijf is intussen elders gewijzigd. Herlaad de pagina en probeer opnieuw.",
    "animalDetailView.stay.notice.invalidPeriod": "Ongeldige periode — controleer de datums (mogelijk overlap of buiten het verblijf).",
    "animalDetailView.stay.notice.required": "Vul de verplichte velden in.",
    "animalDetailView.stay.klant.none": "—",
    "animalDetailView.stay.klant.change": "Wijzigen",
    "animalDetailView.stay.klant.close": "Sluiten",
    "animalDetailView.stay.klant.clear": "Wissen",
    "animalDetailView.stay.klant.search": "Zoek relatie…",
    "animalDetailView.stay.klant.empty": "Geen relaties gevonden",
    "animalDetailView.stay.action.place": "Plaats bij pleeggezin",
    "animalDetailView.stay.placeTitle": "Plaats bij pleeggezin",
    "animalDetailView.stay.notice.ineligible": "Dit pleeggezin kan dit dier niet opnemen (diersoort/vestiging komt niet overeen).",
    "animalDetailView.stay.place.label": "Pleeggezin",
    "animalDetailView.stay.place.choose": "Kies een pleeggezin",
    "animalDetailView.stay.place.search": "Zoek pleeggezin…",
    "animalDetailView.stay.place.empty": "Geen geschikte pleeggezinnen gevonden",
    "animalDetailView.stay.place.subtitle": "Kies het pleeggezin waar dit dier naartoe gaat. Pleeggezinnen met beschikbare capaciteit en passende categorieën staan bovenaan.",
    "animalDetailView.stay.place.filterAll": "Alle categorieën",
    "animalDetailView.stay.place.suitable": "Geschikte pleeggezinnen (%s)",
    "animalDetailView.stay.place.unsuitable": "Niet geschikt (%s)",
    "animalDetailView.stay.place.capacity": "Beschikbare plaatsen",
    "animalDetailView.stay.place.capacityUnset": "Niet ingesteld",
    "animalDetailView.stay.place.capacityUnsetHint": "Capaciteit niet ingesteld",
    "animalDetailView.stay.place.capacityHint": "%s van %s plaatsen bezet",
    "animalDetailView.stay.place.suitableFor": "Geschikt voor",
    "animalDetailView.stay.place.noCategories": "Geen categorieën ingesteld",
    "animalDetailView.stay.place.fullMatch": "Volledig passend",
    "animalDetailView.stay.place.notIdeal": "Niet ideaal voor dit dier",
    "animalDetailView.stay.place.onlyCat": "Alleen: %s",
    "animalDetailView.stay.place.suitableShort": "Geschikt",
    "animalDetailView.stay.place.notSuited": "Niet geschikt",
    "animalDetailView.note.delete.messageNamed": "Weet je zeker dat je \"%s\" wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "animalDetailView.stay.currentStay": "Huidig verblijf",
    "animalDetailView.stay.historical": "Historisch",
    "animalDetailView.stay.side.binnen": "Binnen",
    "animalDetailView.stay.side.uit": "Uit",
    "animalDetailView.stay.overview.countOne": "1 verblijf",
    "animalDetailView.stay.overview.countMany": "%s verblijven",
    "animalDetailView.stay.overview.since": "sinds %s",
    "animalDetailView.stay.overview.viewAll": "Toon alle %s verblijven",
    "animalDetailView.stay.print.button": "Afdrukken",
    "animalDetailView.stay.print.title": "Document afdrukken",
    "animalDetailView.stay.print.intro": "Voor het gekozen verblijf (%s).",
    "animalDetailView.stay.print.empty": "Er staan geen afdruksjablonen aan.",
    "animalDetailView.stay.print.failed": "De afdruk kon niet worden gemaakt.",
    "animalDetailView.stay.overview.allTitle": "Alle verblijven",
    "animalDetailView.stay.field.typeBinnenkomst": "Type binnenkomst",
    "animalDetailView.stay.field.typeVertrek": "Type vertrek",
    "animalDetailView.stay.field.locatie": "Locatie",
    "animalDetailView.stay.field.naamBrenger": "Naam brenger",
    "animalDetailView.stay.field.naamHaler": "Naam haler",
    "animalDetailView.stay.field.redenHerkomst": "Reden / herkomst",
    "animalDetailView.stay.empty.uitForStay": "Nog geen vertrek geregistreerd voor dit verblijf",
    "animalDetailView.stay.foster.historyTitle": "Historie binnen dit verblijf",
    "animalDetailView.stay.foster.categorie": "Categorie",
    "animalDetailView.stay.foster.geenPleeggezin": "Geen pleeggezin",
    "animalDetailView.stay.foster.actief": "Actief",
    "animalDetailView.stay.foster.opDitMomentInAsiel": "Op dit moment in asiel",
    "animalDetailView.stay.foster.huidigInPleeggezin": "Huidig verblijf in pleeggezin",
    "animalDetailView.stay.foster.kiesCategorie": "Kies categorie",
    "animalDetailView.stay.foster.geenCategorieen": "Geen categorieën beschikbaar voor deze vestiging",
    "animalDetailView.stay.foster.asiel": "Asiel",
    "animalDetailView.stay.foster.sinds": "Sinds",
    "animalDetailView.stay.foster.aanwezig": "aanwezig",
    "animalDetailView.stay.foster.capaciteit": "Capaciteit gebruikt",
    "animalDetailView.stay.dayOne": "dag",
    "animalDetailView.history.search": "Zoek in geschiedenis…",
    "animalDetailView.history.today": "Vandaag",
    "animalDetailView.history.yesterday": "Gisteren",
    "animalDetailView.history.unknownDate": "Onbekende datum",
    "animalDetailView.history.system": "systeem",
    "animalDetailView.history.by": "door",
    "animalDetailView.history.more": "Toon meer",
    "animalDetailView.history.less": "Toon minder",
    "animalDetailView.history.close": "Sluiten",
    "animalDetailView.history.changed": "Wijziging",
    "animalDetailView.history.empty": "Nog geen geschiedenis voor dit dier.",
    "animalDetailView.history.emptyFiltered": "Geen wijzigingen gevonden voor deze zoekterm.",
    "animalDetailView.history.ent.DIER": "Dier",
    "animalDetailView.history.ent.ASIELVERBLIJF": "Asielverblijf",
    "animalDetailView.history.ent.ASIELVERBLIJFNOTITIE": "Notitie",
    "animalDetailView.history.ent.ASIELVERBLIJFSTATUSPERIODE": "Statusperiode",
    "animalDetailView.history.ent.ASIELVERBLIJFOPVANGCATEGORIE": "Opvangcategorie",
    "animalDetailView.history.ent.MEETMOMENTHOND": "Meetmoment",
    "animalDetailView.history.ent.MEETMOMENTKAT": "Meetmoment",
    "animalDetailView.history.ent.TNRVANGACTIEDIER": "TNR-vangactie",
    "animalDetailView.history.ent.DOSSIERREGEL": "Dossierregel",
    "animalDetailView.history.ent.USERANIMALPREFERENCE": "Voorkeur",
    "animalDetailView.history.ent.EXCHANGE": "Uitwisseling",
    "animalDetailView.history.ent.KLANT": "Relatie",
    "animalDetailView.history.ent.FACTUUR": "Factuur",
    "animalDetailView.history.ent.VESTIGING": "Vestiging",
    "animalDetailView.history.verb.CREATED": "aangemaakt",
    "animalDetailView.history.verb.UPDATED": "bijgewerkt",
    "animalDetailView.history.verb.DELETED": "verwijderd",
    "animalDetailView.history.verb.SENT": "verzonden",
    "animalDetailView.history.verb.ACCEPTED": "geaccepteerd",
    "animalDetailView.history.verb.CANCELLED": "geannuleerd",
    "animalDetailView.history.verb.COMPLETED": "afgerond",
    "animalDetailView.history.verb.REJECTED": "afgewezen",
    "animalDetailView.history.evt.KLANT_CREATED": "Relatie aangemaakt",
    "animalDetailView.history.evt.KLANT_UPDATED": "Algemene gegevens bijgewerkt",
    "animalDetailView.history.evt.KLANT_DELETED": "Relatie verwijderd",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_PLAATSING": "Dier geplaatst bij pleeggezin",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_EINDE": "Dier teruggehaald",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_UPDATED": "Verblijfsperiode aangepast",
    "animalDetailView.history.evt.PLEEGGEZIN_VERBLIJF_DELETED": "Verblijf verwijderd",
    // Pagina-in-aanbouw — getoond wanneer de SPA een nog-niet-gemigreerde / onbekende route opent.
    "underConstruction.title": "In aanbouw",
    "underConstruction.heading": "Deze pagina is nog in aanbouw",
    "underConstruction.body":
      "We bouwen dit onderdeel van het nieuwe Docasoft nog. Het komt eraan — bedankt voor je geduld.",
    "underConstruction.routeLabel": "Opgevraagde pagina",
    "underConstruction.home": "Terug naar het begin",
    // tarief-types Epic 5: Dierenambulance tarief overzicht (één tariefgrid, migrate-as-is).
    "dierenambulanceTarief.none": "—",
    "dierenambulanceTarief.banner":
      "Dierenambulance-tarieven: wijzig de basisprijs + per-km-tarief van een regel, of bekijk de historie.",
    "dierenambulanceTarief.empty": "Nog geen tarieven.",
    "dierenambulanceTarief.load.error": "De tarieven konden niet worden geladen.",

    // Crematorium tarief-instellingen (Epic 21)
    "crematoriumTarief.klasse.title": "Gewichtsklassen",
    "crematoriumTarief.klasse.add": "Gewichtsklasse toevoegen",
    "crematoriumTarief.klasse.add.title": "Nieuwe gewichtsklasse",
    "crematoriumTarief.klasse.edit.title": "Gewichtsklasse bewerken",
    "crematoriumTarief.klasse.empty": "Nog geen gewichtsklassen.",
    "crematoriumTarief.klasse.col.naam": "Naam",
    "crematoriumTarief.klasse.col.vanKg": "Van (kg)",
    "crematoriumTarief.klasse.col.totKg": "Tot (kg)",
    "crematoriumTarief.klasse.col.volgorde": "Volgorde",
    "crematoriumTarief.tarief.title": "Crematiekosten per gewichtsklasse & verwerkingsvorm",
    "crematoriumTarief.tarief.add": "Tarief toevoegen",
    "crematoriumTarief.tarief.add.title": "Nieuw tarief",
    "crematoriumTarief.tarief.edit.title": "Tarief bewerken",
    "crematoriumTarief.tarief.empty": "Nog geen tarieven.",
    "crematoriumTarief.tarief.col.klasse": "Gewichtsklasse",
    "crematoriumTarief.tarief.col.vorm": "Verwerkingsvorm",
    "crematoriumTarief.tarief.col.prijs": "Prijs",
    "crematoriumTarief.tarief.col.btw": "Btw",
    "crematoriumTarief.tarief.col.ingangsdatum": "Ingangsdatum",
    "crematoriumTarief.tarief.col.einddatum": "Einddatum",
    "crematoriumTarief.col.actief": "Actief",
    "crematoriumTarief.col.acties": "Acties",
    "crematoriumTarief.actief.ja": "Actief",
    "crematoriumTarief.actief.nee": "Inactief",
    "crematoriumTarief.action.refresh": "Vernieuwen",
    "menu.crematoriumHandeling": "Handelingen",
    "crematoriumHandeling.title": "Handelingen",
    "crematoriumHandeling.sub": "Welke stappen een uitvaart doorloopt en wanneer ze aan de beurt zijn",
    "crematoriumHandeling.vorm.groep": "Uitvaartvorm",
    "crematoriumHandeling.vorm.add": "Uitvaartvorm toevoegen",
    "crematoriumHandeling.vorm.edit": "Vorm bewerken",
    "crematoriumHandeling.vorm.add.title": "Nieuwe uitvaartvorm",
    "crematoriumHandeling.vorm.edit.title": "Uitvaartvorm bewerken",
    "crematoriumHandeling.vorm.naam": "Naam",
    "crematoriumHandeling.vorm.code": "Code",
    "crematoriumHandeling.vorm.soort": "Soort",
    "crematoriumHandeling.vorm.soort.hint": "De soort bepaalt de prijsberekening en of de as terugkomt; de naam eromheen kies je zelf.",
    "crematoriumHandeling.vorm.empty": "Nog geen uitvaartvormen.",
    "crematoriumHandeling.vorm.delete.blocked": "Verwijder eerst de handelingen.",
    "crematoriumHandeling.field.code.required": "Vul een code in.",
    "crematoriumHandeling.stappen.title": "Stappen",
    "crematoriumHandeling.stappen.van": "Stappen — %s",
    "crematoriumHandeling.handeling.add": "Handeling toevoegen",
    "crematoriumHandeling.handeling.add.title": "Nieuwe handeling",
    "crematoriumHandeling.handeling.edit.title": "Handeling bewerken",
    "crematoriumHandeling.handeling.empty": "Deze uitvaartvorm heeft nog geen stappen.",
    "crematoriumHandeling.col.naam": "Handeling",
    "crematoriumHandeling.col.wanneer": "Wanneer",
    "crematoriumHandeling.col.verplicht": "Verplicht",
    "crematoriumHandeling.col.document": "Bij afronden",
    "crematoriumHandeling.verplicht.ja": "Verplicht",
    "crematoriumHandeling.verplicht.nee": "Optioneel",
    "crematoriumHandeling.document.geen": "Geen document",
    "crematoriumHandeling.moment.AANMELDING": "aanmelding",
    "crematoriumHandeling.moment.ONTVANGST": "ontvangst",
    "crematoriumHandeling.moment.UITVAART": "de uitvaart",
    "crematoriumHandeling.vanaf.label": "Telt vanaf",
    "crematoriumHandeling.vanaf.hint": "Een moment in het dossier, of een andere handeling — daarmee koppel je stappen aan elkaar.",
    "crematoriumHandeling.vanaf.naHandeling": "na “%s”",
    "crematoriumHandeling.vanaf.onbekend": "een eerdere stap",
    "crematoriumHandeling.dagen": "Dagen",
    "crematoriumHandeling.werkdagen": "Alleen werkdagen tellen",
    "crematoriumHandeling.soort.werkdagen": "werkdagen",
    "crematoriumHandeling.soort.kalenderdagen": "kalenderdagen",
    "crematoriumHandeling.wanneer.direct": "direct bij %s",
    "crematoriumHandeling.wanneer.na": "%d %s na %s",
    "crematoriumHandeling.uitleg.asRetour": ", de as komt terug bij de eigenaar.",
    "crematoriumHandeling.uitleg.geenAsRetour": ", geen as-retour.",
    "crematoriumPlanning.tab.groep": "Weergave",
    "crematoriumPlanning.tab.werklijst": "Openstaande handelingen",
    "crematoriumPlanning.tab.runs": "Crematieplanning",
    "crematoriumWerklijst.search.label": "Zoeken",
    "crematoriumWerklijst.filter.termijn": "Termijn",
    "crematoriumWerklijst.filter.handeling": "Handeling",
    "crematoriumWerklijst.filter.alleHandelingen": "Alle handelingen",
    "crematoriumWerklijst.col.verwachtOp": "Vervalt",
    "crematoriumWerklijst.col.handeling": "Handeling",
    "crematoriumWerklijst.col.dossier": "Dier / dossier",
    "crematoriumWerklijst.col.eigenaar": "Eigenaar",
    "crematoriumWerklijst.col.vorm": "Uitvaartvorm",
    "crematoriumWerklijst.col.verplicht": "Verplicht",
    "crematoriumWerklijst.termijn.verlopen": "Te laat",
    "crematoriumWerklijst.termijn.vandaag": "Vandaag",
    "crematoriumWerklijst.termijn.komend": "Komt eraan",
    "crematoriumWerklijst.termijn.onbepaald": "Nog geen datum",
    "crematoriumWerklijst.dier.onbekend": "Zonder naam",
    "crematoriumWerklijst.action.afronden": "Afronden",
    "crematoriumWerklijst.empty": "Niets openstaand.",
    "crematoriumWerklijst.uitleg": "De vervaldatums volgen uit de ingestelde handelingen — daar bepaal je wat er hoeveel dagen na welk moment moet gebeuren.",
    "crematieDetail.kop.dossier": "Dossier",
    "crematieDetail.kop.dier": "Dier",
    "crematieDetail.kop.vorm": "Uitvaartvorm",
    "crematieDetail.kop.uitvaartdatum": "Uitvaartdatum",
    "crematieDetail.kop.herkomst": "Herkomst",
    "crematieDetail.kop.totaal": "Totaal",
    "crematieDetail.kop.openstaand": "%s openstaand",
    "crematieDetail.kop.factuur": "Factuur",
    "crematieDetail.section.vervoer": "Vervoer",
    "relatieDetailView.tab.uitvaart": "Uitvaart",
    "relatieDetailView.tab.eigenaar": "Eigenaar",
    "relatieDetailView.tab.historie": "Historie",
    "relatieDetailView.klantNummer": "Klant K-%s",
    "relatieDetailView.adresetiket": "Adresetiket",
    "crematieUitvaartTab.geen": "Nog geen uitvaarten voor deze klant.",
    "crematieDetail.tab.dossier": "Dossier",
    "crematieDetail.tab.documenten": "Documenten",
    "crematieDetail.tab.afdrukken": "Afdrukken",
    "crematieDetail.documenten.maken": "Document maken",
    "crematieDetail.documenten.uploaden": "Uploaden",
    "crematieDetail.documenten.bezig": "Bezig met uploaden…",
    "crematieDetail.documenten.uploadFout": "Uploaden is niet gelukt.",
    "crematieDetail.document.bestand": "Bestand",
    "crematieDetail.document.downloaden": "Downloaden",
    "crematieDetail.factuur.voorbeeld": "Voorbeeld",
    "crematieDetail.factuur.datum": "Factuurdatum",
    "crematieDetail.factuur.herinnering": "1e herinnering",
    "crematieDetail.factuur.belmoment": "Belmoment",
    "crematieDetail.factuur.incasso": "Incassobureau",
    "crematieDetail.factuur.perEmail": "Factuur per e-mail versturen",
    "crematieDetail.factuur.opslaanMislukt": "Het bewaren van de opvolging is mislukt.",
    "crematieDetail.factuur.uitgeven": "Uitgeven",
    "crematieDetail.factuur.alUitgegeven": "Dit dossier heeft al een factuur",
    "crematieDetail.factuur.conflict": "Dit dossier heeft al een factuur, of is nog een concept.",
    "crematieDetail.factuur.forbidden": "Je mag geen facturen uitgeven.",
    "crematieDetail.factuur.error": "Het uitgeven van de factuur is mislukt.",
    "crematieDetail.afdruk.titel": "Beschikbare afdrukken",
    "crematieDetail.afdruk.afdrukken": "Afdrukken",
    "crematieDetail.afdruk.voorbeeld": "Voorbeeld",
    "crematieDetail.afdruk.beschikbaar": "Beschikbaar",
    "crematieDetail.afdruk.naUitgifte": "Na uitgifte",
    "crematieDetail.afdruk.geblokkeerd": "De browser hield het printvenster tegen; sta pop-ups toe voor deze site.",
    "crematieDetail.afdruk.fout": "Afgedrukt, maar het document kon niet op het dossier worden vastgelegd.",
    "crematieDetail.afdruk.FACTUUR": "Crematoriumfactuur",
    "crematieDetail.afdruk.CREMATIEFACTUUR": "Crematiefactuur (voorgedrukt)",
    "crematieDetail.afdruk.CREMATIECERTIFICAAT": "Crematiecertificaat",
    "crematieDetail.afdruk.HERINNERINGSKAART": "Herinneringskaart",
    "crematieDetail.afdruk.BEGELEIDENDE_BRIEF": "Begeleidende brief",
    "crematieDetail.afdruk.AS_RETOURBRIEF": "As-retourbrief",
    "crematieDetail.afdruk.IDENTIFICATIELABEL": "Crematie-identificatielabel",
    "crematieDetail.afdruk.URNLABEL": "Urnlabel",
    "crematieDetail.afdruk.ADRESETIKET": "Adresetiket",
    "crematieDetail.klantOpenen": "Klant openen",
    "crematieDetail.groep.identiteit": "Identiteit",
    "crematieDetail.groep.rasGeslacht": "Ras en geslacht",
    "crematieDetail.groep.gewicht": "Gewicht en overlijden",
    "crematieDetail.groep.wanneer": "Wanneer",
    "crematieDetail.groep.tarief": "Gekozen tarief",
    "crematieDetail.groep.asbestemming": "Asbestemming",
    "crematieDetail.groep.opmerking": "Opmerking",
    "crematieDetail.groep.aanlevering": "Aanlevering",
    "crematieDetail.groep.ophaaladres": "Ophaaladres",
    "crematieDetail.groep.rit": "Herkomst en rit",
    "crematieDetail.groep.regels": "Regels",
    "crematieDetail.groep.totaal": "Totaal",
    "crematieDetail.groep.status": "Status wijzigen",
    "crematieDetail.section.factuurregels": "Factuurregels",
    "crematieDetail.section.logboek": "Logboek",
    "crematieDetail.log.status": "Status",
    "crematieDetail.log.controle": "Controle",
    "crematieDetail.log.handeling": "Handeling",
    "crematieDetail.log.betaling": "Betaling",
    "crematieDetail.klasse.hint": "Volgt uit het gewicht en bepaalt het crematietarief",
    "crematieStappen.door": "Door",
    "crematieStappen.doorIkzelf": "Ikzelf",
    "crematieStappen.datum": "Datum",
    "crematieStappen.tijd": "Tijd",
    "crematieDetail.crematie.run": "Run",
    "crematieDetail.vervoer.ophaalDatum": "Ophaaldatum",
    "crematieDetail.vervoer.afstand": "Afstand",
    "crematieDetail.vervoer.retourwijze": "Retourwijze",
    "crematieDetail.vervoer.opgehaald": "Opgehaald bij de klant",
    "crematieDetail.dier.kruising": "Kruising",
    "crematieDetail.dier.kruisingMet": "Kruising met",
    "crematieDetail.dier.geboortedatum": "Geboortedatum",
    "crematieDetail.dier.leeftijd": "Leeftijd",
    "crematieDetail.dier.jaar": "%s jaar",
    "crematieDetail.dier.maanden": "%s maanden",
    "crematieDetail.dier.klasseAutomatisch": "%s (automatisch)",
    "crematieDetail.groep.leeftijdGewicht": "Leeftijd en gewicht",
    "crematieDetail.crematie.ingevoerdDoor": "Ingevoerd door",
    "crematieDetail.crematie.uitvaartdatum": "Uitvaartdatum",
    "crematieDetail.crematie.tijd": "Tijd",
    "crematieDetail.crematie.tarief": "Crematietarief",
    "crematieDetail.crematie.geenTarief": "Nog geen tarief op de factuur",
    "crematieDetail.crematie.tariefKiesHint": "Volgt uit de gewichtsklasse; kies een ander zolang de factuur nog niet is uitgegeven.",
    "crematieDetail.crematie.tariefVast": "De factuur is uitgegeven, dus het tarief ligt vast; wijzigen is een correctie.",
    "crematieDetail.crematie.tariefVersie": "versie %s",
    "crematieDetail.crematie.basisprijs": "Basisprijs",
    "crematieDetail.crematie.bestemming": "Bestemming",
    "crematieDetail.crematie.grafnummer": "Grafnummer",
    "crematieDetail.asbestemming.URN_MEE": "Urn mee naar huis",
    "crematieDetail.asbestemming.VERSTROOIEN_VELD": "Verstrooien op het veld",
    "crematieDetail.asbestemming.VERSTROOIEN_ZEE": "Verstrooien op zee",
    "crematieDetail.asbestemming.BIJZETTEN_GRAF": "Bijzetten in het graf",
    "crematieDetail.vervoer.gebracht": "Eigenaar brengt zelf",
    "crematieDetail.vervoer.afstandEnkel": "Afstand (enkel, km)",
    "crematieDetail.vervoer.ophaalmoment": "Ophaalmoment",
    "crematieDetail.vervoer.regulier": "Regulier",
    "crematieDetail.vervoer.spoed": "Spoed",
    "crematieDetail.vervoer.retourRekenen": "Afstand als retour rekenen",
    "crematieDetail.vervoer.adres": "Adres",
    "crematieDetail.vervoer.adresEigenaar": "Eigenaaradres — %s",
    "crematieDetail.vervoer.adresPraktijk": "Praktijkadres — %s",
    "crematieDetail.vervoer.adresAnders": "Ander adres…",
    "crematieDetail.vervoer.tijd": "Tijd",
    "crematieDetail.vervoer.praktijk": "Praktijk / kliniek",
    "crematieDetail.vervoer.derdePartij": "Derde partij",
    "crematieDetail.vervoer.opgehaaldDoor": "Opgehaald door",
    "crematieDetail.vervoer.ritUitleg": "%s km %s · starttarief %s + %s km ·",
    "crematieDetail.vervoer.retour": "retour",
    "crematieDetail.vervoer.enkel": "enkel",
    "crematieDetail.vervoer.ritOpFactuur": "staat als regel op de factuur.",
    "crematieStappen.tegel.titel": "Handelingen",
    "crematieStappen.volgende": "Volgende stap",
    "crematieStappen.allesAf": "Alles afgerond",
    "crematieStappen.voortgang": "%d van %d afgerond",
    "crematieStappen.afronden": "“%s” afronden",
    "crematieStappen.heropenen": "Heropenen",
    "crematieStappen.afgerondOp": "afgerond %s",
    "crematieStappen.verwacht": "verwacht %s",
    "crematieStappen.teLaatSinds": "te laat sinds %s",
    "crematieStappen.leeg": "Deze uitvaartvorm heeft nog geen stappen ingesteld.",
    "crematieDetail.bord.ontgrendel": "Bord ontgrendelen om te bewerken",
    "crematieDetail.bord.vergrendel": "Bord vergrendelen",
    "relatieDetailView.tile.crematies": "Crematies",
    "crematiesTile.col.dier": "Dier / dossier",
    "crematiesTile.col.vorm": "Uitvaartvorm",
    "crematiesTile.col.datum": "Datum",
    "crematiesTile.col.status": "Status",
    "crematiesTile.col.bedrag": "Bedrag",
    "crematiesTile.nieuw": "Nieuwe crematie",
    "crematiesTile.lopend": "Lopend",
    "crematiesTile.inBehandeling": "In behandeling",
    "crematiesTile.totaal": "Totaal crematies",
    "crematiesTile.laatste": "Laatste crematie",
    "crematiesTile.filter.vestiging": "Vestiging",
    "crematiesTile.filter.alleVestigingen": "Alle vestigingen",
    "crematiesTile.filter.periode": "Periode",
    "crematiesTile.filter.alles": "alles",
    "crematiesTile.filter.geen": "Geen crematies met dit filter.",
    "crematiesTile.nogTePlannen": "nog te plannen",
    "crematiesTile.geenFactuur": "nog niet gefactureerd",
    "crematiesTile.empty": "Geen crematies voor deze klant.",
    "crematiesTile.error": "De crematies konden niet geladen worden.",
    "crematiesTile.aantal": "%d totaal",
    "menu.crematoriumUitvaartoverzichten": "Uitvaartoverzichten",
    "crematoriumOverzichten.title": "Uitvaartoverzichten",
    "crematoriumOverzichten.sub": "Alle dossiers, ovenruns en as-retour bij elkaar",
    "crematoriumOverzichten.tab.dossiers": "Dossiers",
    "crematoriumOverzichten.tab.runs": "Ovenruns",
    "crematoriumOverzichten.tab.asretour": "As-retour",
    "crematoriumOverzichten.kpi.ontvangen": "Ontvangen",
    "crematoriumOverzichten.kpi.gepland": "Ingepland",
    "crematoriumOverzichten.kpi.asRetour": "As nog niet retour",
    "crematoriumOverzichten.kpi.openstaand": "Openstaand",
    "crematoriumTarief.load.error": "Laden mislukt.",
    "crematoriumTarief.field.naam.required": "Naam is verplicht.",
    "crematoriumTarief.field.prijs.required": "Prijs is verplicht.",
    "crematoriumTarief.notice.conflict": "Intussen gewijzigd — herlaad en probeer opnieuw.",
    "crematoriumTarief.notice.forbidden": "Je bent niet gemachtigd voor deze actie.",
    "crematoriumTarief.notice.error": "Opslaan mislukt.",
    "crematoriumTarief.vorm.INDIVIDUEEL": "Individueel",
    "crematoriumTarief.vorm.UITGEBREID": "Uitgebreid",
    "crematoriumTarief.vorm.COLLECTIEF": "Collectief",
    "crematoriumTarief.vorm.RESOMEREN_INDIVIDUEEL": "Resomeren (individueel)",
    "crematoriumTarief.vorm.RESOMEREN_COLLECTIEF": "Resomeren (collectief)",
    "crematoriumTarief.vorm.BEGRAFENIS_INDIVIDUEEL": "Begrafenis (individueel)",
    "crematoriumTarief.vorm.BEGRAFENIS_ANONIEM": "Begrafenis (anoniem)",
    "crematoriumTarief.vorm.DESTRUCTIE": "Destructie",
    // Crematorium vervoerstarief-instellingen (Epic 21)
    "crematoriumVervoer.title": "Ophaalkosten",
    "crematoriumVervoer.add": "Vervoerstarief toevoegen",
    "crematoriumVervoer.add.title": "Nieuw vervoerstarief",
    "crematoriumVervoer.edit.title": "Vervoerstarief bewerken",
    "crematoriumVervoer.empty": "Nog geen vervoerstarieven.",
    "crematoriumVervoer.col.naam": "Naam",
    "crematoriumVervoer.col.starttarief": "Starttarief",
    "crematoriumVervoer.col.prijsPerKm": "Prijs per km",
    "crematoriumVervoer.col.vrijeKm": "Vrije km",
    "crematoriumVervoer.col.spoedtoeslag": "Spoedtoeslag",
    "crematoriumVervoer.col.btw": "Btw",
    "crematoriumVervoer.col.actief": "Actief",
    "crematoriumVervoer.col.acties": "Acties",
    "crematoriumVervoer.actief.ja": "Actief",
    "crematoriumVervoer.actief.nee": "Inactief",
    "crematoriumVervoer.action.refresh": "Vernieuwen",
    "crematoriumVervoer.load.error": "Laden mislukt.",
    "crematoriumVervoer.field.naam.required": "Naam is verplicht.",
    "crematoriumVervoer.notice.conflict": "Intussen gewijzigd — herlaad en probeer opnieuw.",
    "crematoriumVervoer.notice.forbidden": "Je bent niet gemachtigd voor deze actie.",
    "crematoriumVervoer.notice.error": "Opslaan mislukt.",
    // Crematorium dashboard (Epic 21, MR-5)
    "crematoriumDashboard.load.error": "Het dashboard kon niet worden geladen.",
    "crematoriumDashboard.subtitle": "Crematorium · overzicht van vandaag",
    "crematoriumDashboard.snelacties.title": "Snelle acties",
    "crematoriumDashboard.action.nieuw": "Nieuwe aanmelding",
    "crematoriumDashboard.action.relatie": "Relatie zoeken",
    "crematoriumDashboard.action.ophaling": "Ophaling plannen",
    "crematoriumDashboard.action.asRetour": "As-retour registreren",
    "crematoriumDashboard.kpi.nieuweAanmeldingen": "Nieuwe aanmeldingen",
    "crematoriumDashboard.kpi.ophalenVandaag": "Ophalen vandaag",
    "crematoriumDashboard.kpi.ontvangen": "Ontvangen",
    "crematoriumDashboard.kpi.geplandeCrematies": "Geplande crematies",
    "crematoriumDashboard.kpi.asKlaarVoorRetour": "As/urn klaar voor retour",
    "crematoriumDashboard.kpi.openstaandBedrag": "Openstaand bedrag",
    "crematoriumDashboard.kpi.wachtOpBetaling": "Wacht op betaling",
    "crematoriumDashboard.kpi.nogNietIngepland": "Nog niet ingepland",
    "crematoriumDashboard.kpi.facturenVervallen": "Vervallen facturen",
    "crematoriumDashboard.acties.title": "Acties vereist",
    "crematoriumDashboard.omzet.title": "Omzet",
    "crematoriumDashboard.omzet.dezeMaand": "Deze maand",
    "crematoriumDashboard.omzet.openstaand": "Openstaand",
    "crematoriumDashboard.verdeling.title": "Verdeling deze maand",
    "crematoriumDashboard.verdeling.empty": "Nog geen crematies deze maand.",
    "crematoriumDashboard.perDag.title": "Crematies per dag (laatste 7)",
    "crematoriumDashboard.recent.title": "Recente dossiers",
    "crematoriumDashboard.recent.empty": "Nog geen dossiers.",
    "crematoriumDashboard.status.CONCEPT": "Concept",
    "crematoriumDashboard.status.AANGEMELD": "Aangemeld",
    "crematoriumDashboard.status.OPHALING_GEPLAND": "Ophaling gepland",
    "crematoriumDashboard.status.OPGEHAALD": "Opgehaald",
    "crematoriumDashboard.status.ONTVANGEN": "Ontvangen",
    "crematoriumDashboard.status.WACHT_OP_BETALING": "Wacht op betaling",
    "crematoriumDashboard.status.KLAAR_VOOR_CREMATIE": "Klaar voor crematie",
    "crematoriumDashboard.status.GEPLAND": "Gepland",
    "crematoriumDashboard.status.GECREMEERD": "Gecremeerd",
    "crematoriumDashboard.status.AS_URN_KLAAR_VOOR_RETOUR": "As/urn klaar voor retour",
    "crematoriumDashboard.status.AFGEROND": "Afgerond",
    "crematoriumDashboard.status.GEANNULEERD": "Geannuleerd",
    // Crematorium Epic 21 (MR-4): read-only Planning / Runs / As-retour overzichten.
    "crematoriumPlanning.col.planningDatum": "Gepland op",
    "crematoriumPlanning.col.dossier": "Dossier",
    "crematoriumPlanning.col.dier": "Dier",
    "crematoriumPlanning.col.vorm": "Verwerkingsvorm",
    "crematoriumPlanning.col.status": "Status",
    "crematoriumPlanning.col.locatie": "Locatie",
    "crematoriumPlanning.col.run": "Run",
    "crematoriumPlanning.status.KLAAR_VOOR_CREMATIE": "Klaar voor crematie",
    "crematoriumPlanning.status.GEPLAND": "Gepland",
    "crematoriumPlanning.search.label": "Zoeken (dossier / dier)",
    "crematoriumPlanning.filter.status": "Status",
    "crematoriumPlanning.filter.vorm": "Verwerkingsvorm",
    "crematoriumPlanning.filter.all": "Alle",
    "crematoriumPlanning.action.refresh": "Vernieuwen",
    "crematoriumPlanning.load.error": "De planning kon niet worden geladen.",
    "crematoriumPlanning.empty": "Geen dossiers in de planning.",
    "crematoriumPlanning.col.acties": "Acties",
    "crematoriumPlanning.action.koppel": "Koppel aan run",
    "crematoriumPlanning.assign.title": "Koppel aan een crematierun",
    "crematoriumPlanning.assign.dossier": "Dossier: %s",
    "crematoriumPlanning.assign.run": "Crematierun",
    "crematoriumPlanning.assign.opslaan": "Koppelen",
    "crematoriumPlanning.assign.annuleren": "Annuleren",
    "crematoriumPlanning.assign.forbidden": "U bent niet gemachtigd om runs te plannen.",
    "crematoriumPlanning.assign.error": "Het dossier kon niet worden gekoppeld.",
    "crematoriumRuns.col.runnummer": "Runnummer",
    "crematoriumRuns.col.datumTijd": "Datum-tijd",
    "crematoriumRuns.col.vorm": "Verwerkingsvorm",
    "crematoriumRuns.col.locatie": "Locatie",
    "crematoriumRuns.col.oven": "Oven",
    "crematoriumRuns.col.status": "Status",
    "crematoriumRuns.col.totaalGewicht": "Totaalgewicht",
    "crematoriumRuns.status.CONCEPT": "Concept",
    "crematoriumRuns.status.GEPLAND": "Gepland",
    "crematoriumRuns.status.IN_UITVOERING": "In uitvoering",
    "crematoriumRuns.status.UITGEVOERD": "Uitgevoerd",
    "crematoriumRuns.status.GECONTROLEERD": "Gecontroleerd",
    "crematoriumRuns.status.AFGESLOTEN": "Afgesloten",
    "crematoriumRuns.status.GEANNULEERD": "Geannuleerd",
    "crematoriumRuns.search.label": "Zoeken (runnummer / locatie)",
    "crematoriumRuns.filter.status": "Status",
    "crematoriumRuns.filter.all": "Alle",
    "crematoriumRuns.action.refresh": "Vernieuwen",
    "crematoriumRuns.load.error": "De runs konden niet worden geladen.",
    "crematoriumRuns.empty": "Geen crematieruns.",
    "crematoriumRuns.col.acties": "Acties",
    "crematoriumRuns.action.nieuw": "Nieuwe run",
    "crematoriumRuns.action.bewerken": "Bewerken",
    "crematoriumRuns.action.opslaan": "Opslaan",
    "crematoriumRuns.action.annuleren": "Annuleren",
    "crematoriumRuns.add.title": "Nieuwe crematierun",
    "crematoriumRuns.edit.title": "Crematierun bewerken",
    "crematoriumRuns.veld.datumTijd": "Datum & tijd",
    "crematoriumRuns.veld.vorm": "Verwerkingsvorm",
    "crematoriumRuns.veld.locatie": "Locatie",
    "crematoriumRuns.veld.oven": "Oven",
    "crematoriumRuns.veld.capaciteit": "Capaciteit (kg)",
    "crematoriumRuns.veld.status": "Status",
    "crematoriumRuns.veld.opmerkingen": "Opmerkingen",
    "crematoriumRuns.conflict": "Deze run is intussen gewijzigd. Vernieuw en probeer opnieuw.",
    "crematoriumRuns.forbidden": "U bent niet gemachtigd om runs te bewerken.",
    "crematoriumRuns.error": "De run kon niet worden opgeslagen.",
    "crematoriumAsRetour.col.dossier": "Dossier",
    "crematoriumAsRetour.col.dier": "Dier",
    "crematoriumAsRetour.col.eigenaar": "Eigenaar",
    "crematoriumAsRetour.col.asUrnNummer": "As/urn-nummer",
    "crematoriumAsRetour.col.retourwijze": "Retourwijze",
    "crematoriumAsRetour.col.klaarSinds": "Klaar sinds",
    "crematoriumAsRetour.search.label": "Zoeken (dossier / eigenaar / dier)",
    "crematoriumAsRetour.action.refresh": "Vernieuwen",
    "crematoriumAsRetour.load.error": "As & urn retour kon niet worden geladen.",
    "crematoriumAsRetour.empty": "Geen dossiers klaar voor retour.",
    // Crematorium aanmeldingen-werklijst (Epic 21, MR-3)
    "aanmeldingen.col.dossier": "Dossier",
    "aanmeldingen.col.dier": "Dier",
    "aanmeldingen.col.eigenaar": "Eigenaar",
    "aanmeldingen.col.herkomst": "Herkomst",
    "aanmeldingen.col.status": "Status",
    "aanmeldingen.col.verwerkingsvorm": "Verwerkingsvorm",
    "aanmeldingen.col.aangemeld": "Aangemeld",
    "aanmeldingen.search.placeholder": "Zoek op dossiernummer, eigenaar of dier…",
    "aanmeldingen.filter.alle": "Alle",
    "aanmeldingen.load.error": "Laden mislukt.",
    "aanmeldingen.empty": "Nog geen aanmeldingen.",
    "aanmeldingen.nieuw": "Nieuwe aanmelding",
    "aanmeldingen.status.CONCEPT": "Concept",
    "aanmeldingen.status.AANGEMELD": "Aangemeld",
    "aanmeldingen.status.OPHALING_GEPLAND": "Ophaling gepland",
    "aanmeldingen.status.OPGEHAALD": "Opgehaald",
    "aanmeldingen.herkomst.DOOR_EIGENAAR_GEBRACHT": "Door eigenaar gebracht",
    "aanmeldingen.herkomst.OPHALEN_BIJ_EIGENAAR": "Ophalen bij eigenaar",
    "aanmeldingen.herkomst.VIA_DIERENARTS": "Via dierenarts",
    "aanmeldingen.herkomst.VIA_DERDE_PARTIJ": "Via derde partij",
    // Crematorium dossierlijst + alleen-lezen detail (Epic 21, MR-2)
    "crematies.col.dossier": "Dossier",
    "crematies.col.dier": "Dier",
    "crematies.col.eigenaar": "Eigenaar",
    "crematies.col.status": "Status",
    "crematies.col.verwerkingsvorm": "Verwerkingsvorm",
    "crematies.col.betaling": "Betaling",
    "crematies.col.aangemeld": "Aangemeld",
    "crematies.col.totaal": "Totaal",
    "crematies.search.placeholder": "Zoek op dossiernummer, eigenaar of dier…",
    "crematies.filter.alle": "Alle",
    "crematies.load.error": "Laden mislukt.",
    "crematies.empty": "Nog geen dossiers.",
    "crematies.status.CONCEPT": "Concept",
    "crematies.status.AANGEMELD": "Aangemeld",
    "crematies.status.OPHALING_GEPLAND": "Ophaling gepland",
    "crematies.status.OPGEHAALD": "Opgehaald",
    "crematies.status.ONTVANGEN": "Ontvangen",
    "crematies.status.WACHT_OP_BETALING": "Wacht op betaling",
    "crematies.status.KLAAR_VOOR_CREMATIE": "Klaar voor crematie",
    "crematies.status.GEPLAND": "Gepland",
    "crematies.status.GECREMEERD": "Gecremeerd",
    "crematies.status.AS_URN_KLAAR_VOOR_RETOUR": "As/urn klaar voor retour",
    "crematies.status.AFGEROND": "Afgerond",
    "crematies.status.GEANNULEERD": "Geannuleerd",
    "crematies.betaal.NOG_NIET_GEFACTUREERD": "Nog niet gefactureerd",
    "crematies.betaal.GEFACTUREERD": "Gefactureerd",
    "crematies.betaal.BETAALLINK_VERSTUURD": "Betaallink verstuurd",
    "crematies.betaal.DEELS_BETAALD": "Deels betaald",
    "crematies.betaal.BETAALD": "Betaald",
    "crematies.betaal.VERVALLEN": "Vervallen",
    "crematies.betaal.HERINNERING_VERSTUURD": "Herinnering verstuurd",
    "crematies.betaal.GECREDITEERD": "Gecrediteerd",
    "crematies.herkomst.DOOR_EIGENAAR_GEBRACHT": "Door eigenaar gebracht",
    "crematies.herkomst.OPHALEN_BIJ_EIGENAAR": "Ophalen bij eigenaar",
    "crematies.herkomst.VIA_DIERENARTS": "Via dierenarts",
    "crematies.herkomst.VIA_DERDE_PARTIJ": "Via derde partij",
    "crematies.factuur.col.nummer": "Factuurnummer",
    "crematies.factuur.col.factuurdatum": "Factuurdatum",
    "crematies.factuur.col.vervaldatum": "Vervaldatum",
    "crematies.factuur.col.status": "Status",
    "crematies.factuur.col.totaal": "Totaal",
    "crematies.factuur.col.openstaand": "Openstaand",
    "crematieDetail.heading": "Crematiedossier",
    "crematieDetail.load.error": "Het dossier kon niet worden geladen.",
    "crematieAanmelding.heading": "Nieuwe aanmelding",
    "crematieAanmelding.dier.panel": "Diergegevens",
    "crematieAanmelding.dier.naamVerplicht": "Een naam is verplicht.",
    "crematieAanmelding.dier.soortVerplicht": "Kies een diersoort.",
    "crematieAanmelding.dier.gewichtVerplicht": "Het gewicht bepaalt de gewichtsklasse en het tarief.",
    "crematieAanmelding.dier.overlijdenVerplicht": "De datum van overlijden is verplicht.",
    "crematieAanmelding.dier.gevolg": "Wat hieruit volgt",
    "crematieAanmelding.dier.gevolgLeeg": "Vul een gewicht in — daaruit volgen de gewichtsklasse en het tarief.",
    "crematieAanmelding.dier.vormen": "Uitvaartvormen voor deze klasse, incl. btw:",
    "crematieAanmelding.dier.vormGeenTarief": "geen tarief",
    "crematieAanmelding.dier.gevolgPrijs": "crematietarief incl. btw",
    "crematieAanmelding.dier.gevolgGeenVorm": "Het tarief volgt zodra de uitvaartvorm gekozen is.",
    "crematieAanmelding.kosten.vraag": "Wat gaat dit kosten?",
    "crematieAanmelding.kosten.sub": "Wat al vastligt, en wat je er nog bij verkoopt.",
    "crematieAanmelding.kosten.tarief": "Crematie %s · %s",
    "crematieAanmelding.kosten.ophalen": "Ophalen — %s",
    "crematieAanmelding.kosten.ophalenInfo": "Van het ophalen staat alleen het starttarief vast; de kilometers komen erbij als de rit gereden is.",
    "crematieAanmelding.kosten.uitTarief": "uit de tarieven",
    "crematieAanmelding.kosten.bedrag": "Bedrag",
    "crematieAanmelding.kosten.totaal": "Totaal incl. btw",
    "crematieAanmelding.kosten.geen": "Er ligt nog niets vast: kies een gewicht en een uitvaartvorm.",
    "crematieAanmelding.kosten.toevoegen": "Toevoegen uit de catalogus",
    "crematieAanmelding.kosten.spoed": "spoed",
    "crematieAanmelding.kosten.productToevoegen": "Product toevoegen",
    "crematieAanmelding.handelingen.datum": "Datum",
    "crematieAanmelding.handelingen.tijd": "Tijd",
    "crematieAanmelding.kosten.geenTarief": "Voor gewichtsklasse %s is geen tarief %s ingericht — de crematie zelf ontbreekt in deze opzet.",
    "crematieAanmelding.subtitle": "Meld een uitvaart aan bij het crematorium",
    "crematieAanmelding.dier.vraag": "Om welk dier gaat het?",
    "crematieAanmelding.dier.sub": "De gegevens van het dier dat gecremeerd wordt",
    "crematieAanmelding.crematie.vraag": "Welke uitvaart, en wanneer?",
    "crematieAanmelding.crematie.sub": "De vorm bepaalt het tarief én de stappen die volgen",
    "crematieAanmelding.bijverkoop.vraag": "Gaat er nog iets mee?",
    "crematieAanmelding.handelingen.vraag": "Welke stappen worden ingepland?",
    "crematieAanmelding.handelingen.sub": "Die komen als werk op het dossier te staan",
    "crematieAanmelding.bevestigen.vraag": "Klopt dit zo?",
    "crematieAanmelding.bevestigen.sub": "Loop het na — daarna wordt de uitvaart aangemaakt en geopend",
    "crematieAanmelding.eyebrow": "Crematorium",
    "crematieAanmelding.annuleren": "Annuleren",
    "crematieAanmelding.vorige": "Vorige",
    "crematieAanmelding.volgende": "Volgende",
    "crematieAanmelding.opslaanConcept": "Opslaan als concept",
    "crematieAanmelding.definitief": "Definitief aanmelden",
    "crematieAanmelding.ja": "Ja",
    "crematieAanmelding.nee": "Nee",
    "crematieAanmelding.forbidden": "U bent niet gemachtigd om aanmeldingen aan te maken.",
    "crematieAanmelding.validatie": "Vul de verplichte velden in voordat u definitief aanmeldt.",
    "crematieAanmelding.error": "De aanmelding kon niet worden opgeslagen.",
    "crematieAanmelding.stap.dier": "Dier",
    "crematieAanmelding.stap.crematie": "Crematie",
    "crematieAanmelding.stap.bijverkoop": "Kosten",
    "crematieAanmelding.stap.handelingen": "Handelingen",
    "crematieAanmelding.eigenaar.zoek": "Zoek eigenaar",
    "crematieAanmelding.eigenaar.zoekInfo": "Wie bracht het dier?",
    "crematieAanmelding.dier.kiezen": "Kiezen…",
    "crematieAanmelding.dier.reu": "Reu",
    "crematieAanmelding.dier.teef": "Teef",
    "crematieAanmelding.dier.onbekend": "Onbekend",
    "crematieAanmelding.crematie.uitvaartvorm": "Uitvaartvorm",
    "crematieAanmelding.crematie.datum": "Uitvaartdatum",
    "crematieAanmelding.crematie.tijd": "Tijd",
    "crematieAanmelding.bijverkoop.uitleg": "Urnen, sieraden en aandenkens uit de catalogus; ze komen als regels op de factuur.",
    "crematieAanmelding.bijverkoop.zoek": "Zoek producten",
    "crematieAanmelding.bijverkoop.omschrijving": "Omschrijving",
    "crematieAanmelding.bijverkoop.aantal": "Aant.",
    "crematieAanmelding.bijverkoop.prijs": "Prijs",
    "crematieAanmelding.bijverkoop.btw": "Btw",
    "crematieAanmelding.bijverkoop.totaal": "Totaal bijverkoop",
    "crematieAanmelding.handelingen.geenVorm": "Kies eerst een uitvaartvorm — daaruit volgen de stappen.",
    "crematieAanmelding.handelingen.geenVormen": "Er zijn nog geen uitvaartvormen ingericht, dus er valt niets in te plannen.",
    "crematieAanmelding.handelingen.geen": "Voor deze uitvaartvorm zijn nog geen stappen ingericht.",
    "crematieAanmelding.handelingen.uitleg": "Deze stappen worden op het dossier ingepland voor %s:",
    "crematieAanmelding.handelingen.verplicht": "Verplicht",
    "crematieAanmelding.handelingen.moment.AANMELDING": "%s dagen na aanmelding",
    "crematieAanmelding.handelingen.moment.ONTVANGST": "%s dagen na ontvangst",
    "crematieAanmelding.handelingen.moment.UITVAART": "%s dagen na de uitvaart",
    "crematieAanmelding.concept": "Opslaan als concept",
    "crematieAanmelding.aanmaken": "Aanmaken en openen",
    "crematieAanmelding.stap.eigenaar": "Eigenaar",
    "crematieAanmelding.stap.verwerking": "Herkomst & verwerking",
    "crematieAanmelding.stap.bevestigen": "Bevestigen",
    "crematieAanmelding.dier.naam": "Naam",
    "crematieAanmelding.dier.diersoort": "Diersoort",
    "crematieAanmelding.dier.ras": "Ras",
    "crematieAanmelding.dier.geslacht": "Geslacht",
    "crematieAanmelding.dier.kleur": "Kleur",
    "crematieAanmelding.dier.gewicht": "Gewicht (kg)",
    "crematieAanmelding.dier.chip": "Chip / tatoeage",
    "crematieAanmelding.dier.overlijden": "Datum overlijden",
    "crematieAanmelding.eigenaar.naam": "Naam",
    "crematieAanmelding.eigenaar.adres": "Adres",
    "crematieAanmelding.eigenaar.postcode": "Postcode",
    "crematieAanmelding.eigenaar.plaats": "Plaats",
    "crematieAanmelding.eigenaar.telefoon": "Telefoon",
    "crematieAanmelding.eigenaar.email": "E-mail",
    "crematieAanmelding.eigenaar.geenEmail": "Geen e-mail",
    "crematieAanmelding.eigenaar.betaler": "Betaler (indien anders)",
    "crematieAanmelding.verwerking.herkomst": "Herkomst",
    "crematieAanmelding.verwerking.vorm": "Verwerkingsvorm",
    "crematieAanmelding.verwerking.spoed": "Spoed",
    "crematieAanmelding.prijs.titel": "Indicatieprijs (incl. btw)",
    "crematieAanmelding.prijs.klasse": "Gewichtsklasse: %s",
    "crematieAanmelding.prijs.geenKlasse": "Nog geen gewichtsklasse voor dit gewicht",
    "crematieAanmelding.prijs.geenTarief": "Geen tarief gevonden",
    "crematieAanmelding.check.dierNaam": "Diernaam",
    "crematieAanmelding.check.diersoort": "Diersoort",
    "crematieAanmelding.check.gewicht": "Gewicht",
    "crematieAanmelding.check.overlijden": "Datum overlijden",
    "crematieAanmelding.check.eigenaar": "Naam eigenaar",
    "crematieAanmelding.check.contact": "Telefoon of e-mail",
    "crematieAanmelding.check.verwerkingsvorm": "Verwerkingsvorm",
    "crematieAanmelding.check.herkomst": "Herkomst",
    "crematieAanmelding.check.gewichtsklasse": "Gewichtsklasse",
    "crematieDetail.status.title": "Status",
    "crematieDetail.status.volgendeStap": "Volgende stap: %s",
    "crematieDetail.status.wijzigen": "Status wijzigen",
    "crematieDetail.status.opmerking": "Opmerking (optioneel)",
    "crematieDetail.status.bevestig": "Bevestigen",
    "crematieDetail.status.conflict": "Er staat een identificatie-afwijking open. Corrigeer deze eerst voordat het dossier verder kan.",
    "crematieDetail.status.forbidden": "U bent niet gemachtigd om de status te wijzigen.",
    "crematieDetail.status.error": "De status kon niet worden gewijzigd.",
    "crematieDetail.status.geenActie": "Dit dossier heeft een eindstatus bereikt; er zijn geen vervolgstappen mogelijk.",
    "crematieDetail.eyebrow": "Crematiedossier #%s",
    "crematieDetail.section.dier": "Dier",
    "crematieDetail.section.eigenaar": "Eigenaar",
    "crematieDetail.section.crematie": "Crematie",
    "crematieDetail.section.producten": "Producten",
    "crematieDetail.section.facturen": "Facturen",
    "crematieDetail.section.betalingen": "Betalingen",
    "crematieDetail.section.historie": "Statushistorie",
    "crematieDetail.section.controles": "Identificatiecontroles",
    "crematieDetail.section.documenten": "Documenten",
    "crematieDetail.dier.naam": "Naam",
    "crematieDetail.dier.diersoort": "Diersoort",
    "crematieDetail.dier.ras": "Ras",
    "crematieDetail.dier.geslacht": "Geslacht",
    "crematieDetail.dier.kleur": "Kleur",
    "crematieDetail.dier.gewicht": "Gewicht",
    "crematieDetail.dier.chip": "Chip / tatoeage",
    "crematieDetail.dier.overlijden": "Overlijdensdatum",
    "crematieDetail.eigenaar.naam": "Naam",
    "crematieDetail.eigenaar.adres": "Adres",
    "crematieDetail.eigenaar.postcode": "Postcode",
    "crematieDetail.eigenaar.plaats": "Plaats",
    "crematieDetail.eigenaar.telefoon": "Telefoon",
    "crematieDetail.eigenaar.email": "E-mail",
    "crematieDetail.crematie.herkomst": "Herkomst",
    "crematieDetail.crematie.planning": "Gepland",
    "crematieDetail.crematie.locatie": "Locatie",
    "crematieDetail.crematie.klasse": "Gewichtsklasse",
    "crematieDetail.crematie.ophaalAdres": "Ophaaladres",
    "crematieDetail.crematie.chauffeur": "Chauffeur",
    "crematieDetail.crematie.rit": "Ritnummer",
    "crematieDetail.crematie.ontvangen": "Ontvangen door",
    "crematieDetail.crematie.identificatie": "Identificatienummer",
    "crematieDetail.crematie.asUrn": "As-/urnnummer",
    "crematieDetail.crematie.bijzonderheden": "Bijzonderheden",
    "crematieDetail.regel.omschrijving": "Omschrijving",
    "crematieDetail.regel.aantal": "Aantal",
    "crematieDetail.regel.prijs": "Prijs",
    "crematieDetail.regel.korting": "Korting",
    "crematieDetail.regel.btw": "Btw",
    "crematieDetail.regel.totaal": "Totaal",
    "crematieDetail.regel.empty": "Geen producten.",
    "crematieDetail.regel.acties": "Acties",
    "crematieDetail.regel.toevoegen": "Product toevoegen",
    "crematieDetail.regel.gefactureerdSlot": "Gefactureerd — wijzig via de factuur",
    "crematieDetail.regel.bewerken": "Bewerken",
    "crematieDetail.regel.verwijderen": "Verwijderen",
    "crematieDetail.regel.add.title": "Product toevoegen",
    "crematieDetail.regel.edit.title": "Product bewerken",
    "crematieDetail.regel.verwijderConfirm": "Deze productregel verwijderen?",
    "crematieDetail.regel.opslaan": "Opslaan",
    "crematieDetail.regel.annuleren": "Annuleren",
    "crematieDetail.regel.veld.omschrijving": "Omschrijving",
    "crematieDetail.regel.veld.aantal": "Aantal",
    "crematieDetail.regel.veld.prijs": "Prijs",
    "crematieDetail.regel.veld.kortingPct": "Korting %",
    "crematieDetail.regel.veld.btw": "Btw %",
    "crematieDetail.regel.conflict": "Deze productregel is intussen gewijzigd. Vernieuw en probeer opnieuw.",
    "crematieDetail.regel.forbidden": "U bent niet gemachtigd om producten te bewerken.",
    "crematieDetail.regel.error": "Het product kon niet worden opgeslagen.",
    "crematieDetail.totaal.subtotaal": "Subtotaal",
    "crematieDetail.totaal.korting": "Korting",
    "crematieDetail.totaal.btw": "Btw",
    "crematieDetail.totaal.totaal": "Totaal",
    "crematieDetail.totaal.betaald": "Betaald",
    "crematieDetail.totaal.openstaand": "Openstaand",
    "crematieDetail.betaling.datum": "Datum",
    "crematieDetail.betaling.wijze": "Wijze",
    "crematieDetail.betaling.bedrag": "Bedrag",
    "crematieDetail.betaling.door": "Geregistreerd door",
    "crematieDetail.betaling.acties": "Acties",
    "crematieDetail.betaling.registreren": "Betaling registreren",
    "crematieDetail.betaling.add.title": "Betaling registreren",
    "crematieDetail.betaling.veld.bedrag": "Bedrag",
    "crematieDetail.betaling.veld.wijze": "Betaalwijze",
    "crematieDetail.betaling.opslaan": "Opslaan",
    "crematieDetail.betaling.annuleren": "Annuleren",
    "crematieDetail.betaling.verwijderen": "Betaling annuleren",
    "crematieDetail.betaling.verwijderConfirm": "Deze betaling annuleren?",
    "crematieDetail.betaling.forbidden": "U bent niet gemachtigd om betalingen te registreren.",
    "crematieDetail.betaling.error": "De betaling kon niet worden opgeslagen.",
    "crematieDetail.betalingen.empty": "Geen betalingen.",
    "crematieDetail.facturen.empty": "Geen facturen.",
    "crematieDetail.document.type": "Type",
    "crematieDetail.document.omschrijving": "Omschrijving",
    "crematieDetail.document.kanaal": "Kanaal",
    "crematieDetail.document.aangemaakt": "Aangemaakt",
    "crematieDetail.document.door": "Door",
    "crematieDetail.documenten.empty": "Geen documenten.",
    "crematieDetail.controle.stap": "Stap",
    "crematieDetail.controle.uitkomst": "Uitkomst",
    "crematieDetail.controle.door": "Gecontroleerd door",
    "crematieDetail.controle.locatie": "Locatie",
    "crematieDetail.controle.tijdstip": "Tijdstip",
    "crematieDetail.controles.empty": "Geen controles.",
    "crematieDetail.uitkomst.AKKOORD": "Akkoord",
    "crematieDetail.uitkomst.AFWIJKING": "Afwijking",
    "crematieDetail.historie.empty": "Geen statushistorie.",
    // Crematorium facturenlijst (Epic 21)
    "crematoriumFacturen.col.nummer": "Factuurnummer",
    "crematoriumFacturen.col.factuurdatum": "Factuurdatum",
    "crematoriumFacturen.col.vervaldatum": "Vervaldatum",
    "crematoriumFacturen.col.betaler": "Betaler",
    "crematoriumFacturen.col.status": "Status",
    "crematoriumFacturen.col.totaal": "Totaal",
    "crematoriumFacturen.col.openstaand": "Openstaand",
    "crematoriumFacturen.search.placeholder": "Zoek op factuurnummer of betaler…",
    "crematoriumFacturen.filter.alle": "Alle statussen",
    "crematoriumFacturen.load.error": "Laden mislukt.",
    "crematoriumFacturen.empty": "Nog geen facturen.",
    "crematoriumFacturen.status.NOG_NIET_GEFACTUREERD": "Nog niet gefactureerd",
    "crematoriumFacturen.status.GEFACTUREERD": "Gefactureerd",
    "crematoriumFacturen.status.BETAALLINK_VERSTUURD": "Betaallink verstuurd",
    "crematoriumFacturen.status.DEELS_BETAALD": "Deels betaald",
    "crematoriumFacturen.status.BETAALD": "Betaald",
    "crematoriumFacturen.status.VERVALLEN": "Vervallen",
    "crematoriumFacturen.status.HERINNERING_VERSTUURD": "Herinnering verstuurd",
    "crematoriumFacturen.status.GECREDITEERD": "Gecrediteerd",
    "dierenambulanceTarief.col.diensttype": "Diensttype",
    "dierenambulanceTarief.col.basisprijs": "Basisprijs",
    "dierenambulanceTarief.col.perKm": "Per KM",
    "dierenambulanceTarief.col.geldigVanaf": "Geldig vanaf",
    "dierenambulanceTarief.col.acties": "Acties",
    "dierenambulanceTarief.action.prijswijzigen": "Prijs wijzigen",
    "dierenambulanceTarief.action.historie": "Historie tonen",
    "dierenambulanceTarief.action.toevoegen": "Tarief Toevoegen",
    "dierenambulanceTarief.search": "Zoek tarieven",
    "dierenambulanceTarief.peildatum": "Geldig op",
    "dierenambulanceTarief.action.historieOverzicht": "Historie-overzicht",
    "dierenambulanceTarief.action.refresh": "Vernieuwen",
    "dierenambulanceTarief.stub.tooltip": "Volgt in vervolgwerk",
    "dierenambulanceTarief.notice.forbidden": "Je bent niet bevoegd om tarieven te wijzigen.",
    "dierenambulanceTarief.notice.forbiddenPast":
      "Een datum in het verleden vereist de tarief-beheerdersrol (ROLE_TARIEF_ADMIN).",
    "dierenambulanceTarief.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "dierenambulanceTarief.prijswijzigen.title": "Prijs wijzigen — %s",
    "dierenambulanceTarief.prijswijzigen.submit": "Doorvoeren",
    "dierenambulanceTarief.field.basisprijs": "Basisprijs",
    "dierenambulanceTarief.field.basisprijs.required": "Een basisprijs is verplicht.",
    "dierenambulanceTarief.field.perKm": "Per-km-tarief",
    "dierenambulanceTarief.field.effectdatum": "Effectdatum",
    "dierenambulanceTarief.field.reden": "Reden",
    "dierenambulanceTarief.historie.title": "Historie — %s",
    "dierenambulanceTarief.historie.empty": "Nog geen historie.",
    "dierenambulanceTarief.historie.error": "De historie kon niet worden geladen.",
    "dierenambulanceTarief.hist.vanaf": "Geldig vanaf",
    "dierenambulanceTarief.hist.tot": "Tot",
    "dierenambulanceTarief.hist.basisprijs": "Basisprijs",
    "dierenambulanceTarief.hist.perKm": "Per KM",
    "dierenambulanceTarief.hist.reden": "Reden",
    "dierenambulanceTarief.hist.status": "Status",
    "dierenambulanceTarief.hist.status.GEPLAND": "Gepland",
    "dierenambulanceTarief.hist.status.ACTIEF": "Actief",
    "dierenambulanceTarief.hist.status.VERVALLEN": "Vervallen",
    // kp-Epic 2 (verblijfplanning-migration): React floorplan read shell — verbatim Jmix
    // `verblijfplanningOverviewView.*` literals (messages_nl.properties).
    // advertentie-migration (Epic 22/23 Jmix-exit): de React-advertentielijst + read-only detail.
    "menu.advertentie.title": "Advertentie",
    "menu.advertentieBeheer": "Advertenties",
    "kenmerkWerklijst.title": "Vragen invullen",
    "kenmerkWerklijst.subtitle": "Er staan nog %open% vragen open, verdeeld over %dieren% advertenties. De matchwizard op DierMatch leest precies deze antwoorden.",
    "kenmerkWerklijst.laden": "Bezig met tellen wat er open staat…",
    "kenmerkWerklijst.toon": "Toon de lijst",
    "kenmerkWerklijst.verberg": "Verberg de lijst",
    "kenmerkWerklijst.uitleg": "Een onbeantwoorde vraag is geen match: wie thuis een kat heeft krijgt een dier waarvan het dossier niets zegt over katten simpelweg niet te zien.",
    "kenmerkWerklijst.uitlegAi": "Bij %n% hiervan staat genoeg in het dossier om de AI antwoorden te laten voorstellen — je kijkt ze na voordat ze worden opgeslagen.",
    "kenmerkWerklijst.openVan": "%open% van %totaal% open",
    "kenmerkWerklijst.aiKanHelpen": "AI kan helpen",
    "kenmerkWerklijst.geenDossier": "Geen dossiertekst",
    "kenmerkWerklijst.invullen": "Invullen",
    "kenmerkWerklijst.naamloos": "Zonder naam",
    "kenmerkWerklijst.allesGedaan": "Alles op deze pagina is beantwoord.",
    "kenmerkWerklijst.meer": "Toon meer",
    "advertentieListView.title": "Advertenties",
    "advertentieListView.subtitle": "Elk dier met een advertentie, en hoe die ervoor staat.",
    "advertentieListView.stat.total": "Totaal",
    "advertentieListView.acties": "Acties",
    "advertentieListView.stand.NIEUW": "Nieuw",
    "advertentieListView.stand.GERESERVEERD": "Gereserveerd",
    "advertentieListView.stand.GEPLAATST": "Geplaatst",
    "advertentieListView.stand.BUITENBEENTJE": "Buitenbeentje",
    "advertentieListView.actie.stand.BUITENBEENTJE":
      "Tonen als buitenbeentje — de rij \"De buitenbeentjes\" op de home",
    "advertentieListView.actie.stand.NIEUW": "Tonen als nieuw in het asiel",
    "advertentieListView.actie.stand.GERESERVEERD": "Tonen als gereserveerd",
    "advertentieListView.actie.stand.GEPLAATST": "Tonen als geplaatst (gaat na het ingestelde aantal dagen van de site)",
    "advertentieListView.actie.standAutomatisch": "Terug naar automatisch",
    "advertentieDetailView.snel.title": "Direct instellen",
    "advertentieListView.column.bekeken": "Bekeken",
    "advertentieListView.bekeken.uitleg":
      "Hoe vaak dit dier bekeken is op de site waar je nu naar kijkt. DierMatch en ikzoekbaas tellen apart — het zijn twee lijsten met elk hun eigen publiek.",
    "advertentieListView.column.bewaard": "Bewaard",
    "advertentieListView.bewaard.uitleg":
      "Hoeveel bezoekers dit dier nu als favoriet hebben staan. Wie het hartje weghaalt telt niet meer mee.",
    "advertentieListView.column.vragen": "Kenmerken",
    "advertentieListView.vragen.open": "%n% open",
    "advertentieListView.vragen.klaar": "—",
    "advertentieListView.vragen.klaarUitleg": "Alle kenmerken beantwoord — open het dier",
    "advertentieListView.vragen.uitleg":
      "De matchwizard op DierMatch leest deze antwoorden. Elke onbeantwoorde vraag wordt daar “onbekend”, waardoor dit dier nauwelijks meedoet in de match. Klik om ze in te vullen.",
    "advertentieListView.vragen.openAi": "%n% open · AI kan helpen",
    "advertentieListView.vragen.uitlegAi":
      "Bij dit dier staat genoeg in het dossier om de AI de antwoorden te laten voorstellen — je hoeft ze alleen na te kijken. Klik om te beginnen.",
    "advertentieListView.filter.ai": "AI kan helpen",
    "advertentieListView.filter.ai.alle": "Alle",
    "advertentieListView.filter.ai.ja": "Alleen waar de AI kan helpen",
    "advertentieListView.filter.ai.nee": "Alleen zonder dossiertekst",
    "advertentieListView.column.reacties": "Reacties",
    "advertentieListView.reacties.aantal": "%n%",
    "advertentieListView.reacties.nieuw": "%n% · %nieuw% nieuw",
    "advertentieListView.reacties.leeg": "Nog geen reacties — hier staan ze, en hier zet je extra vragen bij dit dier",
    "advertentieListView.reacties.uitleg":
      "Mensen die het formulier op DierMatch hebben ingevuld. Klik om te lezen wat ze schreven en om hun telefoonnummer te vinden.",
    "kennismaking.titel": "Wie %naam% wil leren kennen",
    "kennismaking.ditDier": "dit dier",
    "kennismaking.aantal": "%n% reacties, waarvan %nieuw% nog niet gelezen",
    "kennismaking.aantal.een": "1 reactie, waarvan %nieuw% nog niet gelezen",
    "kennismaking.extra.titel": "Extra vragen bij dit dier",
    "kennismaking.extra.uitleg":
      "Komen op het formulier achter de vaste vragen van de diersoort, in een eigen blok met de naam van het dier. Opslaan stuurt de advertentie meteen opnieuw naar DierMatch.",
    "kennismaking.extra.plaatshouder": "Bijvoorbeeld: heb je een omheinde tuin?",
    "kennismaking.extra.toevoegen": "Vraag toevoegen",
    "kennismaking.extra.verplicht": "Verplicht",
    "kennismaking.extra.bewaard": "Opgeslagen en naar DierMatch gestuurd.",
    "kennismaking.geen":
      "Nog niemand heeft het formulier voor dit dier ingevuld. Reacties staan hier binnen een paar minuten nadat ze zijn verstuurd.",
    "kennismaking.kiesEen": "Kies een reactie om hem te lezen.",
    "kennismaking.nieuw": "Nieuw",
    "kennismaking.zonderNaam": "Naam ontbreekt",
    "kennismaking.heeftNotitie": "Heeft een notitie",
    "kennismaking.overigeAntwoorden": "Overige antwoorden",
    "kennismaking.nietIngevuld": "Niet ingevuld",
    "kennismaking.notitie": "Notitie voor je collega's",
    "kennismaking.notitie.hint": "Dinsdag gebeld, komt zaterdag langs…",
    "kennismaking.notitie.bewaar": "Notitie bewaren",
    "kennismaking.sluiten": "Sluiten",
    "advertentieDetailView.bekeken.label": "Bekeken op de site",
    "advertentieDetailView.bekeken.uitleg":
      "Eén keer per bezoeker geteld, en alleen als de pagina echt in beeld is geweest. Zoekmachines en linkvoorvertoningen tellen niet mee.",
    "advertentieListView.stand.gereserveerd": "Gereserveerd",
    "advertentieListView.actie.gereserveerd": "Gereserveerd",
    "advertentieListView.actie.beschikbaar": "Weer beschikbaar",
    "advertentieListView.actie.openen": "Openen",
    "advertentieListView.filter.kanaal": "Kanaal",
    "advertentieListView.filter.vestiging": "Opvang",
    "advertentieListView.filter.alleVestigingen": "Alle opvangen",
    "advertentieListView.filter.vestigingZoek": "Zoek opvang...",
    "advertentieListView.filter.vestigingGeen": "Geen opvang gevonden.",
    "advertentieListView.filter.vestigingGekozen": "%d opvangen",
    "advertentieListView.filter.allesAan": "Alles aan",
    "advertentieListView.filter.allesUit": "Alles uit",
    "advertentieListView.site": "Site",
    "advertentieListView.filter.clear": "Wis filters",
    "advertentieListView.beschikbaarheid.beschikbaar": "Beschikbaar",
    "advertentieListView.beschikbaarheid.gereserveerd": "Gereserveerd",
    "advertentieListView.beschikbaarheid.nogNiet": "Nog niet beschikbaar",
    "advertentieListView.verouderd.only": "Alleen verouderd",
    "advertentieListView.verouderd.hide": "Bijgewerkt",
    "advertentieListView.results.found": "advertenties gevonden",
    "advertentieListView.results.foundOne": "advertentie gevonden",
    "advertentieListView.viewMode": "Weergave",
    "advertentieListView.cardMode": "Kaarten",
    "advertentieListView.compactMode": "Compact",
    "advertentieListView.listMode": "Lijst",
    "advertentieListView.sortLabel": "Sorteer op:",
    "advertentieListView.sort.gewijzigd": "Laatst gewijzigd",
    "advertentieListView.sort.reacties": "Reacties eerst",
    "advertentieListView.sort.naam": "Naam",
    "advertentieListView.card.noPhoto": "Geen foto",
    "advertentieListView.card.beschikbaarheid": "Beschikbaar",
    "advertentieListView.card.gewijzigd": "Gewijzigd",
    "advertentieListView.search.placeholder": "Zoek op naam van het dier",
    "advertentieListView.filter.status": "Status",
    "advertentieListView.filter.all": "Alle",
    "advertentieListView.filter.opSite": "Op de site",
    "advertentieListView.column.opSite": "Op de site",
    "advertentieListView.opSite.ja": "Staat op de site",
    "advertentieListView.opSite.nee": "Staat er niet op",
    "advertentieListView.opSite.zetErop": "Op deze site zetten",
    "advertentieListView.opSite.haalEraf": "Van deze site halen",
    "advertentieListView.opSite.bezig": "Bezig…",
    "advertentieListView.opSite.mislukt": "Dit dier kon niet op de site gezet worden.",
    "advertentieListView.opSite.teDoen": "Moet nog een advertentie krijgen",
    "advertentieListView.opSite.dierWeg": "Dit dier is op %s uit de opvang vertrokken en hoort niet meer op de site",
    "advertentieListView.status.geen": "Nog geen advertentie",
    "advertentieListView.column.foto": "Foto",
    "advertentieListView.column.dier": "Dier",
    "advertentieListView.column.soort": "Soort",
    "advertentieListView.column.status": "Status",
    "advertentieListView.column.beschikbaarheid": "Beschikbaarheid",
    "advertentieListView.column.verouderd": "Verouderd",
    "advertentieListView.column.gewijzigd": "Laatst gewijzigd",
    "advertentieListView.refresh": "Verversen",
    "advertentieListView.empty": "Geen advertenties gevonden.",
    "advertentieListView.loadFailed": "Kon de advertenties niet laden.",
    "advertentieListView.verouderd.yes": "Verouderd",
    "advertentieListView.verouderd.no": "—",
    "advertentieListView.pagination.range": "%d–%d van %d",
    "advertentieListView.pagination.page": "Pagina %d van %d",
    "advertentieListView.pagination.previous": "Vorige",
    "advertentieListView.pagination.next": "Volgende",
    "advertentieStatus.CONCEPT": "Concept",
    "advertentieStatus.KLAAR_VOOR_CONTROLE": "Klaar voor controle",
    "advertentieStatus.GEPUBLICEERD": "Gepubliceerd",
    "advertentieStatus.GEPLAATST": "Geplaatst",
    "advertentieStatus.GEPAUZEERD": "Gepauzeerd",
    "advertentieStatus.VERLOPEN": "Verlopen",
    "advertentieKanaal.IKZOEKBAAS": "ikzoekbaas.nl",
    "advertentieKanaal.DIERMATCH": "DierMatch",
    "advertentieKanaal.BEIDE": "Allebei",
    "advertentieDetailView.back": "Advertenties",
    "advertentieDetailView.edit": "Bewerken",
    "advertentieDetailView.save": "Opslaan",
    "advertentieDetailView.preview.section": "Live preview",
    "advertentieDetailView.preview.title": "TITEL",
    "advertentieDetailView.preview.cta": "Ik wil %s leren kennen",
    "advertentieDetailView.preview.device.desktop": "Desktop preview",
    "advertentieDetailView.preview.device.mobile": "Mobiele preview",
    "advertentieDetailView.preview.device.instagram": "Instagram post",
    "advertentieDetailView.ai.panel.title": "AI-assistent",
    "advertentieDetailView.ai.panel.subtitle": "Slimme hulp voor een sterke, veilige en compleet klaar advertentie.",
    "advertentieDetailView.ai.card.concept.title": "Maak concepttekst",
    "advertentieDetailView.ai.card.concept.desc": "Genereer een voorstel op basis van AI.",
    "advertentieDetailView.ai.card.warmer.title": "Herschrijf warmer",
    "advertentieDetailView.ai.card.warmer.desc": "Maak de tekst vriendelijker en warmer.",
    "advertentieDetailView.ai.card.korter.title": "Korter maken",
    "advertentieDetailView.ai.card.korter.desc": "Vat samen in een kortere tekst.",
    "advertentieDetailView.ai.card.social.title": "Maak social posts",
    "advertentieDetailView.ai.card.social.desc": "Genereer teksten voor Facebook, Instagram en WhatsApp.",
    "advertentieDetailView.ai.card.foto.title": "Fotohulp",
    "advertentieDetailView.ai.card.foto.desc": "Kies hoofdfoto, volgorde en alt-tekst.",
    "advertentieDetailView.cancel": "Annuleren",
    "advertentieDetailView.markeerKlaar": "Markeer klaar voor controle",
    "advertentieDetailView.ai.label": "AI-hulp:",
    "advertentieDetailView.ai.concept": "Concept maken",
    "advertentieDetailView.ai.altTekst": "AI alt-tekst",
    "advertentieDetailView.extraFotos.opslaan": "Foto's opslaan",
    "advertentieDetailView.extraFotos.geenMedia": "Geen media beschikbaar voor dit dier.",
    "advertentieDetailView.section.social": "Social media",
    "advertentieDetailView.historie": "Historie",
    "advertentieWizard.titel": "Advertentietekst maken voor %s",
    "advertentieWizard.stapVan": "Stap %s van %s",
    "advertentieWizard.vorige": "Vorige",
    "advertentieWizard.volgende": "Volgende",
    "advertentieWizard.schrijf": "Tekst schrijven",
    "advertentieWizard.schrijft": "Bezig met schrijven…",
    "advertentieWizard.stap1.titel": "Stijl",
    "advertentieWizard.stap1.uitleg": "Hoe de tekst leest. Op ikzoekbaas.nl komen allebei de vormen voor: het asiel dat vertelt, of het dier dat zelf aan het woord is.",
    "advertentieWizard.stap2.titel": "Wie is dit dier",
    "advertentieWizard.stap2.uitleg": "Steekwoorden zijn genoeg — de AI maakt er zinnen van. Laat je een veld leeg, dan blijft dat uit de tekst.",
    "advertentieWizard.stap3.titel": "Het thuis dat we zoeken",
    "advertentieWizard.stap3.uitleg": "Wat voor huishouden past, en wat dat vraagt van de nieuwe eigenaar.",
    "advertentieWizard.stap4.titel": "Eerlijk en afsluiten",
    "advertentieWizard.stap4.uitleg": "De advertenties daar benoemen wat lastig is — dat scheelt iedereen een mislukte plaatsing.",
    "advertentieWizard.perspectief": "Wie vertelt het verhaal?",
    "advertentieWizard.perspectief.asiel": "Het asiel",
    "advertentieWizard.perspectief.asiel.uitleg": "\"Ygor kwam als pup bij ons binnen…\"",
    "advertentieWizard.perspectief.dier": "Het dier zelf",
    "advertentieWizard.perspectief.dier.uitleg": "\"Hoi allemaal, ik ben Beer!\"",
    "advertentieWizard.toon": "Toon",
    "advertentieWizard.toon.warm": "Warm en persoonlijk",
    "advertentieWizard.toon.zakelijk": "Rustig en feitelijk",
    "advertentieWizard.lengte": "Lengte",
    "advertentieWizard.lengte.kort": "Kort",
    "advertentieWizard.lengte.gemiddeld": "Gemiddeld",
    "advertentieWizard.lengte.uitgebreid": "Uitgebreid",
    "advertentieWizard.emoji": "Een emoji hier en daar mag",
    "advertentieWizard.herkomst": "Hoe kwam hij of zij bij de opvang?",
    "advertentieWizard.herkomst.hint": "bijv. als zwerver gevonden, afstand gedaan door de eigenaar, teruggekomen na een plaatsing, hier geboren",
    "advertentieWizard.achtergrond": "Wat wil je over zijn verleden vertellen?",
    "advertentieWizard.achtergrond.hint": "bijv. twee eerdere plaatsingen liepen mis, woonde in een verblijf in de tuin, onbekend",
    "advertentieWizard.karakter": "Hoe is zijn karakter?",
    "advertentieWizard.karakter.hint": "bijv. aanhankelijk, veel energie, eigenwijs, onzeker bij vreemden",
    "advertentieWizard.blijVan": "Waar wordt hij blij van?",
    "advertentieWizard.blijVan.hint": "bijv. lange wandelingen, een bal, een schoot, een snoepje, trainen",
    "advertentieWizard.thuis": "Wat voor thuis zoeken jullie?",
    "advertentieWizard.thuis.hint": "bijv. rustig huishouden, tuin is een must, geen flat, kinderen vanaf 12, actief gezin",
    "advertentieWizard.vraagtVan": "Wat vraagt dat van de nieuwe eigenaar?",
    "advertentieWizard.vraagtVan.hint": "bijv. geduld en consequent zijn, ervaring met herders, tijd om door te trainen",
    "advertentieWizard.samenMet": "Samen met een ander dier plaatsen?",
    "advertentieWizard.samenMet.hint": "bijv. samen met zus Shurly, alleen, mag wel een hondenmaatje hebben",
    "advertentieWizard.bijzonderheden": "Wat moet iemand vooraf weten?",
    "advertentieWizard.bijzonderheden.hint": "bijv. hartruis met dagelijkse medicatie, allergie, jaagt op katten, nog niet zindelijk",
    "advertentieWizard.contact": "Hoe neemt iemand contact op?",
    "advertentieWizard.contact.hint": "bijv. eerst mailen voor een afspraak, bellen tijdens openingstijden, niet zomaar langskomen",
    "advertentieWizard.slot": "De tekst wordt meteen in de advertentie opgeslagen; je kunt er daarna alles aan wijzigen.",
    "advertentieWizard.overschrijft": "Er staat al een advertentietekst. Een nieuwe tekst vervangt die.",
    "advertentieDetailView.foto.toevoegen": "Foto's toevoegen",
    "advertentieDetailView.foto.uploadt": "Bezig met uploaden…",
    "advertentieDetailView.foto.uploadHint": "Maak een foto of kies bestanden; ze komen bij het dier te staan.",
    "advertentieDetailView.foto.uploadFout": "Het uploaden is mislukt. Probeer het opnieuw.",
    "advertentieDetailView.notice.onvolledigLeeg": "Nog niet klaar — hieronder staat wat er nog moet gebeuren.",
    "advertentieDetailView.punten.titel": "Wat moet er nog gebeuren",
    "advertentieDetailView.punt.STATUS": "Klaarzetten",
    "advertentieDetailView.punt.BLOKKADE": "Dossierblokkade",
    "advertentieDetailView.punt.VELDEN": "Invullen",
    "advertentieDetailView.punt.PERSOONSGEGEVENS": "Uit de tekst halen",
    "advertentieDetailView.punt.KENMERKEN": "Vragen invullen",
    "advertentieDetailView.punt.PRIVACY": "Privacycheck",
    "advertentieDetailView.punt.GOEDKEURING": "Goedkeuren",
    "advertentieDetailView.punt.GEEN_ADVERTENTIE": "Geen advertentie",
    "advertentieDetailView.punt.OVERIG": "Openstaand",
    "advertentieDetailView.punt.opnieuw": "Opnieuw controleren",
    "advertentieDetailView.check.compleet": "Compleet",
    "advertentieDetailView.check.open": "%s open punt(en)",
    "advertentieDetailView.check.privacySchoon": "Privacy schoon",
    "advertentieDetailView.check.privacyLet": "Privacy: %s aandachtspunt(en)",
    "advertentieDetailView.blok.opnieuw": "Opnieuw schrijven",
    "advertentieDetailView.blok.verbeter": "Verbeteren",
    "advertentieDetailView.kenmerkenInvullen": "Vragen invullen",
    "advertentieDetailView.kenmerken.uitleg": "Dit zijn de vragen die ikzoekbaas.nl stelt. Wat je hier beantwoordt komt in de advertentie te staan; wat je openlaat staat er als Onbekend.",
    "advertentieDetailView.social.kopieer": "Kopiëren",
    "advertentieDetailView.social.facebook": "Facebook",
    "advertentieDetailView.social.instagram": "Instagram",
    "advertentieDetailView.social.whatsapp": "WhatsApp",
    "advertentieDetailView.social.nieuwsbrief": "Nieuwsbrief",
    "advertentieDetailView.ai.unavailable": "AI is niet geconfigureerd — vul de tekst handmatig in.",
    "advertentieDetailView.notice.aiApplied": "AI-voorstel toegepast — controleer en sla op.",
    "advertentieDetailView.notice.aiFailed": "De AI-aanvraag is mislukt of niet beschikbaar.",
    "advertentieDetailView.notice.aiPrivacyClean": "Privacycheck: geen waarschuwingen.",
    "advertentieDetailView.notice.aiPrivacyWarn": "Privacycheck — mogelijk persoonsgegevens:",
    "advertentieDetailView.goedkeuren": "Goedkeuren",
    "advertentieDetailView.publiceer": "Publiceren",
    "advertentieDetailView.pauzeer": "Pauzeren",
    "advertentieDetailView.hervat": "Hervatten",
    "advertentieDetailView.markeerVerlopen": "Markeer verlopen",
    "advertentieDetailView.opnieuwVersturen": "Opnieuw versturen",
    "advertentieDetailView.opnieuwVersturenUitleg": "Stuurt deze advertentie ongewijzigd opnieuw naar het platform \u2014 voor als de instellingen zijn veranderd maar de advertentie niet.",
    "advertentieDetailView.notice.opnieuwVerstuurd": "Opnieuw naar het platform verstuurd.",
    // Platformwachtrij: wat DierMatch niet bereikte blijft staan en wordt opnieuw geprobeerd; een afwijzing heet zo.
    "advertentieDetailView.notice.platformInWachtrij": "Het platform was niet bereikbaar. De advertentie staat in de wachtrij en wordt vanzelf verstuurd.",
    "advertentieDetailView.notice.platformAfgewezen": "Het platform heeft de advertentie afgewezen:",
    "advertentieDetailView.wachtrij.wachtend": "Nog niet op het platform — staat in de wachtrij.",
    "advertentieDetailView.wachtrij.afgewezen": "Het platform heeft deze advertentie afgewezen.",
    "advertentieDetailView.wachtrij.volgendePoging": "Volgende poging: %s (%s poging(en) mislukt).",
    "advertentieDetailView.wachtrij.laatsteFout": "Laatste fout:",
    "advertentieDetailView.wachtrij.nuProberen": "Nu opnieuw proberen",
    "advertentieDetailView.field.platformWachtrij": "Platformwachtrij",
    "advertentieWachtrijToestand.WACHTEND": "Wacht op het platform",
    "advertentieWachtrijToestand.VERSTUURD": "Aangekomen",
    "advertentieWachtrijToestand.AFGEWEZEN": "Afgewezen",
    "advertentieDetailView.heropen": "Heropenen",
    "advertentieDetailView.section.publishGuard": "Publicatie-checklist",
    "advertentieDetailView.publishGuard.ok": "Klaar om te publiceren.",
    "advertentieDetailView.notice.approved": "Goedgekeurd.",
    "advertentieDetailView.notice.published": "Gepubliceerd.",
    "advertentieDetailView.notice.lifecycle": "Status bijgewerkt.",
    "advertentieDetailView.notice.publishBlocked": "Nog niet publiceerbaar:",
    "advertentieDetailView.hoofdfoto": "Hoofdfoto",
    "advertentieDetailView.hoofdfoto.geen": "Geen hoofdfoto",
    "advertentieDetailView.hoofdfoto.geenOpties": "Geen foto's beschikbaar voor dit dier.",
    "advertentieDetailView.section.extraFotos": "Extra foto's",
    "advertentieDetailView.notice.saved": "Opgeslagen.",
    "advertentieDetailView.notice.conflict": "Gewijzigd door iemand anders — vernieuw en probeer opnieuw.",
    "advertentieDetailView.notice.forbidden": "Je hebt geen rechten om advertenties te bewerken.",
    "advertentieDetailView.notice.error": "Er ging iets mis.",
    "advertentieDetailView.notice.klaar": "Klaar gemarkeerd voor controle.",
    "advertentieDetailView.notice.onvolledig": "Nog niet volledig — ontbreekt:",
    "advertentieDetailView.loadFailed": "Kon de advertentie niet laden.",
    "advertentieDetailView.verouderdBanner": "Het dossier is na publicatie gewijzigd — deze advertentie is mogelijk verouderd.",
    "advertentieDetailView.dierWegBanner": "Dit dier is op %s uit de opvang vertrokken en hoort niet meer op de site. Zet de sites hieronder uit, of markeer de advertentie als verlopen.",
    "advertentieDetailView.blokkadeBanner": "Publicatie is geblokkeerd.",
    "advertentieDetailView.section.teksten": "Teksten",
    "advertentieDetailView.section.kenmerken": "Kenmerken",
    "advertentieDetailView.section.fotos": "Foto's",
    "advertentieDetailView.section.publicatie": "Publicatie",
    "advertentieDetailView.section.afzender": "Afzender (asiel)",
    "advertentieDetailView.bewerk.knop": "Bewerken",
    "advertentieDetailView.bewerk.tags": "Naam en tags bewerken",
    "advertentieDetailView.bewerk.fotos": "Foto's bewerken",
    "advertentieDetailView.bewerk.kenmerken": "Vragen invullen",
    "advertentieDetailView.bewerk.afzender": "Afzendergegevens bewerken",
    "advertentieDetailView.bewerk.leeg": "Nog niet ingevuld",
    "advertentieDetailView.field.afzenderNaam": "Naam",
    "advertentieDetailView.field.afzenderTelefoon": "Telefoon",
    "advertentieDetailView.field.afzenderEmail": "E-mail",
    "advertentieDetailView.field.afzenderUrl": "Website",
    "advertentieDetailView.field.afzenderHint": "Staat op de publieke pagina onder de locatie van het dier.",
    "advertentieDetailView.section.log": "Activiteitenlog",
    "advertentieDetailView.field.status": "Status",
    "advertentieDetailView.field.kanaal": "Kanaal",
    "advertentieDetailView.field.soort": "Soort",
    "advertentieDetailView.field.ras": "Ras",
    "advertentieDetailView.field.geslacht": "Geslacht",
    "advertentieDetailView.field.leeftijd": "Leeftijd",
    "advertentieDetailView.field.geboortedatum": "Geboortedatum",
    "advertentieDetailView.field.locatie": "Locatie",
    "advertentieDetailView.field.beschikbaarheid": "Beschikbaarheid",
    "advertentieDetailView.section.plaatsing": "Op de site",
    "advertentieDetailView.buitenbeentje.label": "Buitenbeentje",
    "advertentieDetailView.buitenbeentje.auto": "Automatisch",
    "advertentieDetailView.buitenbeentje.wel": "Wel tonen",
    "advertentieDetailView.buitenbeentje.niet": "Niet tonen",
    "advertentieDetailView.buitenbeentje.uitleg.auto":
      "De site bepaalt het zelf, aan de hand van de vraag of dit dier extra zorg nodig heeft.",
    "advertentieDetailView.buitenbeentje.uitleg.wel":
      "Dit dier staat in de rij \"De buitenbeentjes\" op de home van ikzoekbaas.",
    "advertentieDetailView.buitenbeentje.uitleg.niet":
      "Dit dier blijft uit \"De buitenbeentjes\", ook als het extra zorg nodig heeft.",
    "advertentieDetailView.ai.verbeter": "Verbeter “Over dit dier”",
    "advertentieDetailView.ai.vragen": "Laat de AI de vragen invullen",
    "advertentieDetailView.ai.vragenBezig": "Bezig met het dossier lezen…",
    "advertentieDetailView.ai.vragenUitleg": "Alleen op grond van wat het dossier zegt. Er wordt niets opgeslagen tot je op Opslaan drukt.",
    "advertentieDetailView.ai.bron": "uit het dossier: %s",
    "advertentieDetailView.notice.aiGeenVoorstellen": "Het dossier zegt niets over deze vragen.",
    "advertentieDetailView.field.succesverhaal": "Succesverhaal",
    "advertentieDetailView.field.succesverhaalHint":
      "Hoe de plaatsing ging. Dit is het enige dat op de site blijft staan als het dier eraf gaat: het komt in \"De succesverhalen\" op de home. Over het dier, nooit over de nieuwe eigenaar.",
    "advertentieDetailView.field.altTekst": "Alt-tekst afbeelding",
    "advertentieDetailView.field.tags": "Tags (DierMatch)",
    "advertentieDetailView.field.tagsPlaceholder": "Vriendelijk, Actief, Kan alleen zijn",
    "advertentieDetailView.field.tagsHint": "Korte labels, gescheiden door komma's \u2014 hoogstens 10, elk tot 40 tekens. Dit zijn de chips op DierMatch.nl.",
    "advertentieDetailView.field.publicatieUrl": "Publicatie-URL",
    "advertentieDetailView.field.externeId": "Externe ID",
    "advertentieDetailView.field.publicatiedatum": "Gepubliceerd op",
    "advertentieDetailView.field.laatsteSync": "Laatste sync",
    "advertentieDetailView.field.platformStatus": "Platformstatus",
    "advertentieDetailView.field.publicatieKanalen": "Kanalen",
    "advertentieDetailView.field.goedgekeurdDoor": "Goedgekeurd door",
    "advertentieDetailView.field.foutmelding": "Foutmelding",
    "advertentieDetailView.field.naam": "Naam",
    "advertentieDetailView.field.telefoon": "Telefoon",
    "advertentieDetailView.field.email": "E-mail",
    "advertentieDetailView.field.website": "Website",
    "advertentieDetailView.tekst.overDitDier": "Over dit dier",
    "advertentieDetailView.tekst.pastBij": "Past bij",
    "advertentieDetailView.tekst.belangrijk": "Belangrijk om te weten",
    "advertentieDetailView.kenmerk.publiceerbaar": "Publiceerbaar",
    "advertentieDetailView.empty.kenmerken": "Geen kenmerken.",
    "advertentieDetailView.empty.fotos": "Geen extra foto's geselecteerd.",
    "advertentieDetailView.empty.log": "Nog geen activiteit.",
    "advertentieDetailView.log.column.tijd": "Tijd",
    "advertentieDetailView.log.column.actor": "Door",
    "advertentieDetailView.log.column.actie": "Actie",
    "advertentieDetailView.log.column.detail": "Detail",
    "advertentieKenmerk.KAN_BIJ_KINDEREN": "Kan bij kinderen",
    "advertentieKenmerk.KAN_BIJ_HONDEN": "Kan bij honden",
    "advertentieKenmerk.KAN_BIJ_KATTEN": "Kan bij katten",
    "advertentieKenmerk.ZINDELIJK": "Zindelijk",
    "advertentieDetailView.kenmerk.geenAntwoord": "— niet ingevuld —",
    "advertentieDetailView.kenmerk.toelichting": "Toelichting (optioneel)",
    "advertentieKenmerk.MOET_BIJ_SOORTGENOTEN": "Moet bij soortgenoten",
    "advertentieKenmerk.GECASTREERD_GESTERILISEERD": "Gecastreerd / Gesteriliseerd",
    "advertentieKenmerk.KAN_ALLEEN_THUISBLIJVEN": "Kan alleen thuisblijven",
    "advertentieKenmerk.KAN_MEE_IN_DE_AUTO": "Kan mee in de auto",
    "advertentieKenmerk.BASIS_COMMANDOS": "Beheerst basis commando's",
    "advertentieKenmerk.WAAKSHEID": "Waaksheid",
    "advertentieKenmerk.SCHOFTHOOGTE": "Schofthoogte",
    "advertentieKenmerk.KAN_LOSLOPEN": "Kan loslopen",
    "advertentieKenmerk.BESCHIKBAARHEID": "Beschikbaarheid",
    "advertentieKenmerk.AAN_DE_LIJN": "Aan de lijn",
    "advertentieKenmerk.VACHTVERZORGING": "Vachtverzorging",
    "advertentieKenmerk.SPECIALE_ZORG": "Speciale zorg",
    "advertentieBlok.intro": "Intro",
    "advertentieBlok.overDitDier": "Over dit dier",
    "advertentieBlok.pastBij": "Past bij",
    "advertentieBlok.belangrijkOmTeWeten": "Belangrijk om te weten",
    "advertentieLogActor.AI": "AI",
    "advertentieLogActor.MEDEWERKER": "Medewerker",
    "advertentieLogActor.SYSTEEM": "Systeem",
    "kennelplanning.title": "Planning",
    "kennelplanning.toolbar.refresh": "Verversen",
    "kennelplanning.toolbar.stickers": "Verblijfstickers afdrukken",
    "kennelplanning.toolbar.stickersUitleg":
      "Drukt een vel QR-stickers af, één per verblijf. Wie er in de dierverzorgers-app een scant, staat meteen bij dat verblijf.",
    "kennelplanning.viewMode.floorplan": "Plattegrond",
    "kennelplanning.viewMode.timeline": "Tijdlijn",
    "kennelplanning.viewMode.list": "Lijstweergave",
    "kennelplanning.viewMode.soon": "Binnenkort",
    "kennelplanning.species.honden": "Honden",
    "kennelplanning.species.katten": "Katten",
    "kennelplanning.species.overig": "Overig",
    "kennelplanning.dateMode.dateLabel": "DATUM",
    "kennelplanning.dateMode.periodLabel": "PERIODE",
    "kennelplanning.dateMode.from": "Van",
    "kennelplanning.dateMode.to": "Tot",
    "kennelplanning.date.today": "Vandaag",
    "kennelplanning.timeline.invalidRange": "Ongeldige periode.",
    "kennelplanning.timeline.timeTravel": "Tijdreis",
    "kennelplanning.timeline.empty": "Geen verblijven in deze periode.",
    "kennelplanning.trace.banner.prefix": "Besmettingsonderzoek:",
    "kennelplanning.trace.banner.sameKennel": "zelfde verblijf:",
    "kennelplanning.trace.banner.neighbour": "buurverblijf:",
    "kennelplanning.trace.banner.overlapDays": "dagen overlap",
    "kennelplanning.trace.banner.noContacts": "geen contact-dieren gevonden",
    "kennelplanning.trace.banner.close": "Sluit",
    "kennelplanning.trace.bar.source": "BRON",
    "kennelplanning.historyDrawer.title": "Dier-overzicht",
    "kennelplanning.historyDrawer.aandachtspunten": "Aandachtspunten",
    "kennelplanning.historyDrawer.medisch": "Medisch",
    "kennelplanning.historyDrawer.bijzonderheden": "Bijzonderheden",
    "kennelplanning.historyDrawer.geenAandachtspunten": "Geen aandachtspunten",
    "kennelplanning.historyDrawer.verblijfshistorie": "Verblijfshistorie",
    "kennelplanning.historyDrawer.geenHistorie": "Geen verblijfshistorie",
    "kennelplanning.historyDrawer.heden": "heden",
    "kennelplanning.historyDrawer.door": "door %s",
    "kennelplanning.historyDrawer.besmettingsonderzoek": "Besmettingsonderzoek",
    "kennelplanning.historyDrawer.besmettingsSub": "Toon contact van %s",
    "kennelplanning.historyDrawer.openDossier": "Open dierdossier",
    "kennelplanning.historyDrawer.contactonderzoek": "Contactonderzoek",
    "kennelplanning.historyDrawer.contactenTonen": "Contacten tonen",
    "kennelplanning.historyDrawer.contactenVerbergen": "Contacten verbergen",
    "kennelplanning.historyDrawer.geenContacten": "Geen contact-dieren gevonden",
    "kennelplanning.historyDrawer.zelfdeKennel": "ZELFDE KENNEL",
    "kennelplanning.historyDrawer.buur": "BUUR",
    "kennelplanning.historyDrawer.overlap": "%d dagen overlap",
    "kennelplanning.historyDrawer.gewicht": "Gewicht",
    "kennelplanning.historyDrawer.enting": "Enting",
    "kennelplanning.historyDrawer.voeding": "Voeding",
    "kennelplanning.historyDrawer.recenteNotities": "Recente notities",
    "kennelplanning.historyDrawer.geenNotities": "Geen notities",
    "kennelplanning.empty.noVestiging": "Geen vestiging geselecteerd.",
    "kennelplanning.empty.noGroups": "Geen ruimtes ingericht voor deze vestiging.",
    "kennelplanning.empty.moduleDisabled": "De verblijfplanning-module is uitgeschakeld voor deze organisatie.",
    "kennelplanning.loadFailed": "Kon de planning niet laden.",
    "kennelplanning.tile.empty": "Leeg",
    "kennelplanning.tile.daysPrefix": "dag",
    "kennelplanning.pending.title": "Te plaatsen dieren",
    "kennelplanning.pending.dropHint": "Sleep een dier uit een verblijf om vrij te geven",
    "kennelplanning.pending.aiTip": "AI tip",
    "kennelplanning.verplaats.oppakken": "Verplaats",
    "kennelplanning.verplaats.kiesHok": "Tik een verblijf aan voor %s",
    "kennelplanning.verplaats.kiesHokOfLos": "Tik een verblijf aan voor %s — of de wachtrij om hem uit zijn verblijf te halen",
    "kennelplanning.capacity.title": "Capaciteit",
    "kennelplanning.capacity.liveLabel": "VANDAAG · LIVE",
    "kennelplanning.capacity.addRoom": "Nieuwe ruimte",
    "kennelplanning.capacity.projection.title": "PROGNOSE BEZETTING",
    "kennelplanning.capacity.projection.none":
      "Geen prognose: te weinig opname/uitboek-mutaties (min. 5 in venster).",
    "kennelplanning.capacity.projection.full": "Asiel is vol",
    "kennelplanning.capacity.projection.days": "%d dagen vol",
    "kennelplanning.capacity.projection.basis":
      "Op basis van 28d: %d opname / %d uitboek (%s netto) · trend %s",
    "kennelplanning.capacity.projection.trend.STABIEL": "stabiel",
    "kennelplanning.capacity.projection.trend.STIJGEND": "stijgend",
    "kennelplanning.capacity.projection.trend.DALEND": "dalend",
    "kennelplanning.suggestion.banner": "AI tip voor %s: verblijf %s in %s (%d ptn)",
    "kennelplanning.suggestion.badge": "+ AI TIP",
    "kennelplanning.suggestion.clear": "Suggesties wissen",
    "kennelplanning.suggestion.none": "Geen vrije verblijf gevonden voor dit dier.",
    "kennelplanning.rightPanel.collapse": "Capaciteit-paneel inklappen",
    "kennelplanning.rightPanel.expand": "Capaciteit-paneel uitklappen",
    "kennelplanning.roomTypes.title": "Ruimtetypes",
    "kennelplanning.roomTypes.subtitle": "CONFIGURATIE",
    "kennelplanning.roomTypes.addNew": "Nieuw type",
    "kennelplanning.list.kamer": "Kamer",
    "kennelplanning.list.kennel": "Verblijf",
    "kennelplanning.list.naam": "Naam",
    "kennelplanning.list.geslacht": "Geslacht",
    "kennelplanning.list.ras": "Ras",
    "kennelplanning.list.dagen": "Dagen",
    "kennelplanning.list.opname": "Opnamedatum",
    "kennelplanning.list.empty": "(leeg)",
    "kennelplanning.ruimtetype.short.STANDARD": "STANDAARD",
    "kennelplanning.ruimtetype.short.QUARANTINE": "QUARANTAINE",
    "kennelplanning.ruimtetype.short.ISOLATION": "ISOLATIE",
    "kennelplanning.ruimtetype.short.PUPPY": "PUPPY",
    "kennelplanning.ruimtetype.short.KITTEN": "KITTEN",
    "kennelplanning.ruimtetype.short.OTHER": "OVERIG",
    "kennelplanning.ruimtetype.sub.STANDARD": "Max 1 dier · Standaard zorg",
    "kennelplanning.ruimtetype.sub.QUARANTINE": "Bij binnenkomst · Min. 10 dagen",
    "kennelplanning.ruimtetype.sub.ISOLATION": "Bij ziekte · Aparte ingang",
    "kennelplanning.ruimtetype.sub.PUPPY": "Jonge dieren · Speelzone",
    "kennelplanning.ruimtetype.sub.KITTEN": "Jonge katten · Klein",
    "kennelplanning.ruimtetype.sub.OTHER": "Overige ruimtes",
    "kennelplanning.list.velden": "Velden",
    "kennelplanning.fieldSettings.open": "Veldinstellingen",
    "kennelplanning.fieldSettings.title": "Veldinstellingen",
    "kennelplanning.fieldSettings.subtitle": "Kies welke velden op de planning verschijnen",
    "kennelplanning.fieldSettings.reset": "Standaard",
    "kennelplanning.fieldSettings.group.identiteit": "Identiteit",
    "kennelplanning.fieldSettings.group.status": "Status",
    "kennelplanning.fieldSettings.group.verblijf": "Verblijf",
    "kennelplanning.fieldSettings.group.medisch": "Medisch",
    "kennelplanning.fieldSettings.group.locatie": "Locatie",
    "kennelplanning.fieldSettings.unit.days": "d",
    "kennelplanning.fieldSettings.unit.years": "j",
    "kennelplanning.fieldSettings.unit.months": "m",
    "kennelplanning.fieldSettings.unit.kg": "kg",
    "kennelplanning.fieldSettings.value.castrated": "Gecastreerd",
    "kennelplanning.fieldSettings.value.geen": "Geen",
    "kennelplanning.fieldSettings.value.plaatsbaar": "Plaatsbaar",
    "kennelplanning.fieldSettings.value.zindelijk": "Zindelijk",
    "kennelplanning.fieldSettings.value.drinktFles": "Drinkt uit fles",
    "kennelplanning.fieldSettings.field.NAME": "Naam",
    "kennelplanning.fieldSettings.field.PHOTO": "Foto",
    "kennelplanning.fieldSettings.field.ID": "Chip-/pasnummer",
    "kennelplanning.fieldSettings.field.PASPOORT": "Paspoortnummer",
    "kennelplanning.fieldSettings.field.STAMBOOM": "Stamboomnummer",
    "kennelplanning.fieldSettings.field.TATOEAGE": "Tatoeage",
    "kennelplanning.fieldSettings.field.SPECIES": "Diersoort",
    "kennelplanning.fieldSettings.field.RAS": "Ras",
    "kennelplanning.fieldSettings.field.KRUISING": "Kruising",
    "kennelplanning.fieldSettings.field.VACHT": "Vacht",
    "kennelplanning.fieldSettings.field.KLEUR": "Kleur",
    "kennelplanning.fieldSettings.field.KENMERKEN": "Kenmerken",
    "kennelplanning.fieldSettings.field.BIJZONDERHEDEN": "Bijzonderheden",
    "kennelplanning.fieldSettings.field.GENDER": "Geslacht",
    "kennelplanning.fieldSettings.field.CASTRATED": "Gecastreerd",
    "kennelplanning.fieldSettings.field.LEEFTIJD": "Leeftijd",
    "kennelplanning.fieldSettings.field.GEBOORTE": "Geboortedatum",
    "kennelplanning.fieldSettings.field.PLAATSBAAR": "Plaatsbaar",
    "kennelplanning.fieldSettings.field.ZINDELIJK": "Zindelijk",
    "kennelplanning.fieldSettings.field.DRINKT_FLES": "Drinkt uit fles",
    "kennelplanning.fieldSettings.field.DAYS": "Dagen in asiel",
    "kennelplanning.fieldSettings.field.OPNAME": "Opnamedatum",
    "kennelplanning.fieldSettings.field.OPNAME_SOORT": "Opnamesoort",
    "kennelplanning.fieldSettings.field.VERTREK_DATUM": "Vertrekdatum",
    "kennelplanning.fieldSettings.field.VERBLIJF_NUMMER": "Verblijfnummer",
    "kennelplanning.fieldSettings.field.HALSBAND": "Halsbandnummer",
    "kennelplanning.fieldSettings.field.GERESERVEERD_TOT": "Gereserveerd tot",
    "kennelplanning.fieldSettings.field.OPMERKING_IN": "Opmerking opname",
    "kennelplanning.fieldSettings.field.FLAGS": "Vlaggen (M/!/D)",
    "kennelplanning.fieldSettings.field.GEWICHT": "Gewicht",
    "kennelplanning.fieldSettings.field.ENTING": "Enting",
    "kennelplanning.fieldSettings.field.KENNEL_NUM": "Verblijfnummer",
    "factuurListView.title": "Facturen",
    "factuurListView.search.placeholder": "Zoek op nummer of klant…",
    "factuurListView.filter.from": "Vanaf",
    "factuurListView.filter.to": "Tot en met",
    "factuurListView.refresh": "Vernieuwen",
    "factuurListView.empty": "Geen facturen.",
    "factuurListView.loadFailed": "Kan facturen niet laden.",
    "factuurListView.column.nummer": "Nr.",
    "factuurListView.column.datum": "Factuurdatum",
    "factuurListView.column.status": "Status",
    "factuurListView.column.klant": "Klant",
    "factuurListView.column.totaal": "Totaal",
    "factuurListView.column.openstaand": "Openstaand",
    "factuurListView.column.type": "Type",
    "factuurListView.status.CONCEPT": "Concept",
    "factuurListView.status.BETAALD": "Betaald",
    "factuurListView.status.OPENSTAAND": "Openstaand",
    "factuurListView.status.VERVALLEN": "Vervallen",
    "factuurListView.type.C": "Creditfactuur",
    "factuurListView.type.A": "Geannuleerd",
    "factuurListView.type.F": "Factuur",
    "factuurListView.pagination.range": "%d–%d van %d",
    "factuurListView.pagination.page": "Pagina %d van %d",
    "factuurListView.pagination.previous": "Vorige",
    "factuurListView.pagination.next": "Volgende",
    "factuurDetailView.heading": "Factuur",
    "factuurDetailView.loadFailed": "De factuur kon niet worden geladen.",
    "factuurDetailView.status.CONCEPT": "Concept",
    "factuurDetailView.status.BETAALD": "Betaald",
    "factuurDetailView.status.OPENSTAAND": "Openstaand",
    "factuurDetailView.status.VERVALLEN": "Vervallen",
    "factuurDetailView.tile.klantgegevens": "Klantgegevens",
    "factuurDetailView.tile.factuurinfo": "Factuurinformatie",
    "factuurDetailView.tile.samenvatting": "Betaling & Samenvatting",
    "factuurDetailView.tile.tijdlijn": "Tijdlijn / Historie",
    "factuurDetailView.tile.factuurregels": "Factuurregels",
    "factuurDetailView.tile.betalingen": "Betalingen overzicht",
    "factuurDetailView.tile.bijlagen": "Bijlagen & Notities",
    "factuurDetailView.tile.notitielogboek": "Notitie-logboek",
    "factuurDetailView.tile.snelleActies": "Snelle acties",
    "factuurDetailView.tile.betaalstatus": "Betaalstatus",
    "factuurDetailView.info.nummer": "Nummer",
    "factuurDetailView.info.datum": "Factuurdatum",
    "factuurDetailView.info.verval": "Vervaldatum",
    "factuurDetailView.info.status": "Status",
    "factuurDetailView.info.betaalmethode": "Betaalmethode",
    "factuurDetailView.info.referentie": "Externe referentie",
    "factuurDetailView.klant.naam": "Naam",
    "factuurDetailView.klant.adres": "Adres",
    "factuurDetailView.klant.telefoon": "Telefoon",
    "factuurDetailView.klant.email": "E-mail",
    "factuurDetailView.klant.debiteur": "Debiteurnummer",
    "factuurDetailView.klant.geen": "Geen klant gekoppeld aan deze factuur.",
    "factuurDetailView.klant.soort": "SOORT FACTUUR",
    "factuurDetailView.klant.losseVerkoop": "Losse verkoop",
    "factuurDetailView.klant.geenDebiteur": "Debiteur onbekend — aan de balie afgerekend.",
    "factuurDetailView.samenvatting.subtotaal": "Subtotaal (excl. btw)",
    "factuurDetailView.samenvatting.btw": "Btw",
    "factuurDetailView.samenvatting.korting": "Korting",
    "factuurDetailView.samenvatting.totaal": "Totaal",
    "factuurDetailView.samenvatting.betaald": "Betaald",
    "factuurDetailView.samenvatting.openstaand": "Openstaand",
    "factuurDetailView.regels.col.omschrijving": "Omschrijving",
    "factuurDetailView.regels.col.aantal": "Aantal",
    "factuurDetailView.regels.col.prijs": "Prijs",
    "factuurDetailView.regels.col.btw": "Btw",
    "factuurDetailView.regels.col.totaal": "Totaal",
    "factuurDetailView.regels.empty": "Deze factuur heeft geen regels.",
    "factuurDetailView.betalingen.col.datum": "Datum",
    "factuurDetailView.betalingen.col.methode": "Methode",
    "factuurDetailView.betalingen.col.referentie": "Referentie",
    "factuurDetailView.betalingen.col.bedrag": "Bedrag",
    "factuurDetailView.betalingen.geannuleerd": "geannuleerd",
    "factuurDetailView.betalingen.empty": "Geen betalingen geregistreerd.",
    "factuurDetailView.betalingen.volledigBetaald": "Deze factuur is volledig betaald.",
    "factuurDetailView.tijdlijn.empty": "Nog geen gebeurtenissen.",
    "factuurDetailView.bijlagen.geenNotitie": "Geen notitie op deze factuur.",
    "factuurDetailView.notitielog.toevoegen": "Notitie toevoegen",
    "factuurDetailView.tijdlijn.door": "door %s",
    "factuurDetailView.notitielog.fout": "De notitie is niet opgeslagen. Probeer het opnieuw.",
    "factuurDetailView.notitielog.notitie": "Notitie",
    "factuurDetailView.notitielog.geen": "Geen notitie-logboek voor deze factuur.",
    "factuurDetailView.notitielog.verwijder": "Notitie verwijderen",
    "factuurDetailView.notitielog.verwijderBevestig": "Deze notitie uit het logboek verwijderen?",
    "factuurDetailView.acties.betaling": "Betaling registreren",
    "factuurDetailView.acties.herinnering": "Herinnering sturen",
    "factuurDetailView.acties.crediteren": "Crediteren",
    "factuurDetailView.acties.dupliceren": "Dupliceren",
    "factuurDetailView.acties.annuleren": "Annuleren",
    "factuurDetailView.acties.binnenkort": "Beschikbaar in een latere fase",
    "factuurDetailView.betaalstatus.openstaand": "openstaand",
    "factuurDetailView.betaalstatus.totaalBetaald": "Totaal betaald",
    "factuurDetailView.betaalstatus.openstaandLabel": "Openstaand",
    "factuurDetailView.betaalstatus.statusLabel": "Status",
    "factuurDetailView.regels.subtotaal": "Subtotaal (excl. btw)",
    "factuurDetailView.regels.totaal": "Totaal",
    "factuurDetailView.bijlagen.bijlagen": "Bijlagen",
    "factuurDetailView.bijlagen.geenBijlagen": "Er zijn nog geen bijlagen bij deze factuur.",
    "factuurDetailView.acties.regelToevoegen": "Regel toevoegen",
    "factuurDetailView.acties.herinneringMax": "Beide herinneringen al verstuurd",
    "factuurDetailView.betaling.bedrag": "Bedrag",
    "factuurDetailView.betaling.datum": "Datum",
    "factuurDetailView.betaling.wijze": "Betaalwijze",
    "factuurDetailView.betaling.volledig": "Volledig openstaand",
    "factuurDetailView.betaling.restant": "Restant na deze betaling",
    "factuurDetailView.betaling.mailen": "Factuur mailen naar %s",
    "factuurDetailView.betaling.mailenGeenAdres": "Factuur mailen (klant heeft geen e-mailadres)",
    "factuurDetailView.regel.naam": "Omschrijving",
    "factuurDetailView.regel.aantal": "Aantal",
    "factuurDetailView.regel.prijs": "Stukprijs (incl. btw)",
    "factuurDetailView.regel.btw": "Btw-tarief",
    "factuurDetailView.regels.verwijder": "Regel verwijderen",
    "factuurDetailView.regels.verwijderBevestig": "Deze factuurregel verwijderen?",
    "factuurDetailView.betalingen.annuleer": "Betaling annuleren",
    "factuurDetailView.betalingen.afboeken": "Afboeken",
    "factuurDetailView.betalingen.annuleerBevestig": "Deze betaling afboeken (annuleren)?",
    "factuurDetailView.bijlagen.notitie": "Notitie op de factuur",
    "factuurDetailView.bijlagen.notitieUitleg": "Deze tekst komt op de factuur die de klant krijgt. Aantekeningen voor uzelf horen hieronder, bij Interne notities.",
    "factuurDetailView.bijlagen.opDeFactuur": "Op de factuur (zichtbaar voor klant)",
    "factuurDetailView.bijlagen.bewerken": "Notitie bewerken",
    "factuurDetailView.dialog.betaling.titel": "Betaling registreren",
    "factuurDetailView.dialog.regel.titel": "Factuurregel toevoegen",
    "factuurDetailView.dialog.notitie.titel": "Notitie bewerken",
    "factuurDetailView.confirm.herinnering": "Een herinnering voor deze factuur sturen?",
    "factuurDetailView.confirm.ja": "Bevestigen",
    "factuurDetailView.notice.conflict": "Gewijzigd — opnieuw geladen, probeer nogmaals.",
    "factuurDetailView.notice.error": "Er ging iets mis. Probeer het opnieuw.",
    "factuurDetailView.notice.forbidden": "U mag deze actie niet uitvoeren.",
    "factuurDetailView.notice.credited": "Creditfactuur #%s aangemaakt.",
    "factuurDetailView.notice.duplicated": "Factuur gedupliceerd (#%s).",
    "factuurDetailView.lifecycle.crediteren.titel": "Factuur crediteren",
    "factuurDetailView.lifecycle.crediteren.bevestig": "Een creditfactuur voor deze factuur aanmaken?",
    "factuurDetailView.lifecycle.dupliceren.titel": "Factuur dupliceren",
    "factuurDetailView.lifecycle.dupliceren.bevestig": "Een kopie van deze factuur aanmaken?",
    "factuurDetailView.lifecycle.annuleren.titel": "Factuur annuleren",
    "factuurDetailView.lifecycle.annuleren.bevestig": "Deze factuur annuleren? Het openstaande bedrag wordt op nul gezet.",
    "factuurDetailView.export.pdf": "PDF",
    "factuurDetailView.export.csv": "Betalingen (CSV)",
    "factuurDetailView.export.email": "Versturen per e-mail",
    "factuurDetailView.export.emailBevestig": "Deze factuur als PDF naar de klant e-mailen?",
    "factuurDetailView.notice.emailSent": "De factuur is naar de klant verstuurd.",
    "factuurDetailView.notice.emailNoEmail": "De klant heeft geen e-mailadres.",
    "factuurDetailView.notice.exportError": "De download kon niet worden gestart. Probeer het opnieuw.",
    // Design-opmaak (cards/factuur-detail.html): de factuur als document.
    "factuurDetailView.subtitle": "Overzicht en details van deze factuur.",
    "factuurDetailView.sectie.koppelingen": "Dier, verblijf en dierenambulance",
    "factuurDetailView.sectie.opmerkingen": "Opmerkingen",
    "factuurDetailView.sectie.interneNotities": "Interne notities (niet zichtbaar voor klant)",
    "factuurDetailView.koppeling.verblijf": "Verblijf",
    "factuurDetailView.koppeling.verblijfNr": "Verblijf %s",
    "factuurDetailView.koppeling.opname": "Opgenomen",
    "factuurDetailView.koppeling.vertrek": "Vertrokken",
    "factuurDetailView.koppeling.ritnummer": "Ritnummer",
    "factuurDetailView.koppeling.bekijkDier": "Bekijk dier",
    "factuurDetailView.koppeling.jaar": "%s jaar",
    "factuurDetailView.klant.bekijk": "Bekijk klant",
    "factuurDetailView.betaald.op": "Betaald op",
    "factuurDetailView.betaald.via": "Betaald via",
    "factuurDetailView.samenvatting.over": "over",
    "factuurDetailView.samenvatting.totaalbedrag": "Totaalbedrag",
    "factuurDetailView.betalingen.totaalBetaald": "Totaal betaald",
    "factuurDetailView.regels.col.acties": "Acties",
    "factuurDetailView.regels.wijzig": "Regel wijzigen",
    "factuurDetailView.acties.meer": "Meer acties",
    "factuurDetailView.acties.historie": "Historie",
    "factuurDetailView.terugNaarOverzicht": "Terug",
    "factuurDetailView.concept.openstaand": "%s niet-opgeslagen wijziging(en)",
    "factuurDetailView.concept.nietsOpenstaand": "Alles is opgeslagen",
    "factuurDetailView.concept.opslaanKnop": "Factuur opslaan",
    "factuurDetailView.concept.annulerenKnop": "Wijzigingen annuleren",
    "factuurDetailView.concept.bezig": "Bezig met opslaan…",
    "factuurDetailView.concept.verlatenTitel": "Er staan wijzigingen open",
    "factuurDetailView.concept.verlatenUitleg": "%s wijziging(en) aan deze factuur zijn nog niet opgeslagen. Sla ze op, gooi ze weg, of blijf op deze pagina.",
    "factuurDetailView.concept.blijven": "Hier blijven",
    "factuurDetailView.concept.weggooienEnWeg": "Weggooien en weg",
    "factuurDetailView.concept.opslaanEnBlijven": "Opslaan",
    "factuurDetailView.concept.actieGeblokkeerd": "Sla je wijzigingen eerst op of annuleer ze",
    "kennelplanning.dnd.placed": "Dier geplaatst",
    "kennelplanning.dnd.moved": "Dier verplaatst",
    "kennelplanning.dnd.released": "Dier vrijgegeven",
    "kennelplanning.dnd.failed": "Actie mislukt",
    // kp-Epic 4: ruimte- + ruimtetype-beheerdialogen.
    "kennelplanning.capacity.editRoom": "Ruimte bewerken",
    "kennelplanning.roomTypes.edit": "Ruimtetype bewerken",
    "kennelplanning.groepDialog.createTitle": "Nieuwe ruimte",
    "kennelplanning.groepDialog.editTitle": "Ruimte bewerken",
    "kennelplanning.groepDialog.naam": "Naam",
    "kennelplanning.groepDialog.diersoort": "Diersoort",
    "kennelplanning.groepDialog.diersoortPlaceholder": "Kies een diersoort…",
    "kennelplanning.groepDialog.diersoortLocked": "Vast na aanmaken",
    "kennelplanning.groepDialog.ruimteType": "Ruimtetype",
    "kennelplanning.groepDialog.ruimteTypePlaceholder": "Geen type",
    "kennelplanning.groepDialog.positie": "Positie",
    "kennelplanning.groepDialog.maxCapaciteit": "Max. capaciteit",
    "kennelplanning.groepDialog.startNummer": "Startnummer",
    "kennelplanning.groepDialog.startNummerLocked": "Bij aanmaken bepaald",
    "kennelplanning.groepDialog.aantalKennels": "Aantal verblijven",
    "kennelplanning.groepDialog.naamRequired": "Naam is verplicht.",
    "kennelplanning.groepDialog.diersoortRequired": "Diersoort is verplicht.",
    "kennelplanning.groepDialog.positieRequired": "Positie is verplicht.",
    "kennelplanning.groepDialog.startNummerRequired": "Startnummer is verplicht.",
    "kennelplanning.groepDialog.aantalRequired":
      "Aantal verblijven is verplicht en mag niet negatief zijn.",
    "kennelplanning.groepDialog.shrinkConfirm":
      "Minder verblijven dan nu: de hoogst genummerde verblijven worden verwijderd en eventuele bewoners vrijgegeven. Doorgaan?",
    "kennelplanning.groepDialog.shrinkConfirmAccept": "Ja, aanpassen",
    "kennelplanning.groepDialog.deleteConfirm":
      "Deze ruimte verwijderen? De verblijven worden verwijderd en eventuele bewoners vrijgegeven.",
    "kennelplanning.groepDialog.created": "Ruimte aangemaakt.",
    "kennelplanning.groepDialog.resizeResult": "%d toegevoegd / %d verwijderd / %d dier(en) terug",
    "kennelplanning.groepDialog.deleted": "Ruimte verwijderd · %d dier(en) terug",
    "kennelplanning.groepDialog.conflict":
      "Ruimte is intussen gewijzigd; herlaad en probeer opnieuw.",
    "kennelplanning.groepDialog.invalid": "Controleer de ingevoerde waarden.",
    "kennelplanning.groepDialog.error": "Actie mislukt.",
    "kennelplanning.ruimteTypeDialog.createTitle": "Nieuw ruimtetype",
    "kennelplanning.ruimteTypeDialog.editTitle": "Ruimtetype bewerken",
    "kennelplanning.ruimteTypeDialog.naam": "Naam",
    "kennelplanning.ruimteTypeDialog.beschrijving": "Beschrijving",
    "kennelplanning.ruimteTypeDialog.kleurLabel": "Kleur",
    "kennelplanning.ruimteTypeDialog.maxCapaciteit": "Max. capaciteit",
    "kennelplanning.ruimteTypeDialog.kleur.green": "Groen",
    "kennelplanning.ruimteTypeDialog.kleur.red": "Rood",
    "kennelplanning.ruimteTypeDialog.kleur.orange": "Oranje",
    "kennelplanning.ruimteTypeDialog.kleur.blue": "Blauw",
    "kennelplanning.ruimteTypeDialog.kleur.grey": "Grijs",
    "kennelplanning.ruimteTypeDialog.naamRequired": "Naam is verplicht.",
    "kennelplanning.ruimteTypeDialog.deleteConfirm": "Dit ruimtetype verwijderen?",
    "kennelplanning.ruimteTypeDialog.created": "Ruimtetype aangemaakt.",
    "kennelplanning.ruimteTypeDialog.updated": "Ruimtetype bijgewerkt.",
    "kennelplanning.ruimteTypeDialog.deleted": "Ruimtetype verwijderd.",
    "btw.label": "BTW-tarief",
    "btw.kies": "Kies een BTW-tarief",
    "btw.verplicht": "BTW is verplicht: kies een tarief (0% mag, maar moet gekozen zijn).",
    "btw.kolom": "BTW",
    "picker.btw.label": "BTW-percentage",
    "picker.btw.help": "Dit product of tarief heeft nog geen BTW. Kies het percentage voor deze regel.",
    "picker.btw.verplicht": "Kies eerst het BTW-percentage van deze regel.",
    // Klantportaal: klantverzoeken en de tegel op de klantkaart.
    "menu.klantverzoeken": "Klantverzoeken",
    "relatieDetailView.tile.whatsapp": "WhatsApp",
    "menu.schermbouwer": "Schermbouwer",
    "schermbouwer.title": "AI-schermbouwer",
    "schermbouwer.gesprek": "Gesprek",
    "schermbouwer.beginUitleg": "Beschrijf in je eigen woorden wat je nodig hebt. Je kunt een afbeelding meesturen als visuele inspiratie.",
    "schermbouwer.plaatshouder": "Bijvoorbeeld: toon de naam van het dier, het medicijn en het tijdstip, en waarschuw me bij een dosis die al had gemoeten.",
    "schermbouwer.versturen": "Versturen",
    "schermbouwer.bezig": "Bezig met ontwerpen…",
    "schermbouwer.afbeelding": "Afbeelding",
    "schermbouwer.weghalen": "Weghalen",
    "schermbouwer.afbeeldingUitleg": "Een afbeelding wordt alleen als visuele inspiratie gebruikt; er wordt geen tekst of gegeven uit overgenomen. Stuur geen afbeelding met persoonsgegevens, of snijd hem eerst bij.",
    "schermbouwer.versies": "Versies",
    "schermbouwer.geenVersies": "Nog geen versies.",
    "schermbouwer.doorAi": "Door de AI",
    "schermbouwer.metDeHand": "Met de hand aangepast",
    "schermbouwer.terugzetten": "Terugzetten",
    "schermbouwer.teruggezet": "Teruggezet naar versie %s.",
    "schermbouwer.voorbeeld": "Voorbeeld",
    "schermbouwer.echteData": "Mijn echte data",
    "schermbouwer.status.CONCEPT": "Concept",
    "schermbouwer.status.GEWIJZIGD": "Concept met wijzigingen",
    "schermbouwer.status.GEPUBLICEERD": "Gepubliceerd",
    "schermbouwer.nogGeenOntwerp": "Nog geen ontwerp. Vraag er links om.",
    "schermbouwer.onderdelenInDeTegel": "Onderdelen in deze tegel",
    "schermbouwer.naarLinks": "Naar links",
    "schermbouwer.naarRechts": "Naar rechts",
    "schermbouwer.verwijderen": "Verwijderen",
    "schermbouwer.toevoegen": "Onderdeel toevoegen",
    "schermbouwer.velden": "Velden",
    "schermbouwer.acties": "Knoppen",
    "schermbouwer.catalogusUitleg": "Alleen wat hier staat bestaat voor dit tegeltype. Mis je iets? Vraag er gerust om — het wordt doorgegeven aan Docasoft.",
    "schermbouwer.publiceren": "Publiceren",
    "schermbouwer.gepubliceerd": "Gepubliceerd. De tegel kan nu op een dashboard gezet worden.",
    "schermbouwer.fout.algemeen": "Dat is niet gelukt. Probeer het anders te omschrijven.",
    "schermbouwer.fout.nietOpgeslagen": "Deze wijziging is niet opgeslagen.",
    "schermbouwer.nieuweTegel": "Nieuwe tegel",
    "schermbouwer.nieuweTegelMaken": "Een nieuwe tegel ontwerpen",
    "schermbouwer.ingangUitleg": "Beschrijf een tegel in je eigen woorden en zie meteen wat eruit komt. Je kiest uit wat Docasoft voor dit tegeltype al ondersteunt.",
    "schermbouwer.naam": "Naam",
    "schermbouwer.naamPlaatshouder": "Naam van de tegel",
    "schermbouwer.schermtype": "Soort tegel of scherm",
    "schermbouwer.beginnen": "Beginnen",
    "schermbouwer.geenCatalogus": "Er is nog geen tegeltype om voor te ontwerpen.",
    "schermbouwer.bestaandeTegels": "Tegels in deze organisatie",
    "schermbouwer.nogGeenTegels": "Er zijn nog geen tegels ontworpen.",
    "schermbouwer.openen": "Openen",
    "schermbouwer.terugNaarLijst": "Terug naar de lijst",
    "schermbouwer.bekijkAls": "Bekijk als",
    "schermbouwer.alsMijzelf": "Mijzelf",
    "schermbouwer.zonder": "Iemand zonder %s",
    "schermbouwer.logboek": "Geschiedenis",
    "schermbouwer.gebeurtenis.AANGEMAAKT": "Aangemaakt",
    "schermbouwer.gebeurtenis.ONTWORPEN_MET_AI": "Ontworpen met de AI",
    "schermbouwer.gebeurtenis.AANGEPAST": "Met de hand aangepast",
    "schermbouwer.gebeurtenis.TERUGGEZET": "Eerdere versie teruggezet",
    "schermbouwer.gebeurtenis.GEPUBLICEERD": "Gepubliceerd",
    "schermbouwer.gebeurtenis.PUBLICATIE_AANGEVRAAGD": "Delen aangevraagd",
    "schermbouwer.gebeurtenis.PUBLICATIE_GOEDGEKEURD": "Delen goedgekeurd",
    "schermbouwer.gebeurtenis.PUBLICATIE_AFGEWEZEN": "Delen afgewezen",
    "schermbouwer.gebeurtenis.HERNOEMD": "Hernoemd",
    "schermbouwer.delenAanvragen": "Delen aanvragen",
    "schermbouwer.delenAangevraagd": "Aangevraagd. Een beheerder beslist of deze tegel op gedeelde dashboards komt.",
    "schermbouwer.delenMislukt": "Die aanvraag is niet doorgekomen. Misschien staat er al een open.",
    "schermbouwer.vergelijken": "Vergelijken",
    "schermbouwer.verschilMet": "Versie %s vergeleken met %s:",
    "schermbouwer.erbij": "erbij: %s.",
    "schermbouwer.eraf": "eraf: %s.",
    "schermbouwer.geenVerschil": "dezelfde onderdelen, in een andere volgorde of opmaak.",
    "schermbouwer.beheer": "Beheer schermbouwer",
    "schermbouwer.beheerUitleg": "Wat de AI mag gebruiken, wat mensen missen, en welke tegels wachten om gedeeld te worden.",
    "schermbouwer.aiReady": "Beschikbaar voor de AI",
    "schermbouwer.openVerzoeken": "Wacht op goedkeuring",
    "schermbouwer.geenVerzoeken": "Er wacht niets.",
    "schermbouwer.goedkeuren": "Goedkeuren",
    "schermbouwer.afwijzen": "Afwijzen",
    "schermbouwer.gemisteMogelijkheden": "Wat mensen missen",
    "schermbouwer.geenGemist": "Er is nog niet om iets gevraagd dat niet bestaat.",
    "schermbouwer.aantalKeer": "%s×",
    "menu.schermbouwerBeheer": "Schermbouwer",
    "schermbouwer.beheerTitle": "Beheer schermbouwer",
    "whatsapp.naar": "Naar",
    "whatsapp.plaatshouder": "Typ je bericht…",
    "whatsapp.tekstLabel": "WhatsApp-bericht",
    "whatsapp.versturen": "Versturen",
    "whatsapp.bezig": "Versturen…",
    "whatsapp.verstuurd": "Verstuurd.",
    "whatsapp.mislukt": "Versturen lukte niet.",
    "whatsapp.nietIngesteld": "WhatsApp is op deze omgeving niet ingesteld.",
    "whatsapp.nietGekoppeld": "WhatsApp is voor deze vestiging nog niet gekoppeld.",
    "whatsapp.geenNummer": "Bij deze relatie staat geen mobiel nummer.",
    "whatsapp.gesprek": "WhatsApp-gesprek",
    "whatsapp.leegGesprek": "Nog geen berichten met dit nummer.",
    "whatsapp.zonderTekst": "(%s zonder tekst)",
    "whatsapp.emoji": "Emoji invoegen",
    "whatsapp.status.sent": "Verstuurd",
    "whatsapp.status.delivered": "Afgeleverd",
    "whatsapp.status.read": "Gelezen",
    "whatsapp.status.failed": "Niet afgeleverd",
    "relatieDetailView.tile.klantportaal": "Klantportaal",
    "klantverzoeken.groep.klanten": "Klanten",
    "klantverzoeken.groep.dieren": "Dieren",
    "klantverzoeken.groep.reserveringen": "Reserveringen",
    "klantverzoeken.groep.dagopvang": "Dagopvang",
    "klantverzoeken.groep.overig": "Overig",
    "klantverzoeken.groepUitleg.klanten": "Registraties, gewijzigde gegevens en toegevoegde gezinsleden.",
    "klantverzoeken.groepUitleg.dieren": "Nieuwe dieren, gewijzigde diergegevens en geüploade documenten.",
    "klantverzoeken.groepUitleg.reserveringen": "Nieuwe reserveringen, wachtlijst, wijzigingen en annuleringen.",
    "klantverzoeken.groepUitleg.dagopvang": "Nieuwe dagopvangdagen, wijzigingen en afmeldingen.",
    "klantverzoeken.groepUitleg.overig": "Verzoeken die niet bij een van de andere onderdelen horen.",
    "klantverzoeken.tab.alles": "Alle open",
    "klantverzoeken.tab.nieuw": "Nieuw",
    "klantverzoeken.tab.wijzigingen": "Wijzigingen",
    "klantverzoeken.tab.gezinsleden": "Gezinsleden",
    "klantverzoeken.tab.documenten": "Documenten",
    "klantverzoeken.tab.wachtlijst": "Wachtlijst",
    "klantverzoeken.tab.annuleringen": "Annuleringen",
    "klantverzoeken.tab.afmeldingen": "Afmeldingen",
    "klantverzoeken.tab.afgerond": "Afgerond",
    "klantverzoeken.fase.nieuw": "Nieuw",
    "klantverzoeken.fase.bezig": "In behandeling",
    "klantverzoeken.fase.klant": "Wacht op klant",
    "klantverzoeken.fase.mislukt": "Mislukt",
    "klantverzoeken.fase.verwerkt": "Verwerkt",
    "klantverzoeken.fase.afgewezen": "Afgewezen",
    "klantverzoeken.fase.vervallen": "Ingetrokken/verlopen",
    "klantverzoeken.fase.totaal": "Totaal",
    "klantverzoeken.zoek": "Zoek op klant, nummer of aanvraag…",
    "klantverzoeken.alle": "Alle",
    "klantverzoeken.filterTeLang": "Te lang nieuw",
    "klantverzoeken.nieuweKlanten": "Nieuwe klanten",
    "klantverzoeken.resultaten": "%s verzoek(en)",
    "klantverzoeken.sorteer.nieuwste": "Nieuwste eerst",
    "klantverzoeken.sorteer.oudste": "Oudste eerst",
    "klantverzoeken.sorteer.klant": "Klant",
    "klantverzoeken.leegFilter": "Geen verzoeken bij deze filters.",
    "klantverzoeken.kolom.wat": "Aanvraag",
    "klantverzoeken.bijIemand": "In behandeling bij %s",
    "klantverzoeken.nieuwTeBeoordelen": "%s nieuw(e) verzoek(en) wachten op akkoord",
    "klantverzoeken.leeggemaakt": "leeggemaakt",
    "klantverzoeken.meerVelden": "+ nog %s",
    "klantverzoeken.veld.naam": "Naam",
    "klantverzoeken.veld.email": "E-mail",
    "klantverzoeken.veld.telefoon": "Telefoon",
    "klantverzoeken.veld.mobiel": "Mobiel",
    "klantverzoeken.veld.adres": "Adres",
    "klantverzoeken.veld.dieren": "Dieren",
    "klantverzoeken.veld.voeding": "Voeding",
    "klantverzoeken.veld.voedingInstructies": "Voedingsinstructies",
    "klantverzoeken.veld.opmerking": "Opmerking",
    "klantverzoeken.veld.bijzonderheden": "Bijzonderheden",
    "klantverzoeken.veld.medicatie": "Medicatie",
    "klantverzoeken.veld.verblijf": "Verblijf",
    "klantverzoeken.veld.aankomstTijd": "Aankomsttijd",
    "klantverzoeken.veld.vertrekTijd": "Vertrektijd",
    "klantverzoeken.veld.overigeWensen": "Overige wensen",
    "klantverzoeken.veld.annuleringsverzekering": "Annuleringsverzekering",
    "klantverzoeken.veld.extras": "Extra's",
    "klantverzoeken.veld.geslacht": "Geslacht",
    "klantverzoeken.veld.geboortedatum": "Geboortedatum",
    "klantverzoeken.veld.chipnummer": "Chipnummer",
    "klantverzoeken.veld.gewicht": "Gewicht",
    "klantverzoeken.veld.ras": "Ras",
    "klantverzoeken.veld.soort": "Soort",
    "klantverzoeken.veld.kleur": "Kleur",
    "klantverzoeken.veld.gecastreerd": "Gecastreerd",
    "klantverzoeken.veld.samenMetGezin": "Samen met gezin",
    "klantverzoeken.veld.relatie": "Relatie",
    "klantverzoeken.veld.reden": "Reden",
    "klantverzoeken.veld.toelichting": "Toelichting",
    "klantverzoeken.titel": "Klantverzoeken",
    "klantverzoeken.subtitel": "Alles wat klanten via het portaal aanvragen. Niets wijzigt tot jij het goedkeurt.",
    "klantverzoeken.subtitelTeLang": "%s verzoek(en) staan langer dan een werkdag op Nieuw.",
    "klantverzoeken.filter": "Filter",
    "klantverzoeken.filter.open": "Open",
    "klantverzoeken.filter.registraties": "Registraties",
    "klantverzoeken.filter.mislukt": "Mislukt",
    "klantverzoeken.filter.afgerond": "Afgerond",
    "klantverzoeken.filter.alle": "Alle",
    "klantverzoeken.kolom.status": "Status",
    "klantverzoeken.kolom.nummer": "Nummer",
    "klantverzoeken.kolom.klant": "Klant",
    "klantverzoeken.kolom.type": "Soort",
    "klantverzoeken.kolom.kanaal": "Via",
    "klantverzoeken.kolom.ingediend": "Ingediend",
    "klantverzoeken.kolom.bij": "In behandeling bij",
    "klantverzoeken.nieuweKlant": "nieuwe klant",
    "klantverzoeken.nieuweKlantUitleg": "Nog niet gekoppeld aan een klant: eerst de registratie beoordelen.",
    "klantverzoeken.teLang": "Langer dan een werkdag nieuw",
    "klantverzoeken.leeg": "Geen verzoeken in deze lijst.",
    "klantverzoeken.fout.laden": "De klantverzoeken konden niet worden geladen.",
    "klantverzoeken.fout.actie": "Dat lukte niet. Vernieuw het verzoek en probeer het opnieuw.",
    "klantverzoeken.kanaal.PORTAAL": "Portaal",
    "klantverzoeken.kanaal.EXTERNE_API": "Website",
    "klantverzoeken.status.NIEUW": "Nieuw",
    "klantverzoeken.status.IN_BEHANDELING": "In behandeling",
    "klantverzoeken.status.AANVULLING_NODIG": "Aanvulling gevraagd",
    "klantverzoeken.status.VOORSTEL_KLANT": "Voorstel bij klant",
    "klantverzoeken.status.GOEDGEKEURD": "Goedgekeurd",
    "klantverzoeken.status.VERWERKT": "Verwerkt",
    "klantverzoeken.status.MISLUKT": "Mislukt",
    "klantverzoeken.status.AFGEWEZEN": "Afgewezen",
    "klantverzoeken.status.INGETROKKEN": "Ingetrokken",
    "klantverzoeken.status.VERLOPEN": "Verlopen",
    "klantverzoeken.type.KLANT_REGISTRATIE": "Registratie",
    "klantverzoeken.type.CONTACTPERSOON_TOEVOEGEN": "Gezinslid toevoegen",
    "klantverzoeken.type.CONTACTPERSOON_WIJZIGING": "Contactgegevens wijzigen",
    "klantverzoeken.type.RESERVERING_NIEUW": "Reservering nieuw",
    "klantverzoeken.type.RESERVERING_WIJZIGING": "Reservering wijzigen",
    "klantverzoeken.type.RESERVERING_ANNULERING": "Reservering annuleren",
    "klantverzoeken.type.RESERVERING_WACHTLIJST": "Wachtlijst",
    "klantverzoeken.type.DAGOPVANG_NIEUW": "Dagopvang nieuw",
    "klantverzoeken.type.DAGOPVANG_WIJZIGING": "Dagopvang wijzigen",
    "klantverzoeken.type.DAGOPVANG_ANNULERING": "Dagopvang annuleren",
    "klantverzoeken.type.DIER_NIEUW": "Dier aanmelden",
    "klantverzoeken.type.DIER_WIJZIGING": "Dier wijzigen",
    "klantverzoeken.type.DOCUMENT_UPLOAD": "Document",
    "klantverzoeken.ingediendDoor": "ingediend door %s via %s op %s",
    "klantverzoeken.inBehandelingBij": "In behandeling bij %s",
    "klantverzoeken.mislukt.VALIDATIE": "Verwerking geweigerd",
    "klantverzoeken.mislukt.CONFLICT": "Gewijzigd sinds de klant akkoord gaf",
    "klantverzoeken.mislukt.TECHNISCH": "Technische fout bij verwerken",
    "klantverzoeken.overlappend": "Er lopen meer verzoeken over hetzelfde: %s",
    "klantverzoeken.actie.claimen": "In behandeling nemen",
    "klantverzoeken.actie.aanvulling": "Aanvulling vragen",
    "klantverzoeken.actie.afwijzen": "Afwijzen",
    "klantverzoeken.actie.opnieuw": "Opnieuw beoordelen",
    "klantverzoeken.actie.voorstel": "Tegenvoorstel doen",
    "klantverzoeken.actie.goedkeuren": "Goedkeuren & verwerken",
    "klantverzoeken.actie.registratieGoedkeuren": "Registratie goedkeuren",
    "klantverzoeken.boekje.titel": "Vaccinatieboekje",
    "klantverzoeken.boekje.uitleg": "Controleer de entingen met de foto. Bij goedkeuren gaat het boekje naar het dierdossier.",
    "klantverzoeken.boekje.nogGeen": "De klant gaf een vaccinatieboekje door, maar de foto is (nog) niet binnen.",
    "klantverzoeken.aanvraag": "Aanvraag van de klant",
    "klantverzoeken.reactieAanKlant": "Aan de klant:",
    "klantverzoeken.matches.titel": "Mogelijk bestaande klant",
    "klantverzoeken.matches.geen": "Geen bestaande klant gevonden op e-mail, telefoon of adres.",
    "klantverzoeken.matches.reden.EMAIL": "zelfde e-mail",
    "klantverzoeken.matches.reden.TELEFOON": "zelfde telefoon",
    "klantverzoeken.matches.reden.ADRES": "zelfde postcode + huisnummer",
    "klantverzoeken.matches.inactief": "inactief",
    "klantverzoeken.matches.koppelen": "Vergelijken en koppelen",
    "klantverzoeken.matches.registratie": "Registratie",
    "klantverzoeken.matches.klant": "Bestaande klant",
    "klantverzoeken.voorstellen": "Voorstellen aan de klant",
    "klantverzoeken.voorstelVersie": "Voorstel %s",
    "klantverzoeken.voorstelStatus.OPEN": "Wacht op klant",
    "klantverzoeken.voorstelStatus.GEACCEPTEERD": "Geaccepteerd",
    "klantverzoeken.voorstelStatus.AFGEWEZEN": "Afgewezen",
    "klantverzoeken.voorstelStatus.VERLOPEN": "Verlopen",
    "klantverzoeken.voorstelStatus.VERVALLEN": "Vervangen",
    "klantverzoeken.voorstelDoor": "door %s op %s · reageren vóór %s",
    "klantverzoeken.historie": "Historie",
    "klantverzoeken.door.KLANT": "klant",
    "klantverzoeken.door.SYSTEEM": "systeem",
    "klantverzoeken.door.MEDEWERKER": "medewerker",
    "klantverzoeken.versies": "Versies van de aanvraag",
    "klantverzoeken.versie": "Versie %s",
    "klantverzoeken.aanleiding.INGEDIEND": "ingediend",
    "klantverzoeken.aanleiding.AANVULLING": "aanvulling",
    "klantverzoeken.aanleiding.VOORSTEL_GEACCEPTEERD": "voorstel geaccepteerd",
    "klantverzoeken.conflict.titel": "Gewijzigd sinds de aanvraag",
    "klantverzoeken.conflict.uitleg": "Het object is na het indienen gewijzigd. Vergelijk voordat je goedkeurt.",
    "klantverzoeken.conflict.oud": "Bij indienen",
    "klantverzoeken.conflict.huidig": "Nu",
    "klantverzoeken.conflict.gevraagd": "Gevraagd",
    "klantverzoeken.annuleren": "Annuleren",
    "klantverzoeken.interneNotitie": "Interne notitie (ziet de klant niet)",
    "klantverzoeken.aanvullingVenster.titel": "Aanvulling vragen",
    "klantverzoeken.aanvullingVenster.uitleg": "De klant ziet je vraag in het portaal en past zijn verzoek zelf aan.",
    "klantverzoeken.aanvullingVenster.vraag": "Vraag aan de klant",
    "klantverzoeken.aanvullingVenster.termijn": "Termijn in dagen",
    "klantverzoeken.aanvullingVenster.versturen": "Vraag versturen",
    "klantverzoeken.afwijzenVenster.titel": "Verzoek afwijzen",
    "klantverzoeken.afwijzenVenster.reden": "Reden voor de klant (optioneel)",
    "klantverzoeken.goedkeurenVenster.uitleg": "Het verzoek wordt verwerkt zoals de klant het vroeg, met alle normale controles.",
    "klantverzoeken.goedkeurenVenster.registratieUitleg": "Kies zelf: een nieuwe klant aanmaken of koppelen aan een bestaande klant. Bij koppelen worden de gegevens van de klant niet overschreven.",
    "klantverzoeken.goedkeurenVenster.nieuweKlant": "Nieuwe klant aanmaken",
    "klantverzoeken.goedkeurenVenster.koppelen": "Koppelen aan bestaande klant",
    "klantverzoeken.goedkeurenVenster.klantnummer": "Klant-id",
    "klantverzoeken.goedkeurenVenster.dierenAanmaken": "Deze dieren aanmaken",
    "klantverzoeken.goedkeurenVenster.tochGoedkeuren": "Toch goedkeuren",
    "klantverzoeken.voorstelVenster.titel": "Tegenvoorstel aan de klant",
    "klantverzoeken.voorstelVenster.uitleg": "De klant ziet zijn aanvraag en jouw voorstel naast elkaar en moet akkoord geven. Er wordt niets verwerkt tot dan.",
    "klantverzoeken.voorstelVenster.gevraagd": "Gevraagd",
    "klantverzoeken.voorstelVenster.voorstel": "Voorstel",
    "klantverzoeken.voorstelVenster.reden": "Uitleg voor de klant",
    "klantverzoeken.voorstelVenster.prijs": "Prijs volgens voorstel (optioneel)",
    "klantverzoeken.voorstelVenster.bijAfwijzen": "Als de klant afwijst of niet reageert",
    "klantverzoeken.voorstelVenster.terug": "Terug naar beoordeling",
    "klantverzoeken.voorstelVenster.afwijzen": "Verzoek afwijzen",
    "klantverzoeken.voorstelVenster.afwijsReden": "Reden bij afwijzen",
    "klantverzoeken.voorstelVenster.versturen": "Voorstel versturen",
    "klantportaalTegel.leeg": "Deze klant heeft nog geen toegang tot het klantportaal.",
    "klantportaalTegel.uitnodigen": "Uitnodigen voor portaal",
    "klantportaalTegel.versturen": "Uitnodiging versturen",
    "klantportaalTegel.uitleg": "De persoon krijgt een e-mail met een link die 7 dagen geldig is.",
    "klantportaalTegel.uitlegEerste": "De eerste persoon wordt beheerder van het huishouden en kan zelf gezinsleden uitnodigen.",
    "klantportaalTegel.naam": "Naam",
    "klantportaalTegel.email": "E-mailadres",
    "klantportaalTegel.rolKiezen": "Rol",
    "klantportaalTegel.rolAutomatisch": "Automatisch (eerste persoon wordt beheerder)",
    "klantportaalTegel.rol.BEHEERDER": "Beheerder",
    "klantportaalTegel.rol.GEZINSLID": "Gezinslid",
    "klantportaalTegel.status.ACTIEF": "Actief",
    "klantportaalTegel.status.IN_AFWACHTING": "Wacht op goedkeuring",
    "klantportaalTegel.status.GEBLOKKEERD": "Geblokkeerd",
    "klantportaalTegel.status.INGETROKKEN": "Ingetrokken",
    "klantportaalTegel.blokkeren": "Blokkeren",
    "klantportaalTegel.deblokkeren": "Weer toegang geven",
    "klantportaalTegel.intrekken": "Uitnodiging intrekken",
    "klantportaalTegel.uitgenodigd": "Uitgenodigd (%s), geldig tot %s",
    "klantportaalTegel.fout.laden": "Klantportaal kon niet worden geladen.",
    "klantportaalTegel.fout.recht": "Je hebt geen recht om portaaltoegang te beheren.",
    "klantportaalTegel.fout.algemeen": "Dat lukte niet.",
    "klantverzoeken.reservering.periode": "Periode",
    "klantverzoeken.reservering.geenVoorkeur": "geen voorkeur verblijf",
    "klantverzoeken.reservering.voeding.STANDAARD": "voeding pension",
    "klantverzoeken.reservering.voeding.EIGEN": "eigen voeding",
    "klantverzoeken.reservering.medicatie": "medicatie",
    "klantverzoeken.reservering.samen": "samen met de andere dieren",
    "klantverzoeken.reservering.extras": "Extra's voor de reservering",
    "klantverzoeken.reservering.verzekering": "Annuleringsverzekering",
    "klantverzoeken.reservering.wensen": "Overige wensen",
    "klantverzoeken.reservering.ja": "Ja",
    "klantverzoeken.reservering.nee": "Nee",
    "klantverzoeken.reservering.wizardVersie": "Wizardversie",
    "klantverzoeken.reservering.standaard": "standaard",
    "klantverzoeken.reservering.prijscontrole": "Prijscontrole",
    "klantverzoeken.reservering.gezien": "Prijs die de klant zag",
    "klantverzoeken.reservering.gezienVoorstel": "Prijs in het geaccepteerde voorstel",
    "klantverzoeken.reservering.nu": "Prijs volgens de huidige tarieven",
    "klantverzoeken.reservering.akkoordNodig": "Hoger dan de klant zag: eerst een tegenvoorstel",
    "klantverzoeken.reservering.akkoordUitleg": "Het pension bevestigt nooit tegen een prijs die de klant niet heeft gezien. Toegestaan zonder nieuw akkoord: %s.",
    "klantverzoeken.reservering.voorstelMetPrijs": "Tegenvoorstel met nieuwe prijs",
    "klantverzoeken.reservering.binnenDrempel": "Binnen de drempel: goedkeuren kan zonder nieuw akkoord.",
    "klantverzoeken.reservering.beschikbaarheid": "Beschikbaarheid nu",
    "klantverzoeken.reservering.plek": "Er is plek",
    "klantverzoeken.reservering.geenCapaciteit": "Geen capaciteit ingesteld",
    "klantverzoeken.reservering.vol": "vol",
    "klantverzoeken.reservering.vrij": "nog %s vrij",
    "menu.klantberichten": "Klantberichten",
    "klantberichten.overline": "Klantportaal",
    "klantberichten.zoek": "Zoek op klant, onderwerp of bericht…",
    "klantberichten.resultaten": "%s gesprek(ken)",
    "klantberichten.aantal": "%s bericht(en)",
    "klantberichten.titel": "Klantberichten",
    "klantberichten.subtitel": "Berichten van klanten uit het portaal. Een bericht verandert niets vanzelf; wijzigingen gaan via een verzoek.",
    "klantberichten.filter.open": "Antwoord nodig",
    "klantberichten.filter.alle": "Alle",
    "klantberichten.kolom.status": "Status",
    "klantberichten.kolom.onderwerp": "Onderwerp",
    "klantberichten.kolom.klant": "Klant",
    "klantberichten.kolom.categorie": "Over",
    "klantberichten.kolom.laatste": "Laatste bericht",
    "klantberichten.antwoordNodig": "Antwoord nodig",
    "klantberichten.beantwoord": "Bijgewerkt",
    "klantberichten.persoonlijk": "Persoonlijk (één lid)",
    "klantberichten.huishouden": "Hele huishouden",
    "klantberichten.categorie.RESERVERING": "Reservering",
    "klantberichten.categorie.VERZOEK": "Verzoek",
    "klantberichten.categorie.FACTUUR": "Factuur",
    "klantberichten.categorie.ALGEMEEN": "Algemeen",
    "klantberichten.categorie.ACCOUNT": "Account",
    "klantberichten.kanaal.EMAIL": "e-mail",
    "klantberichten.kanaal.PORTAAL": "portaal",
    "klantberichten.kanaal.SYSTEEM": "systeem",
    "klantberichten.nietBezorgd": "e-mail niet bezorgd",
    "klantberichten.wacht": "wordt verstuurd",
    "klantberichten.leegOpen": "Er wachten geen berichten op antwoord.",
    "klantberichten.leeg": "Nog geen berichten.",
    "klantberichten.fout.laden": "De berichten konden niet worden geladen.",
    "klantberichten.antwoord": "Antwoord aan de klant",
    "klantberichten.antwoordUitleg": "De klant leest je antwoord in het portaal en krijgt een e-mail dat er een bericht is, zonder de inhoud.",
    "klantberichten.versturen": "Antwoord versturen",
    "klantportaalTegel.berichtSturen": "Bericht sturen",
    "klantportaalTegel.berichtUitleg": "Het bericht staat in het portaal van de klant; de ontvangers krijgen een e-mail dat er een bericht is.",
    "klantportaalTegel.berichtAan": "Aan",
    "klantportaalTegel.berichtHuishouden": "Het hele huishouden",
    "klantportaalTegel.berichtPersoonlijk": "Alleen %s",
    "klantportaalTegel.berichtOnderwerp": "Onderwerp",
    "klantverzoeken.dier.naam": "Naam",
    "klantverzoeken.dier.soort": "Soort",
    "klantverzoeken.dier.ras": "Ras",
    "klantverzoeken.dier.geslacht": "Geslacht",
    "klantverzoeken.dier.gecastreerd": "gecastreerd",
    "klantverzoeken.dier.geboortedatum": "Geboortedatum",
    "klantverzoeken.dier.chipnummer": "Chipnummer",
    "klantverzoeken.dier.kleur": "Kleur",
    "klantverzoeken.dier.foto": "Foto van het dier",
    "klantverzoeken.dier.entingen": "Entingen (%s)",
    "klantverzoeken.dier.geenEntingen": "De klant gaf geen entingen op.",
    "klantverzoeken.dier.enting": "Enting",
    "klantverzoeken.dier.toegediend": "Toegediend op",
    "klantverzoeken.dier.geldigTot": "Geldig tot",
    "klantverzoeken.dier.bijzonderheden": "Belangrijke informatie",
    "klantverzoeken.dier.uitleg": "Bij goedkeuren wordt het dier met deze gegevens, de foto en de entingen bij deze klant aangemaakt.",
    "klantportaalTegel.berichtTekst": "Bericht",
    "klantportaalTegel.bekijkAlsKlant": "Bekijk als klant",
    "klantportaalTegel.wizardTesten": "Wizard testen",
    "klantportaalTegel.weergaveOpenen": "Portaal openen",
    "klantportaalTegel.weergaveAls": "Bekijken als",
    "klantportaalTegel.weergaveReden": "Reden (wordt vastgelegd en is zichtbaar voor de klant)",
    "klantportaalTegel.supportUitleg": "Opent het portaal alleen-lezen, precies zoals dit lid het ziet, voor hooguit 30 minuten. Er kan niets worden gewijzigd.",
    "klantportaalTegel.testUitleg": "Opent de reserveringswizard als dit lid in testmodus: prijzen en beschikbaarheid zijn echt, maar er wordt niets aangemaakt, gemaild of bewaard.",
    "klantportaalTegel.berichtVerstuurd": "Het bericht staat in het portaal van de klant.",
    "klantportaalTegel.berichtVersturen": "Bericht versturen",
    "menu.portaalInstellingen": "Portaalinstellingen",
    "portaalInstellingen.kop.actief": "Portaal staat aan",
    "portaalInstellingen.kop.uit": "Portaal staat uit",
    "portaalInstellingen.kop.domeinen": "Domeinen geverifieerd",
    "portaalInstellingen.ai.titel": "Teksten schrijven met AI",
    "portaalInstellingen.ai.uitleg": "De AI schrijft een voorstel op basis van je naam, contactgegevens en de onderdelen van het portaal. Controleer het, pas het aan en sla op.",
    "portaalInstellingen.ai.wens": "Wens voor de AI",
    "portaalInstellingen.ai.wensPlaats": "Optioneel: bijv. noem dat we ook dagopvang hebben, houd het kort",
    "portaalInstellingen.ai.alles": "Schrijf alle drie",
    "portaalInstellingen.ai.een": "Schrijf met AI",
    "portaalInstellingen.ai.bezig": "Bezig…",
    "portaalInstellingen.ai.klaar": "Het voorstel staat in de velden hieronder. Nog niet opgeslagen: controleer het en klik op Opslaan.",
    "portaalInstellingen.ai.fout": "De AI kon geen tekst schrijven.",
    "portaalInstellingen.site.titel": "Kleuren uit je website",
    "portaalInstellingen.site.uitleg": "Geef het adres van je website: we lezen de kleuren en maken er een palet voor het portaal van. Er wordt pas iets opgeslagen als je op Opslaan klikt.",
    "portaalInstellingen.site.adres": "Adres van de website",
    "portaalInstellingen.site.knop": "Haal kleuren op",
    "portaalInstellingen.site.bezig": "Website wordt gelezen…",
    "portaalInstellingen.site.klaar": "Er staat een palet uit je website in. Klik hieronder op een andere kleur om die hoofdkleur te maken, en klik op Opslaan.",
    "portaalInstellingen.site.fout": "De kleuren konden niet uit deze website worden gehaald.",
    "portaalInstellingen.site.gevonden": "Gevonden op de website:",
    "portaalInstellingen.site.kies": "%s als hoofdkleur gebruiken",
    "portaalInstellingen.site.logo": "Kleuren uit het logo",
    "portaalInstellingen.site.gevondenLogo": "Gevonden in het logo:",
    "portaalInstellingen.site.klaarLogo": "Er staat een palet uit je logo in. Klik hieronder op een andere kleur om die hoofdkleur te maken, en klik op Opslaan.",
    "portaalInstellingen.thema.donkerder": "%s is te licht voor witte tekst; het portaal toont hem iets donkerder: %s.",
    "portaalInstellingen.titel": "Portaalinstellingen",
    "portaalInstellingen.subtitel": "Het klantportaal van dit pension: uitstraling, wat klanten zien en wat ze kunnen aanvragen.",
    "portaalInstellingen.opgeslagen": "Opgeslagen.",
    "portaalInstellingen.fout": "Opslaan lukte niet.",
    "portaalInstellingen.opslaan": "Opslaan",
    "portaalInstellingen.standaard": "Standaard",
    "portaalInstellingen.naam": "Naam van het portaal",
    "portaalInstellingen.actief": "Portaal staat aan",
    "portaalInstellingen.actiefUitleg": "Uit: het portaal is voor klanten onbereikbaar. Gegevens en accounts blijven bewaard.",
    "portaalInstellingen.activeren.titel": "Klantportaal activeren",
    "portaalInstellingen.activeren.uitleg": "Maak het portaal aan. Het staat daarna nog uit tot je het aanzet en een domein hebt gekoppeld.",
    "portaalInstellingen.activeren.knop": "Portaal aanmaken",
    "portaalInstellingen.tab.algemeen": "Algemeen",
    "portaalInstellingen.tab.thema": "Thema",
    "portaalInstellingen.tab.modules": "Modules & registratie",
    "portaalInstellingen.tab.gezin": "Gezinsleden",
    "portaalInstellingen.tab.reserveren": "Reserveren",
    "portaalInstellingen.tab.berichten": "Berichten",
    "portaalInstellingen.tab.financieel": "Financieel & documenten",
    "portaalInstellingen.tab.api": "API",
    "portaalInstellingen.inloggen.titel": "Inloggen",
    "portaalInstellingen.inloggen.bestaandeKlanten": "Bestaande klanten kunnen inloggen met het e-mailadres dat bij het pension bekend is",
    "portaalInstellingen.inloggen.uitleg": "De inlogcode gaat naar het adres in de klantgegevens; bij de eerste login wordt het portaalaccount automatisch aan die klant gekoppeld, zodat klanten zich niet opnieuw hoeven te registreren. Een adres dat bij meer dan drie klanten staat, telt niet.",
    "portaalInstellingen.api.uitleg": "Websites die via de externe API met het klantportaal werken. Klanten loggen altijd in via de centrale portaal-login en geven daar zelf toestemming; een website ziet nooit inlogcodes.",
    "portaalInstellingen.api.documentatie": "Documentatie voor de websitebouwer (OpenAPI): %s",
    "portaalInstellingen.api.geen": "Nog geen API-clients.",
    "portaalInstellingen.api.nieuw": "Nieuwe client",
    "portaalInstellingen.api.wijzigen": "Wijzigen",
    "portaalInstellingen.api.naam": "Naam",
    "portaalInstellingen.api.clientId": "Client-ID",
    "portaalInstellingen.api.scopes": "Scopes",
    "portaalInstellingen.api.laatst": "Laatst gebruikt",
    "portaalInstellingen.api.ingetrokken": "ingetrokken",
    "portaalInstellingen.api.soort.PUBLIC": "Website (browser, PKCE)",
    "portaalInstellingen.api.soort.CONFIDENTIAL": "Servertoepassing (secret)",
    "portaalInstellingen.api.soortLabel": "Soort",
    "portaalInstellingen.api.redirects": "Redirect-URI's (één per regel, exact, https)",
    "portaalInstellingen.api.ip": "IP-allowlist (optioneel)",
    "portaalInstellingen.api.verwerkersovereenkomst": "Er is een verwerkersovereenkomst met de websitebouwer",
    "portaalInstellingen.api.intrekken": "Intrekken",
    "portaalInstellingen.api.intrekkenBevestig": "%s intrekken? De website werkt dan direct niet meer met het portaal.",
    "portaalInstellingen.api.nieuwSecret": "Nieuw secret",
    "portaalInstellingen.api.secretBevestig": "Een nieuw secret maken? Het oude werkt dan direct niet meer.",
    "portaalInstellingen.api.secretEenmalig": "Kopieer het secret nu; het wordt niet nog eens getoond.",
    "portaalInstellingen.api.secretGezien": "Ik heb het gekopieerd",
    "portaalInstellingen.api.geenRecht": "Hiervoor heb je het recht nodig om het klantportaal te beheren.",
    "portaalInstellingen.domeinen.titel": "Domeinen",
    "portaalInstellingen.domeinen.uitleg": "Op welk adres klanten het portaal openen, bijvoorbeeld mijn.pensionnaam.nl. Een domein werkt pas als het geverifieerd is.",
    "portaalInstellingen.domeinen.geen": "Nog geen domein gekoppeld.",
    "portaalInstellingen.domeinen.txt": "Zet een TXT-record %s met de waarde %s en klik op Verifiëren.",
    "portaalInstellingen.domeinen.geverifieerd": "Geverifieerd",
    "portaalInstellingen.domeinen.nietGeverifieerd": "Nog niet geverifieerd",
    "portaalInstellingen.domeinen.verifieer": "Verifiëren",
    "portaalInstellingen.domeinen.gelukt": "Het domein is geverifieerd.",
    "portaalInstellingen.domeinen.verwijder": "Domein verwijderen",
    "portaalInstellingen.domeinen.nieuw": "Nieuw domein",
    "portaalInstellingen.domeinen.toevoegen": "Toevoegen",
    "portaalInstellingen.thema.logo": "Logo",
    "portaalInstellingen.thema.header": "Headerafbeelding",
    "portaalInstellingen.thema.welke": "Welke afbeelding",
    "portaalInstellingen.thema.upload": "Afbeelding uploaden",
    "portaalInstellingen.thema.uploadUitleg": "PNG of JPG; logo hooguit 1 MB, header hooguit 3 MB. SVG kan niet.",
    "portaalInstellingen.thema.primaireKleur": "Primaire kleur",
    "portaalInstellingen.thema.accentKleur": "Accentkleur",
    "portaalInstellingen.thema.lettertype": "Lettertype",
    "portaalInstellingen.thema.hoekstijl": "Hoekstijl",
    "portaalInstellingen.thema.hoek.compact": "Compact",
    "portaalInstellingen.thema.hoek.zacht": "Zacht",
    "portaalInstellingen.thema.hoek.rond": "Rond",
    "portaalInstellingen.thema.contrast": "Deze kleur is te licht voor witte tekst; het portaal gebruikt %s.",
    "portaalInstellingen.thema.welkomsttekst": "Welkomsttekst",
    "portaalInstellingen.thema.hulptekst": "Hulptekst",
    "portaalInstellingen.thema.footertekst": "Footertekst",
    "portaalInstellingen.thema.contact.telefoon": "Telefoon",
    "portaalInstellingen.thema.contact.email": "E-mail",
    "portaalInstellingen.thema.contact.openingstijden": "Openingstijden",
    "portaalInstellingen.thema.voorbeeld": "Voorbeeld",
    "portaalInstellingen.thema.voorbeeldTekst": "Welkom in je portaal.",
    "portaalInstellingen.thema.voorbeeldKnop": "Nieuwe reservering",
    "portaalInstellingen.modules.titel": "Modules",
    "portaalInstellingen.module.dieren": "Dieren",
    "portaalInstellingen.module.reserveringen": "Reserveringen",
    "portaalInstellingen.module.dagopvang": "Dagopvang",
    "portaalInstellingen.module.communicatie": "Communicatie",
    "portaalInstellingen.module.financieel": "Financieel",
    "portaalInstellingen.module.documenten": "Documenten",
    "portaalInstellingen.registratie.titel": "Registratie",
    "portaalInstellingen.registratie.zelf": "Nieuwe klanten",
    "portaalInstellingen.registratie.AAN": "Mogen zich zelf registreren",
    "portaalInstellingen.registratie.ALLEEN_UITNODIGING": "Alleen op uitnodiging",
    "portaalInstellingen.registratie.UIT": "Geen toegang",
    "portaalInstellingen.veld.telefoon": "Telefoon",
    "portaalInstellingen.veld.noodcontact": "Noodcontact",
    "portaalInstellingen.veld.dierenarts": "Dierenarts",
    "portaalInstellingen.veld.geboortedatum": "Geboortedatum",
    "portaalInstellingen.veld.dieren": "Dieren",
    "portaalInstellingen.veldstand.VERPLICHT": "Verplicht",
    "portaalInstellingen.veldstand.OPTIONEEL": "Optioneel",
    "portaalInstellingen.veldstand.VERBORGEN": "Verborgen",
    "portaalInstellingen.registratie.privacyUrl": "Privacyverklaring (adres)",
    "portaalInstellingen.registratie.privacyVersie": "Versie privacyverklaring",
    "portaalInstellingen.registratie.voorwaardenUrl": "Algemene voorwaarden (adres)",
    "portaalInstellingen.registratie.voorwaardenVersie": "Versie voorwaarden",
    "portaalInstellingen.registratie.doorlooptijd": "Verwachte doorlooptijd (tekst)",
    "portaalInstellingen.registratie.reserverenVoorGoedkeuring": "Nieuwe klanten mogen al reserveren voordat de registratie is goedgekeurd",
    "portaalInstellingen.dieren.titel": "Dieren",
    "portaalInstellingen.dieren.bijzonderheden": "Bijzonderheden van dieren tonen aan klanten",
    "portaalInstellingen.gezin.maximum": "Maximaal aantal gezinsleden",
    "portaalInstellingen.gezin.naGoedkeuring": "Een gezinslid krijgt pas toegang nadat het pension het heeft goedgekeurd",
    "portaalInstellingen.gezin.standaardProfiel": "Standaardprofiel voor nieuwe gezinsleden",
    "portaalInstellingen.gezin.profielen": "Profielen die een beheerder mag kiezen",
    "portaalInstellingen.profiel.VOLLEDIG": "Volledig",
    "portaalInstellingen.profiel.VOLLEDIG_ZONDER_FINANCIEEL": "Volledig zonder financieel",
    "portaalInstellingen.profiel.RESERVEREN": "Reserveren",
    "portaalInstellingen.profiel.MEEKIJKEN": "Meekijken",
    "portaalInstellingen.reserveren.vestiging": "Klanten reserveren bij vestiging",
    "portaalInstellingen.reserveren.uit": "Reserveren via het portaal staat uit",
    "portaalInstellingen.reserveren.wizardUitleg": "De stappen en eigen vragen komen uit de gepubliceerde wizard van deze vestiging (Instellingen › Pension).",
    "portaalInstellingen.reserveren.beschikbaarheid": "Beschikbaarheid tonen",
    "portaalInstellingen.beschikbaarheid.NIET_TONEN": "Niet tonen",
    "portaalInstellingen.beschikbaarheid.INDICATIEF": "Indicatie (waarschijnlijk / beperkt)",
    "portaalInstellingen.beschikbaarheid.REALTIME": "Echte controle; vol = niet aanvragen",
    "portaalInstellingen.reserveren.drempelBedrag": "Prijsverschil zonder nieuw akkoord (€)",
    "portaalInstellingen.reserveren.drempelProcent": "Prijsverschil zonder nieuw akkoord (%)",
    "portaalInstellingen.reserveren.dagenVooruit": "Op zijn vroegst over (dagen)",
    "portaalInstellingen.reserveren.conceptDagen": "Concept bewaren (dagen)",
    "portaalInstellingen.reserveren.voorwaardenUrl": "Reserveringsvoorwaarden (adres)",
    "portaalInstellingen.reserveren.voorwaardenVersie": "Versie reserveringsvoorwaarden",
    "portaalInstellingen.reserveren.drempelUitleg": "Is de prijs bij goedkeuren hoger dan de klant zag en meer dan dit verschil, dan doe je eerst een tegenvoorstel.",
    "portaalInstellingen.privacy.titel": "Privacy",
    "portaalInstellingen.privacy.supportZichtbaar": "Klant ziet in Mijn account › Activiteit wanneer support heeft meegekeken",
    "portaalInstellingen.regels.titel": "Voorwaardelijke vragen",
    "portaalInstellingen.regels.uitleg": "ALS … EN/OF … DAN toon vraag. Een vraag met een regel blijft verborgen tot een van zijn regels klopt; een verborgen vraag is nooit verplicht.",
    "portaalInstellingen.regels.eerstVestiging": "Kies eerst een vestiging en sla op.",
    "portaalInstellingen.regels.geenVragen": "De reserveringswizard heeft nog geen eigen vragen. Voeg ze toe onder Pensioninstellingen › Reserveringswizard.",
    "portaalInstellingen.regels.leeg": "Geen regels: iedere vraag wordt altijd getoond.",
    "portaalInstellingen.regels.regel": "Regel %s",
    "portaalInstellingen.regels.als": "ALS",
    "portaalInstellingen.regels.dan": "DAN",
    "portaalInstellingen.regels.en": "EN",
    "portaalInstellingen.regels.of": "OF",
    "portaalInstellingen.regels.verbinding": "En/of",
    "portaalInstellingen.regels.veld": "Veld",
    "portaalInstellingen.regels.operator": "Vergelijking",
    "portaalInstellingen.regels.waarde": "Waarde",
    "portaalInstellingen.regels.is": "is",
    "portaalInstellingen.regels.isNiet": "is niet",
    "portaalInstellingen.regels.ja": "ja",
    "portaalInstellingen.regels.nee": "nee",
    "portaalInstellingen.regels.veld.diersoort": "Diersoort",
    "portaalInstellingen.regels.veld.verblijf": "Verblijf",
    "portaalInstellingen.regels.veld.extra": "Extra",
    "portaalInstellingen.regels.veld.verzekering": "Annuleringsverzekering",
    "portaalInstellingen.regels.antwoordOp": "Antwoord op \"%s\"",
    "portaalInstellingen.regels.toon": "Vraag die verschijnt",
    "portaalInstellingen.regels.toonVraag": "toon \"%s\"",
    "portaalInstellingen.regels.voorwaardeErbij": "Voorwaarde toevoegen",
    "portaalInstellingen.regels.voorwaardeWeg": "Voorwaarde verwijderen",
    "portaalInstellingen.regels.regelErbij": "Regel toevoegen",
    "portaalInstellingen.regels.regelWeg": "Regel verwijderen",
    "portaalInstellingen.versies.titel": "Wizardversies",
    "portaalInstellingen.versies.uitleg": "Terugzetten publiceert een eerdere versie opnieuw, als nieuwe versie. Dat geldt alleen voor nieuwe aanvragen; concepten en ingediende aanvragen houden hun eigen versie.",
    "portaalInstellingen.versies.geen": "Nog geen gepubliceerde versies: de wizard gebruikt de standaardindeling.",
    "portaalInstellingen.versies.versie": "Versie",
    "portaalInstellingen.versies.op": "Gepubliceerd",
    "portaalInstellingen.versies.door": "Door",
    "portaalInstellingen.versies.actie": "Actie",
    "portaalInstellingen.versies.live": "live",
    "portaalInstellingen.versies.terugzetten": "Terugzetten",
    "portaalInstellingen.versies.bevestig": "Versie %s opnieuw publiceren als live wizard?",
    "portaalInstellingen.versies.teruggezet": "Versie %s is weer live.",
    "portaalInstellingen.versies.geenRecht": "Alleen pensionbeheerders kunnen een versie terugzetten.",
    "portaalInstellingen.berichten.aan": "Klanten kunnen het pension berichten sturen en reageren",
    "portaalInstellingen.berichten.uitleg": "Berichten komen binnen bij Klantberichten. Een bericht verandert nooit iets vanzelf.",
    "portaalInstellingen.berichten.categorieen": "Waarover klanten een nieuw bericht mogen beginnen",
    "portaalInstellingen.berichten.maxPerDag": "Maximaal aantal berichten per persoon per dag",
    "portaalInstellingen.berichten.gedeeld": "Een nieuw bericht van een klant is zichtbaar voor het hele huishouden",
    "portaalInstellingen.financieel.onlineBetalen": "Klanten kunnen online betalen",
    "portaalInstellingen.financieel.provider": "Betaalprovider",
    "portaalInstellingen.financieel.test": "Testbetalingen (geen echt geld)",
    "portaalInstellingen.financieel.uitleg": "De sleutel van Mollie staat bij Instellingen › Integraties › iDEAL. De betaalstatus komt alleen uit de bevestiging van de provider.",
    "portaalInstellingen.documenten.titel": "Documenten",
    "portaalInstellingen.documenten.uploaden": "Klanten kunnen documenten uploaden (bijv. vaccinatiebewijs)",
    "portaalInstellingen.documenten.tonen": "Documenten uit het dierdossier tonen aan klanten",
    "klantverzoeken.bestanden.titel": "Bestanden",
    "klantverzoeken.bestanden.download": "Downloaden",
    "klantverzoeken.bestanden.fout": "Downloaden lukte niet.",
    "klantverzoeken.bestanden.scan.SCHOON": "Gescand, schoon",
    "klantverzoeken.bestanden.scan.NIET_GESCAND": "Niet gescand",
    "klantverzoeken.bestanden.scan.BESMET": "Geweigerd door virusscan",
    "klantverzoeken.bestanden.scan.NVT": "—",
    "financieel.tab.dagafsluitingen": "Dagafsluitingen",
    "dagafsluitingOverzicht.title": "Dagafsluitingen",
    "dagafsluitingOverzicht.subtitle": "Per dag: wie hem afsloot, wie akkoord gaf en wat er niet klopte.",
    "dagafsluitingOverzicht.kpi.dagen": "Dagen afgesloten",
    "dagafsluitingOverzicht.kpi.metVerschil": "Dagen met een verschil",
    "dagafsluitingOverzicht.kpi.wachtOpControle": "Wacht op controle",
    "dagafsluitingOverzicht.kpi.nietAfgesloten": "Niet afgesloten",
    "dagafsluitingOverzicht.status.NIET_AFGESLOTEN": "Niet afgesloten",
    "dagafsluitingOverzicht.boekingen": "%s kasboekingen, nooit afgesloten",
    "dagafsluitingOverzicht.col.dag": "Dag",
    "dagafsluitingOverzicht.col.vestiging": "Vestiging",
    "dagafsluitingOverzicht.col.status": "Status",
    "dagafsluitingOverzicht.col.afgeslotenDoor": "Afgesloten door",
    "dagafsluitingOverzicht.col.afgeslotenOp": "Afgesloten op",
    "dagafsluitingOverzicht.col.akkoord": "Akkoord door",
    "dagafsluitingOverzicht.col.contant": "Contant geteld",
    "dagafsluitingOverzicht.col.verschilContant": "Verschil contant",
    "dagafsluitingOverzicht.col.pin": "Pin geteld",
    "dagafsluitingOverzicht.col.verschilPin": "Verschil pin",
    "dagafsluitingOverzicht.col.opmerking": "Opmerking",
    "dagafsluitingOverzicht.geenAkkoord": "Niet afgetekend",
    "dagafsluitingOverzicht.tellingTitel": "Geteld, met daaronder wat verwacht werd",
    "dagafsluitingOverzicht.leeg": "In deze periode is geen dag afgesloten.",
    "dagafsluitingOverzicht.laadfout": "De dagafsluitingen konden niet worden geladen.",
    "dagafsluitingOverzicht.status.CONCEPT": "Concept",
    "dagafsluitingOverzicht.status.WACHT_OP_CONTROLE": "Wacht op controle",
    "dagafsluitingOverzicht.status.AKKOORD": "Akkoord",
    "factuurDetailView.concept.geenRegels": "Deze factuur heeft nog geen regels — voeg er een toe, of gooi de factuur weg.",
    "factuurDetailView.concept.losseVerkoopOnbalans": "Een losse verkoop moet in balans zijn: er mag niets openstaan.",
    "factuurDetailView.notice.losseVerkoopOnbalans": "Deze factuur heeft geen debiteur, dus er is niemand om het restant aan te factureren. Registreer de betaling voor het hele bedrag, of pas de regels aan.",
    "factuurDetailView.concept.weggooienKnop": "Factuur weggooien",
    "factuurDetailView.notice.geenRegels": "Een factuur heeft minstens een regel nodig. Voeg een regel toe, of gooi de factuur weg.",
    "factuurDetailView.nogGeenNummer": "(nog geen nummer)",
    "uitboeken.payment.teveel": "Dat is %s meer dan er te betalen staat. Vul hoogstens het openstaande bedrag in — de rest kan later op een factuur.",
    "communicatieAi.selectie.menu": "Aanpassen met AI",
    "communicatieAi.selectie.titel": "Geselecteerde tekst aanpassen met AI",
    "communicatieAi.selectie.uitleg": "Alleen de geselecteerde tekst gaat mee en alleen die tekst wordt vervangen. De rest van het sjabloon blijft zoals het is.",
    "communicatieAi.selectie.huidig": "Geselecteerde tekst",
    "communicatieAi.selectie.voorstel": "Voorstel",
    "communicatieAi.selectie.ongewijzigd": "Het voorstel is gelijk aan de geselecteerde tekst, dus er valt niets door te voeren.",
    "communicatieAi.selectie.opdracht": "Wat moet er veranderen?",
    "communicatieAi.selectie.opdrachtNog": "Wat moet er nog anders?",
    "communicatieAi.selectie.opdracht.placeholder": "Bijvoorbeeld: hier moet de betaalwijze staan",
    "communicatieAi.selectie.vraag": "Vraag een voorstel",
    "communicatieAi.selectie.bijschaven": "Bijschaven",
    "communicatieAi.selectie.doorvoeren": "Doorvoeren",
    "communicatieAi.selectie.velden-kapot": "Dit voorstel verandert de velden in de tekst en is daarom niet door te voeren. Vraag om een andere formulering.",
    "menu.losseVerkoop": "Losse verkoop",
    "losseVerkoop.title": "Losse verkoop",
    "losseVerkoop.subtitle": "Een factuur zonder debiteur, meteen aan de balie afgerekend.",
    "losseVerkoop.fout": "De verkoop kon niet worden afgerond.",
    "losseVerkoop.bezig": "Bezig met openen van een losse verkoop…",
    "losseVerkoop.opnieuw": "Opnieuw proberen",
    "factuurDetailView.export.emailAdres": "E-mailadres",
    "factuurDetailView.export.emailAdresVragen": "Deze factuur heeft geen debiteur, dus er is geen adres bekend. Vul in waar hij naartoe moet.",
    "wachtlijst.titel": "Wachtlijst",
    "wachtlijst.onderschrift": "Afstandsaanvragen en de stand van de intake.",
    "wachtlijst.kpi.nieuw": "Nieuwe aanvragen",
    "wachtlijst.kpi.actieVereist": "Actie vereist",
    "wachtlijst.kpi.klaar": "Klaar voor beoordeling",
    "wachtlijst.kpi.gepland": "Gepland voor opname",
    "wachtlijst.zoek": "Zoek op nummer, eigenaar of dier...",
    "wachtlijst.filter.alle": "Alle statussen",
    "wachtlijst.col.nummer": "#",
    "wachtlijst.col.dieren": "Dier(en)",
    "wachtlijst.col.eigenaar": "Eigenaar",
    "wachtlijst.col.status": "Status intake",
    "wachtlijst.col.compleet": "Dossier compleet",
    "wachtlijst.col.ontvangen": "Ontvangen",
    "wachtlijst.col.acties": "Acties",
    "wachtlijst.open": "Open dossier",
    "wachtlijst.leeg": "Nog geen aanvragen.",
    "wachtlijst.laadfout": "De wachtlijst kon niet worden geladen.",
    "wachtlijst.handmatig": "Status met de hand gezet",
    "wachtlijst.geenTelling": "Geen vragenlijst gekoppeld, dus er valt niets te tellen.",
    "wachtlijst.status.NIEUW": "Nieuw",
    "wachtlijst.status.ACTIE_VEREIST": "Actie vereist",
    "wachtlijst.status.IN_BEHANDELING": "In behandeling",
    "wachtlijst.status.COMPLEET": "Compleet",
    "wachtlijst.status.GEPLAND": "Gepland",
    "wachtlijst.status.AFGEHANDELD": "Afgehandeld",
    "wachtlijst.status.AFGEWEZEN": "Afgewezen",
    "wachtlijst.status.INGETROKKEN": "Ingetrokken",
    "wachtlijst.status.VERLOPEN": "Verlopen",
    "menu.wachtlijst": "Wachtlijst",
    "opvangModules.wachtlijst": "Wachtlijst",
    "wachtlijst.results.found": "aanvragen gevonden",
    "wachtlijst.results.foundOne": "aanvraag gevonden",
    "wachtlijst.weergave": "Weergave",
    "wachtlijst.weergave.card": "Kaarten",
    "wachtlijst.weergave.compact": "Kleine kaarten",
    "wachtlijst.weergave.list": "Lijst",
    "wachtlijstDetail.terug": "Terug",
    "wachtlijstDetail.laadfout": "Deze aanvraag kon niet worden geladen.",
    "wachtlijstDetail.ontvangen": "Ontvangen",
    "wachtlijstDetail.ingediend": "Ingediend",
    "wachtlijstDetail.statusZetten": "Status",
    "wachtlijstDetail.statusFout": "De status kon niet worden gewijzigd.",
    "wachtlijstDetail.eigenaar": "Eigenaar",
    "wachtlijstDetail.naam": "Naam",
    "wachtlijstDetail.email": "E-mail",
    "wachtlijstDetail.telefoon": "Telefoon",
    "wachtlijstDetail.adres": "Adres",
    "wachtlijstDetail.geenContact": "Nog geen contactgegevens.",
    "wachtlijstDetail.notitie": "Interne notitie",
    "wachtlijstDetail.notitieUitleg": "Alleen hier zichtbaar. De eigenaar ziet dit nooit.",
    "wachtlijstDetail.klantKoppelen": "Koppelen aan relatie",
    "wachtlijstDetail.klantKoppelenTitel": "Aanvraag aan een relatie koppelen",
    "wachtlijstDetail.klantKoppelenUitleg": "Op het formulier staat “%s”. Zoek die persoon op tussen de bestaande relaties, dan blijven zijn dieren en historie op één kaart staan in plaats van dat er bij het inboeken een tweede bij komt.",
    "wachtlijstDetail.klantKoppelBevestig": "Koppelen",
    "wachtlijstDetail.klantGekoppeld": "Relatie",
    "wachtlijstDetail.klantOntkoppelen": "Ontkoppelen",
    "wachtlijstDetail.klantZoek": "Zoek de relatie",
    "wachtlijstDetail.klantZoekInfo": "Zoek op e-mailadres of adres; staat deze persoon er nog niet in, maak dan een nieuwe relatie aan.",
    "wachtlijstDetail.klantFout": "De koppeling kon niet worden gewijzigd.",
    "wachtlijstDossier.verschillenKop": "Wijkt af van de gekoppelde relatie",
    "wachtlijstDossier.verschilVeld": "Gegeven",
    "wachtlijstDossier.verschilOpgave": "Op de aanvraag",
    "wachtlijstDossier.verschilRelatie": "Bij de relatie",
    "wachtlijstDetail.vestiging": "Locatie",
    "wachtlijstDetail.vestigingVerplaatsen": "Verplaatsen",
    "wachtlijstDetail.vestigingVerplaatsenTitel": "Naar een andere locatie",
    "wachtlijstDetail.vestigingVerplaatsenUitleg": "Deze aanvraag kwam binnen op de locatie die het dichtst bij postcode %s ligt. Hoort hij ergens anders, kies dan een andere \u2014 de eigenaar ziet nooit welke locaties er zijn.",
    "wachtlijstDetail.vestigingNaar": "Naar locatie",
    "wachtlijstDetail.vestigingVerplaatsBevestig": "Verplaatsen",
    "wachtlijstDetail.vestigingFout": "De aanvraag kon niet worden verplaatst.",
    "wachtlijstDetail.behandelaarFout": "De behandelaar kon niet worden gewijzigd.",
    "wachtlijstDetail.beoordelingFout": "De beoordeling kon niet worden bewaard.",
    "wachtlijstDetail.labelFout": "Het label kon niet worden gewijzigd.",
    "wachtlijstDetail.notitiePlaceholder": "Wat er is afgesproken, wie gebeld heeft, wat nog nagekeken moet worden…",
    "wachtlijstDetail.notitieBewaren": "Notitie bewaren",
    "wachtlijstDetail.notitieBewaard": "Notitie bewaard",
    "wachtlijstDetail.notitieFout": "De notitie kon niet worden bewaard.",
    "wachtlijstDetail.dieren": "Dieren en antwoorden",
    "wachtlijstDetail.geenDieren": "Geen dieren op deze aanvraag.",
    "wachtlijstDetail.nietIngevuld": "Niet ingevuld",
    "wachtlijstDetail.ontbreekt": "%s verplichte vragen zijn nog niet beantwoord.",
    "wachtlijstDossier.terugNaarLijst": "Terug naar lijst",
    "wachtlijstDossier.meerDieren": "%s dieren",
    "wachtlijstDossier.huidigeStap": "Huidige stap",
    "wachtlijstDossier.stap.ontvangen": "Aanvraag ontvangen",
    "wachtlijstDossier.stap.beoordeling": "Beoordeling",
    "wachtlijstDossier.stap.inplannen": "Inplannen opname",
    "wachtlijstDossier.stap.afronden": "Afronden",
    "wachtlijstDossier.onderdelen": "Onderdelen van de vragenlijst",
    "wachtlijstDossier.onderdelenUitleg": "Kies een onderdeel om de antwoorden te bekijken en te beoordelen.",
    "wachtlijstDossier.beoordeeldVan": "%s van %s beoordeeld",
    "wachtlijstDossier.aandachtspunten": "%s aandachtspunt(en)",
    "wachtlijstDossier.geenAandachtspunten": "Geen aandachtspunten",
    "wachtlijstDossier.beoordeelUitleg": "Alle antwoorden van de eigenaar staan hier volledig weergegeven. Beoordeel per vraag of aanvulling nodig is.",
    "wachtlijstDossier.vraagVanHetAsiel": "Vraag van het asiel",
    "wachtlijstDossier.antwoordVanDeEigenaar": "Antwoord van de eigenaar",
    "wachtlijstDossier.beoordeling": "Beoordeling",
    "wachtlijstDossier.akkoord": "Akkoord",
    "wachtlijstDossier.aandachtspunt": "Aandachtspunt",
    "wachtlijstDossier.vragenlijstHerkomst": "Vragen, volgorde en onderdelen komen uit de vragenlijst die uw organisatie zelf inricht.",
    "wachtlijstDossier.tab.dieren": "Dieren",
    "wachtlijstDossier.tab.notities": "Notities",
    "wachtlijstDossier.aanvrager": "Aanvrager",
    "wachtlijstDossier.naam": "Naam",
    "wachtlijstDossier.email": "E-mailadres",
    "wachtlijstDossier.telefoon": "Telefoon",
    "wachtlijstDossier.adres": "Adres",
    "wachtlijstDossier.redenVanAfstand": "Reden van afstand",
    "wachtlijstDossier.geenReden": "De vragenlijst vraagt niet naar een reden.",
    "wachtlijstDossier.gewenstePeriode": "Gewenste periode",
    "wachtlijstDossier.verblijftNuBij": "Verblijft nu bij",
    "wachtlijstDossier.bijDeRelatie": "Bij de relatie %s",
    "wachtlijstDossier.bijDeEigenaar": "Bij de eigenaar",
    "wachtlijstDossier.status": "Status",
    "wachtlijstDossier.behandelaar": "Behandelaar",
    "wachtlijstDossier.nogNiemand": "Nog niet toegewezen",
    "wachtlijstDossier.aanMijToewijzen": "Aan mij toewijzen",
    "wachtlijstDossier.vrijgeven": "Vrijgeven",
    "wachtlijstDossier.labels": "Labels",
    "wachtlijstDossier.labelToevoegen": "Label toevoegen",
    "wachtlijstDossier.labelWeg": "Label %s weghalen",
    "wachtlijstDossier.labelPlaceholder": "bijv. spoed",
    "wachtlijstDossier.afdrukken": "Dossier afdrukken",
    "wachtlijstDossier.notitieToevoegen": "Notitie toevoegen",
    "wachtlijstDossier.notitieBewaren": "Notitie bewaren",
    "wachtlijstDossier.notitiesUitleg": "Alleen hier zichtbaar. De eigenaar ziet dit nooit.",
    "wachtlijstDossier.geenNotities": "Nog geen notities.",
    "wachtlijstDossier.onbekendeSchrijver": "Onbekend",
    "wachtlijstDossier.stap.algemeen": "Algemene gegevens",
    "wachtlijstDossier.stap.vragen": "Afstandsvragen",
    "wachtlijstDossier.stap.gezondheid": "Gezondheid & entingen",
    "wachtlijstDossier.stap.extra": "Extra informatie",
    "wachtlijstDossier.ingevuld": "Ingevuld",
    "wachtlijstDossier.nietOpgegeven": "Niet opgegeven",
    "wachtlijstDossier.geenVragen": "Geen vragen voor deze diersoort",
    "wachtlijstDossier.optioneel": "Optioneel",
    "wachtlijstDossier.aantalFotos": "%s foto('s)",
    "wachtlijstDossier.fotos": "Foto's",
    "wachtlijstDossier.geenFotos": "De eigenaar heeft geen foto's toegevoegd.",
    "wachtlijstDossier.karakter": "Karakter",
    "wachtlijstDossier.bijzonderheden": "Bijzonderheden",
    "wachtlijstDossier.uitklappen": "Uitklappen",
    "wachtlijstDossier.inklappen": "Inklappen",
    "wachtlijstDossier.bewerken": "Bewerken",
    "wachtlijstDossier.tab.antwoorden": "Antwoorden",
    "wachtlijstDossier.tab.documenten": "Documenten",
    "wachtlijstDossier.tab.historie": "Historie",
    "wachtlijstDossier.diergegevens": "Diergegevens",
    "wachtlijstDossier.entingen": "Entingen uit het boekje",
    "wachtlijstDossier.entingenUitleg": "Wat de eigenaar na controle van de foto’s bevestigde — geen bewijs van een geldige vaccinatie. De foto’s van het boekje staan bij Documenten.",
    "wachtlijstDossier.dierZonderNaam": "Dier zonder naam",
    "wachtlijstDossier.enting.vaccin": "Vaccin",
    "wachtlijstDossier.enting.datum": "Datum",
    "wachtlijstDossier.enting.geldigTot": "Geldig tot",
    "wachtlijstDossier.enting.dierenarts": "Dierenarts",
    "wachtlijstDossier.roepnaam": "Roepnaam",
    "wachtlijstDossier.diersoort": "Diersoort",
    "wachtlijstDossier.ras": "Ras",
    "wachtlijstDossier.geslacht": "Geslacht",
    "wachtlijstDossier.geboortedatum": "Geboortedatum",
    "wachtlijstDossier.chipnummer": "Chipnummer",
    "wachtlijstDossier.aanvraagvragen": "Aanvraagvragen",
    "wachtlijstDossier.beantwoord": "%s van %s beantwoord",
    "wachtlijstDossier.groepKlaar": "Voltooid",
    "wachtlijstDossier.groepOnvolledig": "Aanvullende informatie nodig",
    "wachtlijstDossier.controle": "Dossiercontrole",
    "wachtlijstDossier.controle.gegevens": "Gegevens eigenaar",
    "wachtlijstDossier.controle.vragen": "Verplichte vragen",
    "wachtlijstDossier.ontvangenOp": "Aanvraag ontvangen",
    "wachtlijstDossier.ingediendOp": "Ingediend door de eigenaar",
    "wachtlijstDossier.historieOnvolledig": "Wat er daarna met het dossier is gebeurd, wordt nog niet bijgehouden.",
    "wachtlijstInstellingen.titel": "Afstandsportaal",
    "wachtlijstInstellingen.onderschrift": "Welke vragen de eigenaar krijgt, per diersoort.",
    "wachtlijstInstellingen.vragenlijsten": "Vragenlijsten",
    "wachtlijstInstellingen.uitleg": "Gemaakt in dezelfde vragenlijstbouwer als de nazorglijsten. Alleen gepubliceerde lijsten komen in het portaal.",
    "wachtlijstInstellingen.geenVragen": "Nog geen lijst — geen vragen voor deze diersoort",
    "wachtlijstInstellingen.aanpassen": "Aanpassen",
    "wachtlijstInstellingen.maken": "Maken",
    "wachtlijstInstellingen.nieuweLijst": "Nieuwe lijst",
    "wachtlijstInstellingen.laadfout": "De vragenlijsten konden niet worden geladen.",
    "wachtlijstInstellingen.status.GEPUBLICEERD": "Gepubliceerd",
    "wachtlijstInstellingen.status.CONCEPT": "Concept — nog niet live",
    "wachtlijstInstellingen.status.GEARCHIVEERD": "Gearchiveerd",
    "wachtlijst.instellingen": "Portaalinstellingen",
    "wachtlijstDetail.documenten": "Documenten",
    "wachtlijstDetail.documentenUitleg": "Pdf of foto, maximaal 10 MB per bestand. Wat de eigenaar meestuurt komt rechtstreeks vanaf het portaal hier binnen.",
    "wachtlijstDetail.geenDocumenten": "Nog geen documenten.",
    "wachtlijstDetail.documentToevoegen": "Document toevoegen",
    "wachtlijstDetail.uploadBezig": "Bezig met toevoegen…",
    "wachtlijstDetail.uploadFout": "Dat bestand kon niet worden toegevoegd. Alleen pdf, jpeg, png, webp of heic, tot 10 MB.",
    "wachtlijstDetail.documentOpenen": "Openen",
    "wachtlijstDetail.documentBewaren": "Bewaren",
    "wachtlijstDetail.documentWeg": "Verwijderen",
    "wachtlijstDetail.documentWegFout": "Het document kon niet worden verwijderd.",
    "wachtlijstDetail.documentenFout": "De documenten konden niet worden geladen.",
  },
} as const;
